/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		2:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + ({"3":"analysis","4":"admin","5":"login"}[chunkId]||chunkId) + ".bundled.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(151);
	__webpack_require__(1);
	__webpack_require__(119);
	__webpack_require__(79);
	__webpack_require__(76);
	__webpack_require__(77);
	__webpack_require__(78);
	__webpack_require__(116);
	__webpack_require__(75);
	__webpack_require__(113);
	__webpack_require__(74);
	__webpack_require__(115);
	__webpack_require__(117);
	__webpack_require__(3);
	__webpack_require__(2);
	__webpack_require__(96);
	__webpack_require__(73);
	__webpack_require__(54);
	module.exports = __webpack_require__(150);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v1.12.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:17Z
	 */
	
	(function (global, factory) {
	
		if (typeof module === "object" && typeof module.exports === "object") {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ? factory(global, true) : function (w) {
				if (!w.document) {
					throw new Error("jQuery requires a window with a document");
				}
				return factory(w);
			};
		} else {
			factory(global);
		}
	
		// Pass this if window is not defined yet
	})(typeof window !== "undefined" ? window : this, function (window, noGlobal) {
	
		// Support: Firefox 18+
		// Can't be in strict mode, several libs including ASP.NET trace
		// the stack via arguments.caller.callee and Firefox dies if
		// you try to trace through "use strict" call chains. (#13335)
		//"use strict";
		var deletedIds = [];
	
		var document = window.document;
	
		var slice = deletedIds.slice;
	
		var concat = deletedIds.concat;
	
		var push = deletedIds.push;
	
		var indexOf = deletedIds.indexOf;
	
		var class2type = {};
	
		var toString = class2type.toString;
	
		var hasOwn = class2type.hasOwnProperty;
	
		var support = {};
	
		var version = "1.12.4",
	
	
		// Define a local copy of jQuery
		jQuery = function (selector, context) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init(selector, context);
		},
	
	
		// Support: Android<4.1, IE<9
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		    rdashAlpha = /-([\da-z])/gi,
	
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function (all, letter) {
			return letter.toUpperCase();
		};
	
		jQuery.fn = jQuery.prototype = {
	
			// The current version of jQuery being used
			jquery: version,
	
			constructor: jQuery,
	
			// Start with an empty selector
			selector: "",
	
			// The default length of a jQuery object is 0
			length: 0,
	
			toArray: function () {
				return slice.call(this);
			},
	
			// Get the Nth element in the matched element set OR
			// Get the whole matched element set as a clean array
			get: function (num) {
				return num != null ?
	
				// Return just the one element from the set
				num < 0 ? this[num + this.length] : this[num] :
	
				// Return all the elements in a clean array
				slice.call(this);
			},
	
			// Take an array of elements and push it onto the stack
			// (returning the new matched element set)
			pushStack: function (elems) {
	
				// Build a new jQuery matched element set
				var ret = jQuery.merge(this.constructor(), elems);
	
				// Add the old object onto the stack (as a reference)
				ret.prevObject = this;
				ret.context = this.context;
	
				// Return the newly-formed element set
				return ret;
			},
	
			// Execute a callback for every element in the matched set.
			each: function (callback) {
				return jQuery.each(this, callback);
			},
	
			map: function (callback) {
				return this.pushStack(jQuery.map(this, function (elem, i) {
					return callback.call(elem, i, elem);
				}));
			},
	
			slice: function () {
				return this.pushStack(slice.apply(this, arguments));
			},
	
			first: function () {
				return this.eq(0);
			},
	
			last: function () {
				return this.eq(-1);
			},
	
			eq: function (i) {
				var len = this.length,
				    j = +i + (i < 0 ? len : 0);
				return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
			},
	
			end: function () {
				return this.prevObject || this.constructor();
			},
	
			// For internal use only.
			// Behaves like an Array's method, not like a jQuery method.
			push: push,
			sort: deletedIds.sort,
			splice: deletedIds.splice
		};
	
		jQuery.extend = jQuery.fn.extend = function () {
			var src,
			    copyIsArray,
			    copy,
			    name,
			    options,
			    clone,
			    target = arguments[0] || {},
			    i = 1,
			    length = arguments.length,
			    deep = false;
	
			// Handle a deep copy situation
			if (typeof target === "boolean") {
				deep = target;
	
				// skip the boolean and the target
				target = arguments[i] || {};
				i++;
			}
	
			// Handle case when target is a string or something (possible in deep copy)
			if (typeof target !== "object" && !jQuery.isFunction(target)) {
				target = {};
			}
	
			// extend jQuery itself if only one argument is passed
			if (i === length) {
				target = this;
				i--;
			}
	
			for (; i < length; i++) {
	
				// Only deal with non-null/undefined values
				if ((options = arguments[i]) != null) {
	
					// Extend the base object
					for (name in options) {
						src = target[name];
						copy = options[name];
	
						// Prevent never-ending loop
						if (target === copy) {
							continue;
						}
	
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)))) {
	
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && jQuery.isArray(src) ? src : [];
							} else {
								clone = src && jQuery.isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							target[name] = jQuery.extend(deep, clone, copy);
	
							// Don't bring in undefined values
						} else if (copy !== undefined) {
							target[name] = copy;
						}
					}
				}
			}
	
			// Return the modified object
			return target;
		};
	
		jQuery.extend({
	
			// Unique for each copy of jQuery on the page
			expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
	
			// Assume jQuery is ready without the ready module
			isReady: true,
	
			error: function (msg) {
				throw new Error(msg);
			},
	
			noop: function () {},
	
			// See test/unit/core.js for details concerning isFunction.
			// Since version 1.3, DOM methods and functions like alert
			// aren't supported. They return false on IE (#2968).
			isFunction: function (obj) {
				return jQuery.type(obj) === "function";
			},
	
			isArray: Array.isArray || function (obj) {
				return jQuery.type(obj) === "array";
			},
	
			isWindow: function (obj) {
				/* jshint eqeqeq: false */
				return obj != null && obj == obj.window;
			},
	
			isNumeric: function (obj) {
	
				// parseFloat NaNs numeric-cast false positives (null|true|false|"")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				// adding 1 corrects loss of precision from parseFloat (#15100)
				var realStringObj = obj && obj.toString();
				return !jQuery.isArray(obj) && realStringObj - parseFloat(realStringObj) + 1 >= 0;
			},
	
			isEmptyObject: function (obj) {
				var name;
				for (name in obj) {
					return false;
				}
				return true;
			},
	
			isPlainObject: function (obj) {
				var key;
	
				// Must be an Object.
				// Because of IE, we also have to check the presence of the constructor property.
				// Make sure that DOM nodes and window objects don't pass through, as well
				if (!obj || jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow(obj)) {
					return false;
				}
	
				try {
	
					// Not own constructor property must be Object
					if (obj.constructor && !hasOwn.call(obj, "constructor") && !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
						return false;
					}
				} catch (e) {
	
					// IE8,9 Will throw exceptions on certain host objects #9897
					return false;
				}
	
				// Support: IE<9
				// Handle iteration over inherited properties before own properties.
				if (!support.ownFirst) {
					for (key in obj) {
						return hasOwn.call(obj, key);
					}
				}
	
				// Own properties are enumerated firstly, so to speed up,
				// if last one is own, then all properties are own.
				for (key in obj) {}
	
				return key === undefined || hasOwn.call(obj, key);
			},
	
			type: function (obj) {
				if (obj == null) {
					return obj + "";
				}
				return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
			},
	
			// Workarounds based on findings by Jim Driscoll
			// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
			globalEval: function (data) {
				if (data && jQuery.trim(data)) {
	
					// We use execScript on Internet Explorer
					// We use an anonymous function so that context is window
					// rather than jQuery in Firefox
					(window.execScript || function (data) {
						window["eval"].call(window, data); // jscs:ignore requireDotNotation
					})(data);
				}
			},
	
			// Convert dashed to camelCase; used by the css and data modules
			// Microsoft forgot to hump their vendor prefix (#9572)
			camelCase: function (string) {
				return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
			},
	
			nodeName: function (elem, name) {
				return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
			},
	
			each: function (obj, callback) {
				var length,
				    i = 0;
	
				if (isArrayLike(obj)) {
					length = obj.length;
					for (; i < length; i++) {
						if (callback.call(obj[i], i, obj[i]) === false) {
							break;
						}
					}
				} else {
					for (i in obj) {
						if (callback.call(obj[i], i, obj[i]) === false) {
							break;
						}
					}
				}
	
				return obj;
			},
	
			// Support: Android<4.1, IE<9
			trim: function (text) {
				return text == null ? "" : (text + "").replace(rtrim, "");
			},
	
			// results is for internal usage only
			makeArray: function (arr, results) {
				var ret = results || [];
	
				if (arr != null) {
					if (isArrayLike(Object(arr))) {
						jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
					} else {
						push.call(ret, arr);
					}
				}
	
				return ret;
			},
	
			inArray: function (elem, arr, i) {
				var len;
	
				if (arr) {
					if (indexOf) {
						return indexOf.call(arr, elem, i);
					}
	
					len = arr.length;
					i = i ? i < 0 ? Math.max(0, len + i) : i : 0;
	
					for (; i < len; i++) {
	
						// Skip accessing in sparse arrays
						if (i in arr && arr[i] === elem) {
							return i;
						}
					}
				}
	
				return -1;
			},
	
			merge: function (first, second) {
				var len = +second.length,
				    j = 0,
				    i = first.length;
	
				while (j < len) {
					first[i++] = second[j++];
				}
	
				// Support: IE<9
				// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
				if (len !== len) {
					while (second[j] !== undefined) {
						first[i++] = second[j++];
					}
				}
	
				first.length = i;
	
				return first;
			},
	
			grep: function (elems, callback, invert) {
				var callbackInverse,
				    matches = [],
				    i = 0,
				    length = elems.length,
				    callbackExpect = !invert;
	
				// Go through the array, only saving the items
				// that pass the validator function
				for (; i < length; i++) {
					callbackInverse = !callback(elems[i], i);
					if (callbackInverse !== callbackExpect) {
						matches.push(elems[i]);
					}
				}
	
				return matches;
			},
	
			// arg is for internal usage only
			map: function (elems, callback, arg) {
				var length,
				    value,
				    i = 0,
				    ret = [];
	
				// Go through the array, translating each of the items to their new values
				if (isArrayLike(elems)) {
					length = elems.length;
					for (; i < length; i++) {
						value = callback(elems[i], i, arg);
	
						if (value != null) {
							ret.push(value);
						}
					}
	
					// Go through every key on the object,
				} else {
					for (i in elems) {
						value = callback(elems[i], i, arg);
	
						if (value != null) {
							ret.push(value);
						}
					}
				}
	
				// Flatten any nested arrays
				return concat.apply([], ret);
			},
	
			// A global GUID counter for objects
			guid: 1,
	
			// Bind a function to a context, optionally partially applying any
			// arguments.
			proxy: function (fn, context) {
				var args, proxy, tmp;
	
				if (typeof context === "string") {
					tmp = fn[context];
					context = fn;
					fn = tmp;
				}
	
				// Quick check to determine if target is callable, in the spec
				// this throws a TypeError, but we will just return undefined.
				if (!jQuery.isFunction(fn)) {
					return undefined;
				}
	
				// Simulated bind
				args = slice.call(arguments, 2);
				proxy = function () {
					return fn.apply(context || this, args.concat(slice.call(arguments)));
				};
	
				// Set the guid of unique handler to the same of original handler, so it can be removed
				proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
				return proxy;
			},
	
			now: function () {
				return +new Date();
			},
	
			// jQuery.support is not used in Core but other projects attach their
			// properties to it so it needs to exist.
			support: support
		});
	
		// JSHint would error on this code due to the Symbol not being defined in ES5.
		// Defining this global in .jshintrc would create a danger of using the global
		// unguarded in another place, it seems safer to just disable JSHint for these
		// three lines.
		/* jshint ignore: start */
		if (typeof Symbol === "function") {
			jQuery.fn[Symbol.iterator] = deletedIds[Symbol.iterator];
		}
		/* jshint ignore: end */
	
		// Populate the class2type map
		jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (i, name) {
			class2type["[object " + name + "]"] = name.toLowerCase();
		});
	
		function isArrayLike(obj) {
	
			// Support: iOS 8.2 (not reproducible in simulator)
			// `in` check used to prevent JIT error (gh-2145)
			// hasOwn isn't used here due to false negatives
			// regarding Nodelist length in IE
			var length = !!obj && "length" in obj && obj.length,
			    type = jQuery.type(obj);
	
			if (type === "function" || jQuery.isWindow(obj)) {
				return false;
			}
	
			return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
		}
		var Sizzle =
		/*!
	  * Sizzle CSS Selector Engine v2.2.1
	  * http://sizzlejs.com/
	  *
	  * Copyright jQuery Foundation and other contributors
	  * Released under the MIT license
	  * http://jquery.org/license
	  *
	  * Date: 2015-10-17
	  */
		function (window) {
	
			var i,
			    support,
			    Expr,
			    getText,
			    isXML,
			    tokenize,
			    compile,
			    select,
			    outermostContext,
			    sortInput,
			    hasDuplicate,
	
	
			// Local document vars
			setDocument,
			    document,
			    docElem,
			    documentIsHTML,
			    rbuggyQSA,
			    rbuggyMatches,
			    matches,
			    contains,
	
	
			// Instance-specific data
			expando = "sizzle" + 1 * new Date(),
			    preferredDoc = window.document,
			    dirruns = 0,
			    done = 0,
			    classCache = createCache(),
			    tokenCache = createCache(),
			    compilerCache = createCache(),
			    sortOrder = function (a, b) {
				if (a === b) {
					hasDuplicate = true;
				}
				return 0;
			},
	
	
			// General-purpose constants
			MAX_NEGATIVE = 1 << 31,
	
	
			// Instance methods
			hasOwn = {}.hasOwnProperty,
			    arr = [],
			    pop = arr.pop,
			    push_native = arr.push,
			    push = arr.push,
			    slice = arr.slice,
	
			// Use a stripped-down indexOf as it's faster than native
			// http://jsperf.com/thor-indexof-vs-for/5
			indexOf = function (list, elem) {
				var i = 0,
				    len = list.length;
				for (; i < len; i++) {
					if (list[i] === elem) {
						return i;
					}
				}
				return -1;
			},
			    booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
	
			// Regular expressions
	
			// http://www.w3.org/TR/css3-selectors/#whitespace
			whitespace = "[\\x20\\t\\r\\n\\f]",
	
	
			// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
			identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
	
			// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
			attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
			    pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" + ")\\)|)",
	
	
			// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
			rwhitespace = new RegExp(whitespace + "+", "g"),
			    rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
			    rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
			    rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
			    rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"),
			    rpseudo = new RegExp(pseudos),
			    ridentifier = new RegExp("^" + identifier + "$"),
			    matchExpr = {
				"ID": new RegExp("^#(" + identifier + ")"),
				"CLASS": new RegExp("^\\.(" + identifier + ")"),
				"TAG": new RegExp("^(" + identifier + "|[*])"),
				"ATTR": new RegExp("^" + attributes),
				"PSEUDO": new RegExp("^" + pseudos),
				"CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
				"bool": new RegExp("^(?:" + booleans + ")$", "i"),
				// For use in libraries implementing .is()
				// We use this for POS matching in `select`
				"needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
			},
			    rinputs = /^(?:input|select|textarea|button)$/i,
			    rheader = /^h\d$/i,
			    rnative = /^[^{]+\{\s*\[native \w/,
	
	
			// Easily-parseable/retrievable ID or TAG or CLASS selectors
			rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
			    rsibling = /[+~]/,
			    rescape = /'|\\/g,
	
	
			// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
			runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
			    funescape = function (_, escaped, escapedWhitespace) {
				var high = "0x" + escaped - 0x10000;
				// NaN means non-codepoint
				// Support: Firefox<24
				// Workaround erroneous numeric interpretation of +"0x"
				return high !== high || escapedWhitespace ? escaped : high < 0 ?
				// BMP codepoint
				String.fromCharCode(high + 0x10000) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
			},
	
	
			// Used for iframes
			// See setDocument()
			// Removing the function wrapper causes a "Permission Denied"
			// error in IE
			unloadHandler = function () {
				setDocument();
			};
	
			// Optimize for push.apply( _, NodeList )
			try {
				push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
				// Support: Android<4.0
				// Detect silently failing push.apply
				arr[preferredDoc.childNodes.length].nodeType;
			} catch (e) {
				push = { apply: arr.length ?
	
					// Leverage slice if possible
					function (target, els) {
						push_native.apply(target, slice.call(els));
					} :
	
					// Support: IE<9
					// Otherwise append directly
					function (target, els) {
						var j = target.length,
						    i = 0;
						// Can't trust NodeList.length
						while (target[j++] = els[i++]) {}
						target.length = j - 1;
					}
				};
			}
	
			function Sizzle(selector, context, results, seed) {
				var m,
				    i,
				    elem,
				    nid,
				    nidselect,
				    match,
				    groups,
				    newSelector,
				    newContext = context && context.ownerDocument,
	
	
				// nodeType defaults to 9, since context defaults to document
				nodeType = context ? context.nodeType : 9;
	
				results = results || [];
	
				// Return early from calls with invalid selector or context
				if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
	
					return results;
				}
	
				// Try to shortcut find operations (as opposed to filters) in HTML documents
				if (!seed) {
	
					if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
						setDocument(context);
					}
					context = context || document;
	
					if (documentIsHTML) {
	
						// If the selector is sufficiently simple, try using a "get*By*" DOM method
						// (excepting DocumentFragment context, where the methods don't exist)
						if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
	
							// ID selector
							if (m = match[1]) {
	
								// Document context
								if (nodeType === 9) {
									if (elem = context.getElementById(m)) {
	
										// Support: IE, Opera, Webkit
										// TODO: identify versions
										// getElementById can match elements by name instead of ID
										if (elem.id === m) {
											results.push(elem);
											return results;
										}
									} else {
										return results;
									}
	
									// Element context
								} else {
	
									// Support: IE, Opera, Webkit
									// TODO: identify versions
									// getElementById can match elements by name instead of ID
									if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
	
										results.push(elem);
										return results;
									}
								}
	
								// Type selector
							} else if (match[2]) {
								push.apply(results, context.getElementsByTagName(selector));
								return results;
	
								// Class selector
							} else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
	
								push.apply(results, context.getElementsByClassName(m));
								return results;
							}
						}
	
						// Take advantage of querySelectorAll
						if (support.qsa && !compilerCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
	
							if (nodeType !== 1) {
								newContext = context;
								newSelector = selector;
	
								// qSA looks outside Element context, which is not what we want
								// Thanks to Andrew Dupont for this workaround technique
								// Support: IE <=8
								// Exclude object elements
							} else if (context.nodeName.toLowerCase() !== "object") {
	
								// Capture the context ID, setting it first if necessary
								if (nid = context.getAttribute("id")) {
									nid = nid.replace(rescape, "\\$&");
								} else {
									context.setAttribute("id", nid = expando);
								}
	
								// Prefix every selector in the list
								groups = tokenize(selector);
								i = groups.length;
								nidselect = ridentifier.test(nid) ? "#" + nid : "[id='" + nid + "']";
								while (i--) {
									groups[i] = nidselect + " " + toSelector(groups[i]);
								}
								newSelector = groups.join(",");
	
								// Expand context for sibling selectors
								newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
							}
	
							if (newSelector) {
								try {
									push.apply(results, newContext.querySelectorAll(newSelector));
									return results;
								} catch (qsaError) {} finally {
									if (nid === expando) {
										context.removeAttribute("id");
									}
								}
							}
						}
					}
				}
	
				// All others
				return select(selector.replace(rtrim, "$1"), context, results, seed);
			}
	
			/**
	   * Create key-value caches of limited size
	   * @returns {function(string, object)} Returns the Object data after storing it on itself with
	   *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	   *	deleting the oldest entry
	   */
			function createCache() {
				var keys = [];
	
				function cache(key, value) {
					// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
					if (keys.push(key + " ") > Expr.cacheLength) {
						// Only keep the most recent entries
						delete cache[keys.shift()];
					}
					return cache[key + " "] = value;
				}
				return cache;
			}
	
			/**
	   * Mark a function for special use by Sizzle
	   * @param {Function} fn The function to mark
	   */
			function markFunction(fn) {
				fn[expando] = true;
				return fn;
			}
	
			/**
	   * Support testing using an element
	   * @param {Function} fn Passed the created div and expects a boolean result
	   */
			function assert(fn) {
				var div = document.createElement("div");
	
				try {
					return !!fn(div);
				} catch (e) {
					return false;
				} finally {
					// Remove from its parent by default
					if (div.parentNode) {
						div.parentNode.removeChild(div);
					}
					// release memory in IE
					div = null;
				}
			}
	
			/**
	   * Adds the same handler for all of the specified attrs
	   * @param {String} attrs Pipe-separated list of attributes
	   * @param {Function} handler The method that will be applied
	   */
			function addHandle(attrs, handler) {
				var arr = attrs.split("|"),
				    i = arr.length;
	
				while (i--) {
					Expr.attrHandle[arr[i]] = handler;
				}
			}
	
			/**
	   * Checks document order of two siblings
	   * @param {Element} a
	   * @param {Element} b
	   * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	   */
			function siblingCheck(a, b) {
				var cur = b && a,
				    diff = cur && a.nodeType === 1 && b.nodeType === 1 && (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE);
	
				// Use IE sourceIndex if available on both nodes
				if (diff) {
					return diff;
				}
	
				// Check if b follows a
				if (cur) {
					while (cur = cur.nextSibling) {
						if (cur === b) {
							return -1;
						}
					}
				}
	
				return a ? 1 : -1;
			}
	
			/**
	   * Returns a function to use in pseudos for input types
	   * @param {String} type
	   */
			function createInputPseudo(type) {
				return function (elem) {
					var name = elem.nodeName.toLowerCase();
					return name === "input" && elem.type === type;
				};
			}
	
			/**
	   * Returns a function to use in pseudos for buttons
	   * @param {String} type
	   */
			function createButtonPseudo(type) {
				return function (elem) {
					var name = elem.nodeName.toLowerCase();
					return (name === "input" || name === "button") && elem.type === type;
				};
			}
	
			/**
	   * Returns a function to use in pseudos for positionals
	   * @param {Function} fn
	   */
			function createPositionalPseudo(fn) {
				return markFunction(function (argument) {
					argument = +argument;
					return markFunction(function (seed, matches) {
						var j,
						    matchIndexes = fn([], seed.length, argument),
						    i = matchIndexes.length;
	
						// Match elements found at the specified indexes
						while (i--) {
							if (seed[j = matchIndexes[i]]) {
								seed[j] = !(matches[j] = seed[j]);
							}
						}
					});
				});
			}
	
			/**
	   * Checks a node for validity as a Sizzle context
	   * @param {Element|Object=} context
	   * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	   */
			function testContext(context) {
				return context && typeof context.getElementsByTagName !== "undefined" && context;
			}
	
			// Expose support vars for convenience
			support = Sizzle.support = {};
	
			/**
	   * Detects XML nodes
	   * @param {Element|Object} elem An element or a document
	   * @returns {Boolean} True iff elem is a non-HTML XML node
	   */
			isXML = Sizzle.isXML = function (elem) {
				// documentElement is verified for cases where it doesn't yet exist
				// (such as loading iframes in IE - #4833)
				var documentElement = elem && (elem.ownerDocument || elem).documentElement;
				return documentElement ? documentElement.nodeName !== "HTML" : false;
			};
	
			/**
	   * Sets document-related variables once based on the current document
	   * @param {Element|Object} [doc] An element or document object to use to set the document
	   * @returns {Object} Returns the current document
	   */
			setDocument = Sizzle.setDocument = function (node) {
				var hasCompare,
				    parent,
				    doc = node ? node.ownerDocument || node : preferredDoc;
	
				// Return early if doc is invalid or already selected
				if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
					return document;
				}
	
				// Update global variables
				document = doc;
				docElem = document.documentElement;
				documentIsHTML = !isXML(document);
	
				// Support: IE 9-11, Edge
				// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
				if ((parent = document.defaultView) && parent.top !== parent) {
					// Support: IE 11
					if (parent.addEventListener) {
						parent.addEventListener("unload", unloadHandler, false);
	
						// Support: IE 9 - 10 only
					} else if (parent.attachEvent) {
						parent.attachEvent("onunload", unloadHandler);
					}
				}
	
				/* Attributes
	   ---------------------------------------------------------------------- */
	
				// Support: IE<8
				// Verify that getAttribute really returns attributes and not properties
				// (excepting IE8 booleans)
				support.attributes = assert(function (div) {
					div.className = "i";
					return !div.getAttribute("className");
				});
	
				/* getElement(s)By*
	   ---------------------------------------------------------------------- */
	
				// Check if getElementsByTagName("*") returns only elements
				support.getElementsByTagName = assert(function (div) {
					div.appendChild(document.createComment(""));
					return !div.getElementsByTagName("*").length;
				});
	
				// Support: IE<9
				support.getElementsByClassName = rnative.test(document.getElementsByClassName);
	
				// Support: IE<10
				// Check if getElementById returns elements by name
				// The broken getElementById methods don't pick up programatically-set names,
				// so use a roundabout getElementsByName test
				support.getById = assert(function (div) {
					docElem.appendChild(div).id = expando;
					return !document.getElementsByName || !document.getElementsByName(expando).length;
				});
	
				// ID find and filter
				if (support.getById) {
					Expr.find["ID"] = function (id, context) {
						if (typeof context.getElementById !== "undefined" && documentIsHTML) {
							var m = context.getElementById(id);
							return m ? [m] : [];
						}
					};
					Expr.filter["ID"] = function (id) {
						var attrId = id.replace(runescape, funescape);
						return function (elem) {
							return elem.getAttribute("id") === attrId;
						};
					};
				} else {
					// Support: IE6/7
					// getElementById is not reliable as a find shortcut
					delete Expr.find["ID"];
	
					Expr.filter["ID"] = function (id) {
						var attrId = id.replace(runescape, funescape);
						return function (elem) {
							var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
							return node && node.value === attrId;
						};
					};
				}
	
				// Tag
				Expr.find["TAG"] = support.getElementsByTagName ? function (tag, context) {
					if (typeof context.getElementsByTagName !== "undefined") {
						return context.getElementsByTagName(tag);
	
						// DocumentFragment nodes don't have gEBTN
					} else if (support.qsa) {
						return context.querySelectorAll(tag);
					}
				} : function (tag, context) {
					var elem,
					    tmp = [],
					    i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName(tag);
	
					// Filter out possible comments
					if (tag === "*") {
						while (elem = results[i++]) {
							if (elem.nodeType === 1) {
								tmp.push(elem);
							}
						}
	
						return tmp;
					}
					return results;
				};
	
				// Class
				Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
					if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
						return context.getElementsByClassName(className);
					}
				};
	
				/* QSA/matchesSelector
	   ---------------------------------------------------------------------- */
	
				// QSA and matchesSelector support
	
				// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
				rbuggyMatches = [];
	
				// qSa(:focus) reports false when true (Chrome 21)
				// We allow this because of a bug in IE8/9 that throws an error
				// whenever `document.activeElement` is accessed on an iframe
				// So, we allow :focus to pass through QSA all the time to avoid the IE error
				// See http://bugs.jquery.com/ticket/13378
				rbuggyQSA = [];
	
				if (support.qsa = rnative.test(document.querySelectorAll)) {
					// Build QSA regex
					// Regex strategy adopted from Diego Perini
					assert(function (div) {
						// Select is set to empty string on purpose
						// This is to test IE's treatment of not explicitly
						// setting a boolean content attribute,
						// since its presence should be enough
						// http://bugs.jquery.com/ticket/12359
						docElem.appendChild(div).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
	
						// Support: IE8, Opera 11-12.16
						// Nothing should be selected when empty strings follow ^= or $= or *=
						// The test attribute must be unknown in Opera but "safe" for WinRT
						// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
						if (div.querySelectorAll("[msallowcapture^='']").length) {
							rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
						}
	
						// Support: IE8
						// Boolean attributes and "value" are not treated correctly
						if (!div.querySelectorAll("[selected]").length) {
							rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
						}
	
						// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
						if (!div.querySelectorAll("[id~=" + expando + "-]").length) {
							rbuggyQSA.push("~=");
						}
	
						// Webkit/Opera - :checked should return selected option elements
						// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
						// IE8 throws error here and will not see later tests
						if (!div.querySelectorAll(":checked").length) {
							rbuggyQSA.push(":checked");
						}
	
						// Support: Safari 8+, iOS 8+
						// https://bugs.webkit.org/show_bug.cgi?id=136851
						// In-page `selector#id sibing-combinator selector` fails
						if (!div.querySelectorAll("a#" + expando + "+*").length) {
							rbuggyQSA.push(".#.+[+~]");
						}
					});
	
					assert(function (div) {
						// Support: Windows 8 Native Apps
						// The type and name attributes are restricted during .innerHTML assignment
						var input = document.createElement("input");
						input.setAttribute("type", "hidden");
						div.appendChild(input).setAttribute("name", "D");
	
						// Support: IE8
						// Enforce case-sensitivity of name attribute
						if (div.querySelectorAll("[name=d]").length) {
							rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
						}
	
						// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
						// IE8 throws error here and will not see later tests
						if (!div.querySelectorAll(":enabled").length) {
							rbuggyQSA.push(":enabled", ":disabled");
						}
	
						// Opera 10-11 does not throw on post-comma invalid pseudos
						div.querySelectorAll("*,:x");
						rbuggyQSA.push(",.*:");
					});
				}
	
				if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) {
	
					assert(function (div) {
						// Check to see if it's possible to do matchesSelector
						// on a disconnected node (IE 9)
						support.disconnectedMatch = matches.call(div, "div");
	
						// This should fail with an exception
						// Gecko does not error, returns false instead
						matches.call(div, "[s!='']:x");
						rbuggyMatches.push("!=", pseudos);
					});
				}
	
				rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
				rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
	
				/* Contains
	   ---------------------------------------------------------------------- */
				hasCompare = rnative.test(docElem.compareDocumentPosition);
	
				// Element contains another
				// Purposefully self-exclusive
				// As in, an element does not contain itself
				contains = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
					var adown = a.nodeType === 9 ? a.documentElement : a,
					    bup = b && b.parentNode;
					return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
				} : function (a, b) {
					if (b) {
						while (b = b.parentNode) {
							if (b === a) {
								return true;
							}
						}
					}
					return false;
				};
	
				/* Sorting
	   ---------------------------------------------------------------------- */
	
				// Document order sorting
				sortOrder = hasCompare ? function (a, b) {
	
					// Flag for duplicate removal
					if (a === b) {
						hasDuplicate = true;
						return 0;
					}
	
					// Sort on method existence if only one input has compareDocumentPosition
					var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
					if (compare) {
						return compare;
					}
	
					// Calculate position if both inputs belong to the same document
					compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) :
	
					// Otherwise we know they are disconnected
					1;
	
					// Disconnected nodes
					if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
	
						// Choose the first element that is related to our preferred document
						if (a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
							return -1;
						}
						if (b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
							return 1;
						}
	
						// Maintain original order
						return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
					}
	
					return compare & 4 ? -1 : 1;
				} : function (a, b) {
					// Exit early if the nodes are identical
					if (a === b) {
						hasDuplicate = true;
						return 0;
					}
	
					var cur,
					    i = 0,
					    aup = a.parentNode,
					    bup = b.parentNode,
					    ap = [a],
					    bp = [b];
	
					// Parentless nodes are either documents or disconnected
					if (!aup || !bup) {
						return a === document ? -1 : b === document ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
	
						// If the nodes are siblings, we can do a quick check
					} else if (aup === bup) {
						return siblingCheck(a, b);
					}
	
					// Otherwise we need full lists of their ancestors for comparison
					cur = a;
					while (cur = cur.parentNode) {
						ap.unshift(cur);
					}
					cur = b;
					while (cur = cur.parentNode) {
						bp.unshift(cur);
					}
	
					// Walk down the tree looking for a discrepancy
					while (ap[i] === bp[i]) {
						i++;
					}
	
					return i ?
					// Do a sibling check if the nodes have a common ancestor
					siblingCheck(ap[i], bp[i]) :
	
					// Otherwise nodes in our document sort first
					ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
				};
	
				return document;
			};
	
			Sizzle.matches = function (expr, elements) {
				return Sizzle(expr, null, null, elements);
			};
	
			Sizzle.matchesSelector = function (elem, expr) {
				// Set document vars if needed
				if ((elem.ownerDocument || elem) !== document) {
					setDocument(elem);
				}
	
				// Make sure that attribute selectors are quoted
				expr = expr.replace(rattributeQuotes, "='$1']");
	
				if (support.matchesSelector && documentIsHTML && !compilerCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
	
					try {
						var ret = matches.call(elem, expr);
	
						// IE 9's matchesSelector returns false on disconnected nodes
						if (ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11) {
							return ret;
						}
					} catch (e) {}
				}
	
				return Sizzle(expr, document, null, [elem]).length > 0;
			};
	
			Sizzle.contains = function (context, elem) {
				// Set document vars if needed
				if ((context.ownerDocument || context) !== document) {
					setDocument(context);
				}
				return contains(context, elem);
			};
	
			Sizzle.attr = function (elem, name) {
				// Set document vars if needed
				if ((elem.ownerDocument || elem) !== document) {
					setDocument(elem);
				}
	
				var fn = Expr.attrHandle[name.toLowerCase()],
	
				// Don't get fooled by Object.prototype properties (jQuery #13807)
				val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
	
				return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
			};
	
			Sizzle.error = function (msg) {
				throw new Error("Syntax error, unrecognized expression: " + msg);
			};
	
			/**
	   * Document sorting and removing duplicates
	   * @param {ArrayLike} results
	   */
			Sizzle.uniqueSort = function (results) {
				var elem,
				    duplicates = [],
				    j = 0,
				    i = 0;
	
				// Unless we *know* we can detect duplicates, assume their presence
				hasDuplicate = !support.detectDuplicates;
				sortInput = !support.sortStable && results.slice(0);
				results.sort(sortOrder);
	
				if (hasDuplicate) {
					while (elem = results[i++]) {
						if (elem === results[i]) {
							j = duplicates.push(i);
						}
					}
					while (j--) {
						results.splice(duplicates[j], 1);
					}
				}
	
				// Clear input after sorting to release objects
				// See https://github.com/jquery/sizzle/pull/225
				sortInput = null;
	
				return results;
			};
	
			/**
	   * Utility function for retrieving the text value of an array of DOM nodes
	   * @param {Array|Element} elem
	   */
			getText = Sizzle.getText = function (elem) {
				var node,
				    ret = "",
				    i = 0,
				    nodeType = elem.nodeType;
	
				if (!nodeType) {
					// If no nodeType, this is expected to be an array
					while (node = elem[i++]) {
						// Do not traverse comment nodes
						ret += getText(node);
					}
				} else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
					// Use textContent for elements
					// innerText usage removed for consistency of new lines (jQuery #11153)
					if (typeof elem.textContent === "string") {
						return elem.textContent;
					} else {
						// Traverse its children
						for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
							ret += getText(elem);
						}
					}
				} else if (nodeType === 3 || nodeType === 4) {
					return elem.nodeValue;
				}
				// Do not include comment or processing instruction nodes
	
				return ret;
			};
	
			Expr = Sizzle.selectors = {
	
				// Can be adjusted by the user
				cacheLength: 50,
	
				createPseudo: markFunction,
	
				match: matchExpr,
	
				attrHandle: {},
	
				find: {},
	
				relative: {
					">": { dir: "parentNode", first: true },
					" ": { dir: "parentNode" },
					"+": { dir: "previousSibling", first: true },
					"~": { dir: "previousSibling" }
				},
	
				preFilter: {
					"ATTR": function (match) {
						match[1] = match[1].replace(runescape, funescape);
	
						// Move the given value to match[3] whether quoted or unquoted
						match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
	
						if (match[2] === "~=") {
							match[3] = " " + match[3] + " ";
						}
	
						return match.slice(0, 4);
					},
	
					"CHILD": function (match) {
						/* matches from matchExpr["CHILD"]
	     	1 type (only|nth|...)
	     	2 what (child|of-type)
	     	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
	     	4 xn-component of xn+y argument ([+-]?\d*n|)
	     	5 sign of xn-component
	     	6 x of xn-component
	     	7 sign of y-component
	     	8 y of y-component
	     */
						match[1] = match[1].toLowerCase();
	
						if (match[1].slice(0, 3) === "nth") {
							// nth-* requires argument
							if (!match[3]) {
								Sizzle.error(match[0]);
							}
	
							// numeric x and y parameters for Expr.filter.CHILD
							// remember that false/true cast respectively to 0/1
							match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
							match[5] = +(match[7] + match[8] || match[3] === "odd");
	
							// other types prohibit arguments
						} else if (match[3]) {
							Sizzle.error(match[0]);
						}
	
						return match;
					},
	
					"PSEUDO": function (match) {
						var excess,
						    unquoted = !match[6] && match[2];
	
						if (matchExpr["CHILD"].test(match[0])) {
							return null;
						}
	
						// Accept quoted arguments as-is
						if (match[3]) {
							match[2] = match[4] || match[5] || "";
	
							// Strip excess characters from unquoted arguments
						} else if (unquoted && rpseudo.test(unquoted) && (
						// Get excess from tokenize (recursively)
						excess = tokenize(unquoted, true)) && (
						// advance to the next closing parenthesis
						excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
	
							// excess is a negative index
							match[0] = match[0].slice(0, excess);
							match[2] = unquoted.slice(0, excess);
						}
	
						// Return only captures needed by the pseudo filter method (type and argument)
						return match.slice(0, 3);
					}
				},
	
				filter: {
	
					"TAG": function (nodeNameSelector) {
						var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
						return nodeNameSelector === "*" ? function () {
							return true;
						} : function (elem) {
							return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
						};
					},
	
					"CLASS": function (className) {
						var pattern = classCache[className + " "];
	
						return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
							return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
						});
					},
	
					"ATTR": function (name, operator, check) {
						return function (elem) {
							var result = Sizzle.attr(elem, name);
	
							if (result == null) {
								return operator === "!=";
							}
							if (!operator) {
								return true;
							}
	
							result += "";
	
							return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
						};
					},
	
					"CHILD": function (type, what, argument, first, last) {
						var simple = type.slice(0, 3) !== "nth",
						    forward = type.slice(-4) !== "last",
						    ofType = what === "of-type";
	
						return first === 1 && last === 0 ?
	
						// Shortcut for :nth-*(n)
						function (elem) {
							return !!elem.parentNode;
						} : function (elem, context, xml) {
							var cache,
							    uniqueCache,
							    outerCache,
							    node,
							    nodeIndex,
							    start,
							    dir = simple !== forward ? "nextSibling" : "previousSibling",
							    parent = elem.parentNode,
							    name = ofType && elem.nodeName.toLowerCase(),
							    useCache = !xml && !ofType,
							    diff = false;
	
							if (parent) {
	
								// :(first|last|only)-(child|of-type)
								if (simple) {
									while (dir) {
										node = elem;
										while (node = node[dir]) {
											if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
	
												return false;
											}
										}
										// Reverse direction for :only-* (if we haven't yet done so)
										start = dir = type === "only" && !start && "nextSibling";
									}
									return true;
								}
	
								start = [forward ? parent.firstChild : parent.lastChild];
	
								// non-xml :nth-child(...) stores cache data on `parent`
								if (forward && useCache) {
	
									// Seek `elem` from a previously-cached index
	
									// ...in a gzip-friendly way
									node = parent;
									outerCache = node[expando] || (node[expando] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
	
									cache = uniqueCache[type] || [];
									nodeIndex = cache[0] === dirruns && cache[1];
									diff = nodeIndex && cache[2];
									node = nodeIndex && parent.childNodes[nodeIndex];
	
									while (node = ++nodeIndex && node && node[dir] || (
	
									// Fallback to seeking `elem` from the start
									diff = nodeIndex = 0) || start.pop()) {
	
										// When found, cache indexes on `parent` and break
										if (node.nodeType === 1 && ++diff && node === elem) {
											uniqueCache[type] = [dirruns, nodeIndex, diff];
											break;
										}
									}
								} else {
									// Use previously-cached element index if available
									if (useCache) {
										// ...in a gzip-friendly way
										node = elem;
										outerCache = node[expando] || (node[expando] = {});
	
										// Support: IE <9 only
										// Defend against cloned attroperties (jQuery gh-1709)
										uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
	
										cache = uniqueCache[type] || [];
										nodeIndex = cache[0] === dirruns && cache[1];
										diff = nodeIndex;
									}
	
									// xml :nth-child(...)
									// or :nth-last-child(...) or :nth(-last)?-of-type(...)
									if (diff === false) {
										// Use the same loop as above to seek `elem` from the start
										while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
	
											if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
	
												// Cache the index of each encountered element
												if (useCache) {
													outerCache = node[expando] || (node[expando] = {});
	
													// Support: IE <9 only
													// Defend against cloned attroperties (jQuery gh-1709)
													uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
	
													uniqueCache[type] = [dirruns, diff];
												}
	
												if (node === elem) {
													break;
												}
											}
										}
									}
								}
	
								// Incorporate the offset, then check against cycle size
								diff -= last;
								return diff === first || diff % first === 0 && diff / first >= 0;
							}
						};
					},
	
					"PSEUDO": function (pseudo, argument) {
						// pseudo-class names are case-insensitive
						// http://www.w3.org/TR/selectors/#pseudo-classes
						// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
						// Remember that setFilters inherits from pseudos
						var args,
						    fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
	
						// The user may use createPseudo to indicate that
						// arguments are needed to create the filter function
						// just as Sizzle does
						if (fn[expando]) {
							return fn(argument);
						}
	
						// But maintain support for old signatures
						if (fn.length > 1) {
							args = [pseudo, pseudo, "", argument];
							return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
								var idx,
								    matched = fn(seed, argument),
								    i = matched.length;
								while (i--) {
									idx = indexOf(seed, matched[i]);
									seed[idx] = !(matches[idx] = matched[i]);
								}
							}) : function (elem) {
								return fn(elem, 0, args);
							};
						}
	
						return fn;
					}
				},
	
				pseudos: {
					// Potentially complex pseudos
					"not": markFunction(function (selector) {
						// Trim the selector passed to compile
						// to avoid treating leading and trailing
						// spaces as combinators
						var input = [],
						    results = [],
						    matcher = compile(selector.replace(rtrim, "$1"));
	
						return matcher[expando] ? markFunction(function (seed, matches, context, xml) {
							var elem,
							    unmatched = matcher(seed, null, xml, []),
							    i = seed.length;
	
							// Match elements unmatched by `matcher`
							while (i--) {
								if (elem = unmatched[i]) {
									seed[i] = !(matches[i] = elem);
								}
							}
						}) : function (elem, context, xml) {
							input[0] = elem;
							matcher(input, null, xml, results);
							// Don't keep the element (issue #299)
							input[0] = null;
							return !results.pop();
						};
					}),
	
					"has": markFunction(function (selector) {
						return function (elem) {
							return Sizzle(selector, elem).length > 0;
						};
					}),
	
					"contains": markFunction(function (text) {
						text = text.replace(runescape, funescape);
						return function (elem) {
							return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
						};
					}),
	
					// "Whether an element is represented by a :lang() selector
					// is based solely on the element's language value
					// being equal to the identifier C,
					// or beginning with the identifier C immediately followed by "-".
					// The matching of C against the element's language value is performed case-insensitively.
					// The identifier C does not have to be a valid language name."
					// http://www.w3.org/TR/selectors/#lang-pseudo
					"lang": markFunction(function (lang) {
						// lang value must be a valid identifier
						if (!ridentifier.test(lang || "")) {
							Sizzle.error("unsupported lang: " + lang);
						}
						lang = lang.replace(runescape, funescape).toLowerCase();
						return function (elem) {
							var elemLang;
							do {
								if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
	
									elemLang = elemLang.toLowerCase();
									return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
								}
							} while ((elem = elem.parentNode) && elem.nodeType === 1);
							return false;
						};
					}),
	
					// Miscellaneous
					"target": function (elem) {
						var hash = window.location && window.location.hash;
						return hash && hash.slice(1) === elem.id;
					},
	
					"root": function (elem) {
						return elem === docElem;
					},
	
					"focus": function (elem) {
						return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
					},
	
					// Boolean properties
					"enabled": function (elem) {
						return elem.disabled === false;
					},
	
					"disabled": function (elem) {
						return elem.disabled === true;
					},
	
					"checked": function (elem) {
						// In CSS3, :checked should return both checked and selected elements
						// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
						var nodeName = elem.nodeName.toLowerCase();
						return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
					},
	
					"selected": function (elem) {
						// Accessing this property makes selected-by-default
						// options in Safari work properly
						if (elem.parentNode) {
							elem.parentNode.selectedIndex;
						}
	
						return elem.selected === true;
					},
	
					// Contents
					"empty": function (elem) {
						// http://www.w3.org/TR/selectors/#empty-pseudo
						// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
						//   but not by others (comment: 8; processing instruction: 7; etc.)
						// nodeType < 6 works because attributes (2) do not appear as children
						for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
							if (elem.nodeType < 6) {
								return false;
							}
						}
						return true;
					},
	
					"parent": function (elem) {
						return !Expr.pseudos["empty"](elem);
					},
	
					// Element/input types
					"header": function (elem) {
						return rheader.test(elem.nodeName);
					},
	
					"input": function (elem) {
						return rinputs.test(elem.nodeName);
					},
	
					"button": function (elem) {
						var name = elem.nodeName.toLowerCase();
						return name === "input" && elem.type === "button" || name === "button";
					},
	
					"text": function (elem) {
						var attr;
						return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && (
	
						// Support: IE<8
						// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
						(attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
					},
	
					// Position-in-collection
					"first": createPositionalPseudo(function () {
						return [0];
					}),
	
					"last": createPositionalPseudo(function (matchIndexes, length) {
						return [length - 1];
					}),
	
					"eq": createPositionalPseudo(function (matchIndexes, length, argument) {
						return [argument < 0 ? argument + length : argument];
					}),
	
					"even": createPositionalPseudo(function (matchIndexes, length) {
						var i = 0;
						for (; i < length; i += 2) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					}),
	
					"odd": createPositionalPseudo(function (matchIndexes, length) {
						var i = 1;
						for (; i < length; i += 2) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					}),
	
					"lt": createPositionalPseudo(function (matchIndexes, length, argument) {
						var i = argument < 0 ? argument + length : argument;
						for (; --i >= 0;) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					}),
	
					"gt": createPositionalPseudo(function (matchIndexes, length, argument) {
						var i = argument < 0 ? argument + length : argument;
						for (; ++i < length;) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					})
				}
			};
	
			Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
			// Add button/input type pseudos
			for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
				Expr.pseudos[i] = createInputPseudo(i);
			}
			for (i in { submit: true, reset: true }) {
				Expr.pseudos[i] = createButtonPseudo(i);
			}
	
			// Easy API for creating new setFilters
			function setFilters() {}
			setFilters.prototype = Expr.filters = Expr.pseudos;
			Expr.setFilters = new setFilters();
	
			tokenize = Sizzle.tokenize = function (selector, parseOnly) {
				var matched,
				    match,
				    tokens,
				    type,
				    soFar,
				    groups,
				    preFilters,
				    cached = tokenCache[selector + " "];
	
				if (cached) {
					return parseOnly ? 0 : cached.slice(0);
				}
	
				soFar = selector;
				groups = [];
				preFilters = Expr.preFilter;
	
				while (soFar) {
	
					// Comma and first run
					if (!matched || (match = rcomma.exec(soFar))) {
						if (match) {
							// Don't consume trailing commas as valid
							soFar = soFar.slice(match[0].length) || soFar;
						}
						groups.push(tokens = []);
					}
	
					matched = false;
	
					// Combinators
					if (match = rcombinators.exec(soFar)) {
						matched = match.shift();
						tokens.push({
							value: matched,
							// Cast descendant combinators to space
							type: match[0].replace(rtrim, " ")
						});
						soFar = soFar.slice(matched.length);
					}
	
					// Filters
					for (type in Expr.filter) {
						if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
							matched = match.shift();
							tokens.push({
								value: matched,
								type: type,
								matches: match
							});
							soFar = soFar.slice(matched.length);
						}
					}
	
					if (!matched) {
						break;
					}
				}
	
				// Return the length of the invalid excess
				// if we're just parsing
				// Otherwise, throw an error or return tokens
				return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) :
				// Cache the tokens
				tokenCache(selector, groups).slice(0);
			};
	
			function toSelector(tokens) {
				var i = 0,
				    len = tokens.length,
				    selector = "";
				for (; i < len; i++) {
					selector += tokens[i].value;
				}
				return selector;
			}
	
			function addCombinator(matcher, combinator, base) {
				var dir = combinator.dir,
				    checkNonElements = base && dir === "parentNode",
				    doneName = done++;
	
				return combinator.first ?
				// Check against closest ancestor/preceding element
				function (elem, context, xml) {
					while (elem = elem[dir]) {
						if (elem.nodeType === 1 || checkNonElements) {
							return matcher(elem, context, xml);
						}
					}
				} :
	
				// Check against all ancestor/preceding elements
				function (elem, context, xml) {
					var oldCache,
					    uniqueCache,
					    outerCache,
					    newCache = [dirruns, doneName];
	
					// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
					if (xml) {
						while (elem = elem[dir]) {
							if (elem.nodeType === 1 || checkNonElements) {
								if (matcher(elem, context, xml)) {
									return true;
								}
							}
						}
					} else {
						while (elem = elem[dir]) {
							if (elem.nodeType === 1 || checkNonElements) {
								outerCache = elem[expando] || (elem[expando] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
	
								if ((oldCache = uniqueCache[dir]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
	
									// Assign to newCache so results back-propagate to previous elements
									return newCache[2] = oldCache[2];
								} else {
									// Reuse newcache so results back-propagate to previous elements
									uniqueCache[dir] = newCache;
	
									// A match means we're done; a fail means we have to keep checking
									if (newCache[2] = matcher(elem, context, xml)) {
										return true;
									}
								}
							}
						}
					}
				};
			}
	
			function elementMatcher(matchers) {
				return matchers.length > 1 ? function (elem, context, xml) {
					var i = matchers.length;
					while (i--) {
						if (!matchers[i](elem, context, xml)) {
							return false;
						}
					}
					return true;
				} : matchers[0];
			}
	
			function multipleContexts(selector, contexts, results) {
				var i = 0,
				    len = contexts.length;
				for (; i < len; i++) {
					Sizzle(selector, contexts[i], results);
				}
				return results;
			}
	
			function condense(unmatched, map, filter, context, xml) {
				var elem,
				    newUnmatched = [],
				    i = 0,
				    len = unmatched.length,
				    mapped = map != null;
	
				for (; i < len; i++) {
					if (elem = unmatched[i]) {
						if (!filter || filter(elem, context, xml)) {
							newUnmatched.push(elem);
							if (mapped) {
								map.push(i);
							}
						}
					}
				}
	
				return newUnmatched;
			}
	
			function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
				if (postFilter && !postFilter[expando]) {
					postFilter = setMatcher(postFilter);
				}
				if (postFinder && !postFinder[expando]) {
					postFinder = setMatcher(postFinder, postSelector);
				}
				return markFunction(function (seed, results, context, xml) {
					var temp,
					    i,
					    elem,
					    preMap = [],
					    postMap = [],
					    preexisting = results.length,
	
	
					// Get initial elements from seed or context
					elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
	
	
					// Prefilter to get matcher input, preserving a map for seed-results synchronization
					matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
					    matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || (seed ? preFilter : preexisting || postFilter) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results : matcherIn;
	
					// Find primary matches
					if (matcher) {
						matcher(matcherIn, matcherOut, context, xml);
					}
	
					// Apply postFilter
					if (postFilter) {
						temp = condense(matcherOut, postMap);
						postFilter(temp, [], context, xml);
	
						// Un-match failing elements by moving them back to matcherIn
						i = temp.length;
						while (i--) {
							if (elem = temp[i]) {
								matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
							}
						}
					}
	
					if (seed) {
						if (postFinder || preFilter) {
							if (postFinder) {
								// Get the final matcherOut by condensing this intermediate into postFinder contexts
								temp = [];
								i = matcherOut.length;
								while (i--) {
									if (elem = matcherOut[i]) {
										// Restore matcherIn since elem is not yet a final match
										temp.push(matcherIn[i] = elem);
									}
								}
								postFinder(null, matcherOut = [], temp, xml);
							}
	
							// Move matched elements from seed to results to keep them synchronized
							i = matcherOut.length;
							while (i--) {
								if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {
	
									seed[temp] = !(results[temp] = elem);
								}
							}
						}
	
						// Add elements to results, through postFinder if defined
					} else {
						matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
						if (postFinder) {
							postFinder(null, results, matcherOut, xml);
						} else {
							push.apply(results, matcherOut);
						}
					}
				});
			}
	
			function matcherFromTokens(tokens) {
				var checkContext,
				    matcher,
				    j,
				    len = tokens.length,
				    leadingRelative = Expr.relative[tokens[0].type],
				    implicitRelative = leadingRelative || Expr.relative[" "],
				    i = leadingRelative ? 1 : 0,
	
	
				// The foundational matcher ensures that elements are reachable from top-level context(s)
				matchContext = addCombinator(function (elem) {
					return elem === checkContext;
				}, implicitRelative, true),
				    matchAnyContext = addCombinator(function (elem) {
					return indexOf(checkContext, elem) > -1;
				}, implicitRelative, true),
				    matchers = [function (elem, context, xml) {
					var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
					// Avoid hanging onto element (issue #299)
					checkContext = null;
					return ret;
				}];
	
				for (; i < len; i++) {
					if (matcher = Expr.relative[tokens[i].type]) {
						matchers = [addCombinator(elementMatcher(matchers), matcher)];
					} else {
						matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
	
						// Return special upon seeing a positional matcher
						if (matcher[expando]) {
							// Find the next relative operator (if any) for proper handling
							j = ++i;
							for (; j < len; j++) {
								if (Expr.relative[tokens[j].type]) {
									break;
								}
							}
							return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === " " ? "*" : "" })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
						}
						matchers.push(matcher);
					}
				}
	
				return elementMatcher(matchers);
			}
	
			function matcherFromGroupMatchers(elementMatchers, setMatchers) {
				var bySet = setMatchers.length > 0,
				    byElement = elementMatchers.length > 0,
				    superMatcher = function (seed, context, xml, results, outermost) {
					var elem,
					    j,
					    matcher,
					    matchedCount = 0,
					    i = "0",
					    unmatched = seed && [],
					    setMatched = [],
					    contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]("*", outermost),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
					    len = elems.length;
	
					if (outermost) {
						outermostContext = context === document || context || outermost;
					}
	
					// Add elements passing elementMatchers directly to results
					// Support: IE<9, Safari
					// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
					for (; i !== len && (elem = elems[i]) != null; i++) {
						if (byElement && elem) {
							j = 0;
							if (!context && elem.ownerDocument !== document) {
								setDocument(elem);
								xml = !documentIsHTML;
							}
							while (matcher = elementMatchers[j++]) {
								if (matcher(elem, context || document, xml)) {
									results.push(elem);
									break;
								}
							}
							if (outermost) {
								dirruns = dirrunsUnique;
							}
						}
	
						// Track unmatched elements for set filters
						if (bySet) {
							// They will have gone through all possible matchers
							if (elem = !matcher && elem) {
								matchedCount--;
							}
	
							// Lengthen the array for every element, matched or not
							if (seed) {
								unmatched.push(elem);
							}
						}
					}
	
					// `i` is now the count of elements visited above, and adding it to `matchedCount`
					// makes the latter nonnegative.
					matchedCount += i;
	
					// Apply set filters to unmatched elements
					// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
					// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
					// no element matchers and no seed.
					// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
					// case, which will result in a "00" `matchedCount` that differs from `i` but is also
					// numerically zero.
					if (bySet && i !== matchedCount) {
						j = 0;
						while (matcher = setMatchers[j++]) {
							matcher(unmatched, setMatched, context, xml);
						}
	
						if (seed) {
							// Reintegrate element matches to eliminate the need for sorting
							if (matchedCount > 0) {
								while (i--) {
									if (!(unmatched[i] || setMatched[i])) {
										setMatched[i] = pop.call(results);
									}
								}
							}
	
							// Discard index placeholder values to get only actual matches
							setMatched = condense(setMatched);
						}
	
						// Add matches to results
						push.apply(results, setMatched);
	
						// Seedless set matches succeeding multiple successful matchers stipulate sorting
						if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
	
							Sizzle.uniqueSort(results);
						}
					}
	
					// Override manipulation of globals by nested matchers
					if (outermost) {
						dirruns = dirrunsUnique;
						outermostContext = contextBackup;
					}
	
					return unmatched;
				};
	
				return bySet ? markFunction(superMatcher) : superMatcher;
			}
	
			compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
				var i,
				    setMatchers = [],
				    elementMatchers = [],
				    cached = compilerCache[selector + " "];
	
				if (!cached) {
					// Generate a function of recursive functions that can be used to check each element
					if (!match) {
						match = tokenize(selector);
					}
					i = match.length;
					while (i--) {
						cached = matcherFromTokens(match[i]);
						if (cached[expando]) {
							setMatchers.push(cached);
						} else {
							elementMatchers.push(cached);
						}
					}
	
					// Cache the compiled function
					cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
	
					// Save selector and tokenization
					cached.selector = selector;
				}
				return cached;
			};
	
			/**
	   * A low-level selection function that works with Sizzle's compiled
	   *  selector functions
	   * @param {String|Function} selector A selector or a pre-compiled
	   *  selector function built with Sizzle.compile
	   * @param {Element} context
	   * @param {Array} [results]
	   * @param {Array} [seed] A set of elements to match against
	   */
			select = Sizzle.select = function (selector, context, results, seed) {
				var i,
				    tokens,
				    token,
				    type,
				    find,
				    compiled = typeof selector === "function" && selector,
				    match = !seed && tokenize(selector = compiled.selector || selector);
	
				results = results || [];
	
				// Try to minimize operations if there is only one selector in the list and no seed
				// (the latter of which guarantees us context)
				if (match.length === 1) {
	
					// Reduce context if the leading compound selector is an ID
					tokens = match[0] = match[0].slice(0);
					if (tokens.length > 2 && (token = tokens[0]).type === "ID" && support.getById && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
	
						context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
						if (!context) {
							return results;
	
							// Precompiled matchers will still verify ancestry, so step up a level
						} else if (compiled) {
							context = context.parentNode;
						}
	
						selector = selector.slice(tokens.shift().value.length);
					}
	
					// Fetch a seed set for right-to-left matching
					i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
					while (i--) {
						token = tokens[i];
	
						// Abort if we hit a combinator
						if (Expr.relative[type = token.type]) {
							break;
						}
						if (find = Expr.find[type]) {
							// Search, expanding context for leading sibling combinators
							if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
	
								// If seed is empty or no tokens remain, we can return early
								tokens.splice(i, 1);
								selector = seed.length && toSelector(tokens);
								if (!selector) {
									push.apply(results, seed);
									return results;
								}
	
								break;
							}
						}
					}
				}
	
				// Compile and execute a filtering function if one is not provided
				// Provide `match` to avoid retokenization if we modified the selector above
				(compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
				return results;
			};
	
			// One-time assignments
	
			// Sort stability
			support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
	
			// Support: Chrome 14-35+
			// Always assume duplicates if they aren't passed to the comparison function
			support.detectDuplicates = !!hasDuplicate;
	
			// Initialize against the default document
			setDocument();
	
			// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
			// Detached nodes confoundingly follow *each other*
			support.sortDetached = assert(function (div1) {
				// Should return 1, but returns 4 (following)
				return div1.compareDocumentPosition(document.createElement("div")) & 1;
			});
	
			// Support: IE<8
			// Prevent attribute/property "interpolation"
			// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
			if (!assert(function (div) {
				div.innerHTML = "<a href='#'></a>";
				return div.firstChild.getAttribute("href") === "#";
			})) {
				addHandle("type|href|height|width", function (elem, name, isXML) {
					if (!isXML) {
						return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
					}
				});
			}
	
			// Support: IE<9
			// Use defaultValue in place of getAttribute("value")
			if (!support.attributes || !assert(function (div) {
				div.innerHTML = "<input/>";
				div.firstChild.setAttribute("value", "");
				return div.firstChild.getAttribute("value") === "";
			})) {
				addHandle("value", function (elem, name, isXML) {
					if (!isXML && elem.nodeName.toLowerCase() === "input") {
						return elem.defaultValue;
					}
				});
			}
	
			// Support: IE<9
			// Use getAttributeNode to fetch booleans when getAttribute lies
			if (!assert(function (div) {
				return div.getAttribute("disabled") == null;
			})) {
				addHandle(booleans, function (elem, name, isXML) {
					var val;
					if (!isXML) {
						return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
					}
				});
			}
	
			return Sizzle;
		}(window);
	
		jQuery.find = Sizzle;
		jQuery.expr = Sizzle.selectors;
		jQuery.expr[":"] = jQuery.expr.pseudos;
		jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
		jQuery.text = Sizzle.getText;
		jQuery.isXMLDoc = Sizzle.isXML;
		jQuery.contains = Sizzle.contains;
	
		var dir = function (elem, dir, until) {
			var matched = [],
			    truncate = until !== undefined;
	
			while ((elem = elem[dir]) && elem.nodeType !== 9) {
				if (elem.nodeType === 1) {
					if (truncate && jQuery(elem).is(until)) {
						break;
					}
					matched.push(elem);
				}
			}
			return matched;
		};
	
		var siblings = function (n, elem) {
			var matched = [];
	
			for (; n; n = n.nextSibling) {
				if (n.nodeType === 1 && n !== elem) {
					matched.push(n);
				}
			}
	
			return matched;
		};
	
		var rneedsContext = jQuery.expr.match.needsContext;
	
		var rsingleTag = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	
		var risSimple = /^.[^:#\[\.,]*$/;
	
		// Implement the identical functionality for filter and not
		function winnow(elements, qualifier, not) {
			if (jQuery.isFunction(qualifier)) {
				return jQuery.grep(elements, function (elem, i) {
					/* jshint -W018 */
					return !!qualifier.call(elem, i, elem) !== not;
				});
			}
	
			if (qualifier.nodeType) {
				return jQuery.grep(elements, function (elem) {
					return elem === qualifier !== not;
				});
			}
	
			if (typeof qualifier === "string") {
				if (risSimple.test(qualifier)) {
					return jQuery.filter(qualifier, elements, not);
				}
	
				qualifier = jQuery.filter(qualifier, elements);
			}
	
			return jQuery.grep(elements, function (elem) {
				return jQuery.inArray(elem, qualifier) > -1 !== not;
			});
		}
	
		jQuery.filter = function (expr, elems, not) {
			var elem = elems[0];
	
			if (not) {
				expr = ":not(" + expr + ")";
			}
	
			return elems.length === 1 && elem.nodeType === 1 ? jQuery.find.matchesSelector(elem, expr) ? [elem] : [] : jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
				return elem.nodeType === 1;
			}));
		};
	
		jQuery.fn.extend({
			find: function (selector) {
				var i,
				    ret = [],
				    self = this,
				    len = self.length;
	
				if (typeof selector !== "string") {
					return this.pushStack(jQuery(selector).filter(function () {
						for (i = 0; i < len; i++) {
							if (jQuery.contains(self[i], this)) {
								return true;
							}
						}
					}));
				}
	
				for (i = 0; i < len; i++) {
					jQuery.find(selector, self[i], ret);
				}
	
				// Needed because $( selector, context ) becomes $( context ).find( selector )
				ret = this.pushStack(len > 1 ? jQuery.unique(ret) : ret);
				ret.selector = this.selector ? this.selector + " " + selector : selector;
				return ret;
			},
			filter: function (selector) {
				return this.pushStack(winnow(this, selector || [], false));
			},
			not: function (selector) {
				return this.pushStack(winnow(this, selector || [], true));
			},
			is: function (selector) {
				return !!winnow(this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
			}
		});
	
		// Initialize a jQuery object
	
	
		// A central reference to the root jQuery(document)
		var rootjQuery,
	
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
		    init = jQuery.fn.init = function (selector, context, root) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if (!selector) {
				return this;
			}
	
			// init accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if (typeof selector === "string") {
				if (selector.charAt(0) === "<" && selector.charAt(selector.length - 1) === ">" && selector.length >= 3) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [null, selector, null];
				} else {
					match = rquickExpr.exec(selector);
				}
	
				// Match html or make sure no context is specified for #id
				if (match && (match[1] || !context)) {
	
					// HANDLE: $(html) -> $(array)
					if (match[1]) {
						context = context instanceof jQuery ? context[0] : context;
	
						// scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
	
						// HANDLE: $(html, props)
						if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
							for (match in context) {
	
								// Properties of context are called as methods if possible
								if (jQuery.isFunction(this[match])) {
									this[match](context[match]);
	
									// ...and otherwise set as attributes
								} else {
									this.attr(match, context[match]);
								}
							}
						}
	
						return this;
	
						// HANDLE: $(#id)
					} else {
						elem = document.getElementById(match[2]);
	
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document #6963
						if (elem && elem.parentNode) {
	
							// Handle the case where IE and Opera return items
							// by name instead of ID
							if (elem.id !== match[2]) {
								return rootjQuery.find(selector);
							}
	
							// Otherwise, we inject the element directly into the jQuery object
							this.length = 1;
							this[0] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
					// HANDLE: $(expr, $(...))
				} else if (!context || context.jquery) {
					return (context || root).find(selector);
	
					// HANDLE: $(expr, context)
					// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor(context).find(selector);
				}
	
				// HANDLE: $(DOMElement)
			} else if (selector.nodeType) {
				this.context = this[0] = selector;
				this.length = 1;
				return this;
	
				// HANDLE: $(function)
				// Shortcut for document ready
			} else if (jQuery.isFunction(selector)) {
				return typeof root.ready !== "undefined" ? root.ready(selector) :
	
				// Execute immediately if ready is not present
				selector(jQuery);
			}
	
			if (selector.selector !== undefined) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray(selector, this);
		};
	
		// Give the init function the jQuery prototype for later instantiation
		init.prototype = jQuery.fn;
	
		// Initialize central reference
		rootjQuery = jQuery(document);
	
		var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
	
		// methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
		jQuery.fn.extend({
			has: function (target) {
				var i,
				    targets = jQuery(target, this),
				    len = targets.length;
	
				return this.filter(function () {
					for (i = 0; i < len; i++) {
						if (jQuery.contains(this, targets[i])) {
							return true;
						}
					}
				});
			},
	
			closest: function (selectors, context) {
				var cur,
				    i = 0,
				    l = this.length,
				    matched = [],
				    pos = rneedsContext.test(selectors) || typeof selectors !== "string" ? jQuery(selectors, context || this.context) : 0;
	
				for (; i < l; i++) {
					for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
	
						// Always skip document fragments
						if (cur.nodeType < 11 && (pos ? pos.index(cur) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
	
							matched.push(cur);
							break;
						}
					}
				}
	
				return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
			},
	
			// Determine the position of an element within
			// the matched set of elements
			index: function (elem) {
	
				// No argument, return index in parent
				if (!elem) {
					return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
				}
	
				// index in selector
				if (typeof elem === "string") {
					return jQuery.inArray(this[0], jQuery(elem));
				}
	
				// Locate the position of the desired element
				return jQuery.inArray(
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[0] : elem, this);
			},
	
			add: function (selector, context) {
				return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
			},
	
			addBack: function (selector) {
				return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
			}
		});
	
		function sibling(cur, dir) {
			do {
				cur = cur[dir];
			} while (cur && cur.nodeType !== 1);
	
			return cur;
		}
	
		jQuery.each({
			parent: function (elem) {
				var parent = elem.parentNode;
				return parent && parent.nodeType !== 11 ? parent : null;
			},
			parents: function (elem) {
				return dir(elem, "parentNode");
			},
			parentsUntil: function (elem, i, until) {
				return dir(elem, "parentNode", until);
			},
			next: function (elem) {
				return sibling(elem, "nextSibling");
			},
			prev: function (elem) {
				return sibling(elem, "previousSibling");
			},
			nextAll: function (elem) {
				return dir(elem, "nextSibling");
			},
			prevAll: function (elem) {
				return dir(elem, "previousSibling");
			},
			nextUntil: function (elem, i, until) {
				return dir(elem, "nextSibling", until);
			},
			prevUntil: function (elem, i, until) {
				return dir(elem, "previousSibling", until);
			},
			siblings: function (elem) {
				return siblings((elem.parentNode || {}).firstChild, elem);
			},
			children: function (elem) {
				return siblings(elem.firstChild);
			},
			contents: function (elem) {
				return jQuery.nodeName(elem, "iframe") ? elem.contentDocument || elem.contentWindow.document : jQuery.merge([], elem.childNodes);
			}
		}, function (name, fn) {
			jQuery.fn[name] = function (until, selector) {
				var ret = jQuery.map(this, fn, until);
	
				if (name.slice(-5) !== "Until") {
					selector = until;
				}
	
				if (selector && typeof selector === "string") {
					ret = jQuery.filter(selector, ret);
				}
	
				if (this.length > 1) {
	
					// Remove duplicates
					if (!guaranteedUnique[name]) {
						ret = jQuery.uniqueSort(ret);
					}
	
					// Reverse order for parents* and prev-derivatives
					if (rparentsprev.test(name)) {
						ret = ret.reverse();
					}
				}
	
				return this.pushStack(ret);
			};
		});
		var rnotwhite = /\S+/g;
	
		// Convert String-formatted options into Object-formatted ones
		function createOptions(options) {
			var object = {};
			jQuery.each(options.match(rnotwhite) || [], function (_, flag) {
				object[flag] = true;
			});
			return object;
		}
	
		/*
	  * Create a callback list using the following parameters:
	  *
	  *	options: an optional list of space-separated options that will change how
	  *			the callback list behaves or a more traditional option object
	  *
	  * By default a callback list will act like an event callback list and can be
	  * "fired" multiple times.
	  *
	  * Possible options:
	  *
	  *	once:			will ensure the callback list can only be fired once (like a Deferred)
	  *
	  *	memory:			will keep track of previous values and will call any callback added
	  *					after the list has been fired right away with the latest "memorized"
	  *					values (like a Deferred)
	  *
	  *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	  *
	  *	stopOnFalse:	interrupt callings when a callback returns false
	  *
	  */
		jQuery.Callbacks = function (options) {
	
			// Convert options from String-formatted to Object-formatted if needed
			// (we check in cache first)
			options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
	
			var // Flag to know if list is currently firing
			firing,
	
	
			// Last fire value for non-forgettable lists
			memory,
	
	
			// Flag to know if list was already fired
			fired,
	
	
			// Flag to prevent firing
			locked,
	
	
			// Actual callback list
			list = [],
	
	
			// Queue of execution data for repeatable lists
			queue = [],
	
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
	
			// Fire callbacks
			fire = function () {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for (; queue.length; firingIndex = -1) {
					memory = queue.shift();
					while (++firingIndex < list.length) {
	
						// Run callback and check for early termination
						if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if (!options.memory) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if (locked) {
	
					// Keep an empty list if we have data for future add calls
					if (memory) {
						list = [];
	
						// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function () {
					if (list) {
	
						// If we have memory from a past run, we should fire after adding
						if (memory && !firing) {
							firingIndex = list.length - 1;
							queue.push(memory);
						}
	
						(function add(args) {
							jQuery.each(args, function (_, arg) {
								if (jQuery.isFunction(arg)) {
									if (!options.unique || !self.has(arg)) {
										list.push(arg);
									}
								} else if (arg && arg.length && jQuery.type(arg) !== "string") {
	
									// Inspect recursively
									add(arg);
								}
							});
						})(arguments);
	
						if (memory && !firing) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function () {
					jQuery.each(arguments, function (_, arg) {
						var index;
						while ((index = jQuery.inArray(arg, list, index)) > -1) {
							list.splice(index, 1);
	
							// Handle firing indexes
							if (index <= firingIndex) {
								firingIndex--;
							}
						}
					});
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function (fn) {
					return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function () {
					if (list) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function () {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function () {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function () {
					locked = true;
					if (!memory) {
						self.disable();
					}
					return this;
				},
				locked: function () {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function (context, args) {
					if (!locked) {
						args = args || [];
						args = [context, args.slice ? args.slice() : args];
						queue.push(args);
						if (!firing) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function () {
					self.fireWith(this, arguments);
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function () {
					return !!fired;
				}
			};
	
			return self;
		};
	
		jQuery.extend({
	
			Deferred: function (func) {
				var tuples = [
	
				// action, add listener, listener list, final state
				["resolve", "done", jQuery.Callbacks("once memory"), "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), "rejected"], ["notify", "progress", jQuery.Callbacks("memory")]],
				    state = "pending",
				    promise = {
					state: function () {
						return state;
					},
					always: function () {
						deferred.done(arguments).fail(arguments);
						return this;
					},
					then: function () /* fnDone, fnFail, fnProgress */{
						var fns = arguments;
						return jQuery.Deferred(function (newDefer) {
							jQuery.each(tuples, function (i, tuple) {
								var fn = jQuery.isFunction(fns[i]) && fns[i];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[tuple[1]](function () {
									var returned = fn && fn.apply(this, arguments);
									if (returned && jQuery.isFunction(returned.promise)) {
										returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
									} else {
										newDefer[tuple[0] + "With"](this === promise ? newDefer.promise() : this, fn ? [returned] : arguments);
									}
								});
							});
							fns = null;
						}).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function (obj) {
						return obj != null ? jQuery.extend(obj, promise) : promise;
					}
				},
				    deferred = {};
	
				// Keep pipe for back-compat
				promise.pipe = promise.then;
	
				// Add list-specific methods
				jQuery.each(tuples, function (i, tuple) {
					var list = tuple[2],
					    stateString = tuple[3];
	
					// promise[ done | fail | progress ] = list.add
					promise[tuple[1]] = list.add;
	
					// Handle state
					if (stateString) {
						list.add(function () {
	
							// state = [ resolved | rejected ]
							state = stateString;
	
							// [ reject_list | resolve_list ].disable; progress_list.lock
						}, tuples[i ^ 1][2].disable, tuples[2][2].lock);
					}
	
					// deferred[ resolve | reject | notify ]
					deferred[tuple[0]] = function () {
						deferred[tuple[0] + "With"](this === deferred ? promise : this, arguments);
						return this;
					};
					deferred[tuple[0] + "With"] = list.fireWith;
				});
	
				// Make the deferred a promise
				promise.promise(deferred);
	
				// Call given func if any
				if (func) {
					func.call(deferred, deferred);
				}
	
				// All done!
				return deferred;
			},
	
			// Deferred helper
			when: function (subordinate /* , ..., subordinateN */) {
				var i = 0,
				    resolveValues = slice.call(arguments),
				    length = resolveValues.length,
	
	
				// the count of uncompleted subordinates
				remaining = length !== 1 || subordinate && jQuery.isFunction(subordinate.promise) ? length : 0,
	
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
	
				// Update function for both resolve and progress values
				updateFunc = function (i, contexts, values) {
					return function (value) {
						contexts[i] = this;
						values[i] = arguments.length > 1 ? slice.call(arguments) : value;
						if (values === progressValues) {
							deferred.notifyWith(contexts, values);
						} else if (! --remaining) {
							deferred.resolveWith(contexts, values);
						}
					};
				},
				    progressValues,
				    progressContexts,
				    resolveContexts;
	
				// add listeners to Deferred subordinates; treat others as resolved
				if (length > 1) {
					progressValues = new Array(length);
					progressContexts = new Array(length);
					resolveContexts = new Array(length);
					for (; i < length; i++) {
						if (resolveValues[i] && jQuery.isFunction(resolveValues[i].promise)) {
							resolveValues[i].promise().progress(updateFunc(i, progressContexts, progressValues)).done(updateFunc(i, resolveContexts, resolveValues)).fail(deferred.reject);
						} else {
							--remaining;
						}
					}
				}
	
				// if we're not waiting on anything, resolve the master
				if (!remaining) {
					deferred.resolveWith(resolveContexts, resolveValues);
				}
	
				return deferred.promise();
			}
		});
	
		// The deferred used on DOM ready
		var readyList;
	
		jQuery.fn.ready = function (fn) {
	
			// Add the callback
			jQuery.ready.promise().done(fn);
	
			return this;
		};
	
		jQuery.extend({
	
			// Is the DOM ready to be used? Set to true once it occurs.
			isReady: false,
	
			// A counter to track how many items to wait for before
			// the ready event fires. See #6781
			readyWait: 1,
	
			// Hold (or release) the ready event
			holdReady: function (hold) {
				if (hold) {
					jQuery.readyWait++;
				} else {
					jQuery.ready(true);
				}
			},
	
			// Handle when the DOM is ready
			ready: function (wait) {
	
				// Abort if there are pending holds or we're already ready
				if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
					return;
				}
	
				// Remember that the DOM is ready
				jQuery.isReady = true;
	
				// If a normal DOM Ready event fired, decrement, and wait if need be
				if (wait !== true && --jQuery.readyWait > 0) {
					return;
				}
	
				// If there are functions bound, to execute
				readyList.resolveWith(document, [jQuery]);
	
				// Trigger any bound ready events
				if (jQuery.fn.triggerHandler) {
					jQuery(document).triggerHandler("ready");
					jQuery(document).off("ready");
				}
			}
		});
	
		/**
	  * Clean-up method for dom ready events
	  */
		function detach() {
			if (document.addEventListener) {
				document.removeEventListener("DOMContentLoaded", completed);
				window.removeEventListener("load", completed);
			} else {
				document.detachEvent("onreadystatechange", completed);
				window.detachEvent("onload", completed);
			}
		}
	
		/**
	  * The ready event handler and self cleanup method
	  */
		function completed() {
	
			// readyState === "complete" is good enough for us to call the dom ready in oldIE
			if (document.addEventListener || window.event.type === "load" || document.readyState === "complete") {
	
				detach();
				jQuery.ready();
			}
		}
	
		jQuery.ready.promise = function (obj) {
			if (!readyList) {
	
				readyList = jQuery.Deferred();
	
				// Catch cases where $(document).ready() is called
				// after the browser event has already occurred.
				// Support: IE6-10
				// Older IE sometimes signals "interactive" too soon
				if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {
	
					// Handle it asynchronously to allow scripts the opportunity to delay ready
					window.setTimeout(jQuery.ready);
	
					// Standards-based browsers support DOMContentLoaded
				} else if (document.addEventListener) {
	
					// Use the handy event callback
					document.addEventListener("DOMContentLoaded", completed);
	
					// A fallback to window.onload, that will always work
					window.addEventListener("load", completed);
	
					// If IE event model is used
				} else {
	
					// Ensure firing before onload, maybe late but safe also for iframes
					document.attachEvent("onreadystatechange", completed);
	
					// A fallback to window.onload, that will always work
					window.attachEvent("onload", completed);
	
					// If IE and not a frame
					// continually check to see if the document is ready
					var top = false;
	
					try {
						top = window.frameElement == null && document.documentElement;
					} catch (e) {}
	
					if (top && top.doScroll) {
						(function doScrollCheck() {
							if (!jQuery.isReady) {
	
								try {
	
									// Use the trick by Diego Perini
									// http://javascript.nwbox.com/IEContentLoaded/
									top.doScroll("left");
								} catch (e) {
									return window.setTimeout(doScrollCheck, 50);
								}
	
								// detach all dom ready events
								detach();
	
								// and execute any waiting functions
								jQuery.ready();
							}
						})();
					}
				}
			}
			return readyList.promise(obj);
		};
	
		// Kick off the DOM ready check even if the user does not
		jQuery.ready.promise();
	
		// Support: IE<9
		// Iteration over object's inherited properties before its own
		var i;
		for (i in jQuery(support)) {
			break;
		}
		support.ownFirst = i === "0";
	
		// Note: most support tests are defined in their respective modules.
		// false until the test is run
		support.inlineBlockNeedsLayout = false;
	
		// Execute ASAP in case we need to set body.style.zoom
		jQuery(function () {
	
			// Minified: var a,b,c,d
			var val, div, body, container;
	
			body = document.getElementsByTagName("body")[0];
			if (!body || !body.style) {
	
				// Return for frameset docs that don't have a body
				return;
			}
	
			// Setup
			div = document.createElement("div");
			container = document.createElement("div");
			container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
			body.appendChild(container).appendChild(div);
	
			if (typeof div.style.zoom !== "undefined") {
	
				// Support: IE<8
				// Check if natively block-level elements act like inline-block
				// elements when setting their display to 'inline' and giving
				// them layout
				div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";
	
				support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
				if (val) {
	
					// Prevent IE 6 from affecting layout for positioned elements #11048
					// Prevent IE from shrinking the body in IE 7 mode #12869
					// Support: IE<8
					body.style.zoom = 1;
				}
			}
	
			body.removeChild(container);
		});
	
		(function () {
			var div = document.createElement("div");
	
			// Support: IE<9
			support.deleteExpando = true;
			try {
				delete div.test;
			} catch (e) {
				support.deleteExpando = false;
			}
	
			// Null elements to avoid leaks in IE.
			div = null;
		})();
		var acceptData = function (elem) {
			var noData = jQuery.noData[(elem.nodeName + " ").toLowerCase()],
			    nodeType = +elem.nodeType || 1;
	
			// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
			return nodeType !== 1 && nodeType !== 9 ? false :
	
			// Nodes accept data unless otherwise specified; rejection can be conditional
			!noData || noData !== true && elem.getAttribute("classid") === noData;
		};
	
		var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		    rmultiDash = /([A-Z])/g;
	
		function dataAttr(elem, key, data) {
	
			// If nothing was found internally, try to fetch any
			// data from the HTML5 data-* attribute
			if (data === undefined && elem.nodeType === 1) {
	
				var name = "data-" + key.replace(rmultiDash, "-$1").toLowerCase();
	
				data = elem.getAttribute(name);
	
				if (typeof data === "string") {
					try {
						data = data === "true" ? true : data === "false" ? false : data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data : rbrace.test(data) ? jQuery.parseJSON(data) : data;
					} catch (e) {}
	
					// Make sure we set the data so it isn't changed later
					jQuery.data(elem, key, data);
				} else {
					data = undefined;
				}
			}
	
			return data;
		}
	
		// checks a cache object for emptiness
		function isEmptyDataObject(obj) {
			var name;
			for (name in obj) {
	
				// if the public data object is empty, the private is still empty
				if (name === "data" && jQuery.isEmptyObject(obj[name])) {
					continue;
				}
				if (name !== "toJSON") {
					return false;
				}
			}
	
			return true;
		}
	
		function internalData(elem, name, data, pvt /* Internal Use Only */) {
			if (!acceptData(elem)) {
				return;
			}
	
			var ret,
			    thisCache,
			    internalKey = jQuery.expando,
	
	
			// We have to handle DOM nodes and JS objects differently because IE6-7
			// can't GC object references properly across the DOM-JS boundary
			isNode = elem.nodeType,
	
	
			// Only DOM nodes need the global jQuery cache; JS object data is
			// attached directly to the object so GC can occur automatically
			cache = isNode ? jQuery.cache : elem,
	
	
			// Only defining an ID for JS objects if its cache already exists allows
			// the code to shortcut on the same path as a DOM node with no cache
			id = isNode ? elem[internalKey] : elem[internalKey] && internalKey;
	
			// Avoid doing any more work than we need to when trying to get data on an
			// object that has no data at all
			if ((!id || !cache[id] || !pvt && !cache[id].data) && data === undefined && typeof name === "string") {
				return;
			}
	
			if (!id) {
	
				// Only DOM nodes need a new unique ID for each element since their data
				// ends up in the global cache
				if (isNode) {
					id = elem[internalKey] = deletedIds.pop() || jQuery.guid++;
				} else {
					id = internalKey;
				}
			}
	
			if (!cache[id]) {
	
				// Avoid exposing jQuery metadata on plain JS objects when the object
				// is serialized using JSON.stringify
				cache[id] = isNode ? {} : { toJSON: jQuery.noop };
			}
	
			// An object can be passed to jQuery.data instead of a key/value pair; this gets
			// shallow copied over onto the existing cache
			if (typeof name === "object" || typeof name === "function") {
				if (pvt) {
					cache[id] = jQuery.extend(cache[id], name);
				} else {
					cache[id].data = jQuery.extend(cache[id].data, name);
				}
			}
	
			thisCache = cache[id];
	
			// jQuery data() is stored in a separate object inside the object's internal data
			// cache in order to avoid key collisions between internal data and user-defined
			// data.
			if (!pvt) {
				if (!thisCache.data) {
					thisCache.data = {};
				}
	
				thisCache = thisCache.data;
			}
	
			if (data !== undefined) {
				thisCache[jQuery.camelCase(name)] = data;
			}
	
			// Check for both converted-to-camel and non-converted data property names
			// If a data property was specified
			if (typeof name === "string") {
	
				// First Try to find as-is property data
				ret = thisCache[name];
	
				// Test for null|undefined property data
				if (ret == null) {
	
					// Try to find the camelCased property
					ret = thisCache[jQuery.camelCase(name)];
				}
			} else {
				ret = thisCache;
			}
	
			return ret;
		}
	
		function internalRemoveData(elem, name, pvt) {
			if (!acceptData(elem)) {
				return;
			}
	
			var thisCache,
			    i,
			    isNode = elem.nodeType,
	
	
			// See jQuery.data for more information
			cache = isNode ? jQuery.cache : elem,
			    id = isNode ? elem[jQuery.expando] : jQuery.expando;
	
			// If there is already no cache entry for this object, there is no
			// purpose in continuing
			if (!cache[id]) {
				return;
			}
	
			if (name) {
	
				thisCache = pvt ? cache[id] : cache[id].data;
	
				if (thisCache) {
	
					// Support array or space separated string names for data keys
					if (!jQuery.isArray(name)) {
	
						// try the string as a key before any manipulation
						if (name in thisCache) {
							name = [name];
						} else {
	
							// split the camel cased version by spaces unless a key with the spaces exists
							name = jQuery.camelCase(name);
							if (name in thisCache) {
								name = [name];
							} else {
								name = name.split(" ");
							}
						}
					} else {
	
						// If "name" is an array of keys...
						// When data is initially created, via ("key", "val") signature,
						// keys will be converted to camelCase.
						// Since there is no way to tell _how_ a key was added, remove
						// both plain key and camelCase key. #12786
						// This will only penalize the array argument path.
						name = name.concat(jQuery.map(name, jQuery.camelCase));
					}
	
					i = name.length;
					while (i--) {
						delete thisCache[name[i]];
					}
	
					// If there is no data left in the cache, we want to continue
					// and let the cache object itself get destroyed
					if (pvt ? !isEmptyDataObject(thisCache) : !jQuery.isEmptyObject(thisCache)) {
						return;
					}
				}
			}
	
			// See jQuery.data for more information
			if (!pvt) {
				delete cache[id].data;
	
				// Don't destroy the parent cache unless the internal data object
				// had been the only thing left in it
				if (!isEmptyDataObject(cache[id])) {
					return;
				}
			}
	
			// Destroy the cache
			if (isNode) {
				jQuery.cleanData([elem], true);
	
				// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
				/* jshint eqeqeq: false */
			} else if (support.deleteExpando || cache != cache.window) {
				/* jshint eqeqeq: true */
				delete cache[id];
	
				// When all else fails, undefined
			} else {
				cache[id] = undefined;
			}
		}
	
		jQuery.extend({
			cache: {},
	
			// The following elements (space-suffixed to avoid Object.prototype collisions)
			// throw uncatchable exceptions if you attempt to set expando properties
			noData: {
				"applet ": true,
				"embed ": true,
	
				// ...but Flash objects (which have this classid) *can* handle expandos
				"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
			},
	
			hasData: function (elem) {
				elem = elem.nodeType ? jQuery.cache[elem[jQuery.expando]] : elem[jQuery.expando];
				return !!elem && !isEmptyDataObject(elem);
			},
	
			data: function (elem, name, data) {
				return internalData(elem, name, data);
			},
	
			removeData: function (elem, name) {
				return internalRemoveData(elem, name);
			},
	
			// For internal use only.
			_data: function (elem, name, data) {
				return internalData(elem, name, data, true);
			},
	
			_removeData: function (elem, name) {
				return internalRemoveData(elem, name, true);
			}
		});
	
		jQuery.fn.extend({
			data: function (key, value) {
				var i,
				    name,
				    data,
				    elem = this[0],
				    attrs = elem && elem.attributes;
	
				// Special expections of .data basically thwart jQuery.access,
				// so implement the relevant behavior ourselves
	
				// Gets all values
				if (key === undefined) {
					if (this.length) {
						data = jQuery.data(elem);
	
						if (elem.nodeType === 1 && !jQuery._data(elem, "parsedAttrs")) {
							i = attrs.length;
							while (i--) {
	
								// Support: IE11+
								// The attrs elements can be null (#14894)
								if (attrs[i]) {
									name = attrs[i].name;
									if (name.indexOf("data-") === 0) {
										name = jQuery.camelCase(name.slice(5));
										dataAttr(elem, name, data[name]);
									}
								}
							}
							jQuery._data(elem, "parsedAttrs", true);
						}
					}
	
					return data;
				}
	
				// Sets multiple values
				if (typeof key === "object") {
					return this.each(function () {
						jQuery.data(this, key);
					});
				}
	
				return arguments.length > 1 ?
	
				// Sets one value
				this.each(function () {
					jQuery.data(this, key, value);
				}) :
	
				// Gets one value
				// Try to fetch any internally stored data first
				elem ? dataAttr(elem, key, jQuery.data(elem, key)) : undefined;
			},
	
			removeData: function (key) {
				return this.each(function () {
					jQuery.removeData(this, key);
				});
			}
		});
	
		jQuery.extend({
			queue: function (elem, type, data) {
				var queue;
	
				if (elem) {
					type = (type || "fx") + "queue";
					queue = jQuery._data(elem, type);
	
					// Speed up dequeue by getting out quickly if this is just a lookup
					if (data) {
						if (!queue || jQuery.isArray(data)) {
							queue = jQuery._data(elem, type, jQuery.makeArray(data));
						} else {
							queue.push(data);
						}
					}
					return queue || [];
				}
			},
	
			dequeue: function (elem, type) {
				type = type || "fx";
	
				var queue = jQuery.queue(elem, type),
				    startLength = queue.length,
				    fn = queue.shift(),
				    hooks = jQuery._queueHooks(elem, type),
				    next = function () {
					jQuery.dequeue(elem, type);
				};
	
				// If the fx queue is dequeued, always remove the progress sentinel
				if (fn === "inprogress") {
					fn = queue.shift();
					startLength--;
				}
	
				if (fn) {
	
					// Add a progress sentinel to prevent the fx queue from being
					// automatically dequeued
					if (type === "fx") {
						queue.unshift("inprogress");
					}
	
					// clear up the last queue stop function
					delete hooks.stop;
					fn.call(elem, next, hooks);
				}
	
				if (!startLength && hooks) {
					hooks.empty.fire();
				}
			},
	
			// not intended for public consumption - generates a queueHooks object,
			// or returns the current one
			_queueHooks: function (elem, type) {
				var key = type + "queueHooks";
				return jQuery._data(elem, key) || jQuery._data(elem, key, {
					empty: jQuery.Callbacks("once memory").add(function () {
						jQuery._removeData(elem, type + "queue");
						jQuery._removeData(elem, key);
					})
				});
			}
		});
	
		jQuery.fn.extend({
			queue: function (type, data) {
				var setter = 2;
	
				if (typeof type !== "string") {
					data = type;
					type = "fx";
					setter--;
				}
	
				if (arguments.length < setter) {
					return jQuery.queue(this[0], type);
				}
	
				return data === undefined ? this : this.each(function () {
					var queue = jQuery.queue(this, type, data);
	
					// ensure a hooks for this queue
					jQuery._queueHooks(this, type);
	
					if (type === "fx" && queue[0] !== "inprogress") {
						jQuery.dequeue(this, type);
					}
				});
			},
			dequeue: function (type) {
				return this.each(function () {
					jQuery.dequeue(this, type);
				});
			},
			clearQueue: function (type) {
				return this.queue(type || "fx", []);
			},
	
			// Get a promise resolved when queues of a certain type
			// are emptied (fx is the type by default)
			promise: function (type, obj) {
				var tmp,
				    count = 1,
				    defer = jQuery.Deferred(),
				    elements = this,
				    i = this.length,
				    resolve = function () {
					if (! --count) {
						defer.resolveWith(elements, [elements]);
					}
				};
	
				if (typeof type !== "string") {
					obj = type;
					type = undefined;
				}
				type = type || "fx";
	
				while (i--) {
					tmp = jQuery._data(elements[i], type + "queueHooks");
					if (tmp && tmp.empty) {
						count++;
						tmp.empty.add(resolve);
					}
				}
				resolve();
				return defer.promise(obj);
			}
		});
	
		(function () {
			var shrinkWrapBlocksVal;
	
			support.shrinkWrapBlocks = function () {
				if (shrinkWrapBlocksVal != null) {
					return shrinkWrapBlocksVal;
				}
	
				// Will be changed later if needed.
				shrinkWrapBlocksVal = false;
	
				// Minified: var b,c,d
				var div, body, container;
	
				body = document.getElementsByTagName("body")[0];
				if (!body || !body.style) {
	
					// Test fired too early or in an unsupported environment, exit.
					return;
				}
	
				// Setup
				div = document.createElement("div");
				container = document.createElement("div");
				container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
				body.appendChild(container).appendChild(div);
	
				// Support: IE6
				// Check if elements with layout shrink-wrap their children
				if (typeof div.style.zoom !== "undefined") {
	
					// Reset CSS: box-sizing; display; margin; border
					div.style.cssText =
	
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" + "box-sizing:content-box;display:block;margin:0;border:0;" + "padding:1px;width:1px;zoom:1";
					div.appendChild(document.createElement("div")).style.width = "5px";
					shrinkWrapBlocksVal = div.offsetWidth !== 3;
				}
	
				body.removeChild(container);
	
				return shrinkWrapBlocksVal;
			};
		})();
		var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
	
		var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
	
		var cssExpand = ["Top", "Right", "Bottom", "Left"];
	
		var isHidden = function (elem, el) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css(elem, "display") === "none" || !jQuery.contains(elem.ownerDocument, elem);
		};
	
		function adjustCSS(elem, prop, valueParts, tween) {
			var adjusted,
			    scale = 1,
			    maxIterations = 20,
			    currentValue = tween ? function () {
				return tween.cur();
			} : function () {
				return jQuery.css(elem, prop, "");
			},
			    initial = currentValue(),
			    unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),
	
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
	
			if (initialInUnit && initialInUnit[3] !== unit) {
	
				// Trust units reported by jQuery.css
				unit = unit || initialInUnit[3];
	
				// Make sure we update the tween properties later on
				valueParts = valueParts || [];
	
				// Iteratively approximate from a nonzero starting point
				initialInUnit = +initial || 1;
	
				do {
	
					// If previous iteration zeroed out, double until we get *something*.
					// Use string for doubling so we don't accidentally see scale as unchanged below
					scale = scale || ".5";
	
					// Adjust and apply
					initialInUnit = initialInUnit / scale;
					jQuery.style(elem, prop, initialInUnit + unit);
	
					// Update scale, tolerating zero or NaN from tween.cur()
					// Break the loop if scale is unchanged or perfect, or if we've just had enough.
				} while (scale !== (scale = currentValue() / initial) && scale !== 1 && --maxIterations);
			}
	
			if (valueParts) {
				initialInUnit = +initialInUnit || +initial || 0;
	
				// Apply relative offset (+=/-=) if specified
				adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
				if (tween) {
					tween.unit = unit;
					tween.start = initialInUnit;
					tween.end = adjusted;
				}
			}
			return adjusted;
		}
	
		// Multifunctional method to get and set values of a collection
		// The value/s can optionally be executed if it's a function
		var access = function (elems, fn, key, value, chainable, emptyGet, raw) {
			var i = 0,
			    length = elems.length,
			    bulk = key == null;
	
			// Sets many values
			if (jQuery.type(key) === "object") {
				chainable = true;
				for (i in key) {
					access(elems, fn, i, key[i], true, emptyGet, raw);
				}
	
				// Sets one value
			} else if (value !== undefined) {
				chainable = true;
	
				if (!jQuery.isFunction(value)) {
					raw = true;
				}
	
				if (bulk) {
	
					// Bulk operations run against the entire set
					if (raw) {
						fn.call(elems, value);
						fn = null;
	
						// ...except when executing function values
					} else {
						bulk = fn;
						fn = function (elem, key, value) {
							return bulk.call(jQuery(elem), value);
						};
					}
				}
	
				if (fn) {
					for (; i < length; i++) {
						fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
					}
				}
			}
	
			return chainable ? elems :
	
			// Gets
			bulk ? fn.call(elems) : length ? fn(elems[0], key) : emptyGet;
		};
		var rcheckableType = /^(?:checkbox|radio)$/i;
	
		var rtagName = /<([\w:-]+)/;
	
		var rscriptType = /^$|\/(?:java|ecma)script/i;
	
		var rleadingWhitespace = /^\s+/;
	
		var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|" + "details|dialog|figcaption|figure|footer|header|hgroup|main|" + "mark|meter|nav|output|picture|progress|section|summary|template|time|video";
	
		function createSafeFragment(document) {
			var list = nodeNames.split("|"),
			    safeFrag = document.createDocumentFragment();
	
			if (safeFrag.createElement) {
				while (list.length) {
					safeFrag.createElement(list.pop());
				}
			}
			return safeFrag;
		}
	
		(function () {
			var div = document.createElement("div"),
			    fragment = document.createDocumentFragment(),
			    input = document.createElement("input");
	
			// Setup
			div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	
			// IE strips leading whitespace when .innerHTML is used
			support.leadingWhitespace = div.firstChild.nodeType === 3;
	
			// Make sure that tbody elements aren't automatically inserted
			// IE will insert them into empty tables
			support.tbody = !div.getElementsByTagName("tbody").length;
	
			// Make sure that link elements get serialized correctly by innerHTML
			// This requires a wrapper element in IE
			support.htmlSerialize = !!div.getElementsByTagName("link").length;
	
			// Makes sure cloning an html5 element does not cause problems
			// Where outerHTML is undefined, this still works
			support.html5Clone = document.createElement("nav").cloneNode(true).outerHTML !== "<:nav></:nav>";
	
			// Check if a disconnected checkbox will retain its checked
			// value of true after appended to the DOM (IE6/7)
			input.type = "checkbox";
			input.checked = true;
			fragment.appendChild(input);
			support.appendChecked = input.checked;
	
			// Make sure textarea (and checkbox) defaultValue is properly cloned
			// Support: IE6-IE11+
			div.innerHTML = "<textarea>x</textarea>";
			support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
	
			// #11217 - WebKit loses check when the name is after the checked attribute
			fragment.appendChild(div);
	
			// Support: Windows Web Apps (WWA)
			// `name` and `type` must use .setAttribute for WWA (#14901)
			input = document.createElement("input");
			input.setAttribute("type", "radio");
			input.setAttribute("checked", "checked");
			input.setAttribute("name", "t");
	
			div.appendChild(input);
	
			// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
			// old WebKit doesn't clone checked state correctly in fragments
			support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
	
			// Support: IE<9
			// Cloned elements keep attachEvent handlers, we use addEventListener on IE9+
			support.noCloneEvent = !!div.addEventListener;
	
			// Support: IE<9
			// Since attributes and properties are the same in IE,
			// cleanData must set properties to undefined rather than use removeAttribute
			div[jQuery.expando] = 1;
			support.attributes = !div.getAttribute(jQuery.expando);
		})();
	
		// We have to close these tags to support XHTML (#13200)
		var wrapMap = {
			option: [1, "<select multiple='multiple'>", "</select>"],
			legend: [1, "<fieldset>", "</fieldset>"],
			area: [1, "<map>", "</map>"],
	
			// Support: IE8
			param: [1, "<object>", "</object>"],
			thead: [1, "<table>", "</table>"],
			tr: [2, "<table><tbody>", "</tbody></table>"],
			col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
			td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
	
			// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
			// unless wrapped in a div with non-breaking characters in front of it.
			_default: support.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
		};
	
		// Support: IE8-IE9
		wrapMap.optgroup = wrapMap.option;
	
		wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
		wrapMap.th = wrapMap.td;
	
		function getAll(context, tag) {
			var elems,
			    elem,
			    i = 0,
			    found = typeof context.getElementsByTagName !== "undefined" ? context.getElementsByTagName(tag || "*") : typeof context.querySelectorAll !== "undefined" ? context.querySelectorAll(tag || "*") : undefined;
	
			if (!found) {
				for (found = [], elems = context.childNodes || context; (elem = elems[i]) != null; i++) {
					if (!tag || jQuery.nodeName(elem, tag)) {
						found.push(elem);
					} else {
						jQuery.merge(found, getAll(elem, tag));
					}
				}
			}
	
			return tag === undefined || tag && jQuery.nodeName(context, tag) ? jQuery.merge([context], found) : found;
		}
	
		// Mark scripts as having already been evaluated
		function setGlobalEval(elems, refElements) {
			var elem,
			    i = 0;
			for (; (elem = elems[i]) != null; i++) {
				jQuery._data(elem, "globalEval", !refElements || jQuery._data(refElements[i], "globalEval"));
			}
		}
	
		var rhtml = /<|&#?\w+;/,
		    rtbody = /<tbody/i;
	
		function fixDefaultChecked(elem) {
			if (rcheckableType.test(elem.type)) {
				elem.defaultChecked = elem.checked;
			}
		}
	
		function buildFragment(elems, context, scripts, selection, ignored) {
			var j,
			    elem,
			    contains,
			    tmp,
			    tag,
			    tbody,
			    wrap,
			    l = elems.length,
	
	
			// Ensure a safe fragment
			safe = createSafeFragment(context),
			    nodes = [],
			    i = 0;
	
			for (; i < l; i++) {
				elem = elems[i];
	
				if (elem || elem === 0) {
	
					// Add nodes directly
					if (jQuery.type(elem) === "object") {
						jQuery.merge(nodes, elem.nodeType ? [elem] : elem);
	
						// Convert non-html into a text node
					} else if (!rhtml.test(elem)) {
						nodes.push(context.createTextNode(elem));
	
						// Convert html into DOM nodes
					} else {
						tmp = tmp || safe.appendChild(context.createElement("div"));
	
						// Deserialize a standard representation
						tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
						wrap = wrapMap[tag] || wrapMap._default;
	
						tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
	
						// Descend through wrappers to the right content
						j = wrap[0];
						while (j--) {
							tmp = tmp.lastChild;
						}
	
						// Manually add leading whitespace removed by IE
						if (!support.leadingWhitespace && rleadingWhitespace.test(elem)) {
							nodes.push(context.createTextNode(rleadingWhitespace.exec(elem)[0]));
						}
	
						// Remove IE's autoinserted <tbody> from table fragments
						if (!support.tbody) {
	
							// String was a <table>, *may* have spurious <tbody>
							elem = tag === "table" && !rtbody.test(elem) ? tmp.firstChild :
	
							// String was a bare <thead> or <tfoot>
							wrap[1] === "<table>" && !rtbody.test(elem) ? tmp : 0;
	
							j = elem && elem.childNodes.length;
							while (j--) {
								if (jQuery.nodeName(tbody = elem.childNodes[j], "tbody") && !tbody.childNodes.length) {
	
									elem.removeChild(tbody);
								}
							}
						}
	
						jQuery.merge(nodes, tmp.childNodes);
	
						// Fix #12392 for WebKit and IE > 9
						tmp.textContent = "";
	
						// Fix #12392 for oldIE
						while (tmp.firstChild) {
							tmp.removeChild(tmp.firstChild);
						}
	
						// Remember the top-level container for proper cleanup
						tmp = safe.lastChild;
					}
				}
			}
	
			// Fix #11356: Clear elements from fragment
			if (tmp) {
				safe.removeChild(tmp);
			}
	
			// Reset defaultChecked for any radios and checkboxes
			// about to be appended to the DOM in IE 6/7 (#8060)
			if (!support.appendChecked) {
				jQuery.grep(getAll(nodes, "input"), fixDefaultChecked);
			}
	
			i = 0;
			while (elem = nodes[i++]) {
	
				// Skip elements already in the context collection (trac-4087)
				if (selection && jQuery.inArray(elem, selection) > -1) {
					if (ignored) {
						ignored.push(elem);
					}
	
					continue;
				}
	
				contains = jQuery.contains(elem.ownerDocument, elem);
	
				// Append to fragment
				tmp = getAll(safe.appendChild(elem), "script");
	
				// Preserve script evaluation history
				if (contains) {
					setGlobalEval(tmp);
				}
	
				// Capture executables
				if (scripts) {
					j = 0;
					while (elem = tmp[j++]) {
						if (rscriptType.test(elem.type || "")) {
							scripts.push(elem);
						}
					}
				}
			}
	
			tmp = null;
	
			return safe;
		}
	
		(function () {
			var i,
			    eventName,
			    div = document.createElement("div");
	
			// Support: IE<9 (lack submit/change bubble), Firefox (lack focus(in | out) events)
			for (i in { submit: true, change: true, focusin: true }) {
				eventName = "on" + i;
	
				if (!(support[i] = eventName in window)) {
	
					// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
					div.setAttribute(eventName, "t");
					support[i] = div.attributes[eventName].expando === false;
				}
			}
	
			// Null elements to avoid leaks in IE.
			div = null;
		})();
	
		var rformElems = /^(?:input|select|textarea)$/i,
		    rkeyEvent = /^key/,
		    rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		    rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		    rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
		function returnTrue() {
			return true;
		}
	
		function returnFalse() {
			return false;
		}
	
		// Support: IE9
		// See #13393 for more info
		function safeActiveElement() {
			try {
				return document.activeElement;
			} catch (err) {}
		}
	
		function on(elem, types, selector, data, fn, one) {
			var origFn, type;
	
			// Types can be a map of types/handlers
			if (typeof types === "object") {
	
				// ( types-Object, selector, data )
				if (typeof selector !== "string") {
	
					// ( types-Object, data )
					data = data || selector;
					selector = undefined;
				}
				for (type in types) {
					on(elem, type, selector, data, types[type], one);
				}
				return elem;
			}
	
			if (data == null && fn == null) {
	
				// ( types, fn )
				fn = selector;
				data = selector = undefined;
			} else if (fn == null) {
				if (typeof selector === "string") {
	
					// ( types, selector, fn )
					fn = data;
					data = undefined;
				} else {
	
					// ( types, data, fn )
					fn = data;
					data = selector;
					selector = undefined;
				}
			}
			if (fn === false) {
				fn = returnFalse;
			} else if (!fn) {
				return elem;
			}
	
			if (one === 1) {
				origFn = fn;
				fn = function (event) {
	
					// Can use an empty set, since event contains the info
					jQuery().off(event);
					return origFn.apply(this, arguments);
				};
	
				// Use same guid so caller can remove using origFn
				fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
			}
			return elem.each(function () {
				jQuery.event.add(this, types, fn, data, selector);
			});
		}
	
		/*
	  * Helper functions for managing events -- not part of the public interface.
	  * Props to Dean Edwards' addEvent library for many of the ideas.
	  */
		jQuery.event = {
	
			global: {},
	
			add: function (elem, types, handler, data, selector) {
				var tmp,
				    events,
				    t,
				    handleObjIn,
				    special,
				    eventHandle,
				    handleObj,
				    handlers,
				    type,
				    namespaces,
				    origType,
				    elemData = jQuery._data(elem);
	
				// Don't attach events to noData or text/comment nodes (but allow plain objects)
				if (!elemData) {
					return;
				}
	
				// Caller can pass in an object of custom data in lieu of the handler
				if (handler.handler) {
					handleObjIn = handler;
					handler = handleObjIn.handler;
					selector = handleObjIn.selector;
				}
	
				// Make sure that the handler has a unique ID, used to find/remove it later
				if (!handler.guid) {
					handler.guid = jQuery.guid++;
				}
	
				// Init the element's event structure and main handler, if this is the first
				if (!(events = elemData.events)) {
					events = elemData.events = {};
				}
				if (!(eventHandle = elemData.handle)) {
					eventHandle = elemData.handle = function (e) {
	
						// Discard the second event of a jQuery.event.trigger() and
						// when an event is called after a page has unloaded
						return typeof jQuery !== "undefined" && (!e || jQuery.event.triggered !== e.type) ? jQuery.event.dispatch.apply(eventHandle.elem, arguments) : undefined;
					};
	
					// Add elem as a property of the handle fn to prevent a memory leak
					// with IE non-native events
					eventHandle.elem = elem;
				}
	
				// Handle multiple events separated by a space
				types = (types || "").match(rnotwhite) || [""];
				t = types.length;
				while (t--) {
					tmp = rtypenamespace.exec(types[t]) || [];
					type = origType = tmp[1];
					namespaces = (tmp[2] || "").split(".").sort();
	
					// There *must* be a type, no attaching namespace-only handlers
					if (!type) {
						continue;
					}
	
					// If event changes its type, use the special event handlers for the changed type
					special = jQuery.event.special[type] || {};
	
					// If selector defined, determine special event api type, otherwise given type
					type = (selector ? special.delegateType : special.bindType) || type;
	
					// Update special based on newly reset type
					special = jQuery.event.special[type] || {};
	
					// handleObj is passed to all event handlers
					handleObj = jQuery.extend({
						type: type,
						origType: origType,
						data: data,
						handler: handler,
						guid: handler.guid,
						selector: selector,
						needsContext: selector && jQuery.expr.match.needsContext.test(selector),
						namespace: namespaces.join(".")
					}, handleObjIn);
	
					// Init the event handler queue if we're the first
					if (!(handlers = events[type])) {
						handlers = events[type] = [];
						handlers.delegateCount = 0;
	
						// Only use addEventListener/attachEvent if the special events handler returns false
						if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
	
							// Bind the global event handler to the element
							if (elem.addEventListener) {
								elem.addEventListener(type, eventHandle, false);
							} else if (elem.attachEvent) {
								elem.attachEvent("on" + type, eventHandle);
							}
						}
					}
	
					if (special.add) {
						special.add.call(elem, handleObj);
	
						if (!handleObj.handler.guid) {
							handleObj.handler.guid = handler.guid;
						}
					}
	
					// Add to the element's handler list, delegates in front
					if (selector) {
						handlers.splice(handlers.delegateCount++, 0, handleObj);
					} else {
						handlers.push(handleObj);
					}
	
					// Keep track of which events have ever been used, for event optimization
					jQuery.event.global[type] = true;
				}
	
				// Nullify elem to prevent memory leaks in IE
				elem = null;
			},
	
			// Detach an event or set of events from an element
			remove: function (elem, types, handler, selector, mappedTypes) {
				var j,
				    handleObj,
				    tmp,
				    origCount,
				    t,
				    events,
				    special,
				    handlers,
				    type,
				    namespaces,
				    origType,
				    elemData = jQuery.hasData(elem) && jQuery._data(elem);
	
				if (!elemData || !(events = elemData.events)) {
					return;
				}
	
				// Once for each type.namespace in types; type may be omitted
				types = (types || "").match(rnotwhite) || [""];
				t = types.length;
				while (t--) {
					tmp = rtypenamespace.exec(types[t]) || [];
					type = origType = tmp[1];
					namespaces = (tmp[2] || "").split(".").sort();
	
					// Unbind all events (on this namespace, if provided) for the element
					if (!type) {
						for (type in events) {
							jQuery.event.remove(elem, type + types[t], handler, selector, true);
						}
						continue;
					}
	
					special = jQuery.event.special[type] || {};
					type = (selector ? special.delegateType : special.bindType) || type;
					handlers = events[type] || [];
					tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
	
					// Remove matching events
					origCount = j = handlers.length;
					while (j--) {
						handleObj = handlers[j];
	
						if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
							handlers.splice(j, 1);
	
							if (handleObj.selector) {
								handlers.delegateCount--;
							}
							if (special.remove) {
								special.remove.call(elem, handleObj);
							}
						}
					}
	
					// Remove generic event handler if we removed something and no more handlers exist
					// (avoids potential for endless recursion during removal of special event handlers)
					if (origCount && !handlers.length) {
						if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
	
							jQuery.removeEvent(elem, type, elemData.handle);
						}
	
						delete events[type];
					}
				}
	
				// Remove the expando if it's no longer used
				if (jQuery.isEmptyObject(events)) {
					delete elemData.handle;
	
					// removeData also checks for emptiness and clears the expando if empty
					// so use it instead of delete
					jQuery._removeData(elem, "events");
				}
			},
	
			trigger: function (event, data, elem, onlyHandlers) {
				var handle,
				    ontype,
				    cur,
				    bubbleType,
				    special,
				    tmp,
				    i,
				    eventPath = [elem || document],
				    type = hasOwn.call(event, "type") ? event.type : event,
				    namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
	
				cur = tmp = elem = elem || document;
	
				// Don't do events on text and comment nodes
				if (elem.nodeType === 3 || elem.nodeType === 8) {
					return;
				}
	
				// focus/blur morphs to focusin/out; ensure we're not firing them right now
				if (rfocusMorph.test(type + jQuery.event.triggered)) {
					return;
				}
	
				if (type.indexOf(".") > -1) {
	
					// Namespaced trigger; create a regexp to match event type in handle()
					namespaces = type.split(".");
					type = namespaces.shift();
					namespaces.sort();
				}
				ontype = type.indexOf(":") < 0 && "on" + type;
	
				// Caller can pass in a jQuery.Event object, Object, or just an event type string
				event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
	
				// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
				event.isTrigger = onlyHandlers ? 2 : 3;
				event.namespace = namespaces.join(".");
				event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
	
				// Clean up the event in case it is being reused
				event.result = undefined;
				if (!event.target) {
					event.target = elem;
				}
	
				// Clone any incoming data and prepend the event, creating the handler arg list
				data = data == null ? [event] : jQuery.makeArray(data, [event]);
	
				// Allow special events to draw outside the lines
				special = jQuery.event.special[type] || {};
				if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
					return;
				}
	
				// Determine event propagation path in advance, per W3C events spec (#9951)
				// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
				if (!onlyHandlers && !special.noBubble && !jQuery.isWindow(elem)) {
	
					bubbleType = special.delegateType || type;
					if (!rfocusMorph.test(bubbleType + type)) {
						cur = cur.parentNode;
					}
					for (; cur; cur = cur.parentNode) {
						eventPath.push(cur);
						tmp = cur;
					}
	
					// Only add window if we got to document (e.g., not plain obj or detached DOM)
					if (tmp === (elem.ownerDocument || document)) {
						eventPath.push(tmp.defaultView || tmp.parentWindow || window);
					}
				}
	
				// Fire handlers on the event path
				i = 0;
				while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
	
					event.type = i > 1 ? bubbleType : special.bindType || type;
	
					// jQuery handler
					handle = (jQuery._data(cur, "events") || {})[event.type] && jQuery._data(cur, "handle");
	
					if (handle) {
						handle.apply(cur, data);
					}
	
					// Native handler
					handle = ontype && cur[ontype];
					if (handle && handle.apply && acceptData(cur)) {
						event.result = handle.apply(cur, data);
						if (event.result === false) {
							event.preventDefault();
						}
					}
				}
				event.type = type;
	
				// If nobody prevented the default action, do it now
				if (!onlyHandlers && !event.isDefaultPrevented()) {
	
					if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
	
						// Call a native DOM method on the target with the same name name as the event.
						// Can't use an .isFunction() check here because IE6/7 fails that test.
						// Don't do default actions on window, that's where global variables be (#6170)
						if (ontype && elem[type] && !jQuery.isWindow(elem)) {
	
							// Don't re-trigger an onFOO event when we call its FOO() method
							tmp = elem[ontype];
	
							if (tmp) {
								elem[ontype] = null;
							}
	
							// Prevent re-triggering of the same event, since we already bubbled it above
							jQuery.event.triggered = type;
							try {
								elem[type]();
							} catch (e) {
	
								// IE<9 dies on focus/blur to hidden element (#1486,#12518)
								// only reproducible on winXP IE8 native, not IE9 in IE8 mode
							}
							jQuery.event.triggered = undefined;
	
							if (tmp) {
								elem[ontype] = tmp;
							}
						}
					}
				}
	
				return event.result;
			},
	
			dispatch: function (event) {
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix(event);
	
				var i,
				    j,
				    ret,
				    matched,
				    handleObj,
				    handlerQueue = [],
				    args = slice.call(arguments),
				    handlers = (jQuery._data(this, "events") || {})[event.type] || [],
				    special = jQuery.event.special[event.type] || {};
	
				// Use the fix-ed jQuery.Event rather than the (read-only) native event
				args[0] = event;
				event.delegateTarget = this;
	
				// Call the preDispatch hook for the mapped type, and let it bail if desired
				if (special.preDispatch && special.preDispatch.call(this, event) === false) {
					return;
				}
	
				// Determine handlers
				handlerQueue = jQuery.event.handlers.call(this, event, handlers);
	
				// Run delegates first; they may want to stop propagation beneath us
				i = 0;
				while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
					event.currentTarget = matched.elem;
	
					j = 0;
					while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
	
						// Triggered event must either 1) have no namespace, or 2) have namespace(s)
						// a subset or equal to those in the bound event (both can have no namespace).
						if (!event.rnamespace || event.rnamespace.test(handleObj.namespace)) {
	
							event.handleObj = handleObj;
							event.data = handleObj.data;
	
							ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
	
							if (ret !== undefined) {
								if ((event.result = ret) === false) {
									event.preventDefault();
									event.stopPropagation();
								}
							}
						}
					}
				}
	
				// Call the postDispatch hook for the mapped type
				if (special.postDispatch) {
					special.postDispatch.call(this, event);
				}
	
				return event.result;
			},
	
			handlers: function (event, handlers) {
				var i,
				    matches,
				    sel,
				    handleObj,
				    handlerQueue = [],
				    delegateCount = handlers.delegateCount,
				    cur = event.target;
	
				// Support (at least): Chrome, IE9
				// Find delegate handlers
				// Black-hole SVG <use> instance trees (#13180)
				//
				// Support: Firefox<=42+
				// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
				if (delegateCount && cur.nodeType && (event.type !== "click" || isNaN(event.button) || event.button < 1)) {
	
					/* jshint eqeqeq: false */
					for (; cur != this; cur = cur.parentNode || this) {
						/* jshint eqeqeq: true */
	
						// Don't check non-elements (#13208)
						// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
						if (cur.nodeType === 1 && (cur.disabled !== true || event.type !== "click")) {
							matches = [];
							for (i = 0; i < delegateCount; i++) {
								handleObj = handlers[i];
	
								// Don't conflict with Object.prototype properties (#13203)
								sel = handleObj.selector + " ";
	
								if (matches[sel] === undefined) {
									matches[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
								}
								if (matches[sel]) {
									matches.push(handleObj);
								}
							}
							if (matches.length) {
								handlerQueue.push({ elem: cur, handlers: matches });
							}
						}
					}
				}
	
				// Add the remaining (directly-bound) handlers
				if (delegateCount < handlers.length) {
					handlerQueue.push({ elem: this, handlers: handlers.slice(delegateCount) });
				}
	
				return handlerQueue;
			},
	
			fix: function (event) {
				if (event[jQuery.expando]) {
					return event;
				}
	
				// Create a writable copy of the event object and normalize some properties
				var i,
				    prop,
				    copy,
				    type = event.type,
				    originalEvent = event,
				    fixHook = this.fixHooks[type];
	
				if (!fixHook) {
					this.fixHooks[type] = fixHook = rmouseEvent.test(type) ? this.mouseHooks : rkeyEvent.test(type) ? this.keyHooks : {};
				}
				copy = fixHook.props ? this.props.concat(fixHook.props) : this.props;
	
				event = new jQuery.Event(originalEvent);
	
				i = copy.length;
				while (i--) {
					prop = copy[i];
					event[prop] = originalEvent[prop];
				}
	
				// Support: IE<9
				// Fix target property (#1925)
				if (!event.target) {
					event.target = originalEvent.srcElement || document;
				}
	
				// Support: Safari 6-8+
				// Target should not be a text node (#504, #13143)
				if (event.target.nodeType === 3) {
					event.target = event.target.parentNode;
				}
	
				// Support: IE<9
				// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
				event.metaKey = !!event.metaKey;
	
				return fixHook.filter ? fixHook.filter(event, originalEvent) : event;
			},
	
			// Includes some event props shared by KeyEvent and MouseEvent
			props: ("altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " + "metaKey relatedTarget shiftKey target timeStamp view which").split(" "),
	
			fixHooks: {},
	
			keyHooks: {
				props: "char charCode key keyCode".split(" "),
				filter: function (event, original) {
	
					// Add which for key events
					if (event.which == null) {
						event.which = original.charCode != null ? original.charCode : original.keyCode;
					}
	
					return event;
				}
			},
	
			mouseHooks: {
				props: ("button buttons clientX clientY fromElement offsetX offsetY " + "pageX pageY screenX screenY toElement").split(" "),
				filter: function (event, original) {
					var body,
					    eventDoc,
					    doc,
					    button = original.button,
					    fromElement = original.fromElement;
	
					// Calculate pageX/Y if missing and clientX/Y available
					if (event.pageX == null && original.clientX != null) {
						eventDoc = event.target.ownerDocument || document;
						doc = eventDoc.documentElement;
						body = eventDoc.body;
	
						event.pageX = original.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
						event.pageY = original.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
					}
	
					// Add relatedTarget, if necessary
					if (!event.relatedTarget && fromElement) {
						event.relatedTarget = fromElement === event.target ? original.toElement : fromElement;
					}
	
					// Add which for click: 1 === left; 2 === middle; 3 === right
					// Note: button is not normalized, so don't use it
					if (!event.which && button !== undefined) {
						event.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
					}
	
					return event;
				}
			},
	
			special: {
				load: {
	
					// Prevent triggered image.load events from bubbling to window.load
					noBubble: true
				},
				focus: {
	
					// Fire native event if possible so blur/focus sequence is correct
					trigger: function () {
						if (this !== safeActiveElement() && this.focus) {
							try {
								this.focus();
								return false;
							} catch (e) {
	
								// Support: IE<9
								// If we error on focus to hidden element (#1486, #12518),
								// let .trigger() run the handlers
							}
						}
					},
					delegateType: "focusin"
				},
				blur: {
					trigger: function () {
						if (this === safeActiveElement() && this.blur) {
							this.blur();
							return false;
						}
					},
					delegateType: "focusout"
				},
				click: {
	
					// For checkbox, fire native event so checked state will be right
					trigger: function () {
						if (jQuery.nodeName(this, "input") && this.type === "checkbox" && this.click) {
							this.click();
							return false;
						}
					},
	
					// For cross-browser consistency, don't fire native .click() on links
					_default: function (event) {
						return jQuery.nodeName(event.target, "a");
					}
				},
	
				beforeunload: {
					postDispatch: function (event) {
	
						// Support: Firefox 20+
						// Firefox doesn't alert if the returnValue field is not set.
						if (event.result !== undefined && event.originalEvent) {
							event.originalEvent.returnValue = event.result;
						}
					}
				}
			},
	
			// Piggyback on a donor event to simulate a different one
			simulate: function (type, elem, event) {
				var e = jQuery.extend(new jQuery.Event(), event, {
					type: type,
					isSimulated: true
	
					// Previously, `originalEvent: {}` was set here, so stopPropagation call
					// would not be triggered on donor event, since in our own
					// jQuery.event.stopPropagation function we had a check for existence of
					// originalEvent.stopPropagation method, so, consequently it would be a noop.
					//
					// Guard for simulated events was moved to jQuery.event.stopPropagation function
					// since `originalEvent` should point to the original event for the
					// constancy with other events and for more focused logic
				});
	
				jQuery.event.trigger(e, null, elem);
	
				if (e.isDefaultPrevented()) {
					event.preventDefault();
				}
			}
		};
	
		jQuery.removeEvent = document.removeEventListener ? function (elem, type, handle) {
	
			// This "if" is needed for plain objects
			if (elem.removeEventListener) {
				elem.removeEventListener(type, handle);
			}
		} : function (elem, type, handle) {
			var name = "on" + type;
	
			if (elem.detachEvent) {
	
				// #8545, #7054, preventing memory leaks for custom events in IE6-8
				// detachEvent needed property on element, by name of that event,
				// to properly expose it to GC
				if (typeof elem[name] === "undefined") {
					elem[name] = null;
				}
	
				elem.detachEvent(name, handle);
			}
		};
	
		jQuery.Event = function (src, props) {
	
			// Allow instantiation without the 'new' keyword
			if (!(this instanceof jQuery.Event)) {
				return new jQuery.Event(src, props);
			}
	
			// Event object
			if (src && src.type) {
				this.originalEvent = src;
				this.type = src.type;
	
				// Events bubbling up the document may have been marked as prevented
				// by a handler lower down the tree; reflect the correct value.
				this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined &&
	
				// Support: IE < 9, Android < 4.0
				src.returnValue === false ? returnTrue : returnFalse;
	
				// Event type
			} else {
				this.type = src;
			}
	
			// Put explicitly provided properties onto the event object
			if (props) {
				jQuery.extend(this, props);
			}
	
			// Create a timestamp if incoming event doesn't have one
			this.timeStamp = src && src.timeStamp || jQuery.now();
	
			// Mark it as fixed
			this[jQuery.expando] = true;
		};
	
		// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
		// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
		jQuery.Event.prototype = {
			constructor: jQuery.Event,
			isDefaultPrevented: returnFalse,
			isPropagationStopped: returnFalse,
			isImmediatePropagationStopped: returnFalse,
	
			preventDefault: function () {
				var e = this.originalEvent;
	
				this.isDefaultPrevented = returnTrue;
				if (!e) {
					return;
				}
	
				// If preventDefault exists, run it on the original event
				if (e.preventDefault) {
					e.preventDefault();
	
					// Support: IE
					// Otherwise set the returnValue property of the original event to false
				} else {
					e.returnValue = false;
				}
			},
			stopPropagation: function () {
				var e = this.originalEvent;
	
				this.isPropagationStopped = returnTrue;
	
				if (!e || this.isSimulated) {
					return;
				}
	
				// If stopPropagation exists, run it on the original event
				if (e.stopPropagation) {
					e.stopPropagation();
				}
	
				// Support: IE
				// Set the cancelBubble property of the original event to true
				e.cancelBubble = true;
			},
			stopImmediatePropagation: function () {
				var e = this.originalEvent;
	
				this.isImmediatePropagationStopped = returnTrue;
	
				if (e && e.stopImmediatePropagation) {
					e.stopImmediatePropagation();
				}
	
				this.stopPropagation();
			}
		};
	
		// Create mouseenter/leave events using mouseover/out and event-time checks
		// so that event delegation works in jQuery.
		// Do the same for pointerenter/pointerleave and pointerover/pointerout
		//
		// Support: Safari 7 only
		// Safari sends mouseenter too often; see:
		// https://code.google.com/p/chromium/issues/detail?id=470258
		// for the description of the bug (it existed in older Chrome versions as well).
		jQuery.each({
			mouseenter: "mouseover",
			mouseleave: "mouseout",
			pointerenter: "pointerover",
			pointerleave: "pointerout"
		}, function (orig, fix) {
			jQuery.event.special[orig] = {
				delegateType: fix,
				bindType: fix,
	
				handle: function (event) {
					var ret,
					    target = this,
					    related = event.relatedTarget,
					    handleObj = event.handleObj;
	
					// For mouseenter/leave call the handler if related is outside the target.
					// NB: No relatedTarget if the mouse left/entered the browser window
					if (!related || related !== target && !jQuery.contains(target, related)) {
						event.type = handleObj.origType;
						ret = handleObj.handler.apply(this, arguments);
						event.type = fix;
					}
					return ret;
				}
			};
		});
	
		// IE submit delegation
		if (!support.submit) {
	
			jQuery.event.special.submit = {
				setup: function () {
	
					// Only need this for delegated form submit events
					if (jQuery.nodeName(this, "form")) {
						return false;
					}
	
					// Lazy-add a submit handler when a descendant form may potentially be submitted
					jQuery.event.add(this, "click._submit keypress._submit", function (e) {
	
						// Node name check avoids a VML-related crash in IE (#9807)
						var elem = e.target,
						    form = jQuery.nodeName(elem, "input") || jQuery.nodeName(elem, "button") ?
	
						// Support: IE <=8
						// We use jQuery.prop instead of elem.form
						// to allow fixing the IE8 delegated submit issue (gh-2332)
						// by 3rd party polyfills/workarounds.
						jQuery.prop(elem, "form") : undefined;
	
						if (form && !jQuery._data(form, "submit")) {
							jQuery.event.add(form, "submit._submit", function (event) {
								event._submitBubble = true;
							});
							jQuery._data(form, "submit", true);
						}
					});
	
					// return undefined since we don't need an event listener
				},
	
				postDispatch: function (event) {
	
					// If form was submitted by the user, bubble the event up the tree
					if (event._submitBubble) {
						delete event._submitBubble;
						if (this.parentNode && !event.isTrigger) {
							jQuery.event.simulate("submit", this.parentNode, event);
						}
					}
				},
	
				teardown: function () {
	
					// Only need this for delegated form submit events
					if (jQuery.nodeName(this, "form")) {
						return false;
					}
	
					// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
					jQuery.event.remove(this, "._submit");
				}
			};
		}
	
		// IE change delegation and checkbox/radio fix
		if (!support.change) {
	
			jQuery.event.special.change = {
	
				setup: function () {
	
					if (rformElems.test(this.nodeName)) {
	
						// IE doesn't fire change on a check/radio until blur; trigger it on click
						// after a propertychange. Eat the blur-change in special.change.handle.
						// This still fires onchange a second time for check/radio after blur.
						if (this.type === "checkbox" || this.type === "radio") {
							jQuery.event.add(this, "propertychange._change", function (event) {
								if (event.originalEvent.propertyName === "checked") {
									this._justChanged = true;
								}
							});
							jQuery.event.add(this, "click._change", function (event) {
								if (this._justChanged && !event.isTrigger) {
									this._justChanged = false;
								}
	
								// Allow triggered, simulated change events (#11500)
								jQuery.event.simulate("change", this, event);
							});
						}
						return false;
					}
	
					// Delegated event; lazy-add a change handler on descendant inputs
					jQuery.event.add(this, "beforeactivate._change", function (e) {
						var elem = e.target;
	
						if (rformElems.test(elem.nodeName) && !jQuery._data(elem, "change")) {
							jQuery.event.add(elem, "change._change", function (event) {
								if (this.parentNode && !event.isSimulated && !event.isTrigger) {
									jQuery.event.simulate("change", this.parentNode, event);
								}
							});
							jQuery._data(elem, "change", true);
						}
					});
				},
	
				handle: function (event) {
					var elem = event.target;
	
					// Swallow native change events from checkbox/radio, we already triggered them above
					if (this !== elem || event.isSimulated || event.isTrigger || elem.type !== "radio" && elem.type !== "checkbox") {
	
						return event.handleObj.handler.apply(this, arguments);
					}
				},
	
				teardown: function () {
					jQuery.event.remove(this, "._change");
	
					return !rformElems.test(this.nodeName);
				}
			};
		}
	
		// Support: Firefox
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome, Safari
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
		if (!support.focusin) {
			jQuery.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {
	
				// Attach a single capturing handler on the document while someone wants focusin/focusout
				var handler = function (event) {
					jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
				};
	
				jQuery.event.special[fix] = {
					setup: function () {
						var doc = this.ownerDocument || this,
						    attaches = jQuery._data(doc, fix);
	
						if (!attaches) {
							doc.addEventListener(orig, handler, true);
						}
						jQuery._data(doc, fix, (attaches || 0) + 1);
					},
					teardown: function () {
						var doc = this.ownerDocument || this,
						    attaches = jQuery._data(doc, fix) - 1;
	
						if (!attaches) {
							doc.removeEventListener(orig, handler, true);
							jQuery._removeData(doc, fix);
						} else {
							jQuery._data(doc, fix, attaches);
						}
					}
				};
			});
		}
	
		jQuery.fn.extend({
	
			on: function (types, selector, data, fn) {
				return on(this, types, selector, data, fn);
			},
			one: function (types, selector, data, fn) {
				return on(this, types, selector, data, fn, 1);
			},
			off: function (types, selector, fn) {
				var handleObj, type;
				if (types && types.preventDefault && types.handleObj) {
	
					// ( event )  dispatched jQuery.Event
					handleObj = types.handleObj;
					jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
					return this;
				}
				if (typeof types === "object") {
	
					// ( types-object [, selector] )
					for (type in types) {
						this.off(type, selector, types[type]);
					}
					return this;
				}
				if (selector === false || typeof selector === "function") {
	
					// ( types [, fn] )
					fn = selector;
					selector = undefined;
				}
				if (fn === false) {
					fn = returnFalse;
				}
				return this.each(function () {
					jQuery.event.remove(this, types, fn, selector);
				});
			},
	
			trigger: function (type, data) {
				return this.each(function () {
					jQuery.event.trigger(type, data, this);
				});
			},
			triggerHandler: function (type, data) {
				var elem = this[0];
				if (elem) {
					return jQuery.event.trigger(type, data, elem, true);
				}
			}
		});
	
		var rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
		    rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"),
		    rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		    rscriptTypeMasked = /^true\/(.*)/,
		    rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
		    safeFragment = createSafeFragment(document),
		    fragmentDiv = safeFragment.appendChild(document.createElement("div"));
	
		// Support: IE<8
		// Manipulating tables requires a tbody
		function manipulationTarget(elem, content) {
			return jQuery.nodeName(elem, "table") && jQuery.nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr") ? elem.getElementsByTagName("tbody")[0] || elem.appendChild(elem.ownerDocument.createElement("tbody")) : elem;
		}
	
		// Replace/restore the type attribute of script elements for safe DOM manipulation
		function disableScript(elem) {
			elem.type = (jQuery.find.attr(elem, "type") !== null) + "/" + elem.type;
			return elem;
		}
		function restoreScript(elem) {
			var match = rscriptTypeMasked.exec(elem.type);
			if (match) {
				elem.type = match[1];
			} else {
				elem.removeAttribute("type");
			}
			return elem;
		}
	
		function cloneCopyEvent(src, dest) {
			if (dest.nodeType !== 1 || !jQuery.hasData(src)) {
				return;
			}
	
			var type,
			    i,
			    l,
			    oldData = jQuery._data(src),
			    curData = jQuery._data(dest, oldData),
			    events = oldData.events;
	
			if (events) {
				delete curData.handle;
				curData.events = {};
	
				for (type in events) {
					for (i = 0, l = events[type].length; i < l; i++) {
						jQuery.event.add(dest, type, events[type][i]);
					}
				}
			}
	
			// make the cloned public data object a copy from the original
			if (curData.data) {
				curData.data = jQuery.extend({}, curData.data);
			}
		}
	
		function fixCloneNodeIssues(src, dest) {
			var nodeName, e, data;
	
			// We do not need to do anything for non-Elements
			if (dest.nodeType !== 1) {
				return;
			}
	
			nodeName = dest.nodeName.toLowerCase();
	
			// IE6-8 copies events bound via attachEvent when using cloneNode.
			if (!support.noCloneEvent && dest[jQuery.expando]) {
				data = jQuery._data(dest);
	
				for (e in data.events) {
					jQuery.removeEvent(dest, e, data.handle);
				}
	
				// Event data gets referenced instead of copied if the expando gets copied too
				dest.removeAttribute(jQuery.expando);
			}
	
			// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
			if (nodeName === "script" && dest.text !== src.text) {
				disableScript(dest).text = src.text;
				restoreScript(dest);
	
				// IE6-10 improperly clones children of object elements using classid.
				// IE10 throws NoModificationAllowedError if parent is null, #12132.
			} else if (nodeName === "object") {
				if (dest.parentNode) {
					dest.outerHTML = src.outerHTML;
				}
	
				// This path appears unavoidable for IE9. When cloning an object
				// element in IE9, the outerHTML strategy above is not sufficient.
				// If the src has innerHTML and the destination does not,
				// copy the src.innerHTML into the dest.innerHTML. #10324
				if (support.html5Clone && src.innerHTML && !jQuery.trim(dest.innerHTML)) {
					dest.innerHTML = src.innerHTML;
				}
			} else if (nodeName === "input" && rcheckableType.test(src.type)) {
	
				// IE6-8 fails to persist the checked state of a cloned checkbox
				// or radio button. Worse, IE6-7 fail to give the cloned element
				// a checked appearance if the defaultChecked value isn't also set
	
				dest.defaultChecked = dest.checked = src.checked;
	
				// IE6-7 get confused and end up setting the value of a cloned
				// checkbox/radio button to an empty string instead of "on"
				if (dest.value !== src.value) {
					dest.value = src.value;
				}
	
				// IE6-8 fails to return the selected option to the default selected
				// state when cloning options
			} else if (nodeName === "option") {
				dest.defaultSelected = dest.selected = src.defaultSelected;
	
				// IE6-8 fails to set the defaultValue to the correct value when
				// cloning other types of input fields
			} else if (nodeName === "input" || nodeName === "textarea") {
				dest.defaultValue = src.defaultValue;
			}
		}
	
		function domManip(collection, args, callback, ignored) {
	
			// Flatten any nested arrays
			args = concat.apply([], args);
	
			var first,
			    node,
			    hasScripts,
			    scripts,
			    doc,
			    fragment,
			    i = 0,
			    l = collection.length,
			    iNoClone = l - 1,
			    value = args[0],
			    isFunction = jQuery.isFunction(value);
	
			// We can't cloneNode fragments that contain checked, in WebKit
			if (isFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
				return collection.each(function (index) {
					var self = collection.eq(index);
					if (isFunction) {
						args[0] = value.call(this, index, self.html());
					}
					domManip(self, args, callback, ignored);
				});
			}
	
			if (l) {
				fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
				first = fragment.firstChild;
	
				if (fragment.childNodes.length === 1) {
					fragment = first;
				}
	
				// Require either new content or an interest in ignored elements to invoke the callback
				if (first || ignored) {
					scripts = jQuery.map(getAll(fragment, "script"), disableScript);
					hasScripts = scripts.length;
	
					// Use the original fragment for the last item
					// instead of the first because it can end up
					// being emptied incorrectly in certain situations (#8070).
					for (; i < l; i++) {
						node = fragment;
	
						if (i !== iNoClone) {
							node = jQuery.clone(node, true, true);
	
							// Keep references to cloned scripts for later restoration
							if (hasScripts) {
	
								// Support: Android<4.1, PhantomJS<2
								// push.apply(_, arraylike) throws on ancient WebKit
								jQuery.merge(scripts, getAll(node, "script"));
							}
						}
	
						callback.call(collection[i], node, i);
					}
	
					if (hasScripts) {
						doc = scripts[scripts.length - 1].ownerDocument;
	
						// Reenable scripts
						jQuery.map(scripts, restoreScript);
	
						// Evaluate executable scripts on first document insertion
						for (i = 0; i < hasScripts; i++) {
							node = scripts[i];
							if (rscriptType.test(node.type || "") && !jQuery._data(node, "globalEval") && jQuery.contains(doc, node)) {
	
								if (node.src) {
	
									// Optional AJAX dependency, but won't run scripts if not present
									if (jQuery._evalUrl) {
										jQuery._evalUrl(node.src);
									}
								} else {
									jQuery.globalEval((node.text || node.textContent || node.innerHTML || "").replace(rcleanScript, ""));
								}
							}
						}
					}
	
					// Fix #11809: Avoid leaking memory
					fragment = first = null;
				}
			}
	
			return collection;
		}
	
		function remove(elem, selector, keepData) {
			var node,
			    elems = selector ? jQuery.filter(selector, elem) : elem,
			    i = 0;
	
			for (; (node = elems[i]) != null; i++) {
	
				if (!keepData && node.nodeType === 1) {
					jQuery.cleanData(getAll(node));
				}
	
				if (node.parentNode) {
					if (keepData && jQuery.contains(node.ownerDocument, node)) {
						setGlobalEval(getAll(node, "script"));
					}
					node.parentNode.removeChild(node);
				}
			}
	
			return elem;
		}
	
		jQuery.extend({
			htmlPrefilter: function (html) {
				return html.replace(rxhtmlTag, "<$1></$2>");
			},
	
			clone: function (elem, dataAndEvents, deepDataAndEvents) {
				var destElements,
				    node,
				    clone,
				    i,
				    srcElements,
				    inPage = jQuery.contains(elem.ownerDocument, elem);
	
				if (support.html5Clone || jQuery.isXMLDoc(elem) || !rnoshimcache.test("<" + elem.nodeName + ">")) {
	
					clone = elem.cloneNode(true);
	
					// IE<=8 does not properly clone detached, unknown element nodes
				} else {
					fragmentDiv.innerHTML = elem.outerHTML;
					fragmentDiv.removeChild(clone = fragmentDiv.firstChild);
				}
	
				if ((!support.noCloneEvent || !support.noCloneChecked) && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
	
					// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
					destElements = getAll(clone);
					srcElements = getAll(elem);
	
					// Fix all IE cloning issues
					for (i = 0; (node = srcElements[i]) != null; ++i) {
	
						// Ensure that the destination node is not null; Fixes #9587
						if (destElements[i]) {
							fixCloneNodeIssues(node, destElements[i]);
						}
					}
				}
	
				// Copy the events from the original to the clone
				if (dataAndEvents) {
					if (deepDataAndEvents) {
						srcElements = srcElements || getAll(elem);
						destElements = destElements || getAll(clone);
	
						for (i = 0; (node = srcElements[i]) != null; i++) {
							cloneCopyEvent(node, destElements[i]);
						}
					} else {
						cloneCopyEvent(elem, clone);
					}
				}
	
				// Preserve script evaluation history
				destElements = getAll(clone, "script");
				if (destElements.length > 0) {
					setGlobalEval(destElements, !inPage && getAll(elem, "script"));
				}
	
				destElements = srcElements = node = null;
	
				// Return the cloned set
				return clone;
			},
	
			cleanData: function (elems, /* internal */forceAcceptData) {
				var elem,
				    type,
				    id,
				    data,
				    i = 0,
				    internalKey = jQuery.expando,
				    cache = jQuery.cache,
				    attributes = support.attributes,
				    special = jQuery.event.special;
	
				for (; (elem = elems[i]) != null; i++) {
					if (forceAcceptData || acceptData(elem)) {
	
						id = elem[internalKey];
						data = id && cache[id];
	
						if (data) {
							if (data.events) {
								for (type in data.events) {
									if (special[type]) {
										jQuery.event.remove(elem, type);
	
										// This is a shortcut to avoid jQuery.event.remove's overhead
									} else {
										jQuery.removeEvent(elem, type, data.handle);
									}
								}
							}
	
							// Remove cache only if it was not already removed by jQuery.event.remove
							if (cache[id]) {
	
								delete cache[id];
	
								// Support: IE<9
								// IE does not allow us to delete expando properties from nodes
								// IE creates expando attributes along with the property
								// IE does not have a removeAttribute function on Document nodes
								if (!attributes && typeof elem.removeAttribute !== "undefined") {
									elem.removeAttribute(internalKey);
	
									// Webkit & Blink performance suffers when deleting properties
									// from DOM nodes, so set to undefined instead
									// https://code.google.com/p/chromium/issues/detail?id=378607
								} else {
									elem[internalKey] = undefined;
								}
	
								deletedIds.push(id);
							}
						}
					}
				}
			}
		});
	
		jQuery.fn.extend({
	
			// Keep domManip exposed until 3.0 (gh-2225)
			domManip: domManip,
	
			detach: function (selector) {
				return remove(this, selector, true);
			},
	
			remove: function (selector) {
				return remove(this, selector);
			},
	
			text: function (value) {
				return access(this, function (value) {
					return value === undefined ? jQuery.text(this) : this.empty().append((this[0] && this[0].ownerDocument || document).createTextNode(value));
				}, null, value, arguments.length);
			},
	
			append: function () {
				return domManip(this, arguments, function (elem) {
					if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
						var target = manipulationTarget(this, elem);
						target.appendChild(elem);
					}
				});
			},
	
			prepend: function () {
				return domManip(this, arguments, function (elem) {
					if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
						var target = manipulationTarget(this, elem);
						target.insertBefore(elem, target.firstChild);
					}
				});
			},
	
			before: function () {
				return domManip(this, arguments, function (elem) {
					if (this.parentNode) {
						this.parentNode.insertBefore(elem, this);
					}
				});
			},
	
			after: function () {
				return domManip(this, arguments, function (elem) {
					if (this.parentNode) {
						this.parentNode.insertBefore(elem, this.nextSibling);
					}
				});
			},
	
			empty: function () {
				var elem,
				    i = 0;
	
				for (; (elem = this[i]) != null; i++) {
	
					// Remove element nodes and prevent memory leaks
					if (elem.nodeType === 1) {
						jQuery.cleanData(getAll(elem, false));
					}
	
					// Remove any remaining nodes
					while (elem.firstChild) {
						elem.removeChild(elem.firstChild);
					}
	
					// If this is a select, ensure that it displays empty (#12336)
					// Support: IE<9
					if (elem.options && jQuery.nodeName(elem, "select")) {
						elem.options.length = 0;
					}
				}
	
				return this;
			},
	
			clone: function (dataAndEvents, deepDataAndEvents) {
				dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
				deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
				return this.map(function () {
					return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
				});
			},
	
			html: function (value) {
				return access(this, function (value) {
					var elem = this[0] || {},
					    i = 0,
					    l = this.length;
	
					if (value === undefined) {
						return elem.nodeType === 1 ? elem.innerHTML.replace(rinlinejQuery, "") : undefined;
					}
	
					// See if we can take a shortcut and just use innerHTML
					if (typeof value === "string" && !rnoInnerhtml.test(value) && (support.htmlSerialize || !rnoshimcache.test(value)) && (support.leadingWhitespace || !rleadingWhitespace.test(value)) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
	
						value = jQuery.htmlPrefilter(value);
	
						try {
							for (; i < l; i++) {
	
								// Remove element nodes and prevent memory leaks
								elem = this[i] || {};
								if (elem.nodeType === 1) {
									jQuery.cleanData(getAll(elem, false));
									elem.innerHTML = value;
								}
							}
	
							elem = 0;
	
							// If using innerHTML throws an exception, use the fallback method
						} catch (e) {}
					}
	
					if (elem) {
						this.empty().append(value);
					}
				}, null, value, arguments.length);
			},
	
			replaceWith: function () {
				var ignored = [];
	
				// Make the changes, replacing each non-ignored context element with the new content
				return domManip(this, arguments, function (elem) {
					var parent = this.parentNode;
	
					if (jQuery.inArray(this, ignored) < 0) {
						jQuery.cleanData(getAll(this));
						if (parent) {
							parent.replaceChild(elem, this);
						}
					}
	
					// Force callback invocation
				}, ignored);
			}
		});
	
		jQuery.each({
			appendTo: "append",
			prependTo: "prepend",
			insertBefore: "before",
			insertAfter: "after",
			replaceAll: "replaceWith"
		}, function (name, original) {
			jQuery.fn[name] = function (selector) {
				var elems,
				    i = 0,
				    ret = [],
				    insert = jQuery(selector),
				    last = insert.length - 1;
	
				for (; i <= last; i++) {
					elems = i === last ? this : this.clone(true);
					jQuery(insert[i])[original](elems);
	
					// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
					push.apply(ret, elems.get());
				}
	
				return this.pushStack(ret);
			};
		});
	
		var iframe,
		    elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
		/**
	  * Retrieve the actual display of a element
	  * @param {String} name nodeName of the element
	  * @param {Object} doc Document object
	  */
	
		// Called only from within defaultDisplay
		function actualDisplay(name, doc) {
			var elem = jQuery(doc.createElement(name)).appendTo(doc.body),
			    display = jQuery.css(elem[0], "display");
	
			// We don't have any data stored on the element,
			// so use "detach" method as fast way to get rid of the element
			elem.detach();
	
			return display;
		}
	
		/**
	  * Try to determine the default display value of an element
	  * @param {String} nodeName
	  */
		function defaultDisplay(nodeName) {
			var doc = document,
			    display = elemdisplay[nodeName];
	
			if (!display) {
				display = actualDisplay(nodeName, doc);
	
				// If the simple way fails, read from inside an iframe
				if (display === "none" || !display) {
	
					// Use the already-created iframe if possible
					iframe = (iframe || jQuery("<iframe frameborder='0' width='0' height='0'/>")).appendTo(doc.documentElement);
	
					// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
					doc = (iframe[0].contentWindow || iframe[0].contentDocument).document;
	
					// Support: IE
					doc.write();
					doc.close();
	
					display = actualDisplay(nodeName, doc);
					iframe.detach();
				}
	
				// Store the correct default display
				elemdisplay[nodeName] = display;
			}
	
			return display;
		}
		var rmargin = /^margin/;
	
		var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
	
		var swap = function (elem, options, callback, args) {
			var ret,
			    name,
			    old = {};
	
			// Remember the old values, and insert the new ones
			for (name in options) {
				old[name] = elem.style[name];
				elem.style[name] = options[name];
			}
	
			ret = callback.apply(elem, args || []);
	
			// Revert the old values
			for (name in options) {
				elem.style[name] = old[name];
			}
	
			return ret;
		};
	
		var documentElement = document.documentElement;
	
		(function () {
			var pixelPositionVal,
			    pixelMarginRightVal,
			    boxSizingReliableVal,
			    reliableHiddenOffsetsVal,
			    reliableMarginRightVal,
			    reliableMarginLeftVal,
			    container = document.createElement("div"),
			    div = document.createElement("div");
	
			// Finish early in limited (non-browser) environments
			if (!div.style) {
				return;
			}
	
			div.style.cssText = "float:left;opacity:.5";
	
			// Support: IE<9
			// Make sure that element opacity exists (as opposed to filter)
			support.opacity = div.style.opacity === "0.5";
	
			// Verify style float existence
			// (IE uses styleFloat instead of cssFloat)
			support.cssFloat = !!div.style.cssFloat;
	
			div.style.backgroundClip = "content-box";
			div.cloneNode(true).style.backgroundClip = "";
			support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
			container = document.createElement("div");
			container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" + "padding:0;margin-top:1px;position:absolute";
			div.innerHTML = "";
			container.appendChild(div);
	
			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			support.boxSizing = div.style.boxSizing === "" || div.style.MozBoxSizing === "" || div.style.WebkitBoxSizing === "";
	
			jQuery.extend(support, {
				reliableHiddenOffsets: function () {
					if (pixelPositionVal == null) {
						computeStyleTests();
					}
					return reliableHiddenOffsetsVal;
				},
	
				boxSizingReliable: function () {
	
					// We're checking for pixelPositionVal here instead of boxSizingReliableVal
					// since that compresses better and they're computed together anyway.
					if (pixelPositionVal == null) {
						computeStyleTests();
					}
					return boxSizingReliableVal;
				},
	
				pixelMarginRight: function () {
	
					// Support: Android 4.0-4.3
					if (pixelPositionVal == null) {
						computeStyleTests();
					}
					return pixelMarginRightVal;
				},
	
				pixelPosition: function () {
					if (pixelPositionVal == null) {
						computeStyleTests();
					}
					return pixelPositionVal;
				},
	
				reliableMarginRight: function () {
	
					// Support: Android 2.3
					if (pixelPositionVal == null) {
						computeStyleTests();
					}
					return reliableMarginRightVal;
				},
	
				reliableMarginLeft: function () {
	
					// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
					if (pixelPositionVal == null) {
						computeStyleTests();
					}
					return reliableMarginLeftVal;
				}
			});
	
			function computeStyleTests() {
				var contents,
				    divStyle,
				    documentElement = document.documentElement;
	
				// Setup
				documentElement.appendChild(container);
	
				div.style.cssText =
	
				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;box-sizing:border-box;" + "position:relative;display:block;" + "margin:auto;border:1px;padding:1px;" + "top:1%;width:50%";
	
				// Support: IE<9
				// Assume reasonable values in the absence of getComputedStyle
				pixelPositionVal = boxSizingReliableVal = reliableMarginLeftVal = false;
				pixelMarginRightVal = reliableMarginRightVal = true;
	
				// Check for getComputedStyle so that this code is not run in IE<9.
				if (window.getComputedStyle) {
					divStyle = window.getComputedStyle(div);
					pixelPositionVal = (divStyle || {}).top !== "1%";
					reliableMarginLeftVal = (divStyle || {}).marginLeft === "2px";
					boxSizingReliableVal = (divStyle || { width: "4px" }).width === "4px";
	
					// Support: Android 4.0 - 4.3 only
					// Some styles come back with percentage values, even though they shouldn't
					div.style.marginRight = "50%";
					pixelMarginRightVal = (divStyle || { marginRight: "4px" }).marginRight === "4px";
	
					// Support: Android 2.3 only
					// Div with explicit width and no margin-right incorrectly
					// gets computed margin-right based on width of container (#3333)
					// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
					contents = div.appendChild(document.createElement("div"));
	
					// Reset CSS: box-sizing; display; margin; border; padding
					contents.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" + "box-sizing:content-box;display:block;margin:0;border:0;padding:0";
					contents.style.marginRight = contents.style.width = "0";
					div.style.width = "1px";
	
					reliableMarginRightVal = !parseFloat((window.getComputedStyle(contents) || {}).marginRight);
	
					div.removeChild(contents);
				}
	
				// Support: IE6-8
				// First check that getClientRects works as expected
				// Check if table cells still have offsetWidth/Height when they are set
				// to display:none and there are still other visible table cells in a
				// table row; if so, offsetWidth/Height are not reliable for use when
				// determining if an element has been hidden directly using
				// display:none (it is still safe to use offsets if a parent element is
				// hidden; don safety goggles and see bug #4512 for more information).
				div.style.display = "none";
				reliableHiddenOffsetsVal = div.getClientRects().length === 0;
				if (reliableHiddenOffsetsVal) {
					div.style.display = "";
					div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
					div.childNodes[0].style.borderCollapse = "separate";
					contents = div.getElementsByTagName("td");
					contents[0].style.cssText = "margin:0;border:0;padding:0;display:none";
					reliableHiddenOffsetsVal = contents[0].offsetHeight === 0;
					if (reliableHiddenOffsetsVal) {
						contents[0].style.display = "";
						contents[1].style.display = "none";
						reliableHiddenOffsetsVal = contents[0].offsetHeight === 0;
					}
				}
	
				// Teardown
				documentElement.removeChild(container);
			}
		})();
	
		var getStyles,
		    curCSS,
		    rposition = /^(top|right|bottom|left)$/;
	
		if (window.getComputedStyle) {
			getStyles = function (elem) {
	
				// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
				// IE throws on elements created in popups
				// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
				var view = elem.ownerDocument.defaultView;
	
				if (!view || !view.opener) {
					view = window;
				}
	
				return view.getComputedStyle(elem);
			};
	
			curCSS = function (elem, name, computed) {
				var width,
				    minWidth,
				    maxWidth,
				    ret,
				    style = elem.style;
	
				computed = computed || getStyles(elem);
	
				// getPropertyValue is only needed for .css('filter') in IE9, see #12537
				ret = computed ? computed.getPropertyValue(name) || computed[name] : undefined;
	
				// Support: Opera 12.1x only
				// Fall back to style even without computed
				// computed is undefined for elems on document fragments
				if ((ret === "" || ret === undefined) && !jQuery.contains(elem.ownerDocument, elem)) {
					ret = jQuery.style(elem, name);
				}
	
				if (computed) {
	
					// A tribute to the "awesome hack by Dean Edwards"
					// Chrome < 17 and Safari 5.0 uses "computed value"
					// instead of "used value" for margin-right
					// Safari 5.1.7 (at least) returns percentage for a larger set of values,
					// but width seems to be reliably pixels
					// this is against the CSSOM draft spec:
					// http://dev.w3.org/csswg/cssom/#resolved-values
					if (!support.pixelMarginRight() && rnumnonpx.test(ret) && rmargin.test(name)) {
	
						// Remember the original values
						width = style.width;
						minWidth = style.minWidth;
						maxWidth = style.maxWidth;
	
						// Put in the new values to get a computed value out
						style.minWidth = style.maxWidth = style.width = ret;
						ret = computed.width;
	
						// Revert the changed values
						style.width = width;
						style.minWidth = minWidth;
						style.maxWidth = maxWidth;
					}
				}
	
				// Support: IE
				// IE returns zIndex value as an integer.
				return ret === undefined ? ret : ret + "";
			};
		} else if (documentElement.currentStyle) {
			getStyles = function (elem) {
				return elem.currentStyle;
			};
	
			curCSS = function (elem, name, computed) {
				var left,
				    rs,
				    rsLeft,
				    ret,
				    style = elem.style;
	
				computed = computed || getStyles(elem);
				ret = computed ? computed[name] : undefined;
	
				// Avoid setting ret to empty string here
				// so we don't default to auto
				if (ret == null && style && style[name]) {
					ret = style[name];
				}
	
				// From the awesome hack by Dean Edwards
				// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	
				// If we're not dealing with a regular pixel number
				// but a number that has a weird ending, we need to convert it to pixels
				// but not position css attributes, as those are
				// proportional to the parent element instead
				// and we can't measure the parent instead because it
				// might trigger a "stacking dolls" problem
				if (rnumnonpx.test(ret) && !rposition.test(name)) {
	
					// Remember the original values
					left = style.left;
					rs = elem.runtimeStyle;
					rsLeft = rs && rs.left;
	
					// Put in the new values to get a computed value out
					if (rsLeft) {
						rs.left = elem.currentStyle.left;
					}
					style.left = name === "fontSize" ? "1em" : ret;
					ret = style.pixelLeft + "px";
	
					// Revert the changed values
					style.left = left;
					if (rsLeft) {
						rs.left = rsLeft;
					}
				}
	
				// Support: IE
				// IE returns zIndex value as an integer.
				return ret === undefined ? ret : ret + "" || "auto";
			};
		}
	
		function addGetHookIf(conditionFn, hookFn) {
	
			// Define the hook, we'll check on the first run if it's really needed.
			return {
				get: function () {
					if (conditionFn()) {
	
						// Hook not needed (or it's not possible to use it due
						// to missing dependency), remove it.
						delete this.get;
						return;
					}
	
					// Hook needed; redefine it so that the support test is not executed again.
					return (this.get = hookFn).apply(this, arguments);
				}
			};
		}
	
		var ralpha = /alpha\([^)]*\)/i,
		    ropacity = /opacity\s*=\s*([^)]*)/i,
	
	
		// swappable if display is none or starts with table except
		// "table", "table-cell", or "table-caption"
		// see here for display values:
		// https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		    rnumsplit = new RegExp("^(" + pnum + ")(.*)$", "i"),
		    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		    cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
		    cssPrefixes = ["Webkit", "O", "Moz", "ms"],
		    emptyStyle = document.createElement("div").style;
	
		// return a css property mapped to a potentially vendor prefixed property
		function vendorPropName(name) {
	
			// shortcut for names that are not vendor prefixed
			if (name in emptyStyle) {
				return name;
			}
	
			// check for vendor prefixed names
			var capName = name.charAt(0).toUpperCase() + name.slice(1),
			    i = cssPrefixes.length;
	
			while (i--) {
				name = cssPrefixes[i] + capName;
				if (name in emptyStyle) {
					return name;
				}
			}
		}
	
		function showHide(elements, show) {
			var display,
			    elem,
			    hidden,
			    values = [],
			    index = 0,
			    length = elements.length;
	
			for (; index < length; index++) {
				elem = elements[index];
				if (!elem.style) {
					continue;
				}
	
				values[index] = jQuery._data(elem, "olddisplay");
				display = elem.style.display;
				if (show) {
	
					// Reset the inline display of this element to learn if it is
					// being hidden by cascaded rules or not
					if (!values[index] && display === "none") {
						elem.style.display = "";
					}
	
					// Set elements which have been overridden with display: none
					// in a stylesheet to whatever the default browser style is
					// for such an element
					if (elem.style.display === "" && isHidden(elem)) {
						values[index] = jQuery._data(elem, "olddisplay", defaultDisplay(elem.nodeName));
					}
				} else {
					hidden = isHidden(elem);
	
					if (display && display !== "none" || !hidden) {
						jQuery._data(elem, "olddisplay", hidden ? display : jQuery.css(elem, "display"));
					}
				}
			}
	
			// Set the display of most of the elements in a second loop
			// to avoid the constant reflow
			for (index = 0; index < length; index++) {
				elem = elements[index];
				if (!elem.style) {
					continue;
				}
				if (!show || elem.style.display === "none" || elem.style.display === "") {
					elem.style.display = show ? values[index] || "" : "none";
				}
			}
	
			return elements;
		}
	
		function setPositiveNumber(elem, value, subtract) {
			var matches = rnumsplit.exec(value);
			return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max(0, matches[1] - (subtract || 0)) + (matches[2] || "px") : value;
		}
	
		function augmentWidthOrHeight(elem, name, extra, isBorderBox, styles) {
			var i = extra === (isBorderBox ? "border" : "content") ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
			    val = 0;
	
			for (; i < 4; i += 2) {
	
				// both box models exclude margin, so add it if we want it
				if (extra === "margin") {
					val += jQuery.css(elem, extra + cssExpand[i], true, styles);
				}
	
				if (isBorderBox) {
	
					// border-box includes padding, so remove it if we want content
					if (extra === "content") {
						val -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
					}
	
					// at this point, extra isn't border nor margin, so remove border
					if (extra !== "margin") {
						val -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
					}
				} else {
	
					// at this point, extra isn't content, so add padding
					val += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
	
					// at this point, extra isn't content nor padding, so add border
					if (extra !== "padding") {
						val += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
					}
				}
			}
	
			return val;
		}
	
		function getWidthOrHeight(elem, name, extra) {
	
			// Start with offset property, which is equivalent to the border-box value
			var valueIsBorderBox = true,
			    val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			    styles = getStyles(elem),
			    isBorderBox = support.boxSizing && jQuery.css(elem, "boxSizing", false, styles) === "border-box";
	
			// some non-html elements return undefined for offsetWidth, so check for null/undefined
			// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
			// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
			if (val <= 0 || val == null) {
	
				// Fall back to computed then uncomputed css if necessary
				val = curCSS(elem, name, styles);
				if (val < 0 || val == null) {
					val = elem.style[name];
				}
	
				// Computed unit is not pixels. Stop here and return.
				if (rnumnonpx.test(val)) {
					return val;
				}
	
				// we need the check for style in case a browser which returns unreliable values
				// for getComputedStyle silently falls back to the reliable elem.style
				valueIsBorderBox = isBorderBox && (support.boxSizingReliable() || val === elem.style[name]);
	
				// Normalize "", auto, and prepare for extra
				val = parseFloat(val) || 0;
			}
	
			// use the active box-sizing model to add/subtract irrelevant styles
			return val + augmentWidthOrHeight(elem, name, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles) + "px";
		}
	
		jQuery.extend({
	
			// Add in style property hooks for overriding the default
			// behavior of getting and setting a style property
			cssHooks: {
				opacity: {
					get: function (elem, computed) {
						if (computed) {
	
							// We should always get a number back from opacity
							var ret = curCSS(elem, "opacity");
							return ret === "" ? "1" : ret;
						}
					}
				}
			},
	
			// Don't automatically add "px" to these possibly-unitless properties
			cssNumber: {
				"animationIterationCount": true,
				"columnCount": true,
				"fillOpacity": true,
				"flexGrow": true,
				"flexShrink": true,
				"fontWeight": true,
				"lineHeight": true,
				"opacity": true,
				"order": true,
				"orphans": true,
				"widows": true,
				"zIndex": true,
				"zoom": true
			},
	
			// Add in properties whose names you wish to fix before
			// setting or getting the value
			cssProps: {
	
				// normalize float css property
				"float": support.cssFloat ? "cssFloat" : "styleFloat"
			},
	
			// Get and set the style property on a DOM Node
			style: function (elem, name, value, extra) {
	
				// Don't set styles on text and comment nodes
				if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
					return;
				}
	
				// Make sure that we're working with the right name
				var ret,
				    type,
				    hooks,
				    origName = jQuery.camelCase(name),
				    style = elem.style;
	
				name = jQuery.cssProps[origName] || (jQuery.cssProps[origName] = vendorPropName(origName) || origName);
	
				// gets hook for the prefixed version
				// followed by the unprefixed version
				hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
	
				// Check if we're setting a value
				if (value !== undefined) {
					type = typeof value;
	
					// Convert "+=" or "-=" to relative numbers (#7345)
					if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
						value = adjustCSS(elem, name, ret);
	
						// Fixes bug #9237
						type = "number";
					}
	
					// Make sure that null and NaN values aren't set. See: #7116
					if (value == null || value !== value) {
						return;
					}
	
					// If a number was passed in, add the unit (except for certain CSS properties)
					if (type === "number") {
						value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
					}
	
					// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
					// but it would mean to define eight
					// (for every problematic property) identical functions
					if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
						style[name] = "inherit";
					}
	
					// If a hook was provided, use that value, otherwise just set the specified value
					if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
	
						// Support: IE
						// Swallow errors from 'invalid' CSS values (#5509)
						try {
							style[name] = value;
						} catch (e) {}
					}
				} else {
	
					// If a hook was provided get the non-computed value from there
					if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
	
						return ret;
					}
	
					// Otherwise just get the value from the style object
					return style[name];
				}
			},
	
			css: function (elem, name, extra, styles) {
				var num,
				    val,
				    hooks,
				    origName = jQuery.camelCase(name);
	
				// Make sure that we're working with the right name
				name = jQuery.cssProps[origName] || (jQuery.cssProps[origName] = vendorPropName(origName) || origName);
	
				// gets hook for the prefixed version
				// followed by the unprefixed version
				hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
	
				// If a hook was provided get the computed value from there
				if (hooks && "get" in hooks) {
					val = hooks.get(elem, true, extra);
				}
	
				// Otherwise, if a way to get the computed value exists, use that
				if (val === undefined) {
					val = curCSS(elem, name, styles);
				}
	
				//convert "normal" to computed value
				if (val === "normal" && name in cssNormalTransform) {
					val = cssNormalTransform[name];
				}
	
				// Return, converting to number if forced or a qualifier was provided and val looks numeric
				if (extra === "" || extra) {
					num = parseFloat(val);
					return extra === true || isFinite(num) ? num || 0 : val;
				}
				return val;
			}
		});
	
		jQuery.each(["height", "width"], function (i, name) {
			jQuery.cssHooks[name] = {
				get: function (elem, computed, extra) {
					if (computed) {
	
						// certain elements can have dimension info if we invisibly show them
						// however, it must have a current display style that would benefit from this
						return rdisplayswap.test(jQuery.css(elem, "display")) && elem.offsetWidth === 0 ? swap(elem, cssShow, function () {
							return getWidthOrHeight(elem, name, extra);
						}) : getWidthOrHeight(elem, name, extra);
					}
				},
	
				set: function (elem, value, extra) {
					var styles = extra && getStyles(elem);
					return setPositiveNumber(elem, value, extra ? augmentWidthOrHeight(elem, name, extra, support.boxSizing && jQuery.css(elem, "boxSizing", false, styles) === "border-box", styles) : 0);
				}
			};
		});
	
		if (!support.opacity) {
			jQuery.cssHooks.opacity = {
				get: function (elem, computed) {
	
					// IE uses filters for opacity
					return ropacity.test((computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "") ? 0.01 * parseFloat(RegExp.$1) + "" : computed ? "1" : "";
				},
	
				set: function (elem, value) {
					var style = elem.style,
					    currentStyle = elem.currentStyle,
					    opacity = jQuery.isNumeric(value) ? "alpha(opacity=" + value * 100 + ")" : "",
					    filter = currentStyle && currentStyle.filter || style.filter || "";
	
					// IE has trouble with opacity if it does not have layout
					// Force it by setting the zoom level
					style.zoom = 1;
	
					// if setting opacity to 1, and no other filters exist -
					// attempt to remove filter attribute #6652
					// if value === "", then remove inline opacity #12685
					if ((value >= 1 || value === "") && jQuery.trim(filter.replace(ralpha, "")) === "" && style.removeAttribute) {
	
						// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
						// if "filter:" is present at all, clearType is disabled, we want to avoid this
						// style.removeAttribute is IE Only, but so apparently is this code path...
						style.removeAttribute("filter");
	
						// if there is no filter style applied in a css rule
						// or unset inline opacity, we are done
						if (value === "" || currentStyle && !currentStyle.filter) {
							return;
						}
					}
	
					// otherwise, set new filter values
					style.filter = ralpha.test(filter) ? filter.replace(ralpha, opacity) : filter + " " + opacity;
				}
			};
		}
	
		jQuery.cssHooks.marginRight = addGetHookIf(support.reliableMarginRight, function (elem, computed) {
			if (computed) {
				return swap(elem, { "display": "inline-block" }, curCSS, [elem, "marginRight"]);
			}
		});
	
		jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
			if (computed) {
				return (parseFloat(curCSS(elem, "marginLeft")) || (
	
				// Support: IE<=11+
				// Running getBoundingClientRect on a disconnected node in IE throws an error
				// Support: IE8 only
				// getClientRects() errors on disconnected elems
				jQuery.contains(elem.ownerDocument, elem) ? elem.getBoundingClientRect().left - swap(elem, { marginLeft: 0 }, function () {
					return elem.getBoundingClientRect().left;
				}) : 0)) + "px";
			}
		});
	
		// These hooks are used by animate to expand properties
		jQuery.each({
			margin: "",
			padding: "",
			border: "Width"
		}, function (prefix, suffix) {
			jQuery.cssHooks[prefix + suffix] = {
				expand: function (value) {
					var i = 0,
					    expanded = {},
	
	
					// assumes a single number if not a string
					parts = typeof value === "string" ? value.split(" ") : [value];
	
					for (; i < 4; i++) {
						expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
					}
	
					return expanded;
				}
			};
	
			if (!rmargin.test(prefix)) {
				jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
			}
		});
	
		jQuery.fn.extend({
			css: function (name, value) {
				return access(this, function (elem, name, value) {
					var styles,
					    len,
					    map = {},
					    i = 0;
	
					if (jQuery.isArray(name)) {
						styles = getStyles(elem);
						len = name.length;
	
						for (; i < len; i++) {
							map[name[i]] = jQuery.css(elem, name[i], false, styles);
						}
	
						return map;
					}
	
					return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
				}, name, value, arguments.length > 1);
			},
			show: function () {
				return showHide(this, true);
			},
			hide: function () {
				return showHide(this);
			},
			toggle: function (state) {
				if (typeof state === "boolean") {
					return state ? this.show() : this.hide();
				}
	
				return this.each(function () {
					if (isHidden(this)) {
						jQuery(this).show();
					} else {
						jQuery(this).hide();
					}
				});
			}
		});
	
		function Tween(elem, options, prop, end, easing) {
			return new Tween.prototype.init(elem, options, prop, end, easing);
		}
		jQuery.Tween = Tween;
	
		Tween.prototype = {
			constructor: Tween,
			init: function (elem, options, prop, end, easing, unit) {
				this.elem = elem;
				this.prop = prop;
				this.easing = easing || jQuery.easing._default;
				this.options = options;
				this.start = this.now = this.cur();
				this.end = end;
				this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
			},
			cur: function () {
				var hooks = Tween.propHooks[this.prop];
	
				return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
			},
			run: function (percent) {
				var eased,
				    hooks = Tween.propHooks[this.prop];
	
				if (this.options.duration) {
					this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
				} else {
					this.pos = eased = percent;
				}
				this.now = (this.end - this.start) * eased + this.start;
	
				if (this.options.step) {
					this.options.step.call(this.elem, this.now, this);
				}
	
				if (hooks && hooks.set) {
					hooks.set(this);
				} else {
					Tween.propHooks._default.set(this);
				}
				return this;
			}
		};
	
		Tween.prototype.init.prototype = Tween.prototype;
	
		Tween.propHooks = {
			_default: {
				get: function (tween) {
					var result;
	
					// Use a property on the element directly when it is not a DOM element,
					// or when there is no matching style property that exists.
					if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
						return tween.elem[tween.prop];
					}
	
					// passing an empty string as a 3rd parameter to .css will automatically
					// attempt a parseFloat and fallback to a string if the parse fails
					// so, simple values such as "10px" are parsed to Float.
					// complex values such as "rotate(1rad)" are returned as is.
					result = jQuery.css(tween.elem, tween.prop, "");
	
					// Empty strings, null, undefined and "auto" are converted to 0.
					return !result || result === "auto" ? 0 : result;
				},
				set: function (tween) {
	
					// use step hook for back compat - use cssHook if its there - use .style if its
					// available and use plain properties where available
					if (jQuery.fx.step[tween.prop]) {
						jQuery.fx.step[tween.prop](tween);
					} else if (tween.elem.nodeType === 1 && (tween.elem.style[jQuery.cssProps[tween.prop]] != null || jQuery.cssHooks[tween.prop])) {
						jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
					} else {
						tween.elem[tween.prop] = tween.now;
					}
				}
			}
		};
	
		// Support: IE <=9
		// Panic based approach to setting things on disconnected nodes
	
		Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
			set: function (tween) {
				if (tween.elem.nodeType && tween.elem.parentNode) {
					tween.elem[tween.prop] = tween.now;
				}
			}
		};
	
		jQuery.easing = {
			linear: function (p) {
				return p;
			},
			swing: function (p) {
				return 0.5 - Math.cos(p * Math.PI) / 2;
			},
			_default: "swing"
		};
	
		jQuery.fx = Tween.prototype.init;
	
		// Back Compat <1.8 extension point
		jQuery.fx.step = {};
	
		var fxNow,
		    timerId,
		    rfxtypes = /^(?:toggle|show|hide)$/,
		    rrun = /queueHooks$/;
	
		// Animations created synchronously will run synchronously
		function createFxNow() {
			window.setTimeout(function () {
				fxNow = undefined;
			});
			return fxNow = jQuery.now();
		}
	
		// Generate parameters to create a standard animation
		function genFx(type, includeWidth) {
			var which,
			    attrs = { height: type },
			    i = 0;
	
			// if we include width, step value is 1 to do all cssExpand values,
			// if we don't include width, step value is 2 to skip over Left and Right
			includeWidth = includeWidth ? 1 : 0;
			for (; i < 4; i += 2 - includeWidth) {
				which = cssExpand[i];
				attrs["margin" + which] = attrs["padding" + which] = type;
			}
	
			if (includeWidth) {
				attrs.opacity = attrs.width = type;
			}
	
			return attrs;
		}
	
		function createTween(value, prop, animation) {
			var tween,
			    collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
			    index = 0,
			    length = collection.length;
			for (; index < length; index++) {
				if (tween = collection[index].call(animation, prop, value)) {
	
					// we're done with this property
					return tween;
				}
			}
		}
	
		function defaultPrefilter(elem, props, opts) {
			/* jshint validthis: true */
			var prop,
			    value,
			    toggle,
			    tween,
			    hooks,
			    oldfire,
			    display,
			    checkDisplay,
			    anim = this,
			    orig = {},
			    style = elem.style,
			    hidden = elem.nodeType && isHidden(elem),
			    dataShow = jQuery._data(elem, "fxshow");
	
			// handle queue: false promises
			if (!opts.queue) {
				hooks = jQuery._queueHooks(elem, "fx");
				if (hooks.unqueued == null) {
					hooks.unqueued = 0;
					oldfire = hooks.empty.fire;
					hooks.empty.fire = function () {
						if (!hooks.unqueued) {
							oldfire();
						}
					};
				}
				hooks.unqueued++;
	
				anim.always(function () {
	
					// doing this makes sure that the complete handler will be called
					// before this completes
					anim.always(function () {
						hooks.unqueued--;
						if (!jQuery.queue(elem, "fx").length) {
							hooks.empty.fire();
						}
					});
				});
			}
	
			// height/width overflow pass
			if (elem.nodeType === 1 && ("height" in props || "width" in props)) {
	
				// Make sure that nothing sneaks out
				// Record all 3 overflow attributes because IE does not
				// change the overflow attribute when overflowX and
				// overflowY are set to the same value
				opts.overflow = [style.overflow, style.overflowX, style.overflowY];
	
				// Set display property to inline-block for height/width
				// animations on inline elements that are having width/height animated
				display = jQuery.css(elem, "display");
	
				// Test default display if display is currently "none"
				checkDisplay = display === "none" ? jQuery._data(elem, "olddisplay") || defaultDisplay(elem.nodeName) : display;
	
				if (checkDisplay === "inline" && jQuery.css(elem, "float") === "none") {
	
					// inline-level elements accept inline-block;
					// block-level elements need to be inline with layout
					if (!support.inlineBlockNeedsLayout || defaultDisplay(elem.nodeName) === "inline") {
						style.display = "inline-block";
					} else {
						style.zoom = 1;
					}
				}
			}
	
			if (opts.overflow) {
				style.overflow = "hidden";
				if (!support.shrinkWrapBlocks()) {
					anim.always(function () {
						style.overflow = opts.overflow[0];
						style.overflowX = opts.overflow[1];
						style.overflowY = opts.overflow[2];
					});
				}
			}
	
			// show/hide pass
			for (prop in props) {
				value = props[prop];
				if (rfxtypes.exec(value)) {
					delete props[prop];
					toggle = toggle || value === "toggle";
					if (value === (hidden ? "hide" : "show")) {
	
						// If there is dataShow left over from a stopped hide or show
						// and we are going to proceed with show, we should pretend to be hidden
						if (value === "show" && dataShow && dataShow[prop] !== undefined) {
							hidden = true;
						} else {
							continue;
						}
					}
					orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
	
					// Any non-fx value stops us from restoring the original display value
				} else {
					display = undefined;
				}
			}
	
			if (!jQuery.isEmptyObject(orig)) {
				if (dataShow) {
					if ("hidden" in dataShow) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = jQuery._data(elem, "fxshow", {});
				}
	
				// store state if its toggle - enables .stop().toggle() to "reverse"
				if (toggle) {
					dataShow.hidden = !hidden;
				}
				if (hidden) {
					jQuery(elem).show();
				} else {
					anim.done(function () {
						jQuery(elem).hide();
					});
				}
				anim.done(function () {
					var prop;
					jQuery._removeData(elem, "fxshow");
					for (prop in orig) {
						jQuery.style(elem, prop, orig[prop]);
					}
				});
				for (prop in orig) {
					tween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
	
					if (!(prop in dataShow)) {
						dataShow[prop] = tween.start;
						if (hidden) {
							tween.end = tween.start;
							tween.start = prop === "width" || prop === "height" ? 1 : 0;
						}
					}
				}
	
				// If this is a noop like .hide().hide(), restore an overwritten display value
			} else if ((display === "none" ? defaultDisplay(elem.nodeName) : display) === "inline") {
				style.display = display;
			}
		}
	
		function propFilter(props, specialEasing) {
			var index, name, easing, value, hooks;
	
			// camelCase, specialEasing and expand cssHook pass
			for (index in props) {
				name = jQuery.camelCase(index);
				easing = specialEasing[name];
				value = props[index];
				if (jQuery.isArray(value)) {
					easing = value[1];
					value = props[index] = value[0];
				}
	
				if (index !== name) {
					props[name] = value;
					delete props[index];
				}
	
				hooks = jQuery.cssHooks[name];
				if (hooks && "expand" in hooks) {
					value = hooks.expand(value);
					delete props[name];
	
					// not quite $.extend, this wont overwrite keys already present.
					// also - reusing 'index' from above because we have the correct "name"
					for (index in value) {
						if (!(index in props)) {
							props[index] = value[index];
							specialEasing[index] = easing;
						}
					}
				} else {
					specialEasing[name] = easing;
				}
			}
		}
	
		function Animation(elem, properties, options) {
			var result,
			    stopped,
			    index = 0,
			    length = Animation.prefilters.length,
			    deferred = jQuery.Deferred().always(function () {
	
				// don't match elem in the :animated selector
				delete tick.elem;
			}),
			    tick = function () {
				if (stopped) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
				    remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
	
	
				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				    percent = 1 - temp,
				    index = 0,
				    length = animation.tweens.length;
	
				for (; index < length; index++) {
					animation.tweens[index].run(percent);
				}
	
				deferred.notifyWith(elem, [animation, percent, remaining]);
	
				if (percent < 1 && length) {
					return remaining;
				} else {
					deferred.resolveWith(elem, [animation]);
					return false;
				}
			},
			    animation = deferred.promise({
				elem: elem,
				props: jQuery.extend({}, properties),
				opts: jQuery.extend(true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function (prop, end) {
					var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
					animation.tweens.push(tween);
					return tween;
				},
				stop: function (gotoEnd) {
					var index = 0,
	
	
					// if we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
					if (stopped) {
						return this;
					}
					stopped = true;
					for (; index < length; index++) {
						animation.tweens[index].run(1);
					}
	
					// resolve when we played the last frame
					// otherwise, reject
					if (gotoEnd) {
						deferred.notifyWith(elem, [animation, 1, 0]);
						deferred.resolveWith(elem, [animation, gotoEnd]);
					} else {
						deferred.rejectWith(elem, [animation, gotoEnd]);
					}
					return this;
				}
			}),
			    props = animation.props;
	
			propFilter(props, animation.opts.specialEasing);
	
			for (; index < length; index++) {
				result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
				if (result) {
					if (jQuery.isFunction(result.stop)) {
						jQuery._queueHooks(animation.elem, animation.opts.queue).stop = jQuery.proxy(result.stop, result);
					}
					return result;
				}
			}
	
			jQuery.map(props, createTween, animation);
	
			if (jQuery.isFunction(animation.opts.start)) {
				animation.opts.start.call(elem, animation);
			}
	
			jQuery.fx.timer(jQuery.extend(tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			}));
	
			// attach callbacks from options
			return animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
		}
	
		jQuery.Animation = jQuery.extend(Animation, {
	
			tweeners: {
				"*": [function (prop, value) {
					var tween = this.createTween(prop, value);
					adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
					return tween;
				}]
			},
	
			tweener: function (props, callback) {
				if (jQuery.isFunction(props)) {
					callback = props;
					props = ["*"];
				} else {
					props = props.match(rnotwhite);
				}
	
				var prop,
				    index = 0,
				    length = props.length;
	
				for (; index < length; index++) {
					prop = props[index];
					Animation.tweeners[prop] = Animation.tweeners[prop] || [];
					Animation.tweeners[prop].unshift(callback);
				}
			},
	
			prefilters: [defaultPrefilter],
	
			prefilter: function (callback, prepend) {
				if (prepend) {
					Animation.prefilters.unshift(callback);
				} else {
					Animation.prefilters.push(callback);
				}
			}
		});
	
		jQuery.speed = function (speed, easing, fn) {
			var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
				complete: fn || !fn && easing || jQuery.isFunction(speed) && speed,
				duration: speed,
				easing: fn && easing || easing && !jQuery.isFunction(easing) && easing
			};
	
			opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration : opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[opt.duration] : jQuery.fx.speeds._default;
	
			// normalize opt.queue - true/undefined/null -> "fx"
			if (opt.queue == null || opt.queue === true) {
				opt.queue = "fx";
			}
	
			// Queueing
			opt.old = opt.complete;
	
			opt.complete = function () {
				if (jQuery.isFunction(opt.old)) {
					opt.old.call(this);
				}
	
				if (opt.queue) {
					jQuery.dequeue(this, opt.queue);
				}
			};
	
			return opt;
		};
	
		jQuery.fn.extend({
			fadeTo: function (speed, to, easing, callback) {
	
				// show any hidden elements after setting opacity to 0
				return this.filter(isHidden).css("opacity", 0).show()
	
				// animate to the value specified
				.end().animate({ opacity: to }, speed, easing, callback);
			},
			animate: function (prop, speed, easing, callback) {
				var empty = jQuery.isEmptyObject(prop),
				    optall = jQuery.speed(speed, easing, callback),
				    doAnimation = function () {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation(this, jQuery.extend({}, prop), optall);
	
					// Empty animations, or finishing resolves immediately
					if (empty || jQuery._data(this, "finish")) {
						anim.stop(true);
					}
				};
				doAnimation.finish = doAnimation;
	
				return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
			},
			stop: function (type, clearQueue, gotoEnd) {
				var stopQueue = function (hooks) {
					var stop = hooks.stop;
					delete hooks.stop;
					stop(gotoEnd);
				};
	
				if (typeof type !== "string") {
					gotoEnd = clearQueue;
					clearQueue = type;
					type = undefined;
				}
				if (clearQueue && type !== false) {
					this.queue(type || "fx", []);
				}
	
				return this.each(function () {
					var dequeue = true,
					    index = type != null && type + "queueHooks",
					    timers = jQuery.timers,
					    data = jQuery._data(this);
	
					if (index) {
						if (data[index] && data[index].stop) {
							stopQueue(data[index]);
						}
					} else {
						for (index in data) {
							if (data[index] && data[index].stop && rrun.test(index)) {
								stopQueue(data[index]);
							}
						}
					}
	
					for (index = timers.length; index--;) {
						if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
	
							timers[index].anim.stop(gotoEnd);
							dequeue = false;
							timers.splice(index, 1);
						}
					}
	
					// start the next in the queue if the last step wasn't forced
					// timers currently will call their complete callbacks, which will dequeue
					// but only if they were gotoEnd
					if (dequeue || !gotoEnd) {
						jQuery.dequeue(this, type);
					}
				});
			},
			finish: function (type) {
				if (type !== false) {
					type = type || "fx";
				}
				return this.each(function () {
					var index,
					    data = jQuery._data(this),
					    queue = data[type + "queue"],
					    hooks = data[type + "queueHooks"],
					    timers = jQuery.timers,
					    length = queue ? queue.length : 0;
	
					// enable finishing flag on private data
					data.finish = true;
	
					// empty the queue first
					jQuery.queue(this, type, []);
	
					if (hooks && hooks.stop) {
						hooks.stop.call(this, true);
					}
	
					// look for any active animations, and finish them
					for (index = timers.length; index--;) {
						if (timers[index].elem === this && timers[index].queue === type) {
							timers[index].anim.stop(true);
							timers.splice(index, 1);
						}
					}
	
					// look for any animations in the old queue and finish them
					for (index = 0; index < length; index++) {
						if (queue[index] && queue[index].finish) {
							queue[index].finish.call(this);
						}
					}
	
					// turn off finishing flag
					delete data.finish;
				});
			}
		});
	
		jQuery.each(["toggle", "show", "hide"], function (i, name) {
			var cssFn = jQuery.fn[name];
			jQuery.fn[name] = function (speed, easing, callback) {
				return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
			};
		});
	
		// Generate shortcuts for custom animations
		jQuery.each({
			slideDown: genFx("show"),
			slideUp: genFx("hide"),
			slideToggle: genFx("toggle"),
			fadeIn: { opacity: "show" },
			fadeOut: { opacity: "hide" },
			fadeToggle: { opacity: "toggle" }
		}, function (name, props) {
			jQuery.fn[name] = function (speed, easing, callback) {
				return this.animate(props, speed, easing, callback);
			};
		});
	
		jQuery.timers = [];
		jQuery.fx.tick = function () {
			var timer,
			    timers = jQuery.timers,
			    i = 0;
	
			fxNow = jQuery.now();
	
			for (; i < timers.length; i++) {
				timer = timers[i];
	
				// Checks the timer has not already been removed
				if (!timer() && timers[i] === timer) {
					timers.splice(i--, 1);
				}
			}
	
			if (!timers.length) {
				jQuery.fx.stop();
			}
			fxNow = undefined;
		};
	
		jQuery.fx.timer = function (timer) {
			jQuery.timers.push(timer);
			if (timer()) {
				jQuery.fx.start();
			} else {
				jQuery.timers.pop();
			}
		};
	
		jQuery.fx.interval = 13;
	
		jQuery.fx.start = function () {
			if (!timerId) {
				timerId = window.setInterval(jQuery.fx.tick, jQuery.fx.interval);
			}
		};
	
		jQuery.fx.stop = function () {
			window.clearInterval(timerId);
			timerId = null;
		};
	
		jQuery.fx.speeds = {
			slow: 600,
			fast: 200,
	
			// Default speed
			_default: 400
		};
	
		// Based off of the plugin by Clint Helfers, with permission.
		// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
		jQuery.fn.delay = function (time, type) {
			time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
			type = type || "fx";
	
			return this.queue(type, function (next, hooks) {
				var timeout = window.setTimeout(next, time);
				hooks.stop = function () {
					window.clearTimeout(timeout);
				};
			});
		};
	
		(function () {
			var a,
			    input = document.createElement("input"),
			    div = document.createElement("div"),
			    select = document.createElement("select"),
			    opt = select.appendChild(document.createElement("option"));
	
			// Setup
			div = document.createElement("div");
			div.setAttribute("className", "t");
			div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
			a = div.getElementsByTagName("a")[0];
	
			// Support: Windows Web Apps (WWA)
			// `type` must use .setAttribute for WWA (#14901)
			input.setAttribute("type", "checkbox");
			div.appendChild(input);
	
			a = div.getElementsByTagName("a")[0];
	
			// First batch of tests.
			a.style.cssText = "top:1px";
	
			// Test setAttribute on camelCase class.
			// If it works, we need attrFixes when doing get/setAttribute (ie6/7)
			support.getSetAttribute = div.className !== "t";
	
			// Get the style information from getAttribute
			// (IE uses .cssText instead)
			support.style = /top/.test(a.getAttribute("style"));
	
			// Make sure that URLs aren't manipulated
			// (IE normalizes it by default)
			support.hrefNormalized = a.getAttribute("href") === "/a";
	
			// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
			support.checkOn = !!input.value;
	
			// Make sure that a selected-by-default option has a working selected property.
			// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
			support.optSelected = opt.selected;
	
			// Tests for enctype support on a form (#6743)
			support.enctype = !!document.createElement("form").enctype;
	
			// Make sure that the options inside disabled selects aren't marked as disabled
			// (WebKit marks them as disabled)
			select.disabled = true;
			support.optDisabled = !opt.disabled;
	
			// Support: IE8 only
			// Check if we can trust getAttribute("value")
			input = document.createElement("input");
			input.setAttribute("value", "");
			support.input = input.getAttribute("value") === "";
	
			// Check if an input maintains its value after becoming a radio
			input.value = "t";
			input.setAttribute("type", "radio");
			support.radioValue = input.value === "t";
		})();
	
		var rreturn = /\r/g,
		    rspaces = /[\x20\t\r\n\f]+/g;
	
		jQuery.fn.extend({
			val: function (value) {
				var hooks,
				    ret,
				    isFunction,
				    elem = this[0];
	
				if (!arguments.length) {
					if (elem) {
						hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
	
						if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
							return ret;
						}
	
						ret = elem.value;
	
						return typeof ret === "string" ?
	
						// handle most common string cases
						ret.replace(rreturn, "") :
	
						// handle cases where value is null/undef or number
						ret == null ? "" : ret;
					}
	
					return;
				}
	
				isFunction = jQuery.isFunction(value);
	
				return this.each(function (i) {
					var val;
	
					if (this.nodeType !== 1) {
						return;
					}
	
					if (isFunction) {
						val = value.call(this, i, jQuery(this).val());
					} else {
						val = value;
					}
	
					// Treat null/undefined as ""; convert numbers to string
					if (val == null) {
						val = "";
					} else if (typeof val === "number") {
						val += "";
					} else if (jQuery.isArray(val)) {
						val = jQuery.map(val, function (value) {
							return value == null ? "" : value + "";
						});
					}
	
					hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
	
					// If set returns undefined, fall back to normal setting
					if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
						this.value = val;
					}
				});
			}
		});
	
		jQuery.extend({
			valHooks: {
				option: {
					get: function (elem) {
						var val = jQuery.find.attr(elem, "value");
						return val != null ? val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim(jQuery.text(elem)).replace(rspaces, " ");
					}
				},
				select: {
					get: function (elem) {
						var value,
						    option,
						    options = elem.options,
						    index = elem.selectedIndex,
						    one = elem.type === "select-one" || index < 0,
						    values = one ? null : [],
						    max = one ? index + 1 : options.length,
						    i = index < 0 ? max : one ? index : 0;
	
						// Loop through all the selected options
						for (; i < max; i++) {
							option = options[i];
	
							// oldIE doesn't update selected after form reset (#2551)
							if ((option.selected || i === index) && (
	
							// Don't return options that are disabled or in a disabled optgroup
							support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null) && (!option.parentNode.disabled || !jQuery.nodeName(option.parentNode, "optgroup"))) {
	
								// Get the specific value for the option
								value = jQuery(option).val();
	
								// We don't need an array for one selects
								if (one) {
									return value;
								}
	
								// Multi-Selects return an array
								values.push(value);
							}
						}
	
						return values;
					},
	
					set: function (elem, value) {
						var optionSet,
						    option,
						    options = elem.options,
						    values = jQuery.makeArray(value),
						    i = options.length;
	
						while (i--) {
							option = options[i];
	
							if (jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
	
								// Support: IE6
								// When new option element is added to select box we need to
								// force reflow of newly added node in order to workaround delay
								// of initialization properties
								try {
									option.selected = optionSet = true;
								} catch (_) {
	
									// Will be executed only in IE6
									option.scrollHeight;
								}
							} else {
								option.selected = false;
							}
						}
	
						// Force browsers to behave consistently when non-matching value is set
						if (!optionSet) {
							elem.selectedIndex = -1;
						}
	
						return options;
					}
				}
			}
		});
	
		// Radios and checkboxes getter/setter
		jQuery.each(["radio", "checkbox"], function () {
			jQuery.valHooks[this] = {
				set: function (elem, value) {
					if (jQuery.isArray(value)) {
						return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
					}
				}
			};
			if (!support.checkOn) {
				jQuery.valHooks[this].get = function (elem) {
					return elem.getAttribute("value") === null ? "on" : elem.value;
				};
			}
		});
	
		var nodeHook,
		    boolHook,
		    attrHandle = jQuery.expr.attrHandle,
		    ruseDefault = /^(?:checked|selected)$/i,
		    getSetAttribute = support.getSetAttribute,
		    getSetInput = support.input;
	
		jQuery.fn.extend({
			attr: function (name, value) {
				return access(this, jQuery.attr, name, value, arguments.length > 1);
			},
	
			removeAttr: function (name) {
				return this.each(function () {
					jQuery.removeAttr(this, name);
				});
			}
		});
	
		jQuery.extend({
			attr: function (elem, name, value) {
				var ret,
				    hooks,
				    nType = elem.nodeType;
	
				// Don't get/set attributes on text, comment and attribute nodes
				if (nType === 3 || nType === 8 || nType === 2) {
					return;
				}
	
				// Fallback to prop when attributes are not supported
				if (typeof elem.getAttribute === "undefined") {
					return jQuery.prop(elem, name, value);
				}
	
				// All attributes are lowercase
				// Grab necessary hook if one is defined
				if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
					name = name.toLowerCase();
					hooks = jQuery.attrHooks[name] || (jQuery.expr.match.bool.test(name) ? boolHook : nodeHook);
				}
	
				if (value !== undefined) {
					if (value === null) {
						jQuery.removeAttr(elem, name);
						return;
					}
	
					if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
						return ret;
					}
	
					elem.setAttribute(name, value + "");
					return value;
				}
	
				if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
					return ret;
				}
	
				ret = jQuery.find.attr(elem, name);
	
				// Non-existent attributes return null, we normalize to undefined
				return ret == null ? undefined : ret;
			},
	
			attrHooks: {
				type: {
					set: function (elem, value) {
						if (!support.radioValue && value === "radio" && jQuery.nodeName(elem, "input")) {
	
							// Setting the type on a radio button after the value resets the value in IE8-9
							// Reset value to default in case type is set after value during creation
							var val = elem.value;
							elem.setAttribute("type", value);
							if (val) {
								elem.value = val;
							}
							return value;
						}
					}
				}
			},
	
			removeAttr: function (elem, value) {
				var name,
				    propName,
				    i = 0,
				    attrNames = value && value.match(rnotwhite);
	
				if (attrNames && elem.nodeType === 1) {
					while (name = attrNames[i++]) {
						propName = jQuery.propFix[name] || name;
	
						// Boolean attributes get special treatment (#10870)
						if (jQuery.expr.match.bool.test(name)) {
	
							// Set corresponding property to false
							if (getSetInput && getSetAttribute || !ruseDefault.test(name)) {
								elem[propName] = false;
	
								// Support: IE<9
								// Also clear defaultChecked/defaultSelected (if appropriate)
							} else {
								elem[jQuery.camelCase("default-" + name)] = elem[propName] = false;
							}
	
							// See #9699 for explanation of this approach (setting first, then removal)
						} else {
							jQuery.attr(elem, name, "");
						}
	
						elem.removeAttribute(getSetAttribute ? name : propName);
					}
				}
			}
		});
	
		// Hooks for boolean attributes
		boolHook = {
			set: function (elem, value, name) {
				if (value === false) {
	
					// Remove boolean attributes when set to false
					jQuery.removeAttr(elem, name);
				} else if (getSetInput && getSetAttribute || !ruseDefault.test(name)) {
	
					// IE<8 needs the *property* name
					elem.setAttribute(!getSetAttribute && jQuery.propFix[name] || name, name);
				} else {
	
					// Support: IE<9
					// Use defaultChecked and defaultSelected for oldIE
					elem[jQuery.camelCase("default-" + name)] = elem[name] = true;
				}
				return name;
			}
		};
	
		jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (i, name) {
			var getter = attrHandle[name] || jQuery.find.attr;
	
			if (getSetInput && getSetAttribute || !ruseDefault.test(name)) {
				attrHandle[name] = function (elem, name, isXML) {
					var ret, handle;
					if (!isXML) {
	
						// Avoid an infinite loop by temporarily removing this function from the getter
						handle = attrHandle[name];
						attrHandle[name] = ret;
						ret = getter(elem, name, isXML) != null ? name.toLowerCase() : null;
						attrHandle[name] = handle;
					}
					return ret;
				};
			} else {
				attrHandle[name] = function (elem, name, isXML) {
					if (!isXML) {
						return elem[jQuery.camelCase("default-" + name)] ? name.toLowerCase() : null;
					}
				};
			}
		});
	
		// fix oldIE attroperties
		if (!getSetInput || !getSetAttribute) {
			jQuery.attrHooks.value = {
				set: function (elem, value, name) {
					if (jQuery.nodeName(elem, "input")) {
	
						// Does not return so that setAttribute is also used
						elem.defaultValue = value;
					} else {
	
						// Use nodeHook if defined (#1954); otherwise setAttribute is fine
						return nodeHook && nodeHook.set(elem, value, name);
					}
				}
			};
		}
	
		// IE6/7 do not support getting/setting some attributes with get/setAttribute
		if (!getSetAttribute) {
	
			// Use this for any attribute in IE6/7
			// This fixes almost every IE6/7 issue
			nodeHook = {
				set: function (elem, value, name) {
	
					// Set the existing or create a new attribute node
					var ret = elem.getAttributeNode(name);
					if (!ret) {
						elem.setAttributeNode(ret = elem.ownerDocument.createAttribute(name));
					}
	
					ret.value = value += "";
	
					// Break association with cloned elements by also using setAttribute (#9646)
					if (name === "value" || value === elem.getAttribute(name)) {
						return value;
					}
				}
			};
	
			// Some attributes are constructed with empty-string values when not defined
			attrHandle.id = attrHandle.name = attrHandle.coords = function (elem, name, isXML) {
				var ret;
				if (!isXML) {
					return (ret = elem.getAttributeNode(name)) && ret.value !== "" ? ret.value : null;
				}
			};
	
			// Fixing value retrieval on a button requires this module
			jQuery.valHooks.button = {
				get: function (elem, name) {
					var ret = elem.getAttributeNode(name);
					if (ret && ret.specified) {
						return ret.value;
					}
				},
				set: nodeHook.set
			};
	
			// Set contenteditable to false on removals(#10429)
			// Setting to empty string throws an error as an invalid value
			jQuery.attrHooks.contenteditable = {
				set: function (elem, value, name) {
					nodeHook.set(elem, value === "" ? false : value, name);
				}
			};
	
			// Set width and height to auto instead of 0 on empty string( Bug #8150 )
			// This is for removals
			jQuery.each(["width", "height"], function (i, name) {
				jQuery.attrHooks[name] = {
					set: function (elem, value) {
						if (value === "") {
							elem.setAttribute(name, "auto");
							return value;
						}
					}
				};
			});
		}
	
		if (!support.style) {
			jQuery.attrHooks.style = {
				get: function (elem) {
	
					// Return undefined in the case of empty string
					// Note: IE uppercases css property names, but if we were to .toLowerCase()
					// .cssText, that would destroy case sensitivity in URL's, like in "background"
					return elem.style.cssText || undefined;
				},
				set: function (elem, value) {
					return elem.style.cssText = value + "";
				}
			};
		}
	
		var rfocusable = /^(?:input|select|textarea|button|object)$/i,
		    rclickable = /^(?:a|area)$/i;
	
		jQuery.fn.extend({
			prop: function (name, value) {
				return access(this, jQuery.prop, name, value, arguments.length > 1);
			},
	
			removeProp: function (name) {
				name = jQuery.propFix[name] || name;
				return this.each(function () {
	
					// try/catch handles cases where IE balks (such as removing a property on window)
					try {
						this[name] = undefined;
						delete this[name];
					} catch (e) {}
				});
			}
		});
	
		jQuery.extend({
			prop: function (elem, name, value) {
				var ret,
				    hooks,
				    nType = elem.nodeType;
	
				// Don't get/set properties on text, comment and attribute nodes
				if (nType === 3 || nType === 8 || nType === 2) {
					return;
				}
	
				if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
	
					// Fix name and attach hooks
					name = jQuery.propFix[name] || name;
					hooks = jQuery.propHooks[name];
				}
	
				if (value !== undefined) {
					if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
						return ret;
					}
	
					return elem[name] = value;
				}
	
				if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
					return ret;
				}
	
				return elem[name];
			},
	
			propHooks: {
				tabIndex: {
					get: function (elem) {
	
						// elem.tabIndex doesn't always return the
						// correct value when it hasn't been explicitly set
						// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
						// Use proper attribute retrieval(#12072)
						var tabindex = jQuery.find.attr(elem, "tabindex");
	
						return tabindex ? parseInt(tabindex, 10) : rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href ? 0 : -1;
					}
				}
			},
	
			propFix: {
				"for": "htmlFor",
				"class": "className"
			}
		});
	
		// Some attributes require a special call on IE
		// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
		if (!support.hrefNormalized) {
	
			// href/src property should get the full normalized URL (#10299/#12915)
			jQuery.each(["href", "src"], function (i, name) {
				jQuery.propHooks[name] = {
					get: function (elem) {
						return elem.getAttribute(name, 4);
					}
				};
			});
		}
	
		// Support: Safari, IE9+
		// Accessing the selectedIndex property
		// forces the browser to respect setting selected
		// on the option
		// The getter ensures a default option is selected
		// when in an optgroup
		if (!support.optSelected) {
			jQuery.propHooks.selected = {
				get: function (elem) {
					var parent = elem.parentNode;
	
					if (parent) {
						parent.selectedIndex;
	
						// Make sure that it also works with optgroups, see #5701
						if (parent.parentNode) {
							parent.parentNode.selectedIndex;
						}
					}
					return null;
				},
				set: function (elem) {
					var parent = elem.parentNode;
					if (parent) {
						parent.selectedIndex;
	
						if (parent.parentNode) {
							parent.parentNode.selectedIndex;
						}
					}
				}
			};
		}
	
		jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
			jQuery.propFix[this.toLowerCase()] = this;
		});
	
		// IE6/7 call enctype encoding
		if (!support.enctype) {
			jQuery.propFix.enctype = "encoding";
		}
	
		var rclass = /[\t\r\n\f]/g;
	
		function getClass(elem) {
			return jQuery.attr(elem, "class") || "";
		}
	
		jQuery.fn.extend({
			addClass: function (value) {
				var classes,
				    elem,
				    cur,
				    curValue,
				    clazz,
				    j,
				    finalValue,
				    i = 0;
	
				if (jQuery.isFunction(value)) {
					return this.each(function (j) {
						jQuery(this).addClass(value.call(this, j, getClass(this)));
					});
				}
	
				if (typeof value === "string" && value) {
					classes = value.match(rnotwhite) || [];
	
					while (elem = this[i++]) {
						curValue = getClass(elem);
						cur = elem.nodeType === 1 && (" " + curValue + " ").replace(rclass, " ");
	
						if (cur) {
							j = 0;
							while (clazz = classes[j++]) {
								if (cur.indexOf(" " + clazz + " ") < 0) {
									cur += clazz + " ";
								}
							}
	
							// only assign if different to avoid unneeded rendering.
							finalValue = jQuery.trim(cur);
							if (curValue !== finalValue) {
								jQuery.attr(elem, "class", finalValue);
							}
						}
					}
				}
	
				return this;
			},
	
			removeClass: function (value) {
				var classes,
				    elem,
				    cur,
				    curValue,
				    clazz,
				    j,
				    finalValue,
				    i = 0;
	
				if (jQuery.isFunction(value)) {
					return this.each(function (j) {
						jQuery(this).removeClass(value.call(this, j, getClass(this)));
					});
				}
	
				if (!arguments.length) {
					return this.attr("class", "");
				}
	
				if (typeof value === "string" && value) {
					classes = value.match(rnotwhite) || [];
	
					while (elem = this[i++]) {
						curValue = getClass(elem);
	
						// This expression is here for better compressibility (see addClass)
						cur = elem.nodeType === 1 && (" " + curValue + " ").replace(rclass, " ");
	
						if (cur) {
							j = 0;
							while (clazz = classes[j++]) {
	
								// Remove *all* instances
								while (cur.indexOf(" " + clazz + " ") > -1) {
									cur = cur.replace(" " + clazz + " ", " ");
								}
							}
	
							// Only assign if different to avoid unneeded rendering.
							finalValue = jQuery.trim(cur);
							if (curValue !== finalValue) {
								jQuery.attr(elem, "class", finalValue);
							}
						}
					}
				}
	
				return this;
			},
	
			toggleClass: function (value, stateVal) {
				var type = typeof value;
	
				if (typeof stateVal === "boolean" && type === "string") {
					return stateVal ? this.addClass(value) : this.removeClass(value);
				}
	
				if (jQuery.isFunction(value)) {
					return this.each(function (i) {
						jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
					});
				}
	
				return this.each(function () {
					var className, i, self, classNames;
	
					if (type === "string") {
	
						// Toggle individual class names
						i = 0;
						self = jQuery(this);
						classNames = value.match(rnotwhite) || [];
	
						while (className = classNames[i++]) {
	
							// Check each className given, space separated list
							if (self.hasClass(className)) {
								self.removeClass(className);
							} else {
								self.addClass(className);
							}
						}
	
						// Toggle whole class name
					} else if (value === undefined || type === "boolean") {
						className = getClass(this);
						if (className) {
	
							// store className if set
							jQuery._data(this, "__className__", className);
						}
	
						// If the element has a class name or if we're passed "false",
						// then remove the whole classname (if there was one, the above saved it).
						// Otherwise bring back whatever was previously saved (if anything),
						// falling back to the empty string if nothing was stored.
						jQuery.attr(this, "class", className || value === false ? "" : jQuery._data(this, "__className__") || "");
					}
				});
			},
	
			hasClass: function (selector) {
				var className,
				    elem,
				    i = 0;
	
				className = " " + selector + " ";
				while (elem = this[i++]) {
					if (elem.nodeType === 1 && (" " + getClass(elem) + " ").replace(rclass, " ").indexOf(className) > -1) {
						return true;
					}
				}
	
				return false;
			}
		});
	
		// Return jQuery for attributes-only inclusion
	
	
		jQuery.each(("blur focus focusin focusout load resize scroll unload click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup error contextmenu").split(" "), function (i, name) {
	
			// Handle event binding
			jQuery.fn[name] = function (data, fn) {
				return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
			};
		});
	
		jQuery.fn.extend({
			hover: function (fnOver, fnOut) {
				return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
			}
		});
	
		var location = window.location;
	
		var nonce = jQuery.now();
	
		var rquery = /\?/;
	
		var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
	
		jQuery.parseJSON = function (data) {
	
			// Attempt to parse using the native JSON parser first
			if (window.JSON && window.JSON.parse) {
	
				// Support: Android 2.3
				// Workaround failure to string-cast null input
				return window.JSON.parse(data + "");
			}
	
			var requireNonComma,
			    depth = null,
			    str = jQuery.trim(data + "");
	
			// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
			// after removing valid tokens
			return str && !jQuery.trim(str.replace(rvalidtokens, function (token, comma, open, close) {
	
				// Force termination if we see a misplaced comma
				if (requireNonComma && comma) {
					depth = 0;
				}
	
				// Perform no more replacements after returning to outermost depth
				if (depth === 0) {
					return token;
				}
	
				// Commas must not follow "[", "{", or ","
				requireNonComma = open || comma;
	
				// Determine new depth
				// array/object open ("[" or "{"): depth += true - false (increment)
				// array/object close ("]" or "}"): depth += false - true (decrement)
				// other cases ("," or primitive): depth += true - true (numeric cast)
				depth += !close - !open;
	
				// Remove this token
				return "";
			})) ? Function("return " + str)() : jQuery.error("Invalid JSON: " + data);
		};
	
		// Cross-browser xml parsing
		jQuery.parseXML = function (data) {
			var xml, tmp;
			if (!data || typeof data !== "string") {
				return null;
			}
			try {
				if (window.DOMParser) {
					// Standard
					tmp = new window.DOMParser();
					xml = tmp.parseFromString(data, "text/xml");
				} else {
					// IE
					xml = new window.ActiveXObject("Microsoft.XMLDOM");
					xml.async = "false";
					xml.loadXML(data);
				}
			} catch (e) {
				xml = undefined;
			}
			if (!xml || !xml.documentElement || xml.getElementsByTagName("parsererror").length) {
				jQuery.error("Invalid XML: " + data);
			}
			return xml;
		};
	
		var rhash = /#.*$/,
		    rts = /([?&])_=[^&]*/,
	
	
		// IE leaves an \r character at EOL
		rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,
	
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		    rnoContent = /^(?:GET|HEAD)$/,
		    rprotocol = /^\/\//,
		    rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	
	
		/* Prefilters
	  * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	  * 2) These are called:
	  *    - BEFORE asking for a transport
	  *    - AFTER param serialization (s.data is a string if s.processData is true)
	  * 3) key is the dataType
	  * 4) the catchall symbol "*" can be used
	  * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	  */
		prefilters = {},
	
	
		/* Transports bindings
	  * 1) key is the dataType
	  * 2) the catchall symbol "*" can be used
	  * 3) selection will start with transport dataType and THEN go to "*" if needed
	  */
		transports = {},
	
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat("*"),
	
	
		// Document location
		ajaxLocation = location.href,
	
	
		// Segment location into parts
		ajaxLocParts = rurl.exec(ajaxLocation.toLowerCase()) || [];
	
		// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
		function addToPrefiltersOrTransports(structure) {
	
			// dataTypeExpression is optional and defaults to "*"
			return function (dataTypeExpression, func) {
	
				if (typeof dataTypeExpression !== "string") {
					func = dataTypeExpression;
					dataTypeExpression = "*";
				}
	
				var dataType,
				    i = 0,
				    dataTypes = dataTypeExpression.toLowerCase().match(rnotwhite) || [];
	
				if (jQuery.isFunction(func)) {
	
					// For each dataType in the dataTypeExpression
					while (dataType = dataTypes[i++]) {
	
						// Prepend if requested
						if (dataType.charAt(0) === "+") {
							dataType = dataType.slice(1) || "*";
							(structure[dataType] = structure[dataType] || []).unshift(func);
	
							// Otherwise append
						} else {
							(structure[dataType] = structure[dataType] || []).push(func);
						}
					}
				}
			};
		}
	
		// Base inspection function for prefilters and transports
		function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
	
			var inspected = {},
			    seekingTransport = structure === transports;
	
			function inspect(dataType) {
				var selected;
				inspected[dataType] = true;
				jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
					var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
					if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
	
						options.dataTypes.unshift(dataTypeOrTransport);
						inspect(dataTypeOrTransport);
						return false;
					} else if (seekingTransport) {
						return !(selected = dataTypeOrTransport);
					}
				});
				return selected;
			}
	
			return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
		}
	
		// A special extend for ajax options
		// that takes "flat" options (not to be deep extended)
		// Fixes #9887
		function ajaxExtend(target, src) {
			var deep,
			    key,
			    flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
			for (key in src) {
				if (src[key] !== undefined) {
					(flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
				}
			}
			if (deep) {
				jQuery.extend(true, target, deep);
			}
	
			return target;
		}
	
		/* Handles responses to an ajax request:
	  * - finds the right dataType (mediates between content-type and expected dataType)
	  * - returns the corresponding response
	  */
		function ajaxHandleResponses(s, jqXHR, responses) {
			var firstDataType,
			    ct,
			    finalDataType,
			    type,
			    contents = s.contents,
			    dataTypes = s.dataTypes;
	
			// Remove auto dataType and get content-type in the process
			while (dataTypes[0] === "*") {
				dataTypes.shift();
				if (ct === undefined) {
					ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
				}
			}
	
			// Check if we're dealing with a known content-type
			if (ct) {
				for (type in contents) {
					if (contents[type] && contents[type].test(ct)) {
						dataTypes.unshift(type);
						break;
					}
				}
			}
	
			// Check to see if we have a response for the expected dataType
			if (dataTypes[0] in responses) {
				finalDataType = dataTypes[0];
			} else {
	
				// Try convertible dataTypes
				for (type in responses) {
					if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
						finalDataType = type;
						break;
					}
					if (!firstDataType) {
						firstDataType = type;
					}
				}
	
				// Or just use first one
				finalDataType = finalDataType || firstDataType;
			}
	
			// If we found a dataType
			// We add the dataType to the list if needed
			// and return the corresponding response
			if (finalDataType) {
				if (finalDataType !== dataTypes[0]) {
					dataTypes.unshift(finalDataType);
				}
				return responses[finalDataType];
			}
		}
	
		/* Chain conversions given the request and the original response
	  * Also sets the responseXXX fields on the jqXHR instance
	  */
		function ajaxConvert(s, response, jqXHR, isSuccess) {
			var conv2,
			    current,
			    conv,
			    tmp,
			    prev,
			    converters = {},
	
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
			// Create converters map with lowercased keys
			if (dataTypes[1]) {
				for (conv in s.converters) {
					converters[conv.toLowerCase()] = s.converters[conv];
				}
			}
	
			current = dataTypes.shift();
	
			// Convert to each sequential dataType
			while (current) {
	
				if (s.responseFields[current]) {
					jqXHR[s.responseFields[current]] = response;
				}
	
				// Apply the dataFilter if provided
				if (!prev && isSuccess && s.dataFilter) {
					response = s.dataFilter(response, s.dataType);
				}
	
				prev = current;
				current = dataTypes.shift();
	
				if (current) {
	
					// There's only work to do if current dataType is non-auto
					if (current === "*") {
	
						current = prev;
	
						// Convert response if prev dataType is non-auto and differs from current
					} else if (prev !== "*" && prev !== current) {
	
						// Seek a direct converter
						conv = converters[prev + " " + current] || converters["* " + current];
	
						// If none found, seek a pair
						if (!conv) {
							for (conv2 in converters) {
	
								// If conv2 outputs current
								tmp = conv2.split(" ");
								if (tmp[1] === current) {
	
									// If prev can be converted to accepted input
									conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
									if (conv) {
	
										// Condense equivalence converters
										if (conv === true) {
											conv = converters[conv2];
	
											// Otherwise, insert the intermediate dataType
										} else if (converters[conv2] !== true) {
											current = tmp[0];
											dataTypes.unshift(tmp[1]);
										}
										break;
									}
								}
							}
						}
	
						// Apply converter (if not an equivalence)
						if (conv !== true) {
	
							// Unless errors are allowed to bubble, catch and return them
							if (conv && s["throws"]) {
								// jscs:ignore requireDotNotation
								response = conv(response);
							} else {
								try {
									response = conv(response);
								} catch (e) {
									return {
										state: "parsererror",
										error: conv ? e : "No conversion from " + prev + " to " + current
									};
								}
							}
						}
					}
				}
			}
	
			return { state: "success", data: response };
		}
	
		jQuery.extend({
	
			// Counter for holding the number of active queries
			active: 0,
	
			// Last-Modified header cache for next request
			lastModified: {},
			etag: {},
	
			ajaxSettings: {
				url: ajaxLocation,
				type: "GET",
				isLocal: rlocalProtocol.test(ajaxLocParts[1]),
				global: true,
				processData: true,
				async: true,
				contentType: "application/x-www-form-urlencoded; charset=UTF-8",
				/*
	   timeout: 0,
	   data: null,
	   dataType: null,
	   username: null,
	   password: null,
	   cache: null,
	   throws: false,
	   traditional: false,
	   headers: {},
	   */
	
				accepts: {
					"*": allTypes,
					text: "text/plain",
					html: "text/html",
					xml: "application/xml, text/xml",
					json: "application/json, text/javascript"
				},
	
				contents: {
					xml: /\bxml\b/,
					html: /\bhtml/,
					json: /\bjson\b/
				},
	
				responseFields: {
					xml: "responseXML",
					text: "responseText",
					json: "responseJSON"
				},
	
				// Data converters
				// Keys separate source (or catchall "*") and destination types with a single space
				converters: {
	
					// Convert anything to text
					"* text": String,
	
					// Text to html (true = no transformation)
					"text html": true,
	
					// Evaluate text as a json expression
					"text json": jQuery.parseJSON,
	
					// Parse text as xml
					"text xml": jQuery.parseXML
				},
	
				// For options that shouldn't be deep extended:
				// you can add your own custom options here if
				// and when you create one that shouldn't be
				// deep extended (see ajaxExtend)
				flatOptions: {
					url: true,
					context: true
				}
			},
	
			// Creates a full fledged settings object into target
			// with both ajaxSettings and settings fields.
			// If target is omitted, writes into ajaxSettings.
			ajaxSetup: function (target, settings) {
				return settings ?
	
				// Building a settings object
				ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :
	
				// Extending ajaxSettings
				ajaxExtend(jQuery.ajaxSettings, target);
			},
	
			ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
			ajaxTransport: addToPrefiltersOrTransports(transports),
	
			// Main method
			ajax: function (url, options) {
	
				// If url is an object, simulate pre-1.5 signature
				if (typeof url === "object") {
					options = url;
					url = undefined;
				}
	
				// Force options to be an object
				options = options || {};
	
				var
	
				// Cross-domain detection vars
				parts,
	
	
				// Loop variable
				i,
	
	
				// URL without anti-cache param
				cacheURL,
	
	
				// Response headers as string
				responseHeadersString,
	
	
				// timeout handle
				timeoutTimer,
	
	
				// To know if global events are to be dispatched
				fireGlobals,
				    transport,
	
	
				// Response headers
				responseHeaders,
	
	
				// Create the final options object
				s = jQuery.ajaxSetup({}, options),
	
	
				// Callbacks context
				callbackContext = s.context || s,
	
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,
	
	
				// Deferreds
				deferred = jQuery.Deferred(),
				    completeDeferred = jQuery.Callbacks("once memory"),
	
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				    requestHeadersNames = {},
	
	
				// The jqXHR state
				state = 0,
	
	
				// Default abort message
				strAbort = "canceled",
	
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function (key) {
						var match;
						if (state === 2) {
							if (!responseHeaders) {
								responseHeaders = {};
								while (match = rheaders.exec(responseHeadersString)) {
									responseHeaders[match[1].toLowerCase()] = match[2];
								}
							}
							match = responseHeaders[key.toLowerCase()];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function () {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function (name, value) {
						var lname = name.toLowerCase();
						if (!state) {
							name = requestHeadersNames[lname] = requestHeadersNames[lname] || name;
							requestHeaders[name] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function (type) {
						if (!state) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function (map) {
						var code;
						if (map) {
							if (state < 2) {
								for (code in map) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[code] = [statusCode[code], map[code]];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always(map[jqXHR.status]);
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function (statusText) {
						var finalText = statusText || strAbort;
						if (transport) {
							transport.abort(finalText);
						}
						done(0, finalText);
						return this;
					}
				};
	
				// Attach deferreds
				deferred.promise(jqXHR).complete = completeDeferred.add;
				jqXHR.success = jqXHR.done;
				jqXHR.error = jqXHR.fail;
	
				// Remove hash character (#7531: and string promotion)
				// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
				// Handle falsy url in the settings object (#10093: consistency with old signature)
				// We also use the url parameter if available
				s.url = ((url || s.url || ajaxLocation) + "").replace(rhash, "").replace(rprotocol, ajaxLocParts[1] + "//");
	
				// Alias method option to type as per ticket #12004
				s.type = options.method || options.type || s.method || s.type;
	
				// Extract dataTypes list
				s.dataTypes = jQuery.trim(s.dataType || "*").toLowerCase().match(rnotwhite) || [""];
	
				// A cross-domain request is in order when we have a protocol:host:port mismatch
				if (s.crossDomain == null) {
					parts = rurl.exec(s.url.toLowerCase());
					s.crossDomain = !!(parts && (parts[1] !== ajaxLocParts[1] || parts[2] !== ajaxLocParts[2] || (parts[3] || (parts[1] === "http:" ? "80" : "443")) !== (ajaxLocParts[3] || (ajaxLocParts[1] === "http:" ? "80" : "443"))));
				}
	
				// Convert data if not already a string
				if (s.data && s.processData && typeof s.data !== "string") {
					s.data = jQuery.param(s.data, s.traditional);
				}
	
				// Apply prefilters
				inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
	
				// If request was aborted inside a prefilter, stop there
				if (state === 2) {
					return jqXHR;
				}
	
				// We can fire global events as of now if asked to
				// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
				fireGlobals = jQuery.event && s.global;
	
				// Watch for a new set of requests
				if (fireGlobals && jQuery.active++ === 0) {
					jQuery.event.trigger("ajaxStart");
				}
	
				// Uppercase the type
				s.type = s.type.toUpperCase();
	
				// Determine if request has content
				s.hasContent = !rnoContent.test(s.type);
	
				// Save the URL in case we're toying with the If-Modified-Since
				// and/or If-None-Match header later on
				cacheURL = s.url;
	
				// More options handling for requests with no content
				if (!s.hasContent) {
	
					// If data is available, append data to url
					if (s.data) {
						cacheURL = s.url += (rquery.test(cacheURL) ? "&" : "?") + s.data;
	
						// #9682: remove data so that it's not used in an eventual retry
						delete s.data;
					}
	
					// Add anti-cache in url if needed
					if (s.cache === false) {
						s.url = rts.test(cacheURL) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace(rts, "$1_=" + nonce++) :
	
						// Otherwise add one to the end
						cacheURL + (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce++;
					}
				}
	
				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if (s.ifModified) {
					if (jQuery.lastModified[cacheURL]) {
						jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
					}
					if (jQuery.etag[cacheURL]) {
						jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
					}
				}
	
				// Set the correct header, if data is being sent
				if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
					jqXHR.setRequestHeader("Content-Type", s.contentType);
				}
	
				// Set the Accepts header for the server, depending on the dataType
				jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
	
				// Check for headers option
				for (i in s.headers) {
					jqXHR.setRequestHeader(i, s.headers[i]);
				}
	
				// Allow custom headers/mimetypes and early abort
				if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || state === 2)) {
	
					// Abort if not done already and return
					return jqXHR.abort();
				}
	
				// aborting is no longer a cancellation
				strAbort = "abort";
	
				// Install callbacks on deferreds
				for (i in { success: 1, error: 1, complete: 1 }) {
					jqXHR[i](s[i]);
				}
	
				// Get transport
				transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
	
				// If no transport, we auto-abort
				if (!transport) {
					done(-1, "No Transport");
				} else {
					jqXHR.readyState = 1;
	
					// Send global event
					if (fireGlobals) {
						globalEventContext.trigger("ajaxSend", [jqXHR, s]);
					}
	
					// If request was aborted inside ajaxSend, stop there
					if (state === 2) {
						return jqXHR;
					}
	
					// Timeout
					if (s.async && s.timeout > 0) {
						timeoutTimer = window.setTimeout(function () {
							jqXHR.abort("timeout");
						}, s.timeout);
					}
	
					try {
						state = 1;
						transport.send(requestHeaders, done);
					} catch (e) {
	
						// Propagate exception as error if not done
						if (state < 2) {
							done(-1, e);
	
							// Simply rethrow otherwise
						} else {
							throw e;
						}
					}
				}
	
				// Callback for when everything is done
				function done(status, nativeStatusText, responses, headers) {
					var isSuccess,
					    success,
					    error,
					    response,
					    modified,
					    statusText = nativeStatusText;
	
					// Called once
					if (state === 2) {
						return;
					}
	
					// State is "done" now
					state = 2;
	
					// Clear timeout if it exists
					if (timeoutTimer) {
						window.clearTimeout(timeoutTimer);
					}
	
					// Dereference transport for early garbage collection
					// (no matter how long the jqXHR object will be used)
					transport = undefined;
	
					// Cache response headers
					responseHeadersString = headers || "";
	
					// Set readyState
					jqXHR.readyState = status > 0 ? 4 : 0;
	
					// Determine if successful
					isSuccess = status >= 200 && status < 300 || status === 304;
	
					// Get response data
					if (responses) {
						response = ajaxHandleResponses(s, jqXHR, responses);
					}
	
					// Convert no matter what (that way responseXXX fields are always set)
					response = ajaxConvert(s, response, jqXHR, isSuccess);
	
					// If successful, handle type chaining
					if (isSuccess) {
	
						// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
						if (s.ifModified) {
							modified = jqXHR.getResponseHeader("Last-Modified");
							if (modified) {
								jQuery.lastModified[cacheURL] = modified;
							}
							modified = jqXHR.getResponseHeader("etag");
							if (modified) {
								jQuery.etag[cacheURL] = modified;
							}
						}
	
						// if no content
						if (status === 204 || s.type === "HEAD") {
							statusText = "nocontent";
	
							// if not modified
						} else if (status === 304) {
							statusText = "notmodified";
	
							// If we have data, let's convert it
						} else {
							statusText = response.state;
							success = response.data;
							error = response.error;
							isSuccess = !error;
						}
					} else {
	
						// We extract error from statusText
						// then normalize statusText and status for non-aborts
						error = statusText;
						if (status || !statusText) {
							statusText = "error";
							if (status < 0) {
								status = 0;
							}
						}
					}
	
					// Set data for the fake xhr object
					jqXHR.status = status;
					jqXHR.statusText = (nativeStatusText || statusText) + "";
	
					// Success/Error
					if (isSuccess) {
						deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
					} else {
						deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
					}
	
					// Status-dependent callbacks
					jqXHR.statusCode(statusCode);
					statusCode = undefined;
	
					if (fireGlobals) {
						globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
					}
	
					// Complete
					completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
	
					if (fireGlobals) {
						globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
	
						// Handle the global AJAX counter
						if (! --jQuery.active) {
							jQuery.event.trigger("ajaxStop");
						}
					}
				}
	
				return jqXHR;
			},
	
			getJSON: function (url, data, callback) {
				return jQuery.get(url, data, callback, "json");
			},
	
			getScript: function (url, callback) {
				return jQuery.get(url, undefined, callback, "script");
			}
		});
	
		jQuery.each(["get", "post"], function (i, method) {
			jQuery[method] = function (url, data, callback, type) {
	
				// shift arguments if data argument was omitted
				if (jQuery.isFunction(data)) {
					type = type || callback;
					callback = data;
					data = undefined;
				}
	
				// The url can be an options object (which then must have .url)
				return jQuery.ajax(jQuery.extend({
					url: url,
					type: method,
					dataType: type,
					data: data,
					success: callback
				}, jQuery.isPlainObject(url) && url));
			};
		});
	
		jQuery._evalUrl = function (url) {
			return jQuery.ajax({
				url: url,
	
				// Make this explicit, since user can override this through ajaxSetup (#11264)
				type: "GET",
				dataType: "script",
				cache: true,
				async: false,
				global: false,
				"throws": true
			});
		};
	
		jQuery.fn.extend({
			wrapAll: function (html) {
				if (jQuery.isFunction(html)) {
					return this.each(function (i) {
						jQuery(this).wrapAll(html.call(this, i));
					});
				}
	
				if (this[0]) {
	
					// The elements to wrap the target around
					var wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
	
					if (this[0].parentNode) {
						wrap.insertBefore(this[0]);
					}
	
					wrap.map(function () {
						var elem = this;
	
						while (elem.firstChild && elem.firstChild.nodeType === 1) {
							elem = elem.firstChild;
						}
	
						return elem;
					}).append(this);
				}
	
				return this;
			},
	
			wrapInner: function (html) {
				if (jQuery.isFunction(html)) {
					return this.each(function (i) {
						jQuery(this).wrapInner(html.call(this, i));
					});
				}
	
				return this.each(function () {
					var self = jQuery(this),
					    contents = self.contents();
	
					if (contents.length) {
						contents.wrapAll(html);
					} else {
						self.append(html);
					}
				});
			},
	
			wrap: function (html) {
				var isFunction = jQuery.isFunction(html);
	
				return this.each(function (i) {
					jQuery(this).wrapAll(isFunction ? html.call(this, i) : html);
				});
			},
	
			unwrap: function () {
				return this.parent().each(function () {
					if (!jQuery.nodeName(this, "body")) {
						jQuery(this).replaceWith(this.childNodes);
					}
				}).end();
			}
		});
	
		function getDisplay(elem) {
			return elem.style && elem.style.display || jQuery.css(elem, "display");
		}
	
		function filterHidden(elem) {
	
			// Disconnected elements are considered hidden
			if (!jQuery.contains(elem.ownerDocument || document, elem)) {
				return true;
			}
			while (elem && elem.nodeType === 1) {
				if (getDisplay(elem) === "none" || elem.type === "hidden") {
					return true;
				}
				elem = elem.parentNode;
			}
			return false;
		}
	
		jQuery.expr.filters.hidden = function (elem) {
	
			// Support: Opera <= 12.12
			// Opera reports offsetWidths and offsetHeights less than zero on some elements
			return support.reliableHiddenOffsets() ? elem.offsetWidth <= 0 && elem.offsetHeight <= 0 && !elem.getClientRects().length : filterHidden(elem);
		};
	
		jQuery.expr.filters.visible = function (elem) {
			return !jQuery.expr.filters.hidden(elem);
		};
	
		var r20 = /%20/g,
		    rbracket = /\[\]$/,
		    rCRLF = /\r?\n/g,
		    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		    rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
		function buildParams(prefix, obj, traditional, add) {
			var name;
	
			if (jQuery.isArray(obj)) {
	
				// Serialize array item.
				jQuery.each(obj, function (i, v) {
					if (traditional || rbracket.test(prefix)) {
	
						// Treat each array item as a scalar.
						add(prefix, v);
					} else {
	
						// Item is non-scalar (array or object), encode its numeric index.
						buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
					}
				});
			} else if (!traditional && jQuery.type(obj) === "object") {
	
				// Serialize object item.
				for (name in obj) {
					buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
				}
			} else {
	
				// Serialize scalar item.
				add(prefix, obj);
			}
		}
	
		// Serialize an array of form elements or a set of
		// key/values into a query string
		jQuery.param = function (a, traditional) {
			var prefix,
			    s = [],
			    add = function (key, value) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction(value) ? value() : value == null ? "" : value;
				s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value);
			};
	
			// Set traditional to true for jQuery <= 1.3.2 behavior.
			if (traditional === undefined) {
				traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
			}
	
			// If an array was passed in, assume that it is an array of form elements.
			if (jQuery.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
	
				// Serialize the form elements
				jQuery.each(a, function () {
					add(this.name, this.value);
				});
			} else {
	
				// If traditional, encode the "old" way (the way 1.3.2 or older
				// did it), otherwise encode params recursively.
				for (prefix in a) {
					buildParams(prefix, a[prefix], traditional, add);
				}
			}
	
			// Return the resulting serialization
			return s.join("&").replace(r20, "+");
		};
	
		jQuery.fn.extend({
			serialize: function () {
				return jQuery.param(this.serializeArray());
			},
			serializeArray: function () {
				return this.map(function () {
	
					// Can add propHook for "elements" to filter or add form elements
					var elements = jQuery.prop(this, "elements");
					return elements ? jQuery.makeArray(elements) : this;
				}).filter(function () {
					var type = this.type;
	
					// Use .is(":disabled") so that fieldset[disabled] works
					return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
				}).map(function (i, elem) {
					var val = jQuery(this).val();
	
					return val == null ? null : jQuery.isArray(val) ? jQuery.map(val, function (val) {
						return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
					}) : { name: elem.name, value: val.replace(rCRLF, "\r\n") };
				}).get();
			}
		});
	
		// Create the request object
		// (This is still attached to ajaxSettings for backward compatibility)
		jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?
	
		// Support: IE6-IE8
		function () {
	
			// XHR cannot access local files, always use ActiveX for that case
			if (this.isLocal) {
				return createActiveXHR();
			}
	
			// Support: IE 9-11
			// IE seems to error on cross-domain PATCH requests when ActiveX XHR
			// is used. In IE 9+ always use the native XHR.
			// Note: this condition won't catch Edge as it doesn't define
			// document.documentMode but it also doesn't support ActiveX so it won't
			// reach this code.
			if (document.documentMode > 8) {
				return createStandardXHR();
			}
	
			// Support: IE<9
			// oldIE XHR does not support non-RFC2616 methods (#13240)
			// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
			// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
			// Although this check for six methods instead of eight
			// since IE also does not support "trace" and "connect"
			return (/^(get|post|head|put|delete|options)$/i.test(this.type) && createStandardXHR() || createActiveXHR()
			);
		} :
	
		// For all other browsers, use the standard XMLHttpRequest object
		createStandardXHR;
	
		var xhrId = 0,
		    xhrCallbacks = {},
		    xhrSupported = jQuery.ajaxSettings.xhr();
	
		// Support: IE<10
		// Open requests must be manually aborted on unload (#5280)
		// See https://support.microsoft.com/kb/2856746 for more info
		if (window.attachEvent) {
			window.attachEvent("onunload", function () {
				for (var key in xhrCallbacks) {
					xhrCallbacks[key](undefined, true);
				}
			});
		}
	
		// Determine support properties
		support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
		xhrSupported = support.ajax = !!xhrSupported;
	
		// Create transport if the browser can provide an xhr
		if (xhrSupported) {
	
			jQuery.ajaxTransport(function (options) {
	
				// Cross domain only allowed if supported through XMLHttpRequest
				if (!options.crossDomain || support.cors) {
	
					var callback;
	
					return {
						send: function (headers, complete) {
							var i,
							    xhr = options.xhr(),
							    id = ++xhrId;
	
							// Open the socket
							xhr.open(options.type, options.url, options.async, options.username, options.password);
	
							// Apply custom fields if provided
							if (options.xhrFields) {
								for (i in options.xhrFields) {
									xhr[i] = options.xhrFields[i];
								}
							}
	
							// Override mime type if needed
							if (options.mimeType && xhr.overrideMimeType) {
								xhr.overrideMimeType(options.mimeType);
							}
	
							// X-Requested-With header
							// For cross-domain requests, seeing as conditions for a preflight are
							// akin to a jigsaw puzzle, we simply never set it to be sure.
							// (it can always be set on a per-request basis or even using ajaxSetup)
							// For same-domain requests, won't change header if already provided.
							if (!options.crossDomain && !headers["X-Requested-With"]) {
								headers["X-Requested-With"] = "XMLHttpRequest";
							}
	
							// Set headers
							for (i in headers) {
	
								// Support: IE<9
								// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
								// request header to a null-value.
								//
								// To keep consistent with other XHR implementations, cast the value
								// to string and ignore `undefined`.
								if (headers[i] !== undefined) {
									xhr.setRequestHeader(i, headers[i] + "");
								}
							}
	
							// Do send the request
							// This may raise an exception which is actually
							// handled in jQuery.ajax (so no try/catch here)
							xhr.send(options.hasContent && options.data || null);
	
							// Listener
							callback = function (_, isAbort) {
								var status, statusText, responses;
	
								// Was never called and is aborted or complete
								if (callback && (isAbort || xhr.readyState === 4)) {
	
									// Clean up
									delete xhrCallbacks[id];
									callback = undefined;
									xhr.onreadystatechange = jQuery.noop;
	
									// Abort manually if needed
									if (isAbort) {
										if (xhr.readyState !== 4) {
											xhr.abort();
										}
									} else {
										responses = {};
										status = xhr.status;
	
										// Support: IE<10
										// Accessing binary-data responseText throws an exception
										// (#11426)
										if (typeof xhr.responseText === "string") {
											responses.text = xhr.responseText;
										}
	
										// Firefox throws an exception when accessing
										// statusText for faulty cross-domain requests
										try {
											statusText = xhr.statusText;
										} catch (e) {
	
											// We normalize with Webkit giving an empty statusText
											statusText = "";
										}
	
										// Filter status for non standard behaviors
	
										// If the request is local and we have data: assume a success
										// (success with no data won't get notified, that's the best we
										// can do given current implementations)
										if (!status && options.isLocal && !options.crossDomain) {
											status = responses.text ? 200 : 404;
	
											// IE - #1450: sometimes returns 1223 when it should be 204
										} else if (status === 1223) {
											status = 204;
										}
									}
								}
	
								// Call complete if needed
								if (responses) {
									complete(status, statusText, responses, xhr.getAllResponseHeaders());
								}
							};
	
							// Do send the request
							// `xhr.send` may raise an exception, but it will be
							// handled in jQuery.ajax (so no try/catch here)
							if (!options.async) {
	
								// If we're in sync mode we fire the callback
								callback();
							} else if (xhr.readyState === 4) {
	
								// (IE6 & IE7) if it's in cache and has been
								// retrieved directly we need to fire the callback
								window.setTimeout(callback);
							} else {
	
								// Register the callback, but delay it in case `xhr.send` throws
								// Add to the list of active xhr callbacks
								xhr.onreadystatechange = xhrCallbacks[id] = callback;
							}
						},
	
						abort: function () {
							if (callback) {
								callback(undefined, true);
							}
						}
					};
				}
			});
		}
	
		// Functions to create xhrs
		function createStandardXHR() {
			try {
				return new window.XMLHttpRequest();
			} catch (e) {}
		}
	
		function createActiveXHR() {
			try {
				return new window.ActiveXObject("Microsoft.XMLHTTP");
			} catch (e) {}
		}
	
		// Install script dataType
		jQuery.ajaxSetup({
			accepts: {
				script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
			},
			contents: {
				script: /\b(?:java|ecma)script\b/
			},
			converters: {
				"text script": function (text) {
					jQuery.globalEval(text);
					return text;
				}
			}
		});
	
		// Handle cache's special case and global
		jQuery.ajaxPrefilter("script", function (s) {
			if (s.cache === undefined) {
				s.cache = false;
			}
			if (s.crossDomain) {
				s.type = "GET";
				s.global = false;
			}
		});
	
		// Bind script tag hack transport
		jQuery.ajaxTransport("script", function (s) {
	
			// This transport only deals with cross domain requests
			if (s.crossDomain) {
	
				var script,
				    head = document.head || jQuery("head")[0] || document.documentElement;
	
				return {
	
					send: function (_, callback) {
	
						script = document.createElement("script");
	
						script.async = true;
	
						if (s.scriptCharset) {
							script.charset = s.scriptCharset;
						}
	
						script.src = s.url;
	
						// Attach handlers for all browsers
						script.onload = script.onreadystatechange = function (_, isAbort) {
	
							if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
	
								// Handle memory leak in IE
								script.onload = script.onreadystatechange = null;
	
								// Remove the script
								if (script.parentNode) {
									script.parentNode.removeChild(script);
								}
	
								// Dereference the script
								script = null;
	
								// Callback if not abort
								if (!isAbort) {
									callback(200, "success");
								}
							}
						};
	
						// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
						// Use native DOM manipulation to avoid our domManip AJAX trickery
						head.insertBefore(script, head.firstChild);
					},
	
					abort: function () {
						if (script) {
							script.onload(undefined, true);
						}
					}
				};
			}
		});
	
		var oldCallbacks = [],
		    rjsonp = /(=)\?(?=&|$)|\?\?/;
	
		// Default jsonp settings
		jQuery.ajaxSetup({
			jsonp: "callback",
			jsonpCallback: function () {
				var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce++;
				this[callback] = true;
				return callback;
			}
		});
	
		// Detect, normalize options and install callbacks for jsonp requests
		jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {
	
			var callbackName,
			    overwritten,
			    responseContainer,
			    jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
	
			// Handle iff the expected data type is "jsonp" or we have a parameter to set
			if (jsonProp || s.dataTypes[0] === "jsonp") {
	
				// Get callback name, remembering preexisting value associated with it
				callbackName = s.jsonpCallback = jQuery.isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
	
				// Insert callback into url or form data
				if (jsonProp) {
					s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
				} else if (s.jsonp !== false) {
					s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
				}
	
				// Use data converter to retrieve json after script execution
				s.converters["script json"] = function () {
					if (!responseContainer) {
						jQuery.error(callbackName + " was not called");
					}
					return responseContainer[0];
				};
	
				// force json dataType
				s.dataTypes[0] = "json";
	
				// Install callback
				overwritten = window[callbackName];
				window[callbackName] = function () {
					responseContainer = arguments;
				};
	
				// Clean-up function (fires after converters)
				jqXHR.always(function () {
	
					// If previous value didn't exist - remove it
					if (overwritten === undefined) {
						jQuery(window).removeProp(callbackName);
	
						// Otherwise restore preexisting value
					} else {
						window[callbackName] = overwritten;
					}
	
					// Save back as free
					if (s[callbackName]) {
	
						// make sure that re-using the options doesn't screw things around
						s.jsonpCallback = originalSettings.jsonpCallback;
	
						// save the callback name for future use
						oldCallbacks.push(callbackName);
					}
	
					// Call if it was a function and we have a response
					if (responseContainer && jQuery.isFunction(overwritten)) {
						overwritten(responseContainer[0]);
					}
	
					responseContainer = overwritten = undefined;
				});
	
				// Delegate to script
				return "script";
			}
		});
	
		// data: string of html
		// context (optional): If specified, the fragment will be created in this context,
		// defaults to document
		// keepScripts (optional): If true, will include scripts passed in the html string
		jQuery.parseHTML = function (data, context, keepScripts) {
			if (!data || typeof data !== "string") {
				return null;
			}
			if (typeof context === "boolean") {
				keepScripts = context;
				context = false;
			}
			context = context || document;
	
			var parsed = rsingleTag.exec(data),
			    scripts = !keepScripts && [];
	
			// Single tag
			if (parsed) {
				return [context.createElement(parsed[1])];
			}
	
			parsed = buildFragment([data], context, scripts);
	
			if (scripts && scripts.length) {
				jQuery(scripts).remove();
			}
	
			return jQuery.merge([], parsed.childNodes);
		};
	
		// Keep a copy of the old load method
		var _load = jQuery.fn.load;
	
		/**
	  * Load a url into a page
	  */
		jQuery.fn.load = function (url, params, callback) {
			if (typeof url !== "string" && _load) {
				return _load.apply(this, arguments);
			}
	
			var selector,
			    type,
			    response,
			    self = this,
			    off = url.indexOf(" ");
	
			if (off > -1) {
				selector = jQuery.trim(url.slice(off, url.length));
				url = url.slice(0, off);
			}
	
			// If it's a function
			if (jQuery.isFunction(params)) {
	
				// We assume that it's the callback
				callback = params;
				params = undefined;
	
				// Otherwise, build a param string
			} else if (params && typeof params === "object") {
				type = "POST";
			}
	
			// If we have elements to modify, make the request
			if (self.length > 0) {
				jQuery.ajax({
					url: url,
	
					// If "type" variable is undefined, then "GET" method will be used.
					// Make value of this field explicit since
					// user can override it through ajaxSetup method
					type: type || "GET",
					dataType: "html",
					data: params
				}).done(function (responseText) {
	
					// Save response for use in complete callback
					response = arguments;
	
					self.html(selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :
	
					// Otherwise use the full result
					responseText);
	
					// If the request succeeds, this function gets "data", "status", "jqXHR"
					// but they are ignored because response was set above.
					// If it fails, this function gets "jqXHR", "status", "error"
				}).always(callback && function (jqXHR, status) {
					self.each(function () {
						callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
					});
				});
			}
	
			return this;
		};
	
		// Attach a bunch of functions for handling common AJAX events
		jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (i, type) {
			jQuery.fn[type] = function (fn) {
				return this.on(type, fn);
			};
		});
	
		jQuery.expr.filters.animated = function (elem) {
			return jQuery.grep(jQuery.timers, function (fn) {
				return elem === fn.elem;
			}).length;
		};
	
		/**
	  * Gets a window from an element
	  */
		function getWindow(elem) {
			return jQuery.isWindow(elem) ? elem : elem.nodeType === 9 ? elem.defaultView || elem.parentWindow : false;
		}
	
		jQuery.offset = {
			setOffset: function (elem, options, i) {
				var curPosition,
				    curLeft,
				    curCSSTop,
				    curTop,
				    curOffset,
				    curCSSLeft,
				    calculatePosition,
				    position = jQuery.css(elem, "position"),
				    curElem = jQuery(elem),
				    props = {};
	
				// set position first, in-case top/left are set even on static elem
				if (position === "static") {
					elem.style.position = "relative";
				}
	
				curOffset = curElem.offset();
				curCSSTop = jQuery.css(elem, "top");
				curCSSLeft = jQuery.css(elem, "left");
				calculatePosition = (position === "absolute" || position === "fixed") && jQuery.inArray("auto", [curCSSTop, curCSSLeft]) > -1;
	
				// need to be able to calculate position if either top or left
				// is auto and position is either absolute or fixed
				if (calculatePosition) {
					curPosition = curElem.position();
					curTop = curPosition.top;
					curLeft = curPosition.left;
				} else {
					curTop = parseFloat(curCSSTop) || 0;
					curLeft = parseFloat(curCSSLeft) || 0;
				}
	
				if (jQuery.isFunction(options)) {
	
					// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
					options = options.call(elem, i, jQuery.extend({}, curOffset));
				}
	
				if (options.top != null) {
					props.top = options.top - curOffset.top + curTop;
				}
				if (options.left != null) {
					props.left = options.left - curOffset.left + curLeft;
				}
	
				if ("using" in options) {
					options.using.call(elem, props);
				} else {
					curElem.css(props);
				}
			}
		};
	
		jQuery.fn.extend({
			offset: function (options) {
				if (arguments.length) {
					return options === undefined ? this : this.each(function (i) {
						jQuery.offset.setOffset(this, options, i);
					});
				}
	
				var docElem,
				    win,
				    box = { top: 0, left: 0 },
				    elem = this[0],
				    doc = elem && elem.ownerDocument;
	
				if (!doc) {
					return;
				}
	
				docElem = doc.documentElement;
	
				// Make sure it's not a disconnected DOM node
				if (!jQuery.contains(docElem, elem)) {
					return box;
				}
	
				// If we don't have gBCR, just use 0,0 rather than error
				// BlackBerry 5, iOS 3 (original iPhone)
				if (typeof elem.getBoundingClientRect !== "undefined") {
					box = elem.getBoundingClientRect();
				}
				win = getWindow(doc);
				return {
					top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
					left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0)
				};
			},
	
			position: function () {
				if (!this[0]) {
					return;
				}
	
				var offsetParent,
				    offset,
				    parentOffset = { top: 0, left: 0 },
				    elem = this[0];
	
				// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
				// because it is its only offset parent
				if (jQuery.css(elem, "position") === "fixed") {
	
					// we assume that getBoundingClientRect is available when computed position is fixed
					offset = elem.getBoundingClientRect();
				} else {
	
					// Get *real* offsetParent
					offsetParent = this.offsetParent();
	
					// Get correct offsets
					offset = this.offset();
					if (!jQuery.nodeName(offsetParent[0], "html")) {
						parentOffset = offsetParent.offset();
					}
	
					// Add offsetParent borders
					parentOffset.top += jQuery.css(offsetParent[0], "borderTopWidth", true);
					parentOffset.left += jQuery.css(offsetParent[0], "borderLeftWidth", true);
				}
	
				// Subtract parent offsets and element margins
				// note: when an element has margin: auto the offsetLeft and marginLeft
				// are the same in Safari causing offset.left to incorrectly be 0
				return {
					top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
					left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
				};
			},
	
			offsetParent: function () {
				return this.map(function () {
					var offsetParent = this.offsetParent;
	
					while (offsetParent && !jQuery.nodeName(offsetParent, "html") && jQuery.css(offsetParent, "position") === "static") {
						offsetParent = offsetParent.offsetParent;
					}
					return offsetParent || documentElement;
				});
			}
		});
	
		// Create scrollLeft and scrollTop methods
		jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
			var top = /Y/.test(prop);
	
			jQuery.fn[method] = function (val) {
				return access(this, function (elem, method, val) {
					var win = getWindow(elem);
	
					if (val === undefined) {
						return win ? prop in win ? win[prop] : win.document.documentElement[method] : elem[method];
					}
	
					if (win) {
						win.scrollTo(!top ? val : jQuery(win).scrollLeft(), top ? val : jQuery(win).scrollTop());
					} else {
						elem[method] = val;
					}
				}, method, val, arguments.length, null);
			};
		});
	
		// Support: Safari<7-8+, Chrome<37-44+
		// Add the top/left cssHooks using jQuery.fn.position
		// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
		// getComputedStyle returns percent when specified for top/left/bottom/right
		// rather than make the css module depend on the offset module, we just check for it here
		jQuery.each(["top", "left"], function (i, prop) {
			jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
				if (computed) {
					computed = curCSS(elem, prop);
	
					// if curCSS returns percentage, fallback to offset
					return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
				}
			});
		});
	
		// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
		jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
			jQuery.each({ padding: "inner" + name, content: type, "": "outer" + name }, function (defaultExtra, funcName) {
	
				// margin is only for outerHeight, outerWidth
				jQuery.fn[funcName] = function (margin, value) {
					var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
					    extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
	
					return access(this, function (elem, type, value) {
						var doc;
	
						if (jQuery.isWindow(elem)) {
	
							// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
							// isn't a whole lot we can do. See pull request at this URL for discussion:
							// https://github.com/jquery/jquery/pull/764
							return elem.document.documentElement["client" + name];
						}
	
						// Get document width or height
						if (elem.nodeType === 9) {
							doc = elem.documentElement;
	
							// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
							// whichever is greatest
							// unfortunately, this causes bug #3838 in IE6/8 only,
							// but there is currently no good, small way to fix it.
							return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
						}
	
						return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css(elem, type, extra) :
	
						// Set width or height on the element
						jQuery.style(elem, type, value, extra);
					}, type, chainable ? margin : undefined, chainable, null);
				};
			});
		});
	
		jQuery.fn.extend({
	
			bind: function (types, data, fn) {
				return this.on(types, null, data, fn);
			},
			unbind: function (types, fn) {
				return this.off(types, null, fn);
			},
	
			delegate: function (selector, types, data, fn) {
				return this.on(types, selector, data, fn);
			},
			undelegate: function (selector, types, fn) {
	
				// ( namespace ) or ( selector, types [, fn] )
				return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
			}
		});
	
		// The number of elements contained in the matched element set
		jQuery.fn.size = function () {
			return this.length;
		};
	
		jQuery.fn.andSelf = jQuery.fn.addBack;
	
		// Register as a named AMD module, since jQuery can be concatenated with other
		// files that may use define, but not via a proper concatenation script that
		// understands anonymous AMD modules. A named AMD is safest and most robust
		// way to register. Lowercase jquery is used because AMD module names are
		// derived from file names, and jQuery is normally delivered in a lowercase
		// file name. Do this after creating the global so that if an AMD module wants
		// to call noConflict to hide this version of jQuery, it will work.
	
		// Note that for maximum portability, libraries that are not jQuery should
		// declare themselves as anonymous modules, and avoid setting a global if an
		// AMD loader is present. jQuery is a special case. For more information, see
		// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return jQuery;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
		var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
		jQuery.noConflict = function (deep) {
			if (window.$ === jQuery) {
				window.$ = _$;
			}
	
			if (deep && window.jQuery === jQuery) {
				window.jQuery = _jQuery;
			}
	
			return jQuery;
		};
	
		// Expose jQuery and $ identifiers, even in
		// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
		// and CommonJS for browser emulators (#13566)
		if (!noGlobal) {
			window.jQuery = window.$ = jQuery;
		}
	
		return jQuery;
	});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {//     Backbone.js 1.3.3
	
	//     (c) 2010-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org
	
	(function (factory) {
	
	  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
	  // We use `self` instead of `window` for `WebWorker` support.
	  var root = typeof self == 'object' && self.self === self && self || typeof global == 'object' && global.global === global && global;
	
	  // Set up Backbone appropriately for the environment. Start with AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(1), exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $, exports) {
	      // Export global even in AMD case in case this script is loaded with
	      // others that may still expect a global Backbone.
	      root.Backbone = factory(root, exports, _, $);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	    // Next for Node.js or CommonJS. jQuery may not be needed as a module.
	  } else if (typeof exports !== 'undefined') {
	    var _ = require('underscore'),
	        $;
	    try {
	      $ = require('jquery');
	    } catch (e) {}
	    factory(root, exports, _, $);
	
	    // Finally, as a browser global.
	  } else {
	    root.Backbone = factory(root, {}, root._, root.jQuery || root.Zepto || root.ender || root.$);
	  }
	})(function (root, Backbone, _, $) {
	
	  // Initial Setup
	  // -------------
	
	  // Save the previous value of the `Backbone` variable, so that it can be
	  // restored later on, if `noConflict` is used.
	  var previousBackbone = root.Backbone;
	
	  // Create a local reference to a common array method we'll want to use later.
	  var slice = Array.prototype.slice;
	
	  // Current version of the library. Keep in sync with `package.json`.
	  Backbone.VERSION = '1.3.3';
	
	  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
	  // the `$` variable.
	  Backbone.$ = $;
	
	  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
	  // to its previous owner. Returns a reference to this Backbone object.
	  Backbone.noConflict = function () {
	    root.Backbone = previousBackbone;
	    return this;
	  };
	
	  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
	  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
	  // set a `X-Http-Method-Override` header.
	  Backbone.emulateHTTP = false;
	
	  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
	  // `application/json` requests ... this will encode the body as
	  // `application/x-www-form-urlencoded` instead and will send the model in a
	  // form param named `model`.
	  Backbone.emulateJSON = false;
	
	  // Proxy Backbone class methods to Underscore functions, wrapping the model's
	  // `attributes` object or collection's `models` array behind the scenes.
	  //
	  // collection.filter(function(model) { return model.get('age') > 10 });
	  // collection.each(this.addView);
	  //
	  // `Function#apply` can be slow so we use the method's arg count, if we know it.
	  var addMethod = function (length, method, attribute) {
	    switch (length) {
	      case 1:
	        return function () {
	          return _[method](this[attribute]);
	        };
	      case 2:
	        return function (value) {
	          return _[method](this[attribute], value);
	        };
	      case 3:
	        return function (iteratee, context) {
	          return _[method](this[attribute], cb(iteratee, this), context);
	        };
	      case 4:
	        return function (iteratee, defaultVal, context) {
	          return _[method](this[attribute], cb(iteratee, this), defaultVal, context);
	        };
	      default:
	        return function () {
	          var args = slice.call(arguments);
	          args.unshift(this[attribute]);
	          return _[method].apply(_, args);
	        };
	    }
	  };
	  var addUnderscoreMethods = function (Class, methods, attribute) {
	    _.each(methods, function (length, method) {
	      if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
	    });
	  };
	
	  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
	  var cb = function (iteratee, instance) {
	    if (_.isFunction(iteratee)) return iteratee;
	    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
	    if (_.isString(iteratee)) return function (model) {
	      return model.get(iteratee);
	    };
	    return iteratee;
	  };
	  var modelMatcher = function (attrs) {
	    var matcher = _.matches(attrs);
	    return function (model) {
	      return matcher(model.attributes);
	    };
	  };
	
	  // Backbone.Events
	  // ---------------
	
	  // A module that can be mixed in to *any object* in order to provide it with
	  // a custom event channel. You may bind a callback to an event with `on` or
	  // remove with `off`; `trigger`-ing an event fires all callbacks in
	  // succession.
	  //
	  //     var object = {};
	  //     _.extend(object, Backbone.Events);
	  //     object.on('expand', function(){ alert('expanded'); });
	  //     object.trigger('expand');
	  //
	  var Events = Backbone.Events = {};
	
	  // Regular expression used to split event strings.
	  var eventSplitter = /\s+/;
	
	  // Iterates over the standard `event, callback` (as well as the fancy multiple
	  // space-separated events `"change blur", callback` and jQuery-style event
	  // maps `{event: callback}`).
	  var eventsApi = function (iteratee, events, name, callback, opts) {
	    var i = 0,
	        names;
	    if (name && typeof name === 'object') {
	      // Handle event maps.
	      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
	      for (names = _.keys(name); i < names.length; i++) {
	        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
	      }
	    } else if (name && eventSplitter.test(name)) {
	      // Handle space-separated event names by delegating them individually.
	      for (names = name.split(eventSplitter); i < names.length; i++) {
	        events = iteratee(events, names[i], callback, opts);
	      }
	    } else {
	      // Finally, standard events.
	      events = iteratee(events, name, callback, opts);
	    }
	    return events;
	  };
	
	  // Bind an event to a `callback` function. Passing `"all"` will bind
	  // the callback to all events fired.
	  Events.on = function (name, callback, context) {
	    return internalOn(this, name, callback, context);
	  };
	
	  // Guard the `listening` argument from the public API.
	  var internalOn = function (obj, name, callback, context, listening) {
	    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
	      context: context,
	      ctx: obj,
	      listening: listening
	    });
	
	    if (listening) {
	      var listeners = obj._listeners || (obj._listeners = {});
	      listeners[listening.id] = listening;
	    }
	
	    return obj;
	  };
	
	  // Inversion-of-control versions of `on`. Tell *this* object to listen to
	  // an event in another object... keeping track of what it's listening to
	  // for easier unbinding later.
	  Events.listenTo = function (obj, name, callback) {
	    if (!obj) return this;
	    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
	    var listeningTo = this._listeningTo || (this._listeningTo = {});
	    var listening = listeningTo[id];
	
	    // This object is not listening to any other events on `obj` yet.
	    // Setup the necessary references to track the listening callbacks.
	    if (!listening) {
	      var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
	      listening = listeningTo[id] = { obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0 };
	    }
	
	    // Bind callbacks on obj, and keep track of them on listening.
	    internalOn(obj, name, callback, this, listening);
	    return this;
	  };
	
	  // The reducing API that adds a callback to the `events` object.
	  var onApi = function (events, name, callback, options) {
	    if (callback) {
	      var handlers = events[name] || (events[name] = []);
	      var context = options.context,
	          ctx = options.ctx,
	          listening = options.listening;
	      if (listening) listening.count++;
	
	      handlers.push({ callback: callback, context: context, ctx: context || ctx, listening: listening });
	    }
	    return events;
	  };
	
	  // Remove one or many callbacks. If `context` is null, removes all
	  // callbacks with that function. If `callback` is null, removes all
	  // callbacks for the event. If `name` is null, removes all bound
	  // callbacks for all events.
	  Events.off = function (name, callback, context) {
	    if (!this._events) return this;
	    this._events = eventsApi(offApi, this._events, name, callback, {
	      context: context,
	      listeners: this._listeners
	    });
	    return this;
	  };
	
	  // Tell this object to stop listening to either specific events ... or
	  // to every object it's currently listening to.
	  Events.stopListening = function (obj, name, callback) {
	    var listeningTo = this._listeningTo;
	    if (!listeningTo) return this;
	
	    var ids = obj ? [obj._listenId] : _.keys(listeningTo);
	
	    for (var i = 0; i < ids.length; i++) {
	      var listening = listeningTo[ids[i]];
	
	      // If listening doesn't exist, this object is not currently
	      // listening to obj. Break out early.
	      if (!listening) break;
	
	      listening.obj.off(name, callback, this);
	    }
	
	    return this;
	  };
	
	  // The reducing API that removes a callback from the `events` object.
	  var offApi = function (events, name, callback, options) {
	    if (!events) return;
	
	    var i = 0,
	        listening;
	    var context = options.context,
	        listeners = options.listeners;
	
	    // Delete all events listeners and "drop" events.
	    if (!name && !callback && !context) {
	      var ids = _.keys(listeners);
	      for (; i < ids.length; i++) {
	        listening = listeners[ids[i]];
	        delete listeners[listening.id];
	        delete listening.listeningTo[listening.objId];
	      }
	      return;
	    }
	
	    var names = name ? [name] : _.keys(events);
	    for (; i < names.length; i++) {
	      name = names[i];
	      var handlers = events[name];
	
	      // Bail out if there are no events stored.
	      if (!handlers) break;
	
	      // Replace events if there are any remaining.  Otherwise, clean up.
	      var remaining = [];
	      for (var j = 0; j < handlers.length; j++) {
	        var handler = handlers[j];
	        if (callback && callback !== handler.callback && callback !== handler.callback._callback || context && context !== handler.context) {
	          remaining.push(handler);
	        } else {
	          listening = handler.listening;
	          if (listening && --listening.count === 0) {
	            delete listeners[listening.id];
	            delete listening.listeningTo[listening.objId];
	          }
	        }
	      }
	
	      // Update tail event if the list has any events.  Otherwise, clean up.
	      if (remaining.length) {
	        events[name] = remaining;
	      } else {
	        delete events[name];
	      }
	    }
	    return events;
	  };
	
	  // Bind an event to only be triggered a single time. After the first time
	  // the callback is invoked, its listener will be removed. If multiple events
	  // are passed in using the space-separated syntax, the handler will fire
	  // once for each event, not once for a combination of all events.
	  Events.once = function (name, callback, context) {
	    // Map the event into a `{event: once}` object.
	    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
	    if (typeof name === 'string' && context == null) callback = void 0;
	    return this.on(events, callback, context);
	  };
	
	  // Inversion-of-control versions of `once`.
	  Events.listenToOnce = function (obj, name, callback) {
	    // Map the event into a `{event: once}` object.
	    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
	    return this.listenTo(obj, events);
	  };
	
	  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
	  // `offer` unbinds the `onceWrapper` after it has been called.
	  var onceMap = function (map, name, callback, offer) {
	    if (callback) {
	      var once = map[name] = _.once(function () {
	        offer(name, once);
	        callback.apply(this, arguments);
	      });
	      once._callback = callback;
	    }
	    return map;
	  };
	
	  // Trigger one or many events, firing all bound callbacks. Callbacks are
	  // passed the same arguments as `trigger` is, apart from the event name
	  // (unless you're listening on `"all"`, which will cause your callback to
	  // receive the true name of the event as the first argument).
	  Events.trigger = function (name) {
	    if (!this._events) return this;
	
	    var length = Math.max(0, arguments.length - 1);
	    var args = Array(length);
	    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];
	
	    eventsApi(triggerApi, this._events, name, void 0, args);
	    return this;
	  };
	
	  // Handles triggering the appropriate event callbacks.
	  var triggerApi = function (objEvents, name, callback, args) {
	    if (objEvents) {
	      var events = objEvents[name];
	      var allEvents = objEvents.all;
	      if (events && allEvents) allEvents = allEvents.slice();
	      if (events) triggerEvents(events, args);
	      if (allEvents) triggerEvents(allEvents, [name].concat(args));
	    }
	    return objEvents;
	  };
	
	  // A difficult-to-believe, but optimized internal dispatch function for
	  // triggering events. Tries to keep the usual cases speedy (most internal
	  // Backbone events have 3 arguments).
	  var triggerEvents = function (events, args) {
	    var ev,
	        i = -1,
	        l = events.length,
	        a1 = args[0],
	        a2 = args[1],
	        a3 = args[2];
	    switch (args.length) {
	      case 0:
	        while (++i < l) (ev = events[i]).callback.call(ev.ctx);return;
	      case 1:
	        while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1);return;
	      case 2:
	        while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2);return;
	      case 3:
	        while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3);return;
	      default:
	        while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);return;
	    }
	  };
	
	  // Aliases for backwards compatibility.
	  Events.bind = Events.on;
	  Events.unbind = Events.off;
	
	  // Allow the `Backbone` object to serve as a global event bus, for folks who
	  // want global "pubsub" in a convenient place.
	  _.extend(Backbone, Events);
	
	  // Backbone.Model
	  // --------------
	
	  // Backbone **Models** are the basic data object in the framework --
	  // frequently representing a row in a table in a database on your server.
	  // A discrete chunk of data and a bunch of useful, related methods for
	  // performing computations and transformations on that data.
	
	  // Create a new model with the specified attributes. A client id (`cid`)
	  // is automatically generated and assigned for you.
	  var Model = Backbone.Model = function (attributes, options) {
	    var attrs = attributes || {};
	    options || (options = {});
	    this.cid = _.uniqueId(this.cidPrefix);
	    this.attributes = {};
	    if (options.collection) this.collection = options.collection;
	    if (options.parse) attrs = this.parse(attrs, options) || {};
	    var defaults = _.result(this, 'defaults');
	    attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
	    this.set(attrs, options);
	    this.changed = {};
	    this.initialize.apply(this, arguments);
	  };
	
	  // Attach all inheritable methods to the Model prototype.
	  _.extend(Model.prototype, Events, {
	
	    // A hash of attributes whose current and previous value differ.
	    changed: null,
	
	    // The value returned during the last failed validation.
	    validationError: null,
	
	    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
	    // CouchDB users may want to set this to `"_id"`.
	    idAttribute: 'id',
	
	    // The prefix is used to create the client id which is used to identify models locally.
	    // You may want to override this if you're experiencing name clashes with model ids.
	    cidPrefix: 'c',
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function () {},
	
	    // Return a copy of the model's `attributes` object.
	    toJSON: function (options) {
	      return _.clone(this.attributes);
	    },
	
	    // Proxy `Backbone.sync` by default -- but override this if you need
	    // custom syncing semantics for *this* particular model.
	    sync: function () {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Get the value of an attribute.
	    get: function (attr) {
	      return this.attributes[attr];
	    },
	
	    // Get the HTML-escaped value of an attribute.
	    escape: function (attr) {
	      return _.escape(this.get(attr));
	    },
	
	    // Returns `true` if the attribute contains a value that is not null
	    // or undefined.
	    has: function (attr) {
	      return this.get(attr) != null;
	    },
	
	    // Special-cased proxy to underscore's `_.matches` method.
	    matches: function (attrs) {
	      return !!_.iteratee(attrs, this)(this.attributes);
	    },
	
	    // Set a hash of model attributes on the object, firing `"change"`. This is
	    // the core primitive operation of a model, updating the data and notifying
	    // anyone who needs to know about the change in state. The heart of the beast.
	    set: function (key, val, options) {
	      if (key == null) return this;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      var attrs;
	      if (typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options || (options = {});
	
	      // Run validation.
	      if (!this._validate(attrs, options)) return false;
	
	      // Extract attributes and options.
	      var unset = options.unset;
	      var silent = options.silent;
	      var changes = [];
	      var changing = this._changing;
	      this._changing = true;
	
	      if (!changing) {
	        this._previousAttributes = _.clone(this.attributes);
	        this.changed = {};
	      }
	
	      var current = this.attributes;
	      var changed = this.changed;
	      var prev = this._previousAttributes;
	
	      // For each `set` attribute, update or delete the current value.
	      for (var attr in attrs) {
	        val = attrs[attr];
	        if (!_.isEqual(current[attr], val)) changes.push(attr);
	        if (!_.isEqual(prev[attr], val)) {
	          changed[attr] = val;
	        } else {
	          delete changed[attr];
	        }
	        unset ? delete current[attr] : current[attr] = val;
	      }
	
	      // Update the `id`.
	      if (this.idAttribute in attrs) this.id = this.get(this.idAttribute);
	
	      // Trigger all relevant attribute changes.
	      if (!silent) {
	        if (changes.length) this._pending = options;
	        for (var i = 0; i < changes.length; i++) {
	          this.trigger('change:' + changes[i], this, current[changes[i]], options);
	        }
	      }
	
	      // You might be wondering why there's a `while` loop here. Changes can
	      // be recursively nested within `"change"` events.
	      if (changing) return this;
	      if (!silent) {
	        while (this._pending) {
	          options = this._pending;
	          this._pending = false;
	          this.trigger('change', this, options);
	        }
	      }
	      this._pending = false;
	      this._changing = false;
	      return this;
	    },
	
	    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
	    // if the attribute doesn't exist.
	    unset: function (attr, options) {
	      return this.set(attr, void 0, _.extend({}, options, { unset: true }));
	    },
	
	    // Clear all attributes on the model, firing `"change"`.
	    clear: function (options) {
	      var attrs = {};
	      for (var key in this.attributes) attrs[key] = void 0;
	      return this.set(attrs, _.extend({}, options, { unset: true }));
	    },
	
	    // Determine if the model has changed since the last `"change"` event.
	    // If you specify an attribute name, determine if that attribute has changed.
	    hasChanged: function (attr) {
	      if (attr == null) return !_.isEmpty(this.changed);
	      return _.has(this.changed, attr);
	    },
	
	    // Return an object containing all the attributes that have changed, or
	    // false if there are no changed attributes. Useful for determining what
	    // parts of a view need to be updated and/or what attributes need to be
	    // persisted to the server. Unset attributes will be set to undefined.
	    // You can also pass an attributes object to diff against the model,
	    // determining if there *would be* a change.
	    changedAttributes: function (diff) {
	      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
	      var old = this._changing ? this._previousAttributes : this.attributes;
	      var changed = {};
	      for (var attr in diff) {
	        var val = diff[attr];
	        if (_.isEqual(old[attr], val)) continue;
	        changed[attr] = val;
	      }
	      return _.size(changed) ? changed : false;
	    },
	
	    // Get the previous value of an attribute, recorded at the time the last
	    // `"change"` event was fired.
	    previous: function (attr) {
	      if (attr == null || !this._previousAttributes) return null;
	      return this._previousAttributes[attr];
	    },
	
	    // Get all of the attributes of the model at the time of the previous
	    // `"change"` event.
	    previousAttributes: function () {
	      return _.clone(this._previousAttributes);
	    },
	
	    // Fetch the model from the server, merging the response with the model's
	    // local attributes. Any changed attributes will trigger a "change" event.
	    fetch: function (options) {
	      options = _.extend({ parse: true }, options);
	      var model = this;
	      var success = options.success;
	      options.success = function (resp) {
	        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
	        if (!model.set(serverAttrs, options)) return false;
	        if (success) success.call(options.context, model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Set a hash of model attributes, and sync the model to the server.
	    // If the server returns an attributes hash that differs, the model's
	    // state will be `set` again.
	    save: function (key, val, options) {
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      var attrs;
	      if (key == null || typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options = _.extend({ validate: true, parse: true }, options);
	      var wait = options.wait;
	
	      // If we're not waiting and attributes exist, save acts as
	      // `set(attr).save(null, opts)` with validation. Otherwise, check if
	      // the model will be valid when the attributes, if any, are set.
	      if (attrs && !wait) {
	        if (!this.set(attrs, options)) return false;
	      } else if (!this._validate(attrs, options)) {
	        return false;
	      }
	
	      // After a successful server-side save, the client is (optionally)
	      // updated with the server-side state.
	      var model = this;
	      var success = options.success;
	      var attributes = this.attributes;
	      options.success = function (resp) {
	        // Ensure attributes are restored during synchronous saves.
	        model.attributes = attributes;
	        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
	        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
	        if (serverAttrs && !model.set(serverAttrs, options)) return false;
	        if (success) success.call(options.context, model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	
	      // Set temporary attributes if `{wait: true}` to properly find new ids.
	      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);
	
	      var method = this.isNew() ? 'create' : options.patch ? 'patch' : 'update';
	      if (method === 'patch' && !options.attrs) options.attrs = attrs;
	      var xhr = this.sync(method, this, options);
	
	      // Restore attributes.
	      this.attributes = attributes;
	
	      return xhr;
	    },
	
	    // Destroy this model on the server if it was already persisted.
	    // Optimistically removes the model from its collection, if it has one.
	    // If `wait: true` is passed, waits for the server to respond before removal.
	    destroy: function (options) {
	      options = options ? _.clone(options) : {};
	      var model = this;
	      var success = options.success;
	      var wait = options.wait;
	
	      var destroy = function () {
	        model.stopListening();
	        model.trigger('destroy', model, model.collection, options);
	      };
	
	      options.success = function (resp) {
	        if (wait) destroy();
	        if (success) success.call(options.context, model, resp, options);
	        if (!model.isNew()) model.trigger('sync', model, resp, options);
	      };
	
	      var xhr = false;
	      if (this.isNew()) {
	        _.defer(options.success);
	      } else {
	        wrapError(this, options);
	        xhr = this.sync('delete', this, options);
	      }
	      if (!wait) destroy();
	      return xhr;
	    },
	
	    // Default URL for the model's representation on the server -- if you're
	    // using Backbone's restful methods, override this to change the endpoint
	    // that will be called.
	    url: function () {
	      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
	      if (this.isNew()) return base;
	      var id = this.get(this.idAttribute);
	      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
	    },
	
	    // **parse** converts a response into the hash of attributes to be `set` on
	    // the model. The default implementation is just to pass the response along.
	    parse: function (resp, options) {
	      return resp;
	    },
	
	    // Create a new model with identical attributes to this one.
	    clone: function () {
	      return new this.constructor(this.attributes);
	    },
	
	    // A model is new if it has never been saved to the server, and lacks an id.
	    isNew: function () {
	      return !this.has(this.idAttribute);
	    },
	
	    // Check if the model is currently in a valid state.
	    isValid: function (options) {
	      return this._validate({}, _.extend({}, options, { validate: true }));
	    },
	
	    // Run validation against the next complete set of model attributes,
	    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
	    _validate: function (attrs, options) {
	      if (!options.validate || !this.validate) return true;
	      attrs = _.extend({}, this.attributes, attrs);
	      var error = this.validationError = this.validate(attrs, options) || null;
	      if (!error) return true;
	      this.trigger('invalid', this, error, _.extend(options, { validationError: error }));
	      return false;
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Model, mapped to the
	  // number of arguments they take.
	  var modelMethods = { keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
	    omit: 0, chain: 1, isEmpty: 1 };
	
	  // Mix in each Underscore method as a proxy to `Model#attributes`.
	  addUnderscoreMethods(Model, modelMethods, 'attributes');
	
	  // Backbone.Collection
	  // -------------------
	
	  // If models tend to represent a single row of data, a Backbone Collection is
	  // more analogous to a table full of data ... or a small slice or page of that
	  // table, or a collection of rows that belong together for a particular reason
	  // -- all of the messages in this particular folder, all of the documents
	  // belonging to this particular author, and so on. Collections maintain
	  // indexes of their models, both in order, and for lookup by `id`.
	
	  // Create a new **Collection**, perhaps to contain a specific type of `model`.
	  // If a `comparator` is specified, the Collection will maintain
	  // its models in sort order, as they're added and removed.
	  var Collection = Backbone.Collection = function (models, options) {
	    options || (options = {});
	    if (options.model) this.model = options.model;
	    if (options.comparator !== void 0) this.comparator = options.comparator;
	    this._reset();
	    this.initialize.apply(this, arguments);
	    if (models) this.reset(models, _.extend({ silent: true }, options));
	  };
	
	  // Default options for `Collection#set`.
	  var setOptions = { add: true, remove: true, merge: true };
	  var addOptions = { add: true, remove: false };
	
	  // Splices `insert` into `array` at index `at`.
	  var splice = function (array, insert, at) {
	    at = Math.min(Math.max(at, 0), array.length);
	    var tail = Array(array.length - at);
	    var length = insert.length;
	    var i;
	    for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
	    for (i = 0; i < length; i++) array[i + at] = insert[i];
	    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
	  };
	
	  // Define the Collection's inheritable methods.
	  _.extend(Collection.prototype, Events, {
	
	    // The default model for a collection is just a **Backbone.Model**.
	    // This should be overridden in most cases.
	    model: Model,
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function () {},
	
	    // The JSON representation of a Collection is an array of the
	    // models' attributes.
	    toJSON: function (options) {
	      return this.map(function (model) {
	        return model.toJSON(options);
	      });
	    },
	
	    // Proxy `Backbone.sync` by default.
	    sync: function () {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Add a model, or list of models to the set. `models` may be Backbone
	    // Models or raw JavaScript objects to be converted to Models, or any
	    // combination of the two.
	    add: function (models, options) {
	      return this.set(models, _.extend({ merge: false }, options, addOptions));
	    },
	
	    // Remove a model, or a list of models from the set.
	    remove: function (models, options) {
	      options = _.extend({}, options);
	      var singular = !_.isArray(models);
	      models = singular ? [models] : models.slice();
	      var removed = this._removeModels(models, options);
	      if (!options.silent && removed.length) {
	        options.changes = { added: [], merged: [], removed: removed };
	        this.trigger('update', this, options);
	      }
	      return singular ? removed[0] : removed;
	    },
	
	    // Update a collection by `set`-ing a new list of models, adding new ones,
	    // removing models that are no longer present, and merging models that
	    // already exist in the collection, as necessary. Similar to **Model#set**,
	    // the core operation for updating the data contained by the collection.
	    set: function (models, options) {
	      if (models == null) return;
	
	      options = _.extend({}, setOptions, options);
	      if (options.parse && !this._isModel(models)) {
	        models = this.parse(models, options) || [];
	      }
	
	      var singular = !_.isArray(models);
	      models = singular ? [models] : models.slice();
	
	      var at = options.at;
	      if (at != null) at = +at;
	      if (at > this.length) at = this.length;
	      if (at < 0) at += this.length + 1;
	
	      var set = [];
	      var toAdd = [];
	      var toMerge = [];
	      var toRemove = [];
	      var modelMap = {};
	
	      var add = options.add;
	      var merge = options.merge;
	      var remove = options.remove;
	
	      var sort = false;
	      var sortable = this.comparator && at == null && options.sort !== false;
	      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
	
	      // Turn bare objects into model references, and prevent invalid models
	      // from being added.
	      var model, i;
	      for (i = 0; i < models.length; i++) {
	        model = models[i];
	
	        // If a duplicate is found, prevent it from being added and
	        // optionally merge it into the existing model.
	        var existing = this.get(model);
	        if (existing) {
	          if (merge && model !== existing) {
	            var attrs = this._isModel(model) ? model.attributes : model;
	            if (options.parse) attrs = existing.parse(attrs, options);
	            existing.set(attrs, options);
	            toMerge.push(existing);
	            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
	          }
	          if (!modelMap[existing.cid]) {
	            modelMap[existing.cid] = true;
	            set.push(existing);
	          }
	          models[i] = existing;
	
	          // If this is a new, valid model, push it to the `toAdd` list.
	        } else if (add) {
	          model = models[i] = this._prepareModel(model, options);
	          if (model) {
	            toAdd.push(model);
	            this._addReference(model, options);
	            modelMap[model.cid] = true;
	            set.push(model);
	          }
	        }
	      }
	
	      // Remove stale models.
	      if (remove) {
	        for (i = 0; i < this.length; i++) {
	          model = this.models[i];
	          if (!modelMap[model.cid]) toRemove.push(model);
	        }
	        if (toRemove.length) this._removeModels(toRemove, options);
	      }
	
	      // See if sorting is needed, update `length` and splice in new models.
	      var orderChanged = false;
	      var replace = !sortable && add && remove;
	      if (set.length && replace) {
	        orderChanged = this.length !== set.length || _.some(this.models, function (m, index) {
	          return m !== set[index];
	        });
	        this.models.length = 0;
	        splice(this.models, set, 0);
	        this.length = this.models.length;
	      } else if (toAdd.length) {
	        if (sortable) sort = true;
	        splice(this.models, toAdd, at == null ? this.length : at);
	        this.length = this.models.length;
	      }
	
	      // Silently sort the collection if appropriate.
	      if (sort) this.sort({ silent: true });
	
	      // Unless silenced, it's time to fire all appropriate add/sort/update events.
	      if (!options.silent) {
	        for (i = 0; i < toAdd.length; i++) {
	          if (at != null) options.index = at + i;
	          model = toAdd[i];
	          model.trigger('add', model, this, options);
	        }
	        if (sort || orderChanged) this.trigger('sort', this, options);
	        if (toAdd.length || toRemove.length || toMerge.length) {
	          options.changes = {
	            added: toAdd,
	            removed: toRemove,
	            merged: toMerge
	          };
	          this.trigger('update', this, options);
	        }
	      }
	
	      // Return the added (or merged) model (or models).
	      return singular ? models[0] : models;
	    },
	
	    // When you have more items than you want to add or remove individually,
	    // you can reset the entire set with a new list of models, without firing
	    // any granular `add` or `remove` events. Fires `reset` when finished.
	    // Useful for bulk operations and optimizations.
	    reset: function (models, options) {
	      options = options ? _.clone(options) : {};
	      for (var i = 0; i < this.models.length; i++) {
	        this._removeReference(this.models[i], options);
	      }
	      options.previousModels = this.models;
	      this._reset();
	      models = this.add(models, _.extend({ silent: true }, options));
	      if (!options.silent) this.trigger('reset', this, options);
	      return models;
	    },
	
	    // Add a model to the end of the collection.
	    push: function (model, options) {
	      return this.add(model, _.extend({ at: this.length }, options));
	    },
	
	    // Remove a model from the end of the collection.
	    pop: function (options) {
	      var model = this.at(this.length - 1);
	      return this.remove(model, options);
	    },
	
	    // Add a model to the beginning of the collection.
	    unshift: function (model, options) {
	      return this.add(model, _.extend({ at: 0 }, options));
	    },
	
	    // Remove a model from the beginning of the collection.
	    shift: function (options) {
	      var model = this.at(0);
	      return this.remove(model, options);
	    },
	
	    // Slice out a sub-array of models from the collection.
	    slice: function () {
	      return slice.apply(this.models, arguments);
	    },
	
	    // Get a model from the set by id, cid, model object with id or cid
	    // properties, or an attributes object that is transformed through modelId.
	    get: function (obj) {
	      if (obj == null) return void 0;
	      return this._byId[obj] || this._byId[this.modelId(obj.attributes || obj)] || obj.cid && this._byId[obj.cid];
	    },
	
	    // Returns `true` if the model is in the collection.
	    has: function (obj) {
	      return this.get(obj) != null;
	    },
	
	    // Get the model at the given index.
	    at: function (index) {
	      if (index < 0) index += this.length;
	      return this.models[index];
	    },
	
	    // Return models with matching attributes. Useful for simple cases of
	    // `filter`.
	    where: function (attrs, first) {
	      return this[first ? 'find' : 'filter'](attrs);
	    },
	
	    // Return the first model with matching attributes. Useful for simple cases
	    // of `find`.
	    findWhere: function (attrs) {
	      return this.where(attrs, true);
	    },
	
	    // Force the collection to re-sort itself. You don't need to call this under
	    // normal circumstances, as the set will maintain sort order as each item
	    // is added.
	    sort: function (options) {
	      var comparator = this.comparator;
	      if (!comparator) throw new Error('Cannot sort a set without a comparator');
	      options || (options = {});
	
	      var length = comparator.length;
	      if (_.isFunction(comparator)) comparator = _.bind(comparator, this);
	
	      // Run sort based on type of `comparator`.
	      if (length === 1 || _.isString(comparator)) {
	        this.models = this.sortBy(comparator);
	      } else {
	        this.models.sort(comparator);
	      }
	      if (!options.silent) this.trigger('sort', this, options);
	      return this;
	    },
	
	    // Pluck an attribute from each model in the collection.
	    pluck: function (attr) {
	      return this.map(attr + '');
	    },
	
	    // Fetch the default set of models for this collection, resetting the
	    // collection when they arrive. If `reset: true` is passed, the response
	    // data will be passed through the `reset` method instead of `set`.
	    fetch: function (options) {
	      options = _.extend({ parse: true }, options);
	      var success = options.success;
	      var collection = this;
	      options.success = function (resp) {
	        var method = options.reset ? 'reset' : 'set';
	        collection[method](resp, options);
	        if (success) success.call(options.context, collection, resp, options);
	        collection.trigger('sync', collection, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Create a new instance of a model in this collection. Add the model to the
	    // collection immediately, unless `wait: true` is passed, in which case we
	    // wait for the server to agree.
	    create: function (model, options) {
	      options = options ? _.clone(options) : {};
	      var wait = options.wait;
	      model = this._prepareModel(model, options);
	      if (!model) return false;
	      if (!wait) this.add(model, options);
	      var collection = this;
	      var success = options.success;
	      options.success = function (m, resp, callbackOpts) {
	        if (wait) collection.add(m, callbackOpts);
	        if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
	      };
	      model.save(null, options);
	      return model;
	    },
	
	    // **parse** converts a response into a list of models to be added to the
	    // collection. The default implementation is just to pass it through.
	    parse: function (resp, options) {
	      return resp;
	    },
	
	    // Create a new collection with an identical list of models as this one.
	    clone: function () {
	      return new this.constructor(this.models, {
	        model: this.model,
	        comparator: this.comparator
	      });
	    },
	
	    // Define how to uniquely identify models in the collection.
	    modelId: function (attrs) {
	      return attrs[this.model.prototype.idAttribute || 'id'];
	    },
	
	    // Private method to reset all internal state. Called when the collection
	    // is first initialized or reset.
	    _reset: function () {
	      this.length = 0;
	      this.models = [];
	      this._byId = {};
	    },
	
	    // Prepare a hash of attributes (or other model) to be added to this
	    // collection.
	    _prepareModel: function (attrs, options) {
	      if (this._isModel(attrs)) {
	        if (!attrs.collection) attrs.collection = this;
	        return attrs;
	      }
	      options = options ? _.clone(options) : {};
	      options.collection = this;
	      var model = new this.model(attrs, options);
	      if (!model.validationError) return model;
	      this.trigger('invalid', this, model.validationError, options);
	      return false;
	    },
	
	    // Internal method called by both remove and set.
	    _removeModels: function (models, options) {
	      var removed = [];
	      for (var i = 0; i < models.length; i++) {
	        var model = this.get(models[i]);
	        if (!model) continue;
	
	        var index = this.indexOf(model);
	        this.models.splice(index, 1);
	        this.length--;
	
	        // Remove references before triggering 'remove' event to prevent an
	        // infinite loop. #3693
	        delete this._byId[model.cid];
	        var id = this.modelId(model.attributes);
	        if (id != null) delete this._byId[id];
	
	        if (!options.silent) {
	          options.index = index;
	          model.trigger('remove', model, this, options);
	        }
	
	        removed.push(model);
	        this._removeReference(model, options);
	      }
	      return removed;
	    },
	
	    // Method for checking whether an object should be considered a model for
	    // the purposes of adding to the collection.
	    _isModel: function (model) {
	      return model instanceof Model;
	    },
	
	    // Internal method to create a model's ties to a collection.
	    _addReference: function (model, options) {
	      this._byId[model.cid] = model;
	      var id = this.modelId(model.attributes);
	      if (id != null) this._byId[id] = model;
	      model.on('all', this._onModelEvent, this);
	    },
	
	    // Internal method to sever a model's ties to a collection.
	    _removeReference: function (model, options) {
	      delete this._byId[model.cid];
	      var id = this.modelId(model.attributes);
	      if (id != null) delete this._byId[id];
	      if (this === model.collection) delete model.collection;
	      model.off('all', this._onModelEvent, this);
	    },
	
	    // Internal method called every time a model in the set fires an event.
	    // Sets need to update their indexes when models change ids. All other
	    // events simply proxy through. "add" and "remove" events that originate
	    // in other collections are ignored.
	    _onModelEvent: function (event, model, collection, options) {
	      if (model) {
	        if ((event === 'add' || event === 'remove') && collection !== this) return;
	        if (event === 'destroy') this.remove(model, options);
	        if (event === 'change') {
	          var prevId = this.modelId(model.previousAttributes());
	          var id = this.modelId(model.attributes);
	          if (prevId !== id) {
	            if (prevId != null) delete this._byId[prevId];
	            if (id != null) this._byId[id] = model;
	          }
	        }
	      }
	      this.trigger.apply(this, arguments);
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Collection.
	  // 90% of the core usefulness of Backbone Collections is actually implemented
	  // right here:
	  var collectionMethods = { forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
	    foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
	    select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
	    contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
	    head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
	    without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
	    isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
	    sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3 };
	
	  // Mix in each Underscore method as a proxy to `Collection#models`.
	  addUnderscoreMethods(Collection, collectionMethods, 'models');
	
	  // Backbone.View
	  // -------------
	
	  // Backbone Views are almost more convention than they are actual code. A View
	  // is simply a JavaScript object that represents a logical chunk of UI in the
	  // DOM. This might be a single item, an entire list, a sidebar or panel, or
	  // even the surrounding frame which wraps your whole app. Defining a chunk of
	  // UI as a **View** allows you to define your DOM events declaratively, without
	  // having to worry about render order ... and makes it easy for the view to
	  // react to specific changes in the state of your models.
	
	  // Creating a Backbone.View creates its initial element outside of the DOM,
	  // if an existing element is not provided...
	  var View = Backbone.View = function (options) {
	    this.cid = _.uniqueId('view');
	    _.extend(this, _.pick(options, viewOptions));
	    this._ensureElement();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regex to split keys for `delegate`.
	  var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	
	  // List of view options to be set as properties.
	  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];
	
	  // Set up all inheritable **Backbone.View** properties and methods.
	  _.extend(View.prototype, Events, {
	
	    // The default `tagName` of a View's element is `"div"`.
	    tagName: 'div',
	
	    // jQuery delegate for element lookup, scoped to DOM elements within the
	    // current view. This should be preferred to global lookups where possible.
	    $: function (selector) {
	      return this.$el.find(selector);
	    },
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function () {},
	
	    // **render** is the core function that your view should override, in order
	    // to populate its element (`this.el`), with the appropriate HTML. The
	    // convention is for **render** to always return `this`.
	    render: function () {
	      return this;
	    },
	
	    // Remove this view by taking the element out of the DOM, and removing any
	    // applicable Backbone.Events listeners.
	    remove: function () {
	      this._removeElement();
	      this.stopListening();
	      return this;
	    },
	
	    // Remove this view's element from the document and all event listeners
	    // attached to it. Exposed for subclasses using an alternative DOM
	    // manipulation API.
	    _removeElement: function () {
	      this.$el.remove();
	    },
	
	    // Change the view's element (`this.el` property) and re-delegate the
	    // view's events on the new element.
	    setElement: function (element) {
	      this.undelegateEvents();
	      this._setElement(element);
	      this.delegateEvents();
	      return this;
	    },
	
	    // Creates the `this.el` and `this.$el` references for this view using the
	    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
	    // context or an element. Subclasses can override this to utilize an
	    // alternative DOM manipulation API and are only required to set the
	    // `this.el` property.
	    _setElement: function (el) {
	      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
	      this.el = this.$el[0];
	    },
	
	    // Set callbacks, where `this.events` is a hash of
	    //
	    // *{"event selector": "callback"}*
	    //
	    //     {
	    //       'mousedown .title':  'edit',
	    //       'click .button':     'save',
	    //       'click .open':       function(e) { ... }
	    //     }
	    //
	    // pairs. Callbacks will be bound to the view, with `this` set properly.
	    // Uses event delegation for efficiency.
	    // Omitting the selector binds the event to `this.el`.
	    delegateEvents: function (events) {
	      events || (events = _.result(this, 'events'));
	      if (!events) return this;
	      this.undelegateEvents();
	      for (var key in events) {
	        var method = events[key];
	        if (!_.isFunction(method)) method = this[method];
	        if (!method) continue;
	        var match = key.match(delegateEventSplitter);
	        this.delegate(match[1], match[2], _.bind(method, this));
	      }
	      return this;
	    },
	
	    // Add a single event listener to the view's element (or a child element
	    // using `selector`). This only works for delegate-able events: not `focus`,
	    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
	    delegate: function (eventName, selector, listener) {
	      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
	      return this;
	    },
	
	    // Clears all callbacks previously bound to the view by `delegateEvents`.
	    // You usually don't need to use this, but may wish to if you have multiple
	    // Backbone views attached to the same DOM element.
	    undelegateEvents: function () {
	      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
	      return this;
	    },
	
	    // A finer-grained `undelegateEvents` for removing a single delegated event.
	    // `selector` and `listener` are both optional.
	    undelegate: function (eventName, selector, listener) {
	      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
	      return this;
	    },
	
	    // Produces a DOM element to be assigned to your view. Exposed for
	    // subclasses using an alternative DOM manipulation API.
	    _createElement: function (tagName) {
	      return document.createElement(tagName);
	    },
	
	    // Ensure that the View has a DOM element to render into.
	    // If `this.el` is a string, pass it through `$()`, take the first
	    // matching element, and re-assign it to `el`. Otherwise, create
	    // an element from the `id`, `className` and `tagName` properties.
	    _ensureElement: function () {
	      if (!this.el) {
	        var attrs = _.extend({}, _.result(this, 'attributes'));
	        if (this.id) attrs.id = _.result(this, 'id');
	        if (this.className) attrs['class'] = _.result(this, 'className');
	        this.setElement(this._createElement(_.result(this, 'tagName')));
	        this._setAttributes(attrs);
	      } else {
	        this.setElement(_.result(this, 'el'));
	      }
	    },
	
	    // Set attributes from a hash on this view's element.  Exposed for
	    // subclasses using an alternative DOM manipulation API.
	    _setAttributes: function (attributes) {
	      this.$el.attr(attributes);
	    }
	
	  });
	
	  // Backbone.sync
	  // -------------
	
	  // Override this function to change the manner in which Backbone persists
	  // models to the server. You will be passed the type of request, and the
	  // model in question. By default, makes a RESTful Ajax request
	  // to the model's `url()`. Some possible customizations could be:
	  //
	  // * Use `setTimeout` to batch rapid-fire updates into a single request.
	  // * Send up the models as XML instead of JSON.
	  // * Persist models via WebSockets instead of Ajax.
	  //
	  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
	  // as `POST`, with a `_method` parameter containing the true HTTP method,
	  // as well as all requests with the body as `application/x-www-form-urlencoded`
	  // instead of `application/json` with the model in a param named `model`.
	  // Useful when interfacing with server-side languages like **PHP** that make
	  // it difficult to read the body of `PUT` requests.
	  Backbone.sync = function (method, model, options) {
	    var type = methodMap[method];
	
	    // Default options, unless specified.
	    _.defaults(options || (options = {}), {
	      emulateHTTP: Backbone.emulateHTTP,
	      emulateJSON: Backbone.emulateJSON
	    });
	
	    // Default JSON-request options.
	    var params = { type: type, dataType: 'json' };
	
	    // Ensure that we have a URL.
	    if (!options.url) {
	      params.url = _.result(model, 'url') || urlError();
	    }
	
	    // Ensure that we have the appropriate request data.
	    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
	      params.contentType = 'application/json';
	      params.data = JSON.stringify(options.attrs || model.toJSON(options));
	    }
	
	    // For older servers, emulate JSON by encoding the request into an HTML-form.
	    if (options.emulateJSON) {
	      params.contentType = 'application/x-www-form-urlencoded';
	      params.data = params.data ? { model: params.data } : {};
	    }
	
	    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
	    // And an `X-HTTP-Method-Override` header.
	    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
	      params.type = 'POST';
	      if (options.emulateJSON) params.data._method = type;
	      var beforeSend = options.beforeSend;
	      options.beforeSend = function (xhr) {
	        xhr.setRequestHeader('X-HTTP-Method-Override', type);
	        if (beforeSend) return beforeSend.apply(this, arguments);
	      };
	    }
	
	    // Don't process data on a non-GET request.
	    if (params.type !== 'GET' && !options.emulateJSON) {
	      params.processData = false;
	    }
	
	    // Pass along `textStatus` and `errorThrown` from jQuery.
	    var error = options.error;
	    options.error = function (xhr, textStatus, errorThrown) {
	      options.textStatus = textStatus;
	      options.errorThrown = errorThrown;
	      if (error) error.call(options.context, xhr, textStatus, errorThrown);
	    };
	
	    // Make the request, allowing the user to override any Ajax options.
	    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
	    model.trigger('request', model, xhr, options);
	    return xhr;
	  };
	
	  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
	  var methodMap = {
	    'create': 'POST',
	    'update': 'PUT',
	    'patch': 'PATCH',
	    'delete': 'DELETE',
	    'read': 'GET'
	  };
	
	  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
	  // Override this if you'd like to use a different library.
	  Backbone.ajax = function () {
	    return Backbone.$.ajax.apply(Backbone.$, arguments);
	  };
	
	  // Backbone.Router
	  // ---------------
	
	  // Routers map faux-URLs to actions, and fire events when routes are
	  // matched. Creating a new one sets its `routes` hash, if not set statically.
	  var Router = Backbone.Router = function (options) {
	    options || (options = {});
	    if (options.routes) this.routes = options.routes;
	    this._bindRoutes();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regular expressions for matching named param parts and splatted
	  // parts of route strings.
	  var optionalParam = /\((.*?)\)/g;
	  var namedParam = /(\(\?)?:\w+/g;
	  var splatParam = /\*\w+/g;
	  var escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;
	
	  // Set up all inheritable **Backbone.Router** properties and methods.
	  _.extend(Router.prototype, Events, {
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function () {},
	
	    // Manually bind a single named route to a callback. For example:
	    //
	    //     this.route('search/:query/p:num', 'search', function(query, num) {
	    //       ...
	    //     });
	    //
	    route: function (route, name, callback) {
	      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
	      if (_.isFunction(name)) {
	        callback = name;
	        name = '';
	      }
	      if (!callback) callback = this[name];
	      var router = this;
	      Backbone.history.route(route, function (fragment) {
	        var args = router._extractParameters(route, fragment);
	        if (router.execute(callback, args, name) !== false) {
	          router.trigger.apply(router, ['route:' + name].concat(args));
	          router.trigger('route', name, args);
	          Backbone.history.trigger('route', router, name, args);
	        }
	      });
	      return this;
	    },
	
	    // Execute a route handler with the provided parameters.  This is an
	    // excellent place to do pre-route setup or post-route cleanup.
	    execute: function (callback, args, name) {
	      if (callback) callback.apply(this, args);
	    },
	
	    // Simple proxy to `Backbone.history` to save a fragment into the history.
	    navigate: function (fragment, options) {
	      Backbone.history.navigate(fragment, options);
	      return this;
	    },
	
	    // Bind all defined routes to `Backbone.history`. We have to reverse the
	    // order of the routes here to support behavior where the most general
	    // routes can be defined at the bottom of the route map.
	    _bindRoutes: function () {
	      if (!this.routes) return;
	      this.routes = _.result(this, 'routes');
	      var route,
	          routes = _.keys(this.routes);
	      while ((route = routes.pop()) != null) {
	        this.route(route, this.routes[route]);
	      }
	    },
	
	    // Convert a route string into a regular expression, suitable for matching
	    // against the current location hash.
	    _routeToRegExp: function (route) {
	      route = route.replace(escapeRegExp, '\\$&').replace(optionalParam, '(?:$1)?').replace(namedParam, function (match, optional) {
	        return optional ? match : '([^/?]+)';
	      }).replace(splatParam, '([^?]*?)');
	      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
	    },
	
	    // Given a route, and a URL fragment that it matches, return the array of
	    // extracted decoded parameters. Empty or unmatched parameters will be
	    // treated as `null` to normalize cross-browser behavior.
	    _extractParameters: function (route, fragment) {
	      var params = route.exec(fragment).slice(1);
	      return _.map(params, function (param, i) {
	        // Don't decode the search params.
	        if (i === params.length - 1) return param || null;
	        return param ? decodeURIComponent(param) : null;
	      });
	    }
	
	  });
	
	  // Backbone.History
	  // ----------------
	
	  // Handles cross-browser history management, based on either
	  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
	  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
	  // and URL fragments. If the browser supports neither (old IE, natch),
	  // falls back to polling.
	  var History = Backbone.History = function () {
	    this.handlers = [];
	    this.checkUrl = _.bind(this.checkUrl, this);
	
	    // Ensure that `History` can be used outside of the browser.
	    if (typeof window !== 'undefined') {
	      this.location = window.location;
	      this.history = window.history;
	    }
	  };
	
	  // Cached regex for stripping a leading hash/slash and trailing space.
	  var routeStripper = /^[#\/]|\s+$/g;
	
	  // Cached regex for stripping leading and trailing slashes.
	  var rootStripper = /^\/+|\/+$/g;
	
	  // Cached regex for stripping urls of hash.
	  var pathStripper = /#.*$/;
	
	  // Has the history handling already been started?
	  History.started = false;
	
	  // Set up all inheritable **Backbone.History** properties and methods.
	  _.extend(History.prototype, Events, {
	
	    // The default interval to poll for hash changes, if necessary, is
	    // twenty times a second.
	    interval: 50,
	
	    // Are we at the app root?
	    atRoot: function () {
	      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
	      return path === this.root && !this.getSearch();
	    },
	
	    // Does the pathname match the root?
	    matchRoot: function () {
	      var path = this.decodeFragment(this.location.pathname);
	      var rootPath = path.slice(0, this.root.length - 1) + '/';
	      return rootPath === this.root;
	    },
	
	    // Unicode characters in `location.pathname` are percent encoded so they're
	    // decoded for comparison. `%25` should not be decoded since it may be part
	    // of an encoded parameter.
	    decodeFragment: function (fragment) {
	      return decodeURI(fragment.replace(/%25/g, '%2525'));
	    },
	
	    // In IE6, the hash fragment and search params are incorrect if the
	    // fragment contains `?`.
	    getSearch: function () {
	      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
	      return match ? match[0] : '';
	    },
	
	    // Gets the true hash value. Cannot use location.hash directly due to bug
	    // in Firefox where location.hash will always be decoded.
	    getHash: function (window) {
	      var match = (window || this).location.href.match(/#(.*)$/);
	      return match ? match[1] : '';
	    },
	
	    // Get the pathname and search params, without the root.
	    getPath: function () {
	      var path = this.decodeFragment(this.location.pathname + this.getSearch()).slice(this.root.length - 1);
	      return path.charAt(0) === '/' ? path.slice(1) : path;
	    },
	
	    // Get the cross-browser normalized URL fragment from the path or hash.
	    getFragment: function (fragment) {
	      if (fragment == null) {
	        if (this._usePushState || !this._wantsHashChange) {
	          fragment = this.getPath();
	        } else {
	          fragment = this.getHash();
	        }
	      }
	      return fragment.replace(routeStripper, '');
	    },
	
	    // Start the hash change handling, returning `true` if the current URL matches
	    // an existing route, and `false` otherwise.
	    start: function (options) {
	      if (History.started) throw new Error('Backbone.history has already been started');
	      History.started = true;
	
	      // Figure out the initial configuration. Do we need an iframe?
	      // Is pushState desired ... is it available?
	      this.options = _.extend({ root: '/' }, this.options, options);
	      this.root = this.options.root;
	      this._wantsHashChange = this.options.hashChange !== false;
	      this._hasHashChange = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
	      this._useHashChange = this._wantsHashChange && this._hasHashChange;
	      this._wantsPushState = !!this.options.pushState;
	      this._hasPushState = !!(this.history && this.history.pushState);
	      this._usePushState = this._wantsPushState && this._hasPushState;
	      this.fragment = this.getFragment();
	
	      // Normalize root to always include a leading and trailing slash.
	      this.root = ('/' + this.root + '/').replace(rootStripper, '/');
	
	      // Transition from hashChange to pushState or vice versa if both are
	      // requested.
	      if (this._wantsHashChange && this._wantsPushState) {
	
	        // If we've started off with a route from a `pushState`-enabled
	        // browser, but we're currently in a browser that doesn't support it...
	        if (!this._hasPushState && !this.atRoot()) {
	          var rootPath = this.root.slice(0, -1) || '/';
	          this.location.replace(rootPath + '#' + this.getPath());
	          // Return immediately as browser will do redirect to new url
	          return true;
	
	          // Or if we've started out with a hash-based route, but we're currently
	          // in a browser where it could be `pushState`-based instead...
	        } else if (this._hasPushState && this.atRoot()) {
	          this.navigate(this.getHash(), { replace: true });
	        }
	      }
	
	      // Proxy an iframe to handle location events if the browser doesn't
	      // support the `hashchange` event, HTML5 history, or the user wants
	      // `hashChange` but not `pushState`.
	      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
	        this.iframe = document.createElement('iframe');
	        this.iframe.src = 'javascript:0';
	        this.iframe.style.display = 'none';
	        this.iframe.tabIndex = -1;
	        var body = document.body;
	        // Using `appendChild` will throw on IE < 9 if the document is not ready.
	        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
	        iWindow.document.open();
	        iWindow.document.close();
	        iWindow.location.hash = '#' + this.fragment;
	      }
	
	      // Add a cross-platform `addEventListener` shim for older browsers.
	      var addEventListener = window.addEventListener || function (eventName, listener) {
	        return attachEvent('on' + eventName, listener);
	      };
	
	      // Depending on whether we're using pushState or hashes, and whether
	      // 'onhashchange' is supported, determine how we check the URL state.
	      if (this._usePushState) {
	        addEventListener('popstate', this.checkUrl, false);
	      } else if (this._useHashChange && !this.iframe) {
	        addEventListener('hashchange', this.checkUrl, false);
	      } else if (this._wantsHashChange) {
	        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
	      }
	
	      if (!this.options.silent) return this.loadUrl();
	    },
	
	    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
	    // but possibly useful for unit testing Routers.
	    stop: function () {
	      // Add a cross-platform `removeEventListener` shim for older browsers.
	      var removeEventListener = window.removeEventListener || function (eventName, listener) {
	        return detachEvent('on' + eventName, listener);
	      };
	
	      // Remove window listeners.
	      if (this._usePushState) {
	        removeEventListener('popstate', this.checkUrl, false);
	      } else if (this._useHashChange && !this.iframe) {
	        removeEventListener('hashchange', this.checkUrl, false);
	      }
	
	      // Clean up the iframe if necessary.
	      if (this.iframe) {
	        document.body.removeChild(this.iframe);
	        this.iframe = null;
	      }
	
	      // Some environments will throw when clearing an undefined interval.
	      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
	      History.started = false;
	    },
	
	    // Add a route to be tested when the fragment changes. Routes added later
	    // may override previous routes.
	    route: function (route, callback) {
	      this.handlers.unshift({ route: route, callback: callback });
	    },
	
	    // Checks the current URL to see if it has changed, and if it has,
	    // calls `loadUrl`, normalizing across the hidden iframe.
	    checkUrl: function (e) {
	      var current = this.getFragment();
	
	      // If the user pressed the back button, the iframe's hash will have
	      // changed and we should use that for comparison.
	      if (current === this.fragment && this.iframe) {
	        current = this.getHash(this.iframe.contentWindow);
	      }
	
	      if (current === this.fragment) return false;
	      if (this.iframe) this.navigate(current);
	      this.loadUrl();
	    },
	
	    // Attempt to load the current URL fragment. If a route succeeds with a
	    // match, returns `true`. If no defined routes matches the fragment,
	    // returns `false`.
	    loadUrl: function (fragment) {
	      // If the root doesn't match, no routes can match either.
	      if (!this.matchRoot()) return false;
	      fragment = this.fragment = this.getFragment(fragment);
	      return _.some(this.handlers, function (handler) {
	        if (handler.route.test(fragment)) {
	          handler.callback(fragment);
	          return true;
	        }
	      });
	    },
	
	    // Save a fragment into the hash history, or replace the URL state if the
	    // 'replace' option is passed. You are responsible for properly URL-encoding
	    // the fragment in advance.
	    //
	    // The options object can contain `trigger: true` if you wish to have the
	    // route callback be fired (not usually desirable), or `replace: true`, if
	    // you wish to modify the current URL without adding an entry to the history.
	    navigate: function (fragment, options) {
	      if (!History.started) return false;
	      if (!options || options === true) options = { trigger: !!options };
	
	      // Normalize the fragment.
	      fragment = this.getFragment(fragment || '');
	
	      // Don't include a trailing slash on the root.
	      var rootPath = this.root;
	      if (fragment === '' || fragment.charAt(0) === '?') {
	        rootPath = rootPath.slice(0, -1) || '/';
	      }
	      var url = rootPath + fragment;
	
	      // Strip the hash and decode for matching.
	      fragment = this.decodeFragment(fragment.replace(pathStripper, ''));
	
	      if (this.fragment === fragment) return;
	      this.fragment = fragment;
	
	      // If pushState is available, we use it to set the fragment as a real URL.
	      if (this._usePushState) {
	        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);
	
	        // If hash changes haven't been explicitly disabled, update the hash
	        // fragment to store history.
	      } else if (this._wantsHashChange) {
	        this._updateHash(this.location, fragment, options.replace);
	        if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
	          var iWindow = this.iframe.contentWindow;
	
	          // Opening and closing the iframe tricks IE7 and earlier to push a
	          // history entry on hash-tag change.  When replace is true, we don't
	          // want this.
	          if (!options.replace) {
	            iWindow.document.open();
	            iWindow.document.close();
	          }
	
	          this._updateHash(iWindow.location, fragment, options.replace);
	        }
	
	        // If you've told us that you explicitly don't want fallback hashchange-
	        // based history, then `navigate` becomes a page refresh.
	      } else {
	        return this.location.assign(url);
	      }
	      if (options.trigger) return this.loadUrl(fragment);
	    },
	
	    // Update the hash location, either replacing the current entry, or adding
	    // a new one to the browser history.
	    _updateHash: function (location, fragment, replace) {
	      if (replace) {
	        var href = location.href.replace(/(javascript:|#).*$/, '');
	        location.replace(href + '#' + fragment);
	      } else {
	        // Some browsers require that `hash` contains a leading #.
	        location.hash = '#' + fragment;
	      }
	    }
	
	  });
	
	  // Create the default Backbone.history.
	  Backbone.history = new History();
	
	  // Helpers
	  // -------
	
	  // Helper function to correctly set up the prototype chain for subclasses.
	  // Similar to `goog.inherits`, but uses a hash of prototype properties and
	  // class properties to be extended.
	  var extend = function (protoProps, staticProps) {
	    var parent = this;
	    var child;
	
	    // The constructor function for the new subclass is either defined by you
	    // (the "constructor" property in your `extend` definition), or defaulted
	    // by us to simply call the parent constructor.
	    if (protoProps && _.has(protoProps, 'constructor')) {
	      child = protoProps.constructor;
	    } else {
	      child = function () {
	        return parent.apply(this, arguments);
	      };
	    }
	
	    // Add static properties to the constructor function, if supplied.
	    _.extend(child, parent, staticProps);
	
	    // Set the prototype chain to inherit from `parent`, without calling
	    // `parent`'s constructor function and add the prototype properties.
	    child.prototype = _.create(parent.prototype, protoProps);
	    child.prototype.constructor = child;
	
	    // Set a convenience property in case the parent's prototype is needed
	    // later.
	    child.__super__ = parent.prototype;
	
	    return child;
	  };
	
	  // Set up inheritance for the model, collection, router, view and history.
	  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;
	
	  // Throw an error when a URL is needed, and none is supplied.
	  var urlError = function () {
	    throw new Error('A "url" property or function must be specified');
	  };
	
	  // Wrap an optional error callback with a fallback error event.
	  var wrapError = function (model, options) {
	    var error = options.error;
	    options.error = function (resp) {
	      if (error) error.call(options.context, model, resp, options);
	      model.trigger('error', model, resp, options);
	    };
	  };
	
	  return Backbone;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function () {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype,
	      ObjProto = Object.prototype,
	      FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeBind = FuncProto.bind,
	      nativeCreate = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function () {};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function (obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function (func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1:
	        return function (value) {
	          return func.call(context, value);
	        };
	      case 2:
	        return function (value, other) {
	          return func.call(context, value, other);
	        };
	      case 3:
	        return function (value, index, collection) {
	          return func.call(context, value, index, collection);
	        };
	      case 4:
	        return function (accumulator, value, index, collection) {
	          return func.call(context, accumulator, value, index, collection);
	        };
	    }
	    return function () {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function (value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function (value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function (keysFunc, undefinedOnly) {
	    return function (obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function (prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor();
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function (key) {
	    return function (obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function (collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function (obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function (obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function (obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function (obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function (obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function (value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function (obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function (obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function (obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function (obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function (obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function (value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function (obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function (obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function (obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function (obj, iteratee, context) {
	    var result = -Infinity,
	        lastComputed = -Infinity,
	        value,
	        computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function (value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function (obj, iteratee, context) {
	    var result = Infinity,
	        lastComputed = Infinity,
	        value,
	        computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function (value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function (obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function (obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function (obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function (value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function (left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function (behavior) {
	    return function (obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function (value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function (result, value, key) {
	    if (_.has(result, key)) result[key].push(value);else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function (result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function (result, value, key) {
	    if (_.has(result, key)) result[key]++;else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function (obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function (obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function (obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [],
	        fail = [];
	    _.each(obj, function (value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function (array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function (array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function (array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function (array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function (array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function (input, shallow, strict, startIndex) {
	    var output = [],
	        idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0,
	            len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function (array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function (array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function (array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function () {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function (array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function (array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function (value) {
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function () {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function (array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function (list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function (array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function (array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0,
	        high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1;else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function (array, item, idx) {
	      var i = 0,
	          length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function (start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function (sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function (func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function () {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function (func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function () {
	      var position = 0,
	          length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function (obj) {
	    var i,
	        length = arguments.length,
	        key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function (func, hasher) {
	    var memoize = function (key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function (func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function () {
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function (func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function () {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function () {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function (func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function () {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function () {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function (func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function (predicate) {
	    return function () {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function () {
	    var args = arguments;
	    var start = args.length - 1;
	    return function () {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function (times, func) {
	    return function () {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function (times, func) {
	    var memo;
	    return function () {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{ toString: null }.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function (obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function (obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function (obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function (obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = _.keys(obj),
	        length = keys.length,
	        results = {},
	        currentKey;
	    for (var index = 0; index < length; index++) {
	      currentKey = keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function (obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function (obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function (obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function (obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj),
	        key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function (object, oiteratee, context) {
	    var result = {},
	        obj = object,
	        iteratee,
	        keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function (value, key, obj) {
	        return key in obj;
	      };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	  // Return a copy of the object without the blacklisted properties.
	  _.omit = function (obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function (value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function (prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function (obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function (obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function (object, attrs) {
	    var keys = _.keys(attrs),
	        length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function (a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor,
	          bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a),
	          key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function (a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function (obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function (obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function (obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function (name) {
	    _['is' + name] = function (obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function (obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function (obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function (obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function (obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function (obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function (obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function (obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function (obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function () {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function (value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function (value) {
	    return function () {
	      return value;
	    };
	  };
	
	  _.noop = function () {};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function (obj) {
	    return obj == null ? function () {} : function (key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function (attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function (obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function (n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function (min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function () {
	    return new Date().getTime();
	  };
	
	  // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function (map) {
	    var escaper = function (match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function (string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function (object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function (prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function (match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function (text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function (data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function (obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function (instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function (obj) {
	    _.each(_.functions(obj), function (name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function () {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function () {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function (name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function () {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function () {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function () {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_, $, jQuery) {/**
	 * Galaxy utilities comprises small functions, which at this point
	 * do not require their own classes/files
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_l) {
	
	    /** Builds a basic iframe */
	    function iframe(src) {
	        return '<iframe src="' + src + '" frameborder="0" style="width: 100%; height: 100%;"/>';
	    }
	
	    /** Traverse through json */
	    function deepeach(dict, callback) {
	        for (var i in dict) {
	            var d = dict[i];
	            if (_.isObject(d)) {
	                var new_dict = callback(d);
	                new_dict && (dict[i] = new_dict);
	                deepeach(d, callback);
	            }
	        }
	    }
	
	    /** Identifies urls and replaces them with anchors */
	    function linkify(inputText) {
	        var replacedText, replacePattern1, replacePattern2, replacePattern3;
	
	        // URLs starting with http://, https://, or ftp://
	        replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
	        replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
	
	        // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
	        replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
	        replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
	
	        // Change email addresses to mailto:: links.
	        replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
	        replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
	
	        return replacedText;
	    }
	
	    /** Clone */
	    function clone(obj) {
	        return JSON.parse(JSON.stringify(obj) || null);
	    }
	
	    /**
	     * Check if a string is a json string
	     * @param{String}   text - Content to be validated
	     */
	    function isJSON(text) {
	        return (/^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))
	        );
	    }
	
	    /**
	     * Sanitize/escape a string
	     * @param{String}   content - Content to be sanitized
	     */
	    function sanitize(content) {
	        return $('<div/>').text(content).html();
	    }
	
	    /**
	     * Checks if a value or list of values is `empty`
	     * usually used for selectable options
	     * @param{String}   value - Value or list to be validated
	     */
	    function isEmpty(value) {
	        if (!(value instanceof Array)) {
	            value = [value];
	        }
	        if (value.length === 0) {
	            return true;
	        }
	        for (var i in value) {
	            if (['__null__', '__undefined__', null, undefined].indexOf(value[i]) > -1) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    /**
	     * Convert list to pretty string
	     * @param{String}   lst - List of strings to be converted in human readable list sentence
	     */
	    function textify(lst) {
	        if ($.isArray(lst)) {
	            var lst = lst.toString().replace(/,/g, ', ');
	            var pos = lst.lastIndexOf(', ');
	            if (pos != -1) {
	                lst = lst.substr(0, pos) + ' or ' + lst.substr(pos + 2);
	            }
	            return lst;
	        }
	        return '';
	    }
	
	    /**
	     * Request handler for GET
	     * @param{String}   url     - Url request is made to
	     * @param{Function} success - Callback on success
	     * @param{Function} error   - Callback on error
	     * @param{Boolean}  cache   - Use cached data if available
	     */
	    function get(options) {
	        top.__utils__get__ = top.__utils__get__ || {};
	        var cache_key = JSON.stringify(options);
	        if (options.cache && top.__utils__get__[cache_key]) {
	            options.success && options.success(top.__utils__get__[cache_key]);
	            window.console.debug('utils.js::get() - Fetching from cache [' + options.url + '].');
	        } else {
	            request({
	                url: options.url,
	                data: options.data,
	                success: function (response) {
	                    top.__utils__get__[cache_key] = response;
	                    options.success && options.success(response);
	                },
	                error: function (response, status) {
	                    options.error && options.error(response, status);
	                }
	            });
	        }
	    }
	
	    /**
	     * Request handler
	     * @param{String}   method  - Request method ['GET', 'POST', 'DELETE', 'PUT']
	     * @param{String}   url     - Url request is made to
	     * @param{Object}   data    - Data send to url
	     * @param{Function} success - Callback on success
	     * @param{Function} error   - Callback on error
	     */
	    function request(options) {
	        // prepare ajax
	        var ajaxConfig = {
	            contentType: 'application/json',
	            type: options.type || 'GET',
	            data: options.data || {},
	            url: options.url
	        };
	        // encode data into url
	        if (ajaxConfig.type == 'GET' || ajaxConfig.type == 'DELETE') {
	            if (!$.isEmptyObject(ajaxConfig.data)) {
	                ajaxConfig.url += ajaxConfig.url.indexOf('?') == -1 ? '?' : '&';
	                ajaxConfig.url += $.param(ajaxConfig.data, true);
	            }
	            ajaxConfig.data = null;
	        } else {
	            ajaxConfig.dataType = 'json';
	            ajaxConfig.url = ajaxConfig.url;
	            ajaxConfig.data = JSON.stringify(ajaxConfig.data);
	        }
	
	        // make request
	        $.ajax(ajaxConfig).done(function (response) {
	            if (typeof response === 'string') {
	                try {
	                    response = response.replace('Infinity,', '"Infinity",');
	                    response = jQuery.parseJSON(response);
	                } catch (e) {
	                    console.debug(e);
	                }
	            }
	            options.success && options.success(response);
	        }).fail(function (response) {
	            var response_text = null;
	            try {
	                response_text = jQuery.parseJSON(response.responseText);
	            } catch (e) {
	                response_text = response.responseText;
	            }
	            options.error && options.error(response_text, response.status);
	        }).always(function () {
	            options.complete && options.complete();
	        });
	    }
	
	    /**
	     * Read a property value from CSS
	     * @param{String}   classname   - CSS class
	     * @param{String}   name        - CSS property
	     */
	    function cssGetAttribute(classname, name) {
	        var el = $('<div class="' + classname + '"></div>');
	        el.appendTo(':eq(0)');
	        var value = el.css(name);
	        el.remove();
	        return value;
	    }
	
	    /**
	     * Load a CSS file
	     * @param{String}   url - Url of CSS file
	     */
	    function cssLoadFile(url) {
	        if (!$('link[href^="' + url + '"]').length) {
	            $('<link href="' + Galaxy.root + url + '" rel="stylesheet">').appendTo('head');
	        }
	    }
	
	    /**
	     * Safely merge to dictionaries
	     * @param{Object}   options         - Target dictionary
	     * @param{Object}   optionsDefault  - Source dictionary
	     */
	    function merge(options, optionsDefault) {
	        if (options) {
	            return _.defaults(options, optionsDefault);
	        } else {
	            return optionsDefault;
	        }
	    }
	
	    /**
	     * Round floaing point 'number' to 'numPlaces' number of decimal places.
	     * @param{Object}   number      a floaing point number
	     * @param{Object}   numPlaces   number of decimal places
	     */
	    function roundToDecimalPlaces(number, numPlaces) {
	        var placesMultiplier = 1;
	        for (var i = 0; i < numPlaces; i++) {
	            placesMultiplier *= 10;
	        }
	        return Math.round(number * placesMultiplier) / placesMultiplier;
	    }
	
	    // calculate on import
	    var kb = 1024,
	        mb = kb * kb,
	        gb = mb * kb,
	        tb = gb * kb;
	    /**
	     * Format byte size to string with units
	     * @param{Integer}   size           - Size in bytes
	     * @param{Boolean}   normal_font    - Switches font between normal and bold
	     */
	    function bytesToString(size, normal_font, numberPlaces) {
	        numberPlaces = numberPlaces !== undefined ? numberPlaces : 1;
	        // identify unit
	        var unit = "";
	        if (size >= tb) {
	            size = size / tb;unit = 'TB';
	        } else if (size >= gb) {
	            size = size / gb;unit = 'GB';
	        } else if (size >= mb) {
	            size = size / mb;unit = 'MB';
	        } else if (size >= kb) {
	            size = size / kb;unit = 'KB';
	        } else if (size > 0) {
	            unit = 'b';
	        } else {
	            return normal_font ? '0 b' : '<strong>-</strong>';
	        }
	        // return formatted string
	        var rounded = unit == 'b' ? size : roundToDecimalPlaces(size, numberPlaces);
	        if (normal_font) {
	            return rounded + ' ' + unit;
	        } else {
	            return '<strong>' + rounded + '</strong> ' + unit;
	        }
	    }
	
	    /** Create a unique id */
	    function uid() {
	        top.__utils__uid__ = top.__utils__uid__ || 0;
	        return 'uid-' + top.__utils__uid__++;
	    }
	
	    /** Create a time stamp */
	    function time() {
	        var d = new Date();
	        var hours = (d.getHours() < 10 ? "0" : "") + d.getHours();
	        var minutes = (d.getMinutes() < 10 ? "0" : "") + d.getMinutes();
	        return datetime = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() + ", " + hours + ":" + minutes;
	    }
	
	    /** Append script and style tags to Galaxy main application */
	    function appendScriptStyle(data) {
	        // create a script tag inside head tag
	        if (data.script && data.script !== "") {
	            $('<script/>', { type: 'text/javascript' }).text(data.script).appendTo('head');
	        }
	        // create a style tag inside head tag
	        if (data.styles && data.styles !== "") {
	            $('<style/>', { type: 'text/css' }).text(data.styles).appendTo('head');
	        }
	    }
	
	    /** Get querystrings from url */
	    function getQueryString(key) {
	        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
	    }
	
	    function setWindowTitle(title) {
	        if (title) {
	            window.document.title = "Galaxy " + (window.Galaxy.config.brand ? " | " + window.Galaxy.config.brand : '') + " | " + _l(title);
	        } else {
	            window.document.title = "Galaxy " + (window.Galaxy.config.brand ? " | " + window.Galaxy.config.brand : '');
	        }
	    }
	
	    return {
	        cssLoadFile: cssLoadFile,
	        cssGetAttribute: cssGetAttribute,
	        get: get,
	        merge: merge,
	        iframe: iframe,
	        bytesToString: bytesToString,
	        uid: uid,
	        time: time,
	        request: request,
	        sanitize: sanitize,
	        textify: textify,
	        isEmpty: isEmpty,
	        deepeach: deepeach,
	        isJSON: isJSON,
	        clone: clone,
	        linkify: linkify,
	        appendScriptStyle: appendScriptStyle,
	        getQueryString: getQueryString,
	        setWindowTitle: setWindowTitle
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(101)], __WEBPACK_AMD_DEFINE_RESULT__ = function (localeStrings) {
	
	    // =============================================================================
	    /** Simple string replacement localization. Language data from galaxy/scripts/nls */
	
	    // support both requirejs and webpack from the same file
	    // if loaded via webpack, it will be a different format than via requirejs - convert
	    if (localeStrings.hasOwnProperty('__root')) {
	        //console.debug( 'amdi18n+webpack localization for ' + locale + ' loaded' );
	        var locale = typeof navigator === 'undefined' ? '__root' : (navigator.language || navigator.userLanguage || '__root').toLowerCase();
	        localeStrings = localeStrings['__' + locale] || localeStrings['__' + locale.split('-')[0]] || localeStrings.__root;
	
	        // } else {
	        //     console.debug( 'i18n+requirejs localization for ' + locale + ' loaded' );
	    }
	    // TODO: when this is no longer necessary remove this, i18n.js, and the resolveModule in config
	
	    // -----------------------------------------------------------------------------
	    /** Attempt to get a localized string for strToLocalize. If not found, return
	     *      the original strToLocalize.
	     * @param {String} strToLocalize the string to localize
	     * @returns either the localized string if found or strToLocalize if not found
	     */
	    var localize = function (strToLocalize) {
	        // console.debug( 'amdi18n.localize:', strToLocalize, '->', localeStrings[ strToLocalize ] || strToLocalize );
	
	        // //TODO: conditional compile on DEBUG flag
	        // // cache strings that need to be localized but haven't been?
	        // if( localize.cacheNonLocalized && !localeStrings.hasOwnProperty( strToLocalize ) ){
	        //     // console.debug( 'localization NOT found:', strToLocalize );
	        //     // add nonCached as hash directly to this function
	        //     localize.nonLocalized = localize.nonLocalized || {};
	        //     localize.nonLocalized[ locale ] = localize.nonLocalized[ locale ] || {};
	        //     localize.nonLocalized[ locale ][ strToLocalize ] = false;
	        // }
	
	        // return the localized version from the closure if it's there, the strToLocalize if not
	        return localeStrings[strToLocalize] || strToLocalize;
	    };
	    localize.cacheNonLocalized = false;
	
	    // =============================================================================
	    return localize;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(2), __webpack_require__(99), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, addLogging, _l) {
	    'use strict';
	
	    //==============================================================================
	    /** @class Mixin to add logging capabilities to an object.
	     *      Designed to allow switching an objects log output off/on at one central
	     *      statement. Can be used with plain browser console (or something more
	     *      complex like an AJAX logger).
	     *  <br />NOTE: currently only uses the console.debug log function
	     *  (as opposed to debug, error, warn, etc.)
	     *  @name LoggableMixin
	     *
	     *  @example
	     *  // Add to your models/views at the definition using chaining:
	     *      var MyModel = Backbone.Model.extend( LoggableMixin ).extend({ // ... });
	     *
	     *  // or - more explicitly AFTER the definition:
	     *      var MyModel = Backbone.Model.extend({
	     *          logger  : console
	     *          // ...
	     *          this.log( '$#%& it! - broken already...' );
	     *      })
	     *      _.extend( MyModel.prototype, LoggableMixin )
	     *
	     */
	
	    var LoggableMixin = /** @lends LoggableMixin# */{
	        // replace null with console (if available) to see all logs for a particular view/model
	        /** The logging object whose log function will be used to output
	         *      messages. Null will supress all logging. Commonly set to console.
	         */
	        logger: null,
	        /** @type {String} a namespace for filtering/focusing log output */
	        _logNamespace: '.'
	
	    };
	    addLogging(LoggableMixin);
	
	    //==============================================================================
	    /** Backbone model that syncs to the browser's sessionStorage API.
	     *      This all largely happens behind the scenes and no special calls are required.
	     */
	    var SessionStorageModel = Backbone.Model.extend({
	        initialize: function (initialAttrs) {
	            // check for sessionStorage and error if no id is provided
	            this._checkEnabledSessionStorage();
	            if (!initialAttrs.id) {
	                throw new Error('SessionStorageModel requires an id in the initial attributes');
	            }
	            this.id = initialAttrs.id;
	
	            // load existing from storage (if any), clear any attrs set by bbone before init is called,
	            //  layer initial over existing and defaults, and save
	            var existing = !this.isNew() ? this._read(this) : {};
	            this.clear({ silent: true });
	            this.save(_.extend({}, this.defaults, existing, initialAttrs), { silent: true });
	
	            // save on any change to it immediately
	            this.on('change', function () {
	                this.save();
	            });
	        },
	
	        _checkEnabledSessionStorage: function () {
	            try {
	                return window.sessionStorage.length >= 0;
	            } catch (err) {
	                alert('Please enable cookies in your browser for this Galaxy site');
	                return false;
	            }
	        },
	
	        /** override of bbone sync to save to sessionStorage rather than REST
	         *      bbone options (success, errror, etc.) should still apply
	         */
	        sync: function (method, model, options) {
	            if (!options.silent) {
	                model.trigger('request', model, {}, options);
	            }
	            var returned = {};
	            switch (method) {
	                case 'create':
	                    returned = this._create(model);break;
	                case 'read':
	                    returned = this._read(model);break;
	                case 'update':
	                    returned = this._update(model);break;
	                case 'delete':
	                    returned = this._delete(model);break;
	            }
	            if (returned !== undefined || returned !== null) {
	                if (options.success) {
	                    options.success();
	                }
	            } else {
	                if (options.error) {
	                    options.error();
	                }
	            }
	            return returned;
	        },
	
	        /** set storage to the stringified item */
	        _create: function (model) {
	            try {
	                var json = model.toJSON(),
	                    set = sessionStorage.setItem(model.id, JSON.stringify(json));
	                return set === null ? set : json;
	                // DOMException is thrown in Safari if in private browsing mode and sessionStorage is attempted:
	                // http://stackoverflow.com/questions/14555347
	                // TODO: this could probably use a more general soln - like detecting priv. mode + safari => non-ajaxing Model
	            } catch (err) {
	                if (!(err instanceof DOMException && navigator.userAgent.indexOf("Safari") > -1)) {
	                    throw err;
	                }
	            }
	            return null;
	        },
	
	        /** read and parse json from storage */
	        _read: function (model) {
	            return JSON.parse(sessionStorage.getItem(model.id));
	        },
	
	        /** set storage to the item (alias to create) */
	        _update: function (model) {
	            return model._create(model);
	        },
	
	        /** remove the item from storage */
	        _delete: function (model) {
	            return sessionStorage.removeItem(model.id);
	        },
	
	        /** T/F whether sessionStorage contains the model's id (data is present) */
	        isNew: function () {
	            return !sessionStorage.hasOwnProperty(this.id);
	        },
	
	        _log: function () {
	            return JSON.stringify(this.toJSON(), null, '  ');
	        },
	        toString: function () {
	            return 'SessionStorageModel(' + this.id + ')';
	        }
	
	    });
	    (function () {
	        SessionStorageModel.prototype = _.omit(SessionStorageModel.prototype, 'url', 'urlRoot');
	    })();
	
	    //==============================================================================
	    /** Function that allows mixing of hashs into bbone MVC while showing the mixins first
	     *      (before the more local class overrides/hash).
	     *      Basically, a simple reversal of param order on _.defaults() - to show mixins in top of definition.
	     *  @example:
	     *      var NewModel = Something.extend( mixin( MyMixinA, MyMixinB, { ... myVars : ... }) );
	     *
	     *  NOTE: this does not combine any hashes (like events, etc.) and you're expected to handle that
	     */
	    function mixin(mixinHash1, /* mixinHash2, etc: ... variadic */propsHash) {
	        var args = Array.prototype.slice.call(arguments, 0),
	            lastArg = args.pop();
	        args.unshift(lastArg);
	        return _.defaults.apply(_, args);
	    }
	
	    //==============================================================================
	    /** A mixin for models that allow T/F/Matching to their attributes - useful when
	     *      searching or filtering collections of models.
	     * @example:
	     *      see hda-model for searchAttribute and searchAliases definition examples.
	     *      see history-contents.matches for how collections are filtered
	     *      and see readonly-history-view.searchHdas for how user input is connected to the filtering
	     */
	    var SearchableModelMixin = {
	
	        /** what attributes of an HDA will be used in a text search */
	        searchAttributes: [
	            // override
	        ],
	
	        /** our attr keys don't often match the labels we display to the user - so, when using
	         *      attribute specifiers ('name="bler"') in a term, allow passing in aliases for the
	         *      following attr keys.
	         */
	        searchAliases: {
	            // override
	        },
	
	        /** search the attribute with key attrKey for the string searchFor; T/F if found */
	        searchAttribute: function (attrKey, searchFor) {
	            var attrVal = this.get(attrKey);
	            //this.debug( 'searchAttribute', attrKey, attrVal, searchFor );
	            // bail if empty searchFor or unsearchable values
	            if (!searchFor || attrVal === undefined || attrVal === null) {
	                return false;
	            }
	            // pass to sep. fn for deep search of array attributes
	            if (_.isArray(attrVal)) {
	                return this._searchArrayAttribute(attrVal, searchFor);
	            }
	            return attrVal.toString().toLowerCase().indexOf(searchFor.toLowerCase()) !== -1;
	        },
	
	        /** deep(er) search for array attributes; T/F if found */
	        _searchArrayAttribute: function (array, searchFor) {
	            //this.debug( '_searchArrayAttribute', array, searchFor );
	            searchFor = searchFor.toLowerCase();
	            //precondition: searchFor has already been validated as non-empty string
	            //precondition: assumes only 1 level array
	            //TODO: could possibly break up searchFor more (CSV...)
	            return _.any(array, function (elem) {
	                return elem.toString().toLowerCase().indexOf(searchFor.toLowerCase()) !== -1;
	            });
	        },
	
	        /** search all searchAttributes for the string searchFor,
	         *      returning a list of keys of attributes that contain searchFor
	         */
	        search: function (searchFor) {
	            var model = this;
	            return _.filter(this.searchAttributes, function (key) {
	                return model.searchAttribute(key, searchFor);
	            });
	        },
	
	        /** alias of search, but returns a boolean; accepts attribute specifiers where
	         *      the attributes searched can be narrowed to a single attribute using
	         *      the form: matches( 'genome_build=hg19' )
	         *      (the attribute keys allowed can also be aliases to the true attribute key;
	         *          see searchAliases above)
	         *  @param {String} term   plain text or ATTR_SPECIFIER sep. key=val pair
	         *  @returns {Boolean} was term found in (any) attribute(s)
	         */
	        matches: function (term) {
	            var ATTR_SPECIFIER = '=',
	                split = term.split(ATTR_SPECIFIER);
	            // attribute is specified - search only that
	            if (split.length >= 2) {
	                var attrKey = split[0];
	                attrKey = this.searchAliases[attrKey] || attrKey;
	                return this.searchAttribute(attrKey, split[1]);
	            }
	            // no attribute is specified - search all attributes in searchAttributes
	            return !!this.search(term).length;
	        },
	
	        /** an implicit AND search for all terms; IOW, a model must match all terms given
	         *      where terms is a whitespace separated value string.
	         *      e.g. given terms of: 'blah bler database=hg19'
	         *          an HDA would have to have attributes containing blah AND bler AND a genome_build == hg19
	         *      To include whitespace in terms: wrap the term in double quotations (name="blah bler").
	         */
	        matchesAll: function (terms) {
	            var model = this;
	            // break the terms up by whitespace and filter out the empty strings
	            terms = terms.match(/(".*"|\w*=".*"|\S*)/g).filter(function (s) {
	                return !!s;
	            });
	            return _.all(terms, function (term) {
	                term = term.replace(/"/g, '');
	                return model.matches(term);
	            });
	        }
	    };
	
	    //==============================================================================
	    /** A view that renders hidden and shows when some activator is clicked.
	     *      options:
	     *          showFn: the effect used to show/hide the View (defaults to jq.toggle)
	     *          $elementShown: some jqObject (defaults to this.$el) to be shown/hidden
	     *          onShowFirstTime: fn called the first time the view is shown
	     *          onshow: fn called every time the view is shown
	     *          onhide: fn called every time the view is hidden
	     *      events:
	     *          hiddenUntilActivated:shown (the view is passed as an arg)
	     *          hiddenUntilActivated:hidden (the view is passed as an arg)
	     *      instance vars:
	     *          view.hidden {boolean} is the view in the hidden state
	     */
	    var HiddenUntilActivatedViewMixin = /** @lends hiddenUntilActivatedMixin# */{
	        //TODO: since this is a mixin, consider moving toggle, hidden into HUAVOptions
	
	        /** call this in your initialize to set up the mixin
	         *  @param {jQuery} $activator the 'button' that's clicked to show/hide the view
	         *  @param {Object} hash with mixin options
	         */
	        hiddenUntilActivated: function ($activator, options) {
	            // call this in your view's initialize fn
	            options = options || {};
	            //TODO: flesh out options - show them all here
	            this.HUAVOptions = {
	                $elementShown: this.$el,
	                showFn: jQuery.prototype.toggle,
	                showSpeed: 'fast'
	            };
	            _.extend(this.HUAVOptions, options || {});
	            /** has this been shown already (and onshowFirstTime called)? */
	            this.HUAVOptions.hasBeenShown = this.HUAVOptions.$elementShown.is(':visible');
	            this.hidden = this.isHidden();
	
	            if ($activator) {
	                var mixin = this;
	                $activator.on('click', function (ev) {
	                    mixin.toggle(mixin.HUAVOptions.showSpeed);
	                });
	            }
	        },
	
	        //TODO:?? remove? use .hidden?
	        /** returns T/F if the view is hidden */
	        isHidden: function () {
	            return this.HUAVOptions.$elementShown.is(':hidden');
	        },
	
	        /** toggle the hidden state, show/hide $elementShown, call onshow/hide, trigger events */
	        toggle: function () {
	            //TODO: more specific name - toggle is too general
	            // can be called manually as well with normal toggle arguments
	            //TODO: better as a callback (when the show/hide is actually done)
	            // show
	            if (this.hidden) {
	                // fire the optional fns on the first/each showing - good for render()
	                if (!this.HUAVOptions.hasBeenShown) {
	                    if (_.isFunction(this.HUAVOptions.onshowFirstTime)) {
	                        this.HUAVOptions.hasBeenShown = true;
	                        this.HUAVOptions.onshowFirstTime.call(this);
	                    }
	                }
	                if (_.isFunction(this.HUAVOptions.onshow)) {
	                    this.HUAVOptions.onshow.call(this);
	                    this.trigger('hiddenUntilActivated:shown', this);
	                }
	                this.hidden = false;
	
	                // hide
	            } else {
	                if (_.isFunction(this.HUAVOptions.onhide)) {
	                    this.HUAVOptions.onhide.call(this);
	                    this.trigger('hiddenUntilActivated:hidden', this);
	                }
	                this.hidden = true;
	            }
	            return this.HUAVOptions.showFn.apply(this.HUAVOptions.$elementShown, arguments);
	        }
	    };
	
	    //==============================================================================
	    /** Mixin for views that can be dragged and dropped
	     *      Allows for the drag behavior to be turned on/off, setting/removing jQuery event
	     *          handlers each time.
	     *      dataTransfer data is set to the JSON string of the view's model.toJSON
	     *      Override '$dragHandle' to define the draggable DOM sub-element.
	     */
	    var DraggableViewMixin = {
	
	        /** set up instance vars to track whether this view is currently draggable */
	        initialize: function (attributes) {
	            /** is the body of this hda view expanded/not? */
	            this.draggable = attributes.draggable || false;
	        },
	
	        /** what part of the view's DOM triggers the dragging */
	        $dragHandle: function () {
	            //TODO: make abstract/general - move this to listItem
	            // override to the element you want to be your view's handle
	            return this.$('.title-bar');
	        },
	
	        /** toggle whether this view is draggable */
	        toggleDraggable: function () {
	            if (this.draggable) {
	                this.draggableOff();
	            } else {
	                this.draggableOn();
	            }
	        },
	
	        /** allow the view to be dragged, set up event handlers */
	        draggableOn: function () {
	            this.draggable = true;
	            this.dragStartHandler = _.bind(this._dragStartHandler, this);
	            this.dragEndHandler = _.bind(this._dragEndHandler, this);
	
	            var handle = this.$dragHandle().attr('draggable', true).get(0);
	            handle.addEventListener('dragstart', this.dragStartHandler, false);
	            handle.addEventListener('dragend', this.dragEndHandler, false);
	        },
	
	        /** turn of view dragging and remove event listeners */
	        draggableOff: function () {
	            this.draggable = false;
	            var handle = this.$dragHandle().attr('draggable', false).get(0);
	            handle.removeEventListener('dragstart', this.dragStartHandler, false);
	            handle.removeEventListener('dragend', this.dragEndHandler, false);
	        },
	
	        /** sets the dataTransfer data to the model's toJSON
	         *  @fires draggable:dragstart (bbone event) which is passed the event and this view
	         */
	        _dragStartHandler: function (event) {
	            event.dataTransfer.effectAllowed = 'move';
	            //ASSUMES: this.model
	            //TODO: all except IE: should be 'application/json', IE: must be 'text'
	            event.dataTransfer.setData('text', JSON.stringify(this.model.toJSON()));
	            this.trigger('draggable:dragstart', event, this);
	            return false;
	        },
	
	        /** handle the dragend
	         *  @fires draggable:dragend (bbone event) which is passed the event and this view
	         */
	        _dragEndHandler: function (event) {
	            this.trigger('draggable:dragend', event, this);
	            return false;
	        }
	    };
	
	    //==============================================================================
	    /** Mixin that allows a view to be selected (gen. from a list).
	     *      Selection controls ($selector) may be hidden/shown/toggled.
	     *          The bbone event 'selectable' is fired when the controls are shown/hidden (passed T/F).
	     *      Default rendering is a font-awesome checkbox.
	     *      Default selector is '.selector' within the view's $el.
	     *      The bbone events 'selected' and 'de-selected' are fired when the $selector is clicked.
	     *          Both events are passed the view and the (jQuery) event.
	     */
	    var SelectableViewMixin = {
	
	        /** Set up instance state vars for whether the selector is shown and whether the view has been selected */
	        initialize: function (attributes) {
	            /** is the view currently in selection mode? */
	            this.selectable = attributes.selectable || false;
	            /** is the view currently selected? */
	            this.selected = attributes.selected || false;
	        },
	
	        /** $el sub-element where the selector is rendered and what can be clicked to select. */
	        $selector: function () {
	            return this.$('.selector');
	        },
	
	        /** How the selector is rendered - defaults to font-awesome checkbox */
	        _renderSelected: function () {
	            // override
	            this.$selector().find('span').toggleClass('fa-check-square-o', this.selected).toggleClass('fa-square-o', !this.selected);
	        },
	
	        /** Toggle whether the selector is shown */
	        toggleSelector: function () {
	            //TODO: use this.selectable
	            if (!this.$selector().is(':visible')) {
	                this.showSelector();
	            } else {
	                this.hideSelector();
	            }
	        },
	
	        /** Display the selector control.
	         *  @param {Number} a jQuery fx speed
	         *  @fires: selectable which is passed true (IOW, the selector is shown) and the view
	         */
	        showSelector: function (speed) {
	            speed = speed !== undefined ? speed : this.fxSpeed;
	            // make sure selected state is represented properly
	            this.selectable = true;
	            this.trigger('selectable', true, this);
	            this._renderSelected();
	            if (speed) {
	                this.$selector().show(speed);
	            } else {
	                this.$selector().show();
	            }
	        },
	
	        /** remove the selector control
	         *  @param {Number} a jQuery fx speed
	         *  @fires: selectable which is passed false (IOW, the selector is not shown) and the view
	         */
	        hideSelector: function (speed) {
	            speed = speed !== undefined ? speed : this.fxSpeed;
	            // reverse the process from showSelect
	            this.selectable = false;
	            this.trigger('selectable', false, this);
	            if (speed) {
	                this.$selector().hide(speed);
	            } else {
	                this.$selector().hide();
	            }
	        },
	
	        /** Toggle whether the view is selected */
	        toggleSelect: function (event) {
	            if (this.selected) {
	                this.deselect(event);
	            } else {
	                this.select(event);
	            }
	        },
	
	        /** Select this view and re-render the selector control to show it
	         *  @param {Event} a jQuery event that caused the selection
	         *  @fires: selected which is passed the view and the DOM event that triggered it (optionally)
	         */
	        select: function (event) {
	            // switch icon, set selected, and trigger event
	            if (!this.selected) {
	                this.trigger('selected', this, event);
	                this.selected = true;
	                this._renderSelected();
	            }
	            return false;
	        },
	
	        /** De-select this view and re-render the selector control to show it
	         *  @param {Event} a jQuery event that caused the selection
	         *  @fires: de-selected which is passed the view and the DOM event that triggered it (optionally)
	         */
	        deselect: function (event) {
	            // switch icon, set selected, and trigger event
	            if (this.selected) {
	                this.trigger('de-selected', this, event);
	                this.selected = false;
	                this._renderSelected();
	            }
	            return false;
	        }
	    };
	
	    //==============================================================================
	    /** Return an underscore template fn from an array of strings.
	     *  @param {String[]} template      the template strings to compile into the underscore template fn
	     *  @param {String} jsonNamespace   an optional namespace for the json data passed in (defaults to 'model')
	     *  @returns {Function} the (wrapped) underscore template fn
	     *      The function accepts:
	     *
	     *  The template strings can access:
	     *      the json/model hash using model ("<%- model.myAttr %>) using the jsonNamespace above
	     *      _l: the localizer function
	     *      view (if passed): ostensibly, the view using the template (handy for view instance vars)
	     *      Because they're namespaced, undefined attributes will not throw an error.
	     *
	     *  @example:
	     *      templateBler : BASE_MVC.wrapTemplate([
	     *          '<div class="myclass <%- mynamespace.modelClass %>">',
	     *              '<span><% print( _l( mynamespace.message ) ); %>:<%= view.status %></span>'
	     *          '</div>'
	     *      ], 'mynamespace' )
	     *
	     *  Meant to be called in a View's definition in order to compile only once.
	     *
	     */
	    function wrapTemplate(template, jsonNamespace) {
	        jsonNamespace = jsonNamespace || 'model';
	        var templateFn = _.template(template.join(''));
	        return function (json, view) {
	            var templateVars = { view: view || {}, _l: _l };
	            templateVars[jsonNamespace] = json || {};
	            return templateFn(templateVars);
	        };
	    }
	
	    //==============================================================================
	    /** Return a comparator function for sorted Collections */
	    function buildComparator(attribute_name, options) {
	        options = options || {};
	        var ascending = options.ascending ? 1 : -1;
	        return function __comparator(a, b) {
	            a = a.get(attribute_name);
	            b = b.get(attribute_name);
	            return (a < b ? -1 : a > b ? 1 : 0) * ascending;
	        };
	    }
	
	    //==============================================================================
	    return {
	        LoggableMixin: LoggableMixin,
	        SessionStorageModel: SessionStorageModel,
	        mixin: mixin,
	        SearchableModelMixin: SearchableModelMixin,
	        HiddenUntilActivatedViewMixin: HiddenUntilActivatedViewMixin,
	        DraggableViewMixin: DraggableViewMixin,
	        SelectableViewMixin: SelectableViewMixin,
	        wrapTemplate: wrapTemplate,
	        buildComparator: buildComparator
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var View = Backbone.View.extend({
	
	        className: "ui-modal",
	
	        // defaults
	        optionsDefault: {
	            container: 'body',
	            title: 'ui-modal',
	            cls: 'ui-modal',
	            body: '',
	            backdrop: true,
	            height: null,
	            width: null,
	            closing_events: false,
	            closing_callback: null,
	            title_separator: true
	        },
	
	        // button list
	        buttonList: {},
	
	        // initialize
	        initialize: function (options) {
	            this.options = _.defaults(options || {}, this.optionsDefault);
	            $(this.options.container).prepend(this.el);
	            // optional render
	            options && this.render();
	        },
	
	        /**
	         * Displays modal
	        */
	        show: function (options) {
	            if (options) {
	                this.options = _.defaults(options, this.optionsDefault);
	                this.render();
	            }
	            if (!this.visible) {
	                this.visible = true;
	                this.$el.fadeIn('fast');
	                if (this.options.closing_events) {
	                    var self = this;
	                    $(document).on('keyup.ui-modal', function (e) {
	                        e.keyCode == 27 && self.hide(true);
	                    });
	                    this.$backdrop.on('click', function () {
	                        self.hide(true);
	                    });
	                }
	            }
	        },
	
	        /**
	         * Hide modal
	        */
	        hide: function (canceled) {
	            this.visible = false;
	            this.$el.fadeOut('fast');
	            this.options.closing_callback && this.options.closing_callback(canceled);
	            $(document).off('keyup.ui-modal');
	            this.$backdrop.off('click');
	        },
	
	        /**
	         * Render modal
	        */
	        render: function () {
	            var self = this;
	            this.$el.html(this._template());
	
	            // link elements
	            this.$header = this.$('.modal-header');
	            this.$dialog = this.$('.modal-dialog');
	            this.$body = this.$('.modal-body');
	            this.$footer = this.$('.modal-footer');
	            this.$backdrop = this.$('.modal-backdrop');
	            this.$buttons = this.$('.buttons');
	
	            if (this.options.body == 'progress') {
	                this.options.body = $('<div class="progress progress-striped active">' + '<div class="progress-bar progress-bar-info" style="width:100%"/>' + '</div>');
	            }
	
	            // fix main content
	            this.$el.removeClass().addClass('modal').addClass(this.options.cls);
	            this.$header.find('.title').html(this.options.title);
	            this.$body.html(this.options.body);
	
	            // append buttons
	            this.$buttons.empty();
	            this.buttonList = {};
	            if (this.options.buttons) {
	                var counter = 0;
	                $.each(this.options.buttons, function (name, callback) {
	                    var $button = $('<button/>').attr('id', 'button-' + counter++).text(name).click(callback);
	                    self.$buttons.append($button).append('&nbsp;');
	                    self.buttonList[name] = $button;
	                });
	            } else {
	                this.$footer.hide();
	            }
	
	            // configure background, separator line
	            this.$backdrop[this.options.backdrop && 'addClass' || 'removeClass']('in');
	            this.$header[!this.options.title_separator && 'addClass' || 'removeClass']('no-separator');
	
	            // fix dimensions
	            // note: because this is a singleton, we need to clear inline styles from any previous invocations
	            this.$body.removeAttr('style');
	            if (this.options.height) {
	                this.$body.css('height', this.options.height);
	                this.$body.css('overflow', 'hidden');
	            } else {
	                this.$body.css('max-height', $(window).height() / 2);
	            }
	            if (this.options.width) {
	                this.$dialog.css('width', this.options.width);
	            }
	        },
	
	        /**
	         * Returns the button dom
	         * @param{String}   name    - Button name/title
	        */
	        getButton: function (name) {
	            return this.buttonList[name];
	        },
	
	        /**
	         * Enables a button
	         * @param{String}   name    - Button name/title
	        */
	        enableButton: function (name) {
	            this.getButton(name).prop('disabled', false);
	        },
	
	        /**
	         * Disables a button
	         * @param{String}   name    - Button name/title
	        */
	        disableButton: function (name) {
	            this.getButton(name).prop('disabled', true);
	        },
	
	        /**
	         * Show a button
	         * @param{String}   name    - Button name/title
	        */
	        showButton: function (name) {
	            this.getButton(name).show();
	        },
	
	        /**
	         * Hide a button
	         * @param{String}   name    - Button name/title
	        */
	        hideButton: function (name) {
	            this.getButton(name).hide();
	        },
	
	        /**
	         * Returns scroll top for body element
	        */
	        scrollTop: function () {
	            return this.$body.scrollTop();
	        },
	
	        /**
	         * Returns the modal template
	        */
	        _template: function () {
	            return '<div class="modal-backdrop fade"/>' + '<div class="modal-dialog">' + '<div class="modal-content">' + '<div class="modal-header">' + '<h4 class="title"/>' + '</div>' + '<div class="modal-body"/>' + '<div class="modal-footer">' + '<div class="buttons"/>' + '</div>' + '</div>' + '</div>';
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    // ============================================================================
	    function get(key, queryString) {
	        queryString = queryString || window.location.search.substr(1);
	        var keyRegex = new RegExp(key + '=([^&#$]+)', 'g');
	        var matches = queryString.match(keyRegex);
	        if (!matches || !matches.length) {
	            return undefined;
	        }
	        matches = _.map(matches, function (match) {
	            return decodeURIComponent(match.substr(key.length + 1).replace(/\+/g, ' '));
	        });
	        if (matches.length === 1) {
	            return matches[0];
	        }
	        return matches;
	    }
	
	    function parse(queryString) {
	        if (!queryString) {
	            return {};
	        }
	        var parsed = {},
	            split = queryString.split('&');
	        split.forEach(function (pairString) {
	            var pair = pairString.split('=');
	            parsed[pair[0]] = decodeURI(pair[1]);
	        });
	        return parsed;
	    }
	
	    // ============================================================================
	    return {
	        get: get,
	        parse: parse
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {/**
	  Webhooks
	**/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var WebhookModel = Backbone.Model.extend({
	        defaults: {
	            activate: false
	        }
	    });
	
	    var Webhooks = Backbone.Collection.extend({
	        model: WebhookModel
	    });
	
	    var WebhookView = Backbone.View.extend({
	        el: '#webhook-view',
	
	        initialize: function (options) {
	            var me = this;
	            var toolId = options.toolId || '';
	            var toolVersion = options.toolVersion || '';
	
	            this.$el.attr('tool_id', toolId);
	            this.$el.attr('tool_version', toolVersion);
	
	            this.model = new WebhookModel();
	            this.model.urlRoot = options.urlRoot;
	            this.model.fetch({
	                success: function () {
	                    me.render();
	                }
	            });
	        },
	
	        render: function () {
	            var webhook = this.model.toJSON();
	
	            this.$el.html('<div id="' + webhook.name + '"></div>');
	            if (webhook.styles) $('<style/>', { type: 'text/css' }).text(webhook.styles).appendTo('head');
	            if (webhook.script) $('<script/>', { type: 'text/javascript' }).text(webhook.script).appendTo('head');
	
	            return this;
	        }
	    });
	
	    var add = function (options) {
	        var webhooks = new Webhooks();
	
	        webhooks.url = Galaxy.root + options.url;
	        webhooks.fetch({
	            async: options.async ? options.async : true,
	            success: options.callback
	        });
	    };
	
	    return {
	        Webhooks: Webhooks,
	        WebhookView: WebhookView,
	        add: add
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, _) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    /** Frame view */
	    var FrameView = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.model = options && options.model || new Backbone.Model(options);
	            this.setElement($('<div/>').addClass('corner frame'));
	            this.$el.append($('<div/>').addClass('f-header corner').append($('<div/>').addClass('f-title')).append($('<div/>').addClass('f-icon f-close fa fa-close').tooltip({ title: 'Close', placement: 'bottom' }))).append($('<div/>').addClass('f-content')).append($('<div/>').addClass('f-resize f-icon corner fa fa-expand').tooltip({ title: 'Resize' })).append($('<div/>').addClass('f-cover'));
	            this.$header = this.$('.f-header');
	            this.$title = this.$('.f-title');
	            this.$content = this.$('.f-content');
	            this.render();
	            this.listenTo(this.model, 'change', this.render, this);
	        },
	
	        render: function () {
	            var self = this;
	            var options = this.model.attributes;
	            this.$title.html(options.title || '');
	            this.$header.find('.f-icon-left').remove();
	            _.each(options.menu, function (option) {
	                var $option = $('<div/>').addClass('f-icon-left').addClass(option.icon);
	                if (_.isFunction(option.disabled) && option.disabled()) {
	                    $option.attr('disabled', true);
	                } else {
	                    $option.on('click', function () {
	                        option.onclick(self);
	                    }).tooltip({ title: option.tooltip, placement: 'bottom' });
	                }
	                self.$header.append($option);
	            });
	            if (options.url) {
	                this.$content.html($('<iframe/>').addClass('f-iframe').attr('scrolling', 'auto').attr('src', options.url + (options.url.indexOf('?') === -1 ? '?' : '&') + 'widget=True'));
	            } else if (options.content) {
	                _.isFunction(options.content) ? options.content(self.$content) : self.$content.html(options.content);
	            }
	        }
	    });
	
	    /** Scratchbook viewer */
	    var View = Backbone.View.extend({
	        defaultOptions: {
	            frame: { // default frame size in cells
	                cols: 6,
	                rows: 3
	            },
	            rows: 1000, // maximum number of rows
	            cell: 130, // cell size in px
	            margin: 5, // margin between frames
	            scroll: 5, // scroll speed
	            top_min: 40, // top margin
	            frame_max: 9, // maximum number of frames
	            visible: true // initial visibility
	        },
	
	        cols: 0, // number of columns
	        top: 0, // scroll/element top
	        top_max: 0, // viewport scrolling state
	        frame_z: 0, // frame z-index
	        frame_counter: 0, // frame counter
	        frame_uid: 0, // unique frame id counter
	        frame_list: {}, // list of all frames
	        frame_shadow: null, // frame shown as placeholder when moving active frames
	        visible: false, // flag indicating if scratchbook viewer is visible or not
	        event: {}, // dictionary keeping track of current event
	
	        initialize: function (options) {
	            var self = this;
	            this.options = _.defaults(options || {}, this.defaultOptions);
	            this.visible = this.options.visible;
	            this.top = this.top_max = this.options.top_min;
	            this.setElement($('<div/>').addClass('galaxy-frame').append($('<div/>').addClass('frame-background')).append($('<div/>').addClass('frame-menu frame-scroll-up fa fa-chevron-up fa-2x')).append($('<div/>').addClass('frame-menu frame-scroll-down fa fa-chevron-down fa-2x')));
	
	            // initialize shadow to guiding drag/resize events
	            this.frame_shadow = new Backbone.View({ el: $('<div/>').addClass('corner frame-shadow') });
	            this.$el.append(this.frame_shadow.$el);
	            this._frameInit(this.frame_shadow, '#frame-shadow');
	            this._frameResize(this.frame_shadow, { width: 0, height: 0 });
	            this.frame_list['#frame-shadow'] = this.frame_shadow;
	
	            // initialize panel
	            this.visible ? this.show() : this.hide();
	            this._panelRefresh();
	            $(window).resize(function () {
	                self.visible && self._panelRefresh();
	            });
	        },
	
	        /** Render */
	        render: function () {
	            this.$('.frame-scroll-up')[this.top != this.options.top_min && 'show' || 'hide']();
	            this.$('.frame-scroll-down')[this.top != this.top_max && 'show' || 'hide']();
	        },
	
	        /**
	         * Adds and displays a new frame.
	         *
	         * options:
	         *  url     : loaded into an iframe
	         *  content : content is treated as a function or raw HTML, function is passed a single
	         *              argument that is the frame's content DOM element
	         */
	        add: function (options) {
	            if (this.frame_counter >= this.options.frame_max) {
	                Galaxy.modal.show({
	                    title: 'Warning',
	                    body: 'You have reached the maximum number of allowed frames (' + this.options.frame_max + ').',
	                    buttons: { 'Close': function () {
	                            Galaxy.modal.hide();
	                        } }
	                });
	            } else {
	                var frame_id = '#frame-' + this.frame_uid++;
	                if ($(frame_id).length !== 0) {
	                    Galaxy.modal.show({
	                        title: 'Error',
	                        body: 'This frame already exists. This page might contain multiple frame managers.',
	                        buttons: { 'Close': function () {
	                                Galaxy.modal.hide();
	                            } }
	                    });
	                } else {
	                    // initialize new frame elements
	                    this.top = this.options.top_min;
	                    var frame = new FrameView(options);
	                    this.$el.append(frame.$el);
	
	                    // set dimensions
	                    options.width = this._toPixelCoord('width', this.options.frame.cols);
	                    options.height = this._toPixelCoord('height', this.options.frame.rows);
	
	                    // set default z-index and add to ui and frame list
	                    this.frame_z = parseInt(frame.$el.css('z-index'));
	                    this.frame_list[frame_id] = frame;
	                    this.frame_counter++;
	                    this._frameInit(frame, frame_id);
	                    this._frameResize(frame, { width: options.width, height: options.height });
	                    this._frameInsert(frame, { top: 0, left: 0 }, true);
	                    !this.visible && this.show();
	                    this.trigger('add');
	                }
	            }
	        },
	
	        /** Remove a frame */
	        del: function (frame) {
	            var self = this;
	            var $frame = frame.$el;
	            $frame.fadeOut('fast', function () {
	                $frame.remove();
	                delete self.frame_list[frame.id];
	                self.frame_counter--;
	                self._panelRefresh(true);
	                self._panelAnimationComplete();
	                self.trigger('remove');
	            });
	        },
	
	        /** Show panel */
	        show: function () {
	            this.visible = true;
	            this.$el.fadeIn('fast');
	            this.trigger('show');
	        },
	
	        /** Hide panel */
	        hide: function () {
	            if (!this.event.type) {
	                this.visible = false;
	                this.$el.fadeOut('fast', function () {
	                    $(this).hide();
	                });
	                this.trigger('hide');
	            }
	        },
	
	        /** Returns the number of frames */
	        length: function () {
	            return this.frame_counter;
	        },
	
	        /*
	            EVENT HANDLING
	        */
	        events: {
	            // global frame events
	            'mousemove': '_eventFrameMouseMove',
	            'mouseup': '_eventFrameMouseUp',
	            'mouseleave': '_eventFrameMouseUp',
	            'mousewheel': '_eventPanelScroll',
	            'DOMMouseScroll': '_eventPanelScroll',
	
	            // events fixed to elements
	            'mousedown .frame': '_eventFrameMouseDown',
	            'mousedown .frame-background': '_eventHide',
	            'mousedown .frame-scroll-up': '_eventPanelScroll_up',
	            'mousedown .frame-scroll-down': '_eventPanelScroll_down',
	            'mousedown .f-close': '_eventFrameClose'
	        },
	
	        /** Start drag/resize event */
	        _eventFrameMouseDown: function (e) {
	            $('.tooltip').hide();
	            if (!this.event.type) {
	                if ($(e.target).hasClass('f-header') || $(e.target).hasClass('f-title')) {
	                    this.event.type = 'drag';
	                }
	                if ($(e.target).hasClass('f-resize')) {
	                    this.event.type = 'resize';
	                }
	                if (this.event.type) {
	                    e.preventDefault();
	                    this.event.target = this._frameIdentify(e.target);
	                    this.event.xy = {
	                        x: e.originalEvent.pageX,
	                        y: e.originalEvent.pageY
	                    };
	                    this._frameDragStart(this.event.target);
	                }
	            }
	        },
	
	        /** Processes drag/resize events */
	        _eventFrameMouseMove: function (e) {
	            if (this.event.type) {
	                // get mouse motion and delta
	                var event_xy_new = {
	                    x: e.originalEvent.pageX,
	                    y: e.originalEvent.pageY
	                };
	                var event_xy_delta = {
	                    x: event_xy_new.x - this.event.xy.x,
	                    y: event_xy_new.y - this.event.xy.y
	                };
	                this.event.xy = event_xy_new;
	
	                // get current screen position and size of frame
	                var p = this._frameScreen(this.event.target);
	
	                // drag/resize event
	                if (this.event.type == 'resize') {
	                    p.width += event_xy_delta.x;
	                    p.height += event_xy_delta.y;
	                    var min_dim = this.options.cell - this.options.margin - 1;
	                    p.width = Math.max(p.width, min_dim);
	                    p.height = Math.max(p.height, min_dim);
	                    this._frameResize(this.event.target, p);
	                    p.width = this._toGridCoord('width', p.width) + 1;
	                    p.height = this._toGridCoord('height', p.height) + 1;
	                    p.width = this._toPixelCoord('width', p.width);
	                    p.height = this._toPixelCoord('height', p.height);
	                    this._frameResize(this.frame_shadow, p);
	                    this._frameInsert(this.frame_shadow, {
	                        top: this._toGridCoord('top', p.top),
	                        left: this._toGridCoord('left', p.left)
	                    });
	                } else if (this.event.type == 'drag') {
	                    p.left += event_xy_delta.x;
	                    p.top += event_xy_delta.y;
	                    this._frameOffset(this.event.target, p);
	                    var l = {
	                        top: this._toGridCoord('top', p.top),
	                        left: this._toGridCoord('left', p.left)
	                    };
	                    l.left !== 0 && l.left++;
	                    this._frameInsert(this.frame_shadow, l);
	                }
	            }
	        },
	
	        /** Stop drag/resize events */
	        _eventFrameMouseUp: function (e) {
	            if (this.event.type) {
	                this._frameDragStop(this.event.target);
	                this.event.type = null;
	            }
	        },
	
	        /** Destroy a frame */
	        _eventFrameClose: function (e) {
	            if (!this.event.type) {
	                e.preventDefault();
	                this.del(this._frameIdentify(e.target));
	            }
	        },
	
	        /** Hide all frames */
	        _eventHide: function (e) {
	            !this.event.type && this.hide();
	        },
	
	        /** Fired when scrolling occurs on panel */
	        _eventPanelScroll: function (e) {
	            if (!this.event.type && this.visible) {
	                // Stop propagation if scrolling is happening inside a frame.
	                // TODO: could propagate scrolling if at top/bottom of frame.
	                var frames = $(e.srcElement).parents('.frame');
	                if (frames.length !== 0) {
	                    e.stopPropagation();
	                } else {
	                    e.preventDefault();
	                    this._panelScroll(e.originalEvent.detail ? e.originalEvent.detail : e.originalEvent.wheelDelta / -3);
	                }
	            }
	        },
	
	        /** Handle scroll up event */
	        _eventPanelScroll_up: function (e) {
	            if (!this.event.type) {
	                e.preventDefault();
	                this._panelScroll(-this.options.scroll);
	            }
	        },
	
	        /** Handle scroll down */
	        _eventPanelScroll_down: function (e) {
	            if (!this.event.type) {
	                e.preventDefault();
	                this._panelScroll(this.options.scroll);
	            }
	        },
	
	        /*
	            FRAME EVENTS SUPPORT
	        */
	
	        /** Identify the target frame */
	        _frameIdentify: function (target) {
	            return this.frame_list['#' + $(target).closest('.frame').attr('id')];
	        },
	
	        /** Provides drag support */
	        _frameDragStart: function (frame) {
	            this._frameFocus(frame, true);
	            var p = this._frameScreen(frame);
	            this._frameResize(this.frame_shadow, p);
	            this._frameGrid(this.frame_shadow, frame.grid_location);
	            frame.grid_location = null;
	            this.frame_shadow.$el.show();
	            $('.f-cover').show();
	        },
	
	        /** Removes drag support */
	        _frameDragStop: function (frame) {
	            this._frameFocus(frame, false);
	            var p = this._frameScreen(this.frame_shadow);
	            this._frameResize(frame, p);
	            this._frameGrid(frame, this.frame_shadow.grid_location, true);
	            this.frame_shadow.grid_location = null;
	            this.frame_shadow.$el.hide();
	            $('.f-cover').hide();
	            this._panelAnimationComplete();
	        },
	
	        /*
	            GRID/PIXEL CONVERTER
	        */
	
	        /** Converts a pixel to a grid dimension */
	        _toGridCoord: function (type, px) {
	            var sign = type == 'width' || type == 'height' ? 1 : -1;
	            type == 'top' && (px -= this.top);
	            return parseInt((px + sign * this.options.margin) / this.options.cell, 10);
	        },
	
	        /** Converts a grid to a pixels dimension */
	        _toPixelCoord: function (type, g) {
	            var sign = type == 'width' || type == 'height' ? 1 : -1;
	            var px = g * this.options.cell - sign * this.options.margin;
	            type == 'top' && (px += this.top);
	            return px;
	        },
	
	        /** Converts a pixel to a grid coordinate set */
	        _toGrid: function (px) {
	            return {
	                top: this._toGridCoord('top', px.top),
	                left: this._toGridCoord('left', px.left),
	                width: this._toGridCoord('width', px.width),
	                height: this._toGridCoord('height', px.height)
	            };
	        },
	
	        /** Converts a pixel to a grid coordinate set */
	        _toPixel: function (g) {
	            return {
	                top: this._toPixelCoord('top', g.top),
	                left: this._toPixelCoord('left', g.left),
	                width: this._toPixelCoord('width', g.width),
	                height: this._toPixelCoord('height', g.height)
	            };
	        },
	
	        /* 
	            COLLISION DETECTION
	        */
	
	        /** Check collisions for a grid coordinate set */
	        _isCollision: function (g) {
	            function is_collision_pair(a, b) {
	                return !(a.left > b.left + b.width - 1 || a.left + a.width - 1 < b.left || a.top > b.top + b.height - 1 || a.top + a.height - 1 < b.top);
	            }
	            for (var i in this.frame_list) {
	                var frame = this.frame_list[i];
	                if (frame.grid_location !== null && is_collision_pair(g, frame.grid_location)) {
	                    return true;
	                }
	            }
	            return false;
	        },
	
	        /** Return location/grid rank */
	        _locationRank: function (loc) {
	            return loc.top * this.cols + loc.left;
	        },
	
	        /*
	            PANEL/WINDOW FUNCTIONS
	        */
	
	        /** Refresh panel */
	        _panelRefresh: function (animate) {
	            this.cols = parseInt($(window).width() / this.options.cell, 10) + 1;
	            this._frameInsert(null, null, animate);
	        },
	
	        /** Complete panel animation / frames not moving */
	        _panelAnimationComplete: function () {
	            var self = this;
	            $('.frame').promise().done(function () {
	                self._panelScroll(0, true);
	            });
	        },
	
	        /** Scroll panel */
	        _panelScroll: function (delta, animate) {
	            var top_new = this.top - this.options.scroll * delta;
	            top_new = Math.max(top_new, this.top_max);
	            top_new = Math.min(top_new, this.options.top_min);
	            if (this.top != top_new) {
	                for (var i in this.frame_list) {
	                    var frame = this.frame_list[i];
	                    if (frame.grid_location !== null) {
	                        var screen_location = {
	                            top: frame.screen_location.top - (this.top - top_new),
	                            left: frame.screen_location.left
	                        };
	                        this._frameOffset(frame, screen_location, animate);
	                    }
	                }
	                this.top = top_new;
	            }
	            this.render();
	        },
	
	        /*
	            FRAME FUNCTIONS
	        */
	
	        /** Initialize a new frame */
	        _frameInit: function (frame, id) {
	            frame.id = id;
	            frame.screen_location = {};
	            frame.grid_location = {};
	            frame.grid_rank = null;
	            frame.$el.attr('id', id.substring(1));
	        },
	
	        /** Insert frame at given location */
	        _frameInsert: function (frame, new_loc, animate) {
	            var self = this;
	            var place_list = [];
	            if (frame) {
	                frame.grid_location = null;
	                place_list.push([frame, this._locationRank(new_loc)]);
	            }
	            _.each(this.frame_list, function (f) {
	                if (f.grid_location !== null) {
	                    f.grid_location = null;
	                    place_list.push([f, f.grid_rank]);
	                }
	            });
	            place_list.sort(function (a, b) {
	                return a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0;
	            });
	            _.each(place_list, function (place) {
	                self._framePlace(place[0], animate);
	            });
	            this.top_max = 0;
	            _.each(this.frame_list, function (f) {
	                if (f.grid_location !== null) {
	                    self.top_max = Math.max(self.top_max, f.grid_location.top + f.grid_location.height);
	                }
	            });
	            this.top_max = $(window).height() - this.top_max * this.options.cell - 2 * this.options.margin;
	            this.top_max = Math.min(this.top_max, this.options.top_min);
	            this.render();
	        },
	
	        /** Naive frame placement */
	        _framePlace: function (frame, animate) {
	            frame.grid_location = null;
	            var g = this._toGrid(this._frameScreen(frame));
	            var done = false;
	            for (var i = 0; i < this.options.rows; i++) {
	                for (var j = 0; j < Math.max(1, this.cols - g.width); j++) {
	                    g.top = i;
	                    g.left = j;
	                    if (!this._isCollision(g)) {
	                        done = true;
	                        break;
	                    }
	                }
	                if (done) {
	                    break;
	                }
	            }
	            if (done) {
	                this._frameGrid(frame, g, animate);
	            } else {
	                console.log('Grid dimensions exceeded.');
	            }
	        },
	
	        /** Handle frame focussing */
	        _frameFocus: function (frame, has_focus) {
	            frame.$el.css('z-index', this.frame_z + (has_focus ? 1 : 0));
	        },
	
	        /** New left/top position frame */
	        _frameOffset: function (frame, p, animate) {
	            frame.screen_location.left = p.left;
	            frame.screen_location.top = p.top;
	            if (animate) {
	                this._frameFocus(frame, true);
	                var self = this;
	                frame.$el.animate({ top: p.top, left: p.left }, 'fast', function () {
	                    self._frameFocus(frame, false);
	                });
	            } else {
	                frame.$el.css({ top: p.top, left: p.left });
	            }
	        },
	
	        /** Resize frame */
	        _frameResize: function (frame, p) {
	            frame.$el.css({ width: p.width, height: p.height });
	            frame.screen_location.width = p.width;
	            frame.screen_location.height = p.height;
	        },
	
	        /** Push frame to new grid location */
	        _frameGrid: function (frame, l, animate) {
	            frame.grid_location = l;
	            this._frameOffset(frame, this._toPixel(l), animate);
	            frame.grid_rank = this._locationRank(l);
	        },
	
	        /** Get frame dimensions */
	        _frameScreen: function (frame) {
	            var p = frame.screen_location;
	            return { top: p.top, left: p.left, width: p.width, height: p.height };
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(2), __webpack_require__(7), __webpack_require__(95), __webpack_require__(157), __webpack_require__(99), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, BASE_MVC, userModel, metricsLogger, addLogging, localize) {
	
	    // TODO: move into a singleton pattern and have dependents import Galaxy
	    // ============================================================================
	    /** Base galaxy client-side application.
	     *      Iniitializes:
	     *          logger      : the logger/metrics-logger
	     *          localize    : the string localizer
	     *          config      : the current configuration (any k/v in
	     *              galaxy.ini available from the configuration API)
	     *          user        : the current user (as a mvc/user/user-model)
	     */
	    function GalaxyApp(options, bootstrapped) {
	        var self = this;
	        return self._init(options || {}, bootstrapped || {});
	    }
	
	    // add logging shortcuts for this object
	    addLogging(GalaxyApp, 'GalaxyApp');
	
	    // a debug flag can be set via local storage and made available during script/page loading
	    var DEBUGGING_KEY = 'galaxy:debug',
	        NAMESPACE_KEY = DEBUGGING_KEY + ':namespaces',
	        localDebugging = false;
	    try {
	        localDebugging = localStorage.getItem(DEBUGGING_KEY) == 'true';
	    } catch (storageErr) {
	        console.log(localize('localStorage not available for debug flag retrieval'));
	    }
	
	    /** initalize options and sub-components */
	    GalaxyApp.prototype._init = function __init(options, bootstrapped) {
	        var self = this;
	        _.extend(self, Backbone.Events);
	        if (localDebugging) {
	            self.logger = console;
	            console.debug('debugging galaxy:', 'options:', options, 'bootstrapped:', bootstrapped);
	        }
	
	        self._processOptions(options);
	
	        // add root and url parameters
	        self.root = options.root || '/';
	        self.params = options.params || {};
	        self.session_csrf_token = options.session_csrf_token || null;
	
	        self._initConfig(options.config || {});
	        self._patchGalaxy(window.Galaxy);
	
	        self._initLogger(self.options.loggerOptions || {});
	        // at this point, either logging or not and namespaces are enabled - chat it up
	        self.debug('GalaxyApp.options: ', self.options);
	        self.debug('GalaxyApp.config: ', self.config);
	        self.debug('GalaxyApp.logger: ', self.logger);
	
	        self._initLocale();
	        self.debug('GalaxyApp.localize: ', self.localize);
	
	        self.config = options.config || {};
	        self.debug('GalaxyApp.config: ', self.config);
	
	        self._initUser(options.user || {});
	        self.debug('GalaxyApp.user: ', self.user);
	
	        self._setUpListeners();
	        self.trigger('ready', self);
	
	        return self;
	    };
	
	    /** default options */
	    GalaxyApp.prototype.defaultOptions = {
	        /** monkey patch attributes from existing window.Galaxy object? */
	        patchExisting: true,
	        /** root url of this app */
	        root: '/',
	        session_csrf_token: null
	    };
	
	    /** filter to options present in defaultOptions (and default to them) */
	    GalaxyApp.prototype._processOptions = function _processOptions(options) {
	        var self = this,
	            defaults = self.defaultOptions;
	
	        self.options = {};
	        for (var k in defaults) {
	            if (defaults.hasOwnProperty(k)) {
	                self.options[k] = options.hasOwnProperty(k) ? options[k] : defaults[k];
	            }
	        }
	        return self;
	    };
	
	    /** parse the config and any extra info derived from it */
	    GalaxyApp.prototype._initConfig = function _initConfig(config) {
	        var self = this;
	        self.config = config;
	
	        // give precendence to localdebugging for this setting
	        self.config.debug = localDebugging || self.config.debug;
	
	        return self;
	    };
	
	    /** add an option from options if the key matches an option in defaultOptions */
	    GalaxyApp.prototype._patchGalaxy = function _patchGalaxy(patchWith) {
	        var self = this;
	        // in case req or plain script tag order has created a prev. version of the Galaxy obj...
	        if (self.options.patchExisting && patchWith) {
	            // self.debug( 'found existing Galaxy object:', patchWith );
	            // ...(for now) monkey patch any added attributes that the previous Galaxy may have had
	            //TODO: move those attributes to more formal assignment in GalaxyApp
	            for (var k in patchWith) {
	                if (patchWith.hasOwnProperty(k)) {
	                    // self.debug( '\t patching in ' + k + ' to Galaxy:', self[ k ] );
	                    self[k] = patchWith[k];
	                }
	            }
	        }
	    };
	
	    /** set up the metrics logger (utils/metrics-logger) and pass loggerOptions */
	    GalaxyApp.prototype._initLogger = function _initLogger(loggerOptions) {
	        var self = this;
	
	        // default to console logging at the debug level if the debug flag is set
	        if (self.config.debug) {
	            loggerOptions.consoleLogger = loggerOptions.consoleLogger || console;
	            loggerOptions.consoleLevel = loggerOptions.consoleLevel || metricsLogger.MetricsLogger.ALL;
	            // load any logging namespaces from localStorage if we can
	            try {
	                loggerOptions.consoleNamespaceWhitelist = localStorage.getItem(NAMESPACE_KEY).split(',');
	            } catch (storageErr) {}
	        }
	
	        self.logger = new metricsLogger.MetricsLogger(loggerOptions);
	        self.emit = {};
	        ['log', 'debug', 'info', 'warn', 'error', 'metric'].map(function (i) {
	            self.emit[i] = function (data) {
	                self.logger.emit(i, arguments[0], Array.prototype.slice.call(arguments, 1));
	            };
	        });
	
	        if (self.config.debug) {
	            // add this logger to mvc's loggable mixin so that all models can use the logger
	            BASE_MVC.LoggableMixin.logger = self.logger;
	        }
	        return self;
	    };
	
	    /** add the localize fn to this object and the window namespace (as '_l') */
	    GalaxyApp.prototype._initLocale = function _initLocale(options) {
	        var self = this;
	        self.debug('_initLocale:', options);
	        self.localize = localize;
	        // add to window as global shortened alias
	        // TODO: temporary - remove when can require for plugins
	        window._l = self.localize;
	        return self;
	    };
	
	    /** set up the current user as a Backbone model (mvc/user/user-model) */
	    GalaxyApp.prototype._initUser = function _initUser(userJSON) {
	        var self = this;
	        self.debug('_initUser:', userJSON);
	        self.user = new userModel.User(userJSON);
	        self.user.logger = self.logger;
	        return self;
	    };
	
	    /** Set up DOM/jQuery/Backbone event listeners enabled for all pages */
	    GalaxyApp.prototype._setUpListeners = function _setUpListeners() {
	        var self = this;
	
	        // hook to jq beforeSend to record the most recent ajax call and cache some data about it
	        /** cached info about the last ajax call made through jQuery */
	        self.lastAjax = {};
	        $(document).bind('ajaxSend', function (ev, xhr, options) {
	            var data = options.data;
	            try {
	                data = JSON.parse(data);
	            } catch (err) {}
	
	            self.lastAjax = {
	                url: location.href.slice(0, -1) + options.url,
	                data: data
	            };
	            //TODO:?? we might somehow manage to *retry* ajax using either this hook or Backbone.sync
	        });
	        return self;
	    };
	
	    /** Turn debugging/console-output on/off by passing boolean. Pass nothing to get current setting. */
	    GalaxyApp.prototype.debugging = function _debugging(setting) {
	        var self = this;
	        try {
	            if (setting === undefined) {
	                return localStorage.getItem(DEBUGGING_KEY) === 'true';
	            }
	            if (setting) {
	                localStorage.setItem(DEBUGGING_KEY, true);
	                return true;
	            }
	
	            localStorage.removeItem(DEBUGGING_KEY);
	            // also remove all namespaces
	            self.debuggingNamespaces(null);
	        } catch (storageErr) {
	            console.log(localize('localStorage not available for debug flag retrieval'));
	        }
	        return false;
	    };
	
	    /** Add, remove, or clear namespaces from the debugging filters
	     *  Pass no arguments to retrieve the existing namespaces as an array.
	     *  Pass in null to clear all namespaces (all logging messages will show now).
	     *  Pass in an array of strings or single string of the namespaces to filter to.
	     *  Returns the new/current namespaces as an array;
	     */
	    GalaxyApp.prototype.debuggingNamespaces = function _debuggingNamespaces(namespaces) {
	        var self = this;
	        try {
	            if (namespaces === undefined) {
	                var csv = localStorage.getItem(NAMESPACE_KEY);
	                return typeof csv === 'string' ? csv.split(',') : [];
	            } else if (namespaces === null) {
	                localStorage.removeItem(NAMESPACE_KEY);
	            } else {
	                localStorage.setItem(NAMESPACE_KEY, namespaces);
	            }
	            var newSettings = self.debuggingNamespaces();
	            if (self.logger) {
	                self.logger.options.consoleNamespaceWhitelist = newSettings;
	            }
	            return newSettings;
	        } catch (storageErr) {
	            console.log(localize('localStorage not available for debug namespace retrieval'));
	        }
	    };
	
	    /** string rep */
	    GalaxyApp.prototype.toString = function toString() {
	        var userEmail = this.user ? this.user.get('email') || '(anonymous)' : 'uninitialized';
	        return 'GalaxyApp(' + userEmail + ')';
	    };
	
	    // ============================================================================
	    return {
	        GalaxyApp: GalaxyApp
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(106), __webpack_require__(54), __webpack_require__(8), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Masthead, Panel, Modal, Utils) {
	    var View = Backbone.View.extend({
	        el: 'body',
	        className: 'full-content',
	        _panelids: ['left', 'right'],
	
	        initialize: function (options) {
	            var self = this;
	            this.config = _.defaults(options.config || {}, {
	                message_box_visible: false,
	                message_box_content: '',
	                message_box_class: 'info',
	                show_inactivity_warning: false,
	                inactivity_box_content: ''
	            });
	
	            // attach global objects, build mastheads
	            Galaxy.modal = this.modal = new Modal.View();
	            Galaxy.display = this.display = function (view) {
	                if (view.title) {
	                    Utils.setWindowTitle(view.title);
	                    view.allow_title_display = false;
	                } else {
	                    Utils.setWindowTitle();
	                    view.allow_title_display = true;
	                }
	                self.center.display(view);
	            };
	            Galaxy.router = this.router = options.Router && new options.Router(self, options);
	            this.masthead = new Masthead.View(this.config);
	            this.center = new Panel.CenterPanel();
	
	            // build page template
	            this.$el.attr('scroll', 'no');
	            this.$el.html(this._template());
	            this.$('#masthead').replaceWith(this.masthead.$el);
	            this.$('#center').append(this.center.$el);
	            this.$el.append(this.masthead.frame.$el);
	            this.$el.append(this.modal.$el);
	            this.$messagebox = this.$('#messagebox');
	            this.$inactivebox = this.$('#inactivebox');
	
	            // build panels
	            this.panels = {};
	            _.each(this._panelids, function (panel_id) {
	                var panel_class_name = panel_id.charAt(0).toUpperCase() + panel_id.slice(1);
	                var panel_class = options[panel_class_name];
	                if (panel_class) {
	                    var panel_instance = new panel_class(self, options);
	                    self[panel_instance.toString()] = panel_instance;
	                    self.panels[panel_id] = new Panel.SidePanel({
	                        id: panel_id,
	                        el: self.$('#' + panel_id),
	                        view: panel_instance
	                    });
	                }
	            });
	            this.render();
	
	            // start the router
	            this.router && Backbone.history.start({
	                root: Galaxy.root,
	                pushState: true
	            });
	        },
	
	        render: function () {
	            // TODO: Remove this line after select2 update
	            $('.select2-hidden-accessible').remove();
	            this.masthead.render();
	            this.renderMessageBox();
	            this.renderInactivityBox();
	            this.renderPanels();
	            this._checkCommunicationServerOnline();
	            return this;
	        },
	
	        /** Render message box */
	        renderMessageBox: function () {
	            if (this.config.message_box_visible) {
	                var content = this.config.message_box_content || '';
	                var level = this.config.message_box_class || 'info';
	                this.$el.addClass('has-message-box');
	                this.$messagebox.attr('class', 'panel-' + level + '-message').html(content).toggle(!!content).show();
	            } else {
	                this.$el.removeClass('has-message-box');
	                this.$messagebox.hide();
	            }
	            return this;
	        },
	
	        /** Render inactivity warning */
	        renderInactivityBox: function () {
	            if (this.config.show_inactivity_warning) {
	                var content = this.config.inactivity_box_content || '';
	                var verificationLink = $('<a/>').attr('href', Galaxy.root + 'user/resend_verification').text('Resend verification');
	                this.$el.addClass('has-inactivity-box');
	                this.$inactivebox.html(content + ' ').append(verificationLink).toggle(!!content).show();
	            } else {
	                this.$el.removeClass('has-inactivity-box');
	                this.$inactivebox.hide();
	            }
	            return this;
	        },
	
	        /** Render panels */
	        renderPanels: function () {
	            var self = this;
	            _.each(this._panelids, function (panel_id) {
	                var panel = self.panels[panel_id];
	                if (panel) {
	                    panel.render();
	                } else {
	                    self.$('#center').css(panel_id, 0);
	                    self.$('#' + panel_id).hide();
	                }
	            });
	            return this;
	        },
	
	        /** body template */
	        _template: function () {
	            return ['<div id="everything">', '<div id="background"/>', '<div id="masthead"/>', '<div id="messagebox"/>', '<div id="inactivebox" class="panel-warning-message" />', '<div id="left" />', '<div id="center" class="inbound" />', '<div id="right" />', '</div>', '<div id="dd-helper" />'].join('');
	        },
	
	        toString: function () {
	            return 'PageLayoutView';
	        },
	
	        /** Check if the communication server is online and show the icon otherwise hide the icon */
	        _checkCommunicationServerOnline: function () {
	            var host = window.Galaxy.config.communication_server_host,
	                port = window.Galaxy.config.communication_server_port,
	                preferences = window.Galaxy.user.attributes.preferences,
	                $chat_icon_element = $("#show-chat-online");
	            /** Check if the user has deactivated the communication in it's personal settings */
	            if (preferences && ['1', 'true'].indexOf(preferences.communication_server) != -1) {
	                // See if the configured communication server is available
	                $.ajax({
	                    url: host + ":" + port
	                }).success(function (data) {
	                    // enable communication only when a user is logged in
	                    if (window.Galaxy.user.id !== null) {
	                        if ($chat_icon_element.css("visibility") === "hidden") {
	                            $chat_icon_element.css("visibility", "visible");
	                        }
	                    }
	                }).error(function (data) {
	                    // hide the communication icon if the communication server is not available
	                    $chat_icon_element.css("visibility", "hidden");
	                });
	            } else {
	                $chat_icon_element.css("visibility", "hidden");
	            }
	        }
	    });
	
	    return { View: View };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Backbone) {
	    "use strict";
	
	    var MIN_PANEL_WIDTH = 160,
	        MAX_PANEL_WIDTH = 800;
	
	    /** View for left/right panels used by Page view */
	    var SidePanel = Backbone.View.extend({
	
	        initialize: function (options) {
	            this.view = options.view;
	            this.hidden = false;
	            this.saved_size = null;
	            this.hiddenByTool = false;
	        },
	
	        $center: function () {
	            return this.$el.siblings('#center');
	        },
	
	        $toggleButton: function () {
	            return this.$('.unified-panel-footer > .panel-collapse');
	        },
	
	        render: function () {
	            var self = this;
	            var panel = this.view;
	            var components = this.view.model.attributes || {};
	            this.$el.html(this._templatePanel(this.id));
	            _.each(components.buttons, function (button) {
	                self.$('.panel-header-buttons').append(button.$el);
	            });
	            this.$el.addClass(components.cls);
	            this.$('.panel-header-text').html(_.escape(components.title));
	            this.$('.unified-panel-body').append(panel.$el);
	            panel.render();
	        },
	
	        /** panel dom template. id is 'right' or 'left' */
	        _templatePanel: function () {
	            return [this._templateHeader(), this._templateBody(), this._templateFooter()].join('');
	        },
	
	        /** panel dom template. id is 'right' or 'left' */
	        _templateHeader: function (data) {
	            return ['<div class="unified-panel-header" unselectable="on">', '<div class="unified-panel-header-inner">', '<div class="panel-header-buttons" style="float: right"/>', '<div class="panel-header-text"/>', '</div>', '</div>'].join('');
	        },
	
	        /** panel dom template. id is 'right' or 'left' */
	        _templateBody: function (data) {
	            return '<div class="unified-panel-body"/>';
	        },
	
	        /** panel dom template. id is 'right' or 'left' */
	        _templateFooter: function (data) {
	            return ['<div class="unified-panel-footer">', '<div class="panel-collapse ', _.escape(this.id), '"/>', '<div class="drag"/>', '</div>'].join('');
	        },
	
	        events: {
	            'mousedown .unified-panel-footer > .drag': '_mousedownDragHandler',
	            'click .unified-panel-footer > .panel-collapse': 'toggle'
	        },
	
	        _mousedownDragHandler: function (ev) {
	            var self = this,
	                draggingLeft = this.id === 'left',
	                prevX = ev.pageX;
	
	            function move(e) {
	                var delta = e.pageX - prevX;
	                prevX = e.pageX;
	                var oldWidth = self.$el.width(),
	                    newWidth = draggingLeft ? oldWidth + delta : oldWidth - delta;
	                // Limit range
	                newWidth = Math.min(MAX_PANEL_WIDTH, Math.max(MIN_PANEL_WIDTH, newWidth));
	                self.resize(newWidth);
	            }
	
	            // this is a page wide overlay that assists in capturing the move and release of the mouse
	            // if not provided, progress and end wouldn't fire if the mouse moved out of the drag button area
	            $('#dd-helper').show().on('mousemove', move).one('mouseup', function (e) {
	                $(this).hide().off('mousemove', move);
	            });
	        },
	
	        // TODO: the following three could be simplified I think
	        // if panel is 'right' (this.id), move center right newSize number of pixels
	        resize: function (newSize) {
	            this.$el.css('width', newSize);
	            this.$center().css(this.id, newSize);
	            return this;
	        },
	
	        show: function () {
	            if (!this.hidden) {
	                return;
	            }
	            var self = this,
	                animation = {},
	                whichSide = this.id;
	            animation[whichSide] = 0;
	            self.$el.css(whichSide, -this.saved_size).show().animate(animation, "fast", function () {
	                self.resize(self.saved_size);
	            });
	            self.hidden = false;
	            self.$toggleButton().removeClass("hidden");
	            return this;
	        },
	
	        hide: function () {
	            if (this.hidden) {
	                return;
	            }
	            var animation = {},
	                whichSide = this.id;
	            this.saved_size = this.$el.width();
	            animation[whichSide] = -this.saved_size;
	            this.$el.animate(animation, "fast");
	            this.$center().css(whichSide, 0);
	            this.hidden = true;
	            this.$toggleButton().addClass("hidden");
	            return this;
	        },
	
	        toggle: function (ev) {
	            this.hidden ? this.show() : this.hide();
	            this.hiddenByTool = false;
	            return this;
	        },
	
	        // ..............................................................
	        //TODO: only used in message.mako?
	        /**   */
	        handle_minwidth_hint: function (hint) {
	            var space = this.$center().width() - (this.hidden ? this.saved_size : 0);
	            if (space < hint) {
	                if (!this.hidden) {
	                    this.toggle();
	                    this.hiddenByTool = true;
	                }
	            } else {
	                if (this.hiddenByTool) {
	                    this.toggle();
	                    this.hiddenByTool = false;
	                }
	            }
	            return self;
	        },
	
	        /**   */
	        force_panel: function (op) {
	            if (op == 'show') {
	                return this.show();
	            }
	            if (op == 'hide') {
	                return this.hide();
	            }
	            return self;
	        },
	
	        toString: function () {
	            return 'SidePanel(' + this.id + ')';
	        }
	    });
	
	    // ----------------------------------------------------------------------------
	    // TODO: side should be defined by page - not here
	    var LeftPanel = SidePanel.extend({
	        id: 'left'
	    });
	
	    var RightPanel = SidePanel.extend({
	        id: 'right'
	    });
	
	    /** Center panel with the ability to switch between iframe and view */
	    var CenterPanel = Backbone.View.extend({
	
	        initialize: function (options) {
	            this.setElement($(this.template()));
	            this.$frame = this.$('.center-frame');
	            this.$panel = this.$('.center-panel');
	            this.$frame.on('load', _.bind(this._iframeChangeHandler, this));
	        },
	
	        /** Display iframe if its target url changes, hide center panel */
	        _iframeChangeHandler: function (ev) {
	            var iframe = ev.currentTarget;
	            var location = iframe.contentWindow && iframe.contentWindow.location;
	            if (location && location.host) {
	                $(iframe).show();
	                this.$panel.empty().hide();
	                Galaxy.trigger('center-frame:load', {
	                    fullpath: location.pathname + location.search + location.hash,
	                    pathname: location.pathname,
	                    search: location.search,
	                    hash: location.hash
	                });
	            }
	        },
	
	        /** Display a view in the center panel, hide iframe */
	        display: function (view) {
	            var contentWindow = this.$frame[0].contentWindow || {};
	            var message = contentWindow.onbeforeunload && contentWindow.onbeforeunload();
	            if (!message || confirm(message)) {
	                contentWindow.onbeforeunload = undefined;
	                this.$frame.attr('src', 'about:blank').hide();
	                this.$panel.empty().scrollTop(0).append(view.$el).show();
	                Galaxy.trigger('center-panel:load', view);
	            }
	        },
	
	        template: function () {
	            return '<div class="center-container">' + '<iframe id="galaxy_main" name="galaxy_main" frameborder="0" class="center-frame" />' + '<div class="center-panel" />' + '</div>';
	        },
	
	        toString: function () {
	            return 'CenterPanel';
	        }
	    });
	
	    return {
	        SidePanel: SidePanel,
	        LeftPanel: LeftPanel,
	        RightPanel: RightPanel,
	        CenterPanel: CenterPanel
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (jQuery) {
	
	    "use strict";
	    // ============================================================================
	    //TODO: (the older version) unify with ui-modal (the newer version)
	
	    var $ = jQuery;
	
	    // Modal dialog boxes
	    var Modal = function (options) {
	        this.$overlay = options.overlay;
	        this.$dialog = options.dialog;
	        this.$header = this.$dialog.find(".modal-header");
	        this.$body = this.$dialog.find(".modal-body");
	        this.$footer = this.$dialog.find(".modal-footer");
	        this.$backdrop = options.backdrop;
	        // Close button
	        this.$header.find(".close").on("click", $.proxy(this.hide, this));
	    };
	
	    $.extend(Modal.prototype, {
	        setContent: function (options) {
	            this.$header.hide();
	            // Title
	            if (options.title) {
	                this.$header.find(".title").html(options.title);
	                this.$header.show();
	            }
	            if (options.closeButton) {
	                this.$header.find(".close").show();
	                this.$header.show();
	            } else {
	                this.$header.find(".close").hide();
	            }
	            // Buttons
	            this.$footer.hide();
	            var $buttons = this.$footer.find(".buttons").html("");
	            if (options.buttons) {
	                $.each(options.buttons, function (name, value) {
	                    $buttons.append($('<button></button> ').text(name).click(value)).append(" ");
	                });
	                this.$footer.show();
	            }
	            var $extraButtons = this.$footer.find(".extra_buttons").html("");
	            if (options.extra_buttons) {
	                $.each(options.extra_buttons, function (name, value) {
	                    $extraButtons.append($('<button></button>').text(name).click(value)).append(" ");
	                });
	                this.$footer.show();
	            }
	            // Body
	            var body = options.body;
	            if (body == "progress") {
	                body = $("<div class='progress progress-striped active'><div class='progress-bar' style='width: 100%'></div></div>");
	            }
	            this.$body.html(body);
	        },
	        show: function (options, callback) {
	            if (!this.$dialog.is(":visible")) {
	                if (options.backdrop) {
	                    this.$backdrop.addClass("in");
	                } else {
	                    this.$backdrop.removeClass("in");
	                }
	                this.$overlay.show();
	                this.$dialog.show();
	                this.$overlay.addClass("in");
	                // Fix min-width so that modal cannot shrink considerably if new content is loaded.
	                this.$body.css("min-width", this.$body.width());
	                // Set max-height so that modal does not exceed window size and is in middle of page.
	                // TODO: this could perhaps be handled better using CSS.
	                this.$body.css("max-height", $(window).height() - this.$footer.outerHeight() - this.$header.outerHeight() - parseInt(this.$dialog.css("padding-top"), 10) - parseInt(this.$dialog.css("padding-bottom"), 10));
	            }
	            // Callback on init
	            if (callback) {
	                callback();
	            }
	        },
	        hide: function () {
	            var modal = this;
	            modal.$dialog.fadeOut(function () {
	                modal.$overlay.hide();
	                modal.$backdrop.removeClass("in");
	                modal.$body.children().remove();
	                // Clear min-width to allow for modal to take size of new body.
	                modal.$body.css("min-width", undefined);
	            });
	        }
	    });
	
	    var modal;
	
	    $(function () {
	        modal = new Modal({ overlay: $("#top-modal"), dialog: $("#top-modal-dialog"), backdrop: $("#top-modal-backdrop") });
	    });
	
	    // Backward compatibility
	    function hide_modal() {
	        modal.hide();
	    }
	
	    function show_modal(title, body, buttons, extra_buttons, init_fn) {
	        modal.setContent({ title: title, body: body, buttons: buttons, extra_buttons: extra_buttons });
	        modal.show({ backdrop: true }, init_fn);
	    }
	
	    function show_message(title, body, buttons, extra_buttons, init_fn) {
	        modal.setContent({ title: title, body: body, buttons: buttons, extra_buttons: extra_buttons });
	        modal.show({ backdrop: false }, init_fn);
	    }
	
	    function show_in_overlay(options) {
	        var width = options.width || '600';
	        var height = options.height || '400';
	        var scroll = options.scroll || 'auto';
	        $("#overlay-background").bind("click.overlay", function () {
	            hide_modal();
	            $("#overlay-background").unbind("click.overlay");
	        });
	        modal.setContent({
	            closeButton: true,
	            title: "&nbsp;",
	            body: $("<div style='margin: -5px;'><iframe style='margin: 0; padding: 0;' src='" + options.url + "' width='" + width + "' height='" + height + "' scrolling='" + scroll + "' frameborder='0'></iframe></div>")
	        });
	        modal.show({ backdrop: true });
	    }
	
	    // ============================================================================
	    return {
	        Modal: Modal,
	        hide_modal: hide_modal,
	        show_modal: show_modal,
	        show_message: show_message,
	        show_in_overlay: show_in_overlay
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * bootstrap-tour - v0.10.2
	 * http://bootstraptour.com
	 * ========================================================================
	 * Copyright 2012-2015 Ulrich Sossou
	 *
	 * ========================================================================
	 * Licensed under the MIT License (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://opensource.org/licenses/MIT
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * ========================================================================
	 */
	
	(function ($, window) {
	  var Tour, document;
	  document = window.document;
	  Tour = function () {
	    function Tour(options) {
	      var storage;
	      try {
	        storage = window.localStorage;
	      } catch (_error) {
	        storage = false;
	      }
	      this._options = $.extend({
	        name: 'tour',
	        steps: [],
	        container: 'body',
	        autoscroll: true,
	        keyboard: true,
	        storage: storage,
	        debug: false,
	        backdrop: false,
	        backdropContainer: 'body',
	        backdropPadding: 0,
	        redirect: true,
	        orphan: false,
	        duration: false,
	        delay: false,
	        basePath: '',
	        template: '<div class="popover" role="tooltip"> <div class="arrow"></div> <h3 class="popover-title"></h3> <div class="popover-content"></div> <div class="popover-navigation"> <div class="btn-group"> <button class="btn btn-sm btn-default" data-role="prev">&laquo; Prev</button> <button class="btn btn-sm btn-default" data-role="next">Next &raquo;</button> <button class="btn btn-sm btn-default" data-role="pause-resume" data-pause-text="Pause" data-resume-text="Resume">Pause</button> </div> <button class="btn btn-sm btn-default" data-role="end">End tour</button> </div> </div>',
	        afterSetState: function (key, value) {},
	        afterGetState: function (key, value) {},
	        afterRemoveState: function (key) {},
	        onStart: function (tour) {},
	        onEnd: function (tour) {},
	        onShow: function (tour) {},
	        onShown: function (tour) {},
	        onHide: function (tour) {},
	        onHidden: function (tour) {},
	        onNext: function (tour) {},
	        onPrev: function (tour) {},
	        onPause: function (tour, duration) {},
	        onResume: function (tour, duration) {},
	        onRedirectError: function (tour) {}
	      }, options);
	      this._force = false;
	      this._inited = false;
	      this._current = null;
	      this.backdrop = {
	        overlay: null,
	        $element: null,
	        $background: null,
	        backgroundShown: false,
	        overlayElementShown: false
	      };
	      this;
	    }
	
	    Tour.prototype.addSteps = function (steps) {
	      var step, _i, _len;
	      for (_i = 0, _len = steps.length; _i < _len; _i++) {
	        step = steps[_i];
	        this.addStep(step);
	      }
	      return this;
	    };
	
	    Tour.prototype.addStep = function (step) {
	      this._options.steps.push(step);
	      return this;
	    };
	
	    Tour.prototype.getStep = function (i) {
	      if (this._options.steps[i] != null) {
	        return $.extend({
	          id: "step-" + i,
	          path: '',
	          host: '',
	          placement: 'right',
	          title: '',
	          content: '<p></p>',
	          next: i === this._options.steps.length - 1 ? -1 : i + 1,
	          prev: i - 1,
	          animation: true,
	          container: this._options.container,
	          autoscroll: this._options.autoscroll,
	          backdrop: this._options.backdrop,
	          backdropContainer: this._options.backdropContainer,
	          backdropPadding: this._options.backdropPadding,
	          redirect: this._options.redirect,
	          reflexElement: this._options.steps[i].element,
	          orphan: this._options.orphan,
	          duration: this._options.duration,
	          delay: this._options.delay,
	          template: this._options.template,
	          onShow: this._options.onShow,
	          onShown: this._options.onShown,
	          onHide: this._options.onHide,
	          onHidden: this._options.onHidden,
	          onNext: this._options.onNext,
	          onPrev: this._options.onPrev,
	          onPause: this._options.onPause,
	          onResume: this._options.onResume,
	          onRedirectError: this._options.onRedirectError
	        }, this._options.steps[i]);
	      }
	    };
	
	    Tour.prototype.init = function (force) {
	      this._force = force;
	      if (this.ended()) {
	        this._debug('Tour ended, init prevented.');
	        return this;
	      }
	      this.setCurrentStep();
	      this._initMouseNavigation();
	      this._initKeyboardNavigation();
	      this._onResize(function (_this) {
	        return function () {
	          return _this.showStep(_this._current);
	        };
	      }(this));
	      if (this._current !== null) {
	        this.showStep(this._current);
	      }
	      this._inited = true;
	      return this;
	    };
	
	    Tour.prototype.start = function (force) {
	      var promise;
	      if (force == null) {
	        force = false;
	      }
	      if (!this._inited) {
	        this.init(force);
	      }
	      if (this._current === null) {
	        promise = this._makePromise(this._options.onStart != null ? this._options.onStart(this) : void 0);
	        this._callOnPromiseDone(promise, this.showStep, 0);
	      }
	      return this;
	    };
	
	    Tour.prototype.next = function () {
	      var promise;
	      promise = this.hideStep(this._current);
	      return this._callOnPromiseDone(promise, this._showNextStep);
	    };
	
	    Tour.prototype.prev = function () {
	      var promise;
	      promise = this.hideStep(this._current);
	      return this._callOnPromiseDone(promise, this._showPrevStep);
	    };
	
	    Tour.prototype.goTo = function (i) {
	      var promise;
	      promise = this.hideStep(this._current);
	      return this._callOnPromiseDone(promise, this.showStep, i);
	    };
	
	    Tour.prototype.end = function () {
	      var endHelper, promise;
	      endHelper = function (_this) {
	        return function (e) {
	          $(document).off("click.tour-" + _this._options.name);
	          $(document).off("keyup.tour-" + _this._options.name);
	          $(window).off("resize.tour-" + _this._options.name);
	          _this._setState('end', 'yes');
	          _this._inited = false;
	          _this._force = false;
	          _this._clearTimer();
	          if (_this._options.onEnd != null) {
	            return _this._options.onEnd(_this);
	          }
	        };
	      }(this);
	      promise = this.hideStep(this._current);
	      return this._callOnPromiseDone(promise, endHelper);
	    };
	
	    Tour.prototype.ended = function () {
	      return !this._force && !!this._getState('end');
	    };
	
	    Tour.prototype.restart = function () {
	      this._removeState('current_step');
	      this._removeState('end');
	      this._removeState('redirect_to');
	      return this.start();
	    };
	
	    Tour.prototype.pause = function () {
	      var step;
	      step = this.getStep(this._current);
	      if (!(step && step.duration)) {
	        return this;
	      }
	      this._paused = true;
	      this._duration -= new Date().getTime() - this._start;
	      window.clearTimeout(this._timer);
	      this._debug("Paused/Stopped step " + (this._current + 1) + " timer (" + this._duration + " remaining).");
	      if (step.onPause != null) {
	        return step.onPause(this, this._duration);
	      }
	    };
	
	    Tour.prototype.resume = function () {
	      var step;
	      step = this.getStep(this._current);
	      if (!(step && step.duration)) {
	        return this;
	      }
	      this._paused = false;
	      this._start = new Date().getTime();
	      this._duration = this._duration || step.duration;
	      this._timer = window.setTimeout(function (_this) {
	        return function () {
	          if (_this._isLast()) {
	            return _this.next();
	          } else {
	            return _this.end();
	          }
	        };
	      }(this), this._duration);
	      this._debug("Started step " + (this._current + 1) + " timer with duration " + this._duration);
	      if (step.onResume != null && this._duration !== step.duration) {
	        return step.onResume(this, this._duration);
	      }
	    };
	
	    Tour.prototype.hideStep = function (i) {
	      var hideStepHelper, promise, step;
	      step = this.getStep(i);
	      if (!step) {
	        return;
	      }
	      this._clearTimer();
	      promise = this._makePromise(step.onHide != null ? step.onHide(this, i) : void 0);
	      hideStepHelper = function (_this) {
	        return function (e) {
	          var $element;
	          $element = $(step.element);
	          if (!($element.data('bs.popover') || $element.data('popover'))) {
	            $element = $('body');
	          }
	          $element.popover('destroy').removeClass("tour-" + _this._options.name + "-element tour-" + _this._options.name + "-" + i + "-element");
	          $element.removeData('bs.popover');
	          if (step.reflex) {
	            $(step.reflexElement).removeClass('tour-step-element-reflex').off("" + _this._reflexEvent(step.reflex) + ".tour-" + _this._options.name);
	          }
	          if (step.backdrop) {
	            _this._hideBackdrop();
	          }
	          if (step.onHidden != null) {
	            return step.onHidden(_this);
	          }
	        };
	      }(this);
	      this._callOnPromiseDone(promise, hideStepHelper);
	      return promise;
	    };
	
	    Tour.prototype.showStep = function (i) {
	      var promise, showStepHelper, skipToPrevious, step;
	      if (this.ended()) {
	        this._debug('Tour ended, showStep prevented.');
	        return this;
	      }
	      step = this.getStep(i);
	      if (!step) {
	        return;
	      }
	      skipToPrevious = i < this._current;
	      promise = this._makePromise(step.onShow != null ? step.onShow(this, i) : void 0);
	      showStepHelper = function (_this) {
	        return function (e) {
	          var path, showPopoverAndOverlay;
	          _this.setCurrentStep(i);
	          path = function () {
	            switch ({}.toString.call(step.path)) {
	              case '[object Function]':
	                return step.path();
	              case '[object String]':
	                return this._options.basePath + step.path;
	              default:
	                return step.path;
	            }
	          }.call(_this);
	          if (_this._isRedirect(step.host, path, document.location)) {
	            _this._redirect(step, i, path);
	            if (!_this._isJustPathHashDifferent(step.host, path, document.location)) {
	              return;
	            }
	          }
	          if (_this._isOrphan(step)) {
	            if (step.orphan === false) {
	              _this._debug("Skip the orphan step " + (_this._current + 1) + ".\nOrphan option is false and the element does not exist or is hidden.");
	              if (skipToPrevious) {
	                _this._showPrevStep();
	              } else {
	                _this._showNextStep();
	              }
	              return;
	            }
	            _this._debug("Show the orphan step " + (_this._current + 1) + ". Orphans option is true.");
	          }
	          if (step.backdrop) {
	            _this._showBackdrop(step);
	          }
	          showPopoverAndOverlay = function () {
	            if (_this.getCurrentStep() !== i || _this.ended()) {
	              return;
	            }
	            if (step.element != null && step.backdrop) {
	              _this._showOverlayElement(step);
	            }
	            _this._showPopover(step, i);
	            if (step.onShown != null) {
	              step.onShown(_this);
	            }
	            return _this._debug("Step " + (_this._current + 1) + " of " + _this._options.steps.length);
	          };
	          if (step.autoscroll) {
	            _this._scrollIntoView(step.element, showPopoverAndOverlay);
	          } else {
	            showPopoverAndOverlay();
	          }
	          if (step.duration) {
	            return _this.resume();
	          }
	        };
	      }(this);
	      if (step.delay) {
	        this._debug("Wait " + step.delay + " milliseconds to show the step " + (this._current + 1));
	        window.setTimeout(function (_this) {
	          return function () {
	            return _this._callOnPromiseDone(promise, showStepHelper);
	          };
	        }(this), step.delay);
	      } else {
	        this._callOnPromiseDone(promise, showStepHelper);
	      }
	      return promise;
	    };
	
	    Tour.prototype.getCurrentStep = function () {
	      return this._current;
	    };
	
	    Tour.prototype.setCurrentStep = function (value) {
	      if (value != null) {
	        this._current = value;
	        this._setState('current_step', value);
	      } else {
	        this._current = this._getState('current_step');
	        this._current = this._current === null ? null : parseInt(this._current, 10);
	      }
	      return this;
	    };
	
	    Tour.prototype.redraw = function () {
	      return this._showOverlayElement(this.getStep(this.getCurrentStep()).element, true);
	    };
	
	    Tour.prototype._setState = function (key, value) {
	      var e, keyName;
	      if (this._options.storage) {
	        keyName = "" + this._options.name + "_" + key;
	        try {
	          this._options.storage.setItem(keyName, value);
	        } catch (_error) {
	          e = _error;
	          if (e.code === DOMException.QUOTA_EXCEEDED_ERR) {
	            this._debug('LocalStorage quota exceeded. State storage failed.');
	          }
	        }
	        return this._options.afterSetState(keyName, value);
	      } else {
	        if (this._state == null) {
	          this._state = {};
	        }
	        return this._state[key] = value;
	      }
	    };
	
	    Tour.prototype._removeState = function (key) {
	      var keyName;
	      if (this._options.storage) {
	        keyName = "" + this._options.name + "_" + key;
	        this._options.storage.removeItem(keyName);
	        return this._options.afterRemoveState(keyName);
	      } else {
	        if (this._state != null) {
	          return delete this._state[key];
	        }
	      }
	    };
	
	    Tour.prototype._getState = function (key) {
	      var keyName, value;
	      if (this._options.storage) {
	        keyName = "" + this._options.name + "_" + key;
	        value = this._options.storage.getItem(keyName);
	      } else {
	        if (this._state != null) {
	          value = this._state[key];
	        }
	      }
	      if (value === void 0 || value === 'null') {
	        value = null;
	      }
	      this._options.afterGetState(key, value);
	      return value;
	    };
	
	    Tour.prototype._showNextStep = function () {
	      var promise, showNextStepHelper, step;
	      step = this.getStep(this._current);
	      showNextStepHelper = function (_this) {
	        return function (e) {
	          return _this.showStep(step.next);
	        };
	      }(this);
	      promise = this._makePromise(step.onNext != null ? step.onNext(this) : void 0);
	      return this._callOnPromiseDone(promise, showNextStepHelper);
	    };
	
	    Tour.prototype._showPrevStep = function () {
	      var promise, showPrevStepHelper, step;
	      step = this.getStep(this._current);
	      showPrevStepHelper = function (_this) {
	        return function (e) {
	          return _this.showStep(step.prev);
	        };
	      }(this);
	      promise = this._makePromise(step.onPrev != null ? step.onPrev(this) : void 0);
	      return this._callOnPromiseDone(promise, showPrevStepHelper);
	    };
	
	    Tour.prototype._debug = function (text) {
	      if (this._options.debug) {
	        return window.console.log("Bootstrap Tour '" + this._options.name + "' | " + text);
	      }
	    };
	
	    Tour.prototype._isRedirect = function (host, path, location) {
	      var currentPath;
	      if (host !== '') {
	        if (this._isHostDifferent(host, location.href)) {
	          return true;
	        }
	      }
	      currentPath = [location.pathname, location.search, location.hash].join('');
	      return path != null && path !== '' && ({}.toString.call(path) === '[object RegExp]' && !path.test(currentPath) || {}.toString.call(path) === '[object String]' && this._isPathDifferent(path, currentPath));
	    };
	
	    Tour.prototype._isHostDifferent = function (host, currentURL) {
	      return this._getProtocol(host) !== this._getProtocol(currentURL) || this._getHost(host) !== this._getHost(currentURL);
	    };
	
	    Tour.prototype._isPathDifferent = function (path, currentPath) {
	      return this._getPath(path) !== this._getPath(currentPath) || !this._equal(this._getQuery(path), this._getQuery(currentPath)) || !this._equal(this._getHash(path), this._getHash(currentPath));
	    };
	
	    Tour.prototype._isJustPathHashDifferent = function (host, path, location) {
	      var currentPath;
	      if (host !== '') {
	        if (this._isHostDifferent(host, location.href)) {
	          return false;
	        }
	      }
	      currentPath = [location.pathname, location.search, location.hash].join('');
	      if ({}.toString.call(path) === '[object String]') {
	        return this._getPath(path) === this._getPath(currentPath) && this._equal(this._getQuery(path), this._getQuery(currentPath)) && !this._equal(this._getHash(path), this._getHash(currentPath));
	      }
	      return false;
	    };
	
	    Tour.prototype._redirect = function (step, i, path) {
	      if ($.isFunction(step.redirect)) {
	        return step.redirect.call(this, path);
	      } else if (step.redirect === true) {
	        this._debug("Redirect to " + step.host + path);
	        if (this._getState('redirect_to') === "" + i) {
	          this._debug("Error redirection loop to " + path);
	          this._removeState('redirect_to');
	          if (step.onRedirectError != null) {
	            return step.onRedirectError(this);
	          }
	        } else {
	          this._setState('redirect_to', "" + i);
	          return document.location.href = "" + step.host + path;
	        }
	      }
	    };
	
	    Tour.prototype._isOrphan = function (step) {
	      return step.element == null || !$(step.element).length || $(step.element).is(':hidden') && $(step.element)[0].namespaceURI !== 'http://www.w3.org/2000/svg';
	    };
	
	    Tour.prototype._isLast = function () {
	      return this._current < this._options.steps.length - 1;
	    };
	
	    Tour.prototype._showPopover = function (step, i) {
	      var $element, $tip, isOrphan, options, shouldAddSmart;
	      $(".tour-" + this._options.name).remove();
	      options = $.extend({}, this._options);
	      isOrphan = this._isOrphan(step);
	      step.template = this._template(step, i);
	      if (isOrphan) {
	        step.element = 'body';
	        step.placement = 'top';
	      }
	      $element = $(step.element);
	      $element.addClass("tour-" + this._options.name + "-element tour-" + this._options.name + "-" + i + "-element");
	      if (step.options) {
	        $.extend(options, step.options);
	      }
	      if (step.reflex && !isOrphan) {
	        $(step.reflexElement).addClass('tour-step-element-reflex').off("" + this._reflexEvent(step.reflex) + ".tour-" + this._options.name).on("" + this._reflexEvent(step.reflex) + ".tour-" + this._options.name, function (_this) {
	          return function () {
	            if (_this._isLast()) {
	              return _this.next();
	            } else {
	              return _this.end();
	            }
	          };
	        }(this));
	      }
	      shouldAddSmart = step.smartPlacement === true && step.placement.search(/auto/i) === -1;
	      $element.popover({
	        placement: shouldAddSmart ? "auto " + step.placement : step.placement,
	        trigger: 'manual',
	        title: step.title,
	        content: step.content,
	        html: true,
	        animation: step.animation,
	        container: step.container,
	        template: step.template,
	        selector: step.element
	      }).popover('show');
	      $tip = $element.data('bs.popover') ? $element.data('bs.popover').tip() : $element.data('popover').tip();
	      $tip.attr('id', step.id);
	      this._reposition($tip, step);
	      if (isOrphan) {
	        return this._center($tip);
	      }
	    };
	
	    Tour.prototype._template = function (step, i) {
	      var $navigation, $next, $prev, $resume, $template, template;
	      template = step.template;
	      if (this._isOrphan(step) && {}.toString.call(step.orphan) !== '[object Boolean]') {
	        template = step.orphan;
	      }
	      $template = $.isFunction(template) ? $(template(i, step)) : $(template);
	      $navigation = $template.find('.popover-navigation');
	      $prev = $navigation.find('[data-role="prev"]');
	      $next = $navigation.find('[data-role="next"]');
	      $resume = $navigation.find('[data-role="pause-resume"]');
	      if (this._isOrphan(step)) {
	        $template.addClass('orphan');
	      }
	      $template.addClass("tour-" + this._options.name + " tour-" + this._options.name + "-" + i);
	      if (step.reflex) {
	        $template.addClass("tour-" + this._options.name + "-reflex");
	      }
	      if (step.prev < 0) {
	        $prev.addClass('disabled');
	        $prev.prop('disabled', true);
	      }
	      if (step.next < 0) {
	        $next.addClass('disabled');
	        $next.prop('disabled', true);
	      }
	      if (!step.duration) {
	        $resume.remove();
	      }
	      return $template.clone().wrap('<div>').parent().html();
	    };
	
	    Tour.prototype._reflexEvent = function (reflex) {
	      if ({}.toString.call(reflex) === '[object Boolean]') {
	        return 'click';
	      } else {
	        return reflex;
	      }
	    };
	
	    Tour.prototype._reposition = function ($tip, step) {
	      var offsetBottom, offsetHeight, offsetRight, offsetWidth, originalLeft, originalTop, tipOffset;
	      offsetWidth = $tip[0].offsetWidth;
	      offsetHeight = $tip[0].offsetHeight;
	      tipOffset = $tip.offset();
	      originalLeft = tipOffset.left;
	      originalTop = tipOffset.top;
	      offsetBottom = $(document).outerHeight() - tipOffset.top - $tip.outerHeight();
	      if (offsetBottom < 0) {
	        tipOffset.top = tipOffset.top + offsetBottom;
	      }
	      offsetRight = $('html').outerWidth() - tipOffset.left - $tip.outerWidth();
	      if (offsetRight < 0) {
	        tipOffset.left = tipOffset.left + offsetRight;
	      }
	      if (tipOffset.top < 0) {
	        tipOffset.top = 0;
	      }
	      if (tipOffset.left < 0) {
	        tipOffset.left = 0;
	      }
	      $tip.offset(tipOffset);
	      if (step.placement === 'bottom' || step.placement === 'top') {
	        if (originalLeft !== tipOffset.left) {
	          return this._replaceArrow($tip, (tipOffset.left - originalLeft) * 2, offsetWidth, 'left');
	        }
	      } else {
	        if (originalTop !== tipOffset.top) {
	          return this._replaceArrow($tip, (tipOffset.top - originalTop) * 2, offsetHeight, 'top');
	        }
	      }
	    };
	
	    Tour.prototype._center = function ($tip) {
	      return $tip.css('top', $(window).outerHeight() / 2 - $tip.outerHeight() / 2);
	    };
	
	    Tour.prototype._replaceArrow = function ($tip, delta, dimension, position) {
	      return $tip.find('.arrow').css(position, delta ? 50 * (1 - delta / dimension) + '%' : '');
	    };
	
	    Tour.prototype._scrollIntoView = function (element, callback) {
	      var $element, $window, counter, offsetTop, scrollTop, windowHeight;
	      $element = $(element);
	      if (!$element.length) {
	        return callback();
	      }
	      $window = $(window);
	      offsetTop = $element.offset().top;
	      windowHeight = $window.height();
	      scrollTop = Math.max(0, offsetTop - windowHeight / 2);
	      this._debug("Scroll into view. ScrollTop: " + scrollTop + ". Element offset: " + offsetTop + ". Window height: " + windowHeight + ".");
	      counter = 0;
	      return $('body, html').stop(true, true).animate({
	        scrollTop: Math.ceil(scrollTop)
	      }, function (_this) {
	        return function () {
	          if (++counter === 2) {
	            callback();
	            return _this._debug("Scroll into view.\nAnimation end element offset: " + $element.offset().top + ".\nWindow height: " + $window.height() + ".");
	          }
	        };
	      }(this));
	    };
	
	    Tour.prototype._onResize = function (callback, timeout) {
	      return $(window).on("resize.tour-" + this._options.name, function () {
	        clearTimeout(timeout);
	        return timeout = setTimeout(callback, 100);
	      });
	    };
	
	    Tour.prototype._initMouseNavigation = function () {
	      var _this;
	      _this = this;
	      return $(document).off("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='prev']").off("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='next']").off("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='end']").off("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='pause-resume']").on("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='next']", function (_this) {
	        return function (e) {
	          e.preventDefault();
	          return _this.next();
	        };
	      }(this)).on("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='prev']", function (_this) {
	        return function (e) {
	          e.preventDefault();
	          return _this.prev();
	        };
	      }(this)).on("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='end']", function (_this) {
	        return function (e) {
	          e.preventDefault();
	          return _this.end();
	        };
	      }(this)).on("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='pause-resume']", function (e) {
	        var $this;
	        e.preventDefault();
	        $this = $(this);
	        $this.text(_this._paused ? $this.data('pause-text') : $this.data('resume-text'));
	        if (_this._paused) {
	          return _this.resume();
	        } else {
	          return _this.pause();
	        }
	      });
	    };
	
	    Tour.prototype._initKeyboardNavigation = function () {
	      if (!this._options.keyboard) {
	        return;
	      }
	      return $(document).on("keyup.tour-" + this._options.name, function (_this) {
	        return function (e) {
	          if (!e.which) {
	            return;
	          }
	          switch (e.which) {
	            case 39:
	              e.preventDefault();
	              if (_this._isLast()) {
	                return _this.next();
	              } else {
	                return _this.end();
	              }
	              break;
	            case 37:
	              e.preventDefault();
	              if (_this._current > 0) {
	                return _this.prev();
	              }
	              break;
	            case 27:
	              e.preventDefault();
	              return _this.end();
	          }
	        };
	      }(this));
	    };
	
	    Tour.prototype._makePromise = function (result) {
	      if (result && $.isFunction(result.then)) {
	        return result;
	      } else {
	        return null;
	      }
	    };
	
	    Tour.prototype._callOnPromiseDone = function (promise, cb, arg) {
	      if (promise) {
	        return promise.then(function (_this) {
	          return function (e) {
	            return cb.call(_this, arg);
	          };
	        }(this));
	      } else {
	        return cb.call(this, arg);
	      }
	    };
	
	    Tour.prototype._showBackdrop = function (step) {
	      if (this.backdrop.backgroundShown) {
	        return;
	      }
	      this.backdrop = $('<div>', {
	        "class": 'tour-backdrop'
	      });
	      this.backdrop.backgroundShown = true;
	      return $(step.backdropContainer).append(this.backdrop);
	    };
	
	    Tour.prototype._hideBackdrop = function () {
	      this._hideOverlayElement();
	      return this._hideBackground();
	    };
	
	    Tour.prototype._hideBackground = function () {
	      if (this.backdrop) {
	        this.backdrop.remove();
	        this.backdrop.overlay = null;
	        return this.backdrop.backgroundShown = false;
	      }
	    };
	
	    Tour.prototype._showOverlayElement = function (step, force) {
	      var $element, elementData;
	      $element = $(step.element);
	      if (!$element || $element.length === 0 || this.backdrop.overlayElementShown && !force) {
	        return;
	      }
	      if (!this.backdrop.overlayElementShown) {
	        this.backdrop.$element = $element.addClass('tour-step-backdrop');
	        this.backdrop.$background = $('<div>', {
	          "class": 'tour-step-background'
	        });
	        this.backdrop.$background.appendTo(step.backdropContainer);
	        this.backdrop.overlayElementShown = true;
	      }
	      elementData = {
	        width: $element.innerWidth(),
	        height: $element.innerHeight(),
	        offset: $element.offset()
	      };
	      if (step.backdropPadding) {
	        elementData = this._applyBackdropPadding(step.backdropPadding, elementData);
	      }
	      return this.backdrop.$background.width(elementData.width).height(elementData.height).offset(elementData.offset);
	    };
	
	    Tour.prototype._hideOverlayElement = function () {
	      if (!this.backdrop.overlayElementShown) {
	        return;
	      }
	      this.backdrop.$element.removeClass('tour-step-backdrop');
	      this.backdrop.$background.remove();
	      this.backdrop.$element = null;
	      this.backdrop.$background = null;
	      return this.backdrop.overlayElementShown = false;
	    };
	
	    Tour.prototype._applyBackdropPadding = function (padding, data) {
	      if (typeof padding === 'object') {
	        if (padding.top == null) {
	          padding.top = 0;
	        }
	        if (padding.right == null) {
	          padding.right = 0;
	        }
	        if (padding.bottom == null) {
	          padding.bottom = 0;
	        }
	        if (padding.left == null) {
	          padding.left = 0;
	        }
	        data.offset.top = data.offset.top - padding.top;
	        data.offset.left = data.offset.left - padding.left;
	        data.width = data.width + padding.left + padding.right;
	        data.height = data.height + padding.top + padding.bottom;
	      } else {
	        data.offset.top = data.offset.top - padding;
	        data.offset.left = data.offset.left - padding;
	        data.width = data.width + padding * 2;
	        data.height = data.height + padding * 2;
	      }
	      return data;
	    };
	
	    Tour.prototype._clearTimer = function () {
	      window.clearTimeout(this._timer);
	      this._timer = null;
	      return this._duration = null;
	    };
	
	    Tour.prototype._getProtocol = function (url) {
	      url = url.split('://');
	      if (url.length > 1) {
	        return url[0];
	      } else {
	        return 'http';
	      }
	    };
	
	    Tour.prototype._getHost = function (url) {
	      url = url.split('//');
	      url = url.length > 1 ? url[1] : url[0];
	      return url.split('/')[0];
	    };
	
	    Tour.prototype._getPath = function (path) {
	      return path.replace(/\/?$/, '').split('?')[0].split('#')[0];
	    };
	
	    Tour.prototype._getQuery = function (path) {
	      return this._getParams(path, '?');
	    };
	
	    Tour.prototype._getHash = function (path) {
	      return this._getParams(path, '#');
	    };
	
	    Tour.prototype._getParams = function (path, start) {
	      var param, params, paramsObject, _i, _len;
	      params = path.split(start);
	      if (params.length === 1) {
	        return {};
	      }
	      params = params[1].split('&');
	      paramsObject = {};
	      for (_i = 0, _len = params.length; _i < _len; _i++) {
	        param = params[_i];
	        param = param.split('=');
	        paramsObject[param[0]] = param[1] || '';
	      }
	      return paramsObject;
	    };
	
	    Tour.prototype._equal = function (obj1, obj2) {
	      var k, v;
	      if ({}.toString.call(obj1) === '[object Object]' && {}.toString.call(obj2) === '[object Object]') {
	        for (k in obj1) {
	          v = obj1[k];
	          if (obj2[k] !== v) {
	            return false;
	          }
	        }
	        for (k in obj2) {
	          v = obj2[k];
	          if (obj1[k] !== v) {
	            return false;
	          }
	        }
	        return true;
	      }
	      return obj1 === obj2;
	    };
	
	    return Tour;
	  }();
	  return window.Tour = Tour;
	})(jQuery, window);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*! jQuery UI - v1.9.1 - 2012-10-29
	* http://jqueryui.com
	* Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.mouse.js, jquery.ui.position.js, jquery.ui.autocomplete.js, jquery.ui.button.js, jquery.ui.menu.js, jquery.ui.slider.js
	* Copyright (c) 2012 jQuery Foundation and other contributors Licensed MIT */
	
	(function (e, t) {
	  function i(t, n) {
	    var r,
	        i,
	        o,
	        u = t.nodeName.toLowerCase();return "area" === u ? (r = t.parentNode, i = r.name, !t.href || !i || r.nodeName.toLowerCase() !== "map" ? !1 : (o = e("img[usemap=#" + i + "]")[0], !!o && s(o))) : (/input|select|textarea|button|object/.test(u) ? !t.disabled : "a" === u ? t.href || n : n) && s(t);
	  }function s(t) {
	    return e.expr.filters.visible(t) && !e(t).parents().andSelf().filter(function () {
	      return e.css(this, "visibility") === "hidden";
	    }).length;
	  }var n = 0,
	      r = /^ui-id-\d+$/;e.ui = e.ui || {};if (e.ui.version) return;e.extend(e.ui, { version: "1.9.1", keyCode: { BACKSPACE: 8, COMMA: 188, DELETE: 46, DOWN: 40, END: 35, ENTER: 13, ESCAPE: 27, HOME: 36, LEFT: 37, NUMPAD_ADD: 107, NUMPAD_DECIMAL: 110, NUMPAD_DIVIDE: 111, NUMPAD_ENTER: 108, NUMPAD_MULTIPLY: 106, NUMPAD_SUBTRACT: 109, PAGE_DOWN: 34, PAGE_UP: 33, PERIOD: 190, RIGHT: 39, SPACE: 32, TAB: 9, UP: 38 } }), e.fn.extend({ _focus: e.fn.focus, focus: function (t, n) {
	      return typeof t == "number" ? this.each(function () {
	        var r = this;setTimeout(function () {
	          e(r).focus(), n && n.call(r);
	        }, t);
	      }) : this._focus.apply(this, arguments);
	    }, scrollParent: function () {
	      var t;return e.ui.ie && /(static|relative)/.test(this.css("position")) || /absolute/.test(this.css("position")) ? t = this.parents().filter(function () {
	        return (/(relative|absolute|fixed)/.test(e.css(this, "position")) && /(auto|scroll)/.test(e.css(this, "overflow") + e.css(this, "overflow-y") + e.css(this, "overflow-x"))
	        );
	      }).eq(0) : t = this.parents().filter(function () {
	        return (/(auto|scroll)/.test(e.css(this, "overflow") + e.css(this, "overflow-y") + e.css(this, "overflow-x"))
	        );
	      }).eq(0), /fixed/.test(this.css("position")) || !t.length ? e(document) : t;
	    }, zIndex: function (n) {
	      if (n !== t) return this.css("zIndex", n);if (this.length) {
	        var r = e(this[0]),
	            i,
	            s;while (r.length && r[0] !== document) {
	          i = r.css("position");if (i === "absolute" || i === "relative" || i === "fixed") {
	            s = parseInt(r.css("zIndex"), 10);if (!isNaN(s) && s !== 0) return s;
	          }r = r.parent();
	        }
	      }return 0;
	    }, uniqueId: function () {
	      return this.each(function () {
	        this.id || (this.id = "ui-id-" + ++n);
	      });
	    }, removeUniqueId: function () {
	      return this.each(function () {
	        r.test(this.id) && e(this).removeAttr("id");
	      });
	    } }), e("<a>").outerWidth(1).jquery || e.each(["Width", "Height"], function (n, r) {
	    function u(t, n, r, s) {
	      return e.each(i, function () {
	        n -= parseFloat(e.css(t, "padding" + this)) || 0, r && (n -= parseFloat(e.css(t, "border" + this + "Width")) || 0), s && (n -= parseFloat(e.css(t, "margin" + this)) || 0);
	      }), n;
	    }var i = r === "Width" ? ["Left", "Right"] : ["Top", "Bottom"],
	        s = r.toLowerCase(),
	        o = { innerWidth: e.fn.innerWidth, innerHeight: e.fn.innerHeight, outerWidth: e.fn.outerWidth, outerHeight: e.fn.outerHeight };e.fn["inner" + r] = function (n) {
	      return n === t ? o["inner" + r].call(this) : this.each(function () {
	        e(this).css(s, u(this, n) + "px");
	      });
	    }, e.fn["outer" + r] = function (t, n) {
	      return typeof t != "number" ? o["outer" + r].call(this, t) : this.each(function () {
	        e(this).css(s, u(this, t, !0, n) + "px");
	      });
	    };
	  }), e.extend(e.expr[":"], { data: e.expr.createPseudo ? e.expr.createPseudo(function (t) {
	      return function (n) {
	        return !!e.data(n, t);
	      };
	    }) : function (t, n, r) {
	      return !!e.data(t, r[3]);
	    }, focusable: function (t) {
	      return i(t, !isNaN(e.attr(t, "tabindex")));
	    }, tabbable: function (t) {
	      var n = e.attr(t, "tabindex"),
	          r = isNaN(n);return (r || n >= 0) && i(t, !r);
	    } }), e(function () {
	    var t = document.body,
	        n = t.appendChild(n = document.createElement("div"));n.offsetHeight, e.extend(n.style, { minHeight: "100px", height: "auto", padding: 0, borderWidth: 0 }), e.support.minHeight = n.offsetHeight === 100, e.support.selectstart = "onselectstart" in n, t.removeChild(n).style.display = "none";
	  }), function () {
	    var t = /msie ([\w.]+)/.exec(navigator.userAgent.toLowerCase()) || [];e.ui.ie = t.length ? !0 : !1, e.ui.ie6 = parseFloat(t[1], 10) === 6;
	  }(), e.fn.extend({ disableSelection: function () {
	      return this.bind((e.support.selectstart ? "selectstart" : "mousedown") + ".ui-disableSelection", function (e) {
	        e.preventDefault();
	      });
	    }, enableSelection: function () {
	      return this.unbind(".ui-disableSelection");
	    } }), e.extend(e.ui, { plugin: { add: function (t, n, r) {
	        var i,
	            s = e.ui[t].prototype;for (i in r) s.plugins[i] = s.plugins[i] || [], s.plugins[i].push([n, r[i]]);
	      }, call: function (e, t, n) {
	        var r,
	            i = e.plugins[t];if (!i || !e.element[0].parentNode || e.element[0].parentNode.nodeType === 11) return;for (r = 0; r < i.length; r++) e.options[i[r][0]] && i[r][1].apply(e.element, n);
	      } }, contains: e.contains, hasScroll: function (t, n) {
	      if (e(t).css("overflow") === "hidden") return !1;var r = n && n === "left" ? "scrollLeft" : "scrollTop",
	          i = !1;return t[r] > 0 ? !0 : (t[r] = 1, i = t[r] > 0, t[r] = 0, i);
	    }, isOverAxis: function (e, t, n) {
	      return e > t && e < t + n;
	    }, isOver: function (t, n, r, i, s, o) {
	      return e.ui.isOverAxis(t, r, s) && e.ui.isOverAxis(n, i, o);
	    } });
	})(jQuery);(function (e, t) {
	  var n = 0,
	      r = Array.prototype.slice,
	      i = e.cleanData;e.cleanData = function (t) {
	    for (var n = 0, r; (r = t[n]) != null; n++) try {
	      e(r).triggerHandler("remove");
	    } catch (s) {}i(t);
	  }, e.widget = function (t, n, r) {
	    var i,
	        s,
	        o,
	        u,
	        a = t.split(".")[0];t = t.split(".")[1], i = a + "-" + t, r || (r = n, n = e.Widget), e.expr[":"][i.toLowerCase()] = function (t) {
	      return !!e.data(t, i);
	    }, e[a] = e[a] || {}, s = e[a][t], o = e[a][t] = function (e, t) {
	      if (!this._createWidget) return new o(e, t);arguments.length && this._createWidget(e, t);
	    }, e.extend(o, s, { version: r.version, _proto: e.extend({}, r), _childConstructors: [] }), u = new n(), u.options = e.widget.extend({}, u.options), e.each(r, function (t, i) {
	      e.isFunction(i) && (r[t] = function () {
	        var e = function () {
	          return n.prototype[t].apply(this, arguments);
	        },
	            r = function (e) {
	          return n.prototype[t].apply(this, e);
	        };return function () {
	          var t = this._super,
	              n = this._superApply,
	              s;return this._super = e, this._superApply = r, s = i.apply(this, arguments), this._super = t, this._superApply = n, s;
	        };
	      }());
	    }), o.prototype = e.widget.extend(u, { widgetEventPrefix: u.widgetEventPrefix || t }, r, { constructor: o, namespace: a, widgetName: t, widgetBaseClass: i, widgetFullName: i }), s ? (e.each(s._childConstructors, function (t, n) {
	      var r = n.prototype;e.widget(r.namespace + "." + r.widgetName, o, n._proto);
	    }), delete s._childConstructors) : n._childConstructors.push(o), e.widget.bridge(t, o);
	  }, e.widget.extend = function (n) {
	    var i = r.call(arguments, 1),
	        s = 0,
	        o = i.length,
	        u,
	        a;for (; s < o; s++) for (u in i[s]) a = i[s][u], i[s].hasOwnProperty(u) && a !== t && (e.isPlainObject(a) ? n[u] = e.isPlainObject(n[u]) ? e.widget.extend({}, n[u], a) : e.widget.extend({}, a) : n[u] = a);return n;
	  }, e.widget.bridge = function (n, i) {
	    var s = i.prototype.widgetFullName;e.fn[n] = function (o) {
	      var u = typeof o == "string",
	          a = r.call(arguments, 1),
	          f = this;return o = !u && a.length ? e.widget.extend.apply(null, [o].concat(a)) : o, u ? this.each(function () {
	        var r,
	            i = e.data(this, s);if (!i) return e.error("cannot call methods on " + n + " prior to initialization; " + "attempted to call method '" + o + "'");if (!e.isFunction(i[o]) || o.charAt(0) === "_") return e.error("no such method '" + o + "' for " + n + " widget instance");r = i[o].apply(i, a);if (r !== i && r !== t) return f = r && r.jquery ? f.pushStack(r.get()) : r, !1;
	      }) : this.each(function () {
	        var t = e.data(this, s);t ? t.option(o || {})._init() : new i(o, this);
	      }), f;
	    };
	  }, e.Widget = function () {}, e.Widget._childConstructors = [], e.Widget.prototype = { widgetName: "widget", widgetEventPrefix: "", defaultElement: "<div>", options: { disabled: !1, create: null }, _createWidget: function (t, r) {
	      r = e(r || this.defaultElement || this)[0], this.element = e(r), this.uuid = n++, this.eventNamespace = "." + this.widgetName + this.uuid, this.options = e.widget.extend({}, this.options, this._getCreateOptions(), t), this.bindings = e(), this.hoverable = e(), this.focusable = e(), r !== this && (e.data(r, this.widgetName, this), e.data(r, this.widgetFullName, this), this._on(this.element, { remove: function (e) {
	          e.target === r && this.destroy();
	        } }), this.document = e(r.style ? r.ownerDocument : r.document || r), this.window = e(this.document[0].defaultView || this.document[0].parentWindow)), this._create(), this._trigger("create", null, this._getCreateEventData()), this._init();
	    }, _getCreateOptions: e.noop, _getCreateEventData: e.noop, _create: e.noop, _init: e.noop, destroy: function () {
	      this._destroy(), this.element.unbind(this.eventNamespace).removeData(this.widgetName).removeData(this.widgetFullName).removeData(e.camelCase(this.widgetFullName)), this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName + "-disabled " + "ui-state-disabled"), this.bindings.unbind(this.eventNamespace), this.hoverable.removeClass("ui-state-hover"), this.focusable.removeClass("ui-state-focus");
	    }, _destroy: e.noop, widget: function () {
	      return this.element;
	    }, option: function (n, r) {
	      var i = n,
	          s,
	          o,
	          u;if (arguments.length === 0) return e.widget.extend({}, this.options);if (typeof n == "string") {
	        i = {}, s = n.split("."), n = s.shift();if (s.length) {
	          o = i[n] = e.widget.extend({}, this.options[n]);for (u = 0; u < s.length - 1; u++) o[s[u]] = o[s[u]] || {}, o = o[s[u]];n = s.pop();if (r === t) return o[n] === t ? null : o[n];o[n] = r;
	        } else {
	          if (r === t) return this.options[n] === t ? null : this.options[n];i[n] = r;
	        }
	      }return this._setOptions(i), this;
	    }, _setOptions: function (e) {
	      var t;for (t in e) this._setOption(t, e[t]);return this;
	    }, _setOption: function (e, t) {
	      return this.options[e] = t, e === "disabled" && (this.widget().toggleClass(this.widgetFullName + "-disabled ui-state-disabled", !!t).attr("aria-disabled", t), this.hoverable.removeClass("ui-state-hover"), this.focusable.removeClass("ui-state-focus")), this;
	    }, enable: function () {
	      return this._setOption("disabled", !1);
	    }, disable: function () {
	      return this._setOption("disabled", !0);
	    }, _on: function (t, n) {
	      var r,
	          i = this;n ? (t = r = e(t), this.bindings = this.bindings.add(t)) : (n = t, t = this.element, r = this.widget()), e.each(n, function (n, s) {
	        function o() {
	          if (i.options.disabled === !0 || e(this).hasClass("ui-state-disabled")) return;return (typeof s == "string" ? i[s] : s).apply(i, arguments);
	        }typeof s != "string" && (o.guid = s.guid = s.guid || o.guid || e.guid++);var u = n.match(/^(\w+)\s*(.*)$/),
	            a = u[1] + i.eventNamespace,
	            f = u[2];f ? r.delegate(f, a, o) : t.bind(a, o);
	      });
	    }, _off: function (e, t) {
	      t = (t || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace, e.unbind(t).undelegate(t);
	    }, _delay: function (e, t) {
	      function n() {
	        return (typeof e == "string" ? r[e] : e).apply(r, arguments);
	      }var r = this;return setTimeout(n, t || 0);
	    }, _hoverable: function (t) {
	      this.hoverable = this.hoverable.add(t), this._on(t, { mouseenter: function (t) {
	          e(t.currentTarget).addClass("ui-state-hover");
	        }, mouseleave: function (t) {
	          e(t.currentTarget).removeClass("ui-state-hover");
	        } });
	    }, _focusable: function (t) {
	      this.focusable = this.focusable.add(t), this._on(t, { focusin: function (t) {
	          e(t.currentTarget).addClass("ui-state-focus");
	        }, focusout: function (t) {
	          e(t.currentTarget).removeClass("ui-state-focus");
	        } });
	    }, _trigger: function (t, n, r) {
	      var i,
	          s,
	          o = this.options[t];r = r || {}, n = e.Event(n), n.type = (t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t).toLowerCase(), n.target = this.element[0], s = n.originalEvent;if (s) for (i in s) i in n || (n[i] = s[i]);return this.element.trigger(n, r), !(e.isFunction(o) && o.apply(this.element[0], [n].concat(r)) === !1 || n.isDefaultPrevented());
	    } }, e.each({ show: "fadeIn", hide: "fadeOut" }, function (t, n) {
	    e.Widget.prototype["_" + t] = function (r, i, s) {
	      typeof i == "string" && (i = { effect: i });var o,
	          u = i ? i === !0 || typeof i == "number" ? n : i.effect || n : t;i = i || {}, typeof i == "number" && (i = { duration: i }), o = !e.isEmptyObject(i), i.complete = s, i.delay && r.delay(i.delay), o && e.effects && (e.effects.effect[u] || e.uiBackCompat !== !1 && e.effects[u]) ? r[t](i) : u !== t && r[u] ? r[u](i.duration, i.easing, s) : r.queue(function (n) {
	        e(this)[t](), s && s.call(r[0]), n();
	      });
	    };
	  }), e.uiBackCompat !== !1 && (e.Widget.prototype._getCreateOptions = function () {
	    return e.metadata && e.metadata.get(this.element[0])[this.widgetName];
	  });
	})(jQuery);(function (e, t) {
	  var n = !1;e(document).mouseup(function (e) {
	    n = !1;
	  }), e.widget("ui.mouse", { version: "1.9.1", options: { cancel: "input,textarea,button,select,option", distance: 1, delay: 0 }, _mouseInit: function () {
	      var t = this;this.element.bind("mousedown." + this.widgetName, function (e) {
	        return t._mouseDown(e);
	      }).bind("click." + this.widgetName, function (n) {
	        if (!0 === e.data(n.target, t.widgetName + ".preventClickEvent")) return e.removeData(n.target, t.widgetName + ".preventClickEvent"), n.stopImmediatePropagation(), !1;
	      }), this.started = !1;
	    }, _mouseDestroy: function () {
	      this.element.unbind("." + this.widgetName), this._mouseMoveDelegate && e(document).unbind("mousemove." + this.widgetName, this._mouseMoveDelegate).unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
	    }, _mouseDown: function (t) {
	      if (n) return;this._mouseStarted && this._mouseUp(t), this._mouseDownEvent = t;var r = this,
	          i = t.which === 1,
	          s = typeof this.options.cancel == "string" && t.target.nodeName ? e(t.target).closest(this.options.cancel).length : !1;if (!i || s || !this._mouseCapture(t)) return !0;this.mouseDelayMet = !this.options.delay, this.mouseDelayMet || (this._mouseDelayTimer = setTimeout(function () {
	        r.mouseDelayMet = !0;
	      }, this.options.delay));if (this._mouseDistanceMet(t) && this._mouseDelayMet(t)) {
	        this._mouseStarted = this._mouseStart(t) !== !1;if (!this._mouseStarted) return t.preventDefault(), !0;
	      }return !0 === e.data(t.target, this.widgetName + ".preventClickEvent") && e.removeData(t.target, this.widgetName + ".preventClickEvent"), this._mouseMoveDelegate = function (e) {
	        return r._mouseMove(e);
	      }, this._mouseUpDelegate = function (e) {
	        return r._mouseUp(e);
	      }, e(document).bind("mousemove." + this.widgetName, this._mouseMoveDelegate).bind("mouseup." + this.widgetName, this._mouseUpDelegate), t.preventDefault(), n = !0, !0;
	    }, _mouseMove: function (t) {
	      return !e.ui.ie || document.documentMode >= 9 || !!t.button ? this._mouseStarted ? (this._mouseDrag(t), t.preventDefault()) : (this._mouseDistanceMet(t) && this._mouseDelayMet(t) && (this._mouseStarted = this._mouseStart(this._mouseDownEvent, t) !== !1, this._mouseStarted ? this._mouseDrag(t) : this._mouseUp(t)), !this._mouseStarted) : this._mouseUp(t);
	    }, _mouseUp: function (t) {
	      return e(document).unbind("mousemove." + this.widgetName, this._mouseMoveDelegate).unbind("mouseup." + this.widgetName, this._mouseUpDelegate), this._mouseStarted && (this._mouseStarted = !1, t.target === this._mouseDownEvent.target && e.data(t.target, this.widgetName + ".preventClickEvent", !0), this._mouseStop(t)), !1;
	    }, _mouseDistanceMet: function (e) {
	      return Math.max(Math.abs(this._mouseDownEvent.pageX - e.pageX), Math.abs(this._mouseDownEvent.pageY - e.pageY)) >= this.options.distance;
	    }, _mouseDelayMet: function (e) {
	      return this.mouseDelayMet;
	    }, _mouseStart: function (e) {}, _mouseDrag: function (e) {}, _mouseStop: function (e) {}, _mouseCapture: function (e) {
	      return !0;
	    } });
	})(jQuery);(function (e, t) {
	  function h(e, t, n) {
	    return [parseInt(e[0], 10) * (l.test(e[0]) ? t / 100 : 1), parseInt(e[1], 10) * (l.test(e[1]) ? n / 100 : 1)];
	  }function p(t, n) {
	    return parseInt(e.css(t, n), 10) || 0;
	  }e.ui = e.ui || {};var n,
	      r = Math.max,
	      i = Math.abs,
	      s = Math.round,
	      o = /left|center|right/,
	      u = /top|center|bottom/,
	      a = /[\+\-]\d+%?/,
	      f = /^\w+/,
	      l = /%$/,
	      c = e.fn.position;e.position = { scrollbarWidth: function () {
	      if (n !== t) return n;var r,
	          i,
	          s = e("<div style='display:block;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),
	          o = s.children()[0];return e("body").append(s), r = o.offsetWidth, s.css("overflow", "scroll"), i = o.offsetWidth, r === i && (i = s[0].clientWidth), s.remove(), n = r - i;
	    }, getScrollInfo: function (t) {
	      var n = t.isWindow ? "" : t.element.css("overflow-x"),
	          r = t.isWindow ? "" : t.element.css("overflow-y"),
	          i = n === "scroll" || n === "auto" && t.width < t.element[0].scrollWidth,
	          s = r === "scroll" || r === "auto" && t.height < t.element[0].scrollHeight;return { width: i ? e.position.scrollbarWidth() : 0, height: s ? e.position.scrollbarWidth() : 0 };
	    }, getWithinInfo: function (t) {
	      var n = e(t || window),
	          r = e.isWindow(n[0]);return { element: n, isWindow: r, offset: n.offset() || { left: 0, top: 0 }, scrollLeft: n.scrollLeft(), scrollTop: n.scrollTop(), width: r ? n.width() : n.outerWidth(), height: r ? n.height() : n.outerHeight() };
	    } }, e.fn.position = function (t) {
	    if (!t || !t.of) return c.apply(this, arguments);t = e.extend({}, t);var n,
	        l,
	        d,
	        v,
	        m,
	        g = e(t.of),
	        y = e.position.getWithinInfo(t.within),
	        b = e.position.getScrollInfo(y),
	        w = g[0],
	        E = (t.collision || "flip").split(" "),
	        S = {};return w.nodeType === 9 ? (l = g.width(), d = g.height(), v = { top: 0, left: 0 }) : e.isWindow(w) ? (l = g.width(), d = g.height(), v = { top: g.scrollTop(), left: g.scrollLeft() }) : w.preventDefault ? (t.at = "left top", l = d = 0, v = { top: w.pageY, left: w.pageX }) : (l = g.outerWidth(), d = g.outerHeight(), v = g.offset()), m = e.extend({}, v), e.each(["my", "at"], function () {
	      var e = (t[this] || "").split(" "),
	          n,
	          r;e.length === 1 && (e = o.test(e[0]) ? e.concat(["center"]) : u.test(e[0]) ? ["center"].concat(e) : ["center", "center"]), e[0] = o.test(e[0]) ? e[0] : "center", e[1] = u.test(e[1]) ? e[1] : "center", n = a.exec(e[0]), r = a.exec(e[1]), S[this] = [n ? n[0] : 0, r ? r[0] : 0], t[this] = [f.exec(e[0])[0], f.exec(e[1])[0]];
	    }), E.length === 1 && (E[1] = E[0]), t.at[0] === "right" ? m.left += l : t.at[0] === "center" && (m.left += l / 2), t.at[1] === "bottom" ? m.top += d : t.at[1] === "center" && (m.top += d / 2), n = h(S.at, l, d), m.left += n[0], m.top += n[1], this.each(function () {
	      var o,
	          u,
	          a = e(this),
	          f = a.outerWidth(),
	          c = a.outerHeight(),
	          w = p(this, "marginLeft"),
	          x = p(this, "marginTop"),
	          T = f + w + p(this, "marginRight") + b.width,
	          N = c + x + p(this, "marginBottom") + b.height,
	          C = e.extend({}, m),
	          k = h(S.my, a.outerWidth(), a.outerHeight());t.my[0] === "right" ? C.left -= f : t.my[0] === "center" && (C.left -= f / 2), t.my[1] === "bottom" ? C.top -= c : t.my[1] === "center" && (C.top -= c / 2), C.left += k[0], C.top += k[1], e.support.offsetFractions || (C.left = s(C.left), C.top = s(C.top)), o = { marginLeft: w, marginTop: x }, e.each(["left", "top"], function (r, i) {
	        e.ui.position[E[r]] && e.ui.position[E[r]][i](C, { targetWidth: l, targetHeight: d, elemWidth: f, elemHeight: c, collisionPosition: o, collisionWidth: T, collisionHeight: N, offset: [n[0] + k[0], n[1] + k[1]], my: t.my, at: t.at, within: y, elem: a });
	      }), e.fn.bgiframe && a.bgiframe(), t.using && (u = function (e) {
	        var n = v.left - C.left,
	            s = n + l - f,
	            o = v.top - C.top,
	            u = o + d - c,
	            h = { target: { element: g, left: v.left, top: v.top, width: l, height: d }, element: { element: a, left: C.left, top: C.top, width: f, height: c }, horizontal: s < 0 ? "left" : n > 0 ? "right" : "center", vertical: u < 0 ? "top" : o > 0 ? "bottom" : "middle" };l < f && i(n + s) < l && (h.horizontal = "center"), d < c && i(o + u) < d && (h.vertical = "middle"), r(i(n), i(s)) > r(i(o), i(u)) ? h.important = "horizontal" : h.important = "vertical", t.using.call(this, e, h);
	      }), a.offset(e.extend(C, { using: u }));
	    });
	  }, e.ui.position = { fit: { left: function (e, t) {
	        var n = t.within,
	            i = n.isWindow ? n.scrollLeft : n.offset.left,
	            s = n.width,
	            o = e.left - t.collisionPosition.marginLeft,
	            u = i - o,
	            a = o + t.collisionWidth - s - i,
	            f;t.collisionWidth > s ? u > 0 && a <= 0 ? (f = e.left + u + t.collisionWidth - s - i, e.left += u - f) : a > 0 && u <= 0 ? e.left = i : u > a ? e.left = i + s - t.collisionWidth : e.left = i : u > 0 ? e.left += u : a > 0 ? e.left -= a : e.left = r(e.left - o, e.left);
	      }, top: function (e, t) {
	        var n = t.within,
	            i = n.isWindow ? n.scrollTop : n.offset.top,
	            s = t.within.height,
	            o = e.top - t.collisionPosition.marginTop,
	            u = i - o,
	            a = o + t.collisionHeight - s - i,
	            f;t.collisionHeight > s ? u > 0 && a <= 0 ? (f = e.top + u + t.collisionHeight - s - i, e.top += u - f) : a > 0 && u <= 0 ? e.top = i : u > a ? e.top = i + s - t.collisionHeight : e.top = i : u > 0 ? e.top += u : a > 0 ? e.top -= a : e.top = r(e.top - o, e.top);
	      } }, flip: { left: function (e, t) {
	        var n = t.within,
	            r = n.offset.left + n.scrollLeft,
	            s = n.width,
	            o = n.isWindow ? n.scrollLeft : n.offset.left,
	            u = e.left - t.collisionPosition.marginLeft,
	            a = u - o,
	            f = u + t.collisionWidth - s - o,
	            l = t.my[0] === "left" ? -t.elemWidth : t.my[0] === "right" ? t.elemWidth : 0,
	            c = t.at[0] === "left" ? t.targetWidth : t.at[0] === "right" ? -t.targetWidth : 0,
	            h = -2 * t.offset[0],
	            p,
	            d;if (a < 0) {
	          p = e.left + l + c + h + t.collisionWidth - s - r;if (p < 0 || p < i(a)) e.left += l + c + h;
	        } else if (f > 0) {
	          d = e.left - t.collisionPosition.marginLeft + l + c + h - o;if (d > 0 || i(d) < f) e.left += l + c + h;
	        }
	      }, top: function (e, t) {
	        var n = t.within,
	            r = n.offset.top + n.scrollTop,
	            s = n.height,
	            o = n.isWindow ? n.scrollTop : n.offset.top,
	            u = e.top - t.collisionPosition.marginTop,
	            a = u - o,
	            f = u + t.collisionHeight - s - o,
	            l = t.my[1] === "top",
	            c = l ? -t.elemHeight : t.my[1] === "bottom" ? t.elemHeight : 0,
	            h = t.at[1] === "top" ? t.targetHeight : t.at[1] === "bottom" ? -t.targetHeight : 0,
	            p = -2 * t.offset[1],
	            d,
	            v;a < 0 ? (v = e.top + c + h + p + t.collisionHeight - s - r, e.top + c + h + p > a && (v < 0 || v < i(a)) && (e.top += c + h + p)) : f > 0 && (d = e.top - t.collisionPosition.marginTop + c + h + p - o, e.top + c + h + p > f && (d > 0 || i(d) < f) && (e.top += c + h + p));
	      } }, flipfit: { left: function () {
	        e.ui.position.flip.left.apply(this, arguments), e.ui.position.fit.left.apply(this, arguments);
	      }, top: function () {
	        e.ui.position.flip.top.apply(this, arguments), e.ui.position.fit.top.apply(this, arguments);
	      } } }, function () {
	    var t,
	        n,
	        r,
	        i,
	        s,
	        o = document.getElementsByTagName("body")[0],
	        u = document.createElement("div");t = document.createElement(o ? "div" : "body"), r = { visibility: "hidden", width: 0, height: 0, border: 0, margin: 0, background: "none" }, o && e.extend(r, { position: "absolute", left: "-1000px", top: "-1000px" });for (s in r) t.style[s] = r[s];t.appendChild(u), n = o || document.documentElement, n.insertBefore(t, n.firstChild), u.style.cssText = "position: absolute; left: 10.7432222px;", i = e(u).offset().left, e.support.offsetFractions = i > 10 && i < 11, t.innerHTML = "", n.removeChild(t);
	  }(), e.uiBackCompat !== !1 && function (e) {
	    var n = e.fn.position;e.fn.position = function (r) {
	      if (!r || !r.offset) return n.call(this, r);var i = r.offset.split(" "),
	          s = r.at.split(" ");return i.length === 1 && (i[1] = i[0]), /^\d/.test(i[0]) && (i[0] = "+" + i[0]), /^\d/.test(i[1]) && (i[1] = "+" + i[1]), s.length === 1 && (/left|center|right/.test(s[0]) ? s[1] = "center" : (s[1] = s[0], s[0] = "center")), n.call(this, e.extend(r, { at: s[0] + i[0] + " " + s[1] + i[1], offset: t }));
	    };
	  }(jQuery);
	})(jQuery);(function (e, t) {
	  var n = 0;e.widget("ui.autocomplete", { version: "1.9.1", defaultElement: "<input>", options: { appendTo: "body", autoFocus: !1, delay: 300, minLength: 1, position: { my: "left top", at: "left bottom", collision: "none" }, source: null, change: null, close: null, focus: null, open: null, response: null, search: null, select: null }, pending: 0, _create: function () {
	      var t, n, r;this.isMultiLine = this._isMultiLine(), this.valueMethod = this.element[this.element.is("input,textarea") ? "val" : "text"], this.isNewMenu = !0, this.element.addClass("ui-autocomplete-input").attr("autocomplete", "off"), this._on(this.element, { keydown: function (i) {
	          if (this.element.prop("readOnly")) {
	            t = !0, r = !0, n = !0;return;
	          }t = !1, r = !1, n = !1;var s = e.ui.keyCode;switch (i.keyCode) {case s.PAGE_UP:
	              t = !0, this._move("previousPage", i);break;case s.PAGE_DOWN:
	              t = !0, this._move("nextPage", i);break;case s.UP:
	              t = !0, this._keyEvent("previous", i);break;case s.DOWN:
	              t = !0, this._keyEvent("next", i);break;case s.ENTER:case s.NUMPAD_ENTER:
	              this.menu.active && (t = !0, i.preventDefault(), this.menu.select(i));break;case s.TAB:
	              this.menu.active && this.menu.select(i);break;case s.ESCAPE:
	              this.menu.element.is(":visible") && (this._value(this.term), this.close(i), i.preventDefault());break;default:
	              n = !0, this._searchTimeout(i);}
	        }, keypress: function (r) {
	          if (t) {
	            t = !1, r.preventDefault();return;
	          }if (n) return;var i = e.ui.keyCode;switch (r.keyCode) {case i.PAGE_UP:
	              this._move("previousPage", r);break;case i.PAGE_DOWN:
	              this._move("nextPage", r);break;case i.UP:
	              this._keyEvent("previous", r);break;case i.DOWN:
	              this._keyEvent("next", r);}
	        }, input: function (e) {
	          if (r) {
	            r = !1, e.preventDefault();return;
	          }this._searchTimeout(e);
	        }, focus: function () {
	          this.selectedItem = null, this.previous = this._value();
	        }, blur: function (e) {
	          if (this.cancelBlur) {
	            delete this.cancelBlur;return;
	          }clearTimeout(this.searching), this.close(e), this._change(e);
	        } }), this._initSource(), this.menu = e("<ul>").addClass("ui-autocomplete").appendTo(this.document.find(this.options.appendTo || "body")[0]).menu({ input: e(), role: null }).zIndex(this.element.zIndex() + 1).hide().data("menu"), this._on(this.menu.element, { mousedown: function (t) {
	          t.preventDefault(), this.cancelBlur = !0, this._delay(function () {
	            delete this.cancelBlur;
	          });var n = this.menu.element[0];e(t.target).closest(".ui-menu-item").length || this._delay(function () {
	            var t = this;this.document.one("mousedown", function (r) {
	              r.target !== t.element[0] && r.target !== n && !e.contains(n, r.target) && t.close();
	            });
	          });
	        }, menufocus: function (t, n) {
	          if (this.isNewMenu) {
	            this.isNewMenu = !1;if (t.originalEvent && /^mouse/.test(t.originalEvent.type)) {
	              this.menu.blur(), this.document.one("mousemove", function () {
	                e(t.target).trigger(t.originalEvent);
	              });return;
	            }
	          }var r = n.item.data("ui-autocomplete-item") || n.item.data("item.autocomplete");!1 !== this._trigger("focus", t, { item: r }) ? t.originalEvent && /^key/.test(t.originalEvent.type) && this._value(r.value) : this.liveRegion.text(r.value);
	        }, menuselect: function (e, t) {
	          var n = t.item.data("ui-autocomplete-item") || t.item.data("item.autocomplete"),
	              r = this.previous;this.element[0] !== this.document[0].activeElement && (this.element.focus(), this.previous = r, this._delay(function () {
	            this.previous = r, this.selectedItem = n;
	          })), !1 !== this._trigger("select", e, { item: n }) && this._value(n.value), this.term = this._value(), this.close(e), this.selectedItem = n;
	        } }), this.liveRegion = e("<span>", { role: "status", "aria-live": "polite" }).addClass("ui-helper-hidden-accessible").insertAfter(this.element), e.fn.bgiframe && this.menu.element.bgiframe(), this._on(this.window, { beforeunload: function () {
	          this.element.removeAttr("autocomplete");
	        } });
	    }, _destroy: function () {
	      clearTimeout(this.searching), this.element.removeClass("ui-autocomplete-input").removeAttr("autocomplete"), this.menu.element.remove(), this.liveRegion.remove();
	    }, _setOption: function (e, t) {
	      this._super(e, t), e === "source" && this._initSource(), e === "appendTo" && this.menu.element.appendTo(this.document.find(t || "body")[0]), e === "disabled" && t && this.xhr && this.xhr.abort();
	    }, _isMultiLine: function () {
	      return this.element.is("textarea") ? !0 : this.element.is("input") ? !1 : this.element.prop("isContentEditable");
	    }, _initSource: function () {
	      var t,
	          n,
	          r = this;e.isArray(this.options.source) ? (t = this.options.source, this.source = function (n, r) {
	        r(e.ui.autocomplete.filter(t, n.term));
	      }) : typeof this.options.source == "string" ? (n = this.options.source, this.source = function (t, i) {
	        r.xhr && r.xhr.abort(), r.xhr = e.ajax({ url: n, data: t, dataType: "json", success: function (e) {
	            i(e);
	          }, error: function () {
	            i([]);
	          } });
	      }) : this.source = this.options.source;
	    }, _searchTimeout: function (e) {
	      clearTimeout(this.searching), this.searching = this._delay(function () {
	        this.term !== this._value() && (this.selectedItem = null, this.search(null, e));
	      }, this.options.delay);
	    }, search: function (e, t) {
	      e = e != null ? e : this._value(), this.term = this._value();if (e.length < this.options.minLength) return this.close(t);if (this._trigger("search", t) === !1) return;return this._search(e);
	    }, _search: function (e) {
	      this.pending++, this.element.addClass("ui-autocomplete-loading"), this.cancelSearch = !1, this.source({ term: e }, this._response());
	    }, _response: function () {
	      var e = this,
	          t = ++n;return function (r) {
	        t === n && e.__response(r), e.pending--, e.pending || e.element.removeClass("ui-autocomplete-loading");
	      };
	    }, __response: function (e) {
	      e && (e = this._normalize(e)), this._trigger("response", null, { content: e }), !this.options.disabled && e && e.length && !this.cancelSearch ? (this._suggest(e), this._trigger("open")) : this._close();
	    }, close: function (e) {
	      this.cancelSearch = !0, this._close(e);
	    }, _close: function (e) {
	      this.menu.element.is(":visible") && (this.menu.element.hide(), this.menu.blur(), this.isNewMenu = !0, this._trigger("close", e));
	    }, _change: function (e) {
	      this.previous !== this._value() && this._trigger("change", e, { item: this.selectedItem });
	    }, _normalize: function (t) {
	      return t.length && t[0].label && t[0].value ? t : e.map(t, function (t) {
	        return typeof t == "string" ? { label: t, value: t } : e.extend({ label: t.label || t.value, value: t.value || t.label }, t);
	      });
	    }, _suggest: function (t) {
	      var n = this.menu.element.empty().zIndex(this.element.zIndex() + 1);this._renderMenu(n, t), this.menu.refresh(), n.show(), this._resizeMenu(), n.position(e.extend({ of: this.element }, this.options.position)), this.options.autoFocus && this.menu.next();
	    }, _resizeMenu: function () {
	      var e = this.menu.element;e.outerWidth(Math.max(e.width("").outerWidth() + 1, this.element.outerWidth()));
	    }, _renderMenu: function (t, n) {
	      var r = this;e.each(n, function (e, n) {
	        r._renderItemData(t, n);
	      });
	    }, _renderItemData: function (e, t) {
	      return this._renderItem(e, t).data("ui-autocomplete-item", t);
	    }, _renderItem: function (t, n) {
	      return e("<li>").append(e("<a>").text(n.label)).appendTo(t);
	    }, _move: function (e, t) {
	      if (!this.menu.element.is(":visible")) {
	        this.search(null, t);return;
	      }if (this.menu.isFirstItem() && /^previous/.test(e) || this.menu.isLastItem() && /^next/.test(e)) {
	        this._value(this.term), this.menu.blur();return;
	      }this.menu[e](t);
	    }, widget: function () {
	      return this.menu.element;
	    }, _value: function () {
	      return this.valueMethod.apply(this.element, arguments);
	    }, _keyEvent: function (e, t) {
	      if (!this.isMultiLine || this.menu.element.is(":visible")) this._move(e, t), t.preventDefault();
	    } }), e.extend(e.ui.autocomplete, { escapeRegex: function (e) {
	      return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
	    }, filter: function (t, n) {
	      var r = new RegExp(e.ui.autocomplete.escapeRegex(n), "i");return e.grep(t, function (e) {
	        return r.test(e.label || e.value || e);
	      });
	    } }), e.widget("ui.autocomplete", e.ui.autocomplete, { options: { messages: { noResults: "No search results.", results: function (e) {
	          return e + (e > 1 ? " results are" : " result is") + " available, use up and down arrow keys to navigate.";
	        } } }, __response: function (e) {
	      var t;this._superApply(arguments);if (this.options.disabled || this.cancelSearch) return;e && e.length ? t = this.options.messages.results(e.length) : t = this.options.messages.noResults, this.liveRegion.text(t);
	    } });
	})(jQuery);(function (e, t) {
	  var n,
	      r,
	      i,
	      s,
	      o = "ui-button ui-widget ui-state-default ui-corner-all",
	      u = "ui-state-hover ui-state-active ",
	      a = "ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",
	      f = function () {
	    var t = e(this).find(":ui-button");setTimeout(function () {
	      t.button("refresh");
	    }, 1);
	  },
	      l = function (t) {
	    var n = t.name,
	        r = t.form,
	        i = e([]);return n && (r ? i = e(r).find("[name='" + n + "']") : i = e("[name='" + n + "']", t.ownerDocument).filter(function () {
	      return !this.form;
	    })), i;
	  };e.widget("ui.button", { version: "1.9.1", defaultElement: "<button>", options: { disabled: null, text: !0, label: null, icons: { primary: null, secondary: null } }, _create: function () {
	      this.element.closest("form").unbind("reset" + this.eventNamespace).bind("reset" + this.eventNamespace, f), typeof this.options.disabled != "boolean" ? this.options.disabled = !!this.element.prop("disabled") : this.element.prop("disabled", this.options.disabled), this._determineButtonType(), this.hasTitle = !!this.buttonElement.attr("title");var t = this,
	          u = this.options,
	          a = this.type === "checkbox" || this.type === "radio",
	          c = "ui-state-hover" + (a ? "" : " ui-state-active"),
	          h = "ui-state-focus";u.label === null && (u.label = this.type === "input" ? this.buttonElement.val() : this.buttonElement.html()), this.buttonElement.addClass(o).attr("role", "button").bind("mouseenter" + this.eventNamespace, function () {
	        if (u.disabled) return;e(this).addClass("ui-state-hover"), this === n && e(this).addClass("ui-state-active");
	      }).bind("mouseleave" + this.eventNamespace, function () {
	        if (u.disabled) return;e(this).removeClass(c);
	      }).bind("click" + this.eventNamespace, function (e) {
	        u.disabled && (e.preventDefault(), e.stopImmediatePropagation());
	      }), this.element.bind("focus" + this.eventNamespace, function () {
	        t.buttonElement.addClass(h);
	      }).bind("blur" + this.eventNamespace, function () {
	        t.buttonElement.removeClass(h);
	      }), a && (this.element.bind("change" + this.eventNamespace, function () {
	        if (s) return;t.refresh();
	      }), this.buttonElement.bind("mousedown" + this.eventNamespace, function (e) {
	        if (u.disabled) return;s = !1, r = e.pageX, i = e.pageY;
	      }).bind("mouseup" + this.eventNamespace, function (e) {
	        if (u.disabled) return;if (r !== e.pageX || i !== e.pageY) s = !0;
	      })), this.type === "checkbox" ? this.buttonElement.bind("click" + this.eventNamespace, function () {
	        if (u.disabled || s) return !1;e(this).toggleClass("ui-state-active"), t.buttonElement.attr("aria-pressed", t.element[0].checked);
	      }) : this.type === "radio" ? this.buttonElement.bind("click" + this.eventNamespace, function () {
	        if (u.disabled || s) return !1;e(this).addClass("ui-state-active"), t.buttonElement.attr("aria-pressed", "true");var n = t.element[0];l(n).not(n).map(function () {
	          return e(this).button("widget")[0];
	        }).removeClass("ui-state-active").attr("aria-pressed", "false");
	      }) : (this.buttonElement.bind("mousedown" + this.eventNamespace, function () {
	        if (u.disabled) return !1;e(this).addClass("ui-state-active"), n = this, t.document.one("mouseup", function () {
	          n = null;
	        });
	      }).bind("mouseup" + this.eventNamespace, function () {
	        if (u.disabled) return !1;e(this).removeClass("ui-state-active");
	      }).bind("keydown" + this.eventNamespace, function (t) {
	        if (u.disabled) return !1;(t.keyCode === e.ui.keyCode.SPACE || t.keyCode === e.ui.keyCode.ENTER) && e(this).addClass("ui-state-active");
	      }).bind("keyup" + this.eventNamespace, function () {
	        e(this).removeClass("ui-state-active");
	      }), this.buttonElement.is("a") && this.buttonElement.keyup(function (t) {
	        t.keyCode === e.ui.keyCode.SPACE && e(this).click();
	      })), this._setOption("disabled", u.disabled), this._resetButton();
	    }, _determineButtonType: function () {
	      var e, t, n;this.element.is("[type=checkbox]") ? this.type = "checkbox" : this.element.is("[type=radio]") ? this.type = "radio" : this.element.is("input") ? this.type = "input" : this.type = "button", this.type === "checkbox" || this.type === "radio" ? (e = this.element.parents().last(), t = "label[for='" + this.element.attr("id") + "']", this.buttonElement = e.find(t), this.buttonElement.length || (e = e.length ? e.siblings() : this.element.siblings(), this.buttonElement = e.filter(t), this.buttonElement.length || (this.buttonElement = e.find(t))), this.element.addClass("ui-helper-hidden-accessible"), n = this.element.is(":checked"), n && this.buttonElement.addClass("ui-state-active"), this.buttonElement.prop("aria-pressed", n)) : this.buttonElement = this.element;
	    }, widget: function () {
	      return this.buttonElement;
	    }, _destroy: function () {
	      this.element.removeClass("ui-helper-hidden-accessible"), this.buttonElement.removeClass(o + " " + u + " " + a).removeAttr("role").removeAttr("aria-pressed").html(this.buttonElement.find(".ui-button-text").html()), this.hasTitle || this.buttonElement.removeAttr("title");
	    }, _setOption: function (e, t) {
	      this._super(e, t);if (e === "disabled") {
	        t ? this.element.prop("disabled", !0) : this.element.prop("disabled", !1);return;
	      }this._resetButton();
	    }, refresh: function () {
	      var t = this.element.is(":disabled") || this.element.hasClass("ui-button-disabled");t !== this.options.disabled && this._setOption("disabled", t), this.type === "radio" ? l(this.element[0]).each(function () {
	        e(this).is(":checked") ? e(this).button("widget").addClass("ui-state-active").attr("aria-pressed", "true") : e(this).button("widget").removeClass("ui-state-active").attr("aria-pressed", "false");
	      }) : this.type === "checkbox" && (this.element.is(":checked") ? this.buttonElement.addClass("ui-state-active").attr("aria-pressed", "true") : this.buttonElement.removeClass("ui-state-active").attr("aria-pressed", "false"));
	    }, _resetButton: function () {
	      if (this.type === "input") {
	        this.options.label && this.element.val(this.options.label);return;
	      }var t = this.buttonElement.removeClass(a),
	          n = e("<span></span>", this.document[0]).addClass("ui-button-text").html(this.options.label).appendTo(t.empty()).text(),
	          r = this.options.icons,
	          i = r.primary && r.secondary,
	          s = [];r.primary || r.secondary ? (this.options.text && s.push("ui-button-text-icon" + (i ? "s" : r.primary ? "-primary" : "-secondary")), r.primary && t.prepend("<span class='ui-button-icon-primary ui-icon " + r.primary + "'></span>"), r.secondary && t.append("<span class='ui-button-icon-secondary ui-icon " + r.secondary + "'></span>"), this.options.text || (s.push(i ? "ui-button-icons-only" : "ui-button-icon-only"), this.hasTitle || t.attr("title", e.trim(n)))) : s.push("ui-button-text-only"), t.addClass(s.join(" "));
	    } }), e.widget("ui.buttonset", { version: "1.9.1", options: { items: "button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(button)" }, _create: function () {
	      this.element.addClass("ui-buttonset");
	    }, _init: function () {
	      this.refresh();
	    }, _setOption: function (e, t) {
	      e === "disabled" && this.buttons.button("option", e, t), this._super(e, t);
	    }, refresh: function () {
	      var t = this.element.css("direction") === "rtl";this.buttons = this.element.find(this.options.items).filter(":ui-button").button("refresh").end().not(":ui-button").button().end().map(function () {
	        return e(this).button("widget")[0];
	      }).removeClass("ui-corner-all ui-corner-left ui-corner-right").filter(":first").addClass(t ? "ui-corner-right" : "ui-corner-left").end().filter(":last").addClass(t ? "ui-corner-left" : "ui-corner-right").end().end();
	    }, _destroy: function () {
	      this.element.removeClass("ui-buttonset"), this.buttons.map(function () {
	        return e(this).button("widget")[0];
	      }).removeClass("ui-corner-left ui-corner-right").end().button("destroy");
	    } });
	})(jQuery);(function (e, t) {
	  var n = !1;e.widget("ui.menu", { version: "1.9.1", defaultElement: "<ul>", delay: 300, options: { icons: { submenu: "ui-icon-carat-1-e" }, menus: "ul", position: { my: "left top", at: "right top" }, role: "menu", blur: null, focus: null, select: null }, _create: function () {
	      this.activeMenu = this.element, this.element.uniqueId().addClass("ui-menu ui-widget ui-widget-content ui-corner-all").toggleClass("ui-menu-icons", !!this.element.find(".ui-icon").length).attr({ role: this.options.role, tabIndex: 0 }).bind("click" + this.eventNamespace, e.proxy(function (e) {
	        this.options.disabled && e.preventDefault();
	      }, this)), this.options.disabled && this.element.addClass("ui-state-disabled").attr("aria-disabled", "true"), this._on({ "mousedown .ui-menu-item > a": function (e) {
	          e.preventDefault();
	        }, "click .ui-state-disabled > a": function (e) {
	          e.preventDefault();
	        }, "click .ui-menu-item:has(a)": function (t) {
	          var r = e(t.target).closest(".ui-menu-item");!n && r.not(".ui-state-disabled").length && (n = !0, this.select(t), r.has(".ui-menu").length ? this.expand(t) : this.element.is(":focus") || (this.element.trigger("focus", [!0]), this.active && this.active.parents(".ui-menu").length === 1 && clearTimeout(this.timer)));
	        }, "mouseenter .ui-menu-item": function (t) {
	          var n = e(t.currentTarget);n.siblings().children(".ui-state-active").removeClass("ui-state-active"), this.focus(t, n);
	        }, mouseleave: "collapseAll", "mouseleave .ui-menu": "collapseAll", focus: function (e, t) {
	          var n = this.active || this.element.children(".ui-menu-item").eq(0);t || this.focus(e, n);
	        }, blur: function (t) {
	          this._delay(function () {
	            e.contains(this.element[0], this.document[0].activeElement) || this.collapseAll(t);
	          });
	        }, keydown: "_keydown" }), this.refresh(), this._on(this.document, { click: function (t) {
	          e(t.target).closest(".ui-menu").length || this.collapseAll(t), n = !1;
	        } });
	    }, _destroy: function () {
	      this.element.removeAttr("aria-activedescendant").find(".ui-menu").andSelf().removeClass("ui-menu ui-widget ui-widget-content ui-corner-all ui-menu-icons").removeAttr("role").removeAttr("tabIndex").removeAttr("aria-labelledby").removeAttr("aria-expanded").removeAttr("aria-hidden").removeAttr("aria-disabled").removeUniqueId().show(), this.element.find(".ui-menu-item").removeClass("ui-menu-item").removeAttr("role").removeAttr("aria-disabled").children("a").removeUniqueId().removeClass("ui-corner-all ui-state-hover").removeAttr("tabIndex").removeAttr("role").removeAttr("aria-haspopup").children().each(function () {
	        var t = e(this);t.data("ui-menu-submenu-carat") && t.remove();
	      }), this.element.find(".ui-menu-divider").removeClass("ui-menu-divider ui-widget-content");
	    }, _keydown: function (t) {
	      function a(e) {
	        return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
	      }var n,
	          r,
	          i,
	          s,
	          o,
	          u = !0;switch (t.keyCode) {case e.ui.keyCode.PAGE_UP:
	          this.previousPage(t);break;case e.ui.keyCode.PAGE_DOWN:
	          this.nextPage(t);break;case e.ui.keyCode.HOME:
	          this._move("first", "first", t);break;case e.ui.keyCode.END:
	          this._move("last", "last", t);break;case e.ui.keyCode.UP:
	          this.previous(t);break;case e.ui.keyCode.DOWN:
	          this.next(t);break;case e.ui.keyCode.LEFT:
	          this.collapse(t);break;case e.ui.keyCode.RIGHT:
	          this.active && !this.active.is(".ui-state-disabled") && this.expand(t);break;case e.ui.keyCode.ENTER:case e.ui.keyCode.SPACE:
	          this._activate(t);break;case e.ui.keyCode.ESCAPE:
	          this.collapse(t);break;default:
	          u = !1, r = this.previousFilter || "", i = String.fromCharCode(t.keyCode), s = !1, clearTimeout(this.filterTimer), i === r ? s = !0 : i = r + i, o = new RegExp("^" + a(i), "i"), n = this.activeMenu.children(".ui-menu-item").filter(function () {
	            return o.test(e(this).children("a").text());
	          }), n = s && n.index(this.active.next()) !== -1 ? this.active.nextAll(".ui-menu-item") : n, n.length || (i = String.fromCharCode(t.keyCode), o = new RegExp("^" + a(i), "i"), n = this.activeMenu.children(".ui-menu-item").filter(function () {
	            return o.test(e(this).children("a").text());
	          })), n.length ? (this.focus(t, n), n.length > 1 ? (this.previousFilter = i, this.filterTimer = this._delay(function () {
	            delete this.previousFilter;
	          }, 1e3)) : delete this.previousFilter) : delete this.previousFilter;}u && t.preventDefault();
	    }, _activate: function (e) {
	      this.active.is(".ui-state-disabled") || (this.active.children("a[aria-haspopup='true']").length ? this.expand(e) : this.select(e));
	    }, refresh: function () {
	      var t,
	          n = this.options.icons.submenu,
	          r = this.element.find(this.options.menus + ":not(.ui-menu)").addClass("ui-menu ui-widget ui-widget-content ui-corner-all").hide().attr({ role: this.options.role, "aria-hidden": "true", "aria-expanded": "false" });t = r.add(this.element), t.children(":not(.ui-menu-item):has(a)").addClass("ui-menu-item").attr("role", "presentation").children("a").uniqueId().addClass("ui-corner-all").attr({ tabIndex: -1, role: this._itemRole() }), t.children(":not(.ui-menu-item)").each(function () {
	        var t = e(this);/[^\-—–\s]/.test(t.text()) || t.addClass("ui-widget-content ui-menu-divider");
	      }), t.children(".ui-state-disabled").attr("aria-disabled", "true"), r.each(function () {
	        var t = e(this),
	            r = t.prev("a"),
	            i = e("<span>").addClass("ui-menu-icon ui-icon " + n).data("ui-menu-submenu-carat", !0);r.attr("aria-haspopup", "true").prepend(i), t.attr("aria-labelledby", r.attr("id"));
	      }), this.active && !e.contains(this.element[0], this.active[0]) && this.blur();
	    }, _itemRole: function () {
	      return { menu: "menuitem", listbox: "option" }[this.options.role];
	    }, focus: function (e, t) {
	      var n, r;this.blur(e, e && e.type === "focus"), this._scrollIntoView(t), this.active = t.first(), r = this.active.children("a").addClass("ui-state-focus"), this.options.role && this.element.attr("aria-activedescendant", r.attr("id")), this.active.parent().closest(".ui-menu-item").children("a:first").addClass("ui-state-active"), e && e.type === "keydown" ? this._close() : this.timer = this._delay(function () {
	        this._close();
	      }, this.delay), n = t.children(".ui-menu"), n.length && /^mouse/.test(e.type) && this._startOpening(n), this.activeMenu = t.parent(), this._trigger("focus", e, { item: t });
	    }, _scrollIntoView: function (t) {
	      var n, r, i, s, o, u;this._hasScroll() && (n = parseFloat(e.css(this.activeMenu[0], "borderTopWidth")) || 0, r = parseFloat(e.css(this.activeMenu[0], "paddingTop")) || 0, i = t.offset().top - this.activeMenu.offset().top - n - r, s = this.activeMenu.scrollTop(), o = this.activeMenu.height(), u = t.height(), i < 0 ? this.activeMenu.scrollTop(s + i) : i + u > o && this.activeMenu.scrollTop(s + i - o + u));
	    }, blur: function (e, t) {
	      t || clearTimeout(this.timer);if (!this.active) return;this.active.children("a").removeClass("ui-state-focus"), this.active = null, this._trigger("blur", e, { item: this.active });
	    }, _startOpening: function (e) {
	      clearTimeout(this.timer);if (e.attr("aria-hidden") !== "true") return;this.timer = this._delay(function () {
	        this._close(), this._open(e);
	      }, this.delay);
	    }, _open: function (t) {
	      var n = e.extend({ of: this.active }, this.options.position);clearTimeout(this.timer), this.element.find(".ui-menu").not(t.parents(".ui-menu")).hide().attr("aria-hidden", "true"), t.show().removeAttr("aria-hidden").attr("aria-expanded", "true").position(n);
	    }, collapseAll: function (t, n) {
	      clearTimeout(this.timer), this.timer = this._delay(function () {
	        var r = n ? this.element : e(t && t.target).closest(this.element.find(".ui-menu"));r.length || (r = this.element), this._close(r), this.blur(t), this.activeMenu = r;
	      }, this.delay);
	    }, _close: function (e) {
	      e || (e = this.active ? this.active.parent() : this.element), e.find(".ui-menu").hide().attr("aria-hidden", "true").attr("aria-expanded", "false").end().find("a.ui-state-active").removeClass("ui-state-active");
	    }, collapse: function (e) {
	      var t = this.active && this.active.parent().closest(".ui-menu-item", this.element);t && t.length && (this._close(), this.focus(e, t));
	    }, expand: function (e) {
	      var t = this.active && this.active.children(".ui-menu ").children(".ui-menu-item").first();t && t.length && (this._open(t.parent()), this._delay(function () {
	        this.focus(e, t);
	      }));
	    }, next: function (e) {
	      this._move("next", "first", e);
	    }, previous: function (e) {
	      this._move("prev", "last", e);
	    }, isFirstItem: function () {
	      return this.active && !this.active.prevAll(".ui-menu-item").length;
	    }, isLastItem: function () {
	      return this.active && !this.active.nextAll(".ui-menu-item").length;
	    }, _move: function (e, t, n) {
	      var r;this.active && (e === "first" || e === "last" ? r = this.active[e === "first" ? "prevAll" : "nextAll"](".ui-menu-item").eq(-1) : r = this.active[e + "All"](".ui-menu-item").eq(0));if (!r || !r.length || !this.active) r = this.activeMenu.children(".ui-menu-item")[t]();this.focus(n, r);
	    }, nextPage: function (t) {
	      var n, r, i;if (!this.active) {
	        this.next(t);return;
	      }if (this.isLastItem()) return;this._hasScroll() ? (r = this.active.offset().top, i = this.element.height(), this.active.nextAll(".ui-menu-item").each(function () {
	        return n = e(this), n.offset().top - r - i < 0;
	      }), this.focus(t, n)) : this.focus(t, this.activeMenu.children(".ui-menu-item")[this.active ? "last" : "first"]());
	    }, previousPage: function (t) {
	      var n, r, i;if (!this.active) {
	        this.next(t);return;
	      }if (this.isFirstItem()) return;this._hasScroll() ? (r = this.active.offset().top, i = this.element.height(), this.active.prevAll(".ui-menu-item").each(function () {
	        return n = e(this), n.offset().top - r + i > 0;
	      }), this.focus(t, n)) : this.focus(t, this.activeMenu.children(".ui-menu-item").first());
	    }, _hasScroll: function () {
	      return this.element.outerHeight() < this.element.prop("scrollHeight");
	    }, select: function (t) {
	      this.active = this.active || e(t.target).closest(".ui-menu-item");var n = { item: this.active };this.active.has(".ui-menu").length || this.collapseAll(t, !0), this._trigger("select", t, n);
	    } });
	})(jQuery);(function (e, t) {
	  var n = 5;e.widget("ui.slider", e.ui.mouse, { version: "1.9.1", widgetEventPrefix: "slide", options: { animate: !1, distance: 0, max: 100, min: 0, orientation: "horizontal", range: !1, step: 1, value: 0, values: null }, _create: function () {
	      var t,
	          r,
	          i = this.options,
	          s = this.element.find(".ui-slider-handle").addClass("ui-state-default ui-corner-all"),
	          o = "<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>",
	          u = [];this._keySliding = !1, this._mouseSliding = !1, this._animateOff = !0, this._handleIndex = null, this._detectOrientation(), this._mouseInit(), this.element.addClass("ui-slider ui-slider-" + this.orientation + " ui-widget" + " ui-widget-content" + " ui-corner-all" + (i.disabled ? " ui-slider-disabled ui-disabled" : "")), this.range = e([]), i.range && (i.range === !0 && (i.values || (i.values = [this._valueMin(), this._valueMin()]), i.values.length && i.values.length !== 2 && (i.values = [i.values[0], i.values[0]])), this.range = e("<div></div>").appendTo(this.element).addClass("ui-slider-range ui-widget-header" + (i.range === "min" || i.range === "max" ? " ui-slider-range-" + i.range : ""))), r = i.values && i.values.length || 1;for (t = s.length; t < r; t++) u.push(o);this.handles = s.add(e(u.join("")).appendTo(this.element)), this.handle = this.handles.eq(0), this.handles.add(this.range).filter("a").click(function (e) {
	        e.preventDefault();
	      }).mouseenter(function () {
	        i.disabled || e(this).addClass("ui-state-hover");
	      }).mouseleave(function () {
	        e(this).removeClass("ui-state-hover");
	      }).focus(function () {
	        i.disabled ? e(this).blur() : (e(".ui-slider .ui-state-focus").removeClass("ui-state-focus"), e(this).addClass("ui-state-focus"));
	      }).blur(function () {
	        e(this).removeClass("ui-state-focus");
	      }), this.handles.each(function (t) {
	        e(this).data("ui-slider-handle-index", t);
	      }), this._on(this.handles, { keydown: function (t) {
	          var r,
	              i,
	              s,
	              o,
	              u = e(t.target).data("ui-slider-handle-index");switch (t.keyCode) {case e.ui.keyCode.HOME:case e.ui.keyCode.END:case e.ui.keyCode.PAGE_UP:case e.ui.keyCode.PAGE_DOWN:case e.ui.keyCode.UP:case e.ui.keyCode.RIGHT:case e.ui.keyCode.DOWN:case e.ui.keyCode.LEFT:
	              t.preventDefault();if (!this._keySliding) {
	                this._keySliding = !0, e(t.target).addClass("ui-state-active"), r = this._start(t, u);if (r === !1) return;
	              }}o = this.options.step, this.options.values && this.options.values.length ? i = s = this.values(u) : i = s = this.value();switch (t.keyCode) {case e.ui.keyCode.HOME:
	              s = this._valueMin();break;case e.ui.keyCode.END:
	              s = this._valueMax();break;case e.ui.keyCode.PAGE_UP:
	              s = this._trimAlignValue(i + (this._valueMax() - this._valueMin()) / n);break;case e.ui.keyCode.PAGE_DOWN:
	              s = this._trimAlignValue(i - (this._valueMax() - this._valueMin()) / n);break;case e.ui.keyCode.UP:case e.ui.keyCode.RIGHT:
	              if (i === this._valueMax()) return;s = this._trimAlignValue(i + o);break;case e.ui.keyCode.DOWN:case e.ui.keyCode.LEFT:
	              if (i === this._valueMin()) return;s = this._trimAlignValue(i - o);}this._slide(t, u, s);
	        }, keyup: function (t) {
	          var n = e(t.target).data("ui-slider-handle-index");this._keySliding && (this._keySliding = !1, this._stop(t, n), this._change(t, n), e(t.target).removeClass("ui-state-active"));
	        } }), this._refreshValue(), this._animateOff = !1;
	    }, _destroy: function () {
	      this.handles.remove(), this.range.remove(), this.element.removeClass("ui-slider ui-slider-horizontal ui-slider-vertical ui-slider-disabled ui-widget ui-widget-content ui-corner-all"), this._mouseDestroy();
	    }, _mouseCapture: function (t) {
	      var n,
	          r,
	          i,
	          s,
	          o,
	          u,
	          a,
	          f,
	          l = this,
	          c = this.options;return c.disabled ? !1 : (this.elementSize = { width: this.element.outerWidth(), height: this.element.outerHeight() }, this.elementOffset = this.element.offset(), n = { x: t.pageX, y: t.pageY }, r = this._normValueFromMouse(n), i = this._valueMax() - this._valueMin() + 1, this.handles.each(function (t) {
	        var n = Math.abs(r - l.values(t));i > n && (i = n, s = e(this), o = t);
	      }), c.range === !0 && this.values(1) === c.min && (o += 1, s = e(this.handles[o])), u = this._start(t, o), u === !1 ? !1 : (this._mouseSliding = !0, this._handleIndex = o, s.addClass("ui-state-active").focus(), a = s.offset(), f = !e(t.target).parents().andSelf().is(".ui-slider-handle"), this._clickOffset = f ? { left: 0, top: 0 } : { left: t.pageX - a.left - s.width() / 2, top: t.pageY - a.top - s.height() / 2 - (parseInt(s.css("borderTopWidth"), 10) || 0) - (parseInt(s.css("borderBottomWidth"), 10) || 0) + (parseInt(s.css("marginTop"), 10) || 0) }, this.handles.hasClass("ui-state-hover") || this._slide(t, o, r), this._animateOff = !0, !0));
	    }, _mouseStart: function () {
	      return !0;
	    }, _mouseDrag: function (e) {
	      var t = { x: e.pageX, y: e.pageY },
	          n = this._normValueFromMouse(t);return this._slide(e, this._handleIndex, n), !1;
	    }, _mouseStop: function (e) {
	      return this.handles.removeClass("ui-state-active"), this._mouseSliding = !1, this._stop(e, this._handleIndex), this._change(e, this._handleIndex), this._handleIndex = null, this._clickOffset = null, this._animateOff = !1, !1;
	    }, _detectOrientation: function () {
	      this.orientation = this.options.orientation === "vertical" ? "vertical" : "horizontal";
	    }, _normValueFromMouse: function (e) {
	      var t, n, r, i, s;return this.orientation === "horizontal" ? (t = this.elementSize.width, n = e.x - this.elementOffset.left - (this._clickOffset ? this._clickOffset.left : 0)) : (t = this.elementSize.height, n = e.y - this.elementOffset.top - (this._clickOffset ? this._clickOffset.top : 0)), r = n / t, r > 1 && (r = 1), r < 0 && (r = 0), this.orientation === "vertical" && (r = 1 - r), i = this._valueMax() - this._valueMin(), s = this._valueMin() + r * i, this._trimAlignValue(s);
	    }, _start: function (e, t) {
	      var n = { handle: this.handles[t], value: this.value() };return this.options.values && this.options.values.length && (n.value = this.values(t), n.values = this.values()), this._trigger("start", e, n);
	    }, _slide: function (e, t, n) {
	      var r, i, s;this.options.values && this.options.values.length ? (r = this.values(t ? 0 : 1), this.options.values.length === 2 && this.options.range === !0 && (t === 0 && n > r || t === 1 && n < r) && (n = r), n !== this.values(t) && (i = this.values(), i[t] = n, s = this._trigger("slide", e, { handle: this.handles[t], value: n, values: i }), r = this.values(t ? 0 : 1), s !== !1 && this.values(t, n, !0))) : n !== this.value() && (s = this._trigger("slide", e, { handle: this.handles[t], value: n }), s !== !1 && this.value(n));
	    }, _stop: function (e, t) {
	      var n = { handle: this.handles[t], value: this.value() };this.options.values && this.options.values.length && (n.value = this.values(t), n.values = this.values()), this._trigger("stop", e, n);
	    }, _change: function (e, t) {
	      if (!this._keySliding && !this._mouseSliding) {
	        var n = { handle: this.handles[t], value: this.value() };this.options.values && this.options.values.length && (n.value = this.values(t), n.values = this.values()), this._trigger("change", e, n);
	      }
	    }, value: function (e) {
	      if (arguments.length) {
	        this.options.value = this._trimAlignValue(e), this._refreshValue(), this._change(null, 0);return;
	      }return this._value();
	    }, values: function (t, n) {
	      var r, i, s;if (arguments.length > 1) {
	        this.options.values[t] = this._trimAlignValue(n), this._refreshValue(), this._change(null, t);return;
	      }if (!arguments.length) return this._values();if (!e.isArray(arguments[0])) return this.options.values && this.options.values.length ? this._values(t) : this.value();r = this.options.values, i = arguments[0];for (s = 0; s < r.length; s += 1) r[s] = this._trimAlignValue(i[s]), this._change(null, s);this._refreshValue();
	    }, _setOption: function (t, n) {
	      var r,
	          i = 0;e.isArray(this.options.values) && (i = this.options.values.length), e.Widget.prototype._setOption.apply(this, arguments);switch (t) {case "disabled":
	          n ? (this.handles.filter(".ui-state-focus").blur(), this.handles.removeClass("ui-state-hover"), this.handles.prop("disabled", !0), this.element.addClass("ui-disabled")) : (this.handles.prop("disabled", !1), this.element.removeClass("ui-disabled"));break;case "orientation":
	          this._detectOrientation(), this.element.removeClass("ui-slider-horizontal ui-slider-vertical").addClass("ui-slider-" + this.orientation), this._refreshValue();break;case "value":
	          this._animateOff = !0, this._refreshValue(), this._change(null, 0), this._animateOff = !1;break;case "values":
	          this._animateOff = !0, this._refreshValue();for (r = 0; r < i; r += 1) this._change(null, r);this._animateOff = !1;break;case "min":case "max":
	          this._animateOff = !0, this._refreshValue(), this._animateOff = !1;}
	    }, _value: function () {
	      var e = this.options.value;return e = this._trimAlignValue(e), e;
	    }, _values: function (e) {
	      var t, n, r;if (arguments.length) return t = this.options.values[e], t = this._trimAlignValue(t), t;n = this.options.values.slice();for (r = 0; r < n.length; r += 1) n[r] = this._trimAlignValue(n[r]);return n;
	    }, _trimAlignValue: function (e) {
	      if (e <= this._valueMin()) return this._valueMin();if (e >= this._valueMax()) return this._valueMax();var t = this.options.step > 0 ? this.options.step : 1,
	          n = (e - this._valueMin()) % t,
	          r = e - n;return Math.abs(n) * 2 >= t && (r += n > 0 ? t : -t), parseFloat(r.toFixed(5));
	    }, _valueMin: function () {
	      return this.options.min;
	    }, _valueMax: function () {
	      return this.options.max;
	    }, _refreshValue: function () {
	      var t,
	          n,
	          r,
	          i,
	          s,
	          o = this.options.range,
	          u = this.options,
	          a = this,
	          f = this._animateOff ? !1 : u.animate,
	          l = {};this.options.values && this.options.values.length ? this.handles.each(function (r) {
	        n = (a.values(r) - a._valueMin()) / (a._valueMax() - a._valueMin()) * 100, l[a.orientation === "horizontal" ? "left" : "bottom"] = n + "%", e(this).stop(1, 1)[f ? "animate" : "css"](l, u.animate), a.options.range === !0 && (a.orientation === "horizontal" ? (r === 0 && a.range.stop(1, 1)[f ? "animate" : "css"]({ left: n + "%" }, u.animate), r === 1 && a.range[f ? "animate" : "css"]({ width: n - t + "%" }, { queue: !1, duration: u.animate })) : (r === 0 && a.range.stop(1, 1)[f ? "animate" : "css"]({ bottom: n + "%" }, u.animate), r === 1 && a.range[f ? "animate" : "css"]({ height: n - t + "%" }, { queue: !1, duration: u.animate }))), t = n;
	      }) : (r = this.value(), i = this._valueMin(), s = this._valueMax(), n = s !== i ? (r - i) / (s - i) * 100 : 0, l[this.orientation === "horizontal" ? "left" : "bottom"] = n + "%", this.handle.stop(1, 1)[f ? "animate" : "css"](l, u.animate), o === "min" && this.orientation === "horizontal" && this.range.stop(1, 1)[f ? "animate" : "css"]({ width: n + "%" }, u.animate), o === "max" && this.orientation === "horizontal" && this.range[f ? "animate" : "css"]({ width: 100 - n + "%" }, { queue: !1, duration: u.animate }), o === "min" && this.orientation === "vertical" && this.range.stop(1, 1)[f ? "animate" : "css"]({ height: n + "%" }, u.animate), o === "max" && this.orientation === "vertical" && this.range[f ? "animate" : "css"]({ height: 100 - n + "%" }, { queue: !1, duration: u.animate }));
	    } });
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {;(function ($) {
		// secure $ jQuery alias
		/*******************************************************************************************/
		// jquery.event.hover.js 
		// Copyright (c) 2008, Three Dub Media (http://threedubmedia.com)
		// Licensed under the MIT License (MIT-LICENSE.txt)
		// http://www.opensource.org/licenses/mit-license.php
		//
		// JQuery 1.9+ compatible version
		//
		// Optional settings :
		// $.event.special.hover.delay = 100;
		// Defines the delay (msec) while mouse is inside the element before checking the speed
		// $.event.special.hover.speed = 100;
		// Defines the maximum speed (px/sec) the mouse may be moving to trigger the hover event
		/*******************************************************************************************/
	
		// save the old jquery "hover" method
		$.fn._hover = $.fn.hover;
	
		// jquery method 
		$.fn.hover = function (fn1, fn2, fn3) {
			if (fn3) this.bind('hoverstart', fn1); // 3 args
			if (fn2) this.bind('hoverend', fn3 ? fn3 : fn2); // 2+ args
			return !fn1 ? this.trigger('hover') // 0 args 
			: this.bind('hover', fn3 ? fn2 : fn1); // 1+ args
		};
	
		// special event configuration
		var hover = $.event.special.hover = {
			delay: 100, // milliseconds
			speed: 100, // pixels per second
			setup: function (data) {
				data = $.extend({ speed: hover.speed, delay: hover.delay, hovered: 0 }, data || {});
				$.event.add(this, "mouseenter mouseleave", hoverHandler, data);
			},
			teardown: function () {
				$.event.remove(this, "mouseenter mouseleave", hoverHandler);
			}
		};
	
		// shared event handler
		function hoverHandler(event) {
			var data = event.data || event;
			switch (event.type) {
				case 'mouseenter':
					// mouseover
					data.dist2 = 0; // init mouse distance�
					data.event = event; // store the event
					event.type = "hoverstart"; // hijack event
					if ($.event.dispatch.call(this, event) !== false) {
						data.elem = this; // ref to the current element
						$.event.add(this, "mousemove", hoverHandler, data); // track the mouse
						data.timer = setTimeout(compare, data.delay); // start async compare
					}
					break;
				case 'mousemove':
					// track the event, mouse distance� = x� + y�
					data.dist2 += Math.pow(event.pageX - data.event.pageX, 2) + Math.pow(event.pageY - data.event.pageY, 2);
					data.event = event; // store current event
					break;
				case 'mouseleave':
					// mouseout
					clearTimeout(data.timer); // uncompare
					if (data.hovered) {
						event.type = "hoverend"; // hijack event
						$.event.dispatch.call(this, event); // handle "hoverend"
						data.hovered--; // reset flag
					} else $.event.remove(data.elem, "mousemove", hoverHandler); // untrack
					break;
				default:
					// timeout compare // distance� = x� + y�  = ( speed * time )�
					if (data.dist2 <= Math.pow(data.speed * (data.delay / 1e3), 2)) {
						// speed acceptable
						$.event.remove(data.elem, "mousemove", hoverHandler); // untrack
						data.event.type = "hover"; // hijack event
						if ($.event.dispatch.call(data.elem, data.event) !== false) // handle "hover"
							data.hovered++; // flag for "hoverend"
					} else data.timer = setTimeout(compare, data.delay); // async recurse
					data.dist2 = 0; // reset distance� for next compare
					break;
			}
			function compare() {
				hoverHandler(data);
			}; // timeout/recursive function
		};
	
		/*******************************************************************************************/
	})(jQuery); // confine scope
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * jQuery Form Plugin
	 * version: 3.45.0-2013.10.17
	 * Requires jQuery v1.5 or later
	 * Copyright (c) 2013 M. Alsup
	 * Examples and documentation at: http://malsup.com/jquery/form/
	 * Project repository: https://github.com/malsup/form
	 * Dual licensed under the MIT and GPL licenses.
	 * https://github.com/malsup/form#copyright-and-license
	 */
	/*global ActiveXObject */
	;(function ($) {
	    "use strict";
	
	    /*
	        Usage Note:
	        -----------
	        Do not use both ajaxSubmit and ajaxForm on the same form.  These
	        functions are mutually exclusive.  Use ajaxSubmit if you want
	        to bind your own submit handler to the form.  For example,
	    
	        $(document).ready(function() {
	            $('#myForm').on('submit', function(e) {
	                e.preventDefault(); // <-- important
	                $(this).ajaxSubmit({
	                    target: '#output'
	                });
	            });
	        });
	    
	        Use ajaxForm when you want the plugin to manage all the event binding
	        for you.  For example,
	    
	        $(document).ready(function() {
	            $('#myForm').ajaxForm({
	                target: '#output'
	            });
	        });
	    
	        You can also use ajaxForm with delegation (requires jQuery v1.7+), so the
	        form does not have to exist when you invoke ajaxForm:
	    
	        $('#myForm').ajaxForm({
	            delegation: true,
	            target: '#output'
	        });
	    
	        When using ajaxForm, the ajaxSubmit function will be invoked for you
	        at the appropriate time.
	    */
	
	    /**
	     * Feature detection
	     */
	
	    var feature = {};
	    feature.fileapi = $("<input type='file'/>").get(0).files !== undefined;
	    feature.formdata = window.FormData !== undefined;
	
	    var hasProp = !!$.fn.prop;
	
	    // attr2 uses prop when it can but checks the return type for
	    // an expected string.  this accounts for the case where a form 
	    // contains inputs with names like "action" or "method"; in those
	    // cases "prop" returns the element
	    $.fn.attr2 = function () {
	        if (!hasProp) return this.attr.apply(this, arguments);
	        var val = this.prop.apply(this, arguments);
	        if (val && val.jquery || typeof val === 'string') return val;
	        return this.attr.apply(this, arguments);
	    };
	
	    /**
	     * ajaxSubmit() provides a mechanism for immediately submitting
	     * an HTML form using AJAX.
	     */
	    $.fn.ajaxSubmit = function (options) {
	        /*jshint scripturl:true */
	
	        // fast fail if nothing selected (http://dev.jquery.com/ticket/2752)
	        if (!this.length) {
	            log('ajaxSubmit: skipping submit process - no element selected');
	            return this;
	        }
	
	        var method,
	            action,
	            url,
	            $form = this;
	
	        if (typeof options == 'function') {
	            options = { success: options };
	        } else if (options === undefined) {
	            options = {};
	        }
	
	        method = options.type || this.attr2('method');
	        action = options.url || this.attr2('action');
	
	        url = typeof action === 'string' ? $.trim(action) : '';
	        url = url || window.location.href || '';
	        if (url) {
	            // clean url (don't include hash vaue)
	            url = (url.match(/^([^#]+)/) || [])[1];
	        }
	
	        options = $.extend(true, {
	            url: url,
	            success: $.ajaxSettings.success,
	            type: method || $.ajaxSettings.type,
	            iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank'
	        }, options);
	
	        // hook for manipulating the form data before it is extracted;
	        // convenient for use with rich editors like tinyMCE or FCKEditor
	        var veto = {};
	        this.trigger('form-pre-serialize', [this, options, veto]);
	        if (veto.veto) {
	            log('ajaxSubmit: submit vetoed via form-pre-serialize trigger');
	            return this;
	        }
	
	        // provide opportunity to alter form data before it is serialized
	        if (options.beforeSerialize && options.beforeSerialize(this, options) === false) {
	            log('ajaxSubmit: submit aborted via beforeSerialize callback');
	            return this;
	        }
	
	        var traditional = options.traditional;
	        if (traditional === undefined) {
	            traditional = $.ajaxSettings.traditional;
	        }
	
	        var elements = [];
	        var qx,
	            a = this.formToArray(options.semantic, elements);
	        if (options.data) {
	            options.extraData = options.data;
	            qx = $.param(options.data, traditional);
	        }
	
	        // give pre-submit callback an opportunity to abort the submit
	        if (options.beforeSubmit && options.beforeSubmit(a, this, options) === false) {
	            log('ajaxSubmit: submit aborted via beforeSubmit callback');
	            return this;
	        }
	
	        // fire vetoable 'validate' event
	        this.trigger('form-submit-validate', [a, this, options, veto]);
	        if (veto.veto) {
	            log('ajaxSubmit: submit vetoed via form-submit-validate trigger');
	            return this;
	        }
	
	        var q = $.param(a, traditional);
	        if (qx) {
	            q = q ? q + '&' + qx : qx;
	        }
	        if (options.type.toUpperCase() == 'GET') {
	            options.url += (options.url.indexOf('?') >= 0 ? '&' : '?') + q;
	            options.data = null; // data is null for 'get'
	        } else {
	            options.data = q; // data is the query string for 'post'
	        }
	
	        var callbacks = [];
	        if (options.resetForm) {
	            callbacks.push(function () {
	                $form.resetForm();
	            });
	        }
	        if (options.clearForm) {
	            callbacks.push(function () {
	                $form.clearForm(options.includeHidden);
	            });
	        }
	
	        // perform a load on the target only if dataType is not provided
	        if (!options.dataType && options.target) {
	            var oldSuccess = options.success || function () {};
	            callbacks.push(function (data) {
	                var fn = options.replaceTarget ? 'replaceWith' : 'html';
	                $(options.target)[fn](data).each(oldSuccess, arguments);
	            });
	        } else if (options.success) {
	            callbacks.push(options.success);
	        }
	
	        options.success = function (data, status, xhr) {
	            // jQuery 1.4+ passes xhr as 3rd arg
	            var context = options.context || this; // jQuery 1.4+ supports scope context
	            for (var i = 0, max = callbacks.length; i < max; i++) {
	                callbacks[i].apply(context, [data, status, xhr || $form, $form]);
	            }
	        };
	
	        if (options.error) {
	            var oldError = options.error;
	            options.error = function (xhr, status, error) {
	                var context = options.context || this;
	                oldError.apply(context, [xhr, status, error, $form]);
	            };
	        }
	
	        if (options.complete) {
	            var oldComplete = options.complete;
	            options.complete = function (xhr, status) {
	                var context = options.context || this;
	                oldComplete.apply(context, [xhr, status, $form]);
	            };
	        }
	
	        // are there files to upload?
	
	        // [value] (issue #113), also see comment:
	        // https://github.com/malsup/form/commit/588306aedba1de01388032d5f42a60159eea9228#commitcomment-2180219
	        var fileInputs = $('input[type=file]:enabled', this).filter(function () {
	            return $(this).val() !== '';
	        });
	
	        var hasFileInputs = fileInputs.length > 0;
	        var mp = 'multipart/form-data';
	        var multipart = $form.attr('enctype') == mp || $form.attr('encoding') == mp;
	
	        var fileAPI = feature.fileapi && feature.formdata;
	        log("fileAPI :" + fileAPI);
	        var shouldUseFrame = (hasFileInputs || multipart) && !fileAPI;
	
	        var jqxhr;
	
	        // options.iframe allows user to force iframe mode
	        // 06-NOV-09: now defaulting to iframe mode if file input is detected
	        if (options.iframe !== false && (options.iframe || shouldUseFrame)) {
	            // hack to fix Safari hang (thanks to Tim Molendijk for this)
	            // see:  http://groups.google.com/group/jquery-dev/browse_thread/thread/36395b7ab510dd5d
	            if (options.closeKeepAlive) {
	                $.get(options.closeKeepAlive, function () {
	                    jqxhr = fileUploadIframe(a);
	                });
	            } else {
	                jqxhr = fileUploadIframe(a);
	            }
	        } else if ((hasFileInputs || multipart) && fileAPI) {
	            jqxhr = fileUploadXhr(a);
	        } else {
	            jqxhr = $.ajax(options);
	        }
	
	        $form.removeData('jqxhr').data('jqxhr', jqxhr);
	
	        // clear element array
	        for (var k = 0; k < elements.length; k++) elements[k] = null;
	
	        // fire 'notify' event
	        this.trigger('form-submit-notify', [this, options]);
	        return this;
	
	        // utility fn for deep serialization
	        function deepSerialize(extraData) {
	            var serialized = $.param(extraData, options.traditional).split('&');
	            var len = serialized.length;
	            var result = [];
	            var i, part;
	            for (i = 0; i < len; i++) {
	                // #252; undo param space replacement
	                serialized[i] = serialized[i].replace(/\+/g, ' ');
	                part = serialized[i].split('=');
	                // #278; use array instead of object storage, favoring array serializations
	                result.push([decodeURIComponent(part[0]), decodeURIComponent(part[1])]);
	            }
	            return result;
	        }
	
	        // XMLHttpRequest Level 2 file uploads (big hat tip to francois2metz)
	        function fileUploadXhr(a) {
	            var formdata = new FormData();
	
	            for (var i = 0; i < a.length; i++) {
	                formdata.append(a[i].name, a[i].value);
	            }
	
	            if (options.extraData) {
	                var serializedData = deepSerialize(options.extraData);
	                for (i = 0; i < serializedData.length; i++) if (serializedData[i]) formdata.append(serializedData[i][0], serializedData[i][1]);
	            }
	
	            options.data = null;
	
	            var s = $.extend(true, {}, $.ajaxSettings, options, {
	                contentType: false,
	                processData: false,
	                cache: false,
	                type: method || 'POST'
	            });
	
	            if (options.uploadProgress) {
	                // workaround because jqXHR does not expose upload property
	                s.xhr = function () {
	                    var xhr = $.ajaxSettings.xhr();
	                    if (xhr.upload) {
	                        xhr.upload.addEventListener('progress', function (event) {
	                            var percent = 0;
	                            var position = event.loaded || event.position; /*event.position is deprecated*/
	                            var total = event.total;
	                            if (event.lengthComputable) {
	                                percent = Math.ceil(position / total * 100);
	                            }
	                            options.uploadProgress(event, position, total, percent);
	                        }, false);
	                    }
	                    return xhr;
	                };
	            }
	
	            s.data = null;
	            var beforeSend = s.beforeSend;
	            s.beforeSend = function (xhr, o) {
	                //Send FormData() provided by user
	                if (options.formData) o.data = options.formData;else o.data = formdata;
	                if (beforeSend) beforeSend.call(this, xhr, o);
	            };
	            return $.ajax(s);
	        }
	
	        // private function for handling file uploads (hat tip to YAHOO!)
	        function fileUploadIframe(a) {
	            var form = $form[0],
	                el,
	                i,
	                s,
	                g,
	                id,
	                $io,
	                io,
	                xhr,
	                sub,
	                n,
	                timedOut,
	                timeoutHandle;
	            var deferred = $.Deferred();
	
	            // #341
	            deferred.abort = function (status) {
	                xhr.abort(status);
	            };
	
	            if (a) {
	                // ensure that every serialized input is still enabled
	                for (i = 0; i < elements.length; i++) {
	                    el = $(elements[i]);
	                    if (hasProp) el.prop('disabled', false);else el.removeAttr('disabled');
	                }
	            }
	
	            s = $.extend(true, {}, $.ajaxSettings, options);
	            s.context = s.context || s;
	            id = 'jqFormIO' + new Date().getTime();
	            if (s.iframeTarget) {
	                $io = $(s.iframeTarget);
	                n = $io.attr2('name');
	                if (!n) $io.attr2('name', id);else id = n;
	            } else {
	                $io = $('<iframe name="' + id + '" src="' + s.iframeSrc + '" />');
	                $io.css({ position: 'absolute', top: '-1000px', left: '-1000px' });
	            }
	            io = $io[0];
	
	            xhr = { // mock object
	                aborted: 0,
	                responseText: null,
	                responseXML: null,
	                status: 0,
	                statusText: 'n/a',
	                getAllResponseHeaders: function () {},
	                getResponseHeader: function () {},
	                setRequestHeader: function () {},
	                abort: function (status) {
	                    var e = status === 'timeout' ? 'timeout' : 'aborted';
	                    log('aborting upload... ' + e);
	                    this.aborted = 1;
	
	                    try {
	                        // #214, #257
	                        if (io.contentWindow.document.execCommand) {
	                            io.contentWindow.document.execCommand('Stop');
	                        }
	                    } catch (ignore) {}
	
	                    $io.attr('src', s.iframeSrc); // abort op in progress
	                    xhr.error = e;
	                    if (s.error) s.error.call(s.context, xhr, e, status);
	                    if (g) $.event.trigger("ajaxError", [xhr, s, e]);
	                    if (s.complete) s.complete.call(s.context, xhr, e);
	                }
	            };
	
	            g = s.global;
	            // trigger ajax global events so that activity/block indicators work like normal
	            if (g && 0 === $.active++) {
	                $.event.trigger("ajaxStart");
	            }
	            if (g) {
	                $.event.trigger("ajaxSend", [xhr, s]);
	            }
	
	            if (s.beforeSend && s.beforeSend.call(s.context, xhr, s) === false) {
	                if (s.global) {
	                    $.active--;
	                }
	                deferred.reject();
	                return deferred;
	            }
	            if (xhr.aborted) {
	                deferred.reject();
	                return deferred;
	            }
	
	            // add submitting element to data if we know it
	            sub = form.clk;
	            if (sub) {
	                n = sub.name;
	                if (n && !sub.disabled) {
	                    s.extraData = s.extraData || {};
	                    s.extraData[n] = sub.value;
	                    if (sub.type == "image") {
	                        s.extraData[n + '.x'] = form.clk_x;
	                        s.extraData[n + '.y'] = form.clk_y;
	                    }
	                }
	            }
	
	            var CLIENT_TIMEOUT_ABORT = 1;
	            var SERVER_ABORT = 2;
	
	            function getDoc(frame) {
	                /* it looks like contentWindow or contentDocument do not
	                 * carry the protocol property in ie8, when running under ssl
	                 * frame.document is the only valid response document, since
	                 * the protocol is know but not on the other two objects. strange?
	                 * "Same origin policy" http://en.wikipedia.org/wiki/Same_origin_policy
	                 */
	
	                var doc = null;
	
	                // IE8 cascading access check
	                try {
	                    if (frame.contentWindow) {
	                        doc = frame.contentWindow.document;
	                    }
	                } catch (err) {
	                    // IE8 access denied under ssl & missing protocol
	                    log('cannot get iframe.contentWindow document: ' + err);
	                }
	
	                if (doc) {
	                    // successful getting content
	                    return doc;
	                }
	
	                try {
	                    // simply checking may throw in ie8 under ssl or mismatched protocol
	                    doc = frame.contentDocument ? frame.contentDocument : frame.document;
	                } catch (err) {
	                    // last attempt
	                    log('cannot get iframe.contentDocument: ' + err);
	                    doc = frame.document;
	                }
	                return doc;
	            }
	
	            // Rails CSRF hack (thanks to Yvan Barthelemy)
	            var csrf_token = $('meta[name=csrf-token]').attr('content');
	            var csrf_param = $('meta[name=csrf-param]').attr('content');
	            if (csrf_param && csrf_token) {
	                s.extraData = s.extraData || {};
	                s.extraData[csrf_param] = csrf_token;
	            }
	
	            // take a breath so that pending repaints get some cpu time before the upload starts
	            function doSubmit() {
	                // make sure form attrs are set
	                var t = $form.attr2('target'),
	                    a = $form.attr2('action');
	
	                // update form attrs in IE friendly way
	                form.setAttribute('target', id);
	                if (!method || /post/i.test(method)) {
	                    form.setAttribute('method', 'POST');
	                }
	                if (a != s.url) {
	                    form.setAttribute('action', s.url);
	                }
	
	                // ie borks in some cases when setting encoding
	                if (!s.skipEncodingOverride && (!method || /post/i.test(method))) {
	                    $form.attr({
	                        encoding: 'multipart/form-data',
	                        enctype: 'multipart/form-data'
	                    });
	                }
	
	                // support timout
	                if (s.timeout) {
	                    timeoutHandle = setTimeout(function () {
	                        timedOut = true;cb(CLIENT_TIMEOUT_ABORT);
	                    }, s.timeout);
	                }
	
	                // look for server aborts
	                function checkState() {
	                    try {
	                        var state = getDoc(io).readyState;
	                        log('state = ' + state);
	                        if (state && state.toLowerCase() == 'uninitialized') setTimeout(checkState, 50);
	                    } catch (e) {
	                        log('Server abort: ', e, ' (', e.name, ')');
	                        cb(SERVER_ABORT);
	                        if (timeoutHandle) clearTimeout(timeoutHandle);
	                        timeoutHandle = undefined;
	                    }
	                }
	
	                // add "extra" data to form if provided in options
	                var extraInputs = [];
	                try {
	                    if (s.extraData) {
	                        for (var n in s.extraData) {
	                            if (s.extraData.hasOwnProperty(n)) {
	                                // if using the $.param format that allows for multiple values with the same name
	                                if ($.isPlainObject(s.extraData[n]) && s.extraData[n].hasOwnProperty('name') && s.extraData[n].hasOwnProperty('value')) {
	                                    extraInputs.push($('<input type="hidden" name="' + s.extraData[n].name + '">').val(s.extraData[n].value).appendTo(form)[0]);
	                                } else {
	                                    extraInputs.push($('<input type="hidden" name="' + n + '">').val(s.extraData[n]).appendTo(form)[0]);
	                                }
	                            }
	                        }
	                    }
	
	                    if (!s.iframeTarget) {
	                        // add iframe to doc and submit the form
	                        $io.appendTo('body');
	                    }
	                    if (io.attachEvent) io.attachEvent('onload', cb);else io.addEventListener('load', cb, false);
	                    setTimeout(checkState, 15);
	
	                    try {
	                        form.submit();
	                    } catch (err) {
	                        // just in case form has element with name/id of 'submit'
	                        var submitFn = document.createElement('form').submit;
	                        submitFn.apply(form);
	                    }
	                } finally {
	                    // reset attrs and remove "extra" input elements
	                    form.setAttribute('action', a);
	                    if (t) {
	                        form.setAttribute('target', t);
	                    } else {
	                        $form.removeAttr('target');
	                    }
	                    $(extraInputs).remove();
	                }
	            }
	
	            if (s.forceSync) {
	                doSubmit();
	            } else {
	                setTimeout(doSubmit, 10); // this lets dom updates render
	            }
	
	            var data,
	                doc,
	                domCheckCount = 50,
	                callbackProcessed;
	
	            function cb(e) {
	                if (xhr.aborted || callbackProcessed) {
	                    return;
	                }
	
	                doc = getDoc(io);
	                if (!doc) {
	                    log('cannot access response document');
	                    e = SERVER_ABORT;
	                }
	                if (e === CLIENT_TIMEOUT_ABORT && xhr) {
	                    xhr.abort('timeout');
	                    deferred.reject(xhr, 'timeout');
	                    return;
	                } else if (e == SERVER_ABORT && xhr) {
	                    xhr.abort('server abort');
	                    deferred.reject(xhr, 'error', 'server abort');
	                    return;
	                }
	
	                if (!doc || doc.location.href == s.iframeSrc) {
	                    // response not received yet
	                    if (!timedOut) return;
	                }
	                if (io.detachEvent) io.detachEvent('onload', cb);else io.removeEventListener('load', cb, false);
	
	                var status = 'success',
	                    errMsg;
	                try {
	                    if (timedOut) {
	                        throw 'timeout';
	                    }
	
	                    var isXml = s.dataType == 'xml' || doc.XMLDocument || $.isXMLDoc(doc);
	                    log('isXml=' + isXml);
	                    if (!isXml && window.opera && (doc.body === null || !doc.body.innerHTML)) {
	                        if (--domCheckCount) {
	                            // in some browsers (Opera) the iframe DOM is not always traversable when
	                            // the onload callback fires, so we loop a bit to accommodate
	                            log('requeing onLoad callback, DOM not available');
	                            setTimeout(cb, 250);
	                            return;
	                        }
	                        // let this fall through because server response could be an empty document
	                        //log('Could not access iframe DOM after mutiple tries.');
	                        //throw 'DOMException: not available';
	                    }
	
	                    //log('response detected');
	                    var docRoot = doc.body ? doc.body : doc.documentElement;
	                    xhr.responseText = docRoot ? docRoot.innerHTML : null;
	                    xhr.responseXML = doc.XMLDocument ? doc.XMLDocument : doc;
	                    if (isXml) s.dataType = 'xml';
	                    xhr.getResponseHeader = function (header) {
	                        var headers = { 'content-type': s.dataType };
	                        return headers[header.toLowerCase()];
	                    };
	                    // support for XHR 'status' & 'statusText' emulation :
	                    if (docRoot) {
	                        xhr.status = Number(docRoot.getAttribute('status')) || xhr.status;
	                        xhr.statusText = docRoot.getAttribute('statusText') || xhr.statusText;
	                    }
	
	                    var dt = (s.dataType || '').toLowerCase();
	                    var scr = /(json|script|text)/.test(dt);
	                    if (scr || s.textarea) {
	                        // see if user embedded response in textarea
	                        var ta = doc.getElementsByTagName('textarea')[0];
	                        if (ta) {
	                            xhr.responseText = ta.value;
	                            // support for XHR 'status' & 'statusText' emulation :
	                            xhr.status = Number(ta.getAttribute('status')) || xhr.status;
	                            xhr.statusText = ta.getAttribute('statusText') || xhr.statusText;
	                        } else if (scr) {
	                            // account for browsers injecting pre around json response
	                            var pre = doc.getElementsByTagName('pre')[0];
	                            var b = doc.getElementsByTagName('body')[0];
	                            if (pre) {
	                                xhr.responseText = pre.textContent ? pre.textContent : pre.innerText;
	                            } else if (b) {
	                                xhr.responseText = b.textContent ? b.textContent : b.innerText;
	                            }
	                        }
	                    } else if (dt == 'xml' && !xhr.responseXML && xhr.responseText) {
	                        xhr.responseXML = toXml(xhr.responseText);
	                    }
	
	                    try {
	                        data = httpData(xhr, dt, s);
	                    } catch (err) {
	                        status = 'parsererror';
	                        xhr.error = errMsg = err || status;
	                    }
	                } catch (err) {
	                    log('error caught: ', err);
	                    status = 'error';
	                    xhr.error = errMsg = err || status;
	                }
	
	                if (xhr.aborted) {
	                    log('upload aborted');
	                    status = null;
	                }
	
	                if (xhr.status) {
	                    // we've set xhr.status
	                    status = xhr.status >= 200 && xhr.status < 300 || xhr.status === 304 ? 'success' : 'error';
	                }
	
	                // ordering of these callbacks/triggers is odd, but that's how $.ajax does it
	                if (status === 'success') {
	                    if (s.success) s.success.call(s.context, data, 'success', xhr);
	                    deferred.resolve(xhr.responseText, 'success', xhr);
	                    if (g) $.event.trigger("ajaxSuccess", [xhr, s]);
	                } else if (status) {
	                    if (errMsg === undefined) errMsg = xhr.statusText;
	                    if (s.error) s.error.call(s.context, xhr, status, errMsg);
	                    deferred.reject(xhr, 'error', errMsg);
	                    if (g) $.event.trigger("ajaxError", [xhr, s, errMsg]);
	                }
	
	                if (g) $.event.trigger("ajaxComplete", [xhr, s]);
	
	                if (g && ! --$.active) {
	                    $.event.trigger("ajaxStop");
	                }
	
	                if (s.complete) s.complete.call(s.context, xhr, status);
	
	                callbackProcessed = true;
	                if (s.timeout) clearTimeout(timeoutHandle);
	
	                // clean up
	                setTimeout(function () {
	                    if (!s.iframeTarget) $io.remove();else //adding else to clean up existing iframe response.
	                        $io.attr('src', s.iframeSrc);
	                    xhr.responseXML = null;
	                }, 100);
	            }
	
	            var toXml = $.parseXML || function (s, doc) {
	                // use parseXML if available (jQuery 1.5+)
	                if (window.ActiveXObject) {
	                    doc = new ActiveXObject('Microsoft.XMLDOM');
	                    doc.async = 'false';
	                    doc.loadXML(s);
	                } else {
	                    doc = new DOMParser().parseFromString(s, 'text/xml');
	                }
	                return doc && doc.documentElement && doc.documentElement.nodeName != 'parsererror' ? doc : null;
	            };
	            var parseJSON = $.parseJSON || function (s) {
	                /*jslint evil:true */
	                return window['eval']('(' + s + ')');
	            };
	
	            var httpData = function (xhr, type, s) {
	                // mostly lifted from jq1.4.4
	
	                var ct = xhr.getResponseHeader('content-type') || '',
	                    xml = type === 'xml' || !type && ct.indexOf('xml') >= 0,
	                    data = xml ? xhr.responseXML : xhr.responseText;
	
	                if (xml && data.documentElement.nodeName === 'parsererror') {
	                    if ($.error) $.error('parsererror');
	                }
	                if (s && s.dataFilter) {
	                    data = s.dataFilter(data, type);
	                }
	                if (typeof data === 'string') {
	                    if (type === 'json' || !type && ct.indexOf('json') >= 0) {
	                        data = parseJSON(data);
	                    } else if (type === "script" || !type && ct.indexOf("javascript") >= 0) {
	                        $.globalEval(data);
	                    }
	                }
	                return data;
	            };
	
	            return deferred;
	        }
	    };
	
	    /**
	     * ajaxForm() provides a mechanism for fully automating form submission.
	     *
	     * The advantages of using this method instead of ajaxSubmit() are:
	     *
	     * 1: This method will include coordinates for <input type="image" /> elements (if the element
	     *    is used to submit the form).
	     * 2. This method will include the submit element's name/value data (for the element that was
	     *    used to submit the form).
	     * 3. This method binds the submit() method to the form for you.
	     *
	     * The options argument for ajaxForm works exactly as it does for ajaxSubmit.  ajaxForm merely
	     * passes the options argument along after properly binding events for submit elements and
	     * the form itself.
	     */
	    $.fn.ajaxForm = function (options) {
	        options = options || {};
	        options.delegation = options.delegation && $.isFunction($.fn.on);
	
	        // in jQuery 1.3+ we can fix mistakes with the ready state
	        if (!options.delegation && this.length === 0) {
	            var o = { s: this.selector, c: this.context };
	            if (!$.isReady && o.s) {
	                log('DOM not ready, queuing ajaxForm');
	                $(function () {
	                    $(o.s, o.c).ajaxForm(options);
	                });
	                return this;
	            }
	            // is your DOM ready?  http://docs.jquery.com/Tutorials:Introducing_$(document).ready()
	            log('terminating; zero elements found by selector' + ($.isReady ? '' : ' (DOM not ready)'));
	            return this;
	        }
	
	        if (options.delegation) {
	            $(document).off('submit.form-plugin', this.selector, doAjaxSubmit).off('click.form-plugin', this.selector, captureSubmittingElement).on('submit.form-plugin', this.selector, options, doAjaxSubmit).on('click.form-plugin', this.selector, options, captureSubmittingElement);
	            return this;
	        }
	
	        return this.ajaxFormUnbind().bind('submit.form-plugin', options, doAjaxSubmit).bind('click.form-plugin', options, captureSubmittingElement);
	    };
	
	    // private event handlers
	    function doAjaxSubmit(e) {
	        /*jshint validthis:true */
	        var options = e.data;
	        if (!e.isDefaultPrevented()) {
	            // if event has been canceled, don't proceed
	            e.preventDefault();
	            $(e.target).ajaxSubmit(options); // #365
	        }
	    }
	
	    function captureSubmittingElement(e) {
	        /*jshint validthis:true */
	        var target = e.target;
	        var $el = $(target);
	        if (!$el.is("[type=submit],[type=image]")) {
	            // is this a child element of the submit el?  (ex: a span within a button)
	            var t = $el.closest('[type=submit]');
	            if (t.length === 0) {
	                return;
	            }
	            target = t[0];
	        }
	        var form = this;
	        form.clk = target;
	        if (target.type == 'image') {
	            if (e.offsetX !== undefined) {
	                form.clk_x = e.offsetX;
	                form.clk_y = e.offsetY;
	            } else if (typeof $.fn.offset == 'function') {
	                var offset = $el.offset();
	                form.clk_x = e.pageX - offset.left;
	                form.clk_y = e.pageY - offset.top;
	            } else {
	                form.clk_x = e.pageX - target.offsetLeft;
	                form.clk_y = e.pageY - target.offsetTop;
	            }
	        }
	        // clear form vars
	        setTimeout(function () {
	            form.clk = form.clk_x = form.clk_y = null;
	        }, 100);
	    }
	
	    // ajaxFormUnbind unbinds the event handlers that were bound by ajaxForm
	    $.fn.ajaxFormUnbind = function () {
	        return this.unbind('submit.form-plugin click.form-plugin');
	    };
	
	    /**
	     * formToArray() gathers form element data into an array of objects that can
	     * be passed to any of the following ajax functions: $.get, $.post, or load.
	     * Each object in the array has both a 'name' and 'value' property.  An example of
	     * an array for a simple login form might be:
	     *
	     * [ { name: 'username', value: 'jresig' }, { name: 'password', value: 'secret' } ]
	     *
	     * It is this array that is passed to pre-submit callback functions provided to the
	     * ajaxSubmit() and ajaxForm() methods.
	     */
	    $.fn.formToArray = function (semantic, elements) {
	        var a = [];
	        if (this.length === 0) {
	            return a;
	        }
	
	        var form = this[0];
	        var els = semantic ? form.getElementsByTagName('*') : form.elements;
	        if (!els) {
	            return a;
	        }
	
	        var i, j, n, v, el, max, jmax;
	        for (i = 0, max = els.length; i < max; i++) {
	            el = els[i];
	            n = el.name;
	            if (!n || el.disabled) {
	                continue;
	            }
	
	            if (semantic && form.clk && el.type == "image") {
	                // handle image inputs on the fly when semantic == true
	                if (form.clk == el) {
	                    a.push({ name: n, value: $(el).val(), type: el.type });
	                    a.push({ name: n + '.x', value: form.clk_x }, { name: n + '.y', value: form.clk_y });
	                }
	                continue;
	            }
	
	            v = $.fieldValue(el, true);
	            if (v && v.constructor == Array) {
	                if (elements) elements.push(el);
	                for (j = 0, jmax = v.length; j < jmax; j++) {
	                    a.push({ name: n, value: v[j] });
	                }
	            } else if (feature.fileapi && el.type == 'file') {
	                if (elements) elements.push(el);
	                var files = el.files;
	                if (files.length) {
	                    for (j = 0; j < files.length; j++) {
	                        a.push({ name: n, value: files[j], type: el.type });
	                    }
	                } else {
	                    // #180
	                    a.push({ name: n, value: '', type: el.type });
	                }
	            } else if (v !== null && typeof v != 'undefined') {
	                if (elements) elements.push(el);
	                a.push({ name: n, value: v, type: el.type, required: el.required });
	            }
	        }
	
	        if (!semantic && form.clk) {
	            // input type=='image' are not found in elements array! handle it here
	            var $input = $(form.clk),
	                input = $input[0];
	            n = input.name;
	            if (n && !input.disabled && input.type == 'image') {
	                a.push({ name: n, value: $input.val() });
	                a.push({ name: n + '.x', value: form.clk_x }, { name: n + '.y', value: form.clk_y });
	            }
	        }
	        return a;
	    };
	
	    /**
	     * Serializes form data into a 'submittable' string. This method will return a string
	     * in the format: name1=value1&amp;name2=value2
	     */
	    $.fn.formSerialize = function (semantic) {
	        //hand off to jQuery.param for proper encoding
	        return $.param(this.formToArray(semantic));
	    };
	
	    /**
	     * Serializes all field elements in the jQuery object into a query string.
	     * This method will return a string in the format: name1=value1&amp;name2=value2
	     */
	    $.fn.fieldSerialize = function (successful) {
	        var a = [];
	        this.each(function () {
	            var n = this.name;
	            if (!n) {
	                return;
	            }
	            var v = $.fieldValue(this, successful);
	            if (v && v.constructor == Array) {
	                for (var i = 0, max = v.length; i < max; i++) {
	                    a.push({ name: n, value: v[i] });
	                }
	            } else if (v !== null && typeof v != 'undefined') {
	                a.push({ name: this.name, value: v });
	            }
	        });
	        //hand off to jQuery.param for proper encoding
	        return $.param(a);
	    };
	
	    /**
	     * Returns the value(s) of the element in the matched set.  For example, consider the following form:
	     *
	     *  <form><fieldset>
	     *      <input name="A" type="text" />
	     *      <input name="A" type="text" />
	     *      <input name="B" type="checkbox" value="B1" />
	     *      <input name="B" type="checkbox" value="B2"/>
	     *      <input name="C" type="radio" value="C1" />
	     *      <input name="C" type="radio" value="C2" />
	     *  </fieldset></form>
	     *
	     *  var v = $('input[type=text]').fieldValue();
	     *  // if no values are entered into the text inputs
	     *  v == ['','']
	     *  // if values entered into the text inputs are 'foo' and 'bar'
	     *  v == ['foo','bar']
	     *
	     *  var v = $('input[type=checkbox]').fieldValue();
	     *  // if neither checkbox is checked
	     *  v === undefined
	     *  // if both checkboxes are checked
	     *  v == ['B1', 'B2']
	     *
	     *  var v = $('input[type=radio]').fieldValue();
	     *  // if neither radio is checked
	     *  v === undefined
	     *  // if first radio is checked
	     *  v == ['C1']
	     *
	     * The successful argument controls whether or not the field element must be 'successful'
	     * (per http://www.w3.org/TR/html4/interact/forms.html#successful-controls).
	     * The default value of the successful argument is true.  If this value is false the value(s)
	     * for each element is returned.
	     *
	     * Note: This method *always* returns an array.  If no valid value can be determined the
	     *    array will be empty, otherwise it will contain one or more values.
	     */
	    $.fn.fieldValue = function (successful) {
	        for (var val = [], i = 0, max = this.length; i < max; i++) {
	            var el = this[i];
	            var v = $.fieldValue(el, successful);
	            if (v === null || typeof v == 'undefined' || v.constructor == Array && !v.length) {
	                continue;
	            }
	            if (v.constructor == Array) $.merge(val, v);else val.push(v);
	        }
	        return val;
	    };
	
	    /**
	     * Returns the value of the field element.
	     */
	    $.fieldValue = function (el, successful) {
	        var n = el.name,
	            t = el.type,
	            tag = el.tagName.toLowerCase();
	        if (successful === undefined) {
	            successful = true;
	        }
	
	        if (successful && (!n || el.disabled || t == 'reset' || t == 'button' || (t == 'checkbox' || t == 'radio') && !el.checked || (t == 'submit' || t == 'image') && el.form && el.form.clk != el || tag == 'select' && el.selectedIndex == -1)) {
	            return null;
	        }
	
	        if (tag == 'select') {
	            var index = el.selectedIndex;
	            if (index < 0) {
	                return null;
	            }
	            var a = [],
	                ops = el.options;
	            var one = t == 'select-one';
	            var max = one ? index + 1 : ops.length;
	            for (var i = one ? index : 0; i < max; i++) {
	                var op = ops[i];
	                if (op.selected) {
	                    var v = op.value;
	                    if (!v) {
	                        // extra pain for IE...
	                        v = op.attributes && op.attributes['value'] && !op.attributes['value'].specified ? op.text : op.value;
	                    }
	                    if (one) {
	                        return v;
	                    }
	                    a.push(v);
	                }
	            }
	            return a;
	        }
	        return $(el).val();
	    };
	
	    /**
	     * Clears the form data.  Takes the following actions on the form's input fields:
	     *  - input text fields will have their 'value' property set to the empty string
	     *  - select elements will have their 'selectedIndex' property set to -1
	     *  - checkbox and radio inputs will have their 'checked' property set to false
	     *  - inputs of type submit, button, reset, and hidden will *not* be effected
	     *  - button elements will *not* be effected
	     */
	    $.fn.clearForm = function (includeHidden) {
	        return this.each(function () {
	            $('input,select,textarea', this).clearFields(includeHidden);
	        });
	    };
	
	    /**
	     * Clears the selected form elements.
	     */
	    $.fn.clearFields = $.fn.clearInputs = function (includeHidden) {
	        var re = /^(?:color|date|datetime|email|month|number|password|range|search|tel|text|time|url|week)$/i; // 'hidden' is not in this list
	        return this.each(function () {
	            var t = this.type,
	                tag = this.tagName.toLowerCase();
	            if (re.test(t) || tag == 'textarea') {
	                this.value = '';
	            } else if (t == 'checkbox' || t == 'radio') {
	                this.checked = false;
	            } else if (tag == 'select') {
	                this.selectedIndex = -1;
	            } else if (t == "file") {
	                if (/MSIE/.test(navigator.userAgent)) {
	                    $(this).replaceWith($(this).clone(true));
	                } else {
	                    $(this).val('');
	                }
	            } else if (includeHidden) {
	                // includeHidden can be the value true, or it can be a selector string
	                // indicating a special test; for example:
	                //  $('#myForm').clearForm('.special:hidden')
	                // the above would clean hidden inputs that have the class of 'special'
	                if (includeHidden === true && /hidden/.test(t) || typeof includeHidden == 'string' && $(this).is(includeHidden)) this.value = '';
	            }
	        });
	    };
	
	    /**
	     * Resets the form data.  Causes all form elements to be reset to their original value.
	     */
	    $.fn.resetForm = function () {
	        return this.each(function () {
	            // guard against an input with the name of 'reset'
	            // note that IE reports the reset function as an 'object'
	            if (typeof this.reset == 'function' || typeof this.reset == 'object' && !this.reset.nodeType) {
	                this.reset();
	            }
	        });
	    };
	
	    /**
	     * Enables or disables any matching elements.
	     */
	    $.fn.enable = function (b) {
	        if (b === undefined) {
	            b = true;
	        }
	        return this.each(function () {
	            this.disabled = !b;
	        });
	    };
	
	    /**
	     * Checks/unchecks any matching checkboxes or radio buttons and
	     * selects/deselects and matching option elements.
	     */
	    $.fn.selected = function (select) {
	        if (select === undefined) {
	            select = true;
	        }
	        return this.each(function () {
	            var t = this.type;
	            if (t == 'checkbox' || t == 'radio') {
	                this.checked = select;
	            } else if (this.tagName.toLowerCase() == 'option') {
	                var $sel = $(this).parent('select');
	                if (select && $sel[0] && $sel[0].type == 'select-one') {
	                    // deselect all other options
	                    $sel.find('option').selected(false);
	                }
	                this.selected = select;
	            }
	        });
	    };
	
	    // expose debug var
	    $.fn.ajaxSubmit.debug = false;
	
	    // helper fn for console logging
	    function log() {
	        if (!$.fn.ajaxSubmit.debug) return;
	        var msg = '[jquery.form] ' + Array.prototype.join.call(arguments, '');
	        if (window.console && window.console.log) {
	            window.console.log(msg);
	        } else if (window.opera && window.opera.postError) {
	            window.opera.postError(msg);
	        }
	    }
	})(typeof jQuery != 'undefined' ? jQuery : window.Zepto);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, jQuery) {/*
	 ### jQuery Star Rating Plugin v4.11 - 2013-03-14 ###
	 * Home: http://www.fyneworks.com/jquery/star-rating/
	 * Code: http://code.google.com/p/jquery-star-rating-plugin/
	 *
		* Licensed under http://en.wikipedia.org/wiki/MIT_License
	 ###
	*/
	
	/*# AVOID COLLISIONS #*/
	;if (__webpack_provided_window_dot_jQuery) (function ($) {
		/*# AVOID COLLISIONS #*/
	
		// IE6 Background Image Fix
		if (!$.support.opacity && !$.support.style) try {
			document.execCommand("BackgroundImageCache", false, true);
		} catch (e) {};
		// Thanks to http://www.visualjquery.com/rating/rating_redux.html
	
		// plugin initialization
		$.fn.rating = function (options) {
			if (this.length == 0) return this; // quick fail
	
			// Handle API methods
			if (typeof arguments[0] == 'string') {
				// Perform API methods on individual elements
				if (this.length > 1) {
					var args = arguments;
					return this.each(function () {
						$.fn.rating.apply($(this), args);
					});
				};
				// Invoke API method handler
				$.fn.rating[arguments[0]].apply(this, $.makeArray(arguments).slice(1) || []);
				// Quick exit...
				return this;
			};
	
			// Initialize options for this call
			var options = $.extend({} /* new object */
			, $.fn.rating.options /* default options */
			, options || {} /* just-in-time options */
			);
	
			// Allow multiple controls with the same name by making each call unique
			$.fn.rating.calls++;
	
			// loop through each matched element
			this.not('.star-rating-applied').addClass('star-rating-applied').each(function () {
	
				// Load control parameters / find context / etc
				var control,
				    input = $(this);
				var eid = (this.name || 'unnamed-rating').replace(/\[|\]/g, '_').replace(/^\_+|\_+$/g, '');
				var context = $(this.form || document.body);
	
				// FIX: http://code.google.com/p/jquery-star-rating-plugin/issues/detail?id=23
				var raters = context.data('rating');
				if (!raters || raters.call != $.fn.rating.calls) raters = { count: 0, call: $.fn.rating.calls };
				var rater = raters[eid] || context.data('rating' + eid);
	
				// if rater is available, verify that the control still exists
				if (rater) control = rater.data('rating');
	
				if (rater && control) //{// save a byte!
					// add star to control if rater is available and the same control still exists
					control.count++;
	
					//}// save a byte!
				else {
						// create new control if first star or control element was removed/replaced
	
						// Initialize options for this rater
						control = $.extend({} /* new object */
						, options || {} /* current call options */
						, ($.metadata ? input.metadata() : $.meta ? input.data() : null) || {}, /* metadata options */
						{ count: 0, stars: [], inputs: [] });
	
						// increment number of rating controls
						control.serial = raters.count++;
	
						// create rating element
						rater = $('<span class="star-rating-control"/>');
						input.before(rater);
	
						// Mark element for initialization (once all stars are ready)
						rater.addClass('rating-to-be-drawn');
	
						// Accept readOnly setting from 'disabled' property
						if (input.attr('disabled') || input.hasClass('disabled')) control.readOnly = true;
	
						// Accept required setting from class property (class='required')
						if (input.hasClass('required')) control.required = true;
	
						// Create 'cancel' button
						rater.append(control.cancel = $('<div class="rating-cancel"><a title="' + control.cancel + '">' + control.cancelValue + '</a></div>').on('mouseover', function () {
							$(this).rating('drain');
							$(this).addClass('star-rating-hover');
							//$(this).rating('focus');
						}).on('mouseout', function () {
							$(this).rating('draw');
							$(this).removeClass('star-rating-hover');
							//$(this).rating('blur');
						}).on('click', function () {
							$(this).rating('select');
						}).data('rating', control));
					}; // first element of group
	
				// insert rating star (thanks Jan Fanslau rev125 for blind support https://code.google.com/p/jquery-star-rating-plugin/issues/detail?id=125)
				var star = $('<div role="text" aria-label="' + this.title + '" class="star-rating rater-' + control.serial + '"><a title="' + (this.title || this.value) + '">' + this.value + '</a></div>');
				rater.append(star);
	
				// inherit attributes from input element
				if (this.id) star.attr('id', this.id);
				if (this.className) star.addClass(this.className);
	
				// Half-stars?
				if (control.half) control.split = 2;
	
				// Prepare division control
				if (typeof control.split == 'number' && control.split > 0) {
					var stw = ($.fn.width ? star.width() : 0) || control.starWidth;
					var spi = control.count % control.split,
					    spw = Math.floor(stw / control.split);
					star
					// restrict star's width and hide overflow (already in CSS)
					.width(spw)
					// move the star left by using a negative margin
					// this is work-around to IE's stupid box model (position:relative doesn't work)
					.find('a').css({ 'margin-left': '-' + spi * spw + 'px' });
				};
	
				// readOnly?
				if (control.readOnly) //{ //save a byte!
					// Mark star as readOnly so user can customize display
					star.addClass('star-rating-readonly');
					//}  //save a byte!
				else //{ //save a byte!
					// Enable hover css effects
					star.addClass('star-rating-live')
					// Attach mouse events
					.on('mouseover', function () {
						$(this).rating('fill');
						$(this).rating('focus');
					}).on('mouseout', function () {
						$(this).rating('draw');
						$(this).rating('blur');
					}).on('click', function () {
						$(this).rating('select');
					});
				//}; //save a byte!
	
				// set current selection
				if (this.checked) control.current = star;
	
				// set current select for links
				if (this.nodeName == "A") {
					if ($(this).hasClass('selected')) control.current = star;
				};
	
				// hide input element
				input.hide();
	
				// backward compatibility, form element to plugin
				input.on('change.rating', function (event) {
					if (event.selfTriggered) return false;
					$(this).rating('select');
				});
	
				// attach reference to star to input element and vice-versa
				star.data('rating.input', input.data('rating.star', star));
	
				// store control information in form (or body when form not available)
				control.stars[control.stars.length] = star[0];
				control.inputs[control.inputs.length] = input[0];
				control.rater = raters[eid] = rater;
				control.context = context;
	
				input.data('rating', control);
				rater.data('rating', control);
				star.data('rating', control);
				context.data('rating', raters);
				context.data('rating' + eid, rater); // required for ajax forms
			}); // each element
	
			// Initialize ratings (first draw)
			$('.rating-to-be-drawn').rating('draw').removeClass('rating-to-be-drawn');
	
			return this; // don't break the chain...
		};
	
		/*--------------------------------------------------------*/
	
		/*
	 	### Core functionality and API ###
	 */
		$.extend($.fn.rating, {
			// Used to append a unique serial number to internal control ID
			// each time the plugin is invoked so same name controls can co-exist
			calls: 0,
	
			focus: function () {
				var control = this.data('rating');if (!control) return this;
				if (!control.focus) return this; // quick fail if not required
				// find data for event
				var input = $(this).data('rating.input') || $(this.tagName == 'INPUT' ? this : null);
				// focus handler, as requested by focusdigital.co.uk
				if (control.focus) control.focus.apply(input[0], [input.val(), $('a', input.data('rating.star'))[0]]);
			}, // $.fn.rating.focus
	
			blur: function () {
				var control = this.data('rating');if (!control) return this;
				if (!control.blur) return this; // quick fail if not required
				// find data for event
				var input = $(this).data('rating.input') || $(this.tagName == 'INPUT' ? this : null);
				// blur handler, as requested by focusdigital.co.uk
				if (control.blur) control.blur.apply(input[0], [input.val(), $('a', input.data('rating.star'))[0]]);
			}, // $.fn.rating.blur
	
			fill: function () {
				// fill to the current mouse position.
				var control = this.data('rating');if (!control) return this;
				// do not execute when control is in read-only mode
				if (control.readOnly) return;
				// Reset all stars and highlight them up to this element
				this.rating('drain');
				this.prevAll().addBack().filter('.rater-' + control.serial).addClass('star-rating-hover');
			}, // $.fn.rating.fill
	
			drain: function () {
				// drain all the stars.
				var control = this.data('rating');if (!control) return this;
				// do not execute when control is in read-only mode
				if (control.readOnly) return;
				// Reset all stars
				control.rater.children().filter('.rater-' + control.serial).removeClass('star-rating-on').removeClass('star-rating-hover');
			}, // $.fn.rating.drain
	
			draw: function () {
				// set value and stars to reflect current selection
				var control = this.data('rating');if (!control) return this;
				// Clear all stars
				this.rating('drain');
				// Set control value
				var current = $(control.current); //? control.current.data('rating.input') : null );
				var starson = current.length ? current.prevAll().addBack().filter('.rater-' + control.serial) : null;
				if (starson) starson.addClass('star-rating-on');
				// Show/hide 'cancel' button
				control.cancel[control.readOnly || control.required ? 'hide' : 'show']();
				// Add/remove read-only classes to remove hand pointer
				this.siblings()[control.readOnly ? 'addClass' : 'removeClass']('star-rating-readonly');
			}, // $.fn.rating.draw
	
	
			select: function (value, wantCallBack) {
				// select a value
				var control = this.data('rating');if (!control) return this;
				// do not execute when control is in read-only mode
				if (control.readOnly) return;
				// clear selection
				control.current = null;
				// programmatically (based on user input)
				if (typeof value != 'undefined' || this.length > 1) {
					// select by index (0 based)
					if (typeof value == 'number') return $(control.stars[value]).rating('select', undefined, wantCallBack);
					// select by literal value (must be passed as a string
					if (typeof value == 'string') {
						//return
						$.each(control.stars, function () {
							//console.log($(this).data('rating.input'), $(this).data('rating.input').val(), value, $(this).data('rating.input').val()==value?'BINGO!':'');
							if ($(this).data('rating.input').val() == value) $(this).rating('select', undefined, wantCallBack);
						});
						// don't break the chain
						return this;
					};
				} else {
					control.current = this[0].tagName == 'INPUT' ? this.data('rating.star') : this.is('.rater-' + control.serial) ? this : null;
				};
				// Update rating control state
				this.data('rating', control);
				// Update display
				this.rating('draw');
				// find current input and its siblings
				var current = $(control.current ? control.current.data('rating.input') : null);
				var lastipt = $(control.inputs).filter(':checked');
				var deadipt = $(control.inputs).not(current);
				// check and uncheck elements as required
				deadipt.prop('checked', false); //.removeAttr('checked');
				current.prop('checked', true); //.attr('checked','checked');
				// trigger change on current or last selected input
				$(current.length ? current : lastipt).trigger({ type: 'change', selfTriggered: true });
				// click callback, as requested here: http://plugins.jquery.com/node/1655
				if ((wantCallBack || wantCallBack == undefined) && control.callback) control.callback.apply(current[0], [current.val(), $('a', control.current)[0]]); // callback event
				// don't break the chain
				return this;
			}, // $.fn.rating.select
	
	
			readOnly: function (toggle, disable) {
				// make the control read-only (still submits value)
				var control = this.data('rating');if (!control) return this;
				// setread-only status
				control.readOnly = toggle || toggle == undefined ? true : false;
				// enable/disable control value submission
				if (disable) $(control.inputs).attr("disabled", "disabled");else $(control.inputs).removeAttr("disabled");
				// Update rating control state
				this.data('rating', control);
				// Update display
				this.rating('draw');
			}, // $.fn.rating.readOnly
	
			disable: function () {
				// make read-only and never submit value
				this.rating('readOnly', true, true);
			}, // $.fn.rating.disable
	
			enable: function () {
				// make read/write and submit value
				this.rating('readOnly', false, false);
			} // $.fn.rating.select
	
		});
	
		/*--------------------------------------------------------*/
	
		/*
	 	### Default Settings ###
	 	eg.: You can override default control like this:
	 	$.fn.rating.options.cancel = 'Clear';
	 */
		$.fn.rating.options = { //$.extend($.fn.rating, { options: {
			cancel: 'Cancel Rating', // advisory title for the 'cancel' link
			cancelValue: '', // value to submit when user click the 'cancel' link
			split: 0, // split the star into how many parts?
	
			// Width of star image in case the plugin can't work it out. This can happen if
			// the jQuery.dimensions plugin is not available OR the image is hidden at installation
			starWidth: 16 //,
	
			//NB.: These don't need to be pre-defined (can be undefined/null) so let's save some code!
			//half:     false,         // just a shortcut to control.split = 2
			//required: false,         // disables the 'cancel' button so user can only select one of the specified values
			//readOnly: false,         // disable rating plugin interaction/ values cannot be.one('change',		//focus:    function(){},  // executed when stars are focused
			//blur:     function(){},  // executed when stars are focused
			//callback: function(){},  // executed when a star is clicked
		}; //} });
	
		/*--------------------------------------------------------*/
	
		// auto-initialize plugin
		$(function () {
			$('input[type=radio].star').rating();
		});
	
		/*# AVOID COLLISIONS #*/
	})(jQuery);
	/*# AVOID COLLISIONS #*/
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*
	Copyright 2012 Igor Vaynberg
	
	Version: 3.5.1 Timestamp: Tue Jul 22 18:58:56 EDT 2014
	
	This software is licensed under the Apache License, Version 2.0 (the "Apache License") or the GNU
	General Public License version 2 (the "GPL License"). You may choose either license to govern your
	use of this software only upon the condition that you accept all of the terms of either the Apache
	License or the GPL License.
	
	You may obtain a copy of the Apache License and the GPL License at:
	
	    http://www.apache.org/licenses/LICENSE-2.0
	    http://www.gnu.org/licenses/gpl-2.0.html
	
	Unless required by applicable law or agreed to in writing, software distributed under the
	Apache License or the GPL License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	CONDITIONS OF ANY KIND, either express or implied. See the Apache License and the GPL License for
	the specific language governing permissions and limitations under the Apache License and the GPL License.
	*/
	(function ($) {
	    if (typeof $.fn.each2 == "undefined") {
	        $.extend($.fn, {
	            /*
	            * 4-10 times faster .each replacement
	            * use it carefully, as it overrides jQuery context of element on each iteration
	            */
	            each2: function (c) {
	                var j = $([0]),
	                    i = -1,
	                    l = this.length;
	                while (++i < l && (j.context = j[0] = this[i]) && c.call(j[0], i, j) !== false //"this"=DOM, i=index, j=jQuery object
	                );
	                return this;
	            }
	        });
	    }
	})(jQuery);
	
	(function ($, undefined) {
	    "use strict";
	    /*global document, window, jQuery, console */
	
	    if (window.Select2 !== undefined) {
	        return;
	    }
	
	    var KEY,
	        AbstractSelect2,
	        SingleSelect2,
	        MultiSelect2,
	        nextUid,
	        sizer,
	        lastMousePosition = { x: 0, y: 0 },
	        $document,
	        scrollBarDimensions,
	        KEY = {
	        TAB: 9,
	        ENTER: 13,
	        ESC: 27,
	        SPACE: 32,
	        LEFT: 37,
	        UP: 38,
	        RIGHT: 39,
	        DOWN: 40,
	        SHIFT: 16,
	        CTRL: 17,
	        ALT: 18,
	        PAGE_UP: 33,
	        PAGE_DOWN: 34,
	        HOME: 36,
	        END: 35,
	        BACKSPACE: 8,
	        DELETE: 46,
	        isArrow: function (k) {
	            k = k.which ? k.which : k;
	            switch (k) {
	                case KEY.LEFT:
	                case KEY.RIGHT:
	                case KEY.UP:
	                case KEY.DOWN:
	                    return true;
	            }
	            return false;
	        },
	        isControl: function (e) {
	            var k = e.which;
	            switch (k) {
	                case KEY.SHIFT:
	                case KEY.CTRL:
	                case KEY.ALT:
	                    return true;
	            }
	
	            if (e.metaKey) return true;
	
	            return false;
	        },
	        isFunctionKey: function (k) {
	            k = k.which ? k.which : k;
	            return k >= 112 && k <= 123;
	        }
	    },
	        MEASURE_SCROLLBAR_TEMPLATE = "<div class='select2-measure-scrollbar'></div>",
	        DIACRITICS = { "\u24B6": "A", "\uFF21": "A", "\u00C0": "A", "\u00C1": "A", "\u00C2": "A", "\u1EA6": "A", "\u1EA4": "A", "\u1EAA": "A", "\u1EA8": "A", "\u00C3": "A", "\u0100": "A", "\u0102": "A", "\u1EB0": "A", "\u1EAE": "A", "\u1EB4": "A", "\u1EB2": "A", "\u0226": "A", "\u01E0": "A", "\u00C4": "A", "\u01DE": "A", "\u1EA2": "A", "\u00C5": "A", "\u01FA": "A", "\u01CD": "A", "\u0200": "A", "\u0202": "A", "\u1EA0": "A", "\u1EAC": "A", "\u1EB6": "A", "\u1E00": "A", "\u0104": "A", "\u023A": "A", "\u2C6F": "A", "\uA732": "AA", "\u00C6": "AE", "\u01FC": "AE", "\u01E2": "AE", "\uA734": "AO", "\uA736": "AU", "\uA738": "AV", "\uA73A": "AV", "\uA73C": "AY", "\u24B7": "B", "\uFF22": "B", "\u1E02": "B", "\u1E04": "B", "\u1E06": "B", "\u0243": "B", "\u0182": "B", "\u0181": "B", "\u24B8": "C", "\uFF23": "C", "\u0106": "C", "\u0108": "C", "\u010A": "C", "\u010C": "C", "\u00C7": "C", "\u1E08": "C", "\u0187": "C", "\u023B": "C", "\uA73E": "C", "\u24B9": "D", "\uFF24": "D", "\u1E0A": "D", "\u010E": "D", "\u1E0C": "D", "\u1E10": "D", "\u1E12": "D", "\u1E0E": "D", "\u0110": "D", "\u018B": "D", "\u018A": "D", "\u0189": "D", "\uA779": "D", "\u01F1": "DZ", "\u01C4": "DZ", "\u01F2": "Dz", "\u01C5": "Dz", "\u24BA": "E", "\uFF25": "E", "\u00C8": "E", "\u00C9": "E", "\u00CA": "E", "\u1EC0": "E", "\u1EBE": "E", "\u1EC4": "E", "\u1EC2": "E", "\u1EBC": "E", "\u0112": "E", "\u1E14": "E", "\u1E16": "E", "\u0114": "E", "\u0116": "E", "\u00CB": "E", "\u1EBA": "E", "\u011A": "E", "\u0204": "E", "\u0206": "E", "\u1EB8": "E", "\u1EC6": "E", "\u0228": "E", "\u1E1C": "E", "\u0118": "E", "\u1E18": "E", "\u1E1A": "E", "\u0190": "E", "\u018E": "E", "\u24BB": "F", "\uFF26": "F", "\u1E1E": "F", "\u0191": "F", "\uA77B": "F", "\u24BC": "G", "\uFF27": "G", "\u01F4": "G", "\u011C": "G", "\u1E20": "G", "\u011E": "G", "\u0120": "G", "\u01E6": "G", "\u0122": "G", "\u01E4": "G", "\u0193": "G", "\uA7A0": "G", "\uA77D": "G", "\uA77E": "G", "\u24BD": "H", "\uFF28": "H", "\u0124": "H", "\u1E22": "H", "\u1E26": "H", "\u021E": "H", "\u1E24": "H", "\u1E28": "H", "\u1E2A": "H", "\u0126": "H", "\u2C67": "H", "\u2C75": "H", "\uA78D": "H", "\u24BE": "I", "\uFF29": "I", "\u00CC": "I", "\u00CD": "I", "\u00CE": "I", "\u0128": "I", "\u012A": "I", "\u012C": "I", "\u0130": "I", "\u00CF": "I", "\u1E2E": "I", "\u1EC8": "I", "\u01CF": "I", "\u0208": "I", "\u020A": "I", "\u1ECA": "I", "\u012E": "I", "\u1E2C": "I", "\u0197": "I", "\u24BF": "J", "\uFF2A": "J", "\u0134": "J", "\u0248": "J", "\u24C0": "K", "\uFF2B": "K", "\u1E30": "K", "\u01E8": "K", "\u1E32": "K", "\u0136": "K", "\u1E34": "K", "\u0198": "K", "\u2C69": "K", "\uA740": "K", "\uA742": "K", "\uA744": "K", "\uA7A2": "K", "\u24C1": "L", "\uFF2C": "L", "\u013F": "L", "\u0139": "L", "\u013D": "L", "\u1E36": "L", "\u1E38": "L", "\u013B": "L", "\u1E3C": "L", "\u1E3A": "L", "\u0141": "L", "\u023D": "L", "\u2C62": "L", "\u2C60": "L", "\uA748": "L", "\uA746": "L", "\uA780": "L", "\u01C7": "LJ", "\u01C8": "Lj", "\u24C2": "M", "\uFF2D": "M", "\u1E3E": "M", "\u1E40": "M", "\u1E42": "M", "\u2C6E": "M", "\u019C": "M", "\u24C3": "N", "\uFF2E": "N", "\u01F8": "N", "\u0143": "N", "\u00D1": "N", "\u1E44": "N", "\u0147": "N", "\u1E46": "N", "\u0145": "N", "\u1E4A": "N", "\u1E48": "N", "\u0220": "N", "\u019D": "N", "\uA790": "N", "\uA7A4": "N", "\u01CA": "NJ", "\u01CB": "Nj", "\u24C4": "O", "\uFF2F": "O", "\u00D2": "O", "\u00D3": "O", "\u00D4": "O", "\u1ED2": "O", "\u1ED0": "O", "\u1ED6": "O", "\u1ED4": "O", "\u00D5": "O", "\u1E4C": "O", "\u022C": "O", "\u1E4E": "O", "\u014C": "O", "\u1E50": "O", "\u1E52": "O", "\u014E": "O", "\u022E": "O", "\u0230": "O", "\u00D6": "O", "\u022A": "O", "\u1ECE": "O", "\u0150": "O", "\u01D1": "O", "\u020C": "O", "\u020E": "O", "\u01A0": "O", "\u1EDC": "O", "\u1EDA": "O", "\u1EE0": "O", "\u1EDE": "O", "\u1EE2": "O", "\u1ECC": "O", "\u1ED8": "O", "\u01EA": "O", "\u01EC": "O", "\u00D8": "O", "\u01FE": "O", "\u0186": "O", "\u019F": "O", "\uA74A": "O", "\uA74C": "O", "\u01A2": "OI", "\uA74E": "OO", "\u0222": "OU", "\u24C5": "P", "\uFF30": "P", "\u1E54": "P", "\u1E56": "P", "\u01A4": "P", "\u2C63": "P", "\uA750": "P", "\uA752": "P", "\uA754": "P", "\u24C6": "Q", "\uFF31": "Q", "\uA756": "Q", "\uA758": "Q", "\u024A": "Q", "\u24C7": "R", "\uFF32": "R", "\u0154": "R", "\u1E58": "R", "\u0158": "R", "\u0210": "R", "\u0212": "R", "\u1E5A": "R", "\u1E5C": "R", "\u0156": "R", "\u1E5E": "R", "\u024C": "R", "\u2C64": "R", "\uA75A": "R", "\uA7A6": "R", "\uA782": "R", "\u24C8": "S", "\uFF33": "S", "\u1E9E": "S", "\u015A": "S", "\u1E64": "S", "\u015C": "S", "\u1E60": "S", "\u0160": "S", "\u1E66": "S", "\u1E62": "S", "\u1E68": "S", "\u0218": "S", "\u015E": "S", "\u2C7E": "S", "\uA7A8": "S", "\uA784": "S", "\u24C9": "T", "\uFF34": "T", "\u1E6A": "T", "\u0164": "T", "\u1E6C": "T", "\u021A": "T", "\u0162": "T", "\u1E70": "T", "\u1E6E": "T", "\u0166": "T", "\u01AC": "T", "\u01AE": "T", "\u023E": "T", "\uA786": "T", "\uA728": "TZ", "\u24CA": "U", "\uFF35": "U", "\u00D9": "U", "\u00DA": "U", "\u00DB": "U", "\u0168": "U", "\u1E78": "U", "\u016A": "U", "\u1E7A": "U", "\u016C": "U", "\u00DC": "U", "\u01DB": "U", "\u01D7": "U", "\u01D5": "U", "\u01D9": "U", "\u1EE6": "U", "\u016E": "U", "\u0170": "U", "\u01D3": "U", "\u0214": "U", "\u0216": "U", "\u01AF": "U", "\u1EEA": "U", "\u1EE8": "U", "\u1EEE": "U", "\u1EEC": "U", "\u1EF0": "U", "\u1EE4": "U", "\u1E72": "U", "\u0172": "U", "\u1E76": "U", "\u1E74": "U", "\u0244": "U", "\u24CB": "V", "\uFF36": "V", "\u1E7C": "V", "\u1E7E": "V", "\u01B2": "V", "\uA75E": "V", "\u0245": "V", "\uA760": "VY", "\u24CC": "W", "\uFF37": "W", "\u1E80": "W", "\u1E82": "W", "\u0174": "W", "\u1E86": "W", "\u1E84": "W", "\u1E88": "W", "\u2C72": "W", "\u24CD": "X", "\uFF38": "X", "\u1E8A": "X", "\u1E8C": "X", "\u24CE": "Y", "\uFF39": "Y", "\u1EF2": "Y", "\u00DD": "Y", "\u0176": "Y", "\u1EF8": "Y", "\u0232": "Y", "\u1E8E": "Y", "\u0178": "Y", "\u1EF6": "Y", "\u1EF4": "Y", "\u01B3": "Y", "\u024E": "Y", "\u1EFE": "Y", "\u24CF": "Z", "\uFF3A": "Z", "\u0179": "Z", "\u1E90": "Z", "\u017B": "Z", "\u017D": "Z", "\u1E92": "Z", "\u1E94": "Z", "\u01B5": "Z", "\u0224": "Z", "\u2C7F": "Z", "\u2C6B": "Z", "\uA762": "Z", "\u24D0": "a", "\uFF41": "a", "\u1E9A": "a", "\u00E0": "a", "\u00E1": "a", "\u00E2": "a", "\u1EA7": "a", "\u1EA5": "a", "\u1EAB": "a", "\u1EA9": "a", "\u00E3": "a", "\u0101": "a", "\u0103": "a", "\u1EB1": "a", "\u1EAF": "a", "\u1EB5": "a", "\u1EB3": "a", "\u0227": "a", "\u01E1": "a", "\u00E4": "a", "\u01DF": "a", "\u1EA3": "a", "\u00E5": "a", "\u01FB": "a", "\u01CE": "a", "\u0201": "a", "\u0203": "a", "\u1EA1": "a", "\u1EAD": "a", "\u1EB7": "a", "\u1E01": "a", "\u0105": "a", "\u2C65": "a", "\u0250": "a", "\uA733": "aa", "\u00E6": "ae", "\u01FD": "ae", "\u01E3": "ae", "\uA735": "ao", "\uA737": "au", "\uA739": "av", "\uA73B": "av", "\uA73D": "ay", "\u24D1": "b", "\uFF42": "b", "\u1E03": "b", "\u1E05": "b", "\u1E07": "b", "\u0180": "b", "\u0183": "b", "\u0253": "b", "\u24D2": "c", "\uFF43": "c", "\u0107": "c", "\u0109": "c", "\u010B": "c", "\u010D": "c", "\u00E7": "c", "\u1E09": "c", "\u0188": "c", "\u023C": "c", "\uA73F": "c", "\u2184": "c", "\u24D3": "d", "\uFF44": "d", "\u1E0B": "d", "\u010F": "d", "\u1E0D": "d", "\u1E11": "d", "\u1E13": "d", "\u1E0F": "d", "\u0111": "d", "\u018C": "d", "\u0256": "d", "\u0257": "d", "\uA77A": "d", "\u01F3": "dz", "\u01C6": "dz", "\u24D4": "e", "\uFF45": "e", "\u00E8": "e", "\u00E9": "e", "\u00EA": "e", "\u1EC1": "e", "\u1EBF": "e", "\u1EC5": "e", "\u1EC3": "e", "\u1EBD": "e", "\u0113": "e", "\u1E15": "e", "\u1E17": "e", "\u0115": "e", "\u0117": "e", "\u00EB": "e", "\u1EBB": "e", "\u011B": "e", "\u0205": "e", "\u0207": "e", "\u1EB9": "e", "\u1EC7": "e", "\u0229": "e", "\u1E1D": "e", "\u0119": "e", "\u1E19": "e", "\u1E1B": "e", "\u0247": "e", "\u025B": "e", "\u01DD": "e", "\u24D5": "f", "\uFF46": "f", "\u1E1F": "f", "\u0192": "f", "\uA77C": "f", "\u24D6": "g", "\uFF47": "g", "\u01F5": "g", "\u011D": "g", "\u1E21": "g", "\u011F": "g", "\u0121": "g", "\u01E7": "g", "\u0123": "g", "\u01E5": "g", "\u0260": "g", "\uA7A1": "g", "\u1D79": "g", "\uA77F": "g", "\u24D7": "h", "\uFF48": "h", "\u0125": "h", "\u1E23": "h", "\u1E27": "h", "\u021F": "h", "\u1E25": "h", "\u1E29": "h", "\u1E2B": "h", "\u1E96": "h", "\u0127": "h", "\u2C68": "h", "\u2C76": "h", "\u0265": "h", "\u0195": "hv", "\u24D8": "i", "\uFF49": "i", "\u00EC": "i", "\u00ED": "i", "\u00EE": "i", "\u0129": "i", "\u012B": "i", "\u012D": "i", "\u00EF": "i", "\u1E2F": "i", "\u1EC9": "i", "\u01D0": "i", "\u0209": "i", "\u020B": "i", "\u1ECB": "i", "\u012F": "i", "\u1E2D": "i", "\u0268": "i", "\u0131": "i", "\u24D9": "j", "\uFF4A": "j", "\u0135": "j", "\u01F0": "j", "\u0249": "j", "\u24DA": "k", "\uFF4B": "k", "\u1E31": "k", "\u01E9": "k", "\u1E33": "k", "\u0137": "k", "\u1E35": "k", "\u0199": "k", "\u2C6A": "k", "\uA741": "k", "\uA743": "k", "\uA745": "k", "\uA7A3": "k", "\u24DB": "l", "\uFF4C": "l", "\u0140": "l", "\u013A": "l", "\u013E": "l", "\u1E37": "l", "\u1E39": "l", "\u013C": "l", "\u1E3D": "l", "\u1E3B": "l", "\u017F": "l", "\u0142": "l", "\u019A": "l", "\u026B": "l", "\u2C61": "l", "\uA749": "l", "\uA781": "l", "\uA747": "l", "\u01C9": "lj", "\u24DC": "m", "\uFF4D": "m", "\u1E3F": "m", "\u1E41": "m", "\u1E43": "m", "\u0271": "m", "\u026F": "m", "\u24DD": "n", "\uFF4E": "n", "\u01F9": "n", "\u0144": "n", "\u00F1": "n", "\u1E45": "n", "\u0148": "n", "\u1E47": "n", "\u0146": "n", "\u1E4B": "n", "\u1E49": "n", "\u019E": "n", "\u0272": "n", "\u0149": "n", "\uA791": "n", "\uA7A5": "n", "\u01CC": "nj", "\u24DE": "o", "\uFF4F": "o", "\u00F2": "o", "\u00F3": "o", "\u00F4": "o", "\u1ED3": "o", "\u1ED1": "o", "\u1ED7": "o", "\u1ED5": "o", "\u00F5": "o", "\u1E4D": "o", "\u022D": "o", "\u1E4F": "o", "\u014D": "o", "\u1E51": "o", "\u1E53": "o", "\u014F": "o", "\u022F": "o", "\u0231": "o", "\u00F6": "o", "\u022B": "o", "\u1ECF": "o", "\u0151": "o", "\u01D2": "o", "\u020D": "o", "\u020F": "o", "\u01A1": "o", "\u1EDD": "o", "\u1EDB": "o", "\u1EE1": "o", "\u1EDF": "o", "\u1EE3": "o", "\u1ECD": "o", "\u1ED9": "o", "\u01EB": "o", "\u01ED": "o", "\u00F8": "o", "\u01FF": "o", "\u0254": "o", "\uA74B": "o", "\uA74D": "o", "\u0275": "o", "\u01A3": "oi", "\u0223": "ou", "\uA74F": "oo", "\u24DF": "p", "\uFF50": "p", "\u1E55": "p", "\u1E57": "p", "\u01A5": "p", "\u1D7D": "p", "\uA751": "p", "\uA753": "p", "\uA755": "p", "\u24E0": "q", "\uFF51": "q", "\u024B": "q", "\uA757": "q", "\uA759": "q", "\u24E1": "r", "\uFF52": "r", "\u0155": "r", "\u1E59": "r", "\u0159": "r", "\u0211": "r", "\u0213": "r", "\u1E5B": "r", "\u1E5D": "r", "\u0157": "r", "\u1E5F": "r", "\u024D": "r", "\u027D": "r", "\uA75B": "r", "\uA7A7": "r", "\uA783": "r", "\u24E2": "s", "\uFF53": "s", "\u00DF": "s", "\u015B": "s", "\u1E65": "s", "\u015D": "s", "\u1E61": "s", "\u0161": "s", "\u1E67": "s", "\u1E63": "s", "\u1E69": "s", "\u0219": "s", "\u015F": "s", "\u023F": "s", "\uA7A9": "s", "\uA785": "s", "\u1E9B": "s", "\u24E3": "t", "\uFF54": "t", "\u1E6B": "t", "\u1E97": "t", "\u0165": "t", "\u1E6D": "t", "\u021B": "t", "\u0163": "t", "\u1E71": "t", "\u1E6F": "t", "\u0167": "t", "\u01AD": "t", "\u0288": "t", "\u2C66": "t", "\uA787": "t", "\uA729": "tz", "\u24E4": "u", "\uFF55": "u", "\u00F9": "u", "\u00FA": "u", "\u00FB": "u", "\u0169": "u", "\u1E79": "u", "\u016B": "u", "\u1E7B": "u", "\u016D": "u", "\u00FC": "u", "\u01DC": "u", "\u01D8": "u", "\u01D6": "u", "\u01DA": "u", "\u1EE7": "u", "\u016F": "u", "\u0171": "u", "\u01D4": "u", "\u0215": "u", "\u0217": "u", "\u01B0": "u", "\u1EEB": "u", "\u1EE9": "u", "\u1EEF": "u", "\u1EED": "u", "\u1EF1": "u", "\u1EE5": "u", "\u1E73": "u", "\u0173": "u", "\u1E77": "u", "\u1E75": "u", "\u0289": "u", "\u24E5": "v", "\uFF56": "v", "\u1E7D": "v", "\u1E7F": "v", "\u028B": "v", "\uA75F": "v", "\u028C": "v", "\uA761": "vy", "\u24E6": "w", "\uFF57": "w", "\u1E81": "w", "\u1E83": "w", "\u0175": "w", "\u1E87": "w", "\u1E85": "w", "\u1E98": "w", "\u1E89": "w", "\u2C73": "w", "\u24E7": "x", "\uFF58": "x", "\u1E8B": "x", "\u1E8D": "x", "\u24E8": "y", "\uFF59": "y", "\u1EF3": "y", "\u00FD": "y", "\u0177": "y", "\u1EF9": "y", "\u0233": "y", "\u1E8F": "y", "\u00FF": "y", "\u1EF7": "y", "\u1E99": "y", "\u1EF5": "y", "\u01B4": "y", "\u024F": "y", "\u1EFF": "y", "\u24E9": "z", "\uFF5A": "z", "\u017A": "z", "\u1E91": "z", "\u017C": "z", "\u017E": "z", "\u1E93": "z", "\u1E95": "z", "\u01B6": "z", "\u0225": "z", "\u0240": "z", "\u2C6C": "z", "\uA763": "z", "\u0386": "\u0391", "\u0388": "\u0395", "\u0389": "\u0397", "\u038A": "\u0399", "\u03AA": "\u0399", "\u038C": "\u039F", "\u038E": "\u03A5", "\u03AB": "\u03A5", "\u038F": "\u03A9", "\u03AC": "\u03B1", "\u03AD": "\u03B5", "\u03AE": "\u03B7", "\u03AF": "\u03B9", "\u03CA": "\u03B9", "\u0390": "\u03B9", "\u03CC": "\u03BF", "\u03CD": "\u03C5", "\u03CB": "\u03C5", "\u03B0": "\u03C5", "\u03C9": "\u03C9", "\u03C2": "\u03C3" };
	
	    $document = $(document);
	
	    nextUid = function () {
	        var counter = 1;return function () {
	            return counter++;
	        };
	    }();
	
	    function reinsertElement(element) {
	        var placeholder = $(document.createTextNode(''));
	
	        element.before(placeholder);
	        placeholder.before(element);
	        placeholder.remove();
	    }
	
	    function stripDiacritics(str) {
	        // Used 'uni range + named function' from http://jsperf.com/diacritics/18
	        function match(a) {
	            return DIACRITICS[a] || a;
	        }
	
	        return str.replace(/[^\u0000-\u007E]/g, match);
	    }
	
	    function indexOf(value, array) {
	        var i = 0,
	            l = array.length;
	        for (; i < l; i = i + 1) {
	            if (equal(value, array[i])) return i;
	        }
	        return -1;
	    }
	
	    function measureScrollbar() {
	        var $template = $(MEASURE_SCROLLBAR_TEMPLATE);
	        $template.appendTo('body');
	
	        var dim = {
	            width: $template.width() - $template[0].clientWidth,
	            height: $template.height() - $template[0].clientHeight
	        };
	        $template.remove();
	
	        return dim;
	    }
	
	    /**
	     * Compares equality of a and b
	     * @param a
	     * @param b
	     */
	    function equal(a, b) {
	        if (a === b) return true;
	        if (a === undefined || b === undefined) return false;
	        if (a === null || b === null) return false;
	        // Check whether 'a' or 'b' is a string (primitive or object).
	        // The concatenation of an empty string (+'') converts its argument to a string's primitive.
	        if (a.constructor === String) return a + '' === b + ''; // a+'' - in case 'a' is a String object
	        if (b.constructor === String) return b + '' === a + ''; // b+'' - in case 'b' is a String object
	        return false;
	    }
	
	    /**
	     * Splits the string into an array of values, trimming each value. An empty array is returned for nulls or empty
	     * strings
	     * @param string
	     * @param separator
	     */
	    function splitVal(string, separator) {
	        var val, i, l;
	        if (string === null || string.length < 1) return [];
	        val = string.split(separator);
	        for (i = 0, l = val.length; i < l; i = i + 1) val[i] = $.trim(val[i]);
	        return val;
	    }
	
	    function getSideBorderPadding(element) {
	        return element.outerWidth(false) - element.width();
	    }
	
	    function installKeyUpChangeEvent(element) {
	        var key = "keyup-change-value";
	        element.on("keydown", function () {
	            if ($.data(element, key) === undefined) {
	                $.data(element, key, element.val());
	            }
	        });
	        element.on("keyup", function () {
	            var val = $.data(element, key);
	            if (val !== undefined && element.val() !== val) {
	                $.removeData(element, key);
	                element.trigger("keyup-change");
	            }
	        });
	    }
	
	    /**
	     * filters mouse events so an event is fired only if the mouse moved.
	     *
	     * filters out mouse events that occur when mouse is stationary but
	     * the elements under the pointer are scrolled.
	     */
	    function installFilteredMouseMove(element) {
	        element.on("mousemove", function (e) {
	            var lastpos = lastMousePosition;
	            if (lastpos === undefined || lastpos.x !== e.pageX || lastpos.y !== e.pageY) {
	                $(e.target).trigger("mousemove-filtered", e);
	            }
	        });
	    }
	
	    /**
	     * Debounces a function. Returns a function that calls the original fn function only if no invocations have been made
	     * within the last quietMillis milliseconds.
	     *
	     * @param quietMillis number of milliseconds to wait before invoking fn
	     * @param fn function to be debounced
	     * @param ctx object to be used as this reference within fn
	     * @return debounced version of fn
	     */
	    function debounce(quietMillis, fn, ctx) {
	        ctx = ctx || undefined;
	        var timeout;
	        return function () {
	            var args = arguments;
	            window.clearTimeout(timeout);
	            timeout = window.setTimeout(function () {
	                fn.apply(ctx, args);
	            }, quietMillis);
	        };
	    }
	
	    function installDebouncedScroll(threshold, element) {
	        var notify = debounce(threshold, function (e) {
	            element.trigger("scroll-debounced", e);
	        });
	        element.on("scroll", function (e) {
	            if (indexOf(e.target, element.get()) >= 0) notify(e);
	        });
	    }
	
	    function focus($el) {
	        if ($el[0] === document.activeElement) return;
	
	        /* set the focus in a 0 timeout - that way the focus is set after the processing
	            of the current event has finished - which seems like the only reliable way
	            to set focus */
	        window.setTimeout(function () {
	            var el = $el[0],
	                pos = $el.val().length,
	                range;
	
	            $el.focus();
	
	            /* make sure el received focus so we do not error out when trying to manipulate the caret.
	                sometimes modals or others listeners may steal it after its set */
	            var isVisible = el.offsetWidth > 0 || el.offsetHeight > 0;
	            if (isVisible && el === document.activeElement) {
	
	                /* after the focus is set move the caret to the end, necessary when we val()
	                    just before setting focus */
	                if (el.setSelectionRange) {
	                    el.setSelectionRange(pos, pos);
	                } else if (el.createTextRange) {
	                    range = el.createTextRange();
	                    range.collapse(false);
	                    range.select();
	                }
	            }
	        }, 0);
	    }
	
	    function getCursorInfo(el) {
	        el = $(el)[0];
	        var offset = 0;
	        var length = 0;
	        if ('selectionStart' in el) {
	            offset = el.selectionStart;
	            length = el.selectionEnd - offset;
	        } else if ('selection' in document) {
	            el.focus();
	            var sel = document.selection.createRange();
	            length = document.selection.createRange().text.length;
	            sel.moveStart('character', -el.value.length);
	            offset = sel.text.length - length;
	        }
	        return { offset: offset, length: length };
	    }
	
	    function killEvent(event) {
	        event.preventDefault();
	        event.stopPropagation();
	    }
	    function killEventImmediately(event) {
	        event.preventDefault();
	        event.stopImmediatePropagation();
	    }
	
	    function measureTextWidth(e) {
	        if (!sizer) {
	            var style = e[0].currentStyle || window.getComputedStyle(e[0], null);
	            sizer = $(document.createElement("div")).css({
	                position: "absolute",
	                left: "-10000px",
	                top: "-10000px",
	                display: "none",
	                fontSize: style.fontSize,
	                fontFamily: style.fontFamily,
	                fontStyle: style.fontStyle,
	                fontWeight: style.fontWeight,
	                letterSpacing: style.letterSpacing,
	                textTransform: style.textTransform,
	                whiteSpace: "nowrap"
	            });
	            sizer.attr("class", "select2-sizer");
	            $("body").append(sizer);
	        }
	        sizer.text(e.val());
	        return sizer.width();
	    }
	
	    function syncCssClasses(dest, src, adapter) {
	        var classes,
	            replacements = [],
	            adapted;
	
	        classes = $.trim(dest.attr("class"));
	
	        if (classes) {
	            classes = '' + classes; // for IE which returns object
	
	            $(classes.split(/\s+/)).each2(function () {
	                if (this.indexOf("select2-") === 0) {
	                    replacements.push(this);
	                }
	            });
	        }
	
	        classes = $.trim(src.attr("class"));
	
	        if (classes) {
	            classes = '' + classes; // for IE which returns object
	
	            $(classes.split(/\s+/)).each2(function () {
	                if (this.indexOf("select2-") !== 0) {
	                    adapted = adapter(this);
	
	                    if (adapted) {
	                        replacements.push(adapted);
	                    }
	                }
	            });
	        }
	
	        dest.attr("class", replacements.join(" "));
	    }
	
	    function markMatch(text, term, markup, escapeMarkup) {
	        var match = stripDiacritics(text.toUpperCase()).indexOf(stripDiacritics(term.toUpperCase())),
	            tl = term.length;
	
	        if (match < 0) {
	            markup.push(escapeMarkup(text));
	            return;
	        }
	
	        markup.push(escapeMarkup(text.substring(0, match)));
	        markup.push("<span class='select2-match'>");
	        markup.push(escapeMarkup(text.substring(match, match + tl)));
	        markup.push("</span>");
	        markup.push(escapeMarkup(text.substring(match + tl, text.length)));
	    }
	
	    function defaultEscapeMarkup(markup) {
	        var replace_map = {
	            '\\': '&#92;',
	            '&': '&amp;',
	            '<': '&lt;',
	            '>': '&gt;',
	            '"': '&quot;',
	            "'": '&#39;',
	            "/": '&#47;'
	        };
	
	        return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
	            return replace_map[match];
	        });
	    }
	
	    /**
	     * Produces an ajax-based query function
	     *
	     * @param options object containing configuration parameters
	     * @param options.params parameter map for the transport ajax call, can contain such options as cache, jsonpCallback, etc. see $.ajax
	     * @param options.transport function that will be used to execute the ajax request. must be compatible with parameters supported by $.ajax
	     * @param options.url url for the data
	     * @param options.data a function(searchTerm, pageNumber, context) that should return an object containing query string parameters for the above url.
	     * @param options.dataType request data type: ajax, jsonp, other datatypes supported by jQuery's $.ajax function or the transport function if specified
	     * @param options.quietMillis (optional) milliseconds to wait before making the ajaxRequest, helps debounce the ajax function if invoked too often
	     * @param options.results a function(remoteData, pageNumber, query) that converts data returned form the remote request to the format expected by Select2.
	     *      The expected format is an object containing the following keys:
	     *      results array of objects that will be used as choices
	     *      more (optional) boolean indicating whether there are more results available
	     *      Example: {results:[{id:1, text:'Red'},{id:2, text:'Blue'}], more:true}
	     */
	    function ajax(options) {
	        var timeout,
	            // current scheduled but not yet executed request
	        handler = null,
	            quietMillis = options.quietMillis || 100,
	            ajaxUrl = options.url,
	            self = this;
	
	        return function (query) {
	            window.clearTimeout(timeout);
	            timeout = window.setTimeout(function () {
	                var data = options.data,
	                    // ajax data function
	                url = ajaxUrl,
	                    // ajax url string or function
	                transport = options.transport || $.fn.select2.ajaxDefaults.transport,
	
	                // deprecated - to be removed in 4.0  - use params instead
	                deprecated = {
	                    type: options.type || 'GET', // set type of request (GET or POST)
	                    cache: options.cache || false,
	                    jsonpCallback: options.jsonpCallback || undefined,
	                    dataType: options.dataType || "json"
	                },
	                    params = $.extend({}, $.fn.select2.ajaxDefaults.params, deprecated);
	
	                data = data ? data.call(self, query.term, query.page, query.context) : null;
	                url = typeof url === 'function' ? url.call(self, query.term, query.page, query.context) : url;
	
	                if (handler && typeof handler.abort === "function") {
	                    handler.abort();
	                }
	
	                if (options.params) {
	                    if ($.isFunction(options.params)) {
	                        $.extend(params, options.params.call(self));
	                    } else {
	                        $.extend(params, options.params);
	                    }
	                }
	
	                $.extend(params, {
	                    url: url,
	                    dataType: options.dataType,
	                    data: data,
	                    success: function (data) {
	                        // TODO - replace query.page with query so users have access to term, page, etc.
	                        // added query as third paramter to keep backwards compatibility
	                        var results = options.results(data, query.page, query);
	                        query.callback(results);
	                    },
	                    error: function (jqXHR, textStatus, errorThrown) {
	                        var results = {
	                            hasError: true,
	                            jqXHR: jqXHR,
	                            textStatus: textStatus,
	                            errorThrown: errorThrown
	                        };
	
	                        query.callback(results);
	                    }
	                });
	                handler = transport.call(self, params);
	            }, quietMillis);
	        };
	    }
	
	    /**
	     * Produces a query function that works with a local array
	     *
	     * @param options object containing configuration parameters. The options parameter can either be an array or an
	     * object.
	     *
	     * If the array form is used it is assumed that it contains objects with 'id' and 'text' keys.
	     *
	     * If the object form is used it is assumed that it contains 'data' and 'text' keys. The 'data' key should contain
	     * an array of objects that will be used as choices. These objects must contain at least an 'id' key. The 'text'
	     * key can either be a String in which case it is expected that each element in the 'data' array has a key with the
	     * value of 'text' which will be used to match choices. Alternatively, text can be a function(item) that can extract
	     * the text.
	     */
	    function local(options) {
	        var data = options,
	            // data elements
	        dataText,
	            tmp,
	            text = function (item) {
	            return "" + item.text;
	        }; // function used to retrieve the text portion of a data item that is matched against the search
	
	        if ($.isArray(data)) {
	            tmp = data;
	            data = { results: tmp };
	        }
	
	        if ($.isFunction(data) === false) {
	            tmp = data;
	            data = function () {
	                return tmp;
	            };
	        }
	
	        var dataItem = data();
	        if (dataItem.text) {
	            text = dataItem.text;
	            // if text is not a function we assume it to be a key name
	            if (!$.isFunction(text)) {
	                dataText = dataItem.text; // we need to store this in a separate variable because in the next step data gets reset and data.text is no longer available
	                text = function (item) {
	                    return item[dataText];
	                };
	            }
	        }
	
	        return function (query) {
	            var t = query.term,
	                filtered = { results: [] },
	                process;
	            if (t === "") {
	                query.callback(data());
	                return;
	            }
	
	            process = function (datum, collection) {
	                var group, attr;
	                datum = datum[0];
	                if (datum.children) {
	                    group = {};
	                    for (attr in datum) {
	                        if (datum.hasOwnProperty(attr)) group[attr] = datum[attr];
	                    }
	                    group.children = [];
	                    $(datum.children).each2(function (i, childDatum) {
	                        process(childDatum, group.children);
	                    });
	                    if (group.children.length || query.matcher(t, text(group), datum)) {
	                        collection.push(group);
	                    }
	                } else {
	                    if (query.matcher(t, text(datum), datum)) {
	                        collection.push(datum);
	                    }
	                }
	            };
	
	            $(data().results).each2(function (i, datum) {
	                process(datum, filtered.results);
	            });
	            query.callback(filtered);
	        };
	    }
	
	    // TODO javadoc
	    function tags(data) {
	        var isFunc = $.isFunction(data);
	        return function (query) {
	            var t = query.term,
	                filtered = { results: [] };
	            var result = isFunc ? data(query) : data;
	            if ($.isArray(result)) {
	                $(result).each(function () {
	                    var isObject = this.text !== undefined,
	                        text = isObject ? this.text : this;
	                    if (t === "" || query.matcher(t, text)) {
	                        filtered.results.push(isObject ? this : { id: this, text: this });
	                    }
	                });
	                query.callback(filtered);
	            }
	        };
	    }
	
	    /**
	     * Checks if the formatter function should be used.
	     *
	     * Throws an error if it is not a function. Returns true if it should be used,
	     * false if no formatting should be performed.
	     *
	     * @param formatter
	     */
	    function checkFormatter(formatter, formatterName) {
	        if ($.isFunction(formatter)) return true;
	        if (!formatter) return false;
	        if (typeof formatter === 'string') return true;
	        throw new Error(formatterName + " must be a string, function, or falsy value");
	    }
	
	    /**
	     * Returns a given value
	     * If given a function, returns its output
	     *
	     * @param val string|function
	     * @param context value of "this" to be passed to function
	     * @returns {*}
	     */
	    function evaluate(val, context) {
	        if ($.isFunction(val)) {
	            var args = Array.prototype.slice.call(arguments, 2);
	            return val.apply(context, args);
	        }
	        return val;
	    }
	
	    function countResults(results) {
	        var count = 0;
	        $.each(results, function (i, item) {
	            if (item.children) {
	                count += countResults(item.children);
	            } else {
	                count++;
	            }
	        });
	        return count;
	    }
	
	    /**
	     * Default tokenizer. This function uses breaks the input on substring match of any string from the
	     * opts.tokenSeparators array and uses opts.createSearchChoice to create the choice object. Both of those
	     * two options have to be defined in order for the tokenizer to work.
	     *
	     * @param input text user has typed so far or pasted into the search field
	     * @param selection currently selected choices
	     * @param selectCallback function(choice) callback tho add the choice to selection
	     * @param opts select2's opts
	     * @return undefined/null to leave the current input unchanged, or a string to change the input to the returned value
	     */
	    function defaultTokenizer(input, selection, selectCallback, opts) {
	        var original = input,
	            // store the original so we can compare and know if we need to tell the search to update its text
	        dupe = false,
	            // check for whether a token we extracted represents a duplicate selected choice
	        token,
	            // token
	        index,
	            // position at which the separator was found
	        i,
	            l,
	            // looping variables
	        separator; // the matched separator
	
	        if (!opts.createSearchChoice || !opts.tokenSeparators || opts.tokenSeparators.length < 1) return undefined;
	
	        while (true) {
	            index = -1;
	
	            for (i = 0, l = opts.tokenSeparators.length; i < l; i++) {
	                separator = opts.tokenSeparators[i];
	                index = input.indexOf(separator);
	                if (index >= 0) break;
	            }
	
	            if (index < 0) break; // did not find any token separator in the input string, bail
	
	            token = input.substring(0, index);
	            input = input.substring(index + separator.length);
	
	            if (token.length > 0) {
	                token = opts.createSearchChoice.call(this, token, selection);
	                if (token !== undefined && token !== null && opts.id(token) !== undefined && opts.id(token) !== null) {
	                    dupe = false;
	                    for (i = 0, l = selection.length; i < l; i++) {
	                        if (equal(opts.id(token), opts.id(selection[i]))) {
	                            dupe = true;break;
	                        }
	                    }
	
	                    if (!dupe) selectCallback(token);
	                }
	            }
	        }
	
	        if (original !== input) return input;
	    }
	
	    function cleanupJQueryElements() {
	        var self = this;
	
	        $.each(arguments, function (i, element) {
	            self[element].remove();
	            self[element] = null;
	        });
	    }
	
	    /**
	     * Creates a new class
	     *
	     * @param superClass
	     * @param methods
	     */
	    function clazz(SuperClass, methods) {
	        var constructor = function () {};
	        constructor.prototype = new SuperClass();
	        constructor.prototype.constructor = constructor;
	        constructor.prototype.parent = SuperClass.prototype;
	        constructor.prototype = $.extend(constructor.prototype, methods);
	        return constructor;
	    }
	
	    AbstractSelect2 = clazz(Object, {
	
	        // abstract
	        bind: function (func) {
	            var self = this;
	            return function () {
	                func.apply(self, arguments);
	            };
	        },
	
	        // abstract
	        init: function (opts) {
	            var results,
	                search,
	                resultsSelector = ".select2-results";
	
	            // prepare options
	            this.opts = opts = this.prepareOpts(opts);
	
	            this.id = opts.id;
	
	            // destroy if called on an existing component
	            if (opts.element.data("select2") !== undefined && opts.element.data("select2") !== null) {
	                opts.element.data("select2").destroy();
	            }
	
	            this.container = this.createContainer();
	
	            this.liveRegion = $("<span>", {
	                role: "status",
	                "aria-live": "polite"
	            }).addClass("select2-hidden-accessible").appendTo(document.body);
	
	            this.containerId = "s2id_" + (opts.element.attr("id") || "autogen" + nextUid());
	            this.containerEventName = this.containerId.replace(/([.])/g, '_').replace(/([;&,\-\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
	            this.container.attr("id", this.containerId);
	
	            this.container.attr("title", opts.element.attr("title"));
	
	            this.body = $("body");
	
	            syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
	
	            this.container.attr("style", opts.element.attr("style"));
	            this.container.css(evaluate(opts.containerCss, this.opts.element));
	            this.container.addClass(evaluate(opts.containerCssClass, this.opts.element));
	
	            this.elementTabIndex = this.opts.element.attr("tabindex");
	
	            // swap container for the element
	            this.opts.element.data("select2", this).attr("tabindex", "-1").before(this.container).on("click.select2", killEvent); // do not leak click events
	
	            this.container.data("select2", this);
	
	            this.dropdown = this.container.find(".select2-drop");
	
	            syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
	
	            this.dropdown.addClass(evaluate(opts.dropdownCssClass, this.opts.element));
	            this.dropdown.data("select2", this);
	            this.dropdown.on("click", killEvent);
	
	            this.results = results = this.container.find(resultsSelector);
	            this.search = search = this.container.find("input.select2-input");
	
	            this.queryCount = 0;
	            this.resultsPage = 0;
	            this.context = null;
	
	            // initialize the container
	            this.initContainer();
	
	            this.container.on("click", killEvent);
	
	            installFilteredMouseMove(this.results);
	
	            this.dropdown.on("mousemove-filtered", resultsSelector, this.bind(this.highlightUnderEvent));
	            this.dropdown.on("touchstart touchmove touchend", resultsSelector, this.bind(function (event) {
	                this._touchEvent = true;
	                this.highlightUnderEvent(event);
	            }));
	            this.dropdown.on("touchmove", resultsSelector, this.bind(this.touchMoved));
	            this.dropdown.on("touchstart touchend", resultsSelector, this.bind(this.clearTouchMoved));
	
	            // Waiting for a click event on touch devices to select option and hide dropdown
	            // otherwise click will be triggered on an underlying element
	            this.dropdown.on('click', this.bind(function (event) {
	                if (this._touchEvent) {
	                    this._touchEvent = false;
	                    this.selectHighlighted();
	                }
	            }));
	
	            installDebouncedScroll(80, this.results);
	            this.dropdown.on("scroll-debounced", resultsSelector, this.bind(this.loadMoreIfNeeded));
	
	            // do not propagate change event from the search field out of the component
	            $(this.container).on("change", ".select2-input", function (e) {
	                e.stopPropagation();
	            });
	            $(this.dropdown).on("change", ".select2-input", function (e) {
	                e.stopPropagation();
	            });
	
	            // if jquery.mousewheel plugin is installed we can prevent out-of-bounds scrolling of results via mousewheel
	            if ($.fn.mousewheel) {
	                results.mousewheel(function (e, delta, deltaX, deltaY) {
	                    var top = results.scrollTop();
	                    if (deltaY > 0 && top - deltaY <= 0) {
	                        results.scrollTop(0);
	                        killEvent(e);
	                    } else if (deltaY < 0 && results.get(0).scrollHeight - results.scrollTop() + deltaY <= results.height()) {
	                        results.scrollTop(results.get(0).scrollHeight - results.height());
	                        killEvent(e);
	                    }
	                });
	            }
	
	            installKeyUpChangeEvent(search);
	            search.on("keyup-change input paste", this.bind(this.updateResults));
	            search.on("focus", function () {
	                search.addClass("select2-focused");
	            });
	            search.on("blur", function () {
	                search.removeClass("select2-focused");
	            });
	
	            this.dropdown.on("mouseup", resultsSelector, this.bind(function (e) {
	                if ($(e.target).closest(".select2-result-selectable").length > 0) {
	                    this.highlightUnderEvent(e);
	                    this.selectHighlighted(e);
	                }
	            }));
	
	            // trap all mouse events from leaving the dropdown. sometimes there may be a modal that is listening
	            // for mouse events outside of itself so it can close itself. since the dropdown is now outside the select2's
	            // dom it will trigger the popup close, which is not what we want
	            // focusin can cause focus wars between modals and select2 since the dropdown is outside the modal.
	            this.dropdown.on("click mouseup mousedown touchstart touchend focusin", function (e) {
	                e.stopPropagation();
	            });
	
	            this.nextSearchTerm = undefined;
	
	            if ($.isFunction(this.opts.initSelection)) {
	                // initialize selection based on the current value of the source element
	                this.initSelection();
	
	                // if the user has provided a function that can set selection based on the value of the source element
	                // we monitor the change event on the element and trigger it, allowing for two way synchronization
	                this.monitorSource();
	            }
	
	            if (opts.maximumInputLength !== null) {
	                this.search.attr("maxlength", opts.maximumInputLength);
	            }
	
	            var disabled = opts.element.prop("disabled");
	            if (disabled === undefined) disabled = false;
	            this.enable(!disabled);
	
	            var readonly = opts.element.prop("readonly");
	            if (readonly === undefined) readonly = false;
	            this.readonly(readonly);
	
	            // Calculate size of scrollbar
	            scrollBarDimensions = scrollBarDimensions || measureScrollbar();
	
	            this.autofocus = opts.element.prop("autofocus");
	            opts.element.prop("autofocus", false);
	            if (this.autofocus) this.focus();
	
	            this.search.attr("placeholder", opts.searchInputPlaceholder);
	        },
	
	        // abstract
	        destroy: function () {
	            var element = this.opts.element,
	                select2 = element.data("select2"),
	                self = this;
	
	            this.close();
	
	            if (element.length && element[0].detachEvent) {
	                element.each(function () {
	                    this.detachEvent("onpropertychange", self._sync);
	                });
	            }
	            if (this.propertyObserver) {
	                this.propertyObserver.disconnect();
	                this.propertyObserver = null;
	            }
	            this._sync = null;
	
	            if (select2 !== undefined) {
	                select2.container.remove();
	                select2.liveRegion.remove();
	                select2.dropdown.remove();
	                element.removeClass("select2-offscreen").removeData("select2").off(".select2").prop("autofocus", this.autofocus || false);
	                if (this.elementTabIndex) {
	                    element.attr({ tabindex: this.elementTabIndex });
	                } else {
	                    element.removeAttr("tabindex");
	                }
	                element.show();
	            }
	
	            cleanupJQueryElements.call(this, "container", "liveRegion", "dropdown", "results", "search");
	        },
	
	        // abstract
	        optionToData: function (element) {
	            if (element.is("option")) {
	                return {
	                    id: element.prop("value"),
	                    text: element.text(),
	                    element: element.get(),
	                    css: element.attr("class"),
	                    disabled: element.prop("disabled"),
	                    locked: equal(element.attr("locked"), "locked") || equal(element.data("locked"), true)
	                };
	            } else if (element.is("optgroup")) {
	                return {
	                    text: element.attr("label"),
	                    children: [],
	                    element: element.get(),
	                    css: element.attr("class")
	                };
	            }
	        },
	
	        // abstract
	        prepareOpts: function (opts) {
	            var element,
	                select,
	                idKey,
	                ajaxUrl,
	                self = this;
	
	            element = opts.element;
	
	            if (element.get(0).tagName.toLowerCase() === "select") {
	                this.select = select = opts.element;
	            }
	
	            if (select) {
	                // these options are not allowed when attached to a select because they are picked up off the element itself
	                $.each(["id", "multiple", "ajax", "query", "createSearchChoice", "initSelection", "data", "tags"], function () {
	                    if (this in opts) {
	                        throw new Error("Option '" + this + "' is not allowed for Select2 when attached to a <select> element.");
	                    }
	                });
	            }
	
	            opts = $.extend({}, {
	                populateResults: function (container, results, query) {
	                    var populate,
	                        id = this.opts.id,
	                        liveRegion = this.liveRegion;
	
	                    populate = function (results, container, depth) {
	
	                        var i, l, result, selectable, disabled, compound, node, label, innerContainer, formatted;
	
	                        results = opts.sortResults(results, container, query);
	
	                        // collect the created nodes for bulk append
	                        var nodes = [];
	                        for (i = 0, l = results.length; i < l; i = i + 1) {
	
	                            result = results[i];
	
	                            disabled = result.disabled === true;
	                            selectable = !disabled && id(result) !== undefined;
	
	                            compound = result.children && result.children.length > 0;
	
	                            node = $("<li></li>");
	                            node.addClass("select2-results-dept-" + depth);
	                            node.addClass("select2-result");
	                            node.addClass(selectable ? "select2-result-selectable" : "select2-result-unselectable");
	                            if (disabled) {
	                                node.addClass("select2-disabled");
	                            }
	                            if (compound) {
	                                node.addClass("select2-result-with-children");
	                            }
	                            node.addClass(self.opts.formatResultCssClass(result));
	                            node.attr("role", "presentation");
	
	                            label = $(document.createElement("div"));
	                            label.addClass("select2-result-label");
	                            label.attr("id", "select2-result-label-" + nextUid());
	                            label.attr("role", "option");
	
	                            formatted = opts.formatResult(result, label, query, self.opts.escapeMarkup);
	                            if (formatted !== undefined) {
	                                label.html(formatted);
	                                node.append(label);
	                            }
	
	                            if (compound) {
	
	                                innerContainer = $("<ul></ul>");
	                                innerContainer.addClass("select2-result-sub");
	                                populate(result.children, innerContainer, depth + 1);
	                                node.append(innerContainer);
	                            }
	
	                            node.data("select2-data", result);
	                            nodes.push(node[0]);
	                        }
	
	                        // bulk append the created nodes
	                        container.append(nodes);
	                        liveRegion.text(opts.formatMatches(results.length));
	                    };
	
	                    populate(results, container, 0);
	                }
	            }, $.fn.select2.defaults, opts);
	
	            if (typeof opts.id !== "function") {
	                idKey = opts.id;
	                opts.id = function (e) {
	                    return e[idKey];
	                };
	            }
	
	            if ($.isArray(opts.element.data("select2Tags"))) {
	                if ("tags" in opts) {
	                    throw "tags specified as both an attribute 'data-select2-tags' and in options of Select2 " + opts.element.attr("id");
	                }
	                opts.tags = opts.element.data("select2Tags");
	            }
	
	            if (select) {
	                opts.query = this.bind(function (query) {
	                    var data = { results: [], more: false },
	                        term = query.term,
	                        children,
	                        placeholderOption,
	                        process;
	
	                    process = function (element, collection) {
	                        var group;
	                        if (element.is("option")) {
	                            if (query.matcher(term, element.text(), element)) {
	                                collection.push(self.optionToData(element));
	                            }
	                        } else if (element.is("optgroup")) {
	                            group = self.optionToData(element);
	                            element.children().each2(function (i, elm) {
	                                process(elm, group.children);
	                            });
	                            if (group.children.length > 0) {
	                                collection.push(group);
	                            }
	                        }
	                    };
	
	                    children = element.children();
	
	                    // ignore the placeholder option if there is one
	                    if (this.getPlaceholder() !== undefined && children.length > 0) {
	                        placeholderOption = this.getPlaceholderOption();
	                        if (placeholderOption) {
	                            children = children.not(placeholderOption);
	                        }
	                    }
	
	                    children.each2(function (i, elm) {
	                        process(elm, data.results);
	                    });
	
	                    query.callback(data);
	                });
	                // this is needed because inside val() we construct choices from options and their id is hardcoded
	                opts.id = function (e) {
	                    return e.id;
	                };
	            } else {
	                if (!("query" in opts)) {
	
	                    if ("ajax" in opts) {
	                        ajaxUrl = opts.element.data("ajax-url");
	                        if (ajaxUrl && ajaxUrl.length > 0) {
	                            opts.ajax.url = ajaxUrl;
	                        }
	                        opts.query = ajax.call(opts.element, opts.ajax);
	                    } else if ("data" in opts) {
	                        opts.query = local(opts.data);
	                    } else if ("tags" in opts) {
	                        opts.query = tags(opts.tags);
	                        if (opts.createSearchChoice === undefined) {
	                            opts.createSearchChoice = function (term) {
	                                return { id: $.trim(term), text: $.trim(term) };
	                            };
	                        }
	                        if (opts.initSelection === undefined) {
	                            opts.initSelection = function (element, callback) {
	                                var data = [];
	                                $(splitVal(element.val(), opts.separator)).each(function () {
	                                    var obj = { id: this, text: this },
	                                        tags = opts.tags;
	                                    if ($.isFunction(tags)) tags = tags();
	                                    $(tags).each(function () {
	                                        if (equal(this.id, obj.id)) {
	                                            obj = this;return false;
	                                        }
	                                    });
	                                    data.push(obj);
	                                });
	
	                                callback(data);
	                            };
	                        }
	                    }
	                }
	            }
	            if (typeof opts.query !== "function") {
	                throw "query function not defined for Select2 " + opts.element.attr("id");
	            }
	
	            if (opts.createSearchChoicePosition === 'top') {
	                opts.createSearchChoicePosition = function (list, item) {
	                    list.unshift(item);
	                };
	            } else if (opts.createSearchChoicePosition === 'bottom') {
	                opts.createSearchChoicePosition = function (list, item) {
	                    list.push(item);
	                };
	            } else if (typeof opts.createSearchChoicePosition !== "function") {
	                throw "invalid createSearchChoicePosition option must be 'top', 'bottom' or a custom function";
	            }
	
	            return opts;
	        },
	
	        /**
	         * Monitor the original element for changes and update select2 accordingly
	         */
	        // abstract
	        monitorSource: function () {
	            var el = this.opts.element,
	                observer,
	                self = this;
	
	            el.on("change.select2", this.bind(function (e) {
	                if (this.opts.element.data("select2-change-triggered") !== true) {
	                    this.initSelection();
	                }
	            }));
	
	            this._sync = this.bind(function () {
	
	                // sync enabled state
	                var disabled = el.prop("disabled");
	                if (disabled === undefined) disabled = false;
	                this.enable(!disabled);
	
	                var readonly = el.prop("readonly");
	                if (readonly === undefined) readonly = false;
	                this.readonly(readonly);
	
	                syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
	                this.container.addClass(evaluate(this.opts.containerCssClass, this.opts.element));
	
	                syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
	                this.dropdown.addClass(evaluate(this.opts.dropdownCssClass, this.opts.element));
	            });
	
	            // IE8-10 (IE9/10 won't fire propertyChange via attachEventListener)
	            if (el.length && el[0].attachEvent) {
	                el.each(function () {
	                    this.attachEvent("onpropertychange", self._sync);
	                });
	            }
	
	            // safari, chrome, firefox, IE11
	            observer = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	            if (observer !== undefined) {
	                if (this.propertyObserver) {
	                    delete this.propertyObserver;this.propertyObserver = null;
	                }
	                this.propertyObserver = new observer(function (mutations) {
	                    $.each(mutations, self._sync);
	                });
	                this.propertyObserver.observe(el.get(0), { attributes: true, subtree: false });
	            }
	        },
	
	        // abstract
	        triggerSelect: function (data) {
	            var evt = $.Event("select2-selecting", { val: this.id(data), object: data, choice: data });
	            this.opts.element.trigger(evt);
	            return !evt.isDefaultPrevented();
	        },
	
	        /**
	         * Triggers the change event on the source element
	         */
	        // abstract
	        triggerChange: function (details) {
	
	            details = details || {};
	            details = $.extend({}, details, { type: "change", val: this.val() });
	            // prevents recursive triggering
	            this.opts.element.data("select2-change-triggered", true);
	            this.opts.element.trigger(details);
	            this.opts.element.data("select2-change-triggered", false);
	
	            // some validation frameworks ignore the change event and listen instead to keyup, click for selects
	            // so here we trigger the click event manually
	            this.opts.element.click();
	
	            // ValidationEngine ignores the change event and listens instead to blur
	            // so here we trigger the blur event manually if so desired
	            if (this.opts.blurOnChange) this.opts.element.blur();
	        },
	
	        //abstract
	        isInterfaceEnabled: function () {
	            return this.enabledInterface === true;
	        },
	
	        // abstract
	        enableInterface: function () {
	            var enabled = this._enabled && !this._readonly,
	                disabled = !enabled;
	
	            if (enabled === this.enabledInterface) return false;
	
	            this.container.toggleClass("select2-container-disabled", disabled);
	            this.close();
	            this.enabledInterface = enabled;
	
	            return true;
	        },
	
	        // abstract
	        enable: function (enabled) {
	            if (enabled === undefined) enabled = true;
	            if (this._enabled === enabled) return;
	            this._enabled = enabled;
	
	            this.opts.element.prop("disabled", !enabled);
	            this.enableInterface();
	        },
	
	        // abstract
	        disable: function () {
	            this.enable(false);
	        },
	
	        // abstract
	        readonly: function (enabled) {
	            if (enabled === undefined) enabled = false;
	            if (this._readonly === enabled) return;
	            this._readonly = enabled;
	
	            this.opts.element.prop("readonly", enabled);
	            this.enableInterface();
	        },
	
	        // abstract
	        opened: function () {
	            return this.container ? this.container.hasClass("select2-dropdown-open") : false;
	        },
	
	        // abstract
	        positionDropdown: function () {
	            var $dropdown = this.dropdown,
	                offset = this.container.offset(),
	                height = this.container.outerHeight(false),
	                width = this.container.outerWidth(false),
	                dropHeight = $dropdown.outerHeight(false),
	                $window = $(window),
	                windowWidth = $window.width(),
	                windowHeight = $window.height(),
	                viewPortRight = $window.scrollLeft() + windowWidth,
	                viewportBottom = $window.scrollTop() + windowHeight,
	                dropTop = offset.top + height,
	                dropLeft = offset.left,
	                enoughRoomBelow = dropTop + dropHeight <= viewportBottom,
	                enoughRoomAbove = offset.top - dropHeight >= $window.scrollTop(),
	                dropWidth = $dropdown.outerWidth(false),
	                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight,
	                aboveNow = $dropdown.hasClass("select2-drop-above"),
	                bodyOffset,
	                above,
	                changeDirection,
	                css,
	                resultsListNode;
	
	            // always prefer the current above/below alignment, unless there is not enough room
	            if (aboveNow) {
	                above = true;
	                if (!enoughRoomAbove && enoughRoomBelow) {
	                    changeDirection = true;
	                    above = false;
	                }
	            } else {
	                above = false;
	                if (!enoughRoomBelow && enoughRoomAbove) {
	                    changeDirection = true;
	                    above = true;
	                }
	            }
	
	            //if we are changing direction we need to get positions when dropdown is hidden;
	            if (changeDirection) {
	                $dropdown.hide();
	                offset = this.container.offset();
	                height = this.container.outerHeight(false);
	                width = this.container.outerWidth(false);
	                dropHeight = $dropdown.outerHeight(false);
	                viewPortRight = $window.scrollLeft() + windowWidth;
	                viewportBottom = $window.scrollTop() + windowHeight;
	                dropTop = offset.top + height;
	                dropLeft = offset.left;
	                dropWidth = $dropdown.outerWidth(false);
	                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight;
	                $dropdown.show();
	
	                // fix so the cursor does not move to the left within the search-textbox in IE
	                this.focusSearch();
	            }
	
	            if (this.opts.dropdownAutoWidth) {
	                resultsListNode = $('.select2-results', $dropdown)[0];
	                $dropdown.addClass('select2-drop-auto-width');
	                $dropdown.css('width', '');
	                // Add scrollbar width to dropdown if vertical scrollbar is present
	                dropWidth = $dropdown.outerWidth(false) + (resultsListNode.scrollHeight === resultsListNode.clientHeight ? 0 : scrollBarDimensions.width);
	                dropWidth > width ? width = dropWidth : dropWidth = width;
	                dropHeight = $dropdown.outerHeight(false);
	                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight;
	            } else {
	                this.container.removeClass('select2-drop-auto-width');
	            }
	
	            //console.log("below/ droptop:", dropTop, "dropHeight", dropHeight, "sum", (dropTop+dropHeight)+" viewport bottom", viewportBottom, "enough?", enoughRoomBelow);
	            //console.log("above/ offset.top", offset.top, "dropHeight", dropHeight, "top", (offset.top-dropHeight), "scrollTop", this.body.scrollTop(), "enough?", enoughRoomAbove);
	
	            // fix positioning when body has an offset and is not position: static
	            if (this.body.css('position') !== 'static') {
	                bodyOffset = this.body.offset();
	                dropTop -= bodyOffset.top;
	                dropLeft -= bodyOffset.left;
	            }
	
	            if (!enoughRoomOnRight) {
	                dropLeft = offset.left + this.container.outerWidth(false) - dropWidth;
	            }
	
	            css = {
	                left: dropLeft,
	                width: width
	            };
	
	            if (above) {
	                css.top = offset.top - dropHeight;
	                css.bottom = 'auto';
	                this.container.addClass("select2-drop-above");
	                $dropdown.addClass("select2-drop-above");
	            } else {
	                css.top = dropTop;
	                css.bottom = 'auto';
	                this.container.removeClass("select2-drop-above");
	                $dropdown.removeClass("select2-drop-above");
	            }
	            css = $.extend(css, evaluate(this.opts.dropdownCss, this.opts.element));
	
	            $dropdown.css(css);
	        },
	
	        // abstract
	        shouldOpen: function () {
	            var event;
	
	            if (this.opened()) return false;
	
	            if (this._enabled === false || this._readonly === true) return false;
	
	            event = $.Event("select2-opening");
	            this.opts.element.trigger(event);
	            return !event.isDefaultPrevented();
	        },
	
	        // abstract
	        clearDropdownAlignmentPreference: function () {
	            // clear the classes used to figure out the preference of where the dropdown should be opened
	            this.container.removeClass("select2-drop-above");
	            this.dropdown.removeClass("select2-drop-above");
	        },
	
	        /**
	         * Opens the dropdown
	         *
	         * @return {Boolean} whether or not dropdown was opened. This method will return false if, for example,
	         * the dropdown is already open, or if the 'open' event listener on the element called preventDefault().
	         */
	        // abstract
	        open: function () {
	
	            if (!this.shouldOpen()) return false;
	
	            this.opening();
	
	            // Only bind the document mousemove when the dropdown is visible
	            $document.on("mousemove.select2Event", function (e) {
	                lastMousePosition.x = e.pageX;
	                lastMousePosition.y = e.pageY;
	            });
	
	            return true;
	        },
	
	        /**
	         * Performs the opening of the dropdown
	         */
	        // abstract
	        opening: function () {
	            var cid = this.containerEventName,
	                scroll = "scroll." + cid,
	                resize = "resize." + cid,
	                orient = "orientationchange." + cid,
	                mask;
	
	            this.container.addClass("select2-dropdown-open").addClass("select2-container-active");
	
	            this.clearDropdownAlignmentPreference();
	
	            if (this.dropdown[0] !== this.body.children().last()[0]) {
	                this.dropdown.detach().appendTo(this.body);
	            }
	
	            // create the dropdown mask if doesn't already exist
	            mask = $("#select2-drop-mask");
	            if (mask.length == 0) {
	                mask = $(document.createElement("div"));
	                mask.attr("id", "select2-drop-mask").attr("class", "select2-drop-mask");
	                mask.hide();
	                mask.appendTo(this.body);
	                mask.on("mousedown touchstart click", function (e) {
	                    // Prevent IE from generating a click event on the body
	                    reinsertElement(mask);
	
	                    var dropdown = $("#select2-drop"),
	                        self;
	                    if (dropdown.length > 0) {
	                        self = dropdown.data("select2");
	                        if (self.opts.selectOnBlur) {
	                            self.selectHighlighted({ noFocus: true });
	                        }
	                        self.close();
	                        e.preventDefault();
	                        e.stopPropagation();
	                    }
	                });
	            }
	
	            // ensure the mask is always right before the dropdown
	            if (this.dropdown.prev()[0] !== mask[0]) {
	                this.dropdown.before(mask);
	            }
	
	            // move the global id to the correct dropdown
	            $("#select2-drop").removeAttr("id");
	            this.dropdown.attr("id", "select2-drop");
	
	            // show the elements
	            mask.show();
	
	            this.positionDropdown();
	            this.dropdown.show();
	            this.positionDropdown();
	
	            this.dropdown.addClass("select2-drop-active");
	
	            // attach listeners to events that can change the position of the container and thus require
	            // the position of the dropdown to be updated as well so it does not come unglued from the container
	            var that = this;
	            this.container.parents().add(window).each(function () {
	                $(this).on(resize + " " + scroll + " " + orient, function (e) {
	                    if (that.opened()) that.positionDropdown();
	                });
	            });
	        },
	
	        // abstract
	        close: function () {
	            if (!this.opened()) return;
	
	            var cid = this.containerEventName,
	                scroll = "scroll." + cid,
	                resize = "resize." + cid,
	                orient = "orientationchange." + cid;
	
	            // unbind event listeners
	            this.container.parents().add(window).each(function () {
	                $(this).off(scroll).off(resize).off(orient);
	            });
	
	            this.clearDropdownAlignmentPreference();
	
	            $("#select2-drop-mask").hide();
	            this.dropdown.removeAttr("id"); // only the active dropdown has the select2-drop id
	            this.dropdown.hide();
	            this.container.removeClass("select2-dropdown-open").removeClass("select2-container-active");
	            this.results.empty();
	
	            // Now that the dropdown is closed, unbind the global document mousemove event
	            $document.off("mousemove.select2Event");
	
	            this.clearSearch();
	            this.search.removeClass("select2-active");
	            this.opts.element.trigger($.Event("select2-close"));
	        },
	
	        /**
	         * Opens control, sets input value, and updates results.
	         */
	        // abstract
	        externalSearch: function (term) {
	            this.open();
	            this.search.val(term);
	            this.updateResults(false);
	        },
	
	        // abstract
	        clearSearch: function () {},
	
	        //abstract
	        getMaximumSelectionSize: function () {
	            return evaluate(this.opts.maximumSelectionSize, this.opts.element);
	        },
	
	        // abstract
	        ensureHighlightVisible: function () {
	            var results = this.results,
	                children,
	                index,
	                child,
	                hb,
	                rb,
	                y,
	                more,
	                topOffset;
	
	            index = this.highlight();
	
	            if (index < 0) return;
	
	            if (index == 0) {
	
	                // if the first element is highlighted scroll all the way to the top,
	                // that way any unselectable headers above it will also be scrolled
	                // into view
	
	                results.scrollTop(0);
	                return;
	            }
	
	            children = this.findHighlightableChoices().find('.select2-result-label');
	
	            child = $(children[index]);
	
	            topOffset = (child.offset() || {}).top || 0;
	
	            hb = topOffset + child.outerHeight(true);
	
	            // if this is the last child lets also make sure select2-more-results is visible
	            if (index === children.length - 1) {
	                more = results.find("li.select2-more-results");
	                if (more.length > 0) {
	                    hb = more.offset().top + more.outerHeight(true);
	                }
	            }
	
	            rb = results.offset().top + results.outerHeight(true);
	            if (hb > rb) {
	                results.scrollTop(results.scrollTop() + (hb - rb));
	            }
	            y = topOffset - results.offset().top;
	
	            // make sure the top of the element is visible
	            if (y < 0 && child.css('display') != 'none') {
	                results.scrollTop(results.scrollTop() + y); // y is negative
	            }
	        },
	
	        // abstract
	        findHighlightableChoices: function () {
	            return this.results.find(".select2-result-selectable:not(.select2-disabled):not(.select2-selected)");
	        },
	
	        // abstract
	        moveHighlight: function (delta) {
	            var choices = this.findHighlightableChoices(),
	                index = this.highlight();
	
	            while (index > -1 && index < choices.length) {
	                index += delta;
	                var choice = $(choices[index]);
	                if (choice.hasClass("select2-result-selectable") && !choice.hasClass("select2-disabled") && !choice.hasClass("select2-selected")) {
	                    this.highlight(index);
	                    break;
	                }
	            }
	        },
	
	        // abstract
	        highlight: function (index) {
	            var choices = this.findHighlightableChoices(),
	                choice,
	                data;
	
	            if (arguments.length === 0) {
	                return indexOf(choices.filter(".select2-highlighted")[0], choices.get());
	            }
	
	            if (index >= choices.length) index = choices.length - 1;
	            if (index < 0) index = 0;
	
	            this.removeHighlight();
	
	            choice = $(choices[index]);
	            choice.addClass("select2-highlighted");
	
	            // ensure assistive technology can determine the active choice
	            this.search.attr("aria-activedescendant", choice.find(".select2-result-label").attr("id"));
	
	            this.ensureHighlightVisible();
	
	            this.liveRegion.text(choice.text());
	
	            data = choice.data("select2-data");
	            if (data) {
	                this.opts.element.trigger({ type: "select2-highlight", val: this.id(data), choice: data });
	            }
	        },
	
	        removeHighlight: function () {
	            this.results.find(".select2-highlighted").removeClass("select2-highlighted");
	        },
	
	        touchMoved: function () {
	            this._touchMoved = true;
	        },
	
	        clearTouchMoved: function () {
	            this._touchMoved = false;
	        },
	
	        // abstract
	        countSelectableResults: function () {
	            return this.findHighlightableChoices().length;
	        },
	
	        // abstract
	        highlightUnderEvent: function (event) {
	            var el = $(event.target).closest(".select2-result-selectable");
	            if (el.length > 0 && !el.is(".select2-highlighted")) {
	                var choices = this.findHighlightableChoices();
	                this.highlight(choices.index(el));
	            } else if (el.length == 0) {
	                // if we are over an unselectable item remove all highlights
	                this.removeHighlight();
	            }
	        },
	
	        // abstract
	        loadMoreIfNeeded: function () {
	            var results = this.results,
	                more = results.find("li.select2-more-results"),
	                below,
	                // pixels the element is below the scroll fold, below==0 is when the element is starting to be visible
	            page = this.resultsPage + 1,
	                self = this,
	                term = this.search.val(),
	                context = this.context;
	
	            if (more.length === 0) return;
	            below = more.offset().top - results.offset().top - results.height();
	
	            if (below <= this.opts.loadMorePadding) {
	                more.addClass("select2-active");
	                this.opts.query({
	                    element: this.opts.element,
	                    term: term,
	                    page: page,
	                    context: context,
	                    matcher: this.opts.matcher,
	                    callback: this.bind(function (data) {
	
	                        // ignore a response if the select2 has been closed before it was received
	                        if (!self.opened()) return;
	
	                        self.opts.populateResults.call(this, results, data.results, { term: term, page: page, context: context });
	                        self.postprocessResults(data, false, false);
	
	                        if (data.more === true) {
	                            more.detach().appendTo(results).text(evaluate(self.opts.formatLoadMore, self.opts.element, page + 1));
	                            window.setTimeout(function () {
	                                self.loadMoreIfNeeded();
	                            }, 10);
	                        } else {
	                            more.remove();
	                        }
	                        self.positionDropdown();
	                        self.resultsPage = page;
	                        self.context = data.context;
	                        this.opts.element.trigger({ type: "select2-loaded", items: data });
	                    }) });
	            }
	        },
	
	        /**
	         * Default tokenizer function which does nothing
	         */
	        tokenize: function () {},
	
	        /**
	         * @param initial whether or not this is the call to this method right after the dropdown has been opened
	         */
	        // abstract
	        updateResults: function (initial) {
	            var search = this.search,
	                results = this.results,
	                opts = this.opts,
	                data,
	                self = this,
	                input,
	                term = search.val(),
	                lastTerm = $.data(this.container, "select2-last-term"),
	
	            // sequence number used to drop out-of-order responses
	            queryNumber;
	
	            // prevent duplicate queries against the same term
	            if (initial !== true && lastTerm && equal(term, lastTerm)) return;
	
	            $.data(this.container, "select2-last-term", term);
	
	            // if the search is currently hidden we do not alter the results
	            if (initial !== true && (this.showSearchInput === false || !this.opened())) {
	                return;
	            }
	
	            function postRender() {
	                search.removeClass("select2-active");
	                self.positionDropdown();
	                if (results.find('.select2-no-results,.select2-selection-limit,.select2-searching').length) {
	                    self.liveRegion.text(results.text());
	                } else {
	                    self.liveRegion.text(self.opts.formatMatches(results.find('.select2-result-selectable').length));
	                }
	            }
	
	            function render(html) {
	                results.html(html);
	                postRender();
	            }
	
	            queryNumber = ++this.queryCount;
	
	            var maxSelSize = this.getMaximumSelectionSize();
	            if (maxSelSize >= 1) {
	                data = this.data();
	                if ($.isArray(data) && data.length >= maxSelSize && checkFormatter(opts.formatSelectionTooBig, "formatSelectionTooBig")) {
	                    render("<li class='select2-selection-limit'>" + evaluate(opts.formatSelectionTooBig, opts.element, maxSelSize) + "</li>");
	                    return;
	                }
	            }
	
	            if (search.val().length < opts.minimumInputLength) {
	                if (checkFormatter(opts.formatInputTooShort, "formatInputTooShort")) {
	                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooShort, opts.element, search.val(), opts.minimumInputLength) + "</li>");
	                } else {
	                    render("");
	                }
	                if (initial && this.showSearch) this.showSearch(true);
	                return;
	            }
	
	            if (opts.maximumInputLength && search.val().length > opts.maximumInputLength) {
	                if (checkFormatter(opts.formatInputTooLong, "formatInputTooLong")) {
	                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooLong, opts.element, search.val(), opts.maximumInputLength) + "</li>");
	                } else {
	                    render("");
	                }
	                return;
	            }
	
	            if (opts.formatSearching && this.findHighlightableChoices().length === 0) {
	                render("<li class='select2-searching'>" + evaluate(opts.formatSearching, opts.element) + "</li>");
	            }
	
	            search.addClass("select2-active");
	
	            this.removeHighlight();
	
	            // give the tokenizer a chance to pre-process the input
	            input = this.tokenize();
	            if (input != undefined && input != null) {
	                search.val(input);
	            }
	
	            this.resultsPage = 1;
	
	            opts.query({
	                element: opts.element,
	                term: search.val(),
	                page: this.resultsPage,
	                context: null,
	                matcher: opts.matcher,
	                callback: this.bind(function (data) {
	                    var def; // default choice
	
	                    // ignore old responses
	                    if (queryNumber != this.queryCount) {
	                        return;
	                    }
	
	                    // ignore a response if the select2 has been closed before it was received
	                    if (!this.opened()) {
	                        this.search.removeClass("select2-active");
	                        return;
	                    }
	
	                    // handle ajax error
	                    if (data.hasError !== undefined && checkFormatter(opts.formatAjaxError, "formatAjaxError")) {
	                        render("<li class='select2-ajax-error'>" + evaluate(opts.formatAjaxError, opts.element, data.jqXHR, data.textStatus, data.errorThrown) + "</li>");
	                        return;
	                    }
	
	                    // save context, if any
	                    this.context = data.context === undefined ? null : data.context;
	                    // create a default choice and prepend it to the list
	                    if (this.opts.createSearchChoice && search.val() !== "") {
	                        def = this.opts.createSearchChoice.call(self, search.val(), data.results);
	                        if (def !== undefined && def !== null && self.id(def) !== undefined && self.id(def) !== null) {
	                            if ($(data.results).filter(function () {
	                                return equal(self.id(this), self.id(def));
	                            }).length === 0) {
	                                this.opts.createSearchChoicePosition(data.results, def);
	                            }
	                        }
	                    }
	
	                    if (data.results.length === 0 && checkFormatter(opts.formatNoMatches, "formatNoMatches")) {
	                        render("<li class='select2-no-results'>" + evaluate(opts.formatNoMatches, opts.element, search.val()) + "</li>");
	                        return;
	                    }
	
	                    results.empty();
	                    self.opts.populateResults.call(this, results, data.results, { term: search.val(), page: this.resultsPage, context: null });
	
	                    if (data.more === true && checkFormatter(opts.formatLoadMore, "formatLoadMore")) {
	                        results.append("<li class='select2-more-results'>" + opts.escapeMarkup(evaluate(opts.formatLoadMore, opts.element, this.resultsPage)) + "</li>");
	                        window.setTimeout(function () {
	                            self.loadMoreIfNeeded();
	                        }, 10);
	                    }
	
	                    this.postprocessResults(data, initial);
	
	                    postRender();
	
	                    this.opts.element.trigger({ type: "select2-loaded", items: data });
	                }) });
	        },
	
	        // abstract
	        cancel: function () {
	            this.close();
	        },
	
	        // abstract
	        blur: function () {
	            // if selectOnBlur == true, select the currently highlighted option
	            if (this.opts.selectOnBlur) this.selectHighlighted({ noFocus: true });
	
	            this.close();
	            this.container.removeClass("select2-container-active");
	            // synonymous to .is(':focus'), which is available in jquery >= 1.6
	            if (this.search[0] === document.activeElement) {
	                this.search.blur();
	            }
	            this.clearSearch();
	            this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
	        },
	
	        // abstract
	        focusSearch: function () {
	            focus(this.search);
	        },
	
	        // abstract
	        selectHighlighted: function (options) {
	            if (this._touchMoved) {
	                this.clearTouchMoved();
	                return;
	            }
	            var index = this.highlight(),
	                highlighted = this.results.find(".select2-highlighted"),
	                data = highlighted.closest('.select2-result').data("select2-data");
	
	            if (data) {
	                this.highlight(index);
	                this.onSelect(data, options);
	            } else if (options && options.noFocus) {
	                this.close();
	            }
	        },
	
	        // abstract
	        getPlaceholder: function () {
	            var placeholderOption;
	            return this.opts.element.attr("placeholder") || this.opts.element.attr("data-placeholder") || // jquery 1.4 compat
	            this.opts.element.data("placeholder") || this.opts.placeholder || ((placeholderOption = this.getPlaceholderOption()) !== undefined ? placeholderOption.text() : undefined);
	        },
	
	        // abstract
	        getPlaceholderOption: function () {
	            if (this.select) {
	                var firstOption = this.select.children('option').first();
	                if (this.opts.placeholderOption !== undefined) {
	                    //Determine the placeholder option based on the specified placeholderOption setting
	                    return this.opts.placeholderOption === "first" && firstOption || typeof this.opts.placeholderOption === "function" && this.opts.placeholderOption(this.select);
	                } else if ($.trim(firstOption.text()) === "" && firstOption.val() === "") {
	                    //No explicit placeholder option specified, use the first if it's blank
	                    return firstOption;
	                }
	            }
	        },
	
	        /**
	         * Get the desired width for the container element.  This is
	         * derived first from option `width` passed to select2, then
	         * the inline 'style' on the original element, and finally
	         * falls back to the jQuery calculated element width.
	         */
	        // abstract
	        initContainerWidth: function () {
	            function resolveContainerWidth() {
	                var style, attrs, matches, i, l, attr;
	
	                if (this.opts.width === "off") {
	                    return null;
	                } else if (this.opts.width === "element") {
	                    return this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px';
	                } else if (this.opts.width === "copy" || this.opts.width === "resolve") {
	                    // check if there is inline style on the element that contains width
	                    style = this.opts.element.attr('style');
	                    if (style !== undefined) {
	                        attrs = style.split(';');
	                        for (i = 0, l = attrs.length; i < l; i = i + 1) {
	                            attr = attrs[i].replace(/\s/g, '');
	                            matches = attr.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i);
	                            if (matches !== null && matches.length >= 1) return matches[1];
	                        }
	                    }
	
	                    if (this.opts.width === "resolve") {
	                        // next check if css('width') can resolve a width that is percent based, this is sometimes possible
	                        // when attached to input type=hidden or elements hidden via css
	                        style = this.opts.element.css('width');
	                        if (style.indexOf("%") > 0) return style;
	
	                        // finally, fallback on the calculated width of the element
	                        return this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px';
	                    }
	
	                    return null;
	                } else if ($.isFunction(this.opts.width)) {
	                    return this.opts.width();
	                } else {
	                    return this.opts.width;
	                }
	            };
	
	            var width = resolveContainerWidth.call(this);
	            if (width !== null) {
	                this.container.css("width", width);
	            }
	        }
	    });
	
	    SingleSelect2 = clazz(AbstractSelect2, {
	
	        // single
	
	        createContainer: function () {
	            var container = $(document.createElement("div")).attr({
	                "class": "select2-container"
	            }).html(["<a href='javascript:void(0)' class='select2-choice' tabindex='-1'>", "   <span class='select2-chosen'>&#160;</span><abbr class='select2-search-choice-close'></abbr>", "   <span class='select2-arrow' role='presentation'><b role='presentation'></b></span>", "</a>", "<label for='' class='select2-offscreen'></label>", "<input class='select2-focusser select2-offscreen' type='text' aria-haspopup='true' role='button' />", "<div class='select2-drop select2-display-none'>", "   <div class='select2-search'>", "       <label for='' class='select2-offscreen'></label>", "       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input' role='combobox' aria-expanded='true'", "       aria-autocomplete='list' />", "   </div>", "   <ul class='select2-results' role='listbox'>", "   </ul>", "</div>"].join(""));
	            return container;
	        },
	
	        // single
	        enableInterface: function () {
	            if (this.parent.enableInterface.apply(this, arguments)) {
	                this.focusser.prop("disabled", !this.isInterfaceEnabled());
	            }
	        },
	
	        // single
	        opening: function () {
	            var el, range, len;
	
	            if (this.opts.minimumResultsForSearch >= 0) {
	                this.showSearch(true);
	            }
	
	            this.parent.opening.apply(this, arguments);
	
	            if (this.showSearchInput !== false) {
	                // IE appends focusser.val() at the end of field :/ so we manually insert it at the beginning using a range
	                // all other browsers handle this just fine
	
	                this.search.val(this.focusser.val());
	            }
	            if (this.opts.shouldFocusInput(this)) {
	                this.search.focus();
	                // move the cursor to the end after focussing, otherwise it will be at the beginning and
	                // new text will appear *before* focusser.val()
	                el = this.search.get(0);
	                if (el.createTextRange) {
	                    range = el.createTextRange();
	                    range.collapse(false);
	                    range.select();
	                } else if (el.setSelectionRange) {
	                    len = this.search.val().length;
	                    el.setSelectionRange(len, len);
	                }
	            }
	
	            // initializes search's value with nextSearchTerm (if defined by user)
	            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
	            if (this.search.val() === "") {
	                if (this.nextSearchTerm != undefined) {
	                    this.search.val(this.nextSearchTerm);
	                    this.search.select();
	                }
	            }
	
	            this.focusser.prop("disabled", true).val("");
	            this.updateResults(true);
	            this.opts.element.trigger($.Event("select2-open"));
	        },
	
	        // single
	        close: function () {
	            if (!this.opened()) return;
	            this.parent.close.apply(this, arguments);
	
	            this.focusser.prop("disabled", false);
	
	            if (this.opts.shouldFocusInput(this)) {
	                this.focusser.focus();
	            }
	        },
	
	        // single
	        focus: function () {
	            if (this.opened()) {
	                this.close();
	            } else {
	                this.focusser.prop("disabled", false);
	                if (this.opts.shouldFocusInput(this)) {
	                    this.focusser.focus();
	                }
	            }
	        },
	
	        // single
	        isFocused: function () {
	            return this.container.hasClass("select2-container-active");
	        },
	
	        // single
	        cancel: function () {
	            this.parent.cancel.apply(this, arguments);
	            this.focusser.prop("disabled", false);
	
	            if (this.opts.shouldFocusInput(this)) {
	                this.focusser.focus();
	            }
	        },
	
	        // single
	        destroy: function () {
	            $("label[for='" + this.focusser.attr('id') + "']").attr('for', this.opts.element.attr("id"));
	            this.parent.destroy.apply(this, arguments);
	
	            cleanupJQueryElements.call(this, "selection", "focusser");
	        },
	
	        // single
	        initContainer: function () {
	
	            var selection,
	                container = this.container,
	                dropdown = this.dropdown,
	                idSuffix = nextUid(),
	                elementLabel;
	
	            if (this.opts.minimumResultsForSearch < 0) {
	                this.showSearch(false);
	            } else {
	                this.showSearch(true);
	            }
	
	            this.selection = selection = container.find(".select2-choice");
	
	            this.focusser = container.find(".select2-focusser");
	
	            // add aria associations
	            selection.find(".select2-chosen").attr("id", "select2-chosen-" + idSuffix);
	            this.focusser.attr("aria-labelledby", "select2-chosen-" + idSuffix);
	            this.results.attr("id", "select2-results-" + idSuffix);
	            this.search.attr("aria-owns", "select2-results-" + idSuffix);
	
	            // rewrite labels from original element to focusser
	            this.focusser.attr("id", "s2id_autogen" + idSuffix);
	
	            elementLabel = $("label[for='" + this.opts.element.attr("id") + "']");
	
	            this.focusser.prev().text(elementLabel.text()).attr('for', this.focusser.attr('id'));
	
	            // Ensure the original element retains an accessible name
	            var originalTitle = this.opts.element.attr("title");
	            this.opts.element.attr("title", originalTitle || elementLabel.text());
	
	            this.focusser.attr("tabindex", this.elementTabIndex);
	
	            // write label for search field using the label from the focusser element
	            this.search.attr("id", this.focusser.attr('id') + '_search');
	
	            this.search.prev().text($("label[for='" + this.focusser.attr('id') + "']").text()).attr('for', this.search.attr('id'));
	
	            this.search.on("keydown", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	
	                // filter 229 keyCodes (input method editor is processing key input)
	                if (229 == e.keyCode) return;
	
	                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
	                    // prevent the page from scrolling
	                    killEvent(e);
	                    return;
	                }
	
	                switch (e.which) {
	                    case KEY.UP:
	                    case KEY.DOWN:
	                        this.moveHighlight(e.which === KEY.UP ? -1 : 1);
	                        killEvent(e);
	                        return;
	                    case KEY.ENTER:
	                        this.selectHighlighted();
	                        killEvent(e);
	                        return;
	                    case KEY.TAB:
	                        this.selectHighlighted({ noFocus: true });
	                        return;
	                    case KEY.ESC:
	                        this.cancel(e);
	                        killEvent(e);
	                        return;
	                }
	            }));
	
	            this.search.on("blur", this.bind(function (e) {
	                // a workaround for chrome to keep the search field focussed when the scroll bar is used to scroll the dropdown.
	                // without this the search field loses focus which is annoying
	                if (document.activeElement === this.body.get(0)) {
	                    window.setTimeout(this.bind(function () {
	                        if (this.opened()) {
	                            this.search.focus();
	                        }
	                    }), 0);
	                }
	            }));
	
	            this.focusser.on("keydown", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	
	                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	                    return;
	                }
	
	                if (this.opts.openOnEnter === false && e.which === KEY.ENTER) {
	                    killEvent(e);
	                    return;
	                }
	
	                if (e.which == KEY.DOWN || e.which == KEY.UP || e.which == KEY.ENTER && this.opts.openOnEnter) {
	
	                    if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) return;
	
	                    this.open();
	                    killEvent(e);
	                    return;
	                }
	
	                if (e.which == KEY.DELETE || e.which == KEY.BACKSPACE) {
	                    if (this.opts.allowClear) {
	                        this.clear();
	                    }
	                    killEvent(e);
	                    return;
	                }
	            }));
	
	            installKeyUpChangeEvent(this.focusser);
	            this.focusser.on("keyup-change input", this.bind(function (e) {
	                if (this.opts.minimumResultsForSearch >= 0) {
	                    e.stopPropagation();
	                    if (this.opened()) return;
	                    this.open();
	                }
	            }));
	
	            selection.on("mousedown touchstart", "abbr", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	                this.clear();
	                killEventImmediately(e);
	                this.close();
	                this.selection.focus();
	            }));
	
	            selection.on("mousedown touchstart", this.bind(function (e) {
	                // Prevent IE from generating a click event on the body
	                reinsertElement(selection);
	
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	
	                if (this.opened()) {
	                    this.close();
	                } else if (this.isInterfaceEnabled()) {
	                    this.open();
	                }
	
	                killEvent(e);
	            }));
	
	            dropdown.on("mousedown touchstart", this.bind(function () {
	                if (this.opts.shouldFocusInput(this)) {
	                    this.search.focus();
	                }
	            }));
	
	            selection.on("focus", this.bind(function (e) {
	                killEvent(e);
	            }));
	
	            this.focusser.on("focus", this.bind(function () {
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.container.addClass("select2-container-active");
	            })).on("blur", this.bind(function () {
	                if (!this.opened()) {
	                    this.container.removeClass("select2-container-active");
	                    this.opts.element.trigger($.Event("select2-blur"));
	                }
	            }));
	            this.search.on("focus", this.bind(function () {
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.container.addClass("select2-container-active");
	            }));
	
	            this.initContainerWidth();
	            this.opts.element.addClass("select2-offscreen");
	            this.setPlaceholder();
	        },
	
	        // single
	        clear: function (triggerChange) {
	            var data = this.selection.data("select2-data");
	            if (data) {
	                // guard against queued quick consecutive clicks
	                var evt = $.Event("select2-clearing");
	                this.opts.element.trigger(evt);
	                if (evt.isDefaultPrevented()) {
	                    return;
	                }
	                var placeholderOption = this.getPlaceholderOption();
	                this.opts.element.val(placeholderOption ? placeholderOption.val() : "");
	                this.selection.find(".select2-chosen").empty();
	                this.selection.removeData("select2-data");
	                this.setPlaceholder();
	
	                if (triggerChange !== false) {
	                    this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
	                    this.triggerChange({ removed: data });
	                }
	            }
	        },
	
	        /**
	         * Sets selection based on source element's value
	         */
	        // single
	        initSelection: function () {
	            var selected;
	            if (this.isPlaceholderOptionSelected()) {
	                this.updateSelection(null);
	                this.close();
	                this.setPlaceholder();
	            } else {
	                var self = this;
	                this.opts.initSelection.call(null, this.opts.element, function (selected) {
	                    if (selected !== undefined && selected !== null) {
	                        self.updateSelection(selected);
	                        self.close();
	                        self.setPlaceholder();
	                        self.nextSearchTerm = self.opts.nextSearchTerm(selected, self.search.val());
	                    }
	                });
	            }
	        },
	
	        isPlaceholderOptionSelected: function () {
	            var placeholderOption;
	            if (this.getPlaceholder() === undefined) return false; // no placeholder specified so no option should be considered
	            return (placeholderOption = this.getPlaceholderOption()) !== undefined && placeholderOption.prop("selected") || this.opts.element.val() === "" || this.opts.element.val() === undefined || this.opts.element.val() === null;
	        },
	
	        // single
	        prepareOpts: function () {
	            var opts = this.parent.prepareOpts.apply(this, arguments),
	                self = this;
	
	            if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                // install the selection initializer
	                opts.initSelection = function (element, callback) {
	                    var selected = element.find("option").filter(function () {
	                        return this.selected && !this.disabled;
	                    });
	                    // a single select box always has a value, no need to null check 'selected'
	                    callback(self.optionToData(selected));
	                };
	            } else if ("data" in opts) {
	                // install default initSelection when applied to hidden input and data is local
	                opts.initSelection = opts.initSelection || function (element, callback) {
	                    var id = element.val();
	                    //search in data by id, storing the actual matching item
	                    var match = null;
	                    opts.query({
	                        matcher: function (term, text, el) {
	                            var is_match = equal(id, opts.id(el));
	                            if (is_match) {
	                                match = el;
	                            }
	                            return is_match;
	                        },
	                        callback: !$.isFunction(callback) ? $.noop : function () {
	                            callback(match);
	                        }
	                    });
	                };
	            }
	
	            return opts;
	        },
	
	        // single
	        getPlaceholder: function () {
	            // if a placeholder is specified on a single select without a valid placeholder option ignore it
	            if (this.select) {
	                if (this.getPlaceholderOption() === undefined) {
	                    return undefined;
	                }
	            }
	
	            return this.parent.getPlaceholder.apply(this, arguments);
	        },
	
	        // single
	        setPlaceholder: function () {
	            var placeholder = this.getPlaceholder();
	
	            if (this.isPlaceholderOptionSelected() && placeholder !== undefined) {
	
	                // check for a placeholder option if attached to a select
	                if (this.select && this.getPlaceholderOption() === undefined) return;
	
	                this.selection.find(".select2-chosen").html(this.opts.escapeMarkup(placeholder));
	
	                this.selection.addClass("select2-default");
	
	                this.container.removeClass("select2-allowclear");
	            }
	        },
	
	        // single
	        postprocessResults: function (data, initial, noHighlightUpdate) {
	            var selected = 0,
	                self = this,
	                showSearchInput = true;
	
	            // find the selected element in the result list
	
	            this.findHighlightableChoices().each2(function (i, elm) {
	                if (equal(self.id(elm.data("select2-data")), self.opts.element.val())) {
	                    selected = i;
	                    return false;
	                }
	            });
	
	            // and highlight it
	            if (noHighlightUpdate !== false) {
	                if (initial === true && selected >= 0) {
	                    this.highlight(selected);
	                } else {
	                    this.highlight(0);
	                }
	            }
	
	            // hide the search box if this is the first we got the results and there are enough of them for search
	
	            if (initial === true) {
	                var min = this.opts.minimumResultsForSearch;
	                if (min >= 0) {
	                    this.showSearch(countResults(data.results) >= min);
	                }
	            }
	        },
	
	        // single
	        showSearch: function (showSearchInput) {
	            if (this.showSearchInput === showSearchInput) return;
	
	            this.showSearchInput = showSearchInput;
	
	            this.dropdown.find(".select2-search").toggleClass("select2-search-hidden", !showSearchInput);
	            this.dropdown.find(".select2-search").toggleClass("select2-offscreen", !showSearchInput);
	            //add "select2-with-searchbox" to the container if search box is shown
	            $(this.dropdown, this.container).toggleClass("select2-with-searchbox", showSearchInput);
	        },
	
	        // single
	        onSelect: function (data, options) {
	
	            if (!this.triggerSelect(data)) {
	                return;
	            }
	
	            var old = this.opts.element.val(),
	                oldData = this.data();
	
	            this.opts.element.val(this.id(data));
	            this.updateSelection(data);
	
	            this.opts.element.trigger({ type: "select2-selected", val: this.id(data), choice: data });
	
	            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());
	            this.close();
	
	            if ((!options || !options.noFocus) && this.opts.shouldFocusInput(this)) {
	                this.focusser.focus();
	            }
	
	            if (!equal(old, this.id(data))) {
	                this.triggerChange({ added: data, removed: oldData });
	            }
	        },
	
	        // single
	        updateSelection: function (data) {
	
	            var container = this.selection.find(".select2-chosen"),
	                formatted,
	                cssClass;
	
	            this.selection.data("select2-data", data);
	
	            container.empty();
	            if (data !== null) {
	                formatted = this.opts.formatSelection(data, container, this.opts.escapeMarkup);
	            }
	            if (formatted !== undefined) {
	                container.append(formatted);
	            }
	            cssClass = this.opts.formatSelectionCssClass(data, container);
	            if (cssClass !== undefined) {
	                container.addClass(cssClass);
	            }
	
	            this.selection.removeClass("select2-default");
	
	            if (this.opts.allowClear && this.getPlaceholder() !== undefined) {
	                this.container.addClass("select2-allowclear");
	            }
	        },
	
	        // single
	        val: function () {
	            var val,
	                triggerChange = false,
	                data = null,
	                self = this,
	                oldData = this.data();
	
	            if (arguments.length === 0) {
	                return this.opts.element.val();
	            }
	
	            val = arguments[0];
	
	            if (arguments.length > 1) {
	                triggerChange = arguments[1];
	            }
	
	            if (this.select) {
	                this.select.val(val).find("option").filter(function () {
	                    return this.selected;
	                }).each2(function (i, elm) {
	                    data = self.optionToData(elm);
	                    return false;
	                });
	                this.updateSelection(data);
	                this.setPlaceholder();
	                if (triggerChange) {
	                    this.triggerChange({ added: data, removed: oldData });
	                }
	            } else {
	                // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
	                if (!val && val !== 0) {
	                    this.clear(triggerChange);
	                    return;
	                }
	                if (this.opts.initSelection === undefined) {
	                    throw new Error("cannot call val() if initSelection() is not defined");
	                }
	                this.opts.element.val(val);
	                this.opts.initSelection(this.opts.element, function (data) {
	                    self.opts.element.val(!data ? "" : self.id(data));
	                    self.updateSelection(data);
	                    self.setPlaceholder();
	                    if (triggerChange) {
	                        self.triggerChange({ added: data, removed: oldData });
	                    }
	                });
	            }
	        },
	
	        // single
	        clearSearch: function () {
	            this.search.val("");
	            this.focusser.val("");
	        },
	
	        // single
	        data: function (value) {
	            var data,
	                triggerChange = false;
	
	            if (arguments.length === 0) {
	                data = this.selection.data("select2-data");
	                if (data == undefined) data = null;
	                return data;
	            } else {
	                if (arguments.length > 1) {
	                    triggerChange = arguments[1];
	                }
	                if (!value) {
	                    this.clear(triggerChange);
	                } else {
	                    data = this.data();
	                    this.opts.element.val(!value ? "" : this.id(value));
	                    this.updateSelection(value);
	                    if (triggerChange) {
	                        this.triggerChange({ added: value, removed: data });
	                    }
	                }
	            }
	        }
	    });
	
	    MultiSelect2 = clazz(AbstractSelect2, {
	
	        // multi
	        createContainer: function () {
	            var container = $(document.createElement("div")).attr({
	                "class": "select2-container select2-container-multi"
	            }).html(["<ul class='select2-choices'>", "  <li class='select2-search-field'>", "    <label for='' class='select2-offscreen'></label>", "    <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'>", "  </li>", "</ul>", "<div class='select2-drop select2-drop-multi select2-display-none'>", "   <ul class='select2-results'>", "   </ul>", "</div>"].join(""));
	            return container;
	        },
	
	        // multi
	        prepareOpts: function () {
	            var opts = this.parent.prepareOpts.apply(this, arguments),
	                self = this;
	
	            // TODO validate placeholder is a string if specified
	
	            if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                // install the selection initializer
	                opts.initSelection = function (element, callback) {
	
	                    var data = [];
	
	                    element.find("option").filter(function () {
	                        return this.selected && !this.disabled;
	                    }).each2(function (i, elm) {
	                        data.push(self.optionToData(elm));
	                    });
	                    callback(data);
	                };
	            } else if ("data" in opts) {
	                // install default initSelection when applied to hidden input and data is local
	                opts.initSelection = opts.initSelection || function (element, callback) {
	                    var ids = splitVal(element.val(), opts.separator);
	                    //search in data by array of ids, storing matching items in a list
	                    var matches = [];
	                    opts.query({
	                        matcher: function (term, text, el) {
	                            var is_match = $.grep(ids, function (id) {
	                                return equal(id, opts.id(el));
	                            }).length;
	                            if (is_match) {
	                                matches.push(el);
	                            }
	                            return is_match;
	                        },
	                        callback: !$.isFunction(callback) ? $.noop : function () {
	                            // reorder matches based on the order they appear in the ids array because right now
	                            // they are in the order in which they appear in data array
	                            var ordered = [];
	                            for (var i = 0; i < ids.length; i++) {
	                                var id = ids[i];
	                                for (var j = 0; j < matches.length; j++) {
	                                    var match = matches[j];
	                                    if (equal(id, opts.id(match))) {
	                                        ordered.push(match);
	                                        matches.splice(j, 1);
	                                        break;
	                                    }
	                                }
	                            }
	                            callback(ordered);
	                        }
	                    });
	                };
	            }
	
	            return opts;
	        },
	
	        // multi
	        selectChoice: function (choice) {
	
	            var selected = this.container.find(".select2-search-choice-focus");
	            if (selected.length && choice && choice[0] == selected[0]) {} else {
	                if (selected.length) {
	                    this.opts.element.trigger("choice-deselected", selected);
	                }
	                selected.removeClass("select2-search-choice-focus");
	                if (choice && choice.length) {
	                    this.close();
	                    choice.addClass("select2-search-choice-focus");
	                    this.opts.element.trigger("choice-selected", choice);
	                }
	            }
	        },
	
	        // multi
	        destroy: function () {
	            $("label[for='" + this.search.attr('id') + "']").attr('for', this.opts.element.attr("id"));
	            this.parent.destroy.apply(this, arguments);
	
	            cleanupJQueryElements.call(this, "searchContainer", "selection");
	        },
	
	        // multi
	        initContainer: function () {
	
	            var selector = ".select2-choices",
	                selection;
	
	            this.searchContainer = this.container.find(".select2-search-field");
	            this.selection = selection = this.container.find(selector);
	
	            var _this = this;
	            this.selection.on("click", ".select2-search-choice:not(.select2-locked)", function (e) {
	                //killEvent(e);
	                _this.search[0].focus();
	                _this.selectChoice($(this));
	            });
	
	            // rewrite labels from original element to focusser
	            this.search.attr("id", "s2id_autogen" + nextUid());
	
	            this.search.prev().text($("label[for='" + this.opts.element.attr("id") + "']").text()).attr('for', this.search.attr('id'));
	
	            this.search.on("input paste", this.bind(function () {
	                if (this.search.attr('placeholder') && this.search.val().length == 0) return;
	                if (!this.isInterfaceEnabled()) return;
	                if (!this.opened()) {
	                    this.open();
	                }
	            }));
	
	            this.search.attr("tabindex", this.elementTabIndex);
	
	            this.keydowns = 0;
	            this.search.on("keydown", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	
	                ++this.keydowns;
	                var selected = selection.find(".select2-search-choice-focus");
	                var prev = selected.prev(".select2-search-choice:not(.select2-locked)");
	                var next = selected.next(".select2-search-choice:not(.select2-locked)");
	                var pos = getCursorInfo(this.search);
	
	                if (selected.length && (e.which == KEY.LEFT || e.which == KEY.RIGHT || e.which == KEY.BACKSPACE || e.which == KEY.DELETE || e.which == KEY.ENTER)) {
	                    var selectedChoice = selected;
	                    if (e.which == KEY.LEFT && prev.length) {
	                        selectedChoice = prev;
	                    } else if (e.which == KEY.RIGHT) {
	                        selectedChoice = next.length ? next : null;
	                    } else if (e.which === KEY.BACKSPACE) {
	                        if (this.unselect(selected.first())) {
	                            this.search.width(10);
	                            selectedChoice = prev.length ? prev : next;
	                        }
	                    } else if (e.which == KEY.DELETE) {
	                        if (this.unselect(selected.first())) {
	                            this.search.width(10);
	                            selectedChoice = next.length ? next : null;
	                        }
	                    } else if (e.which == KEY.ENTER) {
	                        selectedChoice = null;
	                    }
	
	                    this.selectChoice(selectedChoice);
	                    killEvent(e);
	                    if (!selectedChoice || !selectedChoice.length) {
	                        this.open();
	                    }
	                    return;
	                } else if ((e.which === KEY.BACKSPACE && this.keydowns == 1 || e.which == KEY.LEFT) && pos.offset == 0 && !pos.length) {
	
	                    this.selectChoice(selection.find(".select2-search-choice:not(.select2-locked)").last());
	                    killEvent(e);
	                    return;
	                } else {
	                    this.selectChoice(null);
	                }
	
	                if (this.opened()) {
	                    switch (e.which) {
	                        case KEY.UP:
	                        case KEY.DOWN:
	                            this.moveHighlight(e.which === KEY.UP ? -1 : 1);
	                            killEvent(e);
	                            return;
	                        case KEY.ENTER:
	                            this.selectHighlighted();
	                            killEvent(e);
	                            return;
	                        case KEY.TAB:
	                            this.selectHighlighted({ noFocus: true });
	                            this.close();
	                            return;
	                        case KEY.ESC:
	                            this.cancel(e);
	                            killEvent(e);
	                            return;
	                    }
	                }
	
	                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.BACKSPACE || e.which === KEY.ESC) {
	                    return;
	                }
	
	                if (e.which === KEY.ENTER) {
	                    if (this.opts.openOnEnter === false) {
	                        return;
	                    } else if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
	                        return;
	                    }
	                }
	
	                this.open();
	
	                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
	                    // prevent the page from scrolling
	                    killEvent(e);
	                }
	
	                if (e.which === KEY.ENTER) {
	                    // prevent form from being submitted
	                    killEvent(e);
	                }
	            }));
	
	            this.search.on("keyup", this.bind(function (e) {
	                this.keydowns = 0;
	                this.resizeSearch();
	            }));
	
	            this.search.on("blur", this.bind(function (e) {
	                this.container.removeClass("select2-container-active");
	                this.search.removeClass("select2-focused");
	                this.selectChoice(null);
	                if (!this.opened()) this.clearSearch();
	                e.stopImmediatePropagation();
	                this.opts.element.trigger($.Event("select2-blur"));
	            }));
	
	            this.container.on("click", selector, this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	                if ($(e.target).closest(".select2-search-choice").length > 0) {
	                    // clicked inside a select2 search choice, do not open
	                    return;
	                }
	                this.selectChoice(null);
	                this.clearPlaceholder();
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.open();
	                this.focusSearch();
	                e.preventDefault();
	            }));
	
	            this.container.on("focus", selector, this.bind(function () {
	                if (!this.isInterfaceEnabled()) return;
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.container.addClass("select2-container-active");
	                this.dropdown.addClass("select2-drop-active");
	                this.clearPlaceholder();
	            }));
	
	            this.initContainerWidth();
	            this.opts.element.addClass("select2-offscreen");
	
	            // set the placeholder if necessary
	            this.clearSearch();
	        },
	
	        // multi
	        enableInterface: function () {
	            if (this.parent.enableInterface.apply(this, arguments)) {
	                this.search.prop("disabled", !this.isInterfaceEnabled());
	            }
	        },
	
	        // multi
	        initSelection: function () {
	            var data;
	            if (this.opts.element.val() === "" && this.opts.element.text() === "") {
	                this.updateSelection([]);
	                this.close();
	                // set the placeholder if necessary
	                this.clearSearch();
	            }
	            if (this.select || this.opts.element.val() !== "") {
	                var self = this;
	                this.opts.initSelection.call(null, this.opts.element, function (data) {
	                    if (data !== undefined && data !== null) {
	                        self.updateSelection(data);
	                        self.close();
	                        // set the placeholder if necessary
	                        self.clearSearch();
	                    }
	                });
	            }
	        },
	
	        // multi
	        clearSearch: function () {
	            var placeholder = this.getPlaceholder(),
	                maxWidth = this.getMaxSearchWidth();
	
	            if (placeholder !== undefined && this.getVal().length === 0 && this.search.hasClass("select2-focused") === false) {
	                this.search.val(placeholder).addClass("select2-default");
	                // stretch the search box to full width of the container so as much of the placeholder is visible as possible
	                // we could call this.resizeSearch(), but we do not because that requires a sizer and we do not want to create one so early because of a firefox bug, see #944
	                this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
	            } else {
	                this.search.val("").width(10);
	            }
	        },
	
	        // multi
	        clearPlaceholder: function () {
	            if (this.search.hasClass("select2-default")) {
	                this.search.val("").removeClass("select2-default");
	            }
	        },
	
	        // multi
	        opening: function () {
	            this.clearPlaceholder(); // should be done before super so placeholder is not used to search
	            this.resizeSearch();
	
	            this.parent.opening.apply(this, arguments);
	
	            this.focusSearch();
	
	            // initializes search's value with nextSearchTerm (if defined by user)
	            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
	            if (this.search.val() === "") {
	                if (this.nextSearchTerm != undefined) {
	                    this.search.val(this.nextSearchTerm);
	                    this.search.select();
	                }
	            }
	
	            this.updateResults(true);
	            if (this.opts.shouldFocusInput(this)) {
	                this.search.focus();
	            }
	            this.opts.element.trigger($.Event("select2-open"));
	        },
	
	        // multi
	        close: function () {
	            if (!this.opened()) return;
	            this.parent.close.apply(this, arguments);
	        },
	
	        // multi
	        focus: function () {
	            this.close();
	            this.search.focus();
	        },
	
	        // multi
	        isFocused: function () {
	            return this.search.hasClass("select2-focused");
	        },
	
	        // multi
	        updateSelection: function (data) {
	            var ids = [],
	                filtered = [],
	                self = this;
	
	            // filter out duplicates
	            $(data).each(function () {
	                if (indexOf(self.id(this), ids) < 0) {
	                    ids.push(self.id(this));
	                    filtered.push(this);
	                }
	            });
	            data = filtered;
	
	            this.selection.find(".select2-search-choice").remove();
	            $(data).each(function () {
	                self.addSelectedChoice(this);
	            });
	            self.postprocessResults();
	        },
	
	        // multi
	        tokenize: function () {
	            var input = this.search.val();
	            input = this.opts.tokenizer.call(this, input, this.data(), this.bind(this.onSelect), this.opts);
	            if (input != null && input != undefined) {
	                this.search.val(input);
	                if (input.length > 0) {
	                    this.open();
	                }
	            }
	        },
	
	        // multi
	        onSelect: function (data, options) {
	
	            if (!this.triggerSelect(data) || data.text === "") {
	                return;
	            }
	
	            this.addSelectedChoice(data);
	
	            this.opts.element.trigger({ type: "selected", val: this.id(data), choice: data });
	
	            // keep track of the search's value before it gets cleared
	            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());
	            this.moveHighlight(1);
	            if (this.select || !this.opts.closeOnSelect) this.postprocessResults(data, false, this.opts.closeOnSelect === true);
	
	            if (this.opts.closeOnSelect) {
	                this.clearSearch();
	                this.updateResults();
	                this.close();
	                this.search.width(10);
	            } else {
	                if (this.countSelectableResults() > 0) {
	                    this.search.width(10);
	                    this.resizeSearch();
	                    if (this.getMaximumSelectionSize() > 0 && this.val().length >= this.getMaximumSelectionSize()) {
	                        // if we reached max selection size repaint the results so choices
	                        // are replaced with the max selection reached message
	                        this.updateResults(true);
	                    } else {
	                        // initializes search's value with nextSearchTerm and update search result
	                        if (this.nextSearchTerm != undefined) {
	                            this.search.val(this.nextSearchTerm);
	                            this.updateResults();
	                            this.search.select();
	                        }
	                    }
	                    this.positionDropdown();
	                } else {
	                    // if nothing left to select close
	                    this.close();
	                    this.search.width(10);
	                }
	            }
	
	            // since its not possible to select an element that has already been
	            // added we do not need to check if this is a new element before firing change
	            this.triggerChange({ added: data });
	
	            if (!options || !options.noFocus) this.focusSearch();
	        },
	
	        // multi
	        cancel: function () {
	            this.close();
	            this.focusSearch();
	        },
	
	        addSelectedChoice: function (data) {
	            var enableChoice = !data.locked,
	                enabledItem = $("<li class='select2-search-choice'>" + "    <div></div>" + "    <a href='#' class='select2-search-choice-close' tabindex='-1'></a>" + "</li>"),
	                disabledItem = $("<li class='select2-search-choice select2-locked'>" + "<div></div>" + "</li>");
	            var choice = enableChoice ? enabledItem : disabledItem,
	                id = this.id(data),
	                val = this.getVal(),
	                formatted,
	                cssClass;
	
	            formatted = this.opts.formatSelection(data, choice.find("div"), this.opts.escapeMarkup);
	            if (formatted != undefined) {
	                choice.find("div").replaceWith("<div>" + formatted + "</div>");
	            }
	            cssClass = this.opts.formatSelectionCssClass(data, choice.find("div"));
	            if (cssClass != undefined) {
	                choice.addClass(cssClass);
	            }
	
	            if (enableChoice) {
	                choice.find(".select2-search-choice-close").on("mousedown", killEvent).on("click dblclick", this.bind(function (e) {
	                    if (!this.isInterfaceEnabled()) return;
	
	                    this.unselect($(e.target));
	                    this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
	                    killEvent(e);
	                    this.close();
	                    this.focusSearch();
	                })).on("focus", this.bind(function () {
	                    if (!this.isInterfaceEnabled()) return;
	                    this.container.addClass("select2-container-active");
	                    this.dropdown.addClass("select2-drop-active");
	                }));
	            }
	
	            choice.data("select2-data", data);
	            choice.insertBefore(this.searchContainer);
	
	            val.push(id);
	            this.setVal(val);
	        },
	
	        // multi
	        unselect: function (selected) {
	            var val = this.getVal(),
	                data,
	                index;
	            selected = selected.closest(".select2-search-choice");
	
	            if (selected.length === 0) {
	                throw "Invalid argument: " + selected + ". Must be .select2-search-choice";
	            }
	
	            data = selected.data("select2-data");
	
	            if (!data) {
	                // prevent a race condition when the 'x' is clicked really fast repeatedly the event can be queued
	                // and invoked on an element already removed
	                return;
	            }
	
	            var evt = $.Event("select2-removing");
	            evt.val = this.id(data);
	            evt.choice = data;
	            this.opts.element.trigger(evt);
	
	            if (evt.isDefaultPrevented()) {
	                return false;
	            }
	
	            while ((index = indexOf(this.id(data), val)) >= 0) {
	                val.splice(index, 1);
	                this.setVal(val);
	                if (this.select) this.postprocessResults();
	            }
	
	            selected.remove();
	
	            this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
	            this.triggerChange({ removed: data });
	
	            return true;
	        },
	
	        // multi
	        postprocessResults: function (data, initial, noHighlightUpdate) {
	            var val = this.getVal(),
	                choices = this.results.find(".select2-result"),
	                compound = this.results.find(".select2-result-with-children"),
	                self = this;
	
	            choices.each2(function (i, choice) {
	                var id = self.id(choice.data("select2-data"));
	                if (indexOf(id, val) >= 0) {
	                    choice.addClass("select2-selected");
	                    // mark all children of the selected parent as selected
	                    choice.find(".select2-result-selectable").addClass("select2-selected");
	                }
	            });
	
	            compound.each2(function (i, choice) {
	                // hide an optgroup if it doesn't have any selectable children
	                if (!choice.is('.select2-result-selectable') && choice.find(".select2-result-selectable:not(.select2-selected)").length === 0) {
	                    choice.addClass("select2-selected");
	                }
	            });
	
	            if (this.highlight() == -1 && noHighlightUpdate !== false) {
	                self.highlight(0);
	            }
	
	            //If all results are chosen render formatNoMatches
	            if (!this.opts.createSearchChoice && !choices.filter('.select2-result:not(.select2-selected)').length > 0) {
	                if (!data || data && !data.more && this.results.find(".select2-no-results").length === 0) {
	                    if (checkFormatter(self.opts.formatNoMatches, "formatNoMatches")) {
	                        this.results.append("<li class='select2-no-results'>" + evaluate(self.opts.formatNoMatches, self.opts.element, self.search.val()) + "</li>");
	                    }
	                }
	            }
	        },
	
	        // multi
	        getMaxSearchWidth: function () {
	            return this.selection.width() - getSideBorderPadding(this.search);
	        },
	
	        // multi
	        resizeSearch: function () {
	            var minimumWidth,
	                left,
	                maxWidth,
	                containerLeft,
	                searchWidth,
	                sideBorderPadding = getSideBorderPadding(this.search);
	
	            minimumWidth = measureTextWidth(this.search) + 10;
	
	            left = this.search.offset().left;
	
	            maxWidth = this.selection.width();
	            containerLeft = this.selection.offset().left;
	
	            searchWidth = maxWidth - (left - containerLeft) - sideBorderPadding;
	
	            if (searchWidth < minimumWidth) {
	                searchWidth = maxWidth - sideBorderPadding;
	            }
	
	            if (searchWidth < 40) {
	                searchWidth = maxWidth - sideBorderPadding;
	            }
	
	            if (searchWidth <= 0) {
	                searchWidth = minimumWidth;
	            }
	
	            this.search.width(Math.floor(searchWidth));
	        },
	
	        // multi
	        getVal: function () {
	            var val;
	            if (this.select) {
	                val = this.select.val();
	                return val === null ? [] : val;
	            } else {
	                val = this.opts.element.val();
	                return splitVal(val, this.opts.separator);
	            }
	        },
	
	        // multi
	        setVal: function (val) {
	            var unique;
	            if (this.select) {
	                this.select.val(val);
	            } else {
	                unique = [];
	                // filter out duplicates
	                $(val).each(function () {
	                    if (indexOf(this, unique) < 0) unique.push(this);
	                });
	                this.opts.element.val(unique.length === 0 ? "" : unique.join(this.opts.separator));
	            }
	        },
	
	        // multi
	        buildChangeDetails: function (old, current) {
	            var current = current.slice(0),
	                old = old.slice(0);
	
	            // remove intersection from each array
	            for (var i = 0; i < current.length; i++) {
	                for (var j = 0; j < old.length; j++) {
	                    if (equal(this.opts.id(current[i]), this.opts.id(old[j]))) {
	                        current.splice(i, 1);
	                        if (i > 0) {
	                            i--;
	                        }
	                        old.splice(j, 1);
	                        j--;
	                    }
	                }
	            }
	
	            return { added: current, removed: old };
	        },
	
	        // multi
	        val: function (val, triggerChange) {
	            var oldData,
	                self = this;
	
	            if (arguments.length === 0) {
	                return this.getVal();
	            }
	
	            oldData = this.data();
	            if (!oldData.length) oldData = [];
	
	            // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
	            if (!val && val !== 0) {
	                this.opts.element.val("");
	                this.updateSelection([]);
	                this.clearSearch();
	                if (triggerChange) {
	                    this.triggerChange({ added: this.data(), removed: oldData });
	                }
	                return;
	            }
	
	            // val is a list of ids
	            this.setVal(val);
	
	            if (this.select) {
	                this.opts.initSelection(this.select, this.bind(this.updateSelection));
	                if (triggerChange) {
	                    this.triggerChange(this.buildChangeDetails(oldData, this.data()));
	                }
	            } else {
	                if (this.opts.initSelection === undefined) {
	                    throw new Error("val() cannot be called if initSelection() is not defined");
	                }
	
	                this.opts.initSelection(this.opts.element, function (data) {
	                    var ids = $.map(data, self.id);
	                    self.setVal(ids);
	                    self.updateSelection(data);
	                    self.clearSearch();
	                    if (triggerChange) {
	                        self.triggerChange(self.buildChangeDetails(oldData, self.data()));
	                    }
	                });
	            }
	            this.clearSearch();
	        },
	
	        // multi
	        onSortStart: function () {
	            if (this.select) {
	                throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");
	            }
	
	            // collapse search field into 0 width so its container can be collapsed as well
	            this.search.width(0);
	            // hide the container
	            this.searchContainer.hide();
	        },
	
	        // multi
	        onSortEnd: function () {
	
	            var val = [],
	                self = this;
	
	            // show search and move it to the end of the list
	            this.searchContainer.show();
	            // make sure the search container is the last item in the list
	            this.searchContainer.appendTo(this.searchContainer.parent());
	            // since we collapsed the width in dragStarted, we resize it here
	            this.resizeSearch();
	
	            // update selection
	            this.selection.find(".select2-search-choice").each(function () {
	                val.push(self.opts.id($(this).data("select2-data")));
	            });
	            this.setVal(val);
	            this.triggerChange();
	        },
	
	        // multi
	        data: function (values, triggerChange) {
	            var self = this,
	                ids,
	                old;
	            if (arguments.length === 0) {
	                return this.selection.children(".select2-search-choice").map(function () {
	                    return $(this).data("select2-data");
	                }).get();
	            } else {
	                old = this.data();
	                if (!values) {
	                    values = [];
	                }
	                ids = $.map(values, function (e) {
	                    return self.opts.id(e);
	                });
	                this.setVal(ids);
	                this.updateSelection(values);
	                this.clearSearch();
	                if (triggerChange) {
	                    this.triggerChange(this.buildChangeDetails(old, this.data()));
	                }
	            }
	        }
	    });
	
	    $.fn.select2 = function () {
	
	        var args = Array.prototype.slice.call(arguments, 0),
	            opts,
	            select2,
	            method,
	            value,
	            multiple,
	            allowedMethods = ["val", "destroy", "opened", "open", "close", "focus", "isFocused", "container", "dropdown", "onSortStart", "onSortEnd", "enable", "disable", "readonly", "positionDropdown", "data", "search"],
	            valueMethods = ["opened", "isFocused", "container", "dropdown"],
	            propertyMethods = ["val", "data"],
	            methodsMap = { search: "externalSearch" };
	
	        this.each(function () {
	            if (args.length === 0 || typeof args[0] === "object") {
	                opts = args.length === 0 ? {} : $.extend({}, args[0]);
	                opts.element = $(this);
	
	                if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                    multiple = opts.element.prop("multiple");
	                } else {
	                    multiple = opts.multiple || false;
	                    if ("tags" in opts) {
	                        opts.multiple = multiple = true;
	                    }
	                }
	
	                select2 = multiple ? new window.Select2["class"].multi() : new window.Select2["class"].single();
	                select2.init(opts);
	            } else if (typeof args[0] === "string") {
	
	                if (indexOf(args[0], allowedMethods) < 0) {
	                    throw "Unknown method: " + args[0];
	                }
	
	                value = undefined;
	                select2 = $(this).data("select2");
	                if (select2 === undefined) return;
	
	                method = args[0];
	
	                if (method === "container") {
	                    value = select2.container;
	                } else if (method === "dropdown") {
	                    value = select2.dropdown;
	                } else {
	                    if (methodsMap[method]) method = methodsMap[method];
	
	                    value = select2[method].apply(select2, args.slice(1));
	                }
	                if (indexOf(args[0], valueMethods) >= 0 || indexOf(args[0], propertyMethods) >= 0 && args.length == 1) {
	                    return false; // abort the iteration, ready to return first matched value
	                }
	            } else {
	                throw "Invalid arguments to select2 plugin: " + args;
	            }
	        });
	        return value === undefined ? this : value;
	    };
	
	    // plugin defaults, accessible to users
	    $.fn.select2.defaults = {
	        width: "copy",
	        loadMorePadding: 0,
	        closeOnSelect: true,
	        openOnEnter: true,
	        containerCss: {},
	        dropdownCss: {},
	        containerCssClass: "",
	        dropdownCssClass: "",
	        formatResult: function (result, container, query, escapeMarkup) {
	            var markup = [];
	            markMatch(result.text, query.term, markup, escapeMarkup);
	            return markup.join("");
	        },
	        formatSelection: function (data, container, escapeMarkup) {
	            return data ? escapeMarkup(data.text) : undefined;
	        },
	        sortResults: function (results, container, query) {
	            return results;
	        },
	        formatResultCssClass: function (data) {
	            return data.css;
	        },
	        formatSelectionCssClass: function (data, container) {
	            return undefined;
	        },
	        minimumResultsForSearch: 0,
	        minimumInputLength: 0,
	        maximumInputLength: null,
	        maximumSelectionSize: 0,
	        id: function (e) {
	            return e == undefined ? null : e.id;
	        },
	        matcher: function (term, text) {
	            return stripDiacritics('' + text).toUpperCase().indexOf(stripDiacritics('' + term).toUpperCase()) >= 0;
	        },
	        separator: ",",
	        tokenSeparators: [],
	        tokenizer: defaultTokenizer,
	        escapeMarkup: defaultEscapeMarkup,
	        blurOnChange: false,
	        selectOnBlur: false,
	        adaptContainerCssClass: function (c) {
	            return c;
	        },
	        adaptDropdownCssClass: function (c) {
	            return null;
	        },
	        nextSearchTerm: function (selectedObject, currentSearchTerm) {
	            return undefined;
	        },
	        searchInputPlaceholder: '',
	        createSearchChoicePosition: 'top',
	        shouldFocusInput: function (instance) {
	            // Attempt to detect touch devices
	            var supportsTouchEvents = 'ontouchstart' in window || navigator.msMaxTouchPoints > 0;
	
	            // Only devices which support touch events should be special cased
	            if (!supportsTouchEvents) {
	                return true;
	            }
	
	            // Never focus the input if search is disabled
	            if (instance.opts.minimumResultsForSearch < 0) {
	                return false;
	            }
	
	            return true;
	        }
	    };
	
	    $.fn.select2.locales = [];
	
	    $.fn.select2.locales['en'] = {
	        formatMatches: function (matches) {
	            if (matches === 1) {
	                return "One result is available, press enter to select it.";
	            }return matches + " results are available, use up and down arrow keys to navigate.";
	        },
	        formatNoMatches: function () {
	            return "No matches found";
	        },
	        formatAjaxError: function (jqXHR, textStatus, errorThrown) {
	            return "Loading failed";
	        },
	        formatInputTooShort: function (input, min) {
	            var n = min - input.length;return "Please enter " + n + " or more character" + (n == 1 ? "" : "s");
	        },
	        formatInputTooLong: function (input, max) {
	            var n = input.length - max;return "Please delete " + n + " character" + (n == 1 ? "" : "s");
	        },
	        formatSelectionTooBig: function (limit) {
	            return "You can only select " + limit + " item" + (limit == 1 ? "" : "s");
	        },
	        formatLoadMore: function (pageNumber) {
	            return "Loading more results…";
	        },
	        formatSearching: function () {
	            return "Searching…";
	        }
	    };
	
	    $.extend($.fn.select2.defaults, $.fn.select2.locales['en']);
	
	    $.fn.select2.ajaxDefaults = {
	        transport: $.ajax,
	        params: {
	            type: "GET",
	            cache: false,
	            dataType: "json"
	        }
	    };
	
	    // exports
	    window.Select2 = {
	        query: {
	            ajax: ajax,
	            local: local,
	            tags: tags
	        }, util: {
	            debounce: debounce,
	            markMatch: markMatch,
	            escapeMarkup: defaultEscapeMarkup,
	            stripDiacritics: stripDiacritics
	        }, "class": {
	            "abstract": AbstractSelect2,
	            "single": SingleSelect2,
	            "multi": MultiSelect2
	        }
	    };
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_, $, Backbone) {/**
	 *  This is the primary galaxy tours definition, currently only used for
	 *  rendering a tour menu.
	 *
	 *  For now it's intended to be plunked into the center display a-la
	 *  Galaxy.app.display, but we could use a modal as well for more flexibility.
	 *
	 *  DBTODO - This is downright backbone abuse, rewrite it.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(74)], __WEBPACK_AMD_DEFINE_RESULT__ = function (BootstrapTour) {
	
	    var gxy_root = typeof Galaxy === "undefined" ? '/' : Galaxy.root;
	
	    var tour_opts = { storage: window.sessionStorage,
	        onEnd: function () {
	            sessionStorage.removeItem('activeGalaxyTour');
	        },
	        delay: 150, // Attempts to make it look natural
	        orphan: true
	    };
	
	    var hooked_tour_from_data = function (data) {
	        _.each(data.steps, function (step) {
	            if (step.preclick) {
	                step.onShow = function () {
	                    _.each(step.preclick, function (preclick) {
	                        // TODO: click delay between clicks
	                        $(preclick).click();
	                    });
	                };
	            }
	            if (step.postclick) {
	                step.onNext = function () {
	                    _.each(step.postclick, function (postclick) {
	                        // TODO: click delay between clicks
	                        $(postclick).click();
	                    });
	                };
	            }
	            if (step.textinsert) {
	                // Have to manually trigger a change here, for some
	                // elements which have additional logic, like the
	                // upload input box
	                step.onShown = function () {
	                    $(step.element).val(step.textinsert).trigger("change");
	                };
	            }
	        });
	        return data;
	    };
	
	    var TourItem = Backbone.Model.extend({
	        urlRoot: gxy_root + 'api/tours'
	    });
	
	    var Tours = Backbone.Collection.extend({
	        url: gxy_root + 'api/tours',
	        model: TourItem
	    });
	
	    var giveTour = function (tour_id) {
	        var url = gxy_root + 'api/tours/' + tour_id;
	        $.getJSON(url, function (data) {
	            // Set hooks for additional click and data entry actions.
	            var tourdata = hooked_tour_from_data(data);
	            sessionStorage.setItem('activeGalaxyTour', JSON.stringify(data));
	            // Store tour steps in sessionStorage to easily persist w/o hackery.
	            var tour = new Tour(_.extend({
	                steps: tourdata.steps
	            }, tour_opts));
	            // Always clean restart, since this is a new, explicit giveTour execution.
	            tour.init();
	            tour.goTo(0);
	            tour.restart();
	        });
	    };
	    var ToursView = Backbone.View.extend({
	        title: "Tours",
	        // initialize
	        initialize: function () {
	            var self = this;
	            this.setElement('<div/>');
	            this.model = new Tours();
	            this.model.fetch({
	                success: function () {
	                    self.render();
	                },
	                error: function () {
	                    // Do something.
	                    console.error("Failed to fetch tours.");
	                }
	            });
	        },
	
	        render: function () {
	            var tpl = _.template(["<h2>Galaxy Tours</h2>", "<p>This page presents a list of interactive tours available on this Galaxy server.  ", "Select any tour to get started (and remember, you can click 'End Tour' at any time).</p>", "<ul>", '<% _.each(tours, function(tour) { %>', '<li>', '<a href="/tours/<%- tour.id %>" class="tourItem" data-tour.id=<%- tour.id %>>', '<%- tour.attributes.name || tour.id %>', '</a>', ' - <%- tour.attributes.description || "No description given." %>', '</li>', '<% }); %>', "</ul>"].join(''));
	            this.$el.html(tpl({ tours: this.model.models })).on("click", ".tourItem", function (e) {
	                e.preventDefault();
	                giveTour($(this).data("tour.id"));
	            });
	        }
	    });
	
	    return { ToursView: ToursView,
	        hooked_tour_from_data: hooked_tour_from_data,
	        tour_opts: tour_opts,
	        giveTour: giveTour };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(1), __webpack_require__(2)))

/***/ }),
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(2), __webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, Backbone, baseMVC, _l) {
	    'use strict';
	
	    var logNamespace = 'user';
	    //==============================================================================
	    /** @class Model for a Galaxy user (including anonymous users).
	     *  @name User
	     */
	    var User = Backbone.Model.extend(baseMVC.LoggableMixin).extend(
	    /** @lends User.prototype */{
	        _logNamespace: logNamespace,
	
	        /** API location for this resource */
	        urlRoot: function () {
	            return Galaxy.root + 'api/users';
	        },
	
	        /** Model defaults
	         *  Note: don't check for anon-users with the username as the default is '(anonymous user)'
	         *      a safer method is if( !user.get( 'email' ) ) -> anon user
	         */
	        defaults: /** @lends User.prototype */{
	            id: null,
	            username: '(' + _l("anonymous user") + ')',
	            email: "",
	            total_disk_usage: 0,
	            nice_total_disk_usage: "",
	            quota_percent: null,
	            is_admin: false
	        },
	
	        /** Set up and bind events
	         *  @param {Object} data Initial model data.
	         */
	        initialize: function (data) {
	            this.log('User.initialize:', data);
	
	            this.on('loaded', function (model, resp) {
	                this.log(this + ' has loaded:', model, resp);
	            });
	            this.on('change', function (model, data) {
	                this.log(this + ' has changed:', model, data.changes);
	            });
	        },
	
	        isAnonymous: function () {
	            return !this.get('email');
	        },
	
	        isAdmin: function () {
	            return this.get('is_admin');
	        },
	
	        /** Load a user with the API using an id.
	         *      If getting an anonymous user or no access to a user id, pass the User.CURRENT_ID_STR
	         *      (e.g. 'current') and the API will return the current transaction's user data.
	         *  @param {String} idOrCurrent encoded user id or the User.CURRENT_ID_STR
	         *  @param {Object} options hash to pass to Backbone.Model.fetch. Can contain success, error fns.
	         *  @fires loaded when the model has been loaded from the API, passing the newModel and AJAX response.
	         */
	        loadFromApi: function (idOrCurrent, options) {
	            idOrCurrent = idOrCurrent || User.CURRENT_ID_STR;
	
	            options = options || {};
	            var model = this,
	                userFn = options.success;
	
	            /** @ignore */
	            options.success = function (newModel, response) {
	                model.trigger('loaded', newModel, response);
	                if (userFn) {
	                    userFn(newModel, response);
	                }
	            };
	
	            // requests for the current user must have a sep. constructed url (fetch don't work, ma)
	            if (idOrCurrent === User.CURRENT_ID_STR) {
	                options.url = this.urlRoot + '/' + User.CURRENT_ID_STR;
	            }
	            return Backbone.Model.prototype.fetch.call(this, options);
	        },
	
	        /** Clears all data from the sessionStorage.
	         */
	        clearSessionStorage: function () {
	            for (var key in sessionStorage) {
	                //TODO: store these under the user key so we don't have to do this
	                // currently only history
	                if (key.indexOf('history:') === 0) {
	                    sessionStorage.removeItem(key);
	                } else if (key === 'history-panel') {
	                    sessionStorage.removeItem(key);
	                }
	            }
	        },
	
	        /** string representation */
	        toString: function () {
	            var userInfo = [this.get('username')];
	            if (this.get('id')) {
	                userInfo.unshift(this.get('id'));
	                userInfo.push(this.get('email'));
	            }
	            return 'User(' + userInfo.join(':') + ')';
	        }
	    });
	
	    // string to send to tell server to return this transaction's user (see api/users.py)
	    User.CURRENT_ID_STR = 'current';
	
	    // class method to load the current user via the api and return that model
	    User.getCurrentUserFromApi = function (options) {
	        var currentUser = new User();
	        currentUser.loadFromApi(User.CURRENT_ID_STR, options);
	        return currentUser;
	    };
	
	    // (stub) collection for users (shouldn't be common unless admin UI)
	    var UserCollection = Backbone.Collection.extend(baseMVC.LoggableMixin).extend({
	        model: User,
	        urlRoot: function () {
	            return Galaxy.root + 'api/users';
	        }
	        //logger  : console,
	    });
	
	    //==============================================================================
	    return {
	        User: User
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_) {// from: https://raw.githubusercontent.com/umdjs/umd/master/jqueryPlugin.js
	// Uses AMD or browser globals to create a jQuery plugin.
	(function (factory) {
	    if (true) {
	        //TODO: So...this turns out to be an all or nothing thing. If I load jQuery in the define below, it will
	        //  (of course) wipe the old jquery *and all the plugins loaded into it*. So the define below *is still
	        //  relying on jquery being loaded globally* in order to preserve plugins.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	})(function (jQuery) {
	    'use_strict';
	
	    var $ = jQuery;
	
	    // ============================================================================
	    /**
	    * JQuery extension for tagging with autocomplete.
	    * @author: Jeremy Goecks
	    * @require: jquery.autocomplete plugin
	    */
	    //
	    // Initialize "tag click functions" for tags.
	    //
	    function init_tag_click_function(tag_elt, click_func) {
	        $(tag_elt).find('.tag-name').each(function () {
	            $(this).click(function () {
	                var tag_str = $(this).text();
	                var tag_name_and_value = tag_str.split(":");
	                click_func(tag_name_and_value[0], tag_name_and_value[1]);
	                return true;
	            });
	        });
	    }
	
	    jQuery.fn.autocomplete_tagging = function (options) {
	
	        var defaults = {
	            get_toggle_link_text_fn: function (tags) {
	                var text = "";
	                var num_tags = _.size(tags);
	                if (num_tags > 0) {
	                    text = num_tags + (num_tags > 1 ? " Tags" : " Tag");
	                } else {
	                    text = "Add tags";
	                }
	                return text;
	            },
	            tag_click_fn: function (name, value) {},
	            editable: true,
	            input_size: 20,
	            in_form: false,
	            tags: {},
	            use_toggle_link: true,
	            item_id: "",
	            add_tag_img: "",
	            add_tag_img_rollover: "",
	            delete_tag_img: "",
	            ajax_autocomplete_tag_url: "",
	            ajax_retag_url: "",
	            ajax_delete_tag_url: "",
	            ajax_add_tag_url: ""
	        };
	
	        var settings = jQuery.extend(defaults, options);
	
	        //
	        // Initalize object's elements.
	        //
	
	        // Get elements for this object. For this_obj, assume the last element with the id is the "this"; this is somewhat of a hack to address the problem
	        // that there may be two tagging elements for a single item if there are both community and individual tags for an element.
	        var this_obj = $(this);
	        var tag_area = this_obj.find('.tag-area');
	        var toggle_link = this_obj.find('.toggle-link');
	        var tag_input_field = this_obj.find('.tag-input');
	        var add_tag_button = this_obj.find('.add-tag-button');
	
	        // Initialize toggle link.
	        toggle_link.click(function () {
	            // Take special actions depending on whether toggle is showing or hiding link.
	            var after_toggle_fn;
	            if (tag_area.is(":hidden")) {
	                after_toggle_fn = function () {
	                    // If there are no tags, go right to editing mode by generating a click on the area.
	                    var num_tags = $(this).find('.tag-button').length;
	                    if (num_tags === 0) {
	                        tag_area.click();
	                    }
	                };
	            } else {
	                after_toggle_fn = function () {
	                    tag_area.blur();
	                };
	            }
	            tag_area.slideToggle("fast", after_toggle_fn);
	            return $(this);
	        });
	
	        // Initialize tag input field.
	        if (settings.editable) {
	            tag_input_field.hide();
	        }
	        tag_input_field.keyup(function (e) {
	            if (e.keyCode === 27) {
	                // Escape key
	                $(this).trigger("blur");
	            } else if (e.keyCode === 13 || // Return Key
	            e.keyCode === 188 || // Comma
	            e.keyCode === 32 // Space
	            ) {
	                    //
	                    // Check input.
	                    //
	
	                    var new_value = this.value;
	
	                    // Suppress space after a ":"
	                    if (new_value.indexOf(": ", new_value.length - 2) !== -1) {
	                        this.value = new_value.substring(0, new_value.length - 1);
	                        return false;
	                    }
	
	                    // Remove trigger keys from input.
	                    if (e.keyCode === 188 || e.keyCode === 32) {
	                        new_value = new_value.substring(0, new_value.length - 1);
	                    }
	
	                    // Trim whitespace.
	                    new_value = $.trim(new_value);
	
	                    // Too short?
	                    if (new_value.length < 2) {
	                        return false;
	                    }
	
	                    //
	                    // New tag OK - apply it.
	                    //
	
	                    this.value = ""; // Reset text field now that tag is being added
	
	                    // Add button for tag after all other tag buttons.
	                    var new_tag_button = build_tag_button(new_value);
	                    var tag_buttons = tag_area.children(".tag-button");
	                    if (tag_buttons.length !== 0) {
	                        var last_tag_button = tag_buttons.slice(tag_buttons.length - 1);
	                        last_tag_button.after(new_tag_button);
	                    } else {
	                        tag_area.prepend(new_tag_button);
	                    }
	
	                    // Add tag to internal list.
	                    var tag_name_and_value = new_value.split(":");
	                    settings.tags[tag_name_and_value[0]] = tag_name_and_value[1];
	
	                    // Update toggle link text.
	                    var new_text = settings.get_toggle_link_text_fn(settings.tags);
	                    toggle_link.text(new_text);
	
	                    // Commit tag to server.
	                    var zz = $(this);
	                    $.ajax({
	                        url: settings.ajax_add_tag_url,
	                        data: { new_tag: new_value },
	                        error: function () {
	                            // Failed. Roll back changes and show alert.
	                            new_tag_button.remove();
	                            delete settings.tags[tag_name_and_value[0]];
	                            var new_text = settings.get_toggle_link_text_fn(settings.tags);
	                            toggle_link.text(new_text);
	                            alert("Add tag failed");
	                        },
	                        success: function () {
	                            // Flush autocomplete cache because it's not out of date.
	                            // TODO: in the future, we could remove the particular item
	                            // that was chosen from the cache rather than flush it.
	                            zz.data('autocompleter').cacheFlush();
	                        }
	                    });
	
	                    return false;
	                }
	        });
	
	        // Add autocomplete to input.
	        var format_item_func = function (key, row_position, num_rows, value, search_term) {
	            var tag_name_and_value = value.split(":");
	            return tag_name_and_value.length === 1 ? tag_name_and_value[0] : tag_name_and_value[1];
	        };
	        var autocomplete_options = { selectFirst: false, formatItem: format_item_func,
	            autoFill: false, highlight: false };
	        tag_input_field.autocomplete_verheul(settings.ajax_autocomplete_tag_url, autocomplete_options);
	
	        // Initialize delete tag images for current tags.
	        this_obj.find('.delete-tag-img').each(function () {
	            init_delete_tag_image($(this));
	        });
	
	        // Initialize tag click function.
	        init_tag_click_function($(this), settings.tag_click_fn);
	
	        // Initialize "add tag" button.
	        add_tag_button.click(function () {
	            $(this).hide();
	
	            // Clicking on button is the same as clicking on the tag area.
	            tag_area.click();
	            return false;
	        });
	
	        //
	        // Set up tag area interactions; these are needed only if tags are editable.
	        //
	        if (settings.editable) {
	            // When the tag area blurs, go to "view tag" mode.
	            tag_area.bind("blur", function (e) {
	                if (_.size(settings.tags) > 0) {
	                    add_tag_button.show();
	                    tag_input_field.hide();
	                    tag_area.removeClass("active-tag-area");
	                    // tag_area.addClass("tooltip");
	                } else {
	                        // No tags, so do nothing to ensure that input is still visible.
	                    }
	            });
	
	            // On click, enable user to add tags.
	            tag_area.click(function (e) {
	                var is_active = $(this).hasClass("active-tag-area");
	
	                // If a "delete image" object was pressed and area is inactive, do nothing.
	                if ($(e.target).hasClass("delete-tag-img") && !is_active) {
	                    return false;
	                }
	
	                // If a "tag name" object was pressed and area is inactive, do nothing.
	                if ($(e.target).hasClass("tag-name") && !is_active) {
	                    return false;
	                }
	
	                // Remove tooltip.
	                // $(this).removeClass("tooltip");
	
	                // Hide add tag button, show tag_input field. Change background to show
	                // area is active.
	                $(this).addClass("active-tag-area");
	                add_tag_button.hide();
	                tag_input_field.show();
	                tag_input_field.focus();
	
	                // Add handler to document that will call blur when the tag area is blurred;
	                // a tag area is blurred when a user clicks on an element outside the area.
	                var handle_document_click = function (e) {
	                    var check_click = function (tag_area, target) {
	                        var tag_area_id = tag_area.attr("id");
	                        // Blur the tag area if the element clicked on is not in the tag area.
	                        if (target !== tag_area) {
	                            tag_area.blur();
	                            $(window).unbind("click.tagging_blur");
	                            $(this).addClass("tooltip");
	                        }
	                    };
	                    check_click(tag_area, $(e.target));
	                };
	                // TODO: we should attach the click handler to all frames in order to capture
	                // clicks outside the frame that this element is in.
	                //window.parent.document.onclick = handle_document_click;
	                //var temp = $(window.parent.document.body).contents().find("iframe").html();
	                //alert(temp);
	                //$(document).parent().click(handle_document_click);
	                $(window).bind("click.tagging_blur", handle_document_click);
	
	                return false;
	            });
	        }
	
	        // If using toggle link, hide the tag area. Otherwise, show the tag area.
	        if (settings.use_toggle_link) {
	            tag_area.hide();
	        }
	
	        //
	        // Helper functions.
	        //
	
	        //
	        // Collapse tag name + value into a single string.
	        //
	        function build_tag_str(tag_name, tag_value) {
	            return tag_name + (tag_value ? ":" + tag_value : "");
	        }
	
	        // Initialize a "delete tag image": when click, delete tag from UI and send delete request to server.
	        function init_delete_tag_image(delete_img) {
	            $(delete_img).mouseenter(function () {
	                $(this).attr("src", settings.delete_tag_img_rollover);
	            });
	            $(delete_img).mouseleave(function () {
	                $(this).attr("src", settings.delete_tag_img);
	            });
	            $(delete_img).click(function () {
	                // Tag button is image's parent.
	                var tag_button = $(this).parent();
	
	                // Get tag name, value.
	                var tag_name_elt = tag_button.find(".tag-name").eq(0);
	                var tag_str = tag_name_elt.text();
	                var tag_name_and_value = tag_str.split(":");
	                var tag_name = tag_name_and_value[0];
	                var tag_value = tag_name_and_value[1];
	
	                var prev_button = tag_button.prev();
	                tag_button.remove();
	
	                // Remove tag from local list for consistency.
	                delete settings.tags[tag_name];
	
	                // Update toggle link text.
	                var new_text = settings.get_toggle_link_text_fn(settings.tags);
	                toggle_link.text(new_text);
	
	                // Delete tag.
	                $.ajax({
	                    url: settings.ajax_delete_tag_url,
	                    data: { tag_name: tag_name },
	                    error: function () {
	                        // Failed. Roll back changes and show alert.
	                        settings.tags[tag_name] = tag_value;
	                        if (prev_button.hasClass("tag-button")) {
	                            prev_button.after(tag_button);
	                        } else {
	                            tag_area.prepend(tag_button);
	                        }
	                        alert("Remove tag failed");
	
	                        toggle_link.text(settings.get_toggle_link_text_fn(settings.tags));
	
	                        // TODO: no idea why it's necessary to set this up again.
	                        delete_img.mouseenter(function () {
	                            $(this).attr("src", settings.delete_tag_img_rollover);
	                        });
	                        delete_img.mouseleave(function () {
	                            $(this).attr("src", settings.delete_tag_img);
	                        });
	                    },
	                    success: function () {}
	                });
	
	                return true;
	            });
	        }
	
	        //
	        // Function that builds a tag button.
	        //
	        function build_tag_button(tag_str) {
	            // Build "delete tag" image.
	            var delete_img = $("<img/>").attr("src", settings.delete_tag_img).addClass("delete-tag-img");
	            init_delete_tag_image(delete_img);
	
	            // Build tag button.
	            var tag_name_elt = $("<span>").text(tag_str).addClass("tag-name");
	            tag_name_elt.click(function () {
	                var tag_name_and_value = tag_str.split(":");
	                settings.tag_click_fn(tag_name_and_value[0], tag_name_and_value[1]);
	                return true;
	            });
	
	            var tag_button = $("<span></span>").addClass("tag-button");
	            tag_button.append(tag_name_elt);
	            // Allow delete only if element is editable.
	            if (settings.editable) {
	                tag_button.append(delete_img);
	            }
	
	            return tag_button;
	        }
	    };
	
	    // ============================================================================
	    return init_tag_click_function;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    //==============================================================================
	    var LOGGING_FNS = ['log', 'debug', 'info', 'warn', 'error', 'metric'];
	    /** adds logging functions to an obj.prototype (or obj directly) adding a namespace for filtering
	     *  @param {Object} obj
	     *  @param {String} namespace
	     */
	    function addLogging(obj, namespace) {
	        var addTo = obj.prototype !== undefined ? obj.prototype : obj;
	        if (namespace !== undefined) {
	            addTo._logNamespace = namespace;
	        }
	        //yagni?: without this, may not capture Galaxy.config.debug and add Galaxy.logger properly
	        // if( window.Galaxy && window.Galaxy.config && window.Galaxy.config.debug ){
	        //     addTo.logger = window.Galaxy.logger;
	        // }
	
	        // give the object each
	        LOGGING_FNS.forEach(function (logFn) {
	            addTo[logFn] = function () {
	                if (!this.logger) {
	                    return undefined;
	                }
	                if (this.logger.emit) {
	                    return this.logger.emit(logFn, this._logNamespace, arguments);
	                }
	                if (this.logger[logFn]) {
	                    //TODO:! there has to be a way to get the lineno/file into this
	                    // http://stackoverflow.com/questions/13815640/a-proper-wrapper-for-console-log-with-correct-line-number
	                    // http://www.paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
	                    return this.logger[logFn].apply(this.logger, arguments);
	                }
	                return undefined;
	            };
	        });
	        return obj;
	    }
	
	    //==============================================================================
	    return addLogging;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 100 */,
/* 101 */
/***/ (function(module, exports) {

	var amdi18n={"__root":{"Analyze Data":false,"Workflow":false,"Shared Data":false,"Data Libraries":false,"Histories":false,"Workflows":false,"Visualizations":false,"Pages":false,"Visualization":false,"New Track Browser":false,"Saved Visualizations":false,"Interactive Environments":false,"Admin":false,"Help":false,"Support":false,"Search":false,"Mailing Lists":false,"Videos":false,"Wiki":false,"How to Cite Galaxy":false,"Interactive Tours":false,"User":false,"Login":false,"Register":false,"Login or Register":false,"Logged in as":false,"Preferences":false,"Custom Builds":false,"Logout":false,"Saved Histories":false,"Saved Datasets":false,"Saved Pages":false,"Account and saved data":false,"Account registration or login":false,"Support, contact, and community":false,"Administer this Galaxy":false,"Visualize datasets":false,"Access published resources":false,"Chain tools into workflows":false,"Analysis home view":false,"History Lists":false,"Histories Shared with Me":false,"Current History":false,"Create New":false,"Copy History":false,"Share or Publish":false,"Show Structure":false,"Extract Workflow":false,"Delete Permanently":false,"Dataset Actions":false,"Copy Datasets":false,"Dataset Security":false,"Resume Paused Jobs":false,"Collapse Expanded Datasets":false,"Unhide Hidden Datasets":false,"Delete Hidden Datasets":false,"Purge Deleted Datasets":false,"Downloads":false,"Export Tool Citations":false,"Export History to File":false,"Other Actions":false,"Import from File":false,"Webhooks":false,"This history is empty":false,"No matching datasets found":false,"An error occurred while getting updates from the server":false,"Please contact a Galaxy administrator if the problem persists":false,"search datasets":false,"You are currently viewing a deleted history!":false,"You are over your disk quota":false,"Tool execution is on hold until your disk usage drops below your allocated quota":false,"All":false,"None":false,"For all selected":false,"Edit history tags":false,"Edit history Annotation":false,"Click to rename history":false,"Operations on multiple datasets":false,"Hide datasets":false,"Unhide datasets":false,"Delete datasets":false,"Undelete datasets":false,"Permanently delete datasets":false,"This will permanently remove the data in your datasets. Are you sure?":false,"Dataset":false,"Annotation":false,"This history is empty. Click 'Get Data' on the left tool menu to start":false,"You must be logged in to create histories":false,"Unable to purge dataset":false,"Cannot display datasets removed from disk":false,"This dataset must finish uploading before it can be viewed":false,"This dataset is not yet viewable":false,"View data":false,"Download":false,"Download dataset":false,"Additional files":false,"View details":false,"This is a new dataset and not all of its data are available yet":false,"You do not have permission to view this dataset":false,"The job creating this dataset was cancelled before completion":false,"This job is waiting to run":false,"This dataset is currently uploading":false,"Metadata is being auto-detected":false,"This job is currently running":false,"This job is paused. Use the \"Resume Paused Jobs\" in the history menu to resume":false,"An error occurred with this dataset":false,"No data":false,"An error occurred setting the metadata for this dataset":false,"There was an error getting the data for this dataset":false,"This dataset has been deleted and removed from disk":false,"This dataset has been deleted":false,"This dataset has been hidden":false,"format":false,"database":false,"Edit attributes":false,"Cannot edit attributes of datasets removed from disk":false,"Undelete dataset to edit attributes":false,"This dataset must finish uploading before it can be edited":false,"This dataset is not yet editable":false,"Delete":false,"Dataset is already deleted":false,"View or report this error":false,"Run this job again":false,"Visualize":false,"Visualize in":false,"Undelete it":false,"Permanently remove it from disk":false,"Unhide it":false,"You may be able to":false,"set it manually or retry auto-detection":false,"Edit dataset tags":false,"Edit dataset annotation":false,"Tool Help":false,"Search Tool Shed":false,"Monitor installing repositories":false,"Manage installed tools":false,"Reset metadata":false,"Download local tool":false,"Tool lineage":false,"Reload a tool's configuration":false,"Review tool migration stages":false,"View Tool Error Logs":false,"Manage Display Whitelist":false,"Manage Tool Dependencies":false,"Users":false,"Groups":false,"API keys":false,"Impersonate a user":false,"Data":false,"Quotas":false,"Roles":false,"Local data":false,"Form Definitions":false,"Enable/Disable Scratchbook":false,"Show/Hide Scratchbook":false,"Tags":false,"Edit annotation":false},"__ja":{"Analyze Data":"データ解析","Workflow":"ワークフロー","Shared Data":"共有データ","Data Libraries":"データライブラリ","Histories":"ヒストリー","Workflows":"ワークフロー","Visualizations":"可視化","Pages":"ページ","Visualization":"可視化","New Track Browser":"新しい Track Browser","Saved Visualizations":"保存された可視化","Interactive Environments":"インタラクティブ環境","Admin":"管理者","Help":"ヘルプ","Support":"サポート","Search":"検索","Mailing Lists":"メーリングリスト","Videos":"動画","How to Cite Galaxy":"Galaxy を引用する方法","Interactive Tours":"インタラクティブツアー","User":"ユーザー","Login":"ログイン","Register":"登録","Login or Register":"ログイン/登録","Preferences":"設定","Custom Builds":"カスタムビルド","Logout":"ログアウト","Saved Histories":"保存されたヒストリ","Saved Datasets":"保存されたデータセット","Saved Pages":"保存されたページ","Account and saved data":"アカウントと保存されたデータ","Account registration or login":"アカウントの登録またはログイン","Support, contact, and community":"サポート、コンタクト、コミュニティ","Administer this Galaxy":"この Galaxy の管理者","Visualize datasets":"データセットの可視化","Access published resources":"パブリッシュされたリソースへアクセス","Chain tools into workflows":"ツールとワークフローの連携","Analysis home view":"解析ホーム","History Lists":"ヒストリーリスト","Histories Shared with Me":"私と共有されているヒストリー","Current History":"現在のヒストリー","Create New":"新しく作成","Copy History":"ヒストリーをコピーする","Share or Publish":"共有またはパブリッシュ","Show Structure":"構造を見る","Extract Workflow":"ワークフローを抽出","Delete Permanently":"永久に削除","Dataset Actions":"データセットの操作","Copy Datasets":"データセットをコピー","Dataset Security":"データセットのセキュリティ","Resume Paused Jobs":"一時停止したジョブの再開","Collapse Expanded Datasets":"展開されたデータセットを畳む","Unhide Hidden Datasets":"隠されたデータセットを表示する","Delete Hidden Datasets":"隠されたデータセットを削除する","Purge Deleted Datasets":"削除されたデータセットを永久に削除","Downloads":"ダウンロード","Export Tool Citations":"ツールの引用をエクスポート","Export History to File":"ヒストリーをファイルへエクスポート","Other Actions":"その他のアクション","Import from File":"ファイルからの読み込み","Webhooks":"Webhooks","This history is empty":"ヒストリーは空です","No matching datasets found":"一致するデータセットが見つかりませんでした","Search datasets":"データセットを検索する","You are currently viewing a deleted history!":"消去したヒストリーをみています。","You are over your disk quota":"あなたはディスククォータを超えている","All":"一式","None":"なし","For all selected":"各項目を","Edit history tags":"ヒストリーのタグを編集","Edit history annotation":"ヒストリーのアノテーションを編集","Click to rename history":"ヒストリーの名前を変更するにはクリック","Operations on multiple datasets":"複数のデータセットに対する操作","Permanently delete datasets":"永久にデータセットを削除","This will permanently remove the data in your datasets. Are you sure?":"これは永久にあなたのデータセット内のデータを削除します。本当に？","Dataset":"データセット","This history is empty. Click 'Get Data' on the left tool menu to start":"ヒストリーは空です。解析をはじめるには、左パネルの 'データ取得' をクリック","You must be logged in to create histories":"ヒストリーを作成するためにはログインする必要があります","View data":"データを表示","Download":"ダウンロード","Download dataset":"データセットをダウンロード","View details":"細部を表示","This job is waiting to run":"ジョブは実行待ちです","This job is currently running":"ジョブは実行中です","An error occurred with this dataset":"このジョブの実行中に発生したエラー","No data":"データ無し","This dataset has been deleted and removed from disk":"このデータセットは、永続的にディスクから削除されました","This dataset has been deleted":"このデータセットは削除されました","This dataset has been hidden":"このデータセットは、非表示にされた","format":"フォーマット","database":"データベース","Edit attributes":"変数を編集する","Delete":"削除する","View or report this error":"このエラーを届け出る","Run this job again":"もう一度このジョブを実行する","Visualize":"可視化する","Undelete it":"復元する","Permanently remove it from disk":"永久にディスクから削除","Unhide it":"非表示解除する","Search Tool Shed":"Tool Shed で探す","Search Tool Shed (Beta)":"Tool Shed (Beta) で探す","Monitor installing repositories":"インストールレポジトリのモニタ","Manage installed tools":"インストールしたツールの管理","Reset metadata":"メタデータのリセット","Download local tool":"ローカルツールのダウンロード","Tool lineage":"ツール系統","Reload a tool's configuration":"ツールのコンフィグのリロード","Review tool migration stages":"ツール移行ステージのレビュー","View Tool Error Logs":"ツールのエラーログ","Manage Display Whitelist":"表示ホワイトリストの管理","Manage Tool Dependencies":"ツール依存関係の管理","Users":"ユーザー","Groups":"グループ","API keys":"API キー","Impersonate a user":"ユーザー偽装","Data":"データ","Quotas":"クォータ","Roles":"ロール","Local data":"ローカルデータ","Form definitions":"フォーム定義","Administration":"管理","Server":"サーバー","Tools and Tool Shed":"ツールと Tool Shed","User Management":"ユーザ管理","Form Definitions":"フォーム定義"},"__fr":{"Analyze Data":"Analyse de données","Workflow":"Workflow","Shared Data":"Données partagées","Data Libraries":"Bibliothèque de données","Histories":"Historiques","Workflows":"Workflows","Visualizations":"Visualisations","Pages":"Pages","Visualization":"Visualisation","New Track Browser":"Nouveau Navigateur de Tracks/Pistes","Saved Visualizations":"Visualisations sauvegardées","Interactive Environments":"Environnements interactifs","Admin":"Admin","Help":"Aide","Support":"Assistance","Search":"Recherche","Mailing Lists":"Liste de diffusion","Videos":"Vidéos","Wiki":"Documentations","How to Cite Galaxy":"Comment citer Galaxy","Interactive Tours":"Guides interactifs","User":"Utilisateur","Login":"Authentification","Register":"Enregistrement","Login or Register":"Authentification et Enregistrement","Logged in as":"Authentifié en tant que","Preferences":"Préférences","Custom Builds":"Mes génomes Builds de référence","Logout":"Déconnexion","Saved Histories":"Historiques sauvegardés","Saved Datasets":"Jeux de données sauvegardés","Saved Pages":"Pages sauvegardées","Account and saved data":"Compte et données sauvegardées","Account registration or login":"Enregistrement ou authentification","Support, contact, and community":"Support,contact et communauté","Administer this Galaxy":"Outils Admin","Visualize datasets":"Visualiser les jeux de données","Access published resources":"Accéder aux données partagées","Chain tools into workflows":"Relier outils dans un workflow","Analysis home view":"Accueil analyse de données","History Lists":"Tableaux des historiques","Histories Shared with Me":"Historiques partagés avec moi","Current History":"Cet Historique","Create New":"Créer un nouveau","Copy History":"Copier l'Historique","Share or Publish":"Partager et publier","Show Structure":"Montrer la structure","Extract Workflow":"Extraire un Workflow","Delete Permanently":"Supprimer définitivement","Dataset Actions":"Actions sur les jeux de données","Copy Datasets":"Copier des jeux de données","Dataset Security":"Permissions/Sécurité","Resume Paused Jobs":"Reprendre les processus en pause","Collapse Expanded Datasets":"Réduire les données étendues","Unhide Hidden Datasets":"Afficher les données cachées","Delete Hidden Datasets":"Supprimer les données cachées","Purge Deleted Datasets":"Purger les données supprimées","Downloads":"Télécharger","Export Tool Citations":"Exporter les citations des outils","Export History to File":"Exporter l'Historique dans un fichier","Other Actions":"Autres actions","Import from File":"Importer depuis un fichier","Webhooks":"Webhooks","This history is empty":"Cet historique est vide","No matching datasets found":"Aucunes données correspondantes n'ont été trouvées","An error occurred while getting updates from the server":"Une erreur s'est produite lors de la réception des données depuis le serveur","Please contact a Galaxy administrator if the problem persists":"Veuillez contacter un administrateur de l'instance Galaxy si ce problème persiste","search datasets":"Rechercher des données","You are currently viewing a deleted history!":"Vous consultez actuellement un historique supprimé!","You are over your disk quota":"Vous avez dépassé votre quota d'espace disque","Tool execution is on hold until your disk usage drops below your allocated quota":"L'exécution de l'outil est en attente tant que votre utilisation d'espace disque dépasse le quota attribué","All":"Tout","None":"Aucun","For all selected":"Pour toute la sélection","Edit history tags":"Editer les mots-clés de l'historique","Edit history Annotation":"Editer l'annotation de l'historique","Click to rename history":"Cliquer pour renommer l'historique","Operations on multiple datasets":"Opérer sur plusieurs jeux de données en même temps","Hide datasets":"Cacher les jeux de données","Unhide datasets":"Afficher les jeux de données cachés","Delete datasets":"Supprimer les jeux de données","Undelete datasets":"Restaurer les jeux de données supprimés","Permanently delete datasets":"Supprimer définitivement les jeux de données","This will permanently remove the data in your datasets. Are you sure?":"Cela supprimera de manière permanente les données de votre historique. Êtes-vous certain?","Dataset":"Jeu de données","Annotation":"Annotation","This history is empty. Click 'Get Data' on the left tool menu to start":"Cet historique est vide. Cliquer sur 'Get Data' au niveau du menu d'outils à gauche pour démarrer","You must be logged in to create histories":"Vous devez être connecté pour créer un historique","load your own data":"Charger vos propres données","get data from an external source":"Charger des données depuis une source externe","Include Deleted Datasets":"Inclure les jeux de données supprimés","Include Hidden Datasets":"Inclure les jeux de données cachés","Unable to purge dataset":"Impossible de purger le jeu de données","Cannot display datasets removed from disk":"Impossible de visualiser les jeux de données supprimés du disque","This dataset must finish uploading before it can be viewed":"Le jeu de données doit être totalement téléversé avant de pouvoir être visualiser","This dataset is not yet viewable":"Ce jeu de données n'est pas visualisable","View data":"Voir les données","Download":"Télécharger","Download dataset":"Télécharger le jeu de données","Additional files":"Fichiers additionnels","View details":"Voir les détails","This is a new dataset and not all of its data are available yet":"Il s'agit d'un nouveau jeu de données et seule une partie des données est accessible pour le moment","You do not have permission to view this dataset":"Vous n'avez pas la permission de voir ce jeu de données","The job creating this dataset was cancelled before completion":"Le processus à l'origine de ce jeu de données a été annulé prématurément","This job is waiting to run":"Ce calcul est en attente de traitement","This dataset is currently uploading":"Ce jeu de données est en cours de téléversement","Metadata is being auto-detected":"Les métadonnées sont auto-détectées","This job is currently running":"Le traitement est en cours","This job is paused. Use the \"Resume Paused Jobs\" in the history menu to resume":"Ce traitement est en pause. Utilisez le \"Relancer les traitements en pause\" dans le menu d'historique pour le relancer","An error occurred with this dataset":"Une erreur est survenue avec ce jeu de données","No data":"Aucune donnée","An error occurred setting the metadata for this dataset":"Une erreur est survenue pendant la récupération des métadonnées de ce jeu de données","There was an error getting the data for this dataset":"Il est survenu une erreur durant la récupération du contenu de ce jeu de données","This dataset has been deleted and removed from disk":"Ce jeu de données a été supprimé et effacé du disque","This dataset has been deleted":"Ce jeu de données a été supprimé","This dataset has been hidden":"Ce jeu de données a été caché","format":"format","database":"génome de référence","Edit attributes":"Editer les attributs","Cannot edit attributes of datasets removed from disk":"Impossible d'éditer les attributs de jeux de données effacés du disque","Undelete dataset to edit attributes":"Restaurer le jeu de données pour en éditer les attributs","This dataset must finish uploading before it can be edited":"Ce jeu de données doit être entièrement téléversé avant toute modification","This dataset is not yet editable":"Ce jeu de données n'est pas encore éditable","Delete":"Supprimer","Dataset is already deleted":"Le jeu de données est déjà supprimé","View or report this error":"Voir ou remonter cette erreur","Run this job again":"Exécuter ce traitement à nouveau","Visualize":"Visualiser","Visualize in":"Visualiser via","Undelete it":"Restaurer","Permanently remove it from disk":"Supprimer définitivement du disque","Unhide it":"Rendre visible","You may be able to":"Vous devriez être en mesure de","set it manually or retry auto-detection":"Traitez le manuellement ou retenter la détection automatique","Edit dataset tags":"Editer les mots-clés du jeu de données","Edit dataset annotation":"Editer les annotations du jeu de données","Tags":"Mots-clés","Edit annotation":"Editer les annotations"},"__zh":{"This history is empty":"历史已空","No matching datasets found":"未找到匹配的数据集","Search datasets":"搜索数据集","You are currently viewing a deleted history!":"正在查看已删除的历史","You are over your disk quota":"您已超过磁盘配额","All":"皆","None":"一个也没有","For all selected":"为每个选定","Click to rename history":"单击要重命名的历史","Operations on multiple datasets":"编辑多个数据集","Permanently delete datasets":"永久删除数据集","This will permanently remove the data in your datasets. Are you sure?":"这将永久在你的数据集删除数据。你确定？","Dataset":"数据集","This history is empty. Click 'Get Data' on the left tool menu to start":"历史已空，请单击左边窗格中‘获取数据’","You must be logged in to create histories":"你必须登录后才能创建历史","View data":"数据","Download":"下载","Download dataset":"下载数据集","View details":"查看详情","This job is waiting to run":"等待运行的进程","This job is currently running":"正在运行的进程","An error occurred with this dataset":"进程运行时出错","No data":"没有数据","This dataset has been deleted":"此数据集已被删除","This dataset has been hidden":"此数据集已隐藏","format":"格式","database":"数据库","Edit attributes":"编辑属性","Delete":"删除","View or report this error":"报告错误","Run this job again":"重新运行","Visualize":"图形","Undelete it":"反删除","Permanently remove it from disk":"从磁盘中永久删除","Unhide it":"取消隐藏"}};amdi18n.init=function(language){
	    if(!language){
	        if(window._i18n && window._i18n.locale){
	            language = window._i18n.locale;
	        }else{
	            language = 'root';
	        }
	    }
	    Object.assign(this,this.__root,this['__'+language]);
	  };amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {/** Real-time Communication feature **/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Modal) {
	
	    var GenericNavView = Backbone.View.extend({
	
	        initialize: function () {
	            this.modal = null;
	        },
	
	        /** makes bootstrap modal and iframe inside it */
	        makeModalIframe: function (e) {
	            // make modal
	            var host = window.Galaxy.config.communication_server_host,
	                port = window.Galaxy.config.communication_server_port,
	                username = escape(window.Galaxy.user.attributes.username),
	                persistent_communication_rooms = escape(window.Galaxy.config.persistent_communication_rooms),
	                query_string = "?username=" + username + "&persistent_communication_rooms=" + persistent_communication_rooms,
	                src = host + ":" + port + query_string,
	                $el_chat_modal_header = null,
	                $el_chat_modal_body = null,
	                iframe_template = '<iframe class="f-iframe fade in communication-iframe" src="' + src + '"> </iframe>',
	                header_template = '<i class="fa fa-comment" aria-hidden="true" title="Communicate with other users"></i>' + '<i class="fa fa-expand expand-compress-modal" aria-hidden="true" title="Maximize"></i>' + '<i class="fa fa-times close-modal" aria-hidden="true" title="Close"></i>',
	                frame_height = 350,
	                frame_width = 600,
	                class_names = 'ui-modal chat-modal';
	
	            // deletes the chat modal if already present and create one
	            if ($('.chat-modal').length > 0) {
	                $('.chat-modal').remove();
	            }
	            // creates a modal
	            GenericNavView.modal = new Modal.View({
	                body: iframe_template,
	                height: frame_height,
	                width: frame_width,
	                closing_events: true,
	                title_separator: false,
	                cls: class_names
	            });
	
	            // shows modal
	            GenericNavView.modal.show();
	            $el_chat_modal_header = $('.chat-modal .modal-header');
	            $el_chat_modal_body = $('.chat-modal .modal-body');
	            // adjusts the css of bootstrap modal for chat
	            $el_chat_modal_header.addClass('modal-header-body');
	            $el_chat_modal_body.addClass('modal-header-body');
	            $el_chat_modal_header.find('h4').remove();
	            $el_chat_modal_header.removeAttr('min-height padding border');
	            $el_chat_modal_header.append(header_template);
	            // click event of the close button for chat
	            $('.close-modal').click(function (e) {
	                $('.chat-modal').css('display', 'none');
	            });
	            // click event of expand and compress icon
	            $('.expand-compress-modal').click(function (e) {
	                if ($('.expand-compress-modal').hasClass('fa-expand')) {
	                    $('.chat-modal .modal-dialog').width('1000px');
	                    $('.chat-modal .modal-body').height('575px');
	                    $('.expand-compress-modal').removeClass('fa-expand').addClass('fa-compress');
	                    $('.expand-compress-modal').attr('title', 'Minimize');
	                    $('.expand-compress-modal').css('margin-left', '96.2%');
	                } else {
	                    $('.chat-modal .modal-dialog').width(frame_width + 'px');
	                    $('.chat-modal .modal-body').height(frame_height + 'px');
	                    $('.expand-compress-modal').removeClass('fa-compress').addClass('fa-expand');
	                    $('.expand-compress-modal').attr('title', 'Maximize');
	                    $('.expand-compress-modal').css('margin-left', '93.2%');
	                }
	            });
	            return this;
	        },
	
	        /**renders the chat icon as a nav item*/
	        render: function () {
	            var self = this,
	                navItem = {};
	            navItem = {
	                id: 'show-chat-online',
	                icon: 'fa-comment-o',
	                tooltip: 'Chat online',
	                visible: false,
	                onclick: self.makeModalIframe
	            };
	            return navItem;
	        }
	    });
	
	    return {
	        GenericNavView: GenericNavView
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(107), __webpack_require__(108), __webpack_require__(146)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Utils, Menu, Scratchbook, QuotaMeter) {
	
	    /** Masthead **/
	    var View = Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            this.options = options;
	            this.setElement(this._template());
	            this.$navbarBrandLink = this.$('.navbar-brand-link');
	            this.$navbarBrandImage = this.$('.navbar-brand-image');
	            this.$navbarBrandTitle = this.$('.navbar-brand-title');
	            this.$navbarTabs = this.$('.navbar-tabs');
	            this.$quoteMeter = this.$('.quota-meter-container');
	
	            // build tabs
	            this.collection = new Menu.Collection();
	            this.collection.on('add', function (model) {
	                self.$navbarTabs.append(new Menu.Tab({ model: model }).render().$el);
	            }).on('reset', function () {
	                self.$navbarTabs.empty();
	            }).on('dispatch', function (callback) {
	                self.collection.each(function (m) {
	                    callback(m);
	                });
	            }).fetch(this.options);
	
	            // scratchbook
	            Galaxy.frame = this.frame = new Scratchbook({ collection: this.collection });
	
	            // set up the quota meter (And fetch the current user data from trans)
	            // add quota meter to masthead
	            Galaxy.quotaMeter = this.quotaMeter = new QuotaMeter.UserQuotaMeter({
	                model: Galaxy.user,
	                el: this.$quoteMeter
	            });
	
	            // loop through beforeunload functions if the user attempts to unload the page
	            $(window).on('click', function (e) {
	                var $download_link = $(e.target).closest('a[download]');
	                if ($download_link.length == 1) {
	                    if ($('iframe[id=download]').length === 0) {
	                        $('body').append($('<iframe/>').attr('id', 'download').hide());
	                    }
	                    $('iframe[id=download]').attr('src', $download_link.attr('href'));
	                    e.preventDefault();
	                }
	            }).on('beforeunload', function () {
	                var text = '';
	                self.collection.each(function (model) {
	                    var q = model.get('onbeforeunload') && model.get('onbeforeunload')();
	                    q && (text += q + ' ');
	                });
	                if (text !== '') {
	                    return text;
	                }
	            });
	        },
	
	        render: function () {
	            this.$navbarBrandTitle.html('v2.1.9 <a href="https://galaxyproject.org/">(powered by ' + 'Galaxy)</a> ' + (this.options.brand && '/ ' + this.options.brand || ''));
	            this.$navbarBrandLink.attr('href', this.options.logo_url);
	            this.$navbarBrandImage.attr('src', Galaxy.root + 'static/hyperbrowser/images/logo/HB_logo_title_small.png');
	            this.quotaMeter.render();
	            return this;
	        },
	
	        /** body template */
	        _template: function () {
	            return '<div id="masthead" class="navbar navbar-fixed-top navbar-inverse">' + '<div class="navbar-header">' + '<div class="navbar-tabs"/>' + '</div>' + '<div class="navbar-brand">' + '<a class="navbar-brand-link">' + '<img class="navbar-brand-image"/></a>' + '<span class="navbar-brand-title"/>' + '' + '</div>' + '<div class="quota-meter-container"/>' + '<div class="navbar-icons"/>' + '</div>';
	        }
	    });
	
	    return {
	        View: View
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, $, jQuery, _) {/** Masthead Collection **/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(105), __webpack_require__(44), __webpack_require__(6), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (GenericNav, Webhooks, _l, Utils) {
	    var Collection = Backbone.Collection.extend({
	        model: Backbone.Model.extend({
	            defaults: {
	                visible: true,
	                target: '_parent'
	            }
	        }),
	        fetch: function (options) {
	            var self = this;
	            options = options || {};
	            this.reset();
	
	            //
	            // Chat server tab
	            //
	            var extendedNavItem = new GenericNav.GenericNavView();
	            this.add(extendedNavItem.render());
	
	            //
	            // Analyze data tab.
	            //
	            this.add({
	                id: 'analysis',
	                title: _l('Analyze Data'),
	                url: '',
	                tooltip: _l('Analysis home view')
	            });
	
	            //
	            // Workflow tab.
	            //
	            this.add({
	                id: 'workflow',
	                title: _l('Workflow'),
	                tooltip: _l('Chain tools into workflows'),
	                disabled: !Galaxy.user.id,
	                url: 'workflow'
	            });
	
	            //
	            // 'Shared Items' or Libraries tab.
	            //
	            this.add({
	                id: 'shared',
	                title: _l('Shared Data'),
	                url: 'library/index',
	                tooltip: _l('Access published resources'),
	                menu: [{
	                    title: _l('Data Libraries'),
	                    url: 'library/list'
	                }, {
	                    title: _l('Histories'),
	                    url: 'histories/list_published'
	                }, {
	                    title: _l('Workflows'),
	                    url: 'workflows/list_published'
	                }, {
	                    title: _l('Visualizations'),
	                    url: 'visualizations/list_published'
	                }, {
	                    title: _l('Pages'),
	                    url: 'pages/list_published'
	                }]
	            });
	
	            //
	            // Lab menu.
	            //
	            options.user_requests && this.add({
	                id: 'lab',
	                title: 'Lab',
	                menu: [{
	                    title: 'Sequencing Requests',
	                    url: 'requests/index'
	                }, {
	                    title: 'Find Samples',
	                    url: 'requests/find_samples_index'
	                }, {
	                    title: 'Help',
	                    url: options.lims_doc_url
	                }]
	            });
	
	            //
	            // Visualization tab.
	            //
	            this.add({
	                id: 'visualization',
	                title: _l('Visualization'),
	                url: 'visualizations/list',
	                tooltip: _l('Visualize datasets'),
	                disabled: !Galaxy.user.id,
	                menu: [{
	                    title: _l('New Track Browser'),
	                    url: 'visualization/trackster',
	                    target: '_frame'
	                }, {
	                    title: _l('Saved Visualizations'),
	                    url: 'visualizations/list',
	                    target: '_frame'
	                }, {
	                    title: _l('Interactive Environments'),
	                    url: 'visualization/gie_list',
	                    target: 'galaxy_main'
	                }]
	            });
	
	            //
	            // Webhooks
	            //
	            Webhooks.add({
	                url: 'api/webhooks/masthead/all',
	                callback: function (webhooks) {
	                    $(document).ready(function () {
	                        $.each(webhooks.models, function (index, model) {
	                            var webhook = model.toJSON();
	                            if (webhook.activate) {
	                                var obj = {
	                                    id: webhook.name,
	                                    icon: webhook.config.icon,
	                                    url: webhook.config.url,
	                                    tooltip: webhook.config.tooltip,
	                                    onclick: webhook.config.function && new Function(webhook.config.function)
	                                };
	
	                                // Galaxy.page is undefined for data libraries, workflows pages
	                                if (Galaxy.page) {
	                                    Galaxy.page.masthead.collection.add(obj);
	                                } else if (Galaxy.masthead) {
	                                    Galaxy.masthead.collection.add(obj);
	                                }
	
	                                // Append masthead script and styles to Galaxy main
	                                Utils.appendScriptStyle(webhook);
	                            }
	                        });
	                    });
	                }
	            });
	
	            //
	            // Admin.
	            //
	            Galaxy.user.get('is_admin') && this.add({
	                id: 'admin',
	                title: _l('Admin'),
	                url: 'admin',
	                tooltip: _l('Administer this Galaxy'),
	                cls: 'admin-only'
	            });
	
	            //
	            // Help tab.
	            //
	            var helpTab = {
	                id: 'help',
	                title: _l('Help'),
	                tooltip: _l('Support, contact, and community'),
	                menu: [{
	                    title: _l('HyperBrowser help'),
	                    url: 'http://sites.google.com/site/hyperbrowserhelp/',
	                    target: '_blank'
	                }, {
	                    title: _l('Support'),
	                    url: options.support_url,
	                    target: '_blank'
	                }, {
	                    title: _l('Search'),
	                    url: options.search_url,
	                    target: '_blank'
	                }, {
	                    title: _l('Mailing Lists'),
	                    url: options.mailing_lists,
	                    target: '_blank'
	                }, {
	                    title: _l('Videos'),
	                    url: options.screencasts_url,
	                    target: '_blank'
	                }, {
	                    title: _l('Wiki'),
	                    url: options.wiki_url,
	                    target: '_blank'
	                }, {
	                    title: _l('How to Cite Galaxy'),
	                    url: options.citation_url,
	                    target: '_blank'
	                }, {
	                    title: _l('Interactive Tours'),
	                    url: 'tours'
	                }]
	            };
	            options.terms_url && helpTab.menu.push({
	                title: _l('Terms and Conditions'),
	                url: options.terms_url,
	                target: '_blank'
	            });
	            options.biostar_url && helpTab.menu.unshift({
	                title: _l('Ask a question'),
	                url: 'biostar/biostar_question_redirect',
	                target: '_blank'
	            });
	            options.biostar_url && helpTab.menu.unshift({
	                title: _l('Galaxy Biostar'),
	                url: options.biostar_url_redirect,
	                target: '_blank'
	            });
	            this.add(helpTab);
	
	            //
	            // User tab.
	            //
	            var userTab = {};
	            if (!Galaxy.user.id) {
	                if (options.allow_user_creation) {
	                    userTab = {
	                        id: 'user',
	                        title: _l('Login or Register'),
	                        cls: 'loggedout-only',
	                        tooltip: _l('Account registration or login'),
	                        menu: [{
	                            title: _l('Login'),
	                            url: 'user/login',
	                            target: 'galaxy_main',
	                            noscratchbook: true
	                        }, {
	                            title: _l('Register'),
	                            url: 'user/create',
	                            target: 'galaxy_main',
	                            noscratchbook: true
	                        }]
	                    };
	                } else {
	                    userTab = {
	                        id: 'user',
	                        title: _l('Login'),
	                        cls: 'loggedout-only',
	                        tooltip: _l('Login'),
	                        url: 'user/login',
	                        target: 'galaxy_main',
	                        noscratchbook: true
	                    };
	                }
	            } else {
	                userTab = {
	                    id: 'user',
	                    title: _l('User'),
	                    cls: 'loggedin-only',
	                    tooltip: _l('Account and saved data'),
	                    menu: [{
	                        title: _l('Logged in as') + ' ' + Galaxy.user.get('email')
	                    }, {
	                        title: _l('Preferences'),
	                        url: 'user'
	                    }, {
	                        title: _l('Custom Builds'),
	                        url: 'custom_builds'
	                    }, {
	                        title: _l('Logout'),
	                        url: 'user/logout?session_csrf_token=' + Galaxy.session_csrf_token,
	                        target: '_top',
	                        divider: true
	                    }, {
	                        title: _l('Saved Histories'),
	                        url: 'histories/list',
	                        target: '_top'
	                    }, {
	                        title: _l('Saved Datasets'),
	                        url: 'datasets/list',
	                        target: '_top'
	                    }, {
	                        title: _l('Saved Pages'),
	                        url: 'pages/list',
	                        target: '_top'
	                    }]
	                };
	            }
	            this.add(userTab);
	            var activeView = this.get(options.active_view);
	            activeView && activeView.set('active', true);
	            return new jQuery.Deferred().resolve().promise();
	        }
	    });
	
	    /** Masthead tab **/
	    var Tab = Backbone.View.extend({
	        initialize: function (options) {
	            this.model = options.model;
	            this.setElement(this._template());
	            this.$dropdown = this.$('.dropdown');
	            this.$toggle = this.$('.dropdown-toggle');
	            this.$menu = this.$('.dropdown-menu');
	            this.$note = this.$('.dropdown-note');
	            this.listenTo(this.model, 'change', this.render, this);
	        },
	
	        events: {
	            'click .dropdown-toggle': '_toggleClick'
	        },
	
	        render: function () {
	            var self = this;
	            $('.tooltip').remove();
	            this.$el.attr('id', this.model.id).css({ visibility: this.model.get('visible') && 'visible' || 'hidden' });
	            this.model.set('url', this._formatUrl(this.model.get('url')));
	            this.$note.html(this.model.get('note') || '').removeClass().addClass('dropdown-note').addClass(this.model.get('note_cls')).css({ 'display': this.model.get('show_note') && 'block' || 'none' });
	            this.$toggle.html(this.model.get('title') || '').removeClass().addClass('dropdown-toggle').addClass(this.model.get('cls')).addClass(this.model.get('icon') && 'dropdown-icon fa ' + this.model.get('icon')).addClass(this.model.get('toggle') && 'toggle').attr('target', this.model.get('target')).attr('href', this.model.get('url')).attr('title', this.model.get('tooltip')).tooltip('destroy');
	            this.model.get('tooltip') && this.$toggle.tooltip({ placement: 'bottom' });
	            this.$dropdown.removeClass().addClass('dropdown').addClass(this.model.get('disabled') && 'disabled').addClass(this.model.get('active') && 'active');
	            if (this.model.get('menu') && this.model.get('show_menu')) {
	                this.$menu.show();
	                $('#dd-helper').show().off().on('click', function () {
	                    $('#dd-helper').hide();
	                    self.model.set('show_menu', false);
	                });
	            } else {
	                self.$menu.hide();
	                $('#dd-helper').hide();
	            }
	            this.$menu.empty().removeClass('dropdown-menu');
	            if (this.model.get('menu')) {
	                _.each(this.model.get('menu'), function (menuItem) {
	                    self.$menu.append(self._buildMenuItem(menuItem));
	                    menuItem.divider && self.$menu.append($('<li/>').addClass('divider'));
	                });
	                self.$menu.addClass('dropdown-menu');
	                self.$toggle.append($('<b/>').addClass('caret'));
	            }
	            return this;
	        },
	
	        /** Add new menu item */
	        _buildMenuItem: function (options) {
	            var self = this;
	            options = _.defaults(options || {}, {
	                title: '',
	                url: '',
	                target: '_parent',
	                noscratchbook: false
	            });
	            options.url = self._formatUrl(options.url);
	            return $('<li/>').append($('<a/>').attr('href', options.url).attr('target', options.target).html(options.title).on('click', function (e) {
	                e.preventDefault();
	                self.model.set('show_menu', false);
	                if (options.onclick) {
	                    options.onclick();
	                } else {
	                    Galaxy.frame.add(options);
	                }
	            }));
	        },
	
	        /** Handle click event */
	        _toggleClick: function (e) {
	            var self = this;
	            var model = this.model;
	            e.preventDefault();
	            $('.tooltip').hide();
	            model.trigger('dispatch', function (m) {
	                model.id !== m.id && m.get('menu') && m.set('show_menu', false);
	            });
	            if (!model.get('disabled')) {
	                if (!model.get('menu')) {
	                    model.get('onclick') ? model.get('onclick')() : Galaxy.frame.add(model.attributes);
	                } else {
	                    model.set('show_menu', true);
	                }
	            } else {
	                function buildLink(label, url) {
	                    return $('<div/>').append($('<a/>').attr('href', Galaxy.root + url).html(label)).html();
	                }
	                this.$toggle.popover && this.$toggle.popover('destroy');
	                this.$toggle.popover({
	                    html: true,
	                    placement: 'bottom',
	                    content: 'Please ' + buildLink('login', 'user/login?use_panels=True') + ' or ' + buildLink('register', 'user/create?use_panels=True') + ' to use this feature.'
	                }).popover('show');
	                setTimeout(function () {
	                    self.$toggle.popover('destroy');
	                }, 5000);
	            }
	        },
	
	        /** Url formatting */
	        _formatUrl: function (url) {
	            return typeof url == 'string' && url.indexOf('//') === -1 && url.charAt(0) != '/' && url.lastIndexOf('mailto:', 0) !== 0 ? Galaxy.root + url : url;
	        },
	
	        /** body tempate */
	        _template: function () {
	            return '<ul class="nav navbar-nav">' + '<li class="dropdown">' + '<a class="dropdown-toggle"/>' + '<ul class="dropdown-menu"/>' + '<div class="dropdown-note"/>' + '</li>' + '</ul>';
	        }
	    });
	
	    return {
	        Collection: Collection,
	        Tab: Tab
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {/** Frame manager uses the ui-frames to create the scratch book masthead icon and functionality **/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Frames) {
	    return Backbone.View.extend({
	        initialize: function (options) {
	            var self = this;
	            options = options || {};
	            this.frames = new Frames.View({ visible: false });
	            this.setElement(this.frames.$el);
	            this.buttonActive = options.collection.add({
	                id: 'enable-scratchbook',
	                icon: 'fa-th',
	                tooltip: _l('Enable/Disable Scratchbook'),
	                onclick: function () {
	                    self.active = !self.active;
	                    self.buttonActive.set({
	                        toggle: self.active,
	                        show_note: self.active,
	                        note_cls: self.active && 'fa fa-check'
	                    });
	                    !self.active && self.frames.hide();
	                },
	                onbeforeunload: function () {
	                    if (self.frames.length() > 0) {
	                        return 'You opened ' + self.frames.length() + ' frame(s) which will be lost.';
	                    }
	                }
	            });
	            this.buttonLoad = options.collection.add({
	                id: 'show-scratchbook',
	                icon: 'fa-eye',
	                tooltip: _l('Show/Hide Scratchbook'),
	                show_note: true,
	                visible: false,
	                onclick: function (e) {
	                    self.frames.visible ? self.frames.hide() : self.frames.show();
	                }
	            });
	            this.frames.on('add remove', function () {
	                this.visible && this.length() == 0 && this.hide();
	                self.buttonLoad.set({ 'note': this.length(), 'visible': this.length() > 0 });
	            }).on('show hide ', function () {
	                self.buttonLoad.set({ 'toggle': this.visible, 'icon': this.visible && 'fa-eye' || 'fa-eye-slash' });
	            });
	            this.history_cache = {};
	        },
	
	        /** Add a dataset to the frames */
	        addDataset: function (dataset_id) {
	            var self = this;
	            var current_dataset = null;
	            if (Galaxy && Galaxy.currHistoryPanel) {
	                var history_id = Galaxy.currHistoryPanel.collection.historyId;
	                this.history_cache[history_id] = { name: Galaxy.currHistoryPanel.model.get('name'), dataset_ids: [] };
	                Galaxy.currHistoryPanel.collection.each(function (model) {
	                    !model.get('deleted') && model.get('visible') && self.history_cache[history_id].dataset_ids.push(model.get('id'));
	                });
	            }
	            var _findDataset = function (dataset, offset) {
	                if (dataset) {
	                    var history_details = self.history_cache[dataset.get('history_id')];
	                    if (history_details && history_details.dataset_ids) {
	                        var dataset_list = history_details.dataset_ids;
	                        var pos = dataset_list.indexOf(dataset.get('id'));
	                        if (pos !== -1 && pos + offset >= 0 && pos + offset < dataset_list.length) {
	                            return dataset_list[pos + offset];
	                        }
	                    }
	                }
	            };
	            var _loadDatasetOffset = function (dataset, offset, frame) {
	                var new_dataset_id = _findDataset(dataset, offset);
	                if (new_dataset_id) {
	                    self._loadDataset(new_dataset_id, function (new_dataset, config) {
	                        current_dataset = new_dataset;
	                        frame.model.set(config);
	                    });
	                } else {
	                    frame.model.trigger('change');
	                }
	            };
	            this._loadDataset(dataset_id, function (dataset, config) {
	                current_dataset = dataset;
	                self.add(_.extend({ menu: [{ icon: 'fa fa-chevron-circle-left',
	                        tooltip: 'Previous in History',
	                        onclick: function (frame) {
	                            _loadDatasetOffset(current_dataset, -1, frame);
	                        },
	                        disabled: function () {
	                            return !_findDataset(current_dataset, -1);
	                        } }, { icon: 'fa fa-chevron-circle-right',
	                        tooltip: 'Next in History',
	                        onclick: function (frame) {
	                            _loadDatasetOffset(current_dataset, 1, frame);
	                        },
	                        disabled: function () {
	                            return !_findDataset(current_dataset, 1);
	                        } }] }, config));
	            });
	        },
	
	        _loadDataset: function (dataset_id, callback) {
	            var self = this;
	            __webpack_require__.e/* require */(1, function(__webpack_require__) { /* WEBPACK VAR INJECTION */(function($, _) {var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(16)]; (function (DATA) {
	                var dataset = new DATA.Dataset({ id: dataset_id });
	                $.when(dataset.fetch()).then(function () {
	                    var is_tabular = _.find(['tabular', 'interval'], function (data_type) {
	                        return dataset.get('data_type').indexOf(data_type) !== -1;
	                    });
	                    var title = dataset.get('name');
	                    var history_details = self.history_cache[dataset.get('history_id')];
	                    if (history_details) {
	                        title = history_details.name + ': ' + title;
	                    }
	                    callback(dataset, is_tabular ? {
	                        title: title,
	                        url: null,
	                        content: DATA.createTabularDatasetChunkedView({
	                            model: new DATA.TabularDataset(dataset.toJSON()),
	                            embedded: true,
	                            height: '100%'
	                        }).$el
	                    } : {
	                        title: title,
	                        url: Galaxy.root + 'datasets/' + dataset_id + '/display/?preview=True',
	                        content: null
	                    });
	                });
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(1), __webpack_require__(3)))});
	        },
	
	        /** Add a trackster visualization to the frames. */
	        addTrackster: function (viz_id) {
	            var self = this;
	            __webpack_require__.e/* require */(0, function(__webpack_require__) { /* WEBPACK VAR INJECTION */(function($, _) {var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(51), __webpack_require__(159)]; (function (visualization, trackster) {
	                var viz = new visualization.Visualization({ id: viz_id });
	                $.when(viz.fetch()).then(function () {
	                    var ui = new trackster.TracksterUI(Galaxy.root);
	
	                    // Construct frame config based on dataset's type.
	                    var frame_config = {
	                        title: viz.get('name'),
	                        type: 'other',
	                        content: function (parent_elt) {
	                            // Create view config.
	                            var view_config = {
	                                container: parent_elt,
	                                name: viz.get('title'),
	                                id: viz.id,
	                                // FIXME: this will not work with custom builds b/c the dbkey needed to be encoded.
	                                dbkey: viz.get('dbkey'),
	                                stand_alone: false
	                            },
	                                latest_revision = viz.get('latest_revision'),
	                                drawables = latest_revision.config.view.drawables;
	
	                            // Set up datasets in drawables.
	                            _.each(drawables, function (d) {
	                                d.dataset = {
	                                    hda_ldda: d.hda_ldda,
	                                    id: d.dataset_id
	                                };
	                            });
	                            view = ui.create_visualization(view_config, latest_revision.config.viewport, latest_revision.config.view.drawables, latest_revision.config.bookmarks, false);
	                        }
	                    };
	                    self.add(frame_config);
	                });
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(1), __webpack_require__(3)))});
	        },
	
	        /** Add and display a new frame/window based on options. */
	        add: function (options) {
	            if (options.target == '_blank') {
	                window.open(options.url);
	            } else if (options.target == '_top' || options.target == '_parent' || options.target == '_self') {
	                window.location = options.url;
	            } else if (!this.active || options.noscratchbook) {
	                var $galaxy_main = $(window.parent.document).find('#galaxy_main');
	                if (options.target == 'galaxy_main' || options.target == 'center') {
	                    if ($galaxy_main.length === 0) {
	                        window.location = options.url + (options.url.indexOf('?') == -1 ? '?' : '&') + 'use_panels=True';
	                    } else {
	                        $galaxy_main.attr('src', options.url);
	                    }
	                } else window.location = options.url;
	            } else {
	                this.frames.add(options);
	            }
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, jQuery) {/* ========================================================================
	 * Bootstrap: transition.js v3.0.0
	 * http://twbs.github.com/bootstrap/javascript.html#transitions
	 * ========================================================================
	 * Copyright 2013 Twitter, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * ======================================================================== */
	
	+function ($) {
	  "use strict";
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap');
	
	    var transEndEventNames = {
	      'WebkitTransition': 'webkitTransitionEnd',
	      'MozTransition': 'transitionend',
	      'OTransition': 'oTransitionEnd otransitionend',
	      'transition': 'transitionend'
	    };
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] };
	      }
	    }
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false,
	        $el = this;
	    $(this).one($.support.transition.end, function () {
	      called = true;
	    });
	    var callback = function () {
	      if (!called) $($el).trigger($.support.transition.end);
	    };
	    setTimeout(callback, duration);
	    return this;
	  };
	
	  $(function () {
	    $.support.transition = transitionEnd();
	  });
	}(__webpack_provided_window_dot_jQuery);
	/* ========================================================================
	 * Bootstrap: tab.js v3.0.0
	 * http://twbs.github.com/bootstrap/javascript.html#tabs
	 * ========================================================================
	 * Copyright 2012 Twitter, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * ======================================================================== */
	
	+function ($) {
	  "use strict";
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    this.element = $(element);
	  };
	
	  Tab.prototype.show = function () {
	    var $this = this.element;
	    var $ul = $this.closest('ul:not(.dropdown-menu)');
	    var selector = $this.attr('data-target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); //strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return;
	
	    var previous = $ul.find('.active:last a')[0];
	    var e = $.Event('show.bs.tab', {
	      relatedTarget: previous
	    });
	
	    $this.trigger(e);
	
	    if (e.isDefaultPrevented()) return;
	
	    var $target = $(selector);
	
	    this.activate($this.parent('li'), $ul);
	    this.activate($target, $target.parent(), function () {
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: previous
	      });
	    });
	  };
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active = container.find('> .active');
	    var transition = callback && $.support.transition && $active.hasClass('fade');
	
	    function next() {
	      $active.removeClass('active').find('> .dropdown-menu > .active').removeClass('active');
	
	      element.addClass('active');
	
	      if (transition) {
	        element[0].offsetWidth; // reflow for transition
	        element.addClass('in');
	      } else {
	        element.removeClass('fade');
	      }
	
	      if (element.parent('.dropdown-menu')) {
	        element.closest('li.dropdown').addClass('active');
	      }
	
	      callback && callback();
	    }
	
	    transition ? $active.one($.support.transition.end, next).emulateTransitionEnd(150) : next();
	
	    $active.removeClass('in');
	  };
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  var old = $.fn.tab;
	
	  $.fn.tab = function (option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.tab');
	
	      if (!data) $this.data('bs.tab', data = new Tab(this));
	      if (typeof option == 'string') data[option]();
	    });
	  };
	
	  $.fn.tab.Constructor = Tab;
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old;
	    return this;
	  };
	
	  // TAB DATA-API
	  // ============
	
	  $(document).on('click.bs.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]', function (e) {
	    e.preventDefault();
	    $(this).tab('show');
	  });
	}(__webpack_provided_window_dot_jQuery);
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.0.0
	 * http://twbs.github.com/bootstrap/javascript.html#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2012 Twitter, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * ======================================================================== */
	
	+function ($) {
	  "use strict";
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type = this.options = this.enabled = this.timeout = this.hoverState = this.$element = null;
	
	    this.init('tooltip', element, options);
	  };
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: 'body'
	  };
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled = true;
	    this.type = type;
	    this.$element = $(element);
	    this.options = this.getOptions(options);
	
	    var triggers = this.options.trigger.split(' ');
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i];
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this));
	      } else if (trigger != 'manual') {
	        var eventIn = trigger == 'hover' ? 'mouseenter' : 'focus';
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'blur';
	
	        this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this));
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this));
	      }
	    }
	
	    this.options.selector ? this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' }) : this.fixTitle();
	  };
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS;
	  };
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options);
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      };
	    }
	
	    return options;
	  };
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options = {};
	    var defaults = this.getDefaults();
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value;
	    });
	
	    return options;
	  };
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type);
	
	    clearTimeout(self.timeout);
	
	    self.hoverState = 'in';
	
	    if (!self.options.delay || !self.options.delay.show) return self.show();
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show();
	    }, self.options.delay.show);
	  };
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type);
	
	    clearTimeout(self.timeout);
	
	    self.hoverState = 'out';
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide();
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide();
	    }, self.options.delay.hide);
	  };
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type);
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e);
	
	      if (e.isDefaultPrevented()) return;
	
	      var $tip = this.tip();
	
	      this.setContent();
	
	      if (this.options.animation) $tip.addClass('fade');
	
	      var placement = typeof this.options.placement == 'function' ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;
	
	      var autoToken = /\s?auto?\s?/i;
	      var autoPlace = autoToken.test(placement);
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top';
	
	      $tip.detach().css({ top: 0, left: 0, display: 'block' }).addClass(placement);
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);
	
	      var pos = this.getPosition();
	      var actualWidth = $tip[0].offsetWidth;
	      var actualHeight = $tip[0].offsetHeight;
	
	      if (autoPlace) {
	        var $parent = this.$element.parent();
	
	        var orgPlacement = placement;
	        var docScroll = document.documentElement.scrollTop || document.body.scrollTop;
	        var parentWidth = this.options.container == 'body' ? window.innerWidth : $parent.outerWidth();
	        var parentHeight = this.options.container == 'body' ? window.innerHeight : $parent.outerHeight();
	        var parentLeft = this.options.container == 'body' ? 0 : $parent.offset().left;
	
	        placement = placement == 'bottom' && pos.top + pos.height + actualHeight - docScroll > parentHeight ? 'top' : placement == 'top' && pos.top - docScroll - actualHeight < 0 ? 'bottom' : placement == 'right' && pos.right + actualWidth > parentWidth ? 'left' : placement == 'left' && pos.left - actualWidth < parentLeft ? 'right' : placement;
	
	        $tip.removeClass(orgPlacement).addClass(placement);
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);
	
	      this.applyPlacement(calculatedOffset, placement);
	      this.$element.trigger('shown.bs.' + this.type);
	    }
	  };
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var replace;
	    var $tip = this.tip();
	    var width = $tip[0].offsetWidth;
	    var height = $tip[0].offsetHeight;
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10);
	    var marginLeft = parseInt($tip.css('margin-left'), 10);
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop)) marginTop = 0;
	    if (isNaN(marginLeft)) marginLeft = 0;
	
	    offset.top = offset.top + marginTop;
	    offset.left = offset.left + marginLeft;
	
	    $tip.offset(offset).addClass('in');
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth = $tip[0].offsetWidth;
	    var actualHeight = $tip[0].offsetHeight;
	
	    if (placement == 'top' && actualHeight != height) {
	      replace = true;
	      offset.top = offset.top + height - actualHeight;
	    }
	
	    if (/bottom|top/.test(placement)) {
	      var delta = 0;
	
	      if (offset.left < 0) {
	        delta = offset.left * -2;
	        offset.left = 0;
	
	        $tip.offset(offset);
	
	        actualWidth = $tip[0].offsetWidth;
	        actualHeight = $tip[0].offsetHeight;
	      }
	
	      this.replaceArrow(delta - width + actualWidth, actualWidth, 'left');
	    } else {
	      this.replaceArrow(actualHeight - height, actualHeight, 'top');
	    }
	
	    if (replace) $tip.offset(offset);
	  };
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, position) {
	    this.arrow().css(position, delta ? 50 * (1 - delta / dimension) + "%" : '');
	  };
	
	  Tooltip.prototype.setContent = function () {
	    var $tip = this.tip();
	    var title = this.getTitle();
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title);
	    $tip.removeClass('fade in top bottom left right');
	  };
	
	  Tooltip.prototype.hide = function () {
	    var that = this;
	    var $tip = this.tip();
	    var e = $.Event('hide.bs.' + this.type);
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach();
	    }
	
	    this.$element.trigger(e);
	
	    if (e.isDefaultPrevented()) return;
	
	    $tip.removeClass('in');
	
	    $.support.transition && this.$tip.hasClass('fade') ? $tip.one($.support.transition.end, complete).emulateTransitionEnd(150) : complete();
	
	    this.$element.trigger('hidden.bs.' + this.type);
	
	    return this;
	  };
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element;
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '');
	    }
	  };
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle();
	  };
	
	  Tooltip.prototype.getPosition = function () {
	    var el = this.$element[0];
	    return $.extend({}, typeof el.getBoundingClientRect == 'function' ? el.getBoundingClientRect() : {
	      width: el.offsetWidth,
	      height: el.offsetHeight
	    }, this.$element.offset());
	  };
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'top' ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'left' ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	    /* placement == 'right' */{ top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
	  };
	
	  Tooltip.prototype.getTitle = function () {
	    var title;
	    var $e = this.$element;
	    var o = this.options;
	
	    title = $e.attr('data-original-title') || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title);
	
	    return title;
	  };
	
	  Tooltip.prototype.tip = function () {
	    return this.$tip = this.$tip || $(this.options.template);
	  };
	
	  Tooltip.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow');
	  };
	
	  Tooltip.prototype.validate = function () {
	    if (!this.$element[0].parentNode) {
	      this.hide();
	      this.$element = null;
	      this.options = null;
	    }
	  };
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true;
	  };
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false;
	  };
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled;
	  };
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = e ? $(e.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type) : this;
	    self.tip().hasClass('in') ? self.leave(self) : self.enter(self);
	  };
	
	  Tooltip.prototype.destroy = function () {
	    this.hide().$element.off('.' + this.type).removeData('bs.' + this.type);
	  };
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  var old = $.fn.tooltip;
	
	  $.fn.tooltip = function (option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.tooltip');
	      var options = typeof option == 'object' && option;
	
	      if (!data) $this.data('bs.tooltip', data = new Tooltip(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  };
	
	  $.fn.tooltip.Constructor = Tooltip;
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old;
	    return this;
	  };
	}(__webpack_provided_window_dot_jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.0.0
	 * http://twbs.github.com/bootstrap/javascript.html#dropdowns
	 * ========================================================================
	 * Copyright 2012 Twitter, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * ======================================================================== */
	
	+function ($) {
	  "use strict";
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop';
	  var toggle = '[data-toggle=dropdown]';
	  var Dropdown = function (element) {
	    var $el = $(element).on('click.bs.dropdown', this.toggle);
	  };
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this);
	
	    if ($this.is('.disabled, :disabled')) return;
	
	    var $parent = getParent($this);
	    var isActive = $parent.hasClass('open');
	
	    clearMenus();
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we we use a backdrop because click events don't delegate
	        $('<div class="dropdown-backdrop"/>').insertAfter($(this)).on('click', clearMenus);
	      }
	
	      $parent.trigger(e = $.Event('show.bs.dropdown'));
	
	      if (e.isDefaultPrevented()) return;
	
	      $parent.toggleClass('open').trigger('shown.bs.dropdown');
	
	      $this.focus();
	    }
	
	    return false;
	  };
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27)/.test(e.keyCode)) return;
	
	    var $this = $(this);
	
	    e.preventDefault();
	    e.stopPropagation();
	
	    if ($this.is('.disabled, :disabled')) return;
	
	    var $parent = getParent($this);
	    var isActive = $parent.hasClass('open');
	
	    if (!isActive || isActive && e.keyCode == 27) {
	      if (e.which == 27) $parent.find(toggle).focus();
	      return $this.click();
	    }
	
	    var $items = $('[role=menu] li:not(.divider):visible a', $parent);
	
	    if (!$items.length) return;
	
	    var index = $items.index($items.filter(':focus'));
	
	    if (e.keyCode == 38 && index > 0) index--; // up
	    if (e.keyCode == 40 && index < $items.length - 1) index++; // down
	    if (!~index) index = 0;
	
	    $items.eq(index).focus();
	  };
	
	  function clearMenus() {
	    $(backdrop).remove();
	    $(toggle).each(function (e) {
	      var $parent = getParent($(this));
	      if (!$parent.hasClass('open')) return;
	      $parent.trigger(e = $.Event('hide.bs.dropdown'));
	      if (e.isDefaultPrevented()) return;
	      $parent.removeClass('open').trigger('hidden.bs.dropdown');
	    });
	  }
	
	  function getParent($this) {
	    var selector = $this.attr('data-target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && /#/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); //strip for ie7
	    }
	
	    var $parent = selector && $(selector);
	
	    return $parent && $parent.length ? $parent : $this.parent();
	  }
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  var old = $.fn.dropdown;
	
	  $.fn.dropdown = function (option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('dropdown');
	
	      if (!data) $this.data('dropdown', data = new Dropdown(this));
	      if (typeof option == 'string') data[option].call($this);
	    });
	  };
	
	  $.fn.dropdown.Constructor = Dropdown;
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old;
	    return this;
	  };
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document).on('click.bs.dropdown.data-api', clearMenus).on('click.bs.dropdown.data-api', '.dropdown form', function (e) {
	    e.stopPropagation();
	  }).on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle).on('keydown.bs.dropdown.data-api', toggle + ', [role=menu]', Dropdown.prototype.keydown);
	}(__webpack_provided_window_dot_jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.0.3
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2013 Twitter, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * ======================================================================== */
	
	+function ($) {
	  "use strict";
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options);
	  };
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js');
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  });
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);
	
	  Popover.prototype.constructor = Popover;
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS;
	  };
	
	  Popover.prototype.setContent = function () {
	    var $tip = this.tip();
	    var title = this.getTitle();
	    var content = this.getContent();
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title);
	    $tip.find('.popover-content')[this.options.html ? 'html' : 'text'](content);
	
	    $tip.removeClass('fade top bottom left right in');
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide();
	  };
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent();
	  };
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element;
	    var o = this.options;
	
	    return $e.attr('data-content') || (typeof o.content == 'function' ? o.content.call($e[0]) : o.content);
	  };
	
	  Popover.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.arrow');
	  };
	
	  Popover.prototype.tip = function () {
	    if (!this.$tip) this.$tip = $(this.options.template);
	    return this.$tip;
	  };
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  var old = $.fn.popover;
	
	  $.fn.popover = function (option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.popover');
	      var options = typeof option == 'object' && option;
	
	      if (!data) $this.data('bs.popover', data = new Popover(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  };
	
	  $.fn.popover.Constructor = Popover;
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old;
	    return this;
	  };
	}(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 114 */,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*
	  http://github.com/danpalmer/jquery.complexify.js
	
	  This code is distributed under the WTFPL v2:
	*/
	(function ($) {
	
	  $.fn.extend({
	    complexify: function (options, callback) {
	
	      var MIN_COMPLEXITY = 49; // 12 chars with Upper, Lower and Number
	      var MAX_COMPLEXITY = 120; //  25 chars, all charsets
	      var CHARSETS = [
	      // Commonly Used
	      ////////////////////
	      [0x0020, 0x0020], // Space
	      [0x0030, 0x0039], // Numbers
	      [0x0041, 0x005A], // Uppercase
	      [0x0061, 0x007A], // Lowercase
	      [0x0021, 0x002F], // Punctuation
	      [0x003A, 0x0040], // Punctuation
	      [0x005B, 0x0060], // Punctuation
	      [0x007B, 0x007E], // Punctuation
	      // Everything Else
	      ////////////////////
	      [0x0080, 0x00FF], // Latin-1 Supplement
	      [0x0100, 0x017F], // Latin Extended-A
	      [0x0180, 0x024F], // Latin Extended-B
	      [0x0250, 0x02AF], // IPA Extensions
	      [0x02B0, 0x02FF], // Spacing Modifier Letters
	      [0x0300, 0x036F], // Combining Diacritical Marks
	      [0x0370, 0x03FF], // Greek
	      [0x0400, 0x04FF], // Cyrillic
	      [0x0530, 0x058F], // Armenian
	      [0x0590, 0x05FF], // Hebrew
	      [0x0600, 0x06FF], // Arabic
	      [0x0700, 0x074F], // Syriac
	      [0x0780, 0x07BF], // Thaana
	      [0x0900, 0x097F], // Devanagari
	      [0x0980, 0x09FF], // Bengali
	      [0x0A00, 0x0A7F], // Gurmukhi
	      [0x0A80, 0x0AFF], // Gujarati
	      [0x0B00, 0x0B7F], // Oriya
	      [0x0B80, 0x0BFF], // Tamil
	      [0x0C00, 0x0C7F], // Telugu
	      [0x0C80, 0x0CFF], // Kannada
	      [0x0D00, 0x0D7F], // Malayalam
	      [0x0D80, 0x0DFF], // Sinhala
	      [0x0E00, 0x0E7F], // Thai
	      [0x0E80, 0x0EFF], // Lao
	      [0x0F00, 0x0FFF], // Tibetan
	      [0x1000, 0x109F], // Myanmar
	      [0x10A0, 0x10FF], // Georgian
	      [0x1100, 0x11FF], // Hangul Jamo
	      [0x1200, 0x137F], // Ethiopic
	      [0x13A0, 0x13FF], // Cherokee
	      [0x1400, 0x167F], // Unified Canadian Aboriginal Syllabics
	      [0x1680, 0x169F], // Ogham
	      [0x16A0, 0x16FF], // Runic
	      [0x1780, 0x17FF], // Khmer
	      [0x1800, 0x18AF], // Mongolian
	      [0x1E00, 0x1EFF], // Latin Extended Additional
	      [0x1F00, 0x1FFF], // Greek Extended
	      [0x2000, 0x206F], // General Punctuation
	      [0x2070, 0x209F], // Superscripts and Subscripts
	      [0x20A0, 0x20CF], // Currency Symbols
	      [0x20D0, 0x20FF], // Combining Marks for Symbols
	      [0x2100, 0x214F], // Letterlike Symbols
	      [0x2150, 0x218F], // Number Forms
	      [0x2190, 0x21FF], // Arrows
	      [0x2200, 0x22FF], // Mathematical Operators
	      [0x2300, 0x23FF], // Miscellaneous Technical
	      [0x2400, 0x243F], // Control Pictures
	      [0x2440, 0x245F], // Optical Character Recognition
	      [0x2460, 0x24FF], // Enclosed Alphanumerics
	      [0x2500, 0x257F], // Box Drawing
	      [0x2580, 0x259F], // Block Elements
	      [0x25A0, 0x25FF], // Geometric Shapes
	      [0x2600, 0x26FF], // Miscellaneous Symbols
	      [0x2700, 0x27BF], // Dingbats
	      [0x2800, 0x28FF], // Braille Patterns
	      [0x2E80, 0x2EFF], // CJK Radicals Supplement
	      [0x2F00, 0x2FDF], // Kangxi Radicals
	      [0x2FF0, 0x2FFF], // Ideographic Description Characters
	      [0x3000, 0x303F], // CJK Symbols and Punctuation
	      [0x3040, 0x309F], // Hiragana
	      [0x30A0, 0x30FF], // Katakana
	      [0x3100, 0x312F], // Bopomofo
	      [0x3130, 0x318F], // Hangul Compatibility Jamo
	      [0x3190, 0x319F], // Kanbun
	      [0x31A0, 0x31BF], // Bopomofo Extended
	      [0x3200, 0x32FF], // Enclosed CJK Letters and Months
	      [0x3300, 0x33FF], // CJK Compatibility
	      [0x3400, 0x4DB5], // CJK Unified Ideographs Extension A
	      [0x4E00, 0x9FFF], // CJK Unified Ideographs
	      [0xA000, 0xA48F], // Yi Syllables
	      [0xA490, 0xA4CF], // Yi Radicals
	      [0xAC00, 0xD7A3], // Hangul Syllables
	      [0xD800, 0xDB7F], // High Surrogates
	      [0xDB80, 0xDBFF], // High Private Use Surrogates
	      [0xDC00, 0xDFFF], // Low Surrogates
	      [0xE000, 0xF8FF], // Private Use
	      [0xF900, 0xFAFF], // CJK Compatibility Ideographs
	      [0xFB00, 0xFB4F], // Alphabetic Presentation Forms
	      [0xFB50, 0xFDFF], // Arabic Presentation Forms-A
	      [0xFE20, 0xFE2F], // Combining Half Marks
	      [0xFE30, 0xFE4F], // CJK Compatibility Forms
	      [0xFE50, 0xFE6F], // Small Form Variants
	      [0xFE70, 0xFEFE], // Arabic Presentation Forms-B
	      [0xFEFF, 0xFEFF], // Specials
	      [0xFF00, 0xFFEF], // Halfwidth and Fullwidth Forms
	      [0xFFF0, 0xFFFD] // Specials
	      ];
	
	      var defaults = {
	        minimumChars: 8,
	        strengthScaleFactor: 1,
	        bannedPasswords: window.COMPLEXIFY_BANLIST || [],
	        banMode: 'strict' // (strict|loose)
	      };
	
	      if ($.isFunction(options) && !callback) {
	        callback = options;
	        options = {};
	      }
	
	      options = $.extend(defaults, options);
	
	      function additionalComplexityForCharset(str, charset) {
	        for (var i = str.length - 1; i >= 0; i--) {
	          if (charset[0] <= str.charCodeAt(i) && str.charCodeAt(i) <= charset[1]) {
	            return charset[1] - charset[0] + 1;
	          }
	        }
	        return 0;
	      }
	
	      function inBanlist(str) {
	        if (options.banMode === 'strict') {
	          for (var i = 0; i < options.bannedPasswords.length; i++) {
	            if (str.toLowerCase().indexOf(options.bannedPasswords[i].toLowerCase()) !== -1) {
	              return true;
	            }
	          }
	          return false;
	        } else {
	          return $.inArray(str, options.bannedPasswords) > -1 ? true : false;
	        }
	      }
	
	      function evaluateSecurity() {
	        var password = $(this).val();
	        var complexity = 0,
	            valid = false;
	
	        // Reset complexity to 0 when banned password is found
	        if (!inBanlist(password)) {
	
	          // Add character complexity
	          for (var i = CHARSETS.length - 1; i >= 0; i--) {
	            complexity += additionalComplexityForCharset(password, CHARSETS[i]);
	          }
	        } else {
	          complexity = 1;
	        }
	
	        // Use natural log to produce linear scale
	        complexity = Math.log(Math.pow(complexity, password.length)) * (1 / options.strengthScaleFactor);
	
	        valid = complexity > MIN_COMPLEXITY && password.length >= options.minimumChars;
	
	        // Scale to percentage, so it can be used for a progress bar
	        complexity = complexity / MAX_COMPLEXITY * 100;
	        complexity = complexity > 100 ? 100 : complexity;
	
	        callback.call(this, valid, complexity);
	      }
	
	      this.each(function () {
	        if ($(this).val()) {
	          evaluateSecurity.apply(this);
	        }
	      });
	
	      return this.each(function () {
	        $(this).bind('keyup focus input propertychange mouseup', evaluateSecurity);
	      });
	    }
	  });
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	*
	* jquery.sparkline.js
	*
	* v2.1.2
	* (c) Splunk, Inc
	* Contact: Gareth Watts (gareth@splunk.com)
	* http://omnipotent.net/jquery.sparkline/
	*
	* Generates inline sparkline charts from data supplied either to the method
	* or inline in HTML
	*
	* Compatible with Internet Explorer 6.0+ and modern browsers equipped with the canvas tag
	* (Firefox 2.0+, Safari, Opera, etc)
	*
	* License: New BSD License
	*
	* Copyright (c) 2012, Splunk Inc.
	* All rights reserved.
	*
	* Redistribution and use in source and binary forms, with or without modification,
	* are permitted provided that the following conditions are met:
	*
	*     * Redistributions of source code must retain the above copyright notice,
	*       this list of conditions and the following disclaimer.
	*     * Redistributions in binary form must reproduce the above copyright notice,
	*       this list of conditions and the following disclaimer in the documentation
	*       and/or other materials provided with the distribution.
	*     * Neither the name of Splunk Inc nor the names of its contributors may
	*       be used to endorse or promote products derived from this software without
	*       specific prior written permission.
	*
	* THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
	* EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES
	* OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT
	* SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	* SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
	* OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
	* HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
	* OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	* SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*
	*
	* Usage:
	*  $(selector).sparkline(values, options)
	*
	* If values is undefined or set to 'html' then the data values are read from the specified tag:
	*   <p>Sparkline: <span class="sparkline">1,4,6,6,8,5,3,5</span></p>
	*   $('.sparkline').sparkline();
	* There must be no spaces in the enclosed data set
	*
	* Otherwise values must be an array of numbers or null values
	*    <p>Sparkline: <span id="sparkline1">This text replaced if the browser is compatible</span></p>
	*    $('#sparkline1').sparkline([1,4,6,6,8,5,3,5])
	*    $('#sparkline2').sparkline([1,4,6,null,null,5,3,5])
	*
	* Values can also be specified in an HTML comment, or as a values attribute:
	*    <p>Sparkline: <span class="sparkline"><!--1,4,6,6,8,5,3,5 --></span></p>
	*    <p>Sparkline: <span class="sparkline" values="1,4,6,6,8,5,3,5"></span></p>
	*    $('.sparkline').sparkline();
	*
	* For line charts, x values can also be specified:
	*   <p>Sparkline: <span class="sparkline">1:1,2.7:4,3.4:6,5:6,6:8,8.7:5,9:3,10:5</span></p>
	*    $('#sparkline1').sparkline([ [1,1], [2.7,4], [3.4,6], [5,6], [6,8], [8.7,5], [9,3], [10,5] ])
	*
	* By default, options should be passed in as teh second argument to the sparkline function:
	*   $('.sparkline').sparkline([1,2,3,4], {type: 'bar'})
	*
	* Options can also be set by passing them on the tag itself.  This feature is disabled by default though
	* as there's a slight performance overhead:
	*   $('.sparkline').sparkline([1,2,3,4], {enableTagOptions: true})
	*   <p>Sparkline: <span class="sparkline" sparkType="bar" sparkBarColor="red">loading</span></p>
	* Prefix all options supplied as tag attribute with "spark" (configurable by setting tagOptionPrefix)
	*
	* Supported options:
	*   lineColor - Color of the line used for the chart
	*   fillColor - Color used to fill in the chart - Set to '' or false for a transparent chart
	*   width - Width of the chart - Defaults to 3 times the number of values in pixels
	*   height - Height of the chart - Defaults to the height of the containing element
	*   chartRangeMin - Specify the minimum value to use for the Y range of the chart - Defaults to the minimum value supplied
	*   chartRangeMax - Specify the maximum value to use for the Y range of the chart - Defaults to the maximum value supplied
	*   chartRangeClip - Clip out of range values to the max/min specified by chartRangeMin and chartRangeMax
	*   chartRangeMinX - Specify the minimum value to use for the X range of the chart - Defaults to the minimum value supplied
	*   chartRangeMaxX - Specify the maximum value to use for the X range of the chart - Defaults to the maximum value supplied
	*   composite - If true then don't erase any existing chart attached to the tag, but draw
	*           another chart over the top - Note that width and height are ignored if an
	*           existing chart is detected.
	*   tagValuesAttribute - Name of tag attribute to check for data values - Defaults to 'values'
	*   enableTagOptions - Whether to check tags for sparkline options
	*   tagOptionPrefix - Prefix used for options supplied as tag attributes - Defaults to 'spark'
	*   disableHiddenCheck - If set to true, then the plugin will assume that charts will never be drawn into a
	*           hidden dom element, avoding a browser reflow
	*   disableInteraction - If set to true then all mouseover/click interaction behaviour will be disabled,
	*       making the plugin perform much like it did in 1.x
	*   disableTooltips - If set to true then tooltips will be disabled - Defaults to false (tooltips enabled)
	*   disableHighlight - If set to true then highlighting of selected chart elements on mouseover will be disabled
	*       defaults to false (highlights enabled)
	*   highlightLighten - Factor to lighten/darken highlighted chart values by - Defaults to 1.4 for a 40% increase
	*   tooltipContainer - Specify which DOM element the tooltip should be rendered into - defaults to document.body
	*   tooltipClassname - Optional CSS classname to apply to tooltips - If not specified then a default style will be applied
	*   tooltipOffsetX - How many pixels away from the mouse pointer to render the tooltip on the X axis
	*   tooltipOffsetY - How many pixels away from the mouse pointer to render the tooltip on the r axis
	*   tooltipFormatter  - Optional callback that allows you to override the HTML displayed in the tooltip
	*       callback is given arguments of (sparkline, options, fields)
	*   tooltipChartTitle - If specified then the tooltip uses the string specified by this setting as a title
	*   tooltipFormat - A format string or SPFormat object  (or an array thereof for multiple entries)
	*       to control the format of the tooltip
	*   tooltipPrefix - A string to prepend to each field displayed in a tooltip
	*   tooltipSuffix - A string to append to each field displayed in a tooltip
	*   tooltipSkipNull - If true then null values will not have a tooltip displayed (defaults to true)
	*   tooltipValueLookups - An object or range map to map field values to tooltip strings
	*       (eg. to map -1 to "Lost", 0 to "Draw", and 1 to "Win")
	*   numberFormatter - Optional callback for formatting numbers in tooltips
	*   numberDigitGroupSep - Character to use for group separator in numbers "1,234" - Defaults to ","
	*   numberDecimalMark - Character to use for the decimal point when formatting numbers - Defaults to "."
	*   numberDigitGroupCount - Number of digits between group separator - Defaults to 3
	*
	* There are 7 types of sparkline, selected by supplying a "type" option of 'line' (default),
	* 'bar', 'tristate', 'bullet', 'discrete', 'pie' or 'box'
	*    line - Line chart.  Options:
	*       spotColor - Set to '' to not end each line in a circular spot
	*       minSpotColor - If set, color of spot at minimum value
	*       maxSpotColor - If set, color of spot at maximum value
	*       spotRadius - Radius in pixels
	*       lineWidth - Width of line in pixels
	*       normalRangeMin
	*       normalRangeMax - If set draws a filled horizontal bar between these two values marking the "normal"
	*                      or expected range of values
	*       normalRangeColor - Color to use for the above bar
	*       drawNormalOnTop - Draw the normal range above the chart fill color if true
	*       defaultPixelsPerValue - Defaults to 3 pixels of width for each value in the chart
	*       highlightSpotColor - The color to use for drawing a highlight spot on mouseover - Set to null to disable
	*       highlightLineColor - The color to use for drawing a highlight line on mouseover - Set to null to disable
	*       valueSpots - Specify which points to draw spots on, and in which color.  Accepts a range map
	*
	*   bar - Bar chart.  Options:
	*       barColor - Color of bars for postive values
	*       negBarColor - Color of bars for negative values
	*       zeroColor - Color of bars with zero values
	*       nullColor - Color of bars with null values - Defaults to omitting the bar entirely
	*       barWidth - Width of bars in pixels
	*       colorMap - Optional mappnig of values to colors to override the *BarColor values above
	*                  can be an Array of values to control the color of individual bars or a range map
	*                  to specify colors for individual ranges of values
	*       barSpacing - Gap between bars in pixels
	*       zeroAxis - Centers the y-axis around zero if true
	*
	*   tristate - Charts values of win (>0), lose (<0) or draw (=0)
	*       posBarColor - Color of win values
	*       negBarColor - Color of lose values
	*       zeroBarColor - Color of draw values
	*       barWidth - Width of bars in pixels
	*       barSpacing - Gap between bars in pixels
	*       colorMap - Optional mappnig of values to colors to override the *BarColor values above
	*                  can be an Array of values to control the color of individual bars or a range map
	*                  to specify colors for individual ranges of values
	*
	*   discrete - Options:
	*       lineHeight - Height of each line in pixels - Defaults to 30% of the graph height
	*       thesholdValue - Values less than this value will be drawn using thresholdColor instead of lineColor
	*       thresholdColor
	*
	*   bullet - Values for bullet graphs msut be in the order: target, performance, range1, range2, range3, ...
	*       options:
	*       targetColor - The color of the vertical target marker
	*       targetWidth - The width of the target marker in pixels
	*       performanceColor - The color of the performance measure horizontal bar
	*       rangeColors - Colors to use for each qualitative range background color
	*
	*   pie - Pie chart. Options:
	*       sliceColors - An array of colors to use for pie slices
	*       offset - Angle in degrees to offset the first slice - Try -90 or +90
	*       borderWidth - Width of border to draw around the pie chart, in pixels - Defaults to 0 (no border)
	*       borderColor - Color to use for the pie chart border - Defaults to #000
	*
	*   box - Box plot. Options:
	*       raw - Set to true to supply pre-computed plot points as values
	*             values should be: low_outlier, low_whisker, q1, median, q3, high_whisker, high_outlier
	*             When set to false you can supply any number of values and the box plot will
	*             be computed for you.  Default is false.
	*       showOutliers - Set to true (default) to display outliers as circles
	*       outlierIQR - Interquartile range used to determine outliers.  Default 1.5
	*       boxLineColor - Outline color of the box
	*       boxFillColor - Fill color for the box
	*       whiskerColor - Line color used for whiskers
	*       outlierLineColor - Outline color of outlier circles
	*       outlierFillColor - Fill color of the outlier circles
	*       spotRadius - Radius of outlier circles
	*       medianColor - Line color of the median line
	*       target - Draw a target cross hair at the supplied value (default undefined)
	*
	*
	*
	*   Examples:
	*   $('#sparkline1').sparkline(myvalues, { lineColor: '#f00', fillColor: false });
	*   $('.barsparks').sparkline('html', { type:'bar', height:'40px', barWidth:5 });
	*   $('#tristate').sparkline([1,1,-1,1,0,0,-1], { type:'tristate' }):
	*   $('#discrete').sparkline([1,3,4,5,5,3,4,5], { type:'discrete' });
	*   $('#bullet').sparkline([10,12,12,9,7], { type:'bullet' });
	*   $('#pie').sparkline([1,1,2], { type:'pie' });
	*/
	
	/*jslint regexp: true, browser: true, jquery: true, white: true, nomen: false, plusplus: false, maxerr: 500, indent: 4 */
	
	(function (document, Math, undefined) {
	    // performance/minified-size optimization
	    (function (factory) {
	        if (true) {
	            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else if (jQuery && !jQuery.fn.sparkline) {
	            factory(jQuery);
	        }
	    })(function ($) {
	        'use strict';
	
	        var UNSET_OPTION = {},
	            getDefaults,
	            createClass,
	            SPFormat,
	            clipval,
	            quartile,
	            normalizeValue,
	            normalizeValues,
	            remove,
	            isNumber,
	            all,
	            sum,
	            addCSS,
	            ensureArray,
	            formatNumber,
	            RangeMap,
	            MouseHandler,
	            Tooltip,
	            barHighlightMixin,
	            line,
	            bar,
	            tristate,
	            discrete,
	            bullet,
	            pie,
	            box,
	            defaultStyles,
	            initStyles,
	            VShape,
	            VCanvas_base,
	            VCanvas_canvas,
	            VCanvas_vml,
	            pending,
	            shapeCount = 0;
	
	        /**
	         * Default configuration settings
	         */
	        getDefaults = function () {
	            return {
	                // Settings common to most/all chart types
	                common: {
	                    type: 'line',
	                    lineColor: '#00f',
	                    fillColor: '#cdf',
	                    defaultPixelsPerValue: 3,
	                    width: 'auto',
	                    height: 'auto',
	                    composite: false,
	                    tagValuesAttribute: 'values',
	                    tagOptionsPrefix: 'spark',
	                    enableTagOptions: false,
	                    enableHighlight: true,
	                    highlightLighten: 1.4,
	                    tooltipSkipNull: true,
	                    tooltipPrefix: '',
	                    tooltipSuffix: '',
	                    disableHiddenCheck: false,
	                    numberFormatter: false,
	                    numberDigitGroupCount: 3,
	                    numberDigitGroupSep: ',',
	                    numberDecimalMark: '.',
	                    disableTooltips: false,
	                    disableInteraction: false
	                },
	                // Defaults for line charts
	                line: {
	                    spotColor: '#f80',
	                    highlightSpotColor: '#5f5',
	                    highlightLineColor: '#f22',
	                    spotRadius: 1.5,
	                    minSpotColor: '#f80',
	                    maxSpotColor: '#f80',
	                    lineWidth: 1,
	                    normalRangeMin: undefined,
	                    normalRangeMax: undefined,
	                    normalRangeColor: '#ccc',
	                    drawNormalOnTop: false,
	                    chartRangeMin: undefined,
	                    chartRangeMax: undefined,
	                    chartRangeMinX: undefined,
	                    chartRangeMaxX: undefined,
	                    tooltipFormat: new SPFormat('<span style="color: {{color}}">&#9679;</span> {{prefix}}{{y}}{{suffix}}')
	                },
	                // Defaults for bar charts
	                bar: {
	                    barColor: '#3366cc',
	                    negBarColor: '#f44',
	                    stackedBarColor: ['#3366cc', '#dc3912', '#ff9900', '#109618', '#66aa00', '#dd4477', '#0099c6', '#990099'],
	                    zeroColor: undefined,
	                    nullColor: undefined,
	                    zeroAxis: true,
	                    barWidth: 4,
	                    barSpacing: 1,
	                    chartRangeMax: undefined,
	                    chartRangeMin: undefined,
	                    chartRangeClip: false,
	                    colorMap: undefined,
	                    tooltipFormat: new SPFormat('<span style="color: {{color}}">&#9679;</span> {{prefix}}{{value}}{{suffix}}')
	                },
	                // Defaults for tristate charts
	                tristate: {
	                    barWidth: 4,
	                    barSpacing: 1,
	                    posBarColor: '#6f6',
	                    negBarColor: '#f44',
	                    zeroBarColor: '#999',
	                    colorMap: {},
	                    tooltipFormat: new SPFormat('<span style="color: {{color}}">&#9679;</span> {{value:map}}'),
	                    tooltipValueLookups: { map: { '-1': 'Loss', '0': 'Draw', '1': 'Win' } }
	                },
	                // Defaults for discrete charts
	                discrete: {
	                    lineHeight: 'auto',
	                    thresholdColor: undefined,
	                    thresholdValue: 0,
	                    chartRangeMax: undefined,
	                    chartRangeMin: undefined,
	                    chartRangeClip: false,
	                    tooltipFormat: new SPFormat('{{prefix}}{{value}}{{suffix}}')
	                },
	                // Defaults for bullet charts
	                bullet: {
	                    targetColor: '#f33',
	                    targetWidth: 3, // width of the target bar in pixels
	                    performanceColor: '#33f',
	                    rangeColors: ['#d3dafe', '#a8b6ff', '#7f94ff'],
	                    base: undefined, // set this to a number to change the base start number
	                    tooltipFormat: new SPFormat('{{fieldkey:fields}} - {{value}}'),
	                    tooltipValueLookups: { fields: { r: 'Range', p: 'Performance', t: 'Target' } }
	                },
	                // Defaults for pie charts
	                pie: {
	                    offset: 0,
	                    sliceColors: ['#3366cc', '#dc3912', '#ff9900', '#109618', '#66aa00', '#dd4477', '#0099c6', '#990099'],
	                    borderWidth: 0,
	                    borderColor: '#000',
	                    tooltipFormat: new SPFormat('<span style="color: {{color}}">&#9679;</span> {{value}} ({{percent.1}}%)')
	                },
	                // Defaults for box plots
	                box: {
	                    raw: false,
	                    boxLineColor: '#000',
	                    boxFillColor: '#cdf',
	                    whiskerColor: '#000',
	                    outlierLineColor: '#333',
	                    outlierFillColor: '#fff',
	                    medianColor: '#f00',
	                    showOutliers: true,
	                    outlierIQR: 1.5,
	                    spotRadius: 1.5,
	                    target: undefined,
	                    targetColor: '#4a2',
	                    chartRangeMax: undefined,
	                    chartRangeMin: undefined,
	                    tooltipFormat: new SPFormat('{{field:fields}}: {{value}}'),
	                    tooltipFormatFieldlistKey: 'field',
	                    tooltipValueLookups: { fields: { lq: 'Lower Quartile', med: 'Median',
	                            uq: 'Upper Quartile', lo: 'Left Outlier', ro: 'Right Outlier',
	                            lw: 'Left Whisker', rw: 'Right Whisker' } }
	                }
	            };
	        };
	
	        // You can have tooltips use a css class other than jqstooltip by specifying tooltipClassname
	        defaultStyles = '.jqstooltip { ' + 'position: absolute;' + 'left: 0px;' + 'top: 0px;' + 'visibility: hidden;' + 'background: rgb(0, 0, 0) transparent;' + 'background-color: rgba(0,0,0,0.6);' + 'filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);' + '-ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000)";' + 'color: white;' + 'font: 10px arial, san serif;' + 'text-align: left;' + 'white-space: nowrap;' + 'padding: 5px;' + 'border: 1px solid white;' + 'z-index: 10000;' + '}' + '.jqsfield { ' + 'color: white;' + 'font: 10px arial, san serif;' + 'text-align: left;' + '}';
	
	        /**
	         * Utilities
	         */
	
	        createClass = function () /* [baseclass, [mixin, ...]], definition */{
	            var Class, args;
	            Class = function () {
	                this.init.apply(this, arguments);
	            };
	            if (arguments.length > 1) {
	                if (arguments[0]) {
	                    Class.prototype = $.extend(new arguments[0](), arguments[arguments.length - 1]);
	                    Class._super = arguments[0].prototype;
	                } else {
	                    Class.prototype = arguments[arguments.length - 1];
	                }
	                if (arguments.length > 2) {
	                    args = Array.prototype.slice.call(arguments, 1, -1);
	                    args.unshift(Class.prototype);
	                    $.extend.apply($, args);
	                }
	            } else {
	                Class.prototype = arguments[0];
	            }
	            Class.prototype.cls = Class;
	            return Class;
	        };
	
	        /**
	         * Wraps a format string for tooltips
	         * {{x}}
	         * {{x.2}
	         * {{x:months}}
	         */
	        $.SPFormatClass = SPFormat = createClass({
	            fre: /\{\{([\w.]+?)(:(.+?))?\}\}/g,
	            precre: /(\w+)\.(\d+)/,
	
	            init: function (format, fclass) {
	                this.format = format;
	                this.fclass = fclass;
	            },
	
	            render: function (fieldset, lookups, options) {
	                var self = this,
	                    fields = fieldset,
	                    match,
	                    token,
	                    lookupkey,
	                    fieldvalue,
	                    prec;
	                return this.format.replace(this.fre, function () {
	                    var lookup;
	                    token = arguments[1];
	                    lookupkey = arguments[3];
	                    match = self.precre.exec(token);
	                    if (match) {
	                        prec = match[2];
	                        token = match[1];
	                    } else {
	                        prec = false;
	                    }
	                    fieldvalue = fields[token];
	                    if (fieldvalue === undefined) {
	                        return '';
	                    }
	                    if (lookupkey && lookups && lookups[lookupkey]) {
	                        lookup = lookups[lookupkey];
	                        if (lookup.get) {
	                            // RangeMap
	                            return lookups[lookupkey].get(fieldvalue) || fieldvalue;
	                        } else {
	                            return lookups[lookupkey][fieldvalue] || fieldvalue;
	                        }
	                    }
	                    if (isNumber(fieldvalue)) {
	                        if (options.get('numberFormatter')) {
	                            fieldvalue = options.get('numberFormatter')(fieldvalue);
	                        } else {
	                            fieldvalue = formatNumber(fieldvalue, prec, options.get('numberDigitGroupCount'), options.get('numberDigitGroupSep'), options.get('numberDecimalMark'));
	                        }
	                    }
	                    return fieldvalue;
	                });
	            }
	        });
	
	        // convience method to avoid needing the new operator
	        $.spformat = function (format, fclass) {
	            return new SPFormat(format, fclass);
	        };
	
	        clipval = function (val, min, max) {
	            if (val < min) {
	                return min;
	            }
	            if (val > max) {
	                return max;
	            }
	            return val;
	        };
	
	        quartile = function (values, q) {
	            var vl;
	            if (q === 2) {
	                vl = Math.floor(values.length / 2);
	                return values.length % 2 ? values[vl] : (values[vl - 1] + values[vl]) / 2;
	            } else {
	                if (values.length % 2) {
	                    // odd
	                    vl = (values.length * q + q) / 4;
	                    return vl % 1 ? (values[Math.floor(vl)] + values[Math.floor(vl) - 1]) / 2 : values[vl - 1];
	                } else {
	                    //even
	                    vl = (values.length * q + 2) / 4;
	                    return vl % 1 ? (values[Math.floor(vl)] + values[Math.floor(vl) - 1]) / 2 : values[vl - 1];
	                }
	            }
	        };
	
	        normalizeValue = function (val) {
	            var nf;
	            switch (val) {
	                case 'undefined':
	                    val = undefined;
	                    break;
	                case 'null':
	                    val = null;
	                    break;
	                case 'true':
	                    val = true;
	                    break;
	                case 'false':
	                    val = false;
	                    break;
	                default:
	                    nf = parseFloat(val);
	                    if (val == nf) {
	                        val = nf;
	                    }
	            }
	            return val;
	        };
	
	        normalizeValues = function (vals) {
	            var i,
	                result = [];
	            for (i = vals.length; i--;) {
	                result[i] = normalizeValue(vals[i]);
	            }
	            return result;
	        };
	
	        remove = function (vals, filter) {
	            var i,
	                vl,
	                result = [];
	            for (i = 0, vl = vals.length; i < vl; i++) {
	                if (vals[i] !== filter) {
	                    result.push(vals[i]);
	                }
	            }
	            return result;
	        };
	
	        isNumber = function (num) {
	            return !isNaN(parseFloat(num)) && isFinite(num);
	        };
	
	        formatNumber = function (num, prec, groupsize, groupsep, decsep) {
	            var p, i;
	            num = (prec === false ? parseFloat(num).toString() : num.toFixed(prec)).split('');
	            p = (p = $.inArray('.', num)) < 0 ? num.length : p;
	            if (p < num.length) {
	                num[p] = decsep;
	            }
	            for (i = p - groupsize; i > 0; i -= groupsize) {
	                num.splice(i, 0, groupsep);
	            }
	            return num.join('');
	        };
	
	        // determine if all values of an array match a value
	        // returns true if the array is empty
	        all = function (val, arr, ignoreNull) {
	            var i;
	            for (i = arr.length; i--;) {
	                if (ignoreNull && arr[i] === null) continue;
	                if (arr[i] !== val) {
	                    return false;
	                }
	            }
	            return true;
	        };
	
	        // sums the numeric values in an array, ignoring other values
	        sum = function (vals) {
	            var total = 0,
	                i;
	            for (i = vals.length; i--;) {
	                total += typeof vals[i] === 'number' ? vals[i] : 0;
	            }
	            return total;
	        };
	
	        ensureArray = function (val) {
	            return $.isArray(val) ? val : [val];
	        };
	
	        // http://paulirish.com/2008/bookmarklet-inject-new-css-rules/
	        addCSS = function (css) {
	            var tag;
	            //if ('\v' == 'v') /* ie only */ {
	            if (document.createStyleSheet) {
	                document.createStyleSheet().cssText = css;
	            } else {
	                tag = document.createElement('style');
	                tag.type = 'text/css';
	                document.getElementsByTagName('head')[0].appendChild(tag);
	                tag[typeof document.body.style.WebkitAppearance == 'string' ? /* webkit only */'innerText' : 'innerHTML'] = css;
	            }
	        };
	
	        // Provide a cross-browser interface to a few simple drawing primitives
	        $.fn.simpledraw = function (width, height, useExisting, interact) {
	            var target, mhandler;
	            if (useExisting && (target = this.data('_jqs_vcanvas'))) {
	                return target;
	            }
	
	            if ($.fn.sparkline.canvas === false) {
	                // We've already determined that neither Canvas nor VML are available
	                return false;
	            } else if ($.fn.sparkline.canvas === undefined) {
	                // No function defined yet -- need to see if we support Canvas or VML
	                var el = document.createElement('canvas');
	                if (!!(el.getContext && el.getContext('2d'))) {
	                    // Canvas is available
	                    $.fn.sparkline.canvas = function (width, height, target, interact) {
	                        return new VCanvas_canvas(width, height, target, interact);
	                    };
	                } else if (document.namespaces && !document.namespaces.v) {
	                    // VML is available
	                    document.namespaces.add('v', 'urn:schemas-microsoft-com:vml', '#default#VML');
	                    $.fn.sparkline.canvas = function (width, height, target, interact) {
	                        return new VCanvas_vml(width, height, target);
	                    };
	                } else {
	                    // Neither Canvas nor VML are available
	                    $.fn.sparkline.canvas = false;
	                    return false;
	                }
	            }
	
	            if (width === undefined) {
	                width = $(this).innerWidth();
	            }
	            if (height === undefined) {
	                height = $(this).innerHeight();
	            }
	
	            target = $.fn.sparkline.canvas(width, height, this, interact);
	
	            mhandler = $(this).data('_jqs_mhandler');
	            if (mhandler) {
	                mhandler.registerCanvas(target);
	            }
	            return target;
	        };
	
	        $.fn.cleardraw = function () {
	            var target = this.data('_jqs_vcanvas');
	            if (target) {
	                target.reset();
	            }
	        };
	
	        $.RangeMapClass = RangeMap = createClass({
	            init: function (map) {
	                var key,
	                    range,
	                    rangelist = [];
	                for (key in map) {
	                    if (map.hasOwnProperty(key) && typeof key === 'string' && key.indexOf(':') > -1) {
	                        range = key.split(':');
	                        range[0] = range[0].length === 0 ? -Infinity : parseFloat(range[0]);
	                        range[1] = range[1].length === 0 ? Infinity : parseFloat(range[1]);
	                        range[2] = map[key];
	                        rangelist.push(range);
	                    }
	                }
	                this.map = map;
	                this.rangelist = rangelist || false;
	            },
	
	            get: function (value) {
	                var rangelist = this.rangelist,
	                    i,
	                    range,
	                    result;
	                if ((result = this.map[value]) !== undefined) {
	                    return result;
	                }
	                if (rangelist) {
	                    for (i = rangelist.length; i--;) {
	                        range = rangelist[i];
	                        if (range[0] <= value && range[1] >= value) {
	                            return range[2];
	                        }
	                    }
	                }
	                return undefined;
	            }
	        });
	
	        // Convenience function
	        $.range_map = function (map) {
	            return new RangeMap(map);
	        };
	
	        MouseHandler = createClass({
	            init: function (el, options) {
	                var $el = $(el);
	                this.$el = $el;
	                this.options = options;
	                this.currentPageX = 0;
	                this.currentPageY = 0;
	                this.el = el;
	                this.splist = [];
	                this.tooltip = null;
	                this.over = false;
	                this.displayTooltips = !options.get('disableTooltips');
	                this.highlightEnabled = !options.get('disableHighlight');
	            },
	
	            registerSparkline: function (sp) {
	                this.splist.push(sp);
	                if (this.over) {
	                    this.updateDisplay();
	                }
	            },
	
	            registerCanvas: function (canvas) {
	                var $canvas = $(canvas.canvas);
	                this.canvas = canvas;
	                this.$canvas = $canvas;
	                $canvas.mouseenter($.proxy(this.mouseenter, this));
	                $canvas.mouseleave($.proxy(this.mouseleave, this));
	                $canvas.click($.proxy(this.mouseclick, this));
	            },
	
	            reset: function (removeTooltip) {
	                this.splist = [];
	                if (this.tooltip && removeTooltip) {
	                    this.tooltip.remove();
	                    this.tooltip = undefined;
	                }
	            },
	
	            mouseclick: function (e) {
	                var clickEvent = $.Event('sparklineClick');
	                clickEvent.originalEvent = e;
	                clickEvent.sparklines = this.splist;
	                this.$el.trigger(clickEvent);
	            },
	
	            mouseenter: function (e) {
	                $(document.body).unbind('mousemove.jqs');
	                $(document.body).bind('mousemove.jqs', $.proxy(this.mousemove, this));
	                this.over = true;
	                this.currentPageX = e.pageX;
	                this.currentPageY = e.pageY;
	                this.currentEl = e.target;
	                if (!this.tooltip && this.displayTooltips) {
	                    this.tooltip = new Tooltip(this.options);
	                    this.tooltip.updatePosition(e.pageX, e.pageY);
	                }
	                this.updateDisplay();
	            },
	
	            mouseleave: function () {
	                $(document.body).unbind('mousemove.jqs');
	                var splist = this.splist,
	                    spcount = splist.length,
	                    needsRefresh = false,
	                    sp,
	                    i;
	                this.over = false;
	                this.currentEl = null;
	
	                if (this.tooltip) {
	                    this.tooltip.remove();
	                    this.tooltip = null;
	                }
	
	                for (i = 0; i < spcount; i++) {
	                    sp = splist[i];
	                    if (sp.clearRegionHighlight()) {
	                        needsRefresh = true;
	                    }
	                }
	
	                if (needsRefresh) {
	                    this.canvas.render();
	                }
	            },
	
	            mousemove: function (e) {
	                this.currentPageX = e.pageX;
	                this.currentPageY = e.pageY;
	                this.currentEl = e.target;
	                if (this.tooltip) {
	                    this.tooltip.updatePosition(e.pageX, e.pageY);
	                }
	                this.updateDisplay();
	            },
	
	            updateDisplay: function () {
	                var splist = this.splist,
	                    spcount = splist.length,
	                    needsRefresh = false,
	                    offset = this.$canvas.offset(),
	                    localX = this.currentPageX - offset.left,
	                    localY = this.currentPageY - offset.top,
	                    tooltiphtml,
	                    sp,
	                    i,
	                    result,
	                    changeEvent;
	                if (!this.over) {
	                    return;
	                }
	                for (i = 0; i < spcount; i++) {
	                    sp = splist[i];
	                    result = sp.setRegionHighlight(this.currentEl, localX, localY);
	                    if (result) {
	                        needsRefresh = true;
	                    }
	                }
	                if (needsRefresh) {
	                    changeEvent = $.Event('sparklineRegionChange');
	                    changeEvent.sparklines = this.splist;
	                    this.$el.trigger(changeEvent);
	                    if (this.tooltip) {
	                        tooltiphtml = '';
	                        for (i = 0; i < spcount; i++) {
	                            sp = splist[i];
	                            tooltiphtml += sp.getCurrentRegionTooltip();
	                        }
	                        this.tooltip.setContent(tooltiphtml);
	                    }
	                    if (!this.disableHighlight) {
	                        this.canvas.render();
	                    }
	                }
	                if (result === null) {
	                    this.mouseleave();
	                }
	            }
	        });
	
	        Tooltip = createClass({
	            sizeStyle: 'position: static !important;' + 'display: block !important;' + 'visibility: hidden !important;' + 'float: left !important;',
	
	            init: function (options) {
	                var tooltipClassname = options.get('tooltipClassname', 'jqstooltip'),
	                    sizetipStyle = this.sizeStyle,
	                    offset;
	                this.container = options.get('tooltipContainer') || document.body;
	                this.tooltipOffsetX = options.get('tooltipOffsetX', 10);
	                this.tooltipOffsetY = options.get('tooltipOffsetY', 12);
	                // remove any previous lingering tooltip
	                $('#jqssizetip').remove();
	                $('#jqstooltip').remove();
	                this.sizetip = $('<div/>', {
	                    id: 'jqssizetip',
	                    style: sizetipStyle,
	                    'class': tooltipClassname
	                });
	                this.tooltip = $('<div/>', {
	                    id: 'jqstooltip',
	                    'class': tooltipClassname
	                }).appendTo(this.container);
	                // account for the container's location
	                offset = this.tooltip.offset();
	                this.offsetLeft = offset.left;
	                this.offsetTop = offset.top;
	                this.hidden = true;
	                $(window).unbind('resize.jqs scroll.jqs');
	                $(window).bind('resize.jqs scroll.jqs', $.proxy(this.updateWindowDims, this));
	                this.updateWindowDims();
	            },
	
	            updateWindowDims: function () {
	                this.scrollTop = $(window).scrollTop();
	                this.scrollLeft = $(window).scrollLeft();
	                this.scrollRight = this.scrollLeft + $(window).width();
	                this.updatePosition();
	            },
	
	            getSize: function (content) {
	                this.sizetip.html(content).appendTo(this.container);
	                this.width = this.sizetip.width() + 1;
	                this.height = this.sizetip.height();
	                this.sizetip.remove();
	            },
	
	            setContent: function (content) {
	                if (!content) {
	                    this.tooltip.css('visibility', 'hidden');
	                    this.hidden = true;
	                    return;
	                }
	                this.getSize(content);
	                this.tooltip.html(content).css({
	                    'width': this.width,
	                    'height': this.height,
	                    'visibility': 'visible'
	                });
	                if (this.hidden) {
	                    this.hidden = false;
	                    this.updatePosition();
	                }
	            },
	
	            updatePosition: function (x, y) {
	                if (x === undefined) {
	                    if (this.mousex === undefined) {
	                        return;
	                    }
	                    x = this.mousex - this.offsetLeft;
	                    y = this.mousey - this.offsetTop;
	                } else {
	                    this.mousex = x = x - this.offsetLeft;
	                    this.mousey = y = y - this.offsetTop;
	                }
	                if (!this.height || !this.width || this.hidden) {
	                    return;
	                }
	
	                y -= this.height + this.tooltipOffsetY;
	                x += this.tooltipOffsetX;
	
	                if (y < this.scrollTop) {
	                    y = this.scrollTop;
	                }
	                if (x < this.scrollLeft) {
	                    x = this.scrollLeft;
	                } else if (x + this.width > this.scrollRight) {
	                    x = this.scrollRight - this.width;
	                }
	
	                this.tooltip.css({
	                    'left': x,
	                    'top': y
	                });
	            },
	
	            remove: function () {
	                this.tooltip.remove();
	                this.sizetip.remove();
	                this.sizetip = this.tooltip = undefined;
	                $(window).unbind('resize.jqs scroll.jqs');
	            }
	        });
	
	        initStyles = function () {
	            addCSS(defaultStyles);
	        };
	
	        $(initStyles);
	
	        pending = [];
	        $.fn.sparkline = function (userValues, userOptions) {
	            return this.each(function () {
	                var options = new $.fn.sparkline.options(this, userOptions),
	                    $this = $(this),
	                    render,
	                    i;
	                render = function () {
	                    var values, width, height, tmp, mhandler, sp, vals;
	                    if (userValues === 'html' || userValues === undefined) {
	                        vals = this.getAttribute(options.get('tagValuesAttribute'));
	                        if (vals === undefined || vals === null) {
	                            vals = $this.html();
	                        }
	                        values = vals.replace(/(^\s*<!--)|(-->\s*$)|\s+/g, '').split(',');
	                    } else {
	                        values = userValues;
	                    }
	
	                    width = options.get('width') === 'auto' ? values.length * options.get('defaultPixelsPerValue') : options.get('width');
	                    if (options.get('height') === 'auto') {
	                        if (!options.get('composite') || !$.data(this, '_jqs_vcanvas')) {
	                            // must be a better way to get the line height
	                            tmp = document.createElement('span');
	                            tmp.innerHTML = 'a';
	                            $this.html(tmp);
	                            height = $(tmp).innerHeight() || $(tmp).height();
	                            $(tmp).remove();
	                            tmp = null;
	                        }
	                    } else {
	                        height = options.get('height');
	                    }
	
	                    if (!options.get('disableInteraction')) {
	                        mhandler = $.data(this, '_jqs_mhandler');
	                        if (!mhandler) {
	                            mhandler = new MouseHandler(this, options);
	                            $.data(this, '_jqs_mhandler', mhandler);
	                        } else if (!options.get('composite')) {
	                            mhandler.reset();
	                        }
	                    } else {
	                        mhandler = false;
	                    }
	
	                    if (options.get('composite') && !$.data(this, '_jqs_vcanvas')) {
	                        if (!$.data(this, '_jqs_errnotify')) {
	                            alert('Attempted to attach a composite sparkline to an element with no existing sparkline');
	                            $.data(this, '_jqs_errnotify', true);
	                        }
	                        return;
	                    }
	
	                    sp = new $.fn.sparkline[options.get('type')](this, values, options, width, height);
	
	                    sp.render();
	
	                    if (mhandler) {
	                        mhandler.registerSparkline(sp);
	                    }
	                };
	                if ($(this).html() && !options.get('disableHiddenCheck') && $(this).is(':hidden') || !$(this).parents('body').length) {
	                    if (!options.get('composite') && $.data(this, '_jqs_pending')) {
	                        // remove any existing references to the element
	                        for (i = pending.length; i; i--) {
	                            if (pending[i - 1][0] == this) {
	                                pending.splice(i - 1, 1);
	                            }
	                        }
	                    }
	                    pending.push([this, render]);
	                    $.data(this, '_jqs_pending', true);
	                } else {
	                    render.call(this);
	                }
	            });
	        };
	
	        $.fn.sparkline.defaults = getDefaults();
	
	        $.sparkline_display_visible = function () {
	            var el, i, pl;
	            var done = [];
	            for (i = 0, pl = pending.length; i < pl; i++) {
	                el = pending[i][0];
	                if ($(el).is(':visible') && !$(el).parents().is(':hidden')) {
	                    pending[i][1].call(el);
	                    $.data(pending[i][0], '_jqs_pending', false);
	                    done.push(i);
	                } else if (!$(el).closest('html').length && !$.data(el, '_jqs_pending')) {
	                    // element has been inserted and removed from the DOM
	                    // If it was not yet inserted into the dom then the .data request
	                    // will return true.
	                    // removing from the dom causes the data to be removed.
	                    $.data(pending[i][0], '_jqs_pending', false);
	                    done.push(i);
	                }
	            }
	            for (i = done.length; i; i--) {
	                pending.splice(done[i - 1], 1);
	            }
	        };
	
	        /**
	         * User option handler
	         */
	        $.fn.sparkline.options = createClass({
	            init: function (tag, userOptions) {
	                var extendedOptions, defaults, base, tagOptionType;
	                this.userOptions = userOptions = userOptions || {};
	                this.tag = tag;
	                this.tagValCache = {};
	                defaults = $.fn.sparkline.defaults;
	                base = defaults.common;
	                this.tagOptionsPrefix = userOptions.enableTagOptions && (userOptions.tagOptionsPrefix || base.tagOptionsPrefix);
	
	                tagOptionType = this.getTagSetting('type');
	                if (tagOptionType === UNSET_OPTION) {
	                    extendedOptions = defaults[userOptions.type || base.type];
	                } else {
	                    extendedOptions = defaults[tagOptionType];
	                }
	                this.mergedOptions = $.extend({}, base, extendedOptions, userOptions);
	            },
	
	            getTagSetting: function (key) {
	                var prefix = this.tagOptionsPrefix,
	                    val,
	                    i,
	                    pairs,
	                    keyval;
	                if (prefix === false || prefix === undefined) {
	                    return UNSET_OPTION;
	                }
	                if (this.tagValCache.hasOwnProperty(key)) {
	                    val = this.tagValCache.key;
	                } else {
	                    val = this.tag.getAttribute(prefix + key);
	                    if (val === undefined || val === null) {
	                        val = UNSET_OPTION;
	                    } else if (val.substr(0, 1) === '[') {
	                        val = val.substr(1, val.length - 2).split(',');
	                        for (i = val.length; i--;) {
	                            val[i] = normalizeValue(val[i].replace(/(^\s*)|(\s*$)/g, ''));
	                        }
	                    } else if (val.substr(0, 1) === '{') {
	                        pairs = val.substr(1, val.length - 2).split(',');
	                        val = {};
	                        for (i = pairs.length; i--;) {
	                            keyval = pairs[i].split(':', 2);
	                            val[keyval[0].replace(/(^\s*)|(\s*$)/g, '')] = normalizeValue(keyval[1].replace(/(^\s*)|(\s*$)/g, ''));
	                        }
	                    } else {
	                        val = normalizeValue(val);
	                    }
	                    this.tagValCache.key = val;
	                }
	                return val;
	            },
	
	            get: function (key, defaultval) {
	                var tagOption = this.getTagSetting(key),
	                    result;
	                if (tagOption !== UNSET_OPTION) {
	                    return tagOption;
	                }
	                return (result = this.mergedOptions[key]) === undefined ? defaultval : result;
	            }
	        });
	
	        $.fn.sparkline._base = createClass({
	            disabled: false,
	
	            init: function (el, values, options, width, height) {
	                this.el = el;
	                this.$el = $(el);
	                this.values = values;
	                this.options = options;
	                this.width = width;
	                this.height = height;
	                this.currentRegion = undefined;
	            },
	
	            /**
	             * Setup the canvas
	             */
	            initTarget: function () {
	                var interactive = !this.options.get('disableInteraction');
	                if (!(this.target = this.$el.simpledraw(this.width, this.height, this.options.get('composite'), interactive))) {
	                    this.disabled = true;
	                } else {
	                    this.canvasWidth = this.target.pixelWidth;
	                    this.canvasHeight = this.target.pixelHeight;
	                }
	            },
	
	            /**
	             * Actually render the chart to the canvas
	             */
	            render: function () {
	                if (this.disabled) {
	                    this.el.innerHTML = '';
	                    return false;
	                }
	                return true;
	            },
	
	            /**
	             * Return a region id for a given x/y co-ordinate
	             */
	            getRegion: function (x, y) {},
	
	            /**
	             * Highlight an item based on the moused-over x,y co-ordinate
	             */
	            setRegionHighlight: function (el, x, y) {
	                var currentRegion = this.currentRegion,
	                    highlightEnabled = !this.options.get('disableHighlight'),
	                    newRegion;
	                if (x > this.canvasWidth || y > this.canvasHeight || x < 0 || y < 0) {
	                    return null;
	                }
	                newRegion = this.getRegion(el, x, y);
	                if (currentRegion !== newRegion) {
	                    if (currentRegion !== undefined && highlightEnabled) {
	                        this.removeHighlight();
	                    }
	                    this.currentRegion = newRegion;
	                    if (newRegion !== undefined && highlightEnabled) {
	                        this.renderHighlight();
	                    }
	                    return true;
	                }
	                return false;
	            },
	
	            /**
	             * Reset any currently highlighted item
	             */
	            clearRegionHighlight: function () {
	                if (this.currentRegion !== undefined) {
	                    this.removeHighlight();
	                    this.currentRegion = undefined;
	                    return true;
	                }
	                return false;
	            },
	
	            renderHighlight: function () {
	                this.changeHighlight(true);
	            },
	
	            removeHighlight: function () {
	                this.changeHighlight(false);
	            },
	
	            changeHighlight: function (highlight) {},
	
	            /**
	             * Fetch the HTML to display as a tooltip
	             */
	            getCurrentRegionTooltip: function () {
	                var options = this.options,
	                    header = '',
	                    entries = [],
	                    fields,
	                    formats,
	                    formatlen,
	                    fclass,
	                    text,
	                    i,
	                    showFields,
	                    showFieldsKey,
	                    newFields,
	                    fv,
	                    formatter,
	                    format,
	                    fieldlen,
	                    j;
	                if (this.currentRegion === undefined) {
	                    return '';
	                }
	                fields = this.getCurrentRegionFields();
	                formatter = options.get('tooltipFormatter');
	                if (formatter) {
	                    return formatter(this, options, fields);
	                }
	                if (options.get('tooltipChartTitle')) {
	                    header += '<div class="jqs jqstitle">' + options.get('tooltipChartTitle') + '</div>\n';
	                }
	                formats = this.options.get('tooltipFormat');
	                if (!formats) {
	                    return '';
	                }
	                if (!$.isArray(formats)) {
	                    formats = [formats];
	                }
	                if (!$.isArray(fields)) {
	                    fields = [fields];
	                }
	                showFields = this.options.get('tooltipFormatFieldlist');
	                showFieldsKey = this.options.get('tooltipFormatFieldlistKey');
	                if (showFields && showFieldsKey) {
	                    // user-selected ordering of fields
	                    newFields = [];
	                    for (i = fields.length; i--;) {
	                        fv = fields[i][showFieldsKey];
	                        if ((j = $.inArray(fv, showFields)) != -1) {
	                            newFields[j] = fields[i];
	                        }
	                    }
	                    fields = newFields;
	                }
	                formatlen = formats.length;
	                fieldlen = fields.length;
	                for (i = 0; i < formatlen; i++) {
	                    format = formats[i];
	                    if (typeof format === 'string') {
	                        format = new SPFormat(format);
	                    }
	                    fclass = format.fclass || 'jqsfield';
	                    for (j = 0; j < fieldlen; j++) {
	                        if (!fields[j].isNull || !options.get('tooltipSkipNull')) {
	                            $.extend(fields[j], {
	                                prefix: options.get('tooltipPrefix'),
	                                suffix: options.get('tooltipSuffix')
	                            });
	                            text = format.render(fields[j], options.get('tooltipValueLookups'), options);
	                            entries.push('<div class="' + fclass + '">' + text + '</div>');
	                        }
	                    }
	                }
	                if (entries.length) {
	                    return header + entries.join('\n');
	                }
	                return '';
	            },
	
	            getCurrentRegionFields: function () {},
	
	            calcHighlightColor: function (color, options) {
	                var highlightColor = options.get('highlightColor'),
	                    lighten = options.get('highlightLighten'),
	                    parse,
	                    mult,
	                    rgbnew,
	                    i;
	                if (highlightColor) {
	                    return highlightColor;
	                }
	                if (lighten) {
	                    // extract RGB values
	                    parse = /^#([0-9a-f])([0-9a-f])([0-9a-f])$/i.exec(color) || /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(color);
	                    if (parse) {
	                        rgbnew = [];
	                        mult = color.length === 4 ? 16 : 1;
	                        for (i = 0; i < 3; i++) {
	                            rgbnew[i] = clipval(Math.round(parseInt(parse[i + 1], 16) * mult * lighten), 0, 255);
	                        }
	                        return 'rgb(' + rgbnew.join(',') + ')';
	                    }
	                }
	                return color;
	            }
	
	        });
	
	        barHighlightMixin = {
	            changeHighlight: function (highlight) {
	                var currentRegion = this.currentRegion,
	                    target = this.target,
	                    shapeids = this.regionShapes[currentRegion],
	                    newShapes;
	                // will be null if the region value was null
	                if (shapeids) {
	                    newShapes = this.renderRegion(currentRegion, highlight);
	                    if ($.isArray(newShapes) || $.isArray(shapeids)) {
	                        target.replaceWithShapes(shapeids, newShapes);
	                        this.regionShapes[currentRegion] = $.map(newShapes, function (newShape) {
	                            return newShape.id;
	                        });
	                    } else {
	                        target.replaceWithShape(shapeids, newShapes);
	                        this.regionShapes[currentRegion] = newShapes.id;
	                    }
	                }
	            },
	
	            render: function () {
	                var values = this.values,
	                    target = this.target,
	                    regionShapes = this.regionShapes,
	                    shapes,
	                    ids,
	                    i,
	                    j;
	
	                if (!this.cls._super.render.call(this)) {
	                    return;
	                }
	                for (i = values.length; i--;) {
	                    shapes = this.renderRegion(i);
	                    if (shapes) {
	                        if ($.isArray(shapes)) {
	                            ids = [];
	                            for (j = shapes.length; j--;) {
	                                shapes[j].append();
	                                ids.push(shapes[j].id);
	                            }
	                            regionShapes[i] = ids;
	                        } else {
	                            shapes.append();
	                            regionShapes[i] = shapes.id; // store just the shapeid
	                        }
	                    } else {
	                        // null value
	                        regionShapes[i] = null;
	                    }
	                }
	                target.render();
	            }
	        };
	
	        /**
	         * Line charts
	         */
	        $.fn.sparkline.line = line = createClass($.fn.sparkline._base, {
	            type: 'line',
	
	            init: function (el, values, options, width, height) {
	                line._super.init.call(this, el, values, options, width, height);
	                this.vertices = [];
	                this.regionMap = [];
	                this.xvalues = [];
	                this.yvalues = [];
	                this.yminmax = [];
	                this.hightlightSpotId = null;
	                this.lastShapeId = null;
	                this.initTarget();
	            },
	
	            getRegion: function (el, x, y) {
	                var i,
	                    regionMap = this.regionMap; // maps regions to value positions
	                for (i = regionMap.length; i--;) {
	                    if (regionMap[i] !== null && x >= regionMap[i][0] && x <= regionMap[i][1]) {
	                        return regionMap[i][2];
	                    }
	                }
	                return undefined;
	            },
	
	            getCurrentRegionFields: function () {
	                var currentRegion = this.currentRegion;
	                return {
	                    isNull: this.yvalues[currentRegion] === null,
	                    x: this.xvalues[currentRegion],
	                    y: this.yvalues[currentRegion],
	                    color: this.options.get('lineColor'),
	                    fillColor: this.options.get('fillColor'),
	                    offset: currentRegion
	                };
	            },
	
	            renderHighlight: function () {
	                var currentRegion = this.currentRegion,
	                    target = this.target,
	                    vertex = this.vertices[currentRegion],
	                    options = this.options,
	                    spotRadius = options.get('spotRadius'),
	                    highlightSpotColor = options.get('highlightSpotColor'),
	                    highlightLineColor = options.get('highlightLineColor'),
	                    highlightSpot,
	                    highlightLine;
	
	                if (!vertex) {
	                    return;
	                }
	                if (spotRadius && highlightSpotColor) {
	                    highlightSpot = target.drawCircle(vertex[0], vertex[1], spotRadius, undefined, highlightSpotColor);
	                    this.highlightSpotId = highlightSpot.id;
	                    target.insertAfterShape(this.lastShapeId, highlightSpot);
	                }
	                if (highlightLineColor) {
	                    highlightLine = target.drawLine(vertex[0], this.canvasTop, vertex[0], this.canvasTop + this.canvasHeight, highlightLineColor);
	                    this.highlightLineId = highlightLine.id;
	                    target.insertAfterShape(this.lastShapeId, highlightLine);
	                }
	            },
	
	            removeHighlight: function () {
	                var target = this.target;
	                if (this.highlightSpotId) {
	                    target.removeShapeId(this.highlightSpotId);
	                    this.highlightSpotId = null;
	                }
	                if (this.highlightLineId) {
	                    target.removeShapeId(this.highlightLineId);
	                    this.highlightLineId = null;
	                }
	            },
	
	            scanValues: function () {
	                var values = this.values,
	                    valcount = values.length,
	                    xvalues = this.xvalues,
	                    yvalues = this.yvalues,
	                    yminmax = this.yminmax,
	                    i,
	                    val,
	                    isStr,
	                    isArray,
	                    sp;
	                for (i = 0; i < valcount; i++) {
	                    val = values[i];
	                    isStr = typeof values[i] === 'string';
	                    isArray = typeof values[i] === 'object' && values[i] instanceof Array;
	                    sp = isStr && values[i].split(':');
	                    if (isStr && sp.length === 2) {
	                        // x:y
	                        xvalues.push(Number(sp[0]));
	                        yvalues.push(Number(sp[1]));
	                        yminmax.push(Number(sp[1]));
	                    } else if (isArray) {
	                        xvalues.push(val[0]);
	                        yvalues.push(val[1]);
	                        yminmax.push(val[1]);
	                    } else {
	                        xvalues.push(i);
	                        if (values[i] === null || values[i] === 'null') {
	                            yvalues.push(null);
	                        } else {
	                            yvalues.push(Number(val));
	                            yminmax.push(Number(val));
	                        }
	                    }
	                }
	                if (this.options.get('xvalues')) {
	                    xvalues = this.options.get('xvalues');
	                }
	
	                this.maxy = this.maxyorg = Math.max.apply(Math, yminmax);
	                this.miny = this.minyorg = Math.min.apply(Math, yminmax);
	
	                this.maxx = Math.max.apply(Math, xvalues);
	                this.minx = Math.min.apply(Math, xvalues);
	
	                this.xvalues = xvalues;
	                this.yvalues = yvalues;
	                this.yminmax = yminmax;
	            },
	
	            processRangeOptions: function () {
	                var options = this.options,
	                    normalRangeMin = options.get('normalRangeMin'),
	                    normalRangeMax = options.get('normalRangeMax');
	
	                if (normalRangeMin !== undefined) {
	                    if (normalRangeMin < this.miny) {
	                        this.miny = normalRangeMin;
	                    }
	                    if (normalRangeMax > this.maxy) {
	                        this.maxy = normalRangeMax;
	                    }
	                }
	                if (options.get('chartRangeMin') !== undefined && (options.get('chartRangeClip') || options.get('chartRangeMin') < this.miny)) {
	                    this.miny = options.get('chartRangeMin');
	                }
	                if (options.get('chartRangeMax') !== undefined && (options.get('chartRangeClip') || options.get('chartRangeMax') > this.maxy)) {
	                    this.maxy = options.get('chartRangeMax');
	                }
	                if (options.get('chartRangeMinX') !== undefined && (options.get('chartRangeClipX') || options.get('chartRangeMinX') < this.minx)) {
	                    this.minx = options.get('chartRangeMinX');
	                }
	                if (options.get('chartRangeMaxX') !== undefined && (options.get('chartRangeClipX') || options.get('chartRangeMaxX') > this.maxx)) {
	                    this.maxx = options.get('chartRangeMaxX');
	                }
	            },
	
	            drawNormalRange: function (canvasLeft, canvasTop, canvasHeight, canvasWidth, rangey) {
	                var normalRangeMin = this.options.get('normalRangeMin'),
	                    normalRangeMax = this.options.get('normalRangeMax'),
	                    ytop = canvasTop + Math.round(canvasHeight - canvasHeight * ((normalRangeMax - this.miny) / rangey)),
	                    height = Math.round(canvasHeight * (normalRangeMax - normalRangeMin) / rangey);
	                this.target.drawRect(canvasLeft, ytop, canvasWidth, height, undefined, this.options.get('normalRangeColor')).append();
	            },
	
	            render: function () {
	                var options = this.options,
	                    target = this.target,
	                    canvasWidth = this.canvasWidth,
	                    canvasHeight = this.canvasHeight,
	                    vertices = this.vertices,
	                    spotRadius = options.get('spotRadius'),
	                    regionMap = this.regionMap,
	                    rangex,
	                    rangey,
	                    yvallast,
	                    canvasTop,
	                    canvasLeft,
	                    vertex,
	                    path,
	                    paths,
	                    x,
	                    y,
	                    xnext,
	                    xpos,
	                    xposnext,
	                    last,
	                    next,
	                    yvalcount,
	                    lineShapes,
	                    fillShapes,
	                    plen,
	                    valueSpots,
	                    hlSpotsEnabled,
	                    color,
	                    xvalues,
	                    yvalues,
	                    i;
	
	                if (!line._super.render.call(this)) {
	                    return;
	                }
	
	                this.scanValues();
	                this.processRangeOptions();
	
	                xvalues = this.xvalues;
	                yvalues = this.yvalues;
	
	                if (!this.yminmax.length || this.yvalues.length < 2) {
	                    // empty or all null valuess
	                    return;
	                }
	
	                canvasTop = canvasLeft = 0;
	
	                rangex = this.maxx - this.minx === 0 ? 1 : this.maxx - this.minx;
	                rangey = this.maxy - this.miny === 0 ? 1 : this.maxy - this.miny;
	                yvallast = this.yvalues.length - 1;
	
	                if (spotRadius && (canvasWidth < spotRadius * 4 || canvasHeight < spotRadius * 4)) {
	                    spotRadius = 0;
	                }
	                if (spotRadius) {
	                    // adjust the canvas size as required so that spots will fit
	                    hlSpotsEnabled = options.get('highlightSpotColor') && !options.get('disableInteraction');
	                    if (hlSpotsEnabled || options.get('minSpotColor') || options.get('spotColor') && yvalues[yvallast] === this.miny) {
	                        canvasHeight -= Math.ceil(spotRadius);
	                    }
	                    if (hlSpotsEnabled || options.get('maxSpotColor') || options.get('spotColor') && yvalues[yvallast] === this.maxy) {
	                        canvasHeight -= Math.ceil(spotRadius);
	                        canvasTop += Math.ceil(spotRadius);
	                    }
	                    if (hlSpotsEnabled || (options.get('minSpotColor') || options.get('maxSpotColor')) && (yvalues[0] === this.miny || yvalues[0] === this.maxy)) {
	                        canvasLeft += Math.ceil(spotRadius);
	                        canvasWidth -= Math.ceil(spotRadius);
	                    }
	                    if (hlSpotsEnabled || options.get('spotColor') || options.get('minSpotColor') || options.get('maxSpotColor') && (yvalues[yvallast] === this.miny || yvalues[yvallast] === this.maxy)) {
	                        canvasWidth -= Math.ceil(spotRadius);
	                    }
	                }
	
	                canvasHeight--;
	
	                if (options.get('normalRangeMin') !== undefined && !options.get('drawNormalOnTop')) {
	                    this.drawNormalRange(canvasLeft, canvasTop, canvasHeight, canvasWidth, rangey);
	                }
	
	                path = [];
	                paths = [path];
	                last = next = null;
	                yvalcount = yvalues.length;
	                for (i = 0; i < yvalcount; i++) {
	                    x = xvalues[i];
	                    xnext = xvalues[i + 1];
	                    y = yvalues[i];
	                    xpos = canvasLeft + Math.round((x - this.minx) * (canvasWidth / rangex));
	                    xposnext = i < yvalcount - 1 ? canvasLeft + Math.round((xnext - this.minx) * (canvasWidth / rangex)) : canvasWidth;
	                    next = xpos + (xposnext - xpos) / 2;
	                    regionMap[i] = [last || 0, next, i];
	                    last = next;
	                    if (y === null) {
	                        if (i) {
	                            if (yvalues[i - 1] !== null) {
	                                path = [];
	                                paths.push(path);
	                            }
	                            vertices.push(null);
	                        }
	                    } else {
	                        if (y < this.miny) {
	                            y = this.miny;
	                        }
	                        if (y > this.maxy) {
	                            y = this.maxy;
	                        }
	                        if (!path.length) {
	                            // previous value was null
	                            path.push([xpos, canvasTop + canvasHeight]);
	                        }
	                        vertex = [xpos, canvasTop + Math.round(canvasHeight - canvasHeight * ((y - this.miny) / rangey))];
	                        path.push(vertex);
	                        vertices.push(vertex);
	                    }
	                }
	
	                lineShapes = [];
	                fillShapes = [];
	                plen = paths.length;
	                for (i = 0; i < plen; i++) {
	                    path = paths[i];
	                    if (path.length) {
	                        if (options.get('fillColor')) {
	                            path.push([path[path.length - 1][0], canvasTop + canvasHeight]);
	                            fillShapes.push(path.slice(0));
	                            path.pop();
	                        }
	                        // if there's only a single point in this path, then we want to display it
	                        // as a vertical line which means we keep path[0]  as is
	                        if (path.length > 2) {
	                            // else we want the first value
	                            path[0] = [path[0][0], path[1][1]];
	                        }
	                        lineShapes.push(path);
	                    }
	                }
	
	                // draw the fill first, then optionally the normal range, then the line on top of that
	                plen = fillShapes.length;
	                for (i = 0; i < plen; i++) {
	                    target.drawShape(fillShapes[i], options.get('fillColor'), options.get('fillColor')).append();
	                }
	
	                if (options.get('normalRangeMin') !== undefined && options.get('drawNormalOnTop')) {
	                    this.drawNormalRange(canvasLeft, canvasTop, canvasHeight, canvasWidth, rangey);
	                }
	
	                plen = lineShapes.length;
	                for (i = 0; i < plen; i++) {
	                    target.drawShape(lineShapes[i], options.get('lineColor'), undefined, options.get('lineWidth')).append();
	                }
	
	                if (spotRadius && options.get('valueSpots')) {
	                    valueSpots = options.get('valueSpots');
	                    if (valueSpots.get === undefined) {
	                        valueSpots = new RangeMap(valueSpots);
	                    }
	                    for (i = 0; i < yvalcount; i++) {
	                        color = valueSpots.get(yvalues[i]);
	                        if (color) {
	                            target.drawCircle(canvasLeft + Math.round((xvalues[i] - this.minx) * (canvasWidth / rangex)), canvasTop + Math.round(canvasHeight - canvasHeight * ((yvalues[i] - this.miny) / rangey)), spotRadius, undefined, color).append();
	                        }
	                    }
	                }
	                if (spotRadius && options.get('spotColor') && yvalues[yvallast] !== null) {
	                    target.drawCircle(canvasLeft + Math.round((xvalues[xvalues.length - 1] - this.minx) * (canvasWidth / rangex)), canvasTop + Math.round(canvasHeight - canvasHeight * ((yvalues[yvallast] - this.miny) / rangey)), spotRadius, undefined, options.get('spotColor')).append();
	                }
	                if (this.maxy !== this.minyorg) {
	                    if (spotRadius && options.get('minSpotColor')) {
	                        x = xvalues[$.inArray(this.minyorg, yvalues)];
	                        target.drawCircle(canvasLeft + Math.round((x - this.minx) * (canvasWidth / rangex)), canvasTop + Math.round(canvasHeight - canvasHeight * ((this.minyorg - this.miny) / rangey)), spotRadius, undefined, options.get('minSpotColor')).append();
	                    }
	                    if (spotRadius && options.get('maxSpotColor')) {
	                        x = xvalues[$.inArray(this.maxyorg, yvalues)];
	                        target.drawCircle(canvasLeft + Math.round((x - this.minx) * (canvasWidth / rangex)), canvasTop + Math.round(canvasHeight - canvasHeight * ((this.maxyorg - this.miny) / rangey)), spotRadius, undefined, options.get('maxSpotColor')).append();
	                    }
	                }
	
	                this.lastShapeId = target.getLastShapeId();
	                this.canvasTop = canvasTop;
	                target.render();
	            }
	        });
	
	        /**
	         * Bar charts
	         */
	        $.fn.sparkline.bar = bar = createClass($.fn.sparkline._base, barHighlightMixin, {
	            type: 'bar',
	
	            init: function (el, values, options, width, height) {
	                var barWidth = parseInt(options.get('barWidth'), 10),
	                    barSpacing = parseInt(options.get('barSpacing'), 10),
	                    chartRangeMin = options.get('chartRangeMin'),
	                    chartRangeMax = options.get('chartRangeMax'),
	                    chartRangeClip = options.get('chartRangeClip'),
	                    stackMin = Infinity,
	                    stackMax = -Infinity,
	                    isStackString,
	                    groupMin,
	                    groupMax,
	                    stackRanges,
	                    numValues,
	                    i,
	                    vlen,
	                    range,
	                    zeroAxis,
	                    xaxisOffset,
	                    min,
	                    max,
	                    clipMin,
	                    clipMax,
	                    stacked,
	                    vlist,
	                    j,
	                    slen,
	                    svals,
	                    val,
	                    yoffset,
	                    yMaxCalc,
	                    canvasHeightEf;
	                bar._super.init.call(this, el, values, options, width, height);
	
	                // scan values to determine whether to stack bars
	                for (i = 0, vlen = values.length; i < vlen; i++) {
	                    val = values[i];
	                    isStackString = typeof val === 'string' && val.indexOf(':') > -1;
	                    if (isStackString || $.isArray(val)) {
	                        stacked = true;
	                        if (isStackString) {
	                            val = values[i] = normalizeValues(val.split(':'));
	                        }
	                        val = remove(val, null); // min/max will treat null as zero
	                        groupMin = Math.min.apply(Math, val);
	                        groupMax = Math.max.apply(Math, val);
	                        if (groupMin < stackMin) {
	                            stackMin = groupMin;
	                        }
	                        if (groupMax > stackMax) {
	                            stackMax = groupMax;
	                        }
	                    }
	                }
	
	                this.stacked = stacked;
	                this.regionShapes = {};
	                this.barWidth = barWidth;
	                this.barSpacing = barSpacing;
	                this.totalBarWidth = barWidth + barSpacing;
	                this.width = width = values.length * barWidth + (values.length - 1) * barSpacing;
	
	                this.initTarget();
	
	                if (chartRangeClip) {
	                    clipMin = chartRangeMin === undefined ? -Infinity : chartRangeMin;
	                    clipMax = chartRangeMax === undefined ? Infinity : chartRangeMax;
	                }
	
	                numValues = [];
	                stackRanges = stacked ? [] : numValues;
	                var stackTotals = [];
	                var stackRangesNeg = [];
	                for (i = 0, vlen = values.length; i < vlen; i++) {
	                    if (stacked) {
	                        vlist = values[i];
	                        values[i] = svals = [];
	                        stackTotals[i] = 0;
	                        stackRanges[i] = stackRangesNeg[i] = 0;
	                        for (j = 0, slen = vlist.length; j < slen; j++) {
	                            val = svals[j] = chartRangeClip ? clipval(vlist[j], clipMin, clipMax) : vlist[j];
	                            if (val !== null) {
	                                if (val > 0) {
	                                    stackTotals[i] += val;
	                                }
	                                if (stackMin < 0 && stackMax > 0) {
	                                    if (val < 0) {
	                                        stackRangesNeg[i] += Math.abs(val);
	                                    } else {
	                                        stackRanges[i] += val;
	                                    }
	                                } else {
	                                    stackRanges[i] += Math.abs(val - (val < 0 ? stackMax : stackMin));
	                                }
	                                numValues.push(val);
	                            }
	                        }
	                    } else {
	                        val = chartRangeClip ? clipval(values[i], clipMin, clipMax) : values[i];
	                        val = values[i] = normalizeValue(val);
	                        if (val !== null) {
	                            numValues.push(val);
	                        }
	                    }
	                }
	                this.max = max = Math.max.apply(Math, numValues);
	                this.min = min = Math.min.apply(Math, numValues);
	                this.stackMax = stackMax = stacked ? Math.max.apply(Math, stackTotals) : max;
	                this.stackMin = stackMin = stacked ? Math.min.apply(Math, numValues) : min;
	
	                if (options.get('chartRangeMin') !== undefined && (options.get('chartRangeClip') || options.get('chartRangeMin') < min)) {
	                    min = options.get('chartRangeMin');
	                }
	                if (options.get('chartRangeMax') !== undefined && (options.get('chartRangeClip') || options.get('chartRangeMax') > max)) {
	                    max = options.get('chartRangeMax');
	                }
	
	                this.zeroAxis = zeroAxis = options.get('zeroAxis', true);
	                if (min <= 0 && max >= 0 && zeroAxis) {
	                    xaxisOffset = 0;
	                } else if (zeroAxis == false) {
	                    xaxisOffset = min;
	                } else if (min > 0) {
	                    xaxisOffset = min;
	                } else {
	                    xaxisOffset = max;
	                }
	                this.xaxisOffset = xaxisOffset;
	
	                range = stacked ? Math.max.apply(Math, stackRanges) + Math.max.apply(Math, stackRangesNeg) : max - min;
	
	                // as we plot zero/min values a single pixel line, we add a pixel to all other
	                // values - Reduce the effective canvas size to suit
	                this.canvasHeightEf = zeroAxis && min < 0 ? this.canvasHeight - 2 : this.canvasHeight - 1;
	
	                if (min < xaxisOffset) {
	                    yMaxCalc = stacked && max >= 0 ? stackMax : max;
	                    yoffset = (yMaxCalc - xaxisOffset) / range * this.canvasHeight;
	                    if (yoffset !== Math.ceil(yoffset)) {
	                        this.canvasHeightEf -= 2;
	                        yoffset = Math.ceil(yoffset);
	                    }
	                } else {
	                    yoffset = this.canvasHeight;
	                }
	                this.yoffset = yoffset;
	
	                if ($.isArray(options.get('colorMap'))) {
	                    this.colorMapByIndex = options.get('colorMap');
	                    this.colorMapByValue = null;
	                } else {
	                    this.colorMapByIndex = null;
	                    this.colorMapByValue = options.get('colorMap');
	                    if (this.colorMapByValue && this.colorMapByValue.get === undefined) {
	                        this.colorMapByValue = new RangeMap(this.colorMapByValue);
	                    }
	                }
	
	                this.range = range;
	            },
	
	            getRegion: function (el, x, y) {
	                var result = Math.floor(x / this.totalBarWidth);
	                return result < 0 || result >= this.values.length ? undefined : result;
	            },
	
	            getCurrentRegionFields: function () {
	                var currentRegion = this.currentRegion,
	                    values = ensureArray(this.values[currentRegion]),
	                    result = [],
	                    value,
	                    i;
	                for (i = values.length; i--;) {
	                    value = values[i];
	                    result.push({
	                        isNull: value === null,
	                        value: value,
	                        color: this.calcColor(i, value, currentRegion),
	                        offset: currentRegion
	                    });
	                }
	                return result;
	            },
	
	            calcColor: function (stacknum, value, valuenum) {
	                var colorMapByIndex = this.colorMapByIndex,
	                    colorMapByValue = this.colorMapByValue,
	                    options = this.options,
	                    color,
	                    newColor;
	                if (this.stacked) {
	                    color = options.get('stackedBarColor');
	                } else {
	                    color = value < 0 ? options.get('negBarColor') : options.get('barColor');
	                }
	                if (value === 0 && options.get('zeroColor') !== undefined) {
	                    color = options.get('zeroColor');
	                }
	                if (colorMapByValue && (newColor = colorMapByValue.get(value))) {
	                    color = newColor;
	                } else if (colorMapByIndex && colorMapByIndex.length > valuenum) {
	                    color = colorMapByIndex[valuenum];
	                }
	                return $.isArray(color) ? color[stacknum % color.length] : color;
	            },
	
	            /**
	             * Render bar(s) for a region
	             */
	            renderRegion: function (valuenum, highlight) {
	                var vals = this.values[valuenum],
	                    options = this.options,
	                    xaxisOffset = this.xaxisOffset,
	                    result = [],
	                    range = this.range,
	                    stacked = this.stacked,
	                    target = this.target,
	                    x = valuenum * this.totalBarWidth,
	                    canvasHeightEf = this.canvasHeightEf,
	                    yoffset = this.yoffset,
	                    y,
	                    height,
	                    color,
	                    isNull,
	                    yoffsetNeg,
	                    i,
	                    valcount,
	                    val,
	                    minPlotted,
	                    allMin;
	
	                vals = $.isArray(vals) ? vals : [vals];
	                valcount = vals.length;
	                val = vals[0];
	                isNull = all(null, vals);
	                allMin = all(xaxisOffset, vals, true);
	
	                if (isNull) {
	                    if (options.get('nullColor')) {
	                        color = highlight ? options.get('nullColor') : this.calcHighlightColor(options.get('nullColor'), options);
	                        y = yoffset > 0 ? yoffset - 1 : yoffset;
	                        return target.drawRect(x, y, this.barWidth - 1, 0, color, color);
	                    } else {
	                        return undefined;
	                    }
	                }
	                yoffsetNeg = yoffset;
	                for (i = 0; i < valcount; i++) {
	                    val = vals[i];
	
	                    if (stacked && val === xaxisOffset) {
	                        if (!allMin || minPlotted) {
	                            continue;
	                        }
	                        minPlotted = true;
	                    }
	
	                    if (range > 0) {
	                        height = Math.floor(canvasHeightEf * (Math.abs(val - xaxisOffset) / range)) + 1;
	                    } else {
	                        height = 1;
	                    }
	                    if (val < xaxisOffset || val === xaxisOffset && yoffset === 0) {
	                        y = yoffsetNeg;
	                        yoffsetNeg += height;
	                    } else {
	                        y = yoffset - height;
	                        yoffset -= height;
	                    }
	                    color = this.calcColor(i, val, valuenum);
	                    if (highlight) {
	                        color = this.calcHighlightColor(color, options);
	                    }
	                    result.push(target.drawRect(x, y, this.barWidth - 1, height - 1, color, color));
	                }
	                if (result.length === 1) {
	                    return result[0];
	                }
	                return result;
	            }
	        });
	
	        /**
	         * Tristate charts
	         */
	        $.fn.sparkline.tristate = tristate = createClass($.fn.sparkline._base, barHighlightMixin, {
	            type: 'tristate',
	
	            init: function (el, values, options, width, height) {
	                var barWidth = parseInt(options.get('barWidth'), 10),
	                    barSpacing = parseInt(options.get('barSpacing'), 10);
	                tristate._super.init.call(this, el, values, options, width, height);
	
	                this.regionShapes = {};
	                this.barWidth = barWidth;
	                this.barSpacing = barSpacing;
	                this.totalBarWidth = barWidth + barSpacing;
	                this.values = $.map(values, Number);
	                this.width = width = values.length * barWidth + (values.length - 1) * barSpacing;
	
	                if ($.isArray(options.get('colorMap'))) {
	                    this.colorMapByIndex = options.get('colorMap');
	                    this.colorMapByValue = null;
	                } else {
	                    this.colorMapByIndex = null;
	                    this.colorMapByValue = options.get('colorMap');
	                    if (this.colorMapByValue && this.colorMapByValue.get === undefined) {
	                        this.colorMapByValue = new RangeMap(this.colorMapByValue);
	                    }
	                }
	                this.initTarget();
	            },
	
	            getRegion: function (el, x, y) {
	                return Math.floor(x / this.totalBarWidth);
	            },
	
	            getCurrentRegionFields: function () {
	                var currentRegion = this.currentRegion;
	                return {
	                    isNull: this.values[currentRegion] === undefined,
	                    value: this.values[currentRegion],
	                    color: this.calcColor(this.values[currentRegion], currentRegion),
	                    offset: currentRegion
	                };
	            },
	
	            calcColor: function (value, valuenum) {
	                var values = this.values,
	                    options = this.options,
	                    colorMapByIndex = this.colorMapByIndex,
	                    colorMapByValue = this.colorMapByValue,
	                    color,
	                    newColor;
	
	                if (colorMapByValue && (newColor = colorMapByValue.get(value))) {
	                    color = newColor;
	                } else if (colorMapByIndex && colorMapByIndex.length > valuenum) {
	                    color = colorMapByIndex[valuenum];
	                } else if (values[valuenum] < 0) {
	                    color = options.get('negBarColor');
	                } else if (values[valuenum] > 0) {
	                    color = options.get('posBarColor');
	                } else {
	                    color = options.get('zeroBarColor');
	                }
	                return color;
	            },
	
	            renderRegion: function (valuenum, highlight) {
	                var values = this.values,
	                    options = this.options,
	                    target = this.target,
	                    canvasHeight,
	                    height,
	                    halfHeight,
	                    x,
	                    y,
	                    color;
	
	                canvasHeight = target.pixelHeight;
	                halfHeight = Math.round(canvasHeight / 2);
	
	                x = valuenum * this.totalBarWidth;
	                if (values[valuenum] < 0) {
	                    y = halfHeight;
	                    height = halfHeight - 1;
	                } else if (values[valuenum] > 0) {
	                    y = 0;
	                    height = halfHeight - 1;
	                } else {
	                    y = halfHeight - 1;
	                    height = 2;
	                }
	                color = this.calcColor(values[valuenum], valuenum);
	                if (color === null) {
	                    return;
	                }
	                if (highlight) {
	                    color = this.calcHighlightColor(color, options);
	                }
	                return target.drawRect(x, y, this.barWidth - 1, height - 1, color, color);
	            }
	        });
	
	        /**
	         * Discrete charts
	         */
	        $.fn.sparkline.discrete = discrete = createClass($.fn.sparkline._base, barHighlightMixin, {
	            type: 'discrete',
	
	            init: function (el, values, options, width, height) {
	                discrete._super.init.call(this, el, values, options, width, height);
	
	                this.regionShapes = {};
	                this.values = values = $.map(values, Number);
	                this.min = Math.min.apply(Math, values);
	                this.max = Math.max.apply(Math, values);
	                this.range = this.max - this.min;
	                this.width = width = options.get('width') === 'auto' ? values.length * 2 : this.width;
	                this.interval = Math.floor(width / values.length);
	                this.itemWidth = width / values.length;
	                if (options.get('chartRangeMin') !== undefined && (options.get('chartRangeClip') || options.get('chartRangeMin') < this.min)) {
	                    this.min = options.get('chartRangeMin');
	                }
	                if (options.get('chartRangeMax') !== undefined && (options.get('chartRangeClip') || options.get('chartRangeMax') > this.max)) {
	                    this.max = options.get('chartRangeMax');
	                }
	                this.initTarget();
	                if (this.target) {
	                    this.lineHeight = options.get('lineHeight') === 'auto' ? Math.round(this.canvasHeight * 0.3) : options.get('lineHeight');
	                }
	            },
	
	            getRegion: function (el, x, y) {
	                return Math.floor(x / this.itemWidth);
	            },
	
	            getCurrentRegionFields: function () {
	                var currentRegion = this.currentRegion;
	                return {
	                    isNull: this.values[currentRegion] === undefined,
	                    value: this.values[currentRegion],
	                    offset: currentRegion
	                };
	            },
	
	            renderRegion: function (valuenum, highlight) {
	                var values = this.values,
	                    options = this.options,
	                    min = this.min,
	                    max = this.max,
	                    range = this.range,
	                    interval = this.interval,
	                    target = this.target,
	                    canvasHeight = this.canvasHeight,
	                    lineHeight = this.lineHeight,
	                    pheight = canvasHeight - lineHeight,
	                    ytop,
	                    val,
	                    color,
	                    x;
	
	                val = clipval(values[valuenum], min, max);
	                x = valuenum * interval;
	                ytop = Math.round(pheight - pheight * ((val - min) / range));
	                color = options.get('thresholdColor') && val < options.get('thresholdValue') ? options.get('thresholdColor') : options.get('lineColor');
	                if (highlight) {
	                    color = this.calcHighlightColor(color, options);
	                }
	                return target.drawLine(x, ytop, x, ytop + lineHeight, color);
	            }
	        });
	
	        /**
	         * Bullet charts
	         */
	        $.fn.sparkline.bullet = bullet = createClass($.fn.sparkline._base, {
	            type: 'bullet',
	
	            init: function (el, values, options, width, height) {
	                var min, max, vals;
	                bullet._super.init.call(this, el, values, options, width, height);
	
	                // values: target, performance, range1, range2, range3
	                this.values = values = normalizeValues(values);
	                // target or performance could be null
	                vals = values.slice();
	                vals[0] = vals[0] === null ? vals[2] : vals[0];
	                vals[1] = values[1] === null ? vals[2] : vals[1];
	                min = Math.min.apply(Math, values);
	                max = Math.max.apply(Math, values);
	                if (options.get('base') === undefined) {
	                    min = min < 0 ? min : 0;
	                } else {
	                    min = options.get('base');
	                }
	                this.min = min;
	                this.max = max;
	                this.range = max - min;
	                this.shapes = {};
	                this.valueShapes = {};
	                this.regiondata = {};
	                this.width = width = options.get('width') === 'auto' ? '4.0em' : width;
	                this.target = this.$el.simpledraw(width, height, options.get('composite'));
	                if (!values.length) {
	                    this.disabled = true;
	                }
	                this.initTarget();
	            },
	
	            getRegion: function (el, x, y) {
	                var shapeid = this.target.getShapeAt(el, x, y);
	                return shapeid !== undefined && this.shapes[shapeid] !== undefined ? this.shapes[shapeid] : undefined;
	            },
	
	            getCurrentRegionFields: function () {
	                var currentRegion = this.currentRegion;
	                return {
	                    fieldkey: currentRegion.substr(0, 1),
	                    value: this.values[currentRegion.substr(1)],
	                    region: currentRegion
	                };
	            },
	
	            changeHighlight: function (highlight) {
	                var currentRegion = this.currentRegion,
	                    shapeid = this.valueShapes[currentRegion],
	                    shape;
	                delete this.shapes[shapeid];
	                switch (currentRegion.substr(0, 1)) {
	                    case 'r':
	                        shape = this.renderRange(currentRegion.substr(1), highlight);
	                        break;
	                    case 'p':
	                        shape = this.renderPerformance(highlight);
	                        break;
	                    case 't':
	                        shape = this.renderTarget(highlight);
	                        break;
	                }
	                this.valueShapes[currentRegion] = shape.id;
	                this.shapes[shape.id] = currentRegion;
	                this.target.replaceWithShape(shapeid, shape);
	            },
	
	            renderRange: function (rn, highlight) {
	                var rangeval = this.values[rn],
	                    rangewidth = Math.round(this.canvasWidth * ((rangeval - this.min) / this.range)),
	                    color = this.options.get('rangeColors')[rn - 2];
	                if (highlight) {
	                    color = this.calcHighlightColor(color, this.options);
	                }
	                return this.target.drawRect(0, 0, rangewidth - 1, this.canvasHeight - 1, color, color);
	            },
	
	            renderPerformance: function (highlight) {
	                var perfval = this.values[1],
	                    perfwidth = Math.round(this.canvasWidth * ((perfval - this.min) / this.range)),
	                    color = this.options.get('performanceColor');
	                if (highlight) {
	                    color = this.calcHighlightColor(color, this.options);
	                }
	                return this.target.drawRect(0, Math.round(this.canvasHeight * 0.3), perfwidth - 1, Math.round(this.canvasHeight * 0.4) - 1, color, color);
	            },
	
	            renderTarget: function (highlight) {
	                var targetval = this.values[0],
	                    x = Math.round(this.canvasWidth * ((targetval - this.min) / this.range) - this.options.get('targetWidth') / 2),
	                    targettop = Math.round(this.canvasHeight * 0.10),
	                    targetheight = this.canvasHeight - targettop * 2,
	                    color = this.options.get('targetColor');
	                if (highlight) {
	                    color = this.calcHighlightColor(color, this.options);
	                }
	                return this.target.drawRect(x, targettop, this.options.get('targetWidth') - 1, targetheight - 1, color, color);
	            },
	
	            render: function () {
	                var vlen = this.values.length,
	                    target = this.target,
	                    i,
	                    shape;
	                if (!bullet._super.render.call(this)) {
	                    return;
	                }
	                for (i = 2; i < vlen; i++) {
	                    shape = this.renderRange(i).append();
	                    this.shapes[shape.id] = 'r' + i;
	                    this.valueShapes['r' + i] = shape.id;
	                }
	                if (this.values[1] !== null) {
	                    shape = this.renderPerformance().append();
	                    this.shapes[shape.id] = 'p1';
	                    this.valueShapes.p1 = shape.id;
	                }
	                if (this.values[0] !== null) {
	                    shape = this.renderTarget().append();
	                    this.shapes[shape.id] = 't0';
	                    this.valueShapes.t0 = shape.id;
	                }
	                target.render();
	            }
	        });
	
	        /**
	         * Pie charts
	         */
	        $.fn.sparkline.pie = pie = createClass($.fn.sparkline._base, {
	            type: 'pie',
	
	            init: function (el, values, options, width, height) {
	                var total = 0,
	                    i;
	
	                pie._super.init.call(this, el, values, options, width, height);
	
	                this.shapes = {}; // map shape ids to value offsets
	                this.valueShapes = {}; // maps value offsets to shape ids
	                this.values = values = $.map(values, Number);
	
	                if (options.get('width') === 'auto') {
	                    this.width = this.height;
	                }
	
	                if (values.length > 0) {
	                    for (i = values.length; i--;) {
	                        total += values[i];
	                    }
	                }
	                this.total = total;
	                this.initTarget();
	                this.radius = Math.floor(Math.min(this.canvasWidth, this.canvasHeight) / 2);
	            },
	
	            getRegion: function (el, x, y) {
	                var shapeid = this.target.getShapeAt(el, x, y);
	                return shapeid !== undefined && this.shapes[shapeid] !== undefined ? this.shapes[shapeid] : undefined;
	            },
	
	            getCurrentRegionFields: function () {
	                var currentRegion = this.currentRegion;
	                return {
	                    isNull: this.values[currentRegion] === undefined,
	                    value: this.values[currentRegion],
	                    percent: this.values[currentRegion] / this.total * 100,
	                    color: this.options.get('sliceColors')[currentRegion % this.options.get('sliceColors').length],
	                    offset: currentRegion
	                };
	            },
	
	            changeHighlight: function (highlight) {
	                var currentRegion = this.currentRegion,
	                    newslice = this.renderSlice(currentRegion, highlight),
	                    shapeid = this.valueShapes[currentRegion];
	                delete this.shapes[shapeid];
	                this.target.replaceWithShape(shapeid, newslice);
	                this.valueShapes[currentRegion] = newslice.id;
	                this.shapes[newslice.id] = currentRegion;
	            },
	
	            renderSlice: function (valuenum, highlight) {
	                var target = this.target,
	                    options = this.options,
	                    radius = this.radius,
	                    borderWidth = options.get('borderWidth'),
	                    offset = options.get('offset'),
	                    circle = 2 * Math.PI,
	                    values = this.values,
	                    total = this.total,
	                    next = offset ? 2 * Math.PI * (offset / 360) : 0,
	                    start,
	                    end,
	                    i,
	                    vlen,
	                    color;
	
	                vlen = values.length;
	                for (i = 0; i < vlen; i++) {
	                    start = next;
	                    end = next;
	                    if (total > 0) {
	                        // avoid divide by zero
	                        end = next + circle * (values[i] / total);
	                    }
	                    if (valuenum === i) {
	                        color = options.get('sliceColors')[i % options.get('sliceColors').length];
	                        if (highlight) {
	                            color = this.calcHighlightColor(color, options);
	                        }
	
	                        return target.drawPieSlice(radius, radius, radius - borderWidth, start, end, undefined, color);
	                    }
	                    next = end;
	                }
	            },
	
	            render: function () {
	                var target = this.target,
	                    values = this.values,
	                    options = this.options,
	                    radius = this.radius,
	                    borderWidth = options.get('borderWidth'),
	                    shape,
	                    i;
	
	                if (!pie._super.render.call(this)) {
	                    return;
	                }
	                if (borderWidth) {
	                    target.drawCircle(radius, radius, Math.floor(radius - borderWidth / 2), options.get('borderColor'), undefined, borderWidth).append();
	                }
	                for (i = values.length; i--;) {
	                    if (values[i]) {
	                        // don't render zero values
	                        shape = this.renderSlice(i).append();
	                        this.valueShapes[i] = shape.id; // store just the shapeid
	                        this.shapes[shape.id] = i;
	                    }
	                }
	                target.render();
	            }
	        });
	
	        /**
	         * Box plots
	         */
	        $.fn.sparkline.box = box = createClass($.fn.sparkline._base, {
	            type: 'box',
	
	            init: function (el, values, options, width, height) {
	                box._super.init.call(this, el, values, options, width, height);
	                this.values = $.map(values, Number);
	                this.width = options.get('width') === 'auto' ? '4.0em' : width;
	                this.initTarget();
	                if (!this.values.length) {
	                    this.disabled = 1;
	                }
	            },
	
	            /**
	             * Simulate a single region
	             */
	            getRegion: function () {
	                return 1;
	            },
	
	            getCurrentRegionFields: function () {
	                var result = [{ field: 'lq', value: this.quartiles[0] }, { field: 'med', value: this.quartiles[1] }, { field: 'uq', value: this.quartiles[2] }];
	                if (this.loutlier !== undefined) {
	                    result.push({ field: 'lo', value: this.loutlier });
	                }
	                if (this.routlier !== undefined) {
	                    result.push({ field: 'ro', value: this.routlier });
	                }
	                if (this.lwhisker !== undefined) {
	                    result.push({ field: 'lw', value: this.lwhisker });
	                }
	                if (this.rwhisker !== undefined) {
	                    result.push({ field: 'rw', value: this.rwhisker });
	                }
	                return result;
	            },
	
	            render: function () {
	                var target = this.target,
	                    values = this.values,
	                    vlen = values.length,
	                    options = this.options,
	                    canvasWidth = this.canvasWidth,
	                    canvasHeight = this.canvasHeight,
	                    minValue = options.get('chartRangeMin') === undefined ? Math.min.apply(Math, values) : options.get('chartRangeMin'),
	                    maxValue = options.get('chartRangeMax') === undefined ? Math.max.apply(Math, values) : options.get('chartRangeMax'),
	                    canvasLeft = 0,
	                    lwhisker,
	                    loutlier,
	                    iqr,
	                    q1,
	                    q2,
	                    q3,
	                    rwhisker,
	                    routlier,
	                    i,
	                    size,
	                    unitSize;
	
	                if (!box._super.render.call(this)) {
	                    return;
	                }
	
	                if (options.get('raw')) {
	                    if (options.get('showOutliers') && values.length > 5) {
	                        loutlier = values[0];
	                        lwhisker = values[1];
	                        q1 = values[2];
	                        q2 = values[3];
	                        q3 = values[4];
	                        rwhisker = values[5];
	                        routlier = values[6];
	                    } else {
	                        lwhisker = values[0];
	                        q1 = values[1];
	                        q2 = values[2];
	                        q3 = values[3];
	                        rwhisker = values[4];
	                    }
	                } else {
	                    values.sort(function (a, b) {
	                        return a - b;
	                    });
	                    q1 = quartile(values, 1);
	                    q2 = quartile(values, 2);
	                    q3 = quartile(values, 3);
	                    iqr = q3 - q1;
	                    if (options.get('showOutliers')) {
	                        lwhisker = rwhisker = undefined;
	                        for (i = 0; i < vlen; i++) {
	                            if (lwhisker === undefined && values[i] > q1 - iqr * options.get('outlierIQR')) {
	                                lwhisker = values[i];
	                            }
	                            if (values[i] < q3 + iqr * options.get('outlierIQR')) {
	                                rwhisker = values[i];
	                            }
	                        }
	                        loutlier = values[0];
	                        routlier = values[vlen - 1];
	                    } else {
	                        lwhisker = values[0];
	                        rwhisker = values[vlen - 1];
	                    }
	                }
	                this.quartiles = [q1, q2, q3];
	                this.lwhisker = lwhisker;
	                this.rwhisker = rwhisker;
	                this.loutlier = loutlier;
	                this.routlier = routlier;
	
	                unitSize = canvasWidth / (maxValue - minValue + 1);
	                if (options.get('showOutliers')) {
	                    canvasLeft = Math.ceil(options.get('spotRadius'));
	                    canvasWidth -= 2 * Math.ceil(options.get('spotRadius'));
	                    unitSize = canvasWidth / (maxValue - minValue + 1);
	                    if (loutlier < lwhisker) {
	                        target.drawCircle((loutlier - minValue) * unitSize + canvasLeft, canvasHeight / 2, options.get('spotRadius'), options.get('outlierLineColor'), options.get('outlierFillColor')).append();
	                    }
	                    if (routlier > rwhisker) {
	                        target.drawCircle((routlier - minValue) * unitSize + canvasLeft, canvasHeight / 2, options.get('spotRadius'), options.get('outlierLineColor'), options.get('outlierFillColor')).append();
	                    }
	                }
	
	                // box
	                target.drawRect(Math.round((q1 - minValue) * unitSize + canvasLeft), Math.round(canvasHeight * 0.1), Math.round((q3 - q1) * unitSize), Math.round(canvasHeight * 0.8), options.get('boxLineColor'), options.get('boxFillColor')).append();
	                // left whisker
	                target.drawLine(Math.round((lwhisker - minValue) * unitSize + canvasLeft), Math.round(canvasHeight / 2), Math.round((q1 - minValue) * unitSize + canvasLeft), Math.round(canvasHeight / 2), options.get('lineColor')).append();
	                target.drawLine(Math.round((lwhisker - minValue) * unitSize + canvasLeft), Math.round(canvasHeight / 4), Math.round((lwhisker - minValue) * unitSize + canvasLeft), Math.round(canvasHeight - canvasHeight / 4), options.get('whiskerColor')).append();
	                // right whisker
	                target.drawLine(Math.round((rwhisker - minValue) * unitSize + canvasLeft), Math.round(canvasHeight / 2), Math.round((q3 - minValue) * unitSize + canvasLeft), Math.round(canvasHeight / 2), options.get('lineColor')).append();
	                target.drawLine(Math.round((rwhisker - minValue) * unitSize + canvasLeft), Math.round(canvasHeight / 4), Math.round((rwhisker - minValue) * unitSize + canvasLeft), Math.round(canvasHeight - canvasHeight / 4), options.get('whiskerColor')).append();
	                // median line
	                target.drawLine(Math.round((q2 - minValue) * unitSize + canvasLeft), Math.round(canvasHeight * 0.1), Math.round((q2 - minValue) * unitSize + canvasLeft), Math.round(canvasHeight * 0.9), options.get('medianColor')).append();
	                if (options.get('target')) {
	                    size = Math.ceil(options.get('spotRadius'));
	                    target.drawLine(Math.round((options.get('target') - minValue) * unitSize + canvasLeft), Math.round(canvasHeight / 2 - size), Math.round((options.get('target') - minValue) * unitSize + canvasLeft), Math.round(canvasHeight / 2 + size), options.get('targetColor')).append();
	                    target.drawLine(Math.round((options.get('target') - minValue) * unitSize + canvasLeft - size), Math.round(canvasHeight / 2), Math.round((options.get('target') - minValue) * unitSize + canvasLeft + size), Math.round(canvasHeight / 2), options.get('targetColor')).append();
	                }
	                target.render();
	            }
	        });
	
	        // Setup a very simple "virtual canvas" to make drawing the few shapes we need easier
	        // This is accessible as $(foo).simpledraw()
	
	        VShape = createClass({
	            init: function (target, id, type, args) {
	                this.target = target;
	                this.id = id;
	                this.type = type;
	                this.args = args;
	            },
	            append: function () {
	                this.target.appendShape(this);
	                return this;
	            }
	        });
	
	        VCanvas_base = createClass({
	            _pxregex: /(\d+)(px)?\s*$/i,
	
	            init: function (width, height, target) {
	                if (!width) {
	                    return;
	                }
	                this.width = width;
	                this.height = height;
	                this.target = target;
	                this.lastShapeId = null;
	                if (target[0]) {
	                    target = target[0];
	                }
	                $.data(target, '_jqs_vcanvas', this);
	            },
	
	            drawLine: function (x1, y1, x2, y2, lineColor, lineWidth) {
	                return this.drawShape([[x1, y1], [x2, y2]], lineColor, lineWidth);
	            },
	
	            drawShape: function (path, lineColor, fillColor, lineWidth) {
	                return this._genShape('Shape', [path, lineColor, fillColor, lineWidth]);
	            },
	
	            drawCircle: function (x, y, radius, lineColor, fillColor, lineWidth) {
	                return this._genShape('Circle', [x, y, radius, lineColor, fillColor, lineWidth]);
	            },
	
	            drawPieSlice: function (x, y, radius, startAngle, endAngle, lineColor, fillColor) {
	                return this._genShape('PieSlice', [x, y, radius, startAngle, endAngle, lineColor, fillColor]);
	            },
	
	            drawRect: function (x, y, width, height, lineColor, fillColor) {
	                return this._genShape('Rect', [x, y, width, height, lineColor, fillColor]);
	            },
	
	            getElement: function () {
	                return this.canvas;
	            },
	
	            /**
	             * Return the most recently inserted shape id
	             */
	            getLastShapeId: function () {
	                return this.lastShapeId;
	            },
	
	            /**
	             * Clear and reset the canvas
	             */
	            reset: function () {
	                alert('reset not implemented');
	            },
	
	            _insert: function (el, target) {
	                $(target).html(el);
	            },
	
	            /**
	             * Calculate the pixel dimensions of the canvas
	             */
	            _calculatePixelDims: function (width, height, canvas) {
	                // XXX This should probably be a configurable option
	                var match;
	                match = this._pxregex.exec(height);
	                if (match) {
	                    this.pixelHeight = match[1];
	                } else {
	                    this.pixelHeight = $(canvas).height();
	                }
	                match = this._pxregex.exec(width);
	                if (match) {
	                    this.pixelWidth = match[1];
	                } else {
	                    this.pixelWidth = $(canvas).width();
	                }
	            },
	
	            /**
	             * Generate a shape object and id for later rendering
	             */
	            _genShape: function (shapetype, shapeargs) {
	                var id = shapeCount++;
	                shapeargs.unshift(id);
	                return new VShape(this, id, shapetype, shapeargs);
	            },
	
	            /**
	             * Add a shape to the end of the render queue
	             */
	            appendShape: function (shape) {
	                alert('appendShape not implemented');
	            },
	
	            /**
	             * Replace one shape with another
	             */
	            replaceWithShape: function (shapeid, shape) {
	                alert('replaceWithShape not implemented');
	            },
	
	            /**
	             * Insert one shape after another in the render queue
	             */
	            insertAfterShape: function (shapeid, shape) {
	                alert('insertAfterShape not implemented');
	            },
	
	            /**
	             * Remove a shape from the queue
	             */
	            removeShapeId: function (shapeid) {
	                alert('removeShapeId not implemented');
	            },
	
	            /**
	             * Find a shape at the specified x/y co-ordinates
	             */
	            getShapeAt: function (el, x, y) {
	                alert('getShapeAt not implemented');
	            },
	
	            /**
	             * Render all queued shapes onto the canvas
	             */
	            render: function () {
	                alert('render not implemented');
	            }
	        });
	
	        VCanvas_canvas = createClass(VCanvas_base, {
	            init: function (width, height, target, interact) {
	                VCanvas_canvas._super.init.call(this, width, height, target);
	                this.canvas = document.createElement('canvas');
	                if (target[0]) {
	                    target = target[0];
	                }
	                $.data(target, '_jqs_vcanvas', this);
	                $(this.canvas).css({ display: 'inline-block', width: width, height: height, verticalAlign: 'top' });
	                this._insert(this.canvas, target);
	                this._calculatePixelDims(width, height, this.canvas);
	                this.canvas.width = this.pixelWidth;
	                this.canvas.height = this.pixelHeight;
	                this.interact = interact;
	                this.shapes = {};
	                this.shapeseq = [];
	                this.currentTargetShapeId = undefined;
	                $(this.canvas).css({ width: this.pixelWidth, height: this.pixelHeight });
	            },
	
	            _getContext: function (lineColor, fillColor, lineWidth) {
	                var context = this.canvas.getContext('2d');
	                if (lineColor !== undefined) {
	                    context.strokeStyle = lineColor;
	                }
	                context.lineWidth = lineWidth === undefined ? 1 : lineWidth;
	                if (fillColor !== undefined) {
	                    context.fillStyle = fillColor;
	                }
	                return context;
	            },
	
	            reset: function () {
	                var context = this._getContext();
	                context.clearRect(0, 0, this.pixelWidth, this.pixelHeight);
	                this.shapes = {};
	                this.shapeseq = [];
	                this.currentTargetShapeId = undefined;
	            },
	
	            _drawShape: function (shapeid, path, lineColor, fillColor, lineWidth) {
	                var context = this._getContext(lineColor, fillColor, lineWidth),
	                    i,
	                    plen;
	                context.beginPath();
	                context.moveTo(path[0][0] + 0.5, path[0][1] + 0.5);
	                for (i = 1, plen = path.length; i < plen; i++) {
	                    context.lineTo(path[i][0] + 0.5, path[i][1] + 0.5); // the 0.5 offset gives us crisp pixel-width lines
	                }
	                if (lineColor !== undefined) {
	                    context.stroke();
	                }
	                if (fillColor !== undefined) {
	                    context.fill();
	                }
	                if (this.targetX !== undefined && this.targetY !== undefined && context.isPointInPath(this.targetX, this.targetY)) {
	                    this.currentTargetShapeId = shapeid;
	                }
	            },
	
	            _drawCircle: function (shapeid, x, y, radius, lineColor, fillColor, lineWidth) {
	                var context = this._getContext(lineColor, fillColor, lineWidth);
	                context.beginPath();
	                context.arc(x, y, radius, 0, 2 * Math.PI, false);
	                if (this.targetX !== undefined && this.targetY !== undefined && context.isPointInPath(this.targetX, this.targetY)) {
	                    this.currentTargetShapeId = shapeid;
	                }
	                if (lineColor !== undefined) {
	                    context.stroke();
	                }
	                if (fillColor !== undefined) {
	                    context.fill();
	                }
	            },
	
	            _drawPieSlice: function (shapeid, x, y, radius, startAngle, endAngle, lineColor, fillColor) {
	                var context = this._getContext(lineColor, fillColor);
	                context.beginPath();
	                context.moveTo(x, y);
	                context.arc(x, y, radius, startAngle, endAngle, false);
	                context.lineTo(x, y);
	                context.closePath();
	                if (lineColor !== undefined) {
	                    context.stroke();
	                }
	                if (fillColor) {
	                    context.fill();
	                }
	                if (this.targetX !== undefined && this.targetY !== undefined && context.isPointInPath(this.targetX, this.targetY)) {
	                    this.currentTargetShapeId = shapeid;
	                }
	            },
	
	            _drawRect: function (shapeid, x, y, width, height, lineColor, fillColor) {
	                return this._drawShape(shapeid, [[x, y], [x + width, y], [x + width, y + height], [x, y + height], [x, y]], lineColor, fillColor);
	            },
	
	            appendShape: function (shape) {
	                this.shapes[shape.id] = shape;
	                this.shapeseq.push(shape.id);
	                this.lastShapeId = shape.id;
	                return shape.id;
	            },
	
	            replaceWithShape: function (shapeid, shape) {
	                var shapeseq = this.shapeseq,
	                    i;
	                this.shapes[shape.id] = shape;
	                for (i = shapeseq.length; i--;) {
	                    if (shapeseq[i] == shapeid) {
	                        shapeseq[i] = shape.id;
	                    }
	                }
	                delete this.shapes[shapeid];
	            },
	
	            replaceWithShapes: function (shapeids, shapes) {
	                var shapeseq = this.shapeseq,
	                    shapemap = {},
	                    sid,
	                    i,
	                    first;
	
	                for (i = shapeids.length; i--;) {
	                    shapemap[shapeids[i]] = true;
	                }
	                for (i = shapeseq.length; i--;) {
	                    sid = shapeseq[i];
	                    if (shapemap[sid]) {
	                        shapeseq.splice(i, 1);
	                        delete this.shapes[sid];
	                        first = i;
	                    }
	                }
	                for (i = shapes.length; i--;) {
	                    shapeseq.splice(first, 0, shapes[i].id);
	                    this.shapes[shapes[i].id] = shapes[i];
	                }
	            },
	
	            insertAfterShape: function (shapeid, shape) {
	                var shapeseq = this.shapeseq,
	                    i;
	                for (i = shapeseq.length; i--;) {
	                    if (shapeseq[i] === shapeid) {
	                        shapeseq.splice(i + 1, 0, shape.id);
	                        this.shapes[shape.id] = shape;
	                        return;
	                    }
	                }
	            },
	
	            removeShapeId: function (shapeid) {
	                var shapeseq = this.shapeseq,
	                    i;
	                for (i = shapeseq.length; i--;) {
	                    if (shapeseq[i] === shapeid) {
	                        shapeseq.splice(i, 1);
	                        break;
	                    }
	                }
	                delete this.shapes[shapeid];
	            },
	
	            getShapeAt: function (el, x, y) {
	                this.targetX = x;
	                this.targetY = y;
	                this.render();
	                return this.currentTargetShapeId;
	            },
	
	            render: function () {
	                var shapeseq = this.shapeseq,
	                    shapes = this.shapes,
	                    shapeCount = shapeseq.length,
	                    context = this._getContext(),
	                    shapeid,
	                    shape,
	                    i;
	                context.clearRect(0, 0, this.pixelWidth, this.pixelHeight);
	                for (i = 0; i < shapeCount; i++) {
	                    shapeid = shapeseq[i];
	                    shape = shapes[shapeid];
	                    this['_draw' + shape.type].apply(this, shape.args);
	                }
	                if (!this.interact) {
	                    // not interactive so no need to keep the shapes array
	                    this.shapes = {};
	                    this.shapeseq = [];
	                }
	            }
	
	        });
	
	        VCanvas_vml = createClass(VCanvas_base, {
	            init: function (width, height, target) {
	                var groupel;
	                VCanvas_vml._super.init.call(this, width, height, target);
	                if (target[0]) {
	                    target = target[0];
	                }
	                $.data(target, '_jqs_vcanvas', this);
	                this.canvas = document.createElement('span');
	                $(this.canvas).css({ display: 'inline-block', position: 'relative', overflow: 'hidden', width: width, height: height, margin: '0px', padding: '0px', verticalAlign: 'top' });
	                this._insert(this.canvas, target);
	                this._calculatePixelDims(width, height, this.canvas);
	                this.canvas.width = this.pixelWidth;
	                this.canvas.height = this.pixelHeight;
	                groupel = '<v:group coordorigin="0 0" coordsize="' + this.pixelWidth + ' ' + this.pixelHeight + '"' + ' style="position:absolute;top:0;left:0;width:' + this.pixelWidth + 'px;height=' + this.pixelHeight + 'px;"></v:group>';
	                this.canvas.insertAdjacentHTML('beforeEnd', groupel);
	                this.group = $(this.canvas).children()[0];
	                this.rendered = false;
	                this.prerender = '';
	            },
	
	            _drawShape: function (shapeid, path, lineColor, fillColor, lineWidth) {
	                var vpath = [],
	                    initial,
	                    stroke,
	                    fill,
	                    closed,
	                    vel,
	                    plen,
	                    i;
	                for (i = 0, plen = path.length; i < plen; i++) {
	                    vpath[i] = '' + path[i][0] + ',' + path[i][1];
	                }
	                initial = vpath.splice(0, 1);
	                lineWidth = lineWidth === undefined ? 1 : lineWidth;
	                stroke = lineColor === undefined ? ' stroked="false" ' : ' strokeWeight="' + lineWidth + 'px" strokeColor="' + lineColor + '" ';
	                fill = fillColor === undefined ? ' filled="false"' : ' fillColor="' + fillColor + '" filled="true" ';
	                closed = vpath[0] === vpath[vpath.length - 1] ? 'x ' : '';
	                vel = '<v:shape coordorigin="0 0" coordsize="' + this.pixelWidth + ' ' + this.pixelHeight + '" ' + ' id="jqsshape' + shapeid + '" ' + stroke + fill + ' style="position:absolute;left:0px;top:0px;height:' + this.pixelHeight + 'px;width:' + this.pixelWidth + 'px;padding:0px;margin:0px;" ' + ' path="m ' + initial + ' l ' + vpath.join(', ') + ' ' + closed + 'e">' + ' </v:shape>';
	                return vel;
	            },
	
	            _drawCircle: function (shapeid, x, y, radius, lineColor, fillColor, lineWidth) {
	                var stroke, fill, vel;
	                x -= radius;
	                y -= radius;
	                stroke = lineColor === undefined ? ' stroked="false" ' : ' strokeWeight="' + lineWidth + 'px" strokeColor="' + lineColor + '" ';
	                fill = fillColor === undefined ? ' filled="false"' : ' fillColor="' + fillColor + '" filled="true" ';
	                vel = '<v:oval ' + ' id="jqsshape' + shapeid + '" ' + stroke + fill + ' style="position:absolute;top:' + y + 'px; left:' + x + 'px; width:' + radius * 2 + 'px; height:' + radius * 2 + 'px"></v:oval>';
	                return vel;
	            },
	
	            _drawPieSlice: function (shapeid, x, y, radius, startAngle, endAngle, lineColor, fillColor) {
	                var vpath, startx, starty, endx, endy, stroke, fill, vel;
	                if (startAngle === endAngle) {
	                    return ''; // VML seems to have problem when start angle equals end angle.
	                }
	                if (endAngle - startAngle === 2 * Math.PI) {
	                    startAngle = 0.0; // VML seems to have a problem when drawing a full circle that doesn't start 0
	                    endAngle = 2 * Math.PI;
	                }
	
	                startx = x + Math.round(Math.cos(startAngle) * radius);
	                starty = y + Math.round(Math.sin(startAngle) * radius);
	                endx = x + Math.round(Math.cos(endAngle) * radius);
	                endy = y + Math.round(Math.sin(endAngle) * radius);
	
	                if (startx === endx && starty === endy) {
	                    if (endAngle - startAngle < Math.PI) {
	                        // Prevent very small slices from being mistaken as a whole pie
	                        return '';
	                    }
	                    // essentially going to be the entire circle, so ignore startAngle
	                    startx = endx = x + radius;
	                    starty = endy = y;
	                }
	
	                if (startx === endx && starty === endy && endAngle - startAngle < Math.PI) {
	                    return '';
	                }
	
	                vpath = [x - radius, y - radius, x + radius, y + radius, startx, starty, endx, endy];
	                stroke = lineColor === undefined ? ' stroked="false" ' : ' strokeWeight="1px" strokeColor="' + lineColor + '" ';
	                fill = fillColor === undefined ? ' filled="false"' : ' fillColor="' + fillColor + '" filled="true" ';
	                vel = '<v:shape coordorigin="0 0" coordsize="' + this.pixelWidth + ' ' + this.pixelHeight + '" ' + ' id="jqsshape' + shapeid + '" ' + stroke + fill + ' style="position:absolute;left:0px;top:0px;height:' + this.pixelHeight + 'px;width:' + this.pixelWidth + 'px;padding:0px;margin:0px;" ' + ' path="m ' + x + ',' + y + ' wa ' + vpath.join(', ') + ' x e">' + ' </v:shape>';
	                return vel;
	            },
	
	            _drawRect: function (shapeid, x, y, width, height, lineColor, fillColor) {
	                return this._drawShape(shapeid, [[x, y], [x, y + height], [x + width, y + height], [x + width, y], [x, y]], lineColor, fillColor);
	            },
	
	            reset: function () {
	                this.group.innerHTML = '';
	            },
	
	            appendShape: function (shape) {
	                var vel = this['_draw' + shape.type].apply(this, shape.args);
	                if (this.rendered) {
	                    this.group.insertAdjacentHTML('beforeEnd', vel);
	                } else {
	                    this.prerender += vel;
	                }
	                this.lastShapeId = shape.id;
	                return shape.id;
	            },
	
	            replaceWithShape: function (shapeid, shape) {
	                var existing = $('#jqsshape' + shapeid),
	                    vel = this['_draw' + shape.type].apply(this, shape.args);
	                existing[0].outerHTML = vel;
	            },
	
	            replaceWithShapes: function (shapeids, shapes) {
	                // replace the first shapeid with all the new shapes then toast the remaining old shapes
	                var existing = $('#jqsshape' + shapeids[0]),
	                    replace = '',
	                    slen = shapes.length,
	                    i;
	                for (i = 0; i < slen; i++) {
	                    replace += this['_draw' + shapes[i].type].apply(this, shapes[i].args);
	                }
	                existing[0].outerHTML = replace;
	                for (i = 1; i < shapeids.length; i++) {
	                    $('#jqsshape' + shapeids[i]).remove();
	                }
	            },
	
	            insertAfterShape: function (shapeid, shape) {
	                var existing = $('#jqsshape' + shapeid),
	                    vel = this['_draw' + shape.type].apply(this, shape.args);
	                existing[0].insertAdjacentHTML('afterEnd', vel);
	            },
	
	            removeShapeId: function (shapeid) {
	                var existing = $('#jqsshape' + shapeid);
	                this.group.removeChild(existing[0]);
	            },
	
	            getShapeAt: function (el, x, y) {
	                var shapeid = el.id.substr(8);
	                return shapeid;
	            },
	
	            render: function () {
	                if (!this.rendered) {
	                    // batch the intial render into a single repaint
	                    this.group.innerHTML = this.prerender;
	                    this.rendered = true;
	                }
	            }
	        });
	    });
	})(document, Math);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * @fileOverview jquery-autocomplete, the jQuery Autocompleter
	 * @author <a href="mailto:dylan@dyve.net">Dylan Verheul</a>
	 * @version 2.4.4
	 * @requires jQuery 1.6+
	 * @license MIT | GPL | Apache 2.0, see LICENSE.txt
	 * @see https://github.com/dyve/jquery-autocomplete
	 */
	(function ($) {
	    "use strict";
	
	    /**
	     * jQuery autocomplete plugin
	     * @param {object|string} options
	     * @returns (object} jQuery object
	     */
	
	    $.fn.autocomplete_verheul = function (options) {
	        var url;
	        if (arguments.length > 1) {
	            url = options;
	            options = arguments[1];
	            options.url = url;
	        } else if (typeof options === 'string') {
	            url = options;
	            options = { url: url };
	        }
	        var opts = $.extend({}, $.fn.autocomplete_verheul.defaults, options);
	        return this.each(function () {
	            var $this = $(this);
	            $this.data('autocompleter', new $.Autocompleter($this, $.meta ? $.extend({}, opts, $this.data()) : opts));
	        });
	    };
	
	    /**
	     * Store default options
	     * @type {object}
	     */
	    $.fn.autocomplete_verheul.defaults = {
	        inputClass: 'acInput',
	        loadingClass: 'acLoading',
	        resultsClass: 'acResults',
	        selectClass: 'acSelect',
	        queryParamName: 'q',
	        extraParams: {},
	        remoteDataType: false,
	        lineSeparator: '\n',
	        cellSeparator: '|',
	        minChars: 2,
	        maxItemsToShow: 10,
	        delay: 400,
	        useCache: true,
	        maxCacheLength: 10,
	        matchSubset: true,
	        matchCase: false,
	        matchInside: true,
	        mustMatch: false,
	        selectFirst: false,
	        selectOnly: false,
	        showResult: null,
	        preventDefaultReturn: 1,
	        preventDefaultTab: 0,
	        autoFill: false,
	        filterResults: true,
	        filter: true,
	        sortResults: true,
	        sortFunction: null,
	        onItemSelect: null,
	        onNoMatch: null,
	        onFinish: null,
	        matchStringConverter: null,
	        beforeUseConverter: null,
	        autoWidth: 'min-width',
	        useDelimiter: false,
	        delimiterChar: ',',
	        delimiterKeyCode: 188,
	        processData: null,
	        onError: null,
	        enabled: true
	    };
	
	    /**
	     * Sanitize result
	     * @param {Object} result
	     * @returns {Object} object with members value (String) and data (Object)
	     * @private
	     */
	    var sanitizeResult = function (result) {
	        var value, data;
	        var type = typeof result;
	        if (type === 'string') {
	            value = result;
	            data = {};
	        } else if ($.isArray(result)) {
	            value = result[0];
	            data = result.slice(1);
	        } else if (type === 'object') {
	            value = result.value;
	            data = result.data;
	        }
	        value = String(value);
	        if (typeof data !== 'object') {
	            data = {};
	        }
	        return {
	            value: value,
	            data: data
	        };
	    };
	
	    /**
	     * Sanitize integer
	     * @param {mixed} value
	     * @param {Object} options
	     * @returns {Number} integer
	     * @private
	     */
	    var sanitizeInteger = function (value, stdValue, options) {
	        var num = parseInt(value, 10);
	        options = options || {};
	        if (isNaN(num) || options.min && num < options.min) {
	            num = stdValue;
	        }
	        return num;
	    };
	
	    /**
	     * Create partial url for a name/value pair
	     */
	    var makeUrlParam = function (name, value) {
	        return [name, encodeURIComponent(value)].join('=');
	    };
	
	    /**
	     * Build an url
	     * @param {string} url Base url
	     * @param {object} [params] Dictionary of parameters
	     */
	    var makeUrl = function (url, params) {
	        var urlAppend = [];
	        $.each(params, function (index, value) {
	            urlAppend.push(makeUrlParam(index, value));
	        });
	        if (urlAppend.length) {
	            url += url.indexOf('?') === -1 ? '?' : '&';
	            url += urlAppend.join('&');
	        }
	        return url;
	    };
	
	    /**
	     * Default sort filter
	     * @param {object} a
	     * @param {object} b
	     * @param {boolean} matchCase
	     * @returns {number}
	     */
	    var sortValueAlpha = function (a, b, matchCase) {
	        a = String(a.value);
	        b = String(b.value);
	        if (!matchCase) {
	            a = a.toLowerCase();
	            b = b.toLowerCase();
	        }
	        if (a > b) {
	            return 1;
	        }
	        if (a < b) {
	            return -1;
	        }
	        return 0;
	    };
	
	    /**
	     * Parse data received in text format
	     * @param {string} text Plain text input
	     * @param {string} lineSeparator String that separates lines
	     * @param {string} cellSeparator String that separates cells
	     * @returns {array} Array of autocomplete data objects
	     */
	    var plainTextParser = function (text, lineSeparator, cellSeparator) {
	        var results = [];
	        var i, j, data, line, value, lines;
	        // Be nice, fix linebreaks before splitting on lineSeparator
	        lines = String(text).replace('\r\n', '\n').split(lineSeparator);
	        for (i = 0; i < lines.length; i++) {
	            line = lines[i].split(cellSeparator);
	            data = [];
	            for (j = 0; j < line.length; j++) {
	                data.push(decodeURIComponent(line[j]));
	            }
	            value = data.shift();
	            results.push({ value: value, data: data });
	        }
	        return results;
	    };
	
	    /**
	     * Autocompleter class
	     * @param {object} $elem jQuery object with one input tag
	     * @param {object} options Settings
	     * @constructor
	     */
	    $.Autocompleter = function ($elem, options) {
	
	        /**
	         * Assert parameters
	         */
	        if (!$elem || !($elem instanceof $) || $elem.length !== 1 || $elem.get(0).tagName.toUpperCase() !== 'INPUT' && $elem.get(0).tagName.toUpperCase() !== 'TEXTAREA') {
	            throw new Error('Invalid parameter for jquery.Autocompleter, jQuery object with one element with INPUT or TEXTAREA tag expected.');
	        }
	
	        /**
	         * @constant Link to this instance
	         * @type object
	         * @private
	         */
	        var self = this;
	
	        /**
	         * @property {object} Options for this instance
	         * @public
	         */
	        this.options = options;
	
	        /**
	         * @property object Cached data for this instance
	         * @private
	         */
	        this.cacheData_ = {};
	
	        /**
	         * @property {number} Number of cached data items
	         * @private
	         */
	        this.cacheLength_ = 0;
	
	        /**
	         * @property {string} Class name to mark selected item
	         * @private
	         */
	        this.selectClass_ = 'jquery-autocomplete-selected-item';
	
	        /**
	         * @property {number} Handler to activation timeout
	         * @private
	         */
	        this.keyTimeout_ = null;
	
	        /**
	         * @property {number} Handler to finish timeout
	         * @private
	         */
	        this.finishTimeout_ = null;
	
	        /**
	         * @property {number} Last key pressed in the input field (store for behavior)
	         * @private
	         */
	        this.lastKeyPressed_ = null;
	
	        /**
	         * @property {string} Last value processed by the autocompleter
	         * @private
	         */
	        this.lastProcessedValue_ = null;
	
	        /**
	         * @property {string} Last value selected by the user
	         * @private
	         */
	        this.lastSelectedValue_ = null;
	
	        /**
	         * @property {boolean} Is this autocompleter active (showing results)?
	         * @see showResults
	         * @private
	         */
	        this.active_ = false;
	
	        /**
	         * @property {boolean} Is this autocompleter allowed to finish on blur?
	         * @private
	         */
	        this.finishOnBlur_ = true;
	
	        /**
	         * Sanitize options
	         */
	        this.options.minChars = sanitizeInteger(this.options.minChars, $.fn.autocomplete_verheul.defaults.minChars, { min: 0 });
	        this.options.maxItemsToShow = sanitizeInteger(this.options.maxItemsToShow, $.fn.autocomplete_verheul.defaults.maxItemsToShow, { min: 0 });
	        this.options.maxCacheLength = sanitizeInteger(this.options.maxCacheLength, $.fn.autocomplete_verheul.defaults.maxCacheLength, { min: 1 });
	        this.options.delay = sanitizeInteger(this.options.delay, $.fn.autocomplete_verheul.defaults.delay, { min: 0 });
	        if (this.options.preventDefaultReturn != 2) {
	            this.options.preventDefaultReturn = this.options.preventDefaultReturn ? 1 : 0;
	        }
	        if (this.options.preventDefaultTab != 2) {
	            this.options.preventDefaultTab = this.options.preventDefaultTab ? 1 : 0;
	        }
	
	        /**
	         * Init DOM elements repository
	         */
	        this.dom = {};
	
	        /**
	         * Store the input element we're attached to in the repository
	         */
	        this.dom.$elem = $elem;
	
	        /**
	         * Switch off the native autocomplete and add the input class
	         */
	        this.dom.$elem.attr('autocomplete', 'off').addClass(this.options.inputClass);
	
	        /**
	         * Create DOM element to hold results, and force absolute position
	         */
	        this.dom.$results = $('<div></div>').hide().addClass(this.options.resultsClass).css({
	            position: 'absolute'
	        });
	        $('body').append(this.dom.$results);
	
	        /**
	         * Attach keyboard monitoring to $elem
	         */
	        $elem.keydown(function (e) {
	            self.lastKeyPressed_ = e.keyCode;
	            switch (self.lastKeyPressed_) {
	
	                case self.options.delimiterKeyCode:
	                    // comma = 188
	                    if (self.options.useDelimiter && self.active_) {
	                        self.selectCurrent();
	                    }
	                    break;
	
	                // ignore navigational & special keys
	                case 35: // end
	                case 36: // home
	                case 16: // shift
	                case 17: // ctrl
	                case 18: // alt
	                case 37: // left
	                case 39:
	                    // right
	                    break;
	
	                case 38:
	                    // up
	                    e.preventDefault();
	                    if (self.active_) {
	                        self.focusPrev();
	                    } else {
	                        self.activate();
	                    }
	                    return false;
	
	                case 40:
	                    // down
	                    e.preventDefault();
	                    if (self.active_) {
	                        self.focusNext();
	                    } else {
	                        self.activate();
	                    }
	                    return false;
	
	                case 9:
	                    // tab
	                    if (self.active_) {
	                        self.selectCurrent();
	                        if (self.options.preventDefaultTab) {
	                            e.preventDefault();
	                            return false;
	                        }
	                    }
	                    if (self.options.preventDefaultTab === 2) {
	                        e.preventDefault();
	                        return false;
	                    }
	                    break;
	
	                case 13:
	                    // return
	                    if (self.active_) {
	                        self.selectCurrent();
	                        if (self.options.preventDefaultReturn) {
	                            e.preventDefault();
	                            return false;
	                        }
	                    }
	                    if (self.options.preventDefaultReturn === 2) {
	                        e.preventDefault();
	                        return false;
	                    }
	                    break;
	
	                case 27:
	                    // escape
	                    if (self.active_) {
	                        e.preventDefault();
	                        self.deactivate(true);
	                        return false;
	                    }
	                    break;
	
	                default:
	                    self.activate();
	
	            }
	        });
	
	        /**
	         * Attach paste event listener because paste may occur much later then keydown or even without a keydown at all
	         */
	        $elem.on('paste', function () {
	            self.activate();
	        });
	
	        /**
	         * Finish on blur event
	         * Use a timeout because instant blur gives race conditions
	         */
	        var onBlurFunction = function () {
	            self.deactivate(true);
	        };
	        $elem.blur(function () {
	            if (self.finishOnBlur_) {
	                self.finishTimeout_ = setTimeout(onBlurFunction, 200);
	            }
	        });
	        /**
	         * Catch a race condition on form submit
	         */
	        $elem.parents('form').on('submit', onBlurFunction);
	    };
	
	    /**
	     * Position output DOM elements
	     * @private
	     */
	    $.Autocompleter.prototype.position = function () {
	        var offset = this.dom.$elem.offset();
	        var height = this.dom.$results.outerHeight();
	        var totalHeight = $(window).outerHeight();
	        var inputBottom = offset.top + this.dom.$elem.outerHeight();
	        var bottomIfDown = inputBottom + height;
	        // Set autocomplete results at the bottom of input
	        var position = { top: inputBottom, left: offset.left };
	        if (bottomIfDown > totalHeight) {
	            // Try to set autocomplete results at the top of input
	            var topIfUp = offset.top - height;
	            if (topIfUp >= 0) {
	                position.top = topIfUp;
	            }
	        }
	        this.dom.$results.css(position);
	    };
	
	    /**
	     * Read from cache
	     * @private
	     */
	    $.Autocompleter.prototype.cacheRead = function (filter) {
	        var filterLength, searchLength, search, maxPos, pos;
	        if (this.options.useCache) {
	            filter = String(filter);
	            filterLength = filter.length;
	            if (this.options.matchSubset) {
	                searchLength = 1;
	            } else {
	                searchLength = filterLength;
	            }
	            while (searchLength <= filterLength) {
	                if (this.options.matchInside) {
	                    maxPos = filterLength - searchLength;
	                } else {
	                    maxPos = 0;
	                }
	                pos = 0;
	                while (pos <= maxPos) {
	                    search = filter.substr(0, searchLength);
	                    if (this.cacheData_[search] !== undefined) {
	                        return this.cacheData_[search];
	                    }
	                    pos++;
	                }
	                searchLength++;
	            }
	        }
	        return false;
	    };
	
	    /**
	     * Write to cache
	     * @private
	     */
	    $.Autocompleter.prototype.cacheWrite = function (filter, data) {
	        if (this.options.useCache) {
	            if (this.cacheLength_ >= this.options.maxCacheLength) {
	                this.cacheFlush();
	            }
	            filter = String(filter);
	            if (this.cacheData_[filter] !== undefined) {
	                this.cacheLength_++;
	            }
	            this.cacheData_[filter] = data;
	            return this.cacheData_[filter];
	        }
	        return false;
	    };
	
	    /**
	     * Flush cache
	     * @public
	     */
	    $.Autocompleter.prototype.cacheFlush = function () {
	        this.cacheData_ = {};
	        this.cacheLength_ = 0;
	    };
	
	    /**
	     * Call hook
	     * Note that all called hooks are passed the autocompleter object
	     * @param {string} hook
	     * @param data
	     * @returns Result of called hook, false if hook is undefined
	     */
	    $.Autocompleter.prototype.callHook = function (hook, data) {
	        var f = this.options[hook];
	        if (f && $.isFunction(f)) {
	            return f(data, this);
	        }
	        return false;
	    };
	
	    /**
	     * Set timeout to activate autocompleter
	     */
	    $.Autocompleter.prototype.activate = function () {
	        if (!this.options.enabled) return;
	        var self = this;
	        if (this.keyTimeout_) {
	            clearTimeout(this.keyTimeout_);
	        }
	        this.keyTimeout_ = setTimeout(function () {
	            self.activateNow();
	        }, this.options.delay);
	    };
	
	    /**
	     * Activate autocompleter immediately
	     */
	    $.Autocompleter.prototype.activateNow = function () {
	        var value = this.beforeUseConverter(this.dom.$elem.val());
	        if (value !== this.lastProcessedValue_ && value !== this.lastSelectedValue_) {
	            this.fetchData(value);
	        }
	    };
	
	    /**
	     * Get autocomplete data for a given value
	     * @param {string} value Value to base autocompletion on
	     * @private
	     */
	    $.Autocompleter.prototype.fetchData = function (value) {
	        var self = this;
	        var processResults = function (results, filter) {
	            if (self.options.processData) {
	                results = self.options.processData(results);
	            }
	            self.showResults(self.filterResults(results, filter), filter);
	        };
	        this.lastProcessedValue_ = value;
	        if (value.length < this.options.minChars) {
	            processResults([], value);
	        } else if (this.options.data) {
	            processResults(this.options.data, value);
	        } else {
	            this.fetchRemoteData(value, function (remoteData) {
	                processResults(remoteData, value);
	            });
	        }
	    };
	
	    /**
	     * Get remote autocomplete data for a given value
	     * @param {string} filter The filter to base remote data on
	     * @param {function} callback The function to call after data retrieval
	     * @private
	     */
	    $.Autocompleter.prototype.fetchRemoteData = function (filter, callback) {
	        var data = this.cacheRead(filter);
	        if (data) {
	            callback(data);
	        } else {
	            var self = this;
	            var dataType = self.options.remoteDataType === 'json' ? 'json' : 'text';
	            var ajaxCallback = function (data) {
	                var parsed = false;
	                if (data !== false) {
	                    parsed = self.parseRemoteData(data);
	                    self.cacheWrite(filter, parsed);
	                }
	                self.dom.$elem.removeClass(self.options.loadingClass);
	                callback(parsed);
	            };
	            this.dom.$elem.addClass(this.options.loadingClass);
	            $.ajax({
	                url: this.makeUrl(filter),
	                success: ajaxCallback,
	                error: function (jqXHR, textStatus, errorThrown) {
	                    if ($.isFunction(self.options.onError)) {
	                        self.options.onError(jqXHR, textStatus, errorThrown);
	                    } else {
	                        ajaxCallback(false);
	                    }
	                },
	                dataType: dataType
	            });
	        }
	    };
	
	    /**
	     * Create or update an extra parameter for the remote request
	     * @param {string} name Parameter name
	     * @param {string} value Parameter value
	     * @public
	     */
	    $.Autocompleter.prototype.setExtraParam = function (name, value) {
	        var index = $.trim(String(name));
	        if (index) {
	            if (!this.options.extraParams) {
	                this.options.extraParams = {};
	            }
	            if (this.options.extraParams[index] !== value) {
	                this.options.extraParams[index] = value;
	                this.cacheFlush();
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Build the url for a remote request
	     * If options.queryParamName === false, append query to url instead of using a GET parameter
	     * @param {string} param The value parameter to pass to the backend
	     * @returns {string} The finished url with parameters
	     */
	    $.Autocompleter.prototype.makeUrl = function (param) {
	        var self = this;
	        var url = this.options.url;
	        var params = $.extend({}, this.options.extraParams);
	
	        if (this.options.queryParamName === false) {
	            url += encodeURIComponent(param);
	        } else {
	            params[this.options.queryParamName] = param;
	        }
	
	        return makeUrl(url, params);
	    };
	
	    /**
	     * Parse data received from server
	     * @param remoteData Data received from remote server
	     * @returns {array} Parsed data
	     */
	    $.Autocompleter.prototype.parseRemoteData = function (remoteData) {
	        var remoteDataType;
	        var data = remoteData;
	        if (this.options.remoteDataType === 'json') {
	            remoteDataType = typeof remoteData;
	            switch (remoteDataType) {
	                case 'object':
	                    data = remoteData;
	                    break;
	                case 'string':
	                    data = $.parseJSON(remoteData);
	                    break;
	                default:
	                    throw new Error("Unexpected remote data type: " + remoteDataType);
	            }
	            return data;
	        }
	        return plainTextParser(data, this.options.lineSeparator, this.options.cellSeparator);
	    };
	
	    /**
	     * Default filter for results
	     * @param {Object} result
	     * @param {String} filter
	     * @returns {boolean} Include this result
	     * @private
	     */
	    $.Autocompleter.prototype.defaultFilter = function (result, filter) {
	        if (!result.value) {
	            return false;
	        }
	        if (this.options.filterResults) {
	            var pattern = this.matchStringConverter(filter);
	            var testValue = this.matchStringConverter(result.value);
	            if (!this.options.matchCase) {
	                pattern = pattern.toLowerCase();
	                testValue = testValue.toLowerCase();
	            }
	            var patternIndex = testValue.indexOf(pattern);
	            if (this.options.matchInside) {
	                return patternIndex > -1;
	            } else {
	                return patternIndex === 0;
	            }
	        }
	        return true;
	    };
	
	    /**
	     * Filter result
	     * @param {Object} result
	     * @param {String} filter
	     * @returns {boolean} Include this result
	     * @private
	     */
	    $.Autocompleter.prototype.filterResult = function (result, filter) {
	        // No filter
	        if (this.options.filter === false) {
	            return true;
	        }
	        // Custom filter
	        if ($.isFunction(this.options.filter)) {
	            return this.options.filter(result, filter);
	        }
	        // Default filter
	        return this.defaultFilter(result, filter);
	    };
	
	    /**
	     * Filter results
	     * @param results
	     * @param filter
	     */
	    $.Autocompleter.prototype.filterResults = function (results, filter) {
	        var filtered = [];
	        var i, result;
	
	        for (i = 0; i < results.length; i++) {
	            result = sanitizeResult(results[i]);
	            if (this.filterResult(result, filter)) {
	                filtered.push(result);
	            }
	        }
	        if (this.options.sortResults) {
	            filtered = this.sortResults(filtered, filter);
	        }
	        if (this.options.maxItemsToShow > 0 && this.options.maxItemsToShow < filtered.length) {
	            filtered.length = this.options.maxItemsToShow;
	        }
	        return filtered;
	    };
	
	    /**
	     * Sort results
	     * @param results
	     * @param filter
	     */
	    $.Autocompleter.prototype.sortResults = function (results, filter) {
	        var self = this;
	        var sortFunction = this.options.sortFunction;
	        if (!$.isFunction(sortFunction)) {
	            sortFunction = function (a, b, f) {
	                return sortValueAlpha(a, b, self.options.matchCase);
	            };
	        }
	        results.sort(function (a, b) {
	            return sortFunction(a, b, filter, self.options);
	        });
	        return results;
	    };
	
	    /**
	     * Convert string before matching
	     * @param s
	     * @param a
	     * @param b
	     */
	    $.Autocompleter.prototype.matchStringConverter = function (s, a, b) {
	        var converter = this.options.matchStringConverter;
	        if ($.isFunction(converter)) {
	            s = converter(s, a, b);
	        }
	        return s;
	    };
	
	    /**
	     * Convert string before use
	     * @param {String} s
	     */
	    $.Autocompleter.prototype.beforeUseConverter = function (s) {
	        s = this.getValue(s);
	        var converter = this.options.beforeUseConverter;
	        if ($.isFunction(converter)) {
	            s = converter(s);
	        }
	        return s;
	    };
	
	    /**
	     * Enable finish on blur event
	     */
	    $.Autocompleter.prototype.enableFinishOnBlur = function () {
	        this.finishOnBlur_ = true;
	    };
	
	    /**
	     * Disable finish on blur event
	     */
	    $.Autocompleter.prototype.disableFinishOnBlur = function () {
	        this.finishOnBlur_ = false;
	    };
	
	    /**
	     * Create a results item (LI element) from a result
	     * @param result
	     */
	    $.Autocompleter.prototype.createItemFromResult = function (result) {
	        var self = this;
	        var $li = $('<li/>');
	        $li.html(this.showResult(result.value, result.data));
	        $li.data({ value: result.value, data: result.data }).click(function () {
	            self.selectItem($li);
	        }).mousedown(self.disableFinishOnBlur).mouseup(self.enableFinishOnBlur);
	        return $li;
	    };
	
	    /**
	     * Get all items from the results list
	     * @param result
	     */
	    $.Autocompleter.prototype.getItems = function () {
	        return $('>ul>li', this.dom.$results);
	    };
	
	    /**
	     * Show all results
	     * @param results
	     * @param filter
	     */
	    $.Autocompleter.prototype.showResults = function (results, filter) {
	        var numResults = results.length;
	        var self = this;
	        var $ul = $('<ul></ul>');
	        var i,
	            result,
	            $li,
	            autoWidth,
	            first = false,
	            $first = false;
	
	        if (numResults) {
	            for (i = 0; i < numResults; i++) {
	                result = results[i];
	                $li = this.createItemFromResult(result);
	                $ul.append($li);
	                if (first === false) {
	                    first = String(result.value);
	                    $first = $li;
	                    $li.addClass(this.options.firstItemClass);
	                }
	                if (i === numResults - 1) {
	                    $li.addClass(this.options.lastItemClass);
	                }
	            }
	
	            this.dom.$results.html($ul).show();
	
	            // Always recalculate position since window size or
	            // input element location may have changed.
	            this.position();
	            if (this.options.autoWidth) {
	                autoWidth = this.dom.$elem.outerWidth() - this.dom.$results.outerWidth() + this.dom.$results.width();
	                this.dom.$results.css(this.options.autoWidth, autoWidth);
	            }
	            this.getItems().hover(function () {
	                self.focusItem(this);
	            }, function () {/* void */});
	            if (this.autoFill(first, filter) || this.options.selectFirst || this.options.selectOnly && numResults === 1) {
	                this.focusItem($first);
	            }
	            this.active_ = true;
	        } else {
	            this.hideResults();
	            this.active_ = false;
	        }
	    };
	
	    $.Autocompleter.prototype.showResult = function (value, data) {
	        if ($.isFunction(this.options.showResult)) {
	            return this.options.showResult(value, data);
	        } else {
	            return $('<p></p>').text(value).html();
	        }
	    };
	
	    $.Autocompleter.prototype.autoFill = function (value, filter) {
	        var lcValue, lcFilter, valueLength, filterLength;
	        if (this.options.autoFill && this.lastKeyPressed_ !== 8) {
	            lcValue = String(value).toLowerCase();
	            lcFilter = String(filter).toLowerCase();
	            valueLength = value.length;
	            filterLength = filter.length;
	            if (lcValue.substr(0, filterLength) === lcFilter) {
	                var d = this.getDelimiterOffsets();
	                var pad = d.start ? ' ' : ''; // if there is a preceding delimiter
	                this.setValue(pad + value);
	                var start = filterLength + d.start + pad.length;
	                var end = valueLength + d.start + pad.length;
	                this.selectRange(start, end);
	                return true;
	            }
	        }
	        return false;
	    };
	
	    $.Autocompleter.prototype.focusNext = function () {
	        this.focusMove(+1);
	    };
	
	    $.Autocompleter.prototype.focusPrev = function () {
	        this.focusMove(-1);
	    };
	
	    $.Autocompleter.prototype.focusMove = function (modifier) {
	        var $items = this.getItems();
	        modifier = sanitizeInteger(modifier, 0);
	        if (modifier) {
	            for (var i = 0; i < $items.length; i++) {
	                if ($($items[i]).hasClass(this.selectClass_)) {
	                    this.focusItem(i + modifier);
	                    return;
	                }
	            }
	        }
	        this.focusItem(0);
	    };
	
	    $.Autocompleter.prototype.focusItem = function (item) {
	        var $item,
	            $items = this.getItems();
	        if ($items.length) {
	            $items.removeClass(this.selectClass_).removeClass(this.options.selectClass);
	            if (typeof item === 'number') {
	                if (item < 0) {
	                    item = 0;
	                } else if (item >= $items.length) {
	                    item = $items.length - 1;
	                }
	                $item = $($items[item]);
	            } else {
	                $item = $(item);
	            }
	            if ($item) {
	                $item.addClass(this.selectClass_).addClass(this.options.selectClass);
	            }
	        }
	    };
	
	    $.Autocompleter.prototype.selectCurrent = function () {
	        var $item = $('li.' + this.selectClass_, this.dom.$results);
	        if ($item.length === 1) {
	            this.selectItem($item);
	        } else {
	            this.deactivate(false);
	        }
	    };
	
	    $.Autocompleter.prototype.selectItem = function ($li) {
	        var value = $li.data('value');
	        var data = $li.data('data');
	        var displayValue = this.displayValue(value, data);
	        var processedDisplayValue = this.beforeUseConverter(displayValue);
	        this.lastProcessedValue_ = processedDisplayValue;
	        this.lastSelectedValue_ = processedDisplayValue;
	        var d = this.getDelimiterOffsets();
	        var delimiter = this.options.delimiterChar;
	        var elem = this.dom.$elem;
	        var extraCaretPos = 0;
	        if (this.options.useDelimiter) {
	            // if there is a preceding delimiter, add a space after the delimiter
	            if (elem.val().substring(d.start - 1, d.start) == delimiter && delimiter != ' ') {
	                displayValue = ' ' + displayValue;
	            }
	            // if there is not already a delimiter trailing this value, add it
	            if (elem.val().substring(d.end, d.end + 1) != delimiter && this.lastKeyPressed_ != this.options.delimiterKeyCode) {
	                displayValue = displayValue + delimiter;
	            } else {
	                // move the cursor after the existing trailing delimiter
	                extraCaretPos = 1;
	            }
	        }
	        this.setValue(displayValue);
	        this.setCaret(d.start + displayValue.length + extraCaretPos);
	        this.callHook('onItemSelect', { value: value, data: data });
	        this.deactivate(true);
	        elem.focus();
	    };
	
	    $.Autocompleter.prototype.displayValue = function (value, data) {
	        if ($.isFunction(this.options.displayValue)) {
	            return this.options.displayValue(value, data);
	        }
	        return value;
	    };
	
	    $.Autocompleter.prototype.hideResults = function () {
	        this.dom.$results.hide();
	    };
	
	    $.Autocompleter.prototype.deactivate = function (finish) {
	        if (this.finishTimeout_) {
	            clearTimeout(this.finishTimeout_);
	        }
	        if (this.keyTimeout_) {
	            clearTimeout(this.keyTimeout_);
	        }
	        if (finish) {
	            if (this.lastProcessedValue_ !== this.lastSelectedValue_) {
	                if (this.options.mustMatch) {
	                    this.setValue('');
	                }
	                this.callHook('onNoMatch');
	            }
	            if (this.active_) {
	                this.callHook('onFinish');
	            }
	            this.lastKeyPressed_ = null;
	            this.lastProcessedValue_ = null;
	            this.lastSelectedValue_ = null;
	            this.active_ = false;
	        }
	        this.hideResults();
	    };
	
	    $.Autocompleter.prototype.selectRange = function (start, end) {
	        var input = this.dom.$elem.get(0);
	        if (input.setSelectionRange) {
	            input.focus();
	            input.setSelectionRange(start, end);
	        } else if (input.createTextRange) {
	            var range = input.createTextRange();
	            range.collapse(true);
	            range.moveEnd('character', end);
	            range.moveStart('character', start);
	            range.select();
	        }
	    };
	
	    /**
	     * Move caret to position
	     * @param {Number} pos
	     */
	    $.Autocompleter.prototype.setCaret = function (pos) {
	        this.selectRange(pos, pos);
	    };
	
	    /**
	     * Get caret position
	     */
	    $.Autocompleter.prototype.getCaret = function () {
	        var $elem = this.dom.$elem;
	        var elem = $elem[0];
	        var val, selection, range, start, end, stored_range;
	        if (elem.createTextRange) {
	            // IE
	            selection = document.selection;
	            if (elem.tagName.toLowerCase() != 'textarea') {
	                val = $elem.val();
	                range = selection.createRange().duplicate();
	                range.moveEnd('character', val.length);
	                if (range.text === '') {
	                    start = val.length;
	                } else {
	                    start = val.lastIndexOf(range.text);
	                }
	                range = selection.createRange().duplicate();
	                range.moveStart('character', -val.length);
	                end = range.text.length;
	            } else {
	                range = selection.createRange();
	                stored_range = range.duplicate();
	                stored_range.moveToElementText(elem);
	                stored_range.setEndPoint('EndToEnd', range);
	                start = stored_range.text.length - range.text.length;
	                end = start + range.text.length;
	            }
	        } else {
	            start = $elem[0].selectionStart;
	            end = $elem[0].selectionEnd;
	        }
	        return {
	            start: start,
	            end: end
	        };
	    };
	
	    /**
	     * Set the value that is currently being autocompleted
	     * @param {String} value
	     */
	    $.Autocompleter.prototype.setValue = function (value) {
	        if (this.options.useDelimiter) {
	            // set the substring between the current delimiters
	            var val = this.dom.$elem.val();
	            var d = this.getDelimiterOffsets();
	            var preVal = val.substring(0, d.start);
	            var postVal = val.substring(d.end);
	            value = preVal + value + postVal;
	        }
	        this.dom.$elem.val(value);
	    };
	
	    /**
	     * Get the value currently being autocompleted
	     * @param {String} value
	     */
	    $.Autocompleter.prototype.getValue = function (value) {
	        if (this.options.useDelimiter) {
	            var d = this.getDelimiterOffsets();
	            return value.substring(d.start, d.end).trim();
	        } else {
	            return value;
	        }
	    };
	
	    /**
	     * Get the offsets of the value currently being autocompleted
	     */
	    $.Autocompleter.prototype.getDelimiterOffsets = function () {
	        var val = this.dom.$elem.val();
	        if (this.options.useDelimiter) {
	            var preCaretVal = val.substring(0, this.getCaret().start);
	            var start = preCaretVal.lastIndexOf(this.options.delimiterChar) + 1;
	            var postCaretVal = val.substring(this.getCaret().start);
	            var end = postCaretVal.indexOf(this.options.delimiterChar);
	            if (end == -1) end = val.length;
	            end += this.getCaret().start;
	        } else {
	            start = 0;
	            end = val.length;
	        }
	        return {
	            start: start,
	            end: end
	        };
	    };
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * jQuery Migrate - v1.4.0 - 2016-02-26
	 * Copyright jQuery Foundation and other contributors
	 */
	(function (jQuery, window, undefined) {
		// See http://bugs.jquery.com/ticket/13335
		// "use strict";
	
	
		jQuery.migrateVersion = "1.4.0";
	
		var warnedAbout = {};
	
		// List of warnings already given; public read only
		jQuery.migrateWarnings = [];
	
		// Set to true to prevent console output; migrateWarnings still maintained
		// jQuery.migrateMute = false;
	
		// Show a message on the console so devs know we're active
		if (window.console && window.console.log) {
			window.console.log("JQMIGRATE: Migrate is installed" + (jQuery.migrateMute ? "" : " with logging active") + ", version " + jQuery.migrateVersion);
		}
	
		// Set to false to disable traces that appear with warnings
		if (jQuery.migrateTrace === undefined) {
			jQuery.migrateTrace = true;
		}
	
		// Forget any warnings we've already given; public
		jQuery.migrateReset = function () {
			warnedAbout = {};
			jQuery.migrateWarnings.length = 0;
		};
	
		function migrateWarn(msg) {
			var console = window.console;
			if (!warnedAbout[msg]) {
				warnedAbout[msg] = true;
				jQuery.migrateWarnings.push(msg);
				if (console && console.warn && !jQuery.migrateMute) {
					console.warn("JQMIGRATE: " + msg);
					if (jQuery.migrateTrace && console.trace) {
						console.trace();
					}
				}
			}
		}
	
		function migrateWarnProp(obj, prop, value, msg) {
			if (Object.defineProperty) {
				// On ES5 browsers (non-oldIE), warn if the code tries to get prop;
				// allow property to be overwritten in case some other plugin wants it
				try {
					Object.defineProperty(obj, prop, {
						configurable: true,
						enumerable: true,
						get: function () {
							migrateWarn(msg);
							return value;
						},
						set: function (newValue) {
							migrateWarn(msg);
							value = newValue;
						}
					});
					return;
				} catch (err) {
					// IE8 is a dope about Object.defineProperty, can't warn there
				}
			}
	
			// Non-ES5 (or broken) browser; just set the property
			jQuery._definePropertyBroken = true;
			obj[prop] = value;
		}
	
		if (document.compatMode === "BackCompat") {
			// jQuery has never supported or tested Quirks Mode
			migrateWarn("jQuery is not compatible with Quirks Mode");
		}
	
		var attrFn = jQuery("<input/>", { size: 1 }).attr("size") && jQuery.attrFn,
		    oldAttr = jQuery.attr,
		    valueAttrGet = jQuery.attrHooks.value && jQuery.attrHooks.value.get || function () {
			return null;
		},
		    valueAttrSet = jQuery.attrHooks.value && jQuery.attrHooks.value.set || function () {
			return undefined;
		},
		    rnoType = /^(?:input|button)$/i,
		    rnoAttrNodeType = /^[238]$/,
		    rboolean = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
		    ruseDefault = /^(?:checked|selected)$/i;
	
		// jQuery.attrFn
		migrateWarnProp(jQuery, "attrFn", attrFn || {}, "jQuery.attrFn is deprecated");
	
		jQuery.attr = function (elem, name, value, pass) {
			var lowerName = name.toLowerCase(),
			    nType = elem && elem.nodeType;
	
			if (pass) {
				// Since pass is used internally, we only warn for new jQuery
				// versions where there isn't a pass arg in the formal params
				if (oldAttr.length < 4) {
					migrateWarn("jQuery.fn.attr( props, pass ) is deprecated");
				}
				if (elem && !rnoAttrNodeType.test(nType) && (attrFn ? name in attrFn : jQuery.isFunction(jQuery.fn[name]))) {
					return jQuery(elem)[name](value);
				}
			}
	
			// Warn if user tries to set `type`, since it breaks on IE 6/7/8; by checking
			// for disconnected elements we don't warn on $( "<button>", { type: "button" } ).
			if (name === "type" && value !== undefined && rnoType.test(elem.nodeName) && elem.parentNode) {
				migrateWarn("Can't change the 'type' of an input or button in IE 6/7/8");
			}
	
			// Restore boolHook for boolean property/attribute synchronization
			if (!jQuery.attrHooks[lowerName] && rboolean.test(lowerName)) {
				jQuery.attrHooks[lowerName] = {
					get: function (elem, name) {
						// Align boolean attributes with corresponding properties
						// Fall back to attribute presence where some booleans are not supported
						var attrNode,
						    property = jQuery.prop(elem, name);
						return property === true || typeof property !== "boolean" && (attrNode = elem.getAttributeNode(name)) && attrNode.nodeValue !== false ? name.toLowerCase() : undefined;
					},
					set: function (elem, value, name) {
						var propName;
						if (value === false) {
							// Remove boolean attributes when set to false
							jQuery.removeAttr(elem, name);
						} else {
							// value is true since we know at this point it's type boolean and not false
							// Set boolean attributes to the same name and set the DOM property
							propName = jQuery.propFix[name] || name;
							if (propName in elem) {
								// Only set the IDL specifically if it already exists on the element
								elem[propName] = true;
							}
	
							elem.setAttribute(name, name.toLowerCase());
						}
						return name;
					}
				};
	
				// Warn only for attributes that can remain distinct from their properties post-1.9
				if (ruseDefault.test(lowerName)) {
					migrateWarn("jQuery.fn.attr('" + lowerName + "') might use property instead of attribute");
				}
			}
	
			return oldAttr.call(jQuery, elem, name, value);
		};
	
		// attrHooks: value
		jQuery.attrHooks.value = {
			get: function (elem, name) {
				var nodeName = (elem.nodeName || "").toLowerCase();
				if (nodeName === "button") {
					return valueAttrGet.apply(this, arguments);
				}
				if (nodeName !== "input" && nodeName !== "option") {
					migrateWarn("jQuery.fn.attr('value') no longer gets properties");
				}
				return name in elem ? elem.value : null;
			},
			set: function (elem, value) {
				var nodeName = (elem.nodeName || "").toLowerCase();
				if (nodeName === "button") {
					return valueAttrSet.apply(this, arguments);
				}
				if (nodeName !== "input" && nodeName !== "option") {
					migrateWarn("jQuery.fn.attr('value', val) no longer sets properties");
				}
				// Does not return so that setAttribute is also used
				elem.value = value;
			}
		};
	
		var matched,
		    browser,
		    oldInit = jQuery.fn.init,
		    oldParseJSON = jQuery.parseJSON,
		    rspaceAngle = /^\s*</,
		    rattrHash = /\[\s*\w+\s*[~|^$*]?=\s*(?![\s'"])[^#\]]*#/,
	
		// Note: XSS check is done below after string is trimmed
		rquickExpr = /^([^<]*)(<[\w\W]+>)([^>]*)$/;
	
		// $(html) "looks like html" rule change
		jQuery.fn.init = function (selector, context, rootjQuery) {
			var match, ret;
	
			if (selector && typeof selector === "string" && !jQuery.isPlainObject(context) && (match = rquickExpr.exec(jQuery.trim(selector))) && match[0]) {
				// This is an HTML string according to the "old" rules; is it still?
				if (!rspaceAngle.test(selector)) {
					migrateWarn("$(html) HTML strings must start with '<' character");
				}
				if (match[3]) {
					migrateWarn("$(html) HTML text after last tag is ignored");
				}
	
				// Consistently reject any HTML-like string starting with a hash (#9521)
				// Note that this may break jQuery 1.6.x code that otherwise would work.
				if (match[0].charAt(0) === "#") {
					migrateWarn("HTML string cannot start with a '#' character");
					jQuery.error("JQMIGRATE: Invalid selector string (XSS)");
				}
				// Now process using loose rules; let pre-1.8 play too
				if (context && context.context) {
					// jQuery object as context; parseHTML expects a DOM object
					context = context.context;
				}
				if (jQuery.parseHTML) {
					return oldInit.call(this, jQuery.parseHTML(match[2], context && context.ownerDocument || context || document, true), context, rootjQuery);
				}
			}
	
			if (selector === "#") {
	
				// jQuery( "#" ) is a bogus ID selector, but it returned an empty set before jQuery 3.0
				migrateWarn("jQuery( '#' ) is not a valid selector");
				selector = [];
			} else if (rattrHash.test(selector)) {
	
				// The nonstandard and undocumented unquoted-hash was removed in jQuery 1.12.0
				// Note that this doesn't actually fix the selector due to potential false positives
				migrateWarn("Attribute selectors with '#' must be quoted: '" + selector + "'");
			}
	
			ret = oldInit.apply(this, arguments);
	
			// Fill in selector and context properties so .live() works
			if (selector && selector.selector !== undefined) {
				// A jQuery object, copy its properties
				ret.selector = selector.selector;
				ret.context = selector.context;
			} else {
				ret.selector = typeof selector === "string" ? selector : "";
				if (selector) {
					ret.context = selector.nodeType ? selector : context || document;
				}
			}
	
			return ret;
		};
		jQuery.fn.init.prototype = jQuery.fn;
	
		// Let $.parseJSON(falsy_value) return null
		jQuery.parseJSON = function (json) {
			if (!json) {
				migrateWarn("jQuery.parseJSON requires a valid JSON string");
				return null;
			}
			return oldParseJSON.apply(this, arguments);
		};
	
		jQuery.uaMatch = function (ua) {
			ua = ua.toLowerCase();
	
			var match = /(chrome)[ \/]([\w.]+)/.exec(ua) || /(webkit)[ \/]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
	
			return {
				browser: match[1] || "",
				version: match[2] || "0"
			};
		};
	
		// Don't clobber any existing jQuery.browser in case it's different
		if (!jQuery.browser) {
			matched = jQuery.uaMatch(navigator.userAgent);
			browser = {};
	
			if (matched.browser) {
				browser[matched.browser] = true;
				browser.version = matched.version;
			}
	
			// Chrome is Webkit, but Webkit is also Safari.
			if (browser.chrome) {
				browser.webkit = true;
			} else if (browser.webkit) {
				browser.safari = true;
			}
	
			jQuery.browser = browser;
		}
	
		// Warn if the code tries to get jQuery.browser
		migrateWarnProp(jQuery, "browser", jQuery.browser, "jQuery.browser is deprecated");
	
		// jQuery.boxModel deprecated in 1.3, jQuery.support.boxModel deprecated in 1.7
		jQuery.boxModel = jQuery.support.boxModel = document.compatMode === "CSS1Compat";
		migrateWarnProp(jQuery, "boxModel", jQuery.boxModel, "jQuery.boxModel is deprecated");
		migrateWarnProp(jQuery.support, "boxModel", jQuery.support.boxModel, "jQuery.support.boxModel is deprecated");
	
		jQuery.sub = function () {
			function jQuerySub(selector, context) {
				return new jQuerySub.fn.init(selector, context);
			}
			jQuery.extend(true, jQuerySub, this);
			jQuerySub.superclass = this;
			jQuerySub.fn = jQuerySub.prototype = this();
			jQuerySub.fn.constructor = jQuerySub;
			jQuerySub.sub = this.sub;
			jQuerySub.fn.init = function init(selector, context) {
				var instance = jQuery.fn.init.call(this, selector, context, rootjQuerySub);
				return instance instanceof jQuerySub ? instance : jQuerySub(instance);
			};
			jQuerySub.fn.init.prototype = jQuerySub.fn;
			var rootjQuerySub = jQuerySub(document);
			migrateWarn("jQuery.sub() is deprecated");
			return jQuerySub;
		};
	
		// The number of elements contained in the matched element set
		jQuery.fn.size = function () {
			migrateWarn("jQuery.fn.size() is deprecated; use the .length property");
			return this.length;
		};
	
		var internalSwapCall = false;
	
		// If this version of jQuery has .swap(), don't false-alarm on internal uses
		if (jQuery.swap) {
			jQuery.each(["height", "width", "reliableMarginRight"], function (_, name) {
				var oldHook = jQuery.cssHooks[name] && jQuery.cssHooks[name].get;
	
				if (oldHook) {
					jQuery.cssHooks[name].get = function () {
						var ret;
	
						internalSwapCall = true;
						ret = oldHook.apply(this, arguments);
						internalSwapCall = false;
						return ret;
					};
				}
			});
		}
	
		jQuery.swap = function (elem, options, callback, args) {
			var ret,
			    name,
			    old = {};
	
			if (!internalSwapCall) {
				migrateWarn("jQuery.swap() is undocumented and deprecated");
			}
	
			// Remember the old values, and insert the new ones
			for (name in options) {
				old[name] = elem.style[name];
				elem.style[name] = options[name];
			}
	
			ret = callback.apply(elem, args || []);
	
			// Revert the old values
			for (name in options) {
				elem.style[name] = old[name];
			}
	
			return ret;
		};
	
		// Ensure that $.ajax gets the new parseJSON defined in core.js
		jQuery.ajaxSetup({
			converters: {
				"text json": jQuery.parseJSON
			}
		});
	
		var oldFnData = jQuery.fn.data;
	
		jQuery.fn.data = function (name) {
			var ret,
			    evt,
			    elem = this[0];
	
			// Handles 1.7 which has this behavior and 1.8 which doesn't
			if (elem && name === "events" && arguments.length === 1) {
				ret = jQuery.data(elem, name);
				evt = jQuery._data(elem, name);
				if ((ret === undefined || ret === evt) && evt !== undefined) {
					migrateWarn("Use of jQuery.fn.data('events') is deprecated");
					return evt;
				}
			}
			return oldFnData.apply(this, arguments);
		};
	
		var rscriptType = /\/(java|ecma)script/i;
	
		// Since jQuery.clean is used internally on older versions, we only shim if it's missing
		if (!jQuery.clean) {
			jQuery.clean = function (elems, context, fragment, scripts) {
				// Set context per 1.8 logic
				context = context || document;
				context = !context.nodeType && context[0] || context;
				context = context.ownerDocument || context;
	
				migrateWarn("jQuery.clean() is deprecated");
	
				var i,
				    elem,
				    handleScript,
				    jsTags,
				    ret = [];
	
				jQuery.merge(ret, jQuery.buildFragment(elems, context).childNodes);
	
				// Complex logic lifted directly from jQuery 1.8
				if (fragment) {
					// Special handling of each script element
					handleScript = function (elem) {
						// Check if we consider it executable
						if (!elem.type || rscriptType.test(elem.type)) {
							// Detach the script and store it in the scripts array (if provided) or the fragment
							// Return truthy to indicate that it has been handled
							return scripts ? scripts.push(elem.parentNode ? elem.parentNode.removeChild(elem) : elem) : fragment.appendChild(elem);
						}
					};
	
					for (i = 0; (elem = ret[i]) != null; i++) {
						// Check if we're done after handling an executable script
						if (!(jQuery.nodeName(elem, "script") && handleScript(elem))) {
							// Append to fragment and handle embedded scripts
							fragment.appendChild(elem);
							if (typeof elem.getElementsByTagName !== "undefined") {
								// handleScript alters the DOM, so use jQuery.merge to ensure snapshot iteration
								jsTags = jQuery.grep(jQuery.merge([], elem.getElementsByTagName("script")), handleScript);
	
								// Splice the scripts into ret after their former ancestor and advance our index beyond them
								ret.splice.apply(ret, [i + 1, 0].concat(jsTags));
								i += jsTags.length;
							}
						}
					}
				}
	
				return ret;
			};
		}
	
		var eventAdd = jQuery.event.add,
		    eventRemove = jQuery.event.remove,
		    eventTrigger = jQuery.event.trigger,
		    oldToggle = jQuery.fn.toggle,
		    oldLive = jQuery.fn.live,
		    oldDie = jQuery.fn.die,
		    oldLoad = jQuery.fn.load,
		    ajaxEvents = "ajaxStart|ajaxStop|ajaxSend|ajaxComplete|ajaxError|ajaxSuccess",
		    rajaxEvent = new RegExp("\\b(?:" + ajaxEvents + ")\\b"),
		    rhoverHack = /(?:^|\s)hover(\.\S+|)\b/,
		    hoverHack = function (events) {
			if (typeof events !== "string" || jQuery.event.special.hover) {
				return events;
			}
			if (rhoverHack.test(events)) {
				migrateWarn("'hover' pseudo-event is deprecated, use 'mouseenter mouseleave'");
			}
			return events && events.replace(rhoverHack, "mouseenter$1 mouseleave$1");
		};
	
		// Event props removed in 1.9, put them back if needed; no practical way to warn them
		if (jQuery.event.props && jQuery.event.props[0] !== "attrChange") {
			jQuery.event.props.unshift("attrChange", "attrName", "relatedNode", "srcElement");
		}
	
		// Undocumented jQuery.event.handle was "deprecated" in jQuery 1.7
		if (jQuery.event.dispatch) {
			migrateWarnProp(jQuery.event, "handle", jQuery.event.dispatch, "jQuery.event.handle is undocumented and deprecated");
		}
	
		// Support for 'hover' pseudo-event and ajax event warnings
		jQuery.event.add = function (elem, types, handler, data, selector) {
			if (elem !== document && rajaxEvent.test(types)) {
				migrateWarn("AJAX events should be attached to document: " + types);
			}
			eventAdd.call(this, elem, hoverHack(types || ""), handler, data, selector);
		};
		jQuery.event.remove = function (elem, types, handler, selector, mappedTypes) {
			eventRemove.call(this, elem, hoverHack(types) || "", handler, selector, mappedTypes);
		};
	
		jQuery.each(["load", "unload", "error"], function (_, name) {
	
			jQuery.fn[name] = function () {
				var args = Array.prototype.slice.call(arguments, 0);
	
				// If this is an ajax load() the first arg should be the string URL;
				// technically this could also be the "Anything" arg of the event .load()
				// which just goes to show why this dumb signature has been deprecated!
				// jQuery custom builds that exclude the Ajax module justifiably die here.
				if (name === "load" && typeof args[0] === "string") {
					return oldLoad.apply(this, args);
				}
	
				migrateWarn("jQuery.fn." + name + "() is deprecated");
	
				args.splice(0, 0, name);
				if (arguments.length) {
					return this.bind.apply(this, args);
				}
	
				// Use .triggerHandler here because:
				// - load and unload events don't need to bubble, only applied to window or image
				// - error event should not bubble to window, although it does pre-1.7
				// See http://bugs.jquery.com/ticket/11820
				this.triggerHandler.apply(this, args);
				return this;
			};
		});
	
		jQuery.fn.toggle = function (fn, fn2) {
	
			// Don't mess with animation or css toggles
			if (!jQuery.isFunction(fn) || !jQuery.isFunction(fn2)) {
				return oldToggle.apply(this, arguments);
			}
			migrateWarn("jQuery.fn.toggle(handler, handler...) is deprecated");
	
			// Save reference to arguments for access in closure
			var args = arguments,
			    guid = fn.guid || jQuery.guid++,
			    i = 0,
			    toggler = function (event) {
				// Figure out which function to execute
				var lastToggle = (jQuery._data(this, "lastToggle" + fn.guid) || 0) % i;
				jQuery._data(this, "lastToggle" + fn.guid, lastToggle + 1);
	
				// Make sure that clicks stop
				event.preventDefault();
	
				// and execute the function
				return args[lastToggle].apply(this, arguments) || false;
			};
	
			// link all the functions, so any of them can unbind this click handler
			toggler.guid = guid;
			while (i < args.length) {
				args[i++].guid = guid;
			}
	
			return this.click(toggler);
		};
	
		jQuery.fn.live = function (types, data, fn) {
			migrateWarn("jQuery.fn.live() is deprecated");
			if (oldLive) {
				return oldLive.apply(this, arguments);
			}
			jQuery(this.context).on(types, this.selector, data, fn);
			return this;
		};
	
		jQuery.fn.die = function (types, fn) {
			migrateWarn("jQuery.fn.die() is deprecated");
			if (oldDie) {
				return oldDie.apply(this, arguments);
			}
			jQuery(this.context).off(types, this.selector || "**", fn);
			return this;
		};
	
		// Turn global events into document-triggered events
		jQuery.event.trigger = function (event, data, elem, onlyHandlers) {
			if (!elem && !rajaxEvent.test(event)) {
				migrateWarn("Global events are undocumented and deprecated");
			}
			return eventTrigger.call(this, event, data, elem || document, onlyHandlers);
		};
		jQuery.each(ajaxEvents.split("|"), function (_, name) {
			jQuery.event.special[name] = {
				setup: function () {
					var elem = this;
	
					// The document needs no shimming; must be !== for oldIE
					if (elem !== document) {
						jQuery.event.add(document, name + "." + jQuery.guid, function () {
							jQuery.event.trigger(name, Array.prototype.slice.call(arguments, 1), elem, true);
						});
						jQuery._data(this, name, jQuery.guid++);
					}
					return false;
				},
				teardown: function () {
					if (this !== document) {
						jQuery.event.remove(document, name + "." + jQuery._data(this, name));
					}
					return false;
				}
			};
		});
	
		jQuery.event.special.ready = {
			setup: function () {
				if (this === document) {
					migrateWarn("'ready' event is deprecated");
				}
			}
		};
	
		var oldSelf = jQuery.fn.andSelf || jQuery.fn.addBack,
		    oldFind = jQuery.fn.find;
	
		jQuery.fn.andSelf = function () {
			migrateWarn("jQuery.fn.andSelf() replaced by jQuery.fn.addBack()");
			return oldSelf.apply(this, arguments);
		};
	
		jQuery.fn.find = function (selector) {
			var ret = oldFind.apply(this, arguments);
			ret.context = this.context;
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		};
	
		// jQuery 1.6 did not support Callbacks, do not warn there
		if (jQuery.Callbacks) {
	
			var oldDeferred = jQuery.Deferred,
			    tuples = [
			// action, add listener, callbacks, .then handlers, final state
			["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), "rejected"], ["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory")]];
	
			jQuery.Deferred = function (func) {
				var deferred = oldDeferred(),
				    promise = deferred.promise();
	
				deferred.pipe = promise.pipe = function () /* fnDone, fnFail, fnProgress */{
					var fns = arguments;
	
					migrateWarn("deferred.pipe() is deprecated");
	
					return jQuery.Deferred(function (newDefer) {
						jQuery.each(tuples, function (i, tuple) {
							var fn = jQuery.isFunction(fns[i]) && fns[i];
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							deferred[tuple[1]](function () {
								var returned = fn && fn.apply(this, arguments);
								if (returned && jQuery.isFunction(returned.promise)) {
									returned.promise().done(newDefer.resolve).fail(newDefer.reject).progress(newDefer.notify);
								} else {
									newDefer[tuple[0] + "With"](this === promise ? newDefer.promise() : this, fn ? [returned] : arguments);
								}
							});
						});
						fns = null;
					}).promise();
				};
	
				deferred.isResolved = function () {
					migrateWarn("deferred.isResolved is deprecated");
					return deferred.state() === "resolved";
				};
	
				deferred.isRejected = function () {
					migrateWarn("deferred.isRejected is deprecated");
					return deferred.state() === "rejected";
				};
	
				if (func) {
					func.call(deferred, deferred);
				}
	
				return deferred;
			};
		}
	})(jQuery, window);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (baseMVC, _l) {
	    'use strict';
	
	    var logNamespace = 'user';
	    //==============================================================================
	    /** @class View to display a user's disk/storage usage
	     *      either as a progress bar representing the percentage of a quota used
	     *      or a simple text element displaying the human readable size used.
	     *  @name UserQuotaMeter
	     *  @augments Backbone.View
	     */
	    var UserQuotaMeter = Backbone.View.extend(baseMVC.LoggableMixin).extend(
	    /** @lends UserQuotaMeter.prototype */{
	        _logNamespace: logNamespace,
	
	        /** Defaults for optional settings passed to initialize */
	        options: {
	            warnAtPercent: 85,
	            errorAtPercent: 100
	        },
	
	        /** Set up, accept options, and bind events */
	        initialize: function (options) {
	            this.log(this + '.initialize:', options);
	            _.extend(this.options, options);
	
	            //this.bind( 'all', function( event, data ){ this.log( this + ' event:', event, data ); }, this );
	            this.listenTo(this.model, 'change:quota_percent change:total_disk_usage', this.render);
	        },
	
	        /** Re-load user model data from the api */
	        update: function (options) {
	            this.log(this + ' updating user data...', options);
	            this.model.loadFromApi(this.model.get('id'), options);
	            return this;
	        },
	
	        /** Is the user over their quota (if there is one)?
	         * @returns {Boolean} true if over quota, false if no quota or under quota
	         */
	        isOverQuota: function () {
	            return this.model.get('quota_percent') !== null && this.model.get('quota_percent') >= this.options.errorAtPercent;
	        },
	
	        /** Render the meter when they have an applicable quota. Will render as a progress bar
	         *      with their percentage of that quota in text over the bar.
	         *  @fires quota:over when user is over quota (>= this.errorAtPercent)
	         *  @fires quota:under when user is under quota
	         *  @fires quota:under:approaching when user is >= this.warnAtPercent of their quota
	         *  @fires quota:under:ok when user is below this.warnAtPercent
	         *  @returns {jQuery} the rendered meter
	         */
	        _render_quota: function () {
	            var modelJson = this.model.toJSON(),
	
	            //prevPercent = this.model.previous( 'quota_percent' ),
	            percent = modelJson.quota_percent,
	
	            //meter = $( UserQuotaMeter.templates.quota( modelJson ) );
	            $meter = $(this._templateQuotaMeter(modelJson)),
	                $bar = $meter.find('.progress-bar');
	            //this.log( this + '.rendering quota, percent:', percent, 'meter:', meter );
	
	            // OVER QUOTA: color the quota bar and show the quota error message
	            if (this.isOverQuota()) {
	                //this.log( '\t over quota' );
	                $bar.attr('class', 'progress-bar progress-bar-danger');
	                $meter.find('.quota-meter-text').css('color', 'white');
	                //TODO: only trigger event if state has changed
	                this.trigger('quota:over', modelJson);
	
	                // APPROACHING QUOTA: color the quota bar
	            } else if (percent >= this.options.warnAtPercent) {
	                //this.log( '\t approaching quota' );
	                $bar.attr('class', 'progress-bar progress-bar-warning');
	                //TODO: only trigger event if state has changed
	                this.trigger('quota:under quota:under:approaching', modelJson);
	
	                // otherwise, hide/don't use the msg box
	            } else {
	                $bar.attr('class', 'progress-bar progress-bar-success');
	                //TODO: only trigger event if state has changed
	                this.trigger('quota:under quota:under:ok', modelJson);
	            }
	            return $meter;
	        },
	
	        /** Render the meter when the user has NO applicable quota. Will render as text
	         *      showing the human readable sum storage their data is using.
	         *  @returns {jQuery} the rendered text
	         */
	        _render_usage: function () {
	            //var usage = $( UserQuotaMeter.templates.usage( this.model.toJSON() ) );
	            var usage = $(this._templateUsage(this.model.toJSON()));
	            this.log(this + '.rendering usage:', usage);
	            return usage;
	        },
	
	        /** Render either the quota percentage meter or the human readable disk usage
	         *      depending on whether the user model has quota info (quota_percent === null -> no quota)
	         *  @returns {Object} this UserQuotaMeter
	         */
	        render: function () {
	            //this.log( this + '.rendering' );
	            var meterHtml = null;
	
	            // no quota on server ('quota_percent' === null (can be valid at 0)), show usage instead
	            this.log(this + '.model.quota_percent:', this.model.get('quota_percent'));
	            if (this.model.get('quota_percent') === null || this.model.get('quota_percent') === undefined) {
	                meterHtml = this._render_usage();
	
	                // otherwise, render percent of quota (and warning, error)
	            } else {
	                meterHtml = this._render_quota();
	                //TODO: add the original text for unregistered quotas
	                //tooltip = "Your disk quota is %s.  You can increase your quota by registering a Galaxy account."
	            }
	
	            this.$el.html(meterHtml);
	            this.$el.find('.quota-meter-text').tooltip();
	            return this;
	        },
	
	        _templateQuotaMeter: function (data) {
	            return ['<div id="quota-meter" class="quota-meter progress">', '<div class="progress-bar" style="width: ', data.quota_percent, '%"></div>', '<div class="quota-meter-text" data-placement="left" style="top: 6px"', data.nice_total_disk_usage ? ' title="Using ' + data.nice_total_disk_usage + '.  This value is recalculated when you log out.">' : '>', _l('Using'), ' ', data.quota_percent, '%', '</div>', '</div>'].join('');
	        },
	
	        _templateUsage: function (data) {
	            return ['<div id="quota-meter" class="quota-meter" style="background-color: transparent">', '<div class="quota-meter-text" data-placement="left" data-original-title="This value is recalculated when you log out." style="top: 6px; color: white">', data.nice_total_disk_usage ? _l('Using ') + data.nice_total_disk_usage : '', '</div>', '</div>'].join('');
	        },
	
	        toString: function () {
	            return 'UserQuotaMeter(' + this.model + ')';
	        }
	    });
	
	    //==============================================================================
	    return {
	        UserQuotaMeter: UserQuotaMeter
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, _, Backbone, $) {// ============================================================================
	// Globals (temporary)
	// ============================================================================
	// HACK: add these to global scope until we stop asking for them there...
	// Via webpack: these are required here automatically by the provider plugin
	// Via script tag: these are redundant (identities) since they're already global
	window['jQuery'] = jQuery; // a weird form to prevent webpack from sub'ing 'window.jQuery' in the provider plugin
	window.$ = jQuery;
	window._ = _;
	window.Backbone = Backbone;
	// console.debug('globals loaded:', window.jQuery, window.Backbone, '...');
	
	// these are galaxy globals not defined in the provider (although they could be - but why encourage that?)
	window.panels = __webpack_require__(54);
	// using extend bc there are multiple fns/objs to decorate the window with
	_.extend(window, __webpack_require__(73));
	window.async_save_text = __webpack_require__(155);
	var POPUPMENU = __webpack_require__(153);
	window.make_popupmenu = POPUPMENU.make_popupmenu;
	window.make_popup_menus = POPUPMENU.make_popup_menus;
	window.init_tag_click_function = __webpack_require__(96);
	var TOURS = __webpack_require__(93);
	var QUERY_STRING = __webpack_require__(19);
	// console.debug( 'galaxy globals loaded' );
	
	// ============================================================================
	// jquery on document ready
	// ============================================================================
	// Replace select box with a text input box + autocomplete.
	function replace_big_select_inputs(min_length, max_length, select_elts) {
	
	    function refresh_select2(element) {
	        var select_elt = $(element);
	        var options = { placeholder: 'Click to select',
	            closeOnSelect: !select_elt.is("[MULTIPLE]"),
	            dropdownAutoWidth: true,
	            containerCssClass: 'select2-minwidth'
	        };
	        return element.select2(options);
	    }
	
	    // To do replace, the select2 plugin must be loaded.
	    if (!jQuery.fn.select2) {
	        return;
	    }
	
	    // Set default for min_length and max_length
	    if (min_length === undefined) {
	        min_length = 20;
	    }
	    if (max_length === undefined) {
	        max_length = 3000;
	    }
	
	    select_elts = select_elts || $('select');
	
	    select_elts.each(function () {
	        var select_elt = $(this).not('[multiple]');
	        // Make sure that options is within range.
	        var num_options = select_elt.find('option').length;
	        if (num_options < min_length || num_options > max_length) {
	            return;
	        }
	
	        if (select_elt.hasClass("no-autocomplete")) {
	            return;
	        }
	
	        /* Replaced jQuery.autocomplete with select2, notes:
	         * - multiple selects are supported
	         * - the original element is updated with the value, convert_to_values should not be needed
	         * - events are fired when updating the original element, so refresh_on_change should just work
	         *
	         * - should we still sort dbkey fields here?
	         */
	        refresh_select2(select_elt);
	    });
	}
	
	// Initialize refresh events.
	function init_refresh_on_change() {
	    $("select[refresh_on_change='true']").off('change').change(function () {
	        var select_field = $(this),
	            select_val = select_field.val(),
	            refresh = false,
	            ref_on_change_vals = select_field.attr("refresh_on_change_values");
	        if (ref_on_change_vals) {
	            ref_on_change_vals = ref_on_change_vals.split(',');
	            var last_selected_value = select_field.attr("last_selected_value");
	            if ($.inArray(select_val, ref_on_change_vals) === -1 && $.inArray(last_selected_value, ref_on_change_vals) === -1) {
	                return;
	            }
	        }
	        $(window).trigger("refresh_on_change");
	        $(document).trigger("convert_to_values"); // Convert autocomplete text to values
	        select_field.get(0).form.submit();
	    });
	
	    // checkboxes refresh on change
	    $(":checkbox[refresh_on_change='true']").off('click').click(function () {
	        var select_field = $(this),
	            select_val = select_field.val(),
	            refresh = false,
	            ref_on_change_vals = select_field.attr("refresh_on_change_values");
	        if (ref_on_change_vals) {
	            ref_on_change_vals = ref_on_change_vals.split(',');
	            var last_selected_value = select_field.attr("last_selected_value");
	            if ($.inArray(select_val, ref_on_change_vals) === -1 && $.inArray(last_selected_value, ref_on_change_vals) === -1) {
	                return;
	            }
	        }
	        $(window).trigger("refresh_on_change");
	        select_field.get(0).form.submit();
	    });
	
	    // Links with confirmation
	    $("a[confirm]").off('click').click(function () {
	        return confirm($(this).attr("confirm"));
	    });
	}
	// used globally in grid-view
	window.init_refresh_on_change = init_refresh_on_change;
	
	$(document).ready(function () {
	    // Refresh events for form fields.
	    init_refresh_on_change();
	
	    // Tooltips
	    if ($.fn.tooltip) {
	        // Put tooltips below items in panel header so that they do not overlap masthead.
	        $(".unified-panel-header [title]").tooltip({ placement: 'bottom' });
	
	        // default tooltip initialization, it will follow the data-placement tag for tooltip location
	        // and fallback to 'top' if not present
	        $("[title]").tooltip();
	    }
	    // Make popup menus.
	    make_popup_menus();
	
	    // Replace big selects.
	    replace_big_select_inputs(20, 1500);
	
	    // If galaxy_main frame does not exist and link targets galaxy_main,
	    // add use_panels=True and set target to self.
	    $("a").click(function () {
	        var anchor = $(this);
	        var galaxy_main_exists = parent.frames && parent.frames.galaxy_main;
	        if (anchor.attr("target") == "galaxy_main" && !galaxy_main_exists) {
	            var href = anchor.attr("href");
	            if (href.indexOf("?") == -1) {
	                href += "?";
	            } else {
	                href += "&";
	            }
	            href += "use_panels=True";
	            anchor.attr("href", href);
	            anchor.attr("target", "_self");
	        }
	        return anchor;
	    });
	
	    var et = JSON.parse(sessionStorage.getItem('activeGalaxyTour'));
	    if (et) {
	        et = TOURS.hooked_tour_from_data(et);
	        if (et && et.steps) {
	            if (window && window.self === window.top) {
	                // Only kick off a new tour if this is the toplevel window (non-iframe).  This
	                // functionality actually *could* be useful, but we'd need to handle it better and
	                // come up with some design guidelines for tours jumping between windows.
	                // Disabling for now.
	                var tour = new Tour(_.extend({
	                    steps: et.steps
	                }, TOURS.tour_opts));
	                tour.init();
	                tour.restart();
	            }
	        }
	    }
	
	    function onloadWebhooks() {
	        if (Galaxy.root !== undefined) {
	            // Load all webhooks with the type 'onload'
	            $.getJSON(Galaxy.root + 'api/webhooks/onload/all', function (webhooks) {
	                _.each(webhooks, function (webhook) {
	                    if (webhook.activate && webhook.script) {
	                        $('<script/>', { type: 'text/javascript' }).text(webhook.script).appendTo('head');
	                        $('<style/>', { type: 'text/css' }).text(webhook.styles).appendTo('head');
	                    }
	                });
	            });
	        } else {
	            setTimeout(onloadWebhooks, 100);
	        }
	    }
	    onloadWebhooks();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/**
	    Perform feature inference and redirect if below some minimum (must have canvas, etc.)
	    and polyfill for non-standard features.
	 */
	
	(function () {
	    /* TODO: move to modernizr or something besides us doing this...
	     * These are across all of our apps (reports, tool shed), but:
	     *     these should be configurable via options because they all need different things.
	     * So, analysis-polyfills.js, reports-polyfills.js (or analysis/polyfills)
	     */
	    'use strict';
	    /*globals window, clearTimeout */
	
	    // ------------------------------------------------------------------ polyfills
	    // console protection needed in some versions of IE (at this point (IE>=9), shouldn't be needed)
	
	    window.console = window.console || {
	        log: function () {},
	        debug: function () {},
	        info: function () {},
	        warn: function () {},
	        error: function () {},
	        assert: function () {}
	    };
	
	    // phantomjs: does not have the native extend fn assign
	    Object.assign = Object.assign || _.extend;
	
	    // requestAnimationFrame polyfill
	    var lastTime = 0;
	    var vendors = ['ms', 'moz', 'webkit', 'o'];
	    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	        window.cancelRequestAnimationFrame = window[vendors[x] + 'CancelRequestAnimationFrame'];
	    }
	
	    if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback, element) {
	        var currTime = new Date().getTime();
	        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	        var id = window.setTimeout(function () {
	            callback(currTime + timeToCall);
	        }, timeToCall);
	        lastTime = currTime + timeToCall;
	        return id;
	    };
	
	    if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
	        clearTimeout(id);
	    };
	
	    // ------------------------------------------------------------------ can't/won't polyfill
	    var features = [{ name: 'canvas', compatible: function () {
	            return window.CanvasRenderingContext2D;
	        } }, { name: 'sessionStorage', compatible: function () {
	            try {
	                return window.sessionStorage.length >= 0;
	            } catch (err) {}
	            return false;
	        } }];
	    // build a list of feature names for features that were not found
	    var incompatibilities = features.filter(function (feature) {
	        return !feature.compatible();
	    }).map(function (feature) {
	        return feature.name;
	    });
	
	    // if there are needed features missing, follow the index link to the static incompat warning
	    if (!!incompatibilities.length) {
	        var root = document.querySelectorAll('link[rel="index"]').item(0);
	        if (root) {
	            window.location = root.href + 'static/incompatible-browser.html';
	        }
	        console.log('incompatible browser:\n' + incompatibilities.join('\n'));
	    }
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(_) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (jQuery) {
	    'use_strict';
	
	    var $ = jQuery;
	
	    // ============================================================================
	    // TODO: unify popup menus and/or eliminate this
	    /**
	     * Sets up popupmenu rendering and binds options functions to the appropriate links.
	     * initial_options is a dict with text describing the option pointing to either (a) a
	     * function to perform; or (b) another dict with two required keys, 'url' and 'action' (the
	     * function to perform. (b) is useful for exposing the underlying URL of the option.
	     */
	    function make_popupmenu(button_element, initial_options) {
	        /*  Use the $.data feature to store options with the link element.
	            This allows options to be changed at a later time
	        */
	        var element_menu_exists = button_element.data("menu_options");
	        button_element.data("menu_options", initial_options);
	
	        // If element already has menu, nothing else to do since HTML and actions are already set.
	        if (element_menu_exists) {
	            return;
	        }
	
	        button_element.bind("click.show_popup", function (e) {
	            // Close existing visible menus
	            $(".popmenu-wrapper").remove();
	
	            // Need setTimeouts so clicks don't interfere with each other
	            setTimeout(function () {
	                // Dynamically generate the wrapper holding all the selectable options of the menu.
	                var menu_element = $("<ul class='dropdown-menu' id='" + button_element.attr('id') + "-menu'></ul>");
	                var options = button_element.data("menu_options");
	                if (_.size(options) <= 0) {
	                    $("<li>No Options.</li>").appendTo(menu_element);
	                }
	                $.each(options, function (k, v) {
	                    if (v) {
	                        // Action can be either an anonymous function and a mapped dict.
	                        var action = v.action || v;
	                        menu_element.append($("<li></li>").append($("<a>").attr("href", v.url).html(k).click(action)));
	                    } else {
	                        menu_element.append($("<li></li>").addClass("head").append($("<a href='#'></a>").html(k)));
	                    }
	                });
	                var wrapper = $("<div class='popmenu-wrapper' style='position: absolute;left: 0; top: -1000;'></div>").append(menu_element).appendTo("body");
	
	                var x = e.pageX - wrapper.width() / 2;
	                x = Math.min(x, $(document).scrollLeft() + $(window).width() - $(wrapper).width() - 5);
	                x = Math.max(x, $(document).scrollLeft() + 5);
	
	                wrapper.css({
	                    top: e.pageY,
	                    left: x
	                });
	            }, 10);
	
	            setTimeout(function () {
	                // Bind click event to current window and all frames to remove any visible menus
	                // Bind to document object instead of window object for IE compat
	                var close_popup = function (el) {
	                    $(el).bind("click.close_popup", function () {
	                        $(".popmenu-wrapper").remove();
	                        el.unbind("click.close_popup");
	                    });
	                };
	                close_popup($(window.document)); // Current frame
	                close_popup($(window.top.document)); // Parent frame
	                for (var frame_id = window.top.frames.length; frame_id--;) {
	                    // Sibling frames
	                    var frame = $(window.top.frames[frame_id].document);
	                    close_popup(frame);
	                }
	            }, 50);
	
	            return false;
	        });
	    }
	
	    /**
	     *  Convert two seperate (often adjacent) divs into galaxy popupmenu
	     *  - div 1 contains a number of anchors which become the menu options
	     *  - div 1 should have a 'popupmenu' attribute
	     *  - this popupmenu attribute contains the id of div 2
	     *  - div 2 becomes the 'face' of the popupmenu
	     *
	     *  NOTE: make_popup_menus finds and operates on all divs with a popupmenu attr (no need to point it at something)
	     *          but (since that selector searches the dom on the page), you can send a parent in
	     *  NOTE: make_popup_menus, and make_popupmenu are horrible names
	     */
	    function make_popup_menus(parent) {
	        // find all popupmenu menu divs (divs that contains anchors to be converted to menu options)
	        //  either in the parent or the document if no parent passed
	        parent = parent || document;
	        $(parent).find("div[popupmenu]").each(function () {
	            var options = {};
	            var menu = $(this);
	
	            // find each anchor in the menu, convert them into an options map: { a.text : click_function }
	            menu.find("a").each(function () {
	                var link = $(this),
	                    link_dom = link.get(0),
	                    confirmtext = link_dom.getAttribute("confirm"),
	                    href = link_dom.getAttribute("href"),
	                    target = link_dom.getAttribute("target");
	
	                // no href - no function (gen. a label)
	                if (!href) {
	                    options[link.text()] = null;
	                } else {
	                    options[link.text()] = {
	                        url: href,
	                        action: function (event) {
	
	                            // if theres confirm text, send the dialog
	                            if (!confirmtext || confirm(confirmtext)) {
	                                // link.click() doesn't use target for some reason,
	                                // so manually do it here.
	                                if (target) {
	                                    window.open(href, target);
	                                    return false;
	                                }
	                                // For all other links, do the default action.
	                                else {
	                                        link.click();
	                                    }
	                            } else {
	                                event.preventDefault();
	                            }
	                        }
	                    };
	                }
	            });
	            // locate the element with the id corresponding to the menu's popupmenu attr
	            var box = $(parent).find("#" + menu.attr('popupmenu'));
	
	            // For menus with clickable link text, make clicking on the link go through instead
	            // of activating the popup menu
	            box.find("a").bind("click", function (e) {
	                e.stopPropagation(); // Stop bubbling so clicking on the link goes through
	                return true;
	            });
	
	            // attach the click events and menu box building to the box element
	            make_popupmenu(box, options);
	            box.addClass("popup");
	            menu.remove();
	        });
	    }
	
	    // ============================================================================
	    return {
	        make_popupmenu: make_popupmenu,
	        make_popup_menus: make_popup_menus
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 154 */,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (jQuery) {
	    'use_strict';
	
	    var $ = jQuery;
	    // ============================================================================
	    /**
	     * Edit and save text asynchronously.
	     */
	    function async_save_text(click_to_edit_elt, text_elt_id, save_url, text_parm_name, num_cols, use_textarea, num_rows, on_start, on_finish) {
	        // Set defaults if necessary.
	        if (num_cols === undefined) {
	            num_cols = 30;
	        }
	        if (num_rows === undefined) {
	            num_rows = 4;
	        }
	
	        // Set up input element.
	        $("#" + click_to_edit_elt).click(function () {
	            // Check if this is already active
	            if ($("#renaming-active").length > 0) {
	                return;
	            }
	            var text_elt = $("#" + text_elt_id),
	                old_text = text_elt.text(),
	                t;
	
	            if (use_textarea) {
	                t = $("<textarea></textarea>").attr({ rows: num_rows, cols: num_cols }).text($.trim(old_text));
	            } else {
	                t = $("<input type='text'></input>").attr({ value: $.trim(old_text), size: num_cols });
	            }
	            t.attr("id", "renaming-active");
	            t.blur(function () {
	                $(this).remove();
	                text_elt.show();
	                if (on_finish) {
	                    on_finish(t);
	                }
	            });
	            t.keyup(function (e) {
	                if (e.keyCode === 27) {
	                    // Escape key
	                    $(this).trigger("blur");
	                } else if (e.keyCode === 13) {
	                    // Enter key submits
	                    var ajax_data = {};
	                    ajax_data[text_parm_name] = $(this).val();
	                    $(this).trigger("blur");
	                    $.ajax({
	                        url: save_url,
	                        data: ajax_data,
	                        error: function () {
	                            alert("Text editing for elt " + text_elt_id + " failed");
	                            // TODO: call finish or no? For now, let's not because error occurred.
	                        },
	                        success: function (processed_text) {
	                            // Set new text and call finish method.
	                            if (processed_text !== "") {
	                                text_elt.text(processed_text);
	                            } else {
	                                text_elt.html("<em>None</em>");
	                            }
	                            if (on_finish) {
	                                on_finish(t);
	                            }
	                        }
	                    });
	                }
	            });
	
	            if (on_start) {
	                on_start(t);
	            }
	            // Replace text with input object and focus & select.
	            text_elt.hide();
	            t.insertAfter(text_elt);
	            t.focus();
	            t.select();
	
	            return;
	        });
	    }
	
	    // ============================================================================
	    return async_save_text;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(jQuery) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    /*global window, jQuery, console */
	    /*=============================================================================
	    TODO:
	        while anon: logs saved to 'logs-null' - this will never post
	            unless we manually do so at/after login
	            OR prepend when userId and localStorage has 'logs-null'
	        wire up _delayPost and test
	    
	    =============================================================================*/
	    /** @class MetricsLogger
	     *
	     *  Object to cache, output, and post log/metric messages to the server.
	     *  Meant to be attached to the Galaxy object.
	     *
	     *  Log from objects by either attaching logger directly:
	     *      panel.logger.metric( 'user dataset deletion', panel.user.id, hda.toJSON() )
	     *  or using the LoggableMixin or addLogging function:
	     *      MyBackboneModel.extend( LoggableMixin ).extend({ ... })
	     *      addLogging( MyBackboneModel, 'my-backbone-model' )
	     *
	     *  Log from templates by calling directly from Galaxy object:
	     *      Galaxy.logger.metric( 'template loaded', { ownedByUser : true });
	     *
	     *  If you attempt to log an un-serializable object (circular reference, window, etc.),
	     *  that entry will not be cached (or sent). If you set consoleLevel and consoleLogger
	     *  appropriately, a warning will be shown when this happens:
	     *      > panel.metric( 'something weird with window', { window : window })
	     *      !'Metrics logger could not stringify logArguments: ...'
	     */
	    function MetricsLogger(options) {
	        options = options || {};
	        var self = this;
	
	        ///** get the current user's id from bootstrapped data or options */
	        self.userId = window.bootstrapped && window.bootstrapped.user ? window.bootstrapped.user.id : null;
	        self.userId = self.userId || options.userId || null;
	
	        /** the (optional) console to emit logs to */
	        self.consoleLogger = options.consoleLogger || null;
	
	        self._init(options);
	        return self;
	    }
	
	    //----------------------------------------------------------------------------- defaults and constants
	    // see: python std lib, logging
	    MetricsLogger.ALL = 0;
	    MetricsLogger.LOG = 0;
	    MetricsLogger.DEBUG = 10;
	    MetricsLogger.INFO = 20;
	    MetricsLogger.WARN = 30;
	    MetricsLogger.ERROR = 40;
	    // metrics levels here?
	    //MetricsLogger.MinorEvent  = 45;
	    //MetricsLogger.MajorEvent  = 50;
	    MetricsLogger.METRIC = 50;
	    MetricsLogger.NONE = 100;
	
	    /** default options - override these through the constructor */
	    MetricsLogger.defaultOptions = {
	        /** if an incoming message has a level >= this, it will be cached - can also be a string (e.g. 'debug') */
	        logLevel: MetricsLogger.NONE,
	        /** if an incoming message has a level >= this, it will be output to the console */
	        consoleLevel: MetricsLogger.NONE,
	        /** the default 'namespace' or label associated with an incoming message (if none is passed) */
	        defaultNamespace: 'Galaxy',
	        /** the namespaces output to the console (all namespaces will be output if this is falsy)
	         *  note: applies only to the console (not the event/metrics log/cache)
	         */
	        consoleNamespaceWhitelist: null,
	        /** the prefix attached to client-side logs to distinguish them in the metrics db */
	        clientPrefix: 'client.',
	
	        /** the maximum number of messages the cache should hold; if exceeded older messages are removed first */
	        maxCacheSize: 3000,
	        /** the number of messages accumulate before posting to the server; should be <= maxCacheSize */
	        postSize: 1000,
	        /** T/F whether to add a timestamp to incoming cached messages */
	        addTime: true,
	        /** string to prefix to userid for cache web storage */
	        cacheKeyPrefix: 'logs-',
	
	        /** the relative url to post messages to */
	        postUrl: '/api/metrics',
	        /** delay before trying post again after two failures */
	        delayPostInMs: 1000 * 60 * 10,
	
	        /** an (optional) function that should return an object; used to send additional data with the metrics */
	        getPingData: undefined,
	        /** an (optional) function that will handle the servers response after successfully posting messages */
	        onServerResponse: undefined
	    };
	
	    //----------------------------------------------------------------------------- set up
	    /** initialize the logger with options, set up instance vars and cache, and add onpageunload to window */
	    MetricsLogger.prototype._init = function _init(options) {
	        var self = this;
	        self.options = {};
	        for (var k in MetricsLogger.defaultOptions) {
	            if (MetricsLogger.defaultOptions.hasOwnProperty(k)) {
	                self.options[k] = options.hasOwnProperty(k) ? options[k] : MetricsLogger.defaultOptions[k];
	            }
	        }
	        self.options.logLevel = self._parseLevel(self.options.logLevel);
	        self.options.consoleLevel = self._parseLevel(self.options.consoleLevel);
	        //self._emitToConsole( 'debug', 'MetricsLogger', 'MetricsLogger.options:', self.options );
	
	        /** is the logger currently sending? */
	        self._sending = false;
	        /** the setTimeout id if the logger POST has failed more than once */
	        self._waiting = null;
	        /** the current number of entries to send in a POST */
	        self._postSize = self.options.postSize;
	
	        self._initCache();
	
	        return self;
	    };
	
	    /** initialize the cache */
	    MetricsLogger.prototype._initCache = function _initCache() {
	        try {
	            this.cache = new LoggingCache({
	                maxSize: this.options.maxCacheSize,
	                key: this.options.cacheKeyPrefix + this.userId
	            });
	        } catch (err) {
	            this._emitToConsole('warn', 'MetricsLogger', ['Could not intitialize logging cache:', err]);
	            this.options.logLevel = MetricsLogger.NONE;
	        }
	    };
	
	    /** return the numeric log level if level in 'none, debug, log, info, warn, error' */
	    MetricsLogger.prototype._parseLevel = function _parseLevel(level) {
	        var type = typeof level;
	        if (type === 'number') {
	            return level;
	        }
	        if (type === 'string') {
	            var upper = level.toUpperCase();
	            if (MetricsLogger.hasOwnProperty(upper)) {
	                return MetricsLogger[upper];
	            }
	        }
	        throw new Error('Unknown log level: ' + level);
	    };
	
	    //----------------------------------------------------------------------------- main entry point
	    /** record a log/message's arguments to the cache and/or the console based on level and namespace */
	    MetricsLogger.prototype.emit = function emit(level, namespace, logArguments) {
	        //this._emitToConsole( 'debug', 'MetricsLogger', [ 'emit:', level, namespace, logArguments ]);
	        var self = this;
	        namespace = namespace || self.options.defaultNamespace;
	        if (!level || !logArguments) {
	            return self;
	        }
	        // add to cache if proper level
	        //TODO: respect do not track?
	        //if( !navigator.doNotTrack && level >= self.options.logLevel ){
	        level = self._parseLevel(level);
	        if (level >= self.options.logLevel) {
	            self._addToCache(level, namespace, logArguments);
	        }
	        // also emit to consoleLogger if proper level for that
	        if (self.consoleLogger && level >= self.options.consoleLevel) {
	            self._emitToConsole(level, namespace, logArguments);
	        }
	        return self;
	    };
	
	    //----------------------------------------------------------------------------- cache
	    /** add a message to the cache and if messages.length is high enough post them to the server */
	    MetricsLogger.prototype._addToCache = function _addToCache(level, namespace, logArguments) {
	        this._emitToConsole('debug', 'MetricsLogger', ['_addToCache:', arguments, this.options.addTime, this.cache.length()]);
	        //this._emitToConsole( 'debug', 'MetricsLogger', [ '\t logArguments:', logArguments ]);
	        var self = this;
	        // try add to the cache and if we've got _postSize number of entries, attempt to post them to the server
	        try {
	            var newLength = self.cache.add(self._buildEntry(level, namespace, logArguments));
	            if (newLength >= self._postSize) {
	                self._postCache();
	            }
	            // discard entry if an error occurs, but warn if level set to do so
	        } catch (err) {
	            self._emitToConsole('warn', 'MetricsLogger', ['Metrics logger could not stringify logArguments:', namespace, logArguments]);
	            self._emitToConsole('error', 'MetricsLogger', [err]);
	        }
	        return self;
	    };
	
	    /** build a log cache entry object from the given level, namespace, and arguments (optionally adding timestamp */
	    MetricsLogger.prototype._buildEntry = function _buildEntry(level, namespace, logArguments) {
	        this._emitToConsole('debug', 'MetricsLogger', ['_buildEntry:', arguments]);
	        var entry = {
	            level: level,
	            namespace: this.options.clientPrefix + namespace,
	            args: logArguments
	        };
	        if (this.options.addTime) {
	            entry.time = new Date().toISOString();
	        }
	        return entry;
	    };
	
	    /** post _postSize messages from the cache to the server, removing them if successful
	     *      if the post fails, wait until maxCacheSize is accumulated instead and try again then
	     *      in addition to the messages from the cache ('metrics'), any info from getPingData (if set) will be sent
	     *      onServerResponse will be called (if set) with any response from the server
	     */
	    MetricsLogger.prototype._postCache = function _postCache(options) {
	        options = options || {};
	        this._emitToConsole('info', 'MetricsLogger', ['_postCache', options, this._postSize]);
	
	        // short circuit if we're already sending
	        if (!this.options.postUrl || this._sending) {
	            return jQuery.when({});
	        }
	
	        var self = this,
	            postSize = options.count || self._postSize,
	
	        // do not splice - remove after *successful* post
	        entries = self.cache.get(postSize),
	            entriesLength = entries.length,
	
	        // use the optional getPingData to add any extra info we may want to send
	        postData = typeof self.options.getPingData === 'function' ? self.options.getPingData() : {};
	        //console.debug( postSize, entriesLength );
	
	        // add the metrics and send
	        postData.metrics = JSON.stringify(entries);
	        //console.debug( postData.metrics );
	        self._sending = true;
	        return jQuery.post(self.options.postUrl, postData).always(function () {
	            self._sending = false;
	        }).fail(function (xhr, status, message) {
	            // if we failed the previous time, set the next post target to the max num of entries
	            self._postSize = self.options.maxCacheSize;
	            //TODO:??
	            // log this failure to explain any gap in metrics
	            self.emit('error', 'MetricsLogger', ['_postCache error:', xhr.readyState, xhr.status, xhr.responseJSON || xhr.responseText]);
	            //TODO: still doesn't solve the problem that when cache == max, post will be tried on every emit
	            //TODO: see _delayPost
	        }).done(function (response) {
	            if (typeof self.options.onServerResponse === 'function') {
	                self.options.onServerResponse(response);
	            }
	            // only remove if post successful
	            self.cache.remove(entriesLength);
	            //console.debug( 'removed entries:', entriesLength, 'size now:', self.cache.length() );
	            // if we succeeded, reset the post target to the normal num of entries
	            self._postSize = self.options.postSize;
	        });
	        // return the xhr promise
	    };
	
	    /** set _waiting to true and, after delayPostInMs, set it back to false */
	    MetricsLogger.prototype._delayPost = function _delayPost() {
	        //TODO: this won't work between pages
	        var self = this;
	        self._waiting = setTimeout(function () {
	            self._waiting = null;
	        }, self.options.delayPostInMs);
	    };
	
	    //----------------------------------------------------------------------------- console
	    /** output message to console based on level and consoleLogger type */
	    MetricsLogger.prototype._emitToConsole = function _emitToConsole(level, namespace, logArguments) {
	        //console.debug( '_emitToConsole:', level, namespace, logArguments );
	        var self = this,
	            whitelist = self.options.consoleNamespaceWhitelist;
	        if (!self.consoleLogger) {
	            return self;
	        }
	        // if a whitelist for namespaces is set, bail if this namespace is not in the list
	        if (whitelist && whitelist.indexOf(namespace) === -1) {
	            return self;
	        }
	
	        var args = Array.prototype.slice.call(logArguments, 0);
	        args.unshift(namespace);
	        //TODO: script location and/or source maps?
	        //TODO: branch on navigator.userAgent == AIIEEE - it only has log
	        if (level >= MetricsLogger.METRIC && typeof self.consoleLogger.info === 'function') {
	            return self.consoleLogger.info.apply(self.consoleLogger, args);
	        } else if (level >= MetricsLogger.ERROR && typeof self.consoleLogger.error === 'function') {
	            return self.consoleLogger.error.apply(self.consoleLogger, args);
	        } else if (level >= MetricsLogger.WARN && typeof self.consoleLogger.warn === 'function') {
	            self.consoleLogger.warn.apply(self.consoleLogger, args);
	        } else if (level >= MetricsLogger.INFO && typeof self.consoleLogger.info === 'function') {
	            self.consoleLogger.info.apply(self.consoleLogger, args);
	        } else if (level >= MetricsLogger.DEBUG && typeof self.consoleLogger.debug === 'function') {
	            self.consoleLogger.debug.apply(self.consoleLogger, args);
	        } else if (typeof self.consoleLogger.log === 'function') {
	            self.consoleLogger.log.apply(self.consoleLogger, args);
	        }
	        return self;
	    };
	
	    //----------------------------------------------------------------------------- shortcuts
	    // generic functions when logging from non-namespaced object (e.g. templates)
	    /** log to default namespace */
	    MetricsLogger.prototype.log = function log() {
	        this.emit(1, this.options.defaultNamespace, Array.prototype.slice.call(arguments, 0));
	    };
	
	    /** debug to default namespace */
	    MetricsLogger.prototype.debug = function debug() {
	        this.emit(MetricsLogger.DEBUG, this.options.defaultNamespace, Array.prototype.slice.call(arguments, 0));
	    };
	
	    /** info to default namespace */
	    MetricsLogger.prototype.info = function info() {
	        this.emit(MetricsLogger.INFO, this.options.defaultNamespace, Array.prototype.slice.call(arguments, 0));
	    };
	
	    /** warn to default namespace */
	    MetricsLogger.prototype.warn = function warn() {
	        this.emit(MetricsLogger.WARN, this.options.defaultNamespace, Array.prototype.slice.call(arguments, 0));
	    };
	
	    /** error to default namespace */
	    MetricsLogger.prototype.error = function error() {
	        this.emit(MetricsLogger.ERROR, this.options.defaultNamespace, Array.prototype.slice.call(arguments, 0));
	    };
	
	    /** metric to default namespace */
	    MetricsLogger.prototype.metric = function metric() {
	        this.emit(MetricsLogger.METRIC, this.options.defaultNamespace, Array.prototype.slice.call(arguments, 0));
	    };
	
	    /* ============================================================================
	    TODO:
	        need a performance pass - the JSON un/parsing is a bit much
	    
	    ============================================================================ */
	    /** @class LoggingCache
	     *  Simple implementation of cache wrapping an array.
	     *
	     *  Formats an entry before it's cached and only keeps options.maxSize number
	     *  of entries. Older entries are deleted first.
	     */
	    function LoggingCache(options) {
	        var self = this;
	        return self._init(options || {});
	    }
	
	    /** default options */
	    LoggingCache.defaultOptions = {
	        /** maximum number of entries to keep before discarding oldest */
	        maxSize: 5000
	    };
	
	    /** initialize with options */
	    LoggingCache.prototype._init = function _init(options) {
	        if (!this._hasStorage()) {
	            //TODO: fall back to jstorage
	            throw new Error('LoggingCache needs localStorage');
	        }
	        if (!options.key) {
	            throw new Error('LoggingCache needs key for localStorage');
	        }
	        this.key = options.key;
	        this._initStorage();
	
	        this.maxSize = options.maxSize || LoggingCache.defaultOptions.maxSize;
	        return this;
	    };
	
	    /** tests for localStorage fns */
	    LoggingCache.prototype._hasStorage = function _hasStorage() {
	        //TODO: modernizr
	        var test = 'test';
	        try {
	            localStorage.setItem(test, test);
	            localStorage.removeItem(test);
	            return true;
	        } catch (e) {
	            return false;
	        }
	    };
	
	    /** if no localStorage set for key, initialize to empty array */
	    LoggingCache.prototype._initStorage = function _initStorage() {
	        if (localStorage.getItem(this.key) === null) {
	            return this.empty();
	        }
	        return this;
	    };
	
	    /** add an entry to the cache, removing the oldest beforehand if size >= maxSize */
	    LoggingCache.prototype.add = function add(entry) {
	        var self = this,
	            _cache = self._fetchAndParse(),
	            overage = _cache.length + 1 - self.maxSize;
	        if (overage > 0) {
	            _cache.splice(0, overage);
	        }
	        _cache.push(entry);
	        self._unparseAndStore(_cache);
	        return _cache.length;
	    };
	
	    /** get the entries from localStorage and parse them */
	    LoggingCache.prototype._fetchAndParse = function _fetchAndParse() {
	        var self = this;
	        return JSON.parse(localStorage.getItem(self.key));
	    };
	
	    /** stringify the entries and put them in localStorage */
	    LoggingCache.prototype._unparseAndStore = function _unparseAndStore(entries) {
	        var self = this;
	        return localStorage.setItem(self.key, JSON.stringify(entries));
	    };
	
	    ///** process the entry before caching */
	    //LoggingCache.prototype._preprocessEntry = function _preprocessEntry( entry ){
	    //    return JSON.stringify( entry );
	    //};
	
	    /** return the length --- oh, getters where are you? */
	    LoggingCache.prototype.length = function length() {
	        return this._fetchAndParse().length;
	    };
	
	    /** get count number of entries starting with the oldest */
	    LoggingCache.prototype.get = function get(count) {
	        return this._fetchAndParse().slice(0, count);
	    };
	
	    /** remove count number of entries starting with the oldest */
	    LoggingCache.prototype.remove = function remove(count) {
	        var _cache = this._fetchAndParse(),
	            removed = _cache.splice(0, count);
	        this._unparseAndStore(_cache);
	        return removed;
	    };
	
	    /** empty/clear the entire cache */
	    LoggingCache.prototype.empty = function empty() {
	        localStorage.setItem(this.key, '[]');
	        return this;
	    };
	
	    /** stringify count number of entries (but do not remove) */
	    LoggingCache.prototype.stringify = function stringify(count) {
	        return JSON.stringify(this.get(count));
	    };
	
	    /** outputs entire cache to console */
	    LoggingCache.prototype.print = function print() {
	        // popup? (really, carl? a popup?) - easier to copy/paste
	        console.log(JSON.stringify(this._fetchAndParse(), null, '  '));
	    };
	
	    //=============================================================================
	    return {
	        MetricsLogger: MetricsLogger,
	        LoggingCache: LoggingCache
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// libs.bundled.js